// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/primereact/resources/themes/lara-light-cyan/theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/dripicons-v2.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/dripicons-v2.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/dripicons-v2.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/dripicons-v2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/remixicon.eot?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/remixicon.woff2?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/remixicon.woff?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/remixicon.ttf?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/remixicon.svg?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23b1bbc4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%234bb543%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23EC221F%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23EC221F%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23505d69%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23204692%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=5.9.55" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "#dripicons-v2" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Upzet -  Admin & Dashboard Template
Author: Themesdesign
Version: 1.1.0
Contact: themesdesign.in@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.mdi-ab-testing::before {
  content: "\\F01C9"; }

.mdi-abacus::before {
  content: "\\F16E0"; }

.mdi-abjad-arabic::before {
  content: "\\F1328"; }

.mdi-abjad-hebrew::before {
  content: "\\F1329"; }

.mdi-abugida-devanagari::before {
  content: "\\F132A"; }

.mdi-abugida-thai::before {
  content: "\\F132B"; }

.mdi-access-point::before {
  content: "\\F0003"; }

.mdi-access-point-check::before {
  content: "\\F1538"; }

.mdi-access-point-minus::before {
  content: "\\F1539"; }

.mdi-access-point-network::before {
  content: "\\F0002"; }

.mdi-access-point-network-off::before {
  content: "\\F0BE1"; }

.mdi-access-point-off::before {
  content: "\\F1511"; }

.mdi-access-point-plus::before {
  content: "\\F153A"; }

.mdi-access-point-remove::before {
  content: "\\F153B"; }

.mdi-account::before {
  content: "\\F0004"; }

.mdi-account-alert::before {
  content: "\\F0005"; }

.mdi-account-alert-outline::before {
  content: "\\F0B50"; }

.mdi-account-arrow-left::before {
  content: "\\F0B51"; }

.mdi-account-arrow-left-outline::before {
  content: "\\F0B52"; }

.mdi-account-arrow-right::before {
  content: "\\F0B53"; }

.mdi-account-arrow-right-outline::before {
  content: "\\F0B54"; }

.mdi-account-box::before {
  content: "\\F0006"; }

.mdi-account-box-multiple::before {
  content: "\\F0934"; }

.mdi-account-box-multiple-outline::before {
  content: "\\F100A"; }

.mdi-account-box-outline::before {
  content: "\\F0007"; }

.mdi-account-cancel::before {
  content: "\\F12DF"; }

.mdi-account-cancel-outline::before {
  content: "\\F12E0"; }

.mdi-account-cash::before {
  content: "\\F1097"; }

.mdi-account-cash-outline::before {
  content: "\\F1098"; }

.mdi-account-check::before {
  content: "\\F0008"; }

.mdi-account-check-outline::before {
  content: "\\F0BE2"; }

.mdi-account-child::before {
  content: "\\F0A89"; }

.mdi-account-child-circle::before {
  content: "\\F0A8A"; }

.mdi-account-child-outline::before {
  content: "\\F10C8"; }

.mdi-account-circle::before {
  content: "\\F0009"; }

.mdi-account-circle-outline::before {
  content: "\\F0B55"; }

.mdi-account-clock::before {
  content: "\\F0B56"; }

.mdi-account-clock-outline::before {
  content: "\\F0B57"; }

.mdi-account-cog::before {
  content: "\\F1370"; }

.mdi-account-cog-outline::before {
  content: "\\F1371"; }

.mdi-account-convert::before {
  content: "\\F000A"; }

.mdi-account-convert-outline::before {
  content: "\\F1301"; }

.mdi-account-cowboy-hat::before {
  content: "\\F0E9B"; }

.mdi-account-details::before {
  content: "\\F0631"; }

.mdi-account-details-outline::before {
  content: "\\F1372"; }

.mdi-account-edit::before {
  content: "\\F06BC"; }

.mdi-account-edit-outline::before {
  content: "\\F0FFB"; }

.mdi-account-group::before {
  content: "\\F0849"; }

.mdi-account-group-outline::before {
  content: "\\F0B58"; }

.mdi-account-hard-hat::before {
  content: "\\F05B5"; }

.mdi-account-heart::before {
  content: "\\F0899"; }

.mdi-account-heart-outline::before {
  content: "\\F0BE3"; }

.mdi-account-key::before {
  content: "\\F000B"; }

.mdi-account-key-outline::before {
  content: "\\F0BE4"; }

.mdi-account-lock::before {
  content: "\\F115E"; }

.mdi-account-lock-outline::before {
  content: "\\F115F"; }

.mdi-account-minus::before {
  content: "\\F000D"; }

.mdi-account-minus-outline::before {
  content: "\\F0AEC"; }

.mdi-account-multiple::before {
  content: "\\F000E"; }

.mdi-account-multiple-check::before {
  content: "\\F08C5"; }

.mdi-account-multiple-check-outline::before {
  content: "\\F11FE"; }

.mdi-account-multiple-minus::before {
  content: "\\F05D3"; }

.mdi-account-multiple-minus-outline::before {
  content: "\\F0BE5"; }

.mdi-account-multiple-outline::before {
  content: "\\F000F"; }

.mdi-account-multiple-plus::before {
  content: "\\F0010"; }

.mdi-account-multiple-plus-outline::before {
  content: "\\F0800"; }

.mdi-account-multiple-remove::before {
  content: "\\F120A"; }

.mdi-account-multiple-remove-outline::before {
  content: "\\F120B"; }

.mdi-account-music::before {
  content: "\\F0803"; }

.mdi-account-music-outline::before {
  content: "\\F0CE9"; }

.mdi-account-network::before {
  content: "\\F0011"; }

.mdi-account-network-outline::before {
  content: "\\F0BE6"; }

.mdi-account-off::before {
  content: "\\F0012"; }

.mdi-account-off-outline::before {
  content: "\\F0BE7"; }

.mdi-account-outline::before {
  content: "\\F0013"; }

.mdi-account-plus::before {
  content: "\\F0014"; }

.mdi-account-plus-outline::before {
  content: "\\F0801"; }

.mdi-account-question::before {
  content: "\\F0B59"; }

.mdi-account-question-outline::before {
  content: "\\F0B5A"; }

.mdi-account-reactivate::before {
  content: "\\F152B"; }

.mdi-account-reactivate-outline::before {
  content: "\\F152C"; }

.mdi-account-remove::before {
  content: "\\F0015"; }

.mdi-account-remove-outline::before {
  content: "\\F0AED"; }

.mdi-account-search::before {
  content: "\\F0016"; }

.mdi-account-search-outline::before {
  content: "\\F0935"; }

.mdi-account-settings::before {
  content: "\\F0630"; }

.mdi-account-settings-outline::before {
  content: "\\F10C9"; }

.mdi-account-star::before {
  content: "\\F0017"; }

.mdi-account-star-outline::before {
  content: "\\F0BE8"; }

.mdi-account-supervisor::before {
  content: "\\F0A8B"; }

.mdi-account-supervisor-circle::before {
  content: "\\F0A8C"; }

.mdi-account-supervisor-circle-outline::before {
  content: "\\F14EC"; }

.mdi-account-supervisor-outline::before {
  content: "\\F112D"; }

.mdi-account-switch::before {
  content: "\\F0019"; }

.mdi-account-switch-outline::before {
  content: "\\F04CB"; }

.mdi-account-tie::before {
  content: "\\F0CE3"; }

.mdi-account-tie-outline::before {
  content: "\\F10CA"; }

.mdi-account-tie-voice::before {
  content: "\\F1308"; }

.mdi-account-tie-voice-off::before {
  content: "\\F130A"; }

.mdi-account-tie-voice-off-outline::before {
  content: "\\F130B"; }

.mdi-account-tie-voice-outline::before {
  content: "\\F1309"; }

.mdi-account-voice::before {
  content: "\\F05CB"; }

.mdi-adjust::before {
  content: "\\F001A"; }

.mdi-adobe::before {
  content: "\\F0936"; }

.mdi-adobe-acrobat::before {
  content: "\\F0F9D"; }

.mdi-air-conditioner::before {
  content: "\\F001B"; }

.mdi-air-filter::before {
  content: "\\F0D43"; }

.mdi-air-horn::before {
  content: "\\F0DAC"; }

.mdi-air-humidifier::before {
  content: "\\F1099"; }

.mdi-air-humidifier-off::before {
  content: "\\F1466"; }

.mdi-air-purifier::before {
  content: "\\F0D44"; }

.mdi-airbag::before {
  content: "\\F0BE9"; }

.mdi-airballoon::before {
  content: "\\F001C"; }

.mdi-airballoon-outline::before {
  content: "\\F100B"; }

.mdi-airplane::before {
  content: "\\F001D"; }

.mdi-airplane-landing::before {
  content: "\\F05D4"; }

.mdi-airplane-off::before {
  content: "\\F001E"; }

.mdi-airplane-takeoff::before {
  content: "\\F05D5"; }

.mdi-airport::before {
  content: "\\F084B"; }

.mdi-alarm::before {
  content: "\\F0020"; }

.mdi-alarm-bell::before {
  content: "\\F078E"; }

.mdi-alarm-check::before {
  content: "\\F0021"; }

.mdi-alarm-light::before {
  content: "\\F078F"; }

.mdi-alarm-light-off::before {
  content: "\\F171E"; }

.mdi-alarm-light-off-outline::before {
  content: "\\F171F"; }

.mdi-alarm-light-outline::before {
  content: "\\F0BEA"; }

.mdi-alarm-multiple::before {
  content: "\\F0022"; }

.mdi-alarm-note::before {
  content: "\\F0E71"; }

.mdi-alarm-note-off::before {
  content: "\\F0E72"; }

.mdi-alarm-off::before {
  content: "\\F0023"; }

.mdi-alarm-panel::before {
  content: "\\F15C4"; }

.mdi-alarm-panel-outline::before {
  content: "\\F15C5"; }

.mdi-alarm-plus::before {
  content: "\\F0024"; }

.mdi-alarm-snooze::before {
  content: "\\F068E"; }

.mdi-album::before {
  content: "\\F0025"; }

.mdi-alert::before {
  content: "\\F0026"; }

.mdi-alert-box::before {
  content: "\\F0027"; }

.mdi-alert-box-outline::before {
  content: "\\F0CE4"; }

.mdi-alert-circle::before {
  content: "\\F0028"; }

.mdi-alert-circle-check::before {
  content: "\\F11ED"; }

.mdi-alert-circle-check-outline::before {
  content: "\\F11EE"; }

.mdi-alert-circle-outline::before {
  content: "\\F05D6"; }

.mdi-alert-decagram::before {
  content: "\\F06BD"; }

.mdi-alert-decagram-outline::before {
  content: "\\F0CE5"; }

.mdi-alert-minus::before {
  content: "\\F14BB"; }

.mdi-alert-minus-outline::before {
  content: "\\F14BE"; }

.mdi-alert-octagon::before {
  content: "\\F0029"; }

.mdi-alert-octagon-outline::before {
  content: "\\F0CE6"; }

.mdi-alert-octagram::before {
  content: "\\F0767"; }

.mdi-alert-octagram-outline::before {
  content: "\\F0CE7"; }

.mdi-alert-outline::before {
  content: "\\F002A"; }

.mdi-alert-plus::before {
  content: "\\F14BA"; }

.mdi-alert-plus-outline::before {
  content: "\\F14BD"; }

.mdi-alert-remove::before {
  content: "\\F14BC"; }

.mdi-alert-remove-outline::before {
  content: "\\F14BF"; }

.mdi-alert-rhombus::before {
  content: "\\F11CE"; }

.mdi-alert-rhombus-outline::before {
  content: "\\F11CF"; }

.mdi-alien::before {
  content: "\\F089A"; }

.mdi-alien-outline::before {
  content: "\\F10CB"; }

.mdi-align-horizontal-center::before {
  content: "\\F11C3"; }

.mdi-align-horizontal-left::before {
  content: "\\F11C2"; }

.mdi-align-horizontal-right::before {
  content: "\\F11C4"; }

.mdi-align-vertical-bottom::before {
  content: "\\F11C5"; }

.mdi-align-vertical-center::before {
  content: "\\F11C6"; }

.mdi-align-vertical-top::before {
  content: "\\F11C7"; }

.mdi-all-inclusive::before {
  content: "\\F06BE"; }

.mdi-allergy::before {
  content: "\\F1258"; }

.mdi-alpha::before {
  content: "\\F002B"; }

.mdi-alpha-a::before {
  content: "\\F0AEE"; }

.mdi-alpha-a-box::before {
  content: "\\F0B08"; }

.mdi-alpha-a-box-outline::before {
  content: "\\F0BEB"; }

.mdi-alpha-a-circle::before {
  content: "\\F0BEC"; }

.mdi-alpha-a-circle-outline::before {
  content: "\\F0BED"; }

.mdi-alpha-b::before {
  content: "\\F0AEF"; }

.mdi-alpha-b-box::before {
  content: "\\F0B09"; }

.mdi-alpha-b-box-outline::before {
  content: "\\F0BEE"; }

.mdi-alpha-b-circle::before {
  content: "\\F0BEF"; }

.mdi-alpha-b-circle-outline::before {
  content: "\\F0BF0"; }

.mdi-alpha-c::before {
  content: "\\F0AF0"; }

.mdi-alpha-c-box::before {
  content: "\\F0B0A"; }

.mdi-alpha-c-box-outline::before {
  content: "\\F0BF1"; }

.mdi-alpha-c-circle::before {
  content: "\\F0BF2"; }

.mdi-alpha-c-circle-outline::before {
  content: "\\F0BF3"; }

.mdi-alpha-d::before {
  content: "\\F0AF1"; }

.mdi-alpha-d-box::before {
  content: "\\F0B0B"; }

.mdi-alpha-d-box-outline::before {
  content: "\\F0BF4"; }

.mdi-alpha-d-circle::before {
  content: "\\F0BF5"; }

.mdi-alpha-d-circle-outline::before {
  content: "\\F0BF6"; }

.mdi-alpha-e::before {
  content: "\\F0AF2"; }

.mdi-alpha-e-box::before {
  content: "\\F0B0C"; }

.mdi-alpha-e-box-outline::before {
  content: "\\F0BF7"; }

.mdi-alpha-e-circle::before {
  content: "\\F0BF8"; }

.mdi-alpha-e-circle-outline::before {
  content: "\\F0BF9"; }

.mdi-alpha-f::before {
  content: "\\F0AF3"; }

.mdi-alpha-f-box::before {
  content: "\\F0B0D"; }

.mdi-alpha-f-box-outline::before {
  content: "\\F0BFA"; }

.mdi-alpha-f-circle::before {
  content: "\\F0BFB"; }

.mdi-alpha-f-circle-outline::before {
  content: "\\F0BFC"; }

.mdi-alpha-g::before {
  content: "\\F0AF4"; }

.mdi-alpha-g-box::before {
  content: "\\F0B0E"; }

.mdi-alpha-g-box-outline::before {
  content: "\\F0BFD"; }

.mdi-alpha-g-circle::before {
  content: "\\F0BFE"; }

.mdi-alpha-g-circle-outline::before {
  content: "\\F0BFF"; }

.mdi-alpha-h::before {
  content: "\\F0AF5"; }

.mdi-alpha-h-box::before {
  content: "\\F0B0F"; }

.mdi-alpha-h-box-outline::before {
  content: "\\F0C00"; }

.mdi-alpha-h-circle::before {
  content: "\\F0C01"; }

.mdi-alpha-h-circle-outline::before {
  content: "\\F0C02"; }

.mdi-alpha-i::before {
  content: "\\F0AF6"; }

.mdi-alpha-i-box::before {
  content: "\\F0B10"; }

.mdi-alpha-i-box-outline::before {
  content: "\\F0C03"; }

.mdi-alpha-i-circle::before {
  content: "\\F0C04"; }

.mdi-alpha-i-circle-outline::before {
  content: "\\F0C05"; }

.mdi-alpha-j::before {
  content: "\\F0AF7"; }

.mdi-alpha-j-box::before {
  content: "\\F0B11"; }

.mdi-alpha-j-box-outline::before {
  content: "\\F0C06"; }

.mdi-alpha-j-circle::before {
  content: "\\F0C07"; }

.mdi-alpha-j-circle-outline::before {
  content: "\\F0C08"; }

.mdi-alpha-k::before {
  content: "\\F0AF8"; }

.mdi-alpha-k-box::before {
  content: "\\F0B12"; }

.mdi-alpha-k-box-outline::before {
  content: "\\F0C09"; }

.mdi-alpha-k-circle::before {
  content: "\\F0C0A"; }

.mdi-alpha-k-circle-outline::before {
  content: "\\F0C0B"; }

.mdi-alpha-l::before {
  content: "\\F0AF9"; }

.mdi-alpha-l-box::before {
  content: "\\F0B13"; }

.mdi-alpha-l-box-outline::before {
  content: "\\F0C0C"; }

.mdi-alpha-l-circle::before {
  content: "\\F0C0D"; }

.mdi-alpha-l-circle-outline::before {
  content: "\\F0C0E"; }

.mdi-alpha-m::before {
  content: "\\F0AFA"; }

.mdi-alpha-m-box::before {
  content: "\\F0B14"; }

.mdi-alpha-m-box-outline::before {
  content: "\\F0C0F"; }

.mdi-alpha-m-circle::before {
  content: "\\F0C10"; }

.mdi-alpha-m-circle-outline::before {
  content: "\\F0C11"; }

.mdi-alpha-n::before {
  content: "\\F0AFB"; }

.mdi-alpha-n-box::before {
  content: "\\F0B15"; }

.mdi-alpha-n-box-outline::before {
  content: "\\F0C12"; }

.mdi-alpha-n-circle::before {
  content: "\\F0C13"; }

.mdi-alpha-n-circle-outline::before {
  content: "\\F0C14"; }

.mdi-alpha-o::before {
  content: "\\F0AFC"; }

.mdi-alpha-o-box::before {
  content: "\\F0B16"; }

.mdi-alpha-o-box-outline::before {
  content: "\\F0C15"; }

.mdi-alpha-o-circle::before {
  content: "\\F0C16"; }

.mdi-alpha-o-circle-outline::before {
  content: "\\F0C17"; }

.mdi-alpha-p::before {
  content: "\\F0AFD"; }

.mdi-alpha-p-box::before {
  content: "\\F0B17"; }

.mdi-alpha-p-box-outline::before {
  content: "\\F0C18"; }

.mdi-alpha-p-circle::before {
  content: "\\F0C19"; }

.mdi-alpha-p-circle-outline::before {
  content: "\\F0C1A"; }

.mdi-alpha-q::before {
  content: "\\F0AFE"; }

.mdi-alpha-q-box::before {
  content: "\\F0B18"; }

.mdi-alpha-q-box-outline::before {
  content: "\\F0C1B"; }

.mdi-alpha-q-circle::before {
  content: "\\F0C1C"; }

.mdi-alpha-q-circle-outline::before {
  content: "\\F0C1D"; }

.mdi-alpha-r::before {
  content: "\\F0AFF"; }

.mdi-alpha-r-box::before {
  content: "\\F0B19"; }

.mdi-alpha-r-box-outline::before {
  content: "\\F0C1E"; }

.mdi-alpha-r-circle::before {
  content: "\\F0C1F"; }

.mdi-alpha-r-circle-outline::before {
  content: "\\F0C20"; }

.mdi-alpha-s::before {
  content: "\\F0B00"; }

.mdi-alpha-s-box::before {
  content: "\\F0B1A"; }

.mdi-alpha-s-box-outline::before {
  content: "\\F0C21"; }

.mdi-alpha-s-circle::before {
  content: "\\F0C22"; }

.mdi-alpha-s-circle-outline::before {
  content: "\\F0C23"; }

.mdi-alpha-t::before {
  content: "\\F0B01"; }

.mdi-alpha-t-box::before {
  content: "\\F0B1B"; }

.mdi-alpha-t-box-outline::before {
  content: "\\F0C24"; }

.mdi-alpha-t-circle::before {
  content: "\\F0C25"; }

.mdi-alpha-t-circle-outline::before {
  content: "\\F0C26"; }

.mdi-alpha-u::before {
  content: "\\F0B02"; }

.mdi-alpha-u-box::before {
  content: "\\F0B1C"; }

.mdi-alpha-u-box-outline::before {
  content: "\\F0C27"; }

.mdi-alpha-u-circle::before {
  content: "\\F0C28"; }

.mdi-alpha-u-circle-outline::before {
  content: "\\F0C29"; }

.mdi-alpha-v::before {
  content: "\\F0B03"; }

.mdi-alpha-v-box::before {
  content: "\\F0B1D"; }

.mdi-alpha-v-box-outline::before {
  content: "\\F0C2A"; }

.mdi-alpha-v-circle::before {
  content: "\\F0C2B"; }

.mdi-alpha-v-circle-outline::before {
  content: "\\F0C2C"; }

.mdi-alpha-w::before {
  content: "\\F0B04"; }

.mdi-alpha-w-box::before {
  content: "\\F0B1E"; }

.mdi-alpha-w-box-outline::before {
  content: "\\F0C2D"; }

.mdi-alpha-w-circle::before {
  content: "\\F0C2E"; }

.mdi-alpha-w-circle-outline::before {
  content: "\\F0C2F"; }

.mdi-alpha-x::before {
  content: "\\F0B05"; }

.mdi-alpha-x-box::before {
  content: "\\F0B1F"; }

.mdi-alpha-x-box-outline::before {
  content: "\\F0C30"; }

.mdi-alpha-x-circle::before {
  content: "\\F0C31"; }

.mdi-alpha-x-circle-outline::before {
  content: "\\F0C32"; }

.mdi-alpha-y::before {
  content: "\\F0B06"; }

.mdi-alpha-y-box::before {
  content: "\\F0B20"; }

.mdi-alpha-y-box-outline::before {
  content: "\\F0C33"; }

.mdi-alpha-y-circle::before {
  content: "\\F0C34"; }

.mdi-alpha-y-circle-outline::before {
  content: "\\F0C35"; }

.mdi-alpha-z::before {
  content: "\\F0B07"; }

.mdi-alpha-z-box::before {
  content: "\\F0B21"; }

.mdi-alpha-z-box-outline::before {
  content: "\\F0C36"; }

.mdi-alpha-z-circle::before {
  content: "\\F0C37"; }

.mdi-alpha-z-circle-outline::before {
  content: "\\F0C38"; }

.mdi-alphabet-aurebesh::before {
  content: "\\F132C"; }

.mdi-alphabet-cyrillic::before {
  content: "\\F132D"; }

.mdi-alphabet-greek::before {
  content: "\\F132E"; }

.mdi-alphabet-latin::before {
  content: "\\F132F"; }

.mdi-alphabet-piqad::before {
  content: "\\F1330"; }

.mdi-alphabet-tengwar::before {
  content: "\\F1337"; }

.mdi-alphabetical::before {
  content: "\\F002C"; }

.mdi-alphabetical-off::before {
  content: "\\F100C"; }

.mdi-alphabetical-variant::before {
  content: "\\F100D"; }

.mdi-alphabetical-variant-off::before {
  content: "\\F100E"; }

.mdi-altimeter::before {
  content: "\\F05D7"; }

.mdi-amazon::before {
  content: "\\F002D"; }

.mdi-amazon-alexa::before {
  content: "\\F08C6"; }

.mdi-ambulance::before {
  content: "\\F002F"; }

.mdi-ammunition::before {
  content: "\\F0CE8"; }

.mdi-ampersand::before {
  content: "\\F0A8D"; }

.mdi-amplifier::before {
  content: "\\F0030"; }

.mdi-amplifier-off::before {
  content: "\\F11B5"; }

.mdi-anchor::before {
  content: "\\F0031"; }

.mdi-android::before {
  content: "\\F0032"; }

.mdi-android-auto::before {
  content: "\\F0A8E"; }

.mdi-android-debug-bridge::before {
  content: "\\F0033"; }

.mdi-android-messages::before {
  content: "\\F0D45"; }

.mdi-android-studio::before {
  content: "\\F0034"; }

.mdi-angle-acute::before {
  content: "\\F0937"; }

.mdi-angle-obtuse::before {
  content: "\\F0938"; }

.mdi-angle-right::before {
  content: "\\F0939"; }

.mdi-angular::before {
  content: "\\F06B2"; }

.mdi-angularjs::before {
  content: "\\F06BF"; }

.mdi-animation::before {
  content: "\\F05D8"; }

.mdi-animation-outline::before {
  content: "\\F0A8F"; }

.mdi-animation-play::before {
  content: "\\F093A"; }

.mdi-animation-play-outline::before {
  content: "\\F0A90"; }

.mdi-ansible::before {
  content: "\\F109A"; }

.mdi-antenna::before {
  content: "\\F1119"; }

.mdi-anvil::before {
  content: "\\F089B"; }

.mdi-apache-kafka::before {
  content: "\\F100F"; }

.mdi-api::before {
  content: "\\F109B"; }

.mdi-api-off::before {
  content: "\\F1257"; }

.mdi-apple::before {
  content: "\\F0035"; }

.mdi-apple-airplay::before {
  content: "\\F001F"; }

.mdi-apple-finder::before {
  content: "\\F0036"; }

.mdi-apple-icloud::before {
  content: "\\F0038"; }

.mdi-apple-ios::before {
  content: "\\F0037"; }

.mdi-apple-keyboard-caps::before {
  content: "\\F0632"; }

.mdi-apple-keyboard-command::before {
  content: "\\F0633"; }

.mdi-apple-keyboard-control::before {
  content: "\\F0634"; }

.mdi-apple-keyboard-option::before {
  content: "\\F0635"; }

.mdi-apple-keyboard-shift::before {
  content: "\\F0636"; }

.mdi-apple-safari::before {
  content: "\\F0039"; }

.mdi-application::before {
  content: "\\F0614"; }

.mdi-application-cog::before {
  content: "\\F1577"; }

.mdi-application-export::before {
  content: "\\F0DAD"; }

.mdi-application-import::before {
  content: "\\F0DAE"; }

.mdi-application-settings::before {
  content: "\\F1555"; }

.mdi-approximately-equal::before {
  content: "\\F0F9E"; }

.mdi-approximately-equal-box::before {
  content: "\\F0F9F"; }

.mdi-apps::before {
  content: "\\F003B"; }

.mdi-apps-box::before {
  content: "\\F0D46"; }

.mdi-arch::before {
  content: "\\F08C7"; }

.mdi-archive::before {
  content: "\\F003C"; }

.mdi-archive-alert::before {
  content: "\\F14FD"; }

.mdi-archive-alert-outline::before {
  content: "\\F14FE"; }

.mdi-archive-arrow-down::before {
  content: "\\F1259"; }

.mdi-archive-arrow-down-outline::before {
  content: "\\F125A"; }

.mdi-archive-arrow-up::before {
  content: "\\F125B"; }

.mdi-archive-arrow-up-outline::before {
  content: "\\F125C"; }

.mdi-archive-outline::before {
  content: "\\F120E"; }

.mdi-arm-flex::before {
  content: "\\F0FD7"; }

.mdi-arm-flex-outline::before {
  content: "\\F0FD6"; }

.mdi-arrange-bring-forward::before {
  content: "\\F003D"; }

.mdi-arrange-bring-to-front::before {
  content: "\\F003E"; }

.mdi-arrange-send-backward::before {
  content: "\\F003F"; }

.mdi-arrange-send-to-back::before {
  content: "\\F0040"; }

.mdi-arrow-all::before {
  content: "\\F0041"; }

.mdi-arrow-bottom-left::before {
  content: "\\F0042"; }

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\F09B7"; }

.mdi-arrow-bottom-left-thick::before {
  content: "\\F09B8"; }

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\F1596"; }

.mdi-arrow-bottom-right::before {
  content: "\\F0043"; }

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\F09B9"; }

.mdi-arrow-bottom-right-thick::before {
  content: "\\F09BA"; }

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\F1595"; }

.mdi-arrow-collapse::before {
  content: "\\F0615"; }

.mdi-arrow-collapse-all::before {
  content: "\\F0044"; }

.mdi-arrow-collapse-down::before {
  content: "\\F0792"; }

.mdi-arrow-collapse-horizontal::before {
  content: "\\F084C"; }

.mdi-arrow-collapse-left::before {
  content: "\\F0793"; }

.mdi-arrow-collapse-right::before {
  content: "\\F0794"; }

.mdi-arrow-collapse-up::before {
  content: "\\F0795"; }

.mdi-arrow-collapse-vertical::before {
  content: "\\F084D"; }

.mdi-arrow-decision::before {
  content: "\\F09BB"; }

.mdi-arrow-decision-auto::before {
  content: "\\F09BC"; }

.mdi-arrow-decision-auto-outline::before {
  content: "\\F09BD"; }

.mdi-arrow-decision-outline::before {
  content: "\\F09BE"; }

.mdi-arrow-down::before {
  content: "\\F0045"; }

.mdi-arrow-down-bold::before {
  content: "\\F072E"; }

.mdi-arrow-down-bold-box::before {
  content: "\\F072F"; }

.mdi-arrow-down-bold-box-outline::before {
  content: "\\F0730"; }

.mdi-arrow-down-bold-circle::before {
  content: "\\F0047"; }

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\F0048"; }

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\F0049"; }

.mdi-arrow-down-bold-outline::before {
  content: "\\F09BF"; }

.mdi-arrow-down-box::before {
  content: "\\F06C0"; }

.mdi-arrow-down-circle::before {
  content: "\\F0CDB"; }

.mdi-arrow-down-circle-outline::before {
  content: "\\F0CDC"; }

.mdi-arrow-down-drop-circle::before {
  content: "\\F004A"; }

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\F004B"; }

.mdi-arrow-down-thick::before {
  content: "\\F0046"; }

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\F1599"; }

.mdi-arrow-expand::before {
  content: "\\F0616"; }

.mdi-arrow-expand-all::before {
  content: "\\F004C"; }

.mdi-arrow-expand-down::before {
  content: "\\F0796"; }

.mdi-arrow-expand-horizontal::before {
  content: "\\F084E"; }

.mdi-arrow-expand-left::before {
  content: "\\F0797"; }

.mdi-arrow-expand-right::before {
  content: "\\F0798"; }

.mdi-arrow-expand-up::before {
  content: "\\F0799"; }

.mdi-arrow-expand-vertical::before {
  content: "\\F084F"; }

.mdi-arrow-horizontal-lock::before {
  content: "\\F115B"; }

.mdi-arrow-left::before {
  content: "\\F004D"; }

.mdi-arrow-left-bold::before {
  content: "\\F0731"; }

.mdi-arrow-left-bold-box::before {
  content: "\\F0732"; }

.mdi-arrow-left-bold-box-outline::before {
  content: "\\F0733"; }

.mdi-arrow-left-bold-circle::before {
  content: "\\F004F"; }

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\F0050"; }

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\F0051"; }

.mdi-arrow-left-bold-outline::before {
  content: "\\F09C0"; }

.mdi-arrow-left-box::before {
  content: "\\F06C1"; }

.mdi-arrow-left-circle::before {
  content: "\\F0CDD"; }

.mdi-arrow-left-circle-outline::before {
  content: "\\F0CDE"; }

.mdi-arrow-left-drop-circle::before {
  content: "\\F0052"; }

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\F0053"; }

.mdi-arrow-left-right::before {
  content: "\\F0E73"; }

.mdi-arrow-left-right-bold::before {
  content: "\\F0E74"; }

.mdi-arrow-left-right-bold-outline::before {
  content: "\\F09C1"; }

.mdi-arrow-left-thick::before {
  content: "\\F004E"; }

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\F159A"; }

.mdi-arrow-right::before {
  content: "\\F0054"; }

.mdi-arrow-right-bold::before {
  content: "\\F0734"; }

.mdi-arrow-right-bold-box::before {
  content: "\\F0735"; }

.mdi-arrow-right-bold-box-outline::before {
  content: "\\F0736"; }

.mdi-arrow-right-bold-circle::before {
  content: "\\F0056"; }

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\F0057"; }

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\F0058"; }

.mdi-arrow-right-bold-outline::before {
  content: "\\F09C2"; }

.mdi-arrow-right-box::before {
  content: "\\F06C2"; }

.mdi-arrow-right-circle::before {
  content: "\\F0CDF"; }

.mdi-arrow-right-circle-outline::before {
  content: "\\F0CE0"; }

.mdi-arrow-right-drop-circle::before {
  content: "\\F0059"; }

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\F005A"; }

.mdi-arrow-right-thick::before {
  content: "\\F0055"; }

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\F1598"; }

.mdi-arrow-split-horizontal::before {
  content: "\\F093B"; }

.mdi-arrow-split-vertical::before {
  content: "\\F093C"; }

.mdi-arrow-top-left::before {
  content: "\\F005B"; }

.mdi-arrow-top-left-bold-outline::before {
  content: "\\F09C3"; }

.mdi-arrow-top-left-bottom-right::before {
  content: "\\F0E75"; }

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\F0E76"; }

.mdi-arrow-top-left-thick::before {
  content: "\\F09C4"; }

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\F1593"; }

.mdi-arrow-top-right::before {
  content: "\\F005C"; }

.mdi-arrow-top-right-bold-outline::before {
  content: "\\F09C5"; }

.mdi-arrow-top-right-bottom-left::before {
  content: "\\F0E77"; }

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\F0E78"; }

.mdi-arrow-top-right-thick::before {
  content: "\\F09C6"; }

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\F1594"; }

.mdi-arrow-up::before {
  content: "\\F005D"; }

.mdi-arrow-up-bold::before {
  content: "\\F0737"; }

.mdi-arrow-up-bold-box::before {
  content: "\\F0738"; }

.mdi-arrow-up-bold-box-outline::before {
  content: "\\F0739"; }

.mdi-arrow-up-bold-circle::before {
  content: "\\F005F"; }

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\F0060"; }

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\F0061"; }

.mdi-arrow-up-bold-outline::before {
  content: "\\F09C7"; }

.mdi-arrow-up-box::before {
  content: "\\F06C3"; }

.mdi-arrow-up-circle::before {
  content: "\\F0CE1"; }

.mdi-arrow-up-circle-outline::before {
  content: "\\F0CE2"; }

.mdi-arrow-up-down::before {
  content: "\\F0E79"; }

.mdi-arrow-up-down-bold::before {
  content: "\\F0E7A"; }

.mdi-arrow-up-down-bold-outline::before {
  content: "\\F09C8"; }

.mdi-arrow-up-drop-circle::before {
  content: "\\F0062"; }

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\F0063"; }

.mdi-arrow-up-thick::before {
  content: "\\F005E"; }

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\F1597"; }

.mdi-arrow-vertical-lock::before {
  content: "\\F115C"; }

.mdi-artstation::before {
  content: "\\F0B5B"; }

.mdi-aspect-ratio::before {
  content: "\\F0A24"; }

.mdi-assistant::before {
  content: "\\F0064"; }

.mdi-asterisk::before {
  content: "\\F06C4"; }

.mdi-at::before {
  content: "\\F0065"; }

.mdi-atlassian::before {
  content: "\\F0804"; }

.mdi-atm::before {
  content: "\\F0D47"; }

.mdi-atom::before {
  content: "\\F0768"; }

.mdi-atom-variant::before {
  content: "\\F0E7B"; }

.mdi-attachment::before {
  content: "\\F0066"; }

.mdi-audio-video::before {
  content: "\\F093D"; }

.mdi-audio-video-off::before {
  content: "\\F11B6"; }

.mdi-augmented-reality::before {
  content: "\\F0850"; }

.mdi-auto-download::before {
  content: "\\F137E"; }

.mdi-auto-fix::before {
  content: "\\F0068"; }

.mdi-auto-upload::before {
  content: "\\F0069"; }

.mdi-autorenew::before {
  content: "\\F006A"; }

.mdi-av-timer::before {
  content: "\\F006B"; }

.mdi-aws::before {
  content: "\\F0E0F"; }

.mdi-axe::before {
  content: "\\F08C8"; }

.mdi-axis::before {
  content: "\\F0D48"; }

.mdi-axis-arrow::before {
  content: "\\F0D49"; }

.mdi-axis-arrow-info::before {
  content: "\\F140E"; }

.mdi-axis-arrow-lock::before {
  content: "\\F0D4A"; }

.mdi-axis-lock::before {
  content: "\\F0D4B"; }

.mdi-axis-x-arrow::before {
  content: "\\F0D4C"; }

.mdi-axis-x-arrow-lock::before {
  content: "\\F0D4D"; }

.mdi-axis-x-rotate-clockwise::before {
  content: "\\F0D4E"; }

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\F0D4F"; }

.mdi-axis-x-y-arrow-lock::before {
  content: "\\F0D50"; }

.mdi-axis-y-arrow::before {
  content: "\\F0D51"; }

.mdi-axis-y-arrow-lock::before {
  content: "\\F0D52"; }

.mdi-axis-y-rotate-clockwise::before {
  content: "\\F0D53"; }

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\F0D54"; }

.mdi-axis-z-arrow::before {
  content: "\\F0D55"; }

.mdi-axis-z-arrow-lock::before {
  content: "\\F0D56"; }

.mdi-axis-z-rotate-clockwise::before {
  content: "\\F0D57"; }

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\F0D58"; }

.mdi-babel::before {
  content: "\\F0A25"; }

.mdi-baby::before {
  content: "\\F006C"; }

.mdi-baby-bottle::before {
  content: "\\F0F39"; }

.mdi-baby-bottle-outline::before {
  content: "\\F0F3A"; }

.mdi-baby-buggy::before {
  content: "\\F13E0"; }

.mdi-baby-carriage::before {
  content: "\\F068F"; }

.mdi-baby-carriage-off::before {
  content: "\\F0FA0"; }

.mdi-baby-face::before {
  content: "\\F0E7C"; }

.mdi-baby-face-outline::before {
  content: "\\F0E7D"; }

.mdi-backburger::before {
  content: "\\F006D"; }

.mdi-backspace::before {
  content: "\\F006E"; }

.mdi-backspace-outline::before {
  content: "\\F0B5C"; }

.mdi-backspace-reverse::before {
  content: "\\F0E7E"; }

.mdi-backspace-reverse-outline::before {
  content: "\\F0E7F"; }

.mdi-backup-restore::before {
  content: "\\F006F"; }

.mdi-bacteria::before {
  content: "\\F0ED5"; }

.mdi-bacteria-outline::before {
  content: "\\F0ED6"; }

.mdi-badge-account::before {
  content: "\\F0DA7"; }

.mdi-badge-account-alert::before {
  content: "\\F0DA8"; }

.mdi-badge-account-alert-outline::before {
  content: "\\F0DA9"; }

.mdi-badge-account-horizontal::before {
  content: "\\F0E0D"; }

.mdi-badge-account-horizontal-outline::before {
  content: "\\F0E0E"; }

.mdi-badge-account-outline::before {
  content: "\\F0DAA"; }

.mdi-badminton::before {
  content: "\\F0851"; }

.mdi-bag-carry-on::before {
  content: "\\F0F3B"; }

.mdi-bag-carry-on-check::before {
  content: "\\F0D65"; }

.mdi-bag-carry-on-off::before {
  content: "\\F0F3C"; }

.mdi-bag-checked::before {
  content: "\\F0F3D"; }

.mdi-bag-personal::before {
  content: "\\F0E10"; }

.mdi-bag-personal-off::before {
  content: "\\F0E11"; }

.mdi-bag-personal-off-outline::before {
  content: "\\F0E12"; }

.mdi-bag-personal-outline::before {
  content: "\\F0E13"; }

.mdi-bag-suitcase::before {
  content: "\\F158B"; }

.mdi-bag-suitcase-off::before {
  content: "\\F158D"; }

.mdi-bag-suitcase-off-outline::before {
  content: "\\F158E"; }

.mdi-bag-suitcase-outline::before {
  content: "\\F158C"; }

.mdi-baguette::before {
  content: "\\F0F3E"; }

.mdi-balloon::before {
  content: "\\F0A26"; }

.mdi-ballot::before {
  content: "\\F09C9"; }

.mdi-ballot-outline::before {
  content: "\\F09CA"; }

.mdi-ballot-recount::before {
  content: "\\F0C39"; }

.mdi-ballot-recount-outline::before {
  content: "\\F0C3A"; }

.mdi-bandage::before {
  content: "\\F0DAF"; }

.mdi-bandcamp::before {
  content: "\\F0675"; }

.mdi-bank::before {
  content: "\\F0070"; }

.mdi-bank-check::before {
  content: "\\F1655"; }

.mdi-bank-minus::before {
  content: "\\F0DB0"; }

.mdi-bank-off::before {
  content: "\\F1656"; }

.mdi-bank-off-outline::before {
  content: "\\F1657"; }

.mdi-bank-outline::before {
  content: "\\F0E80"; }

.mdi-bank-plus::before {
  content: "\\F0DB1"; }

.mdi-bank-remove::before {
  content: "\\F0DB2"; }

.mdi-bank-transfer::before {
  content: "\\F0A27"; }

.mdi-bank-transfer-in::before {
  content: "\\F0A28"; }

.mdi-bank-transfer-out::before {
  content: "\\F0A29"; }

.mdi-barcode::before {
  content: "\\F0071"; }

.mdi-barcode-off::before {
  content: "\\F1236"; }

.mdi-barcode-scan::before {
  content: "\\F0072"; }

.mdi-barley::before {
  content: "\\F0073"; }

.mdi-barley-off::before {
  content: "\\F0B5D"; }

.mdi-barn::before {
  content: "\\F0B5E"; }

.mdi-barrel::before {
  content: "\\F0074"; }

.mdi-baseball::before {
  content: "\\F0852"; }

.mdi-baseball-bat::before {
  content: "\\F0853"; }

.mdi-baseball-diamond::before {
  content: "\\F15EC"; }

.mdi-baseball-diamond-outline::before {
  content: "\\F15ED"; }

.mdi-bash::before {
  content: "\\F1183"; }

.mdi-basket::before {
  content: "\\F0076"; }

.mdi-basket-fill::before {
  content: "\\F0077"; }

.mdi-basket-minus::before {
  content: "\\F1523"; }

.mdi-basket-minus-outline::before {
  content: "\\F1524"; }

.mdi-basket-off::before {
  content: "\\F1525"; }

.mdi-basket-off-outline::before {
  content: "\\F1526"; }

.mdi-basket-outline::before {
  content: "\\F1181"; }

.mdi-basket-plus::before {
  content: "\\F1527"; }

.mdi-basket-plus-outline::before {
  content: "\\F1528"; }

.mdi-basket-remove::before {
  content: "\\F1529"; }

.mdi-basket-remove-outline::before {
  content: "\\F152A"; }

.mdi-basket-unfill::before {
  content: "\\F0078"; }

.mdi-basketball::before {
  content: "\\F0806"; }

.mdi-basketball-hoop::before {
  content: "\\F0C3B"; }

.mdi-basketball-hoop-outline::before {
  content: "\\F0C3C"; }

.mdi-bat::before {
  content: "\\F0B5F"; }

.mdi-battery::before {
  content: "\\F0079"; }

.mdi-battery-10::before {
  content: "\\F007A"; }

.mdi-battery-10-bluetooth::before {
  content: "\\F093E"; }

.mdi-battery-20::before {
  content: "\\F007B"; }

.mdi-battery-20-bluetooth::before {
  content: "\\F093F"; }

.mdi-battery-30::before {
  content: "\\F007C"; }

.mdi-battery-30-bluetooth::before {
  content: "\\F0940"; }

.mdi-battery-40::before {
  content: "\\F007D"; }

.mdi-battery-40-bluetooth::before {
  content: "\\F0941"; }

.mdi-battery-50::before {
  content: "\\F007E"; }

.mdi-battery-50-bluetooth::before {
  content: "\\F0942"; }

.mdi-battery-60::before {
  content: "\\F007F"; }

.mdi-battery-60-bluetooth::before {
  content: "\\F0943"; }

.mdi-battery-70::before {
  content: "\\F0080"; }

.mdi-battery-70-bluetooth::before {
  content: "\\F0944"; }

.mdi-battery-80::before {
  content: "\\F0081"; }

.mdi-battery-80-bluetooth::before {
  content: "\\F0945"; }

.mdi-battery-90::before {
  content: "\\F0082"; }

.mdi-battery-90-bluetooth::before {
  content: "\\F0946"; }

.mdi-battery-alert::before {
  content: "\\F0083"; }

.mdi-battery-alert-bluetooth::before {
  content: "\\F0947"; }

.mdi-battery-alert-variant::before {
  content: "\\F10CC"; }

.mdi-battery-alert-variant-outline::before {
  content: "\\F10CD"; }

.mdi-battery-bluetooth::before {
  content: "\\F0948"; }

.mdi-battery-bluetooth-variant::before {
  content: "\\F0949"; }

.mdi-battery-charging::before {
  content: "\\F0084"; }

.mdi-battery-charging-10::before {
  content: "\\F089C"; }

.mdi-battery-charging-100::before {
  content: "\\F0085"; }

.mdi-battery-charging-20::before {
  content: "\\F0086"; }

.mdi-battery-charging-30::before {
  content: "\\F0087"; }

.mdi-battery-charging-40::before {
  content: "\\F0088"; }

.mdi-battery-charging-50::before {
  content: "\\F089D"; }

.mdi-battery-charging-60::before {
  content: "\\F0089"; }

.mdi-battery-charging-70::before {
  content: "\\F089E"; }

.mdi-battery-charging-80::before {
  content: "\\F008A"; }

.mdi-battery-charging-90::before {
  content: "\\F008B"; }

.mdi-battery-charging-high::before {
  content: "\\F12A6"; }

.mdi-battery-charging-low::before {
  content: "\\F12A4"; }

.mdi-battery-charging-medium::before {
  content: "\\F12A5"; }

.mdi-battery-charging-outline::before {
  content: "\\F089F"; }

.mdi-battery-charging-wireless::before {
  content: "\\F0807"; }

.mdi-battery-charging-wireless-10::before {
  content: "\\F0808"; }

.mdi-battery-charging-wireless-20::before {
  content: "\\F0809"; }

.mdi-battery-charging-wireless-30::before {
  content: "\\F080A"; }

.mdi-battery-charging-wireless-40::before {
  content: "\\F080B"; }

.mdi-battery-charging-wireless-50::before {
  content: "\\F080C"; }

.mdi-battery-charging-wireless-60::before {
  content: "\\F080D"; }

.mdi-battery-charging-wireless-70::before {
  content: "\\F080E"; }

.mdi-battery-charging-wireless-80::before {
  content: "\\F080F"; }

.mdi-battery-charging-wireless-90::before {
  content: "\\F0810"; }

.mdi-battery-charging-wireless-alert::before {
  content: "\\F0811"; }

.mdi-battery-charging-wireless-outline::before {
  content: "\\F0812"; }

.mdi-battery-heart::before {
  content: "\\F120F"; }

.mdi-battery-heart-outline::before {
  content: "\\F1210"; }

.mdi-battery-heart-variant::before {
  content: "\\F1211"; }

.mdi-battery-high::before {
  content: "\\F12A3"; }

.mdi-battery-low::before {
  content: "\\F12A1"; }

.mdi-battery-medium::before {
  content: "\\F12A2"; }

.mdi-battery-minus::before {
  content: "\\F008C"; }

.mdi-battery-negative::before {
  content: "\\F008D"; }

.mdi-battery-off::before {
  content: "\\F125D"; }

.mdi-battery-off-outline::before {
  content: "\\F125E"; }

.mdi-battery-outline::before {
  content: "\\F008E"; }

.mdi-battery-plus::before {
  content: "\\F008F"; }

.mdi-battery-positive::before {
  content: "\\F0090"; }

.mdi-battery-unknown::before {
  content: "\\F0091"; }

.mdi-battery-unknown-bluetooth::before {
  content: "\\F094A"; }

.mdi-battlenet::before {
  content: "\\F0B60"; }

.mdi-beach::before {
  content: "\\F0092"; }

.mdi-beaker::before {
  content: "\\F0CEA"; }

.mdi-beaker-alert::before {
  content: "\\F1229"; }

.mdi-beaker-alert-outline::before {
  content: "\\F122A"; }

.mdi-beaker-check::before {
  content: "\\F122B"; }

.mdi-beaker-check-outline::before {
  content: "\\F122C"; }

.mdi-beaker-minus::before {
  content: "\\F122D"; }

.mdi-beaker-minus-outline::before {
  content: "\\F122E"; }

.mdi-beaker-outline::before {
  content: "\\F0690"; }

.mdi-beaker-plus::before {
  content: "\\F122F"; }

.mdi-beaker-plus-outline::before {
  content: "\\F1230"; }

.mdi-beaker-question::before {
  content: "\\F1231"; }

.mdi-beaker-question-outline::before {
  content: "\\F1232"; }

.mdi-beaker-remove::before {
  content: "\\F1233"; }

.mdi-beaker-remove-outline::before {
  content: "\\F1234"; }

.mdi-bed::before {
  content: "\\F02E3"; }

.mdi-bed-double::before {
  content: "\\F0FD4"; }

.mdi-bed-double-outline::before {
  content: "\\F0FD3"; }

.mdi-bed-empty::before {
  content: "\\F08A0"; }

.mdi-bed-king::before {
  content: "\\F0FD2"; }

.mdi-bed-king-outline::before {
  content: "\\F0FD1"; }

.mdi-bed-outline::before {
  content: "\\F0099"; }

.mdi-bed-queen::before {
  content: "\\F0FD0"; }

.mdi-bed-queen-outline::before {
  content: "\\F0FDB"; }

.mdi-bed-single::before {
  content: "\\F106D"; }

.mdi-bed-single-outline::before {
  content: "\\F106E"; }

.mdi-bee::before {
  content: "\\F0FA1"; }

.mdi-bee-flower::before {
  content: "\\F0FA2"; }

.mdi-beehive-off-outline::before {
  content: "\\F13ED"; }

.mdi-beehive-outline::before {
  content: "\\F10CE"; }

.mdi-beekeeper::before {
  content: "\\F14E2"; }

.mdi-beer::before {
  content: "\\F0098"; }

.mdi-beer-outline::before {
  content: "\\F130C"; }

.mdi-bell::before {
  content: "\\F009A"; }

.mdi-bell-alert::before {
  content: "\\F0D59"; }

.mdi-bell-alert-outline::before {
  content: "\\F0E81"; }

.mdi-bell-cancel::before {
  content: "\\F13E7"; }

.mdi-bell-cancel-outline::before {
  content: "\\F13E8"; }

.mdi-bell-check::before {
  content: "\\F11E5"; }

.mdi-bell-check-outline::before {
  content: "\\F11E6"; }

.mdi-bell-circle::before {
  content: "\\F0D5A"; }

.mdi-bell-circle-outline::before {
  content: "\\F0D5B"; }

.mdi-bell-minus::before {
  content: "\\F13E9"; }

.mdi-bell-minus-outline::before {
  content: "\\F13EA"; }

.mdi-bell-off::before {
  content: "\\F009B"; }

.mdi-bell-off-outline::before {
  content: "\\F0A91"; }

.mdi-bell-outline::before {
  content: "\\F009C"; }

.mdi-bell-plus::before {
  content: "\\F009D"; }

.mdi-bell-plus-outline::before {
  content: "\\F0A92"; }

.mdi-bell-remove::before {
  content: "\\F13EB"; }

.mdi-bell-remove-outline::before {
  content: "\\F13EC"; }

.mdi-bell-ring::before {
  content: "\\F009E"; }

.mdi-bell-ring-outline::before {
  content: "\\F009F"; }

.mdi-bell-sleep::before {
  content: "\\F00A0"; }

.mdi-bell-sleep-outline::before {
  content: "\\F0A93"; }

.mdi-beta::before {
  content: "\\F00A1"; }

.mdi-betamax::before {
  content: "\\F09CB"; }

.mdi-biathlon::before {
  content: "\\F0E14"; }

.mdi-bicycle::before {
  content: "\\F109C"; }

.mdi-bicycle-basket::before {
  content: "\\F1235"; }

.mdi-bicycle-electric::before {
  content: "\\F15B4"; }

.mdi-bicycle-penny-farthing::before {
  content: "\\F15E9"; }

.mdi-bike::before {
  content: "\\F00A3"; }

.mdi-bike-fast::before {
  content: "\\F111F"; }

.mdi-billboard::before {
  content: "\\F1010"; }

.mdi-billiards::before {
  content: "\\F0B61"; }

.mdi-billiards-rack::before {
  content: "\\F0B62"; }

.mdi-binoculars::before {
  content: "\\F00A5"; }

.mdi-bio::before {
  content: "\\F00A6"; }

.mdi-biohazard::before {
  content: "\\F00A7"; }

.mdi-bird::before {
  content: "\\F15C6"; }

.mdi-bitbucket::before {
  content: "\\F00A8"; }

.mdi-bitcoin::before {
  content: "\\F0813"; }

.mdi-black-mesa::before {
  content: "\\F00A9"; }

.mdi-blender::before {
  content: "\\F0CEB"; }

.mdi-blender-software::before {
  content: "\\F00AB"; }

.mdi-blinds::before {
  content: "\\F00AC"; }

.mdi-blinds-open::before {
  content: "\\F1011"; }

.mdi-block-helper::before {
  content: "\\F00AD"; }

.mdi-blogger::before {
  content: "\\F00AE"; }

.mdi-blood-bag::before {
  content: "\\F0CEC"; }

.mdi-bluetooth::before {
  content: "\\F00AF"; }

.mdi-bluetooth-audio::before {
  content: "\\F00B0"; }

.mdi-bluetooth-connect::before {
  content: "\\F00B1"; }

.mdi-bluetooth-off::before {
  content: "\\F00B2"; }

.mdi-bluetooth-settings::before {
  content: "\\F00B3"; }

.mdi-bluetooth-transfer::before {
  content: "\\F00B4"; }

.mdi-blur::before {
  content: "\\F00B5"; }

.mdi-blur-linear::before {
  content: "\\F00B6"; }

.mdi-blur-off::before {
  content: "\\F00B7"; }

.mdi-blur-radial::before {
  content: "\\F00B8"; }

.mdi-bolnisi-cross::before {
  content: "\\F0CED"; }

.mdi-bolt::before {
  content: "\\F0DB3"; }

.mdi-bomb::before {
  content: "\\F0691"; }

.mdi-bomb-off::before {
  content: "\\F06C5"; }

.mdi-bone::before {
  content: "\\F00B9"; }

.mdi-book::before {
  content: "\\F00BA"; }

.mdi-book-account::before {
  content: "\\F13AD"; }

.mdi-book-account-outline::before {
  content: "\\F13AE"; }

.mdi-book-alert::before {
  content: "\\F167C"; }

.mdi-book-alert-outline::before {
  content: "\\F167D"; }

.mdi-book-alphabet::before {
  content: "\\F061D"; }

.mdi-book-arrow-down::before {
  content: "\\F167E"; }

.mdi-book-arrow-down-outline::before {
  content: "\\F167F"; }

.mdi-book-arrow-left::before {
  content: "\\F1680"; }

.mdi-book-arrow-left-outline::before {
  content: "\\F1681"; }

.mdi-book-arrow-right::before {
  content: "\\F1682"; }

.mdi-book-arrow-right-outline::before {
  content: "\\F1683"; }

.mdi-book-arrow-up::before {
  content: "\\F1684"; }

.mdi-book-arrow-up-outline::before {
  content: "\\F1685"; }

.mdi-book-cancel::before {
  content: "\\F1686"; }

.mdi-book-cancel-outline::before {
  content: "\\F1687"; }

.mdi-book-check::before {
  content: "\\F14F3"; }

.mdi-book-check-outline::before {
  content: "\\F14F4"; }

.mdi-book-clock::before {
  content: "\\F1688"; }

.mdi-book-clock-outline::before {
  content: "\\F1689"; }

.mdi-book-cog::before {
  content: "\\F168A"; }

.mdi-book-cog-outline::before {
  content: "\\F168B"; }

.mdi-book-cross::before {
  content: "\\F00A2"; }

.mdi-book-edit::before {
  content: "\\F168C"; }

.mdi-book-edit-outline::before {
  content: "\\F168D"; }

.mdi-book-education::before {
  content: "\\F16C9"; }

.mdi-book-education-outline::before {
  content: "\\F16CA"; }

.mdi-book-information-variant::before {
  content: "\\F106F"; }

.mdi-book-lock::before {
  content: "\\F079A"; }

.mdi-book-lock-open::before {
  content: "\\F079B"; }

.mdi-book-lock-open-outline::before {
  content: "\\F168E"; }

.mdi-book-lock-outline::before {
  content: "\\F168F"; }

.mdi-book-marker::before {
  content: "\\F1690"; }

.mdi-book-marker-outline::before {
  content: "\\F1691"; }

.mdi-book-minus::before {
  content: "\\F05D9"; }

.mdi-book-minus-multiple::before {
  content: "\\F0A94"; }

.mdi-book-minus-multiple-outline::before {
  content: "\\F090B"; }

.mdi-book-minus-outline::before {
  content: "\\F1692"; }

.mdi-book-multiple::before {
  content: "\\F00BB"; }

.mdi-book-multiple-outline::before {
  content: "\\F0436"; }

.mdi-book-music::before {
  content: "\\F0067"; }

.mdi-book-music-outline::before {
  content: "\\F1693"; }

.mdi-book-off::before {
  content: "\\F1694"; }

.mdi-book-off-outline::before {
  content: "\\F1695"; }

.mdi-book-open::before {
  content: "\\F00BD"; }

.mdi-book-open-blank-variant::before {
  content: "\\F00BE"; }

.mdi-book-open-outline::before {
  content: "\\F0B63"; }

.mdi-book-open-page-variant::before {
  content: "\\F05DA"; }

.mdi-book-open-page-variant-outline::before {
  content: "\\F15D6"; }

.mdi-book-open-variant::before {
  content: "\\F14F7"; }

.mdi-book-outline::before {
  content: "\\F0B64"; }

.mdi-book-play::before {
  content: "\\F0E82"; }

.mdi-book-play-outline::before {
  content: "\\F0E83"; }

.mdi-book-plus::before {
  content: "\\F05DB"; }

.mdi-book-plus-multiple::before {
  content: "\\F0A95"; }

.mdi-book-plus-multiple-outline::before {
  content: "\\F0ADE"; }

.mdi-book-plus-outline::before {
  content: "\\F1696"; }

.mdi-book-refresh::before {
  content: "\\F1697"; }

.mdi-book-refresh-outline::before {
  content: "\\F1698"; }

.mdi-book-remove::before {
  content: "\\F0A97"; }

.mdi-book-remove-multiple::before {
  content: "\\F0A96"; }

.mdi-book-remove-multiple-outline::before {
  content: "\\F04CA"; }

.mdi-book-remove-outline::before {
  content: "\\F1699"; }

.mdi-book-search::before {
  content: "\\F0E84"; }

.mdi-book-search-outline::before {
  content: "\\F0E85"; }

.mdi-book-settings::before {
  content: "\\F169A"; }

.mdi-book-settings-outline::before {
  content: "\\F169B"; }

.mdi-book-sync::before {
  content: "\\F169C"; }

.mdi-book-sync-outline::before {
  content: "\\F16C8"; }

.mdi-book-variant::before {
  content: "\\F00BF"; }

.mdi-book-variant-multiple::before {
  content: "\\F00BC"; }

.mdi-bookmark::before {
  content: "\\F00C0"; }

.mdi-bookmark-check::before {
  content: "\\F00C1"; }

.mdi-bookmark-check-outline::before {
  content: "\\F137B"; }

.mdi-bookmark-minus::before {
  content: "\\F09CC"; }

.mdi-bookmark-minus-outline::before {
  content: "\\F09CD"; }

.mdi-bookmark-multiple::before {
  content: "\\F0E15"; }

.mdi-bookmark-multiple-outline::before {
  content: "\\F0E16"; }

.mdi-bookmark-music::before {
  content: "\\F00C2"; }

.mdi-bookmark-music-outline::before {
  content: "\\F1379"; }

.mdi-bookmark-off::before {
  content: "\\F09CE"; }

.mdi-bookmark-off-outline::before {
  content: "\\F09CF"; }

.mdi-bookmark-outline::before {
  content: "\\F00C3"; }

.mdi-bookmark-plus::before {
  content: "\\F00C5"; }

.mdi-bookmark-plus-outline::before {
  content: "\\F00C4"; }

.mdi-bookmark-remove::before {
  content: "\\F00C6"; }

.mdi-bookmark-remove-outline::before {
  content: "\\F137A"; }

.mdi-bookshelf::before {
  content: "\\F125F"; }

.mdi-boom-gate::before {
  content: "\\F0E86"; }

.mdi-boom-gate-alert::before {
  content: "\\F0E87"; }

.mdi-boom-gate-alert-outline::before {
  content: "\\F0E88"; }

.mdi-boom-gate-down::before {
  content: "\\F0E89"; }

.mdi-boom-gate-down-outline::before {
  content: "\\F0E8A"; }

.mdi-boom-gate-outline::before {
  content: "\\F0E8B"; }

.mdi-boom-gate-up::before {
  content: "\\F0E8C"; }

.mdi-boom-gate-up-outline::before {
  content: "\\F0E8D"; }

.mdi-boombox::before {
  content: "\\F05DC"; }

.mdi-boomerang::before {
  content: "\\F10CF"; }

.mdi-bootstrap::before {
  content: "\\F06C6"; }

.mdi-border-all::before {
  content: "\\F00C7"; }

.mdi-border-all-variant::before {
  content: "\\F08A1"; }

.mdi-border-bottom::before {
  content: "\\F00C8"; }

.mdi-border-bottom-variant::before {
  content: "\\F08A2"; }

.mdi-border-color::before {
  content: "\\F00C9"; }

.mdi-border-horizontal::before {
  content: "\\F00CA"; }

.mdi-border-inside::before {
  content: "\\F00CB"; }

.mdi-border-left::before {
  content: "\\F00CC"; }

.mdi-border-left-variant::before {
  content: "\\F08A3"; }

.mdi-border-none::before {
  content: "\\F00CD"; }

.mdi-border-none-variant::before {
  content: "\\F08A4"; }

.mdi-border-outside::before {
  content: "\\F00CE"; }

.mdi-border-right::before {
  content: "\\F00CF"; }

.mdi-border-right-variant::before {
  content: "\\F08A5"; }

.mdi-border-style::before {
  content: "\\F00D0"; }

.mdi-border-top::before {
  content: "\\F00D1"; }

.mdi-border-top-variant::before {
  content: "\\F08A6"; }

.mdi-border-vertical::before {
  content: "\\F00D2"; }

.mdi-bottle-soda::before {
  content: "\\F1070"; }

.mdi-bottle-soda-classic::before {
  content: "\\F1071"; }

.mdi-bottle-soda-classic-outline::before {
  content: "\\F1363"; }

.mdi-bottle-soda-outline::before {
  content: "\\F1072"; }

.mdi-bottle-tonic::before {
  content: "\\F112E"; }

.mdi-bottle-tonic-outline::before {
  content: "\\F112F"; }

.mdi-bottle-tonic-plus::before {
  content: "\\F1130"; }

.mdi-bottle-tonic-plus-outline::before {
  content: "\\F1131"; }

.mdi-bottle-tonic-skull::before {
  content: "\\F1132"; }

.mdi-bottle-tonic-skull-outline::before {
  content: "\\F1133"; }

.mdi-bottle-wine::before {
  content: "\\F0854"; }

.mdi-bottle-wine-outline::before {
  content: "\\F1310"; }

.mdi-bow-tie::before {
  content: "\\F0678"; }

.mdi-bowl::before {
  content: "\\F028E"; }

.mdi-bowl-mix::before {
  content: "\\F0617"; }

.mdi-bowl-mix-outline::before {
  content: "\\F02E4"; }

.mdi-bowl-outline::before {
  content: "\\F02A9"; }

.mdi-bowling::before {
  content: "\\F00D3"; }

.mdi-box::before {
  content: "\\F00D4"; }

.mdi-box-cutter::before {
  content: "\\F00D5"; }

.mdi-box-cutter-off::before {
  content: "\\F0B4A"; }

.mdi-box-shadow::before {
  content: "\\F0637"; }

.mdi-boxing-glove::before {
  content: "\\F0B65"; }

.mdi-braille::before {
  content: "\\F09D0"; }

.mdi-brain::before {
  content: "\\F09D1"; }

.mdi-bread-slice::before {
  content: "\\F0CEE"; }

.mdi-bread-slice-outline::before {
  content: "\\F0CEF"; }

.mdi-bridge::before {
  content: "\\F0618"; }

.mdi-briefcase::before {
  content: "\\F00D6"; }

.mdi-briefcase-account::before {
  content: "\\F0CF0"; }

.mdi-briefcase-account-outline::before {
  content: "\\F0CF1"; }

.mdi-briefcase-check::before {
  content: "\\F00D7"; }

.mdi-briefcase-check-outline::before {
  content: "\\F131E"; }

.mdi-briefcase-clock::before {
  content: "\\F10D0"; }

.mdi-briefcase-clock-outline::before {
  content: "\\F10D1"; }

.mdi-briefcase-download::before {
  content: "\\F00D8"; }

.mdi-briefcase-download-outline::before {
  content: "\\F0C3D"; }

.mdi-briefcase-edit::before {
  content: "\\F0A98"; }

.mdi-briefcase-edit-outline::before {
  content: "\\F0C3E"; }

.mdi-briefcase-minus::before {
  content: "\\F0A2A"; }

.mdi-briefcase-minus-outline::before {
  content: "\\F0C3F"; }

.mdi-briefcase-off::before {
  content: "\\F1658"; }

.mdi-briefcase-off-outline::before {
  content: "\\F1659"; }

.mdi-briefcase-outline::before {
  content: "\\F0814"; }

.mdi-briefcase-plus::before {
  content: "\\F0A2B"; }

.mdi-briefcase-plus-outline::before {
  content: "\\F0C40"; }

.mdi-briefcase-remove::before {
  content: "\\F0A2C"; }

.mdi-briefcase-remove-outline::before {
  content: "\\F0C41"; }

.mdi-briefcase-search::before {
  content: "\\F0A2D"; }

.mdi-briefcase-search-outline::before {
  content: "\\F0C42"; }

.mdi-briefcase-upload::before {
  content: "\\F00D9"; }

.mdi-briefcase-upload-outline::before {
  content: "\\F0C43"; }

.mdi-briefcase-variant::before {
  content: "\\F1494"; }

.mdi-briefcase-variant-off::before {
  content: "\\F165A"; }

.mdi-briefcase-variant-off-outline::before {
  content: "\\F165B"; }

.mdi-briefcase-variant-outline::before {
  content: "\\F1495"; }

.mdi-brightness-1::before {
  content: "\\F00DA"; }

.mdi-brightness-2::before {
  content: "\\F00DB"; }

.mdi-brightness-3::before {
  content: "\\F00DC"; }

.mdi-brightness-4::before {
  content: "\\F00DD"; }

.mdi-brightness-5::before {
  content: "\\F00DE"; }

.mdi-brightness-6::before {
  content: "\\F00DF"; }

.mdi-brightness-7::before {
  content: "\\F00E0"; }

.mdi-brightness-auto::before {
  content: "\\F00E1"; }

.mdi-brightness-percent::before {
  content: "\\F0CF2"; }

.mdi-broadcast::before {
  content: "\\F1720"; }

.mdi-broadcast-off::before {
  content: "\\F1721"; }

.mdi-broom::before {
  content: "\\F00E2"; }

.mdi-brush::before {
  content: "\\F00E3"; }

.mdi-bucket::before {
  content: "\\F1415"; }

.mdi-bucket-outline::before {
  content: "\\F1416"; }

.mdi-buddhism::before {
  content: "\\F094B"; }

.mdi-buffer::before {
  content: "\\F0619"; }

.mdi-buffet::before {
  content: "\\F0578"; }

.mdi-bug::before {
  content: "\\F00E4"; }

.mdi-bug-check::before {
  content: "\\F0A2E"; }

.mdi-bug-check-outline::before {
  content: "\\F0A2F"; }

.mdi-bug-outline::before {
  content: "\\F0A30"; }

.mdi-bugle::before {
  content: "\\F0DB4"; }

.mdi-bulldozer::before {
  content: "\\F0B22"; }

.mdi-bullet::before {
  content: "\\F0CF3"; }

.mdi-bulletin-board::before {
  content: "\\F00E5"; }

.mdi-bullhorn::before {
  content: "\\F00E6"; }

.mdi-bullhorn-outline::before {
  content: "\\F0B23"; }

.mdi-bullseye::before {
  content: "\\F05DD"; }

.mdi-bullseye-arrow::before {
  content: "\\F08C9"; }

.mdi-bulma::before {
  content: "\\F12E7"; }

.mdi-bunk-bed::before {
  content: "\\F1302"; }

.mdi-bunk-bed-outline::before {
  content: "\\F0097"; }

.mdi-bus::before {
  content: "\\F00E7"; }

.mdi-bus-alert::before {
  content: "\\F0A99"; }

.mdi-bus-articulated-end::before {
  content: "\\F079C"; }

.mdi-bus-articulated-front::before {
  content: "\\F079D"; }

.mdi-bus-clock::before {
  content: "\\F08CA"; }

.mdi-bus-double-decker::before {
  content: "\\F079E"; }

.mdi-bus-marker::before {
  content: "\\F1212"; }

.mdi-bus-multiple::before {
  content: "\\F0F3F"; }

.mdi-bus-school::before {
  content: "\\F079F"; }

.mdi-bus-side::before {
  content: "\\F07A0"; }

.mdi-bus-stop::before {
  content: "\\F1012"; }

.mdi-bus-stop-covered::before {
  content: "\\F1013"; }

.mdi-bus-stop-uncovered::before {
  content: "\\F1014"; }

.mdi-butterfly::before {
  content: "\\F1589"; }

.mdi-butterfly-outline::before {
  content: "\\F158A"; }

.mdi-cable-data::before {
  content: "\\F1394"; }

.mdi-cached::before {
  content: "\\F00E8"; }

.mdi-cactus::before {
  content: "\\F0DB5"; }

.mdi-cake::before {
  content: "\\F00E9"; }

.mdi-cake-layered::before {
  content: "\\F00EA"; }

.mdi-cake-variant::before {
  content: "\\F00EB"; }

.mdi-calculator::before {
  content: "\\F00EC"; }

.mdi-calculator-variant::before {
  content: "\\F0A9A"; }

.mdi-calculator-variant-outline::before {
  content: "\\F15A6"; }

.mdi-calendar::before {
  content: "\\F00ED"; }

.mdi-calendar-account::before {
  content: "\\F0ED7"; }

.mdi-calendar-account-outline::before {
  content: "\\F0ED8"; }

.mdi-calendar-alert::before {
  content: "\\F0A31"; }

.mdi-calendar-arrow-left::before {
  content: "\\F1134"; }

.mdi-calendar-arrow-right::before {
  content: "\\F1135"; }

.mdi-calendar-blank::before {
  content: "\\F00EE"; }

.mdi-calendar-blank-multiple::before {
  content: "\\F1073"; }

.mdi-calendar-blank-outline::before {
  content: "\\F0B66"; }

.mdi-calendar-check::before {
  content: "\\F00EF"; }

.mdi-calendar-check-outline::before {
  content: "\\F0C44"; }

.mdi-calendar-clock::before {
  content: "\\F00F0"; }

.mdi-calendar-clock-outline::before {
  content: "\\F16E1"; }

.mdi-calendar-cursor::before {
  content: "\\F157B"; }

.mdi-calendar-edit::before {
  content: "\\F08A7"; }

.mdi-calendar-end::before {
  content: "\\F166C"; }

.mdi-calendar-export::before {
  content: "\\F0B24"; }

.mdi-calendar-heart::before {
  content: "\\F09D2"; }

.mdi-calendar-import::before {
  content: "\\F0B25"; }

.mdi-calendar-lock::before {
  content: "\\F1641"; }

.mdi-calendar-lock-outline::before {
  content: "\\F1642"; }

.mdi-calendar-minus::before {
  content: "\\F0D5C"; }

.mdi-calendar-month::before {
  content: "\\F0E17"; }

.mdi-calendar-month-outline::before {
  content: "\\F0E18"; }

.mdi-calendar-multiple::before {
  content: "\\F00F1"; }

.mdi-calendar-multiple-check::before {
  content: "\\F00F2"; }

.mdi-calendar-multiselect::before {
  content: "\\F0A32"; }

.mdi-calendar-outline::before {
  content: "\\F0B67"; }

.mdi-calendar-plus::before {
  content: "\\F00F3"; }

.mdi-calendar-question::before {
  content: "\\F0692"; }

.mdi-calendar-range::before {
  content: "\\F0679"; }

.mdi-calendar-range-outline::before {
  content: "\\F0B68"; }

.mdi-calendar-refresh::before {
  content: "\\F01E1"; }

.mdi-calendar-refresh-outline::before {
  content: "\\F0203"; }

.mdi-calendar-remove::before {
  content: "\\F00F4"; }

.mdi-calendar-remove-outline::before {
  content: "\\F0C45"; }

.mdi-calendar-search::before {
  content: "\\F094C"; }

.mdi-calendar-star::before {
  content: "\\F09D3"; }

.mdi-calendar-start::before {
  content: "\\F166D"; }

.mdi-calendar-sync::before {
  content: "\\F0E8E"; }

.mdi-calendar-sync-outline::before {
  content: "\\F0E8F"; }

.mdi-calendar-text::before {
  content: "\\F00F5"; }

.mdi-calendar-text-outline::before {
  content: "\\F0C46"; }

.mdi-calendar-today::before {
  content: "\\F00F6"; }

.mdi-calendar-week::before {
  content: "\\F0A33"; }

.mdi-calendar-week-begin::before {
  content: "\\F0A34"; }

.mdi-calendar-weekend::before {
  content: "\\F0ED9"; }

.mdi-calendar-weekend-outline::before {
  content: "\\F0EDA"; }

.mdi-call-made::before {
  content: "\\F00F7"; }

.mdi-call-merge::before {
  content: "\\F00F8"; }

.mdi-call-missed::before {
  content: "\\F00F9"; }

.mdi-call-received::before {
  content: "\\F00FA"; }

.mdi-call-split::before {
  content: "\\F00FB"; }

.mdi-camcorder::before {
  content: "\\F00FC"; }

.mdi-camcorder-off::before {
  content: "\\F00FF"; }

.mdi-camera::before {
  content: "\\F0100"; }

.mdi-camera-account::before {
  content: "\\F08CB"; }

.mdi-camera-burst::before {
  content: "\\F0693"; }

.mdi-camera-control::before {
  content: "\\F0B69"; }

.mdi-camera-enhance::before {
  content: "\\F0101"; }

.mdi-camera-enhance-outline::before {
  content: "\\F0B6A"; }

.mdi-camera-flip::before {
  content: "\\F15D9"; }

.mdi-camera-flip-outline::before {
  content: "\\F15DA"; }

.mdi-camera-front::before {
  content: "\\F0102"; }

.mdi-camera-front-variant::before {
  content: "\\F0103"; }

.mdi-camera-gopro::before {
  content: "\\F07A1"; }

.mdi-camera-image::before {
  content: "\\F08CC"; }

.mdi-camera-iris::before {
  content: "\\F0104"; }

.mdi-camera-metering-center::before {
  content: "\\F07A2"; }

.mdi-camera-metering-matrix::before {
  content: "\\F07A3"; }

.mdi-camera-metering-partial::before {
  content: "\\F07A4"; }

.mdi-camera-metering-spot::before {
  content: "\\F07A5"; }

.mdi-camera-off::before {
  content: "\\F05DF"; }

.mdi-camera-outline::before {
  content: "\\F0D5D"; }

.mdi-camera-party-mode::before {
  content: "\\F0105"; }

.mdi-camera-plus::before {
  content: "\\F0EDB"; }

.mdi-camera-plus-outline::before {
  content: "\\F0EDC"; }

.mdi-camera-rear::before {
  content: "\\F0106"; }

.mdi-camera-rear-variant::before {
  content: "\\F0107"; }

.mdi-camera-retake::before {
  content: "\\F0E19"; }

.mdi-camera-retake-outline::before {
  content: "\\F0E1A"; }

.mdi-camera-switch::before {
  content: "\\F0108"; }

.mdi-camera-switch-outline::before {
  content: "\\F084A"; }

.mdi-camera-timer::before {
  content: "\\F0109"; }

.mdi-camera-wireless::before {
  content: "\\F0DB6"; }

.mdi-camera-wireless-outline::before {
  content: "\\F0DB7"; }

.mdi-campfire::before {
  content: "\\F0EDD"; }

.mdi-cancel::before {
  content: "\\F073A"; }

.mdi-candle::before {
  content: "\\F05E2"; }

.mdi-candycane::before {
  content: "\\F010A"; }

.mdi-cannabis::before {
  content: "\\F07A6"; }

.mdi-cannabis-off::before {
  content: "\\F166E"; }

.mdi-caps-lock::before {
  content: "\\F0A9B"; }

.mdi-car::before {
  content: "\\F010B"; }

.mdi-car-2-plus::before {
  content: "\\F1015"; }

.mdi-car-3-plus::before {
  content: "\\F1016"; }

.mdi-car-arrow-left::before {
  content: "\\F13B2"; }

.mdi-car-arrow-right::before {
  content: "\\F13B3"; }

.mdi-car-back::before {
  content: "\\F0E1B"; }

.mdi-car-battery::before {
  content: "\\F010C"; }

.mdi-car-brake-abs::before {
  content: "\\F0C47"; }

.mdi-car-brake-alert::before {
  content: "\\F0C48"; }

.mdi-car-brake-hold::before {
  content: "\\F0D5E"; }

.mdi-car-brake-parking::before {
  content: "\\F0D5F"; }

.mdi-car-brake-retarder::before {
  content: "\\F1017"; }

.mdi-car-child-seat::before {
  content: "\\F0FA3"; }

.mdi-car-clutch::before {
  content: "\\F1018"; }

.mdi-car-cog::before {
  content: "\\F13CC"; }

.mdi-car-connected::before {
  content: "\\F010D"; }

.mdi-car-convertible::before {
  content: "\\F07A7"; }

.mdi-car-coolant-level::before {
  content: "\\F1019"; }

.mdi-car-cruise-control::before {
  content: "\\F0D60"; }

.mdi-car-defrost-front::before {
  content: "\\F0D61"; }

.mdi-car-defrost-rear::before {
  content: "\\F0D62"; }

.mdi-car-door::before {
  content: "\\F0B6B"; }

.mdi-car-door-lock::before {
  content: "\\F109D"; }

.mdi-car-electric::before {
  content: "\\F0B6C"; }

.mdi-car-electric-outline::before {
  content: "\\F15B5"; }

.mdi-car-emergency::before {
  content: "\\F160F"; }

.mdi-car-esp::before {
  content: "\\F0C49"; }

.mdi-car-estate::before {
  content: "\\F07A8"; }

.mdi-car-hatchback::before {
  content: "\\F07A9"; }

.mdi-car-info::before {
  content: "\\F11BE"; }

.mdi-car-key::before {
  content: "\\F0B6D"; }

.mdi-car-lifted-pickup::before {
  content: "\\F152D"; }

.mdi-car-light-dimmed::before {
  content: "\\F0C4A"; }

.mdi-car-light-fog::before {
  content: "\\F0C4B"; }

.mdi-car-light-high::before {
  content: "\\F0C4C"; }

.mdi-car-limousine::before {
  content: "\\F08CD"; }

.mdi-car-multiple::before {
  content: "\\F0B6E"; }

.mdi-car-off::before {
  content: "\\F0E1C"; }

.mdi-car-outline::before {
  content: "\\F14ED"; }

.mdi-car-parking-lights::before {
  content: "\\F0D63"; }

.mdi-car-pickup::before {
  content: "\\F07AA"; }

.mdi-car-seat::before {
  content: "\\F0FA4"; }

.mdi-car-seat-cooler::before {
  content: "\\F0FA5"; }

.mdi-car-seat-heater::before {
  content: "\\F0FA6"; }

.mdi-car-settings::before {
  content: "\\F13CD"; }

.mdi-car-shift-pattern::before {
  content: "\\F0F40"; }

.mdi-car-side::before {
  content: "\\F07AB"; }

.mdi-car-sports::before {
  content: "\\F07AC"; }

.mdi-car-tire-alert::before {
  content: "\\F0C4D"; }

.mdi-car-traction-control::before {
  content: "\\F0D64"; }

.mdi-car-turbocharger::before {
  content: "\\F101A"; }

.mdi-car-wash::before {
  content: "\\F010E"; }

.mdi-car-windshield::before {
  content: "\\F101B"; }

.mdi-car-windshield-outline::before {
  content: "\\F101C"; }

.mdi-carabiner::before {
  content: "\\F14C0"; }

.mdi-caravan::before {
  content: "\\F07AD"; }

.mdi-card::before {
  content: "\\F0B6F"; }

.mdi-card-account-details::before {
  content: "\\F05D2"; }

.mdi-card-account-details-outline::before {
  content: "\\F0DAB"; }

.mdi-card-account-details-star::before {
  content: "\\F02A3"; }

.mdi-card-account-details-star-outline::before {
  content: "\\F06DB"; }

.mdi-card-account-mail::before {
  content: "\\F018E"; }

.mdi-card-account-mail-outline::before {
  content: "\\F0E98"; }

.mdi-card-account-phone::before {
  content: "\\F0E99"; }

.mdi-card-account-phone-outline::before {
  content: "\\F0E9A"; }

.mdi-card-bulleted::before {
  content: "\\F0B70"; }

.mdi-card-bulleted-off::before {
  content: "\\F0B71"; }

.mdi-card-bulleted-off-outline::before {
  content: "\\F0B72"; }

.mdi-card-bulleted-outline::before {
  content: "\\F0B73"; }

.mdi-card-bulleted-settings::before {
  content: "\\F0B74"; }

.mdi-card-bulleted-settings-outline::before {
  content: "\\F0B75"; }

.mdi-card-minus::before {
  content: "\\F1600"; }

.mdi-card-minus-outline::before {
  content: "\\F1601"; }

.mdi-card-off::before {
  content: "\\F1602"; }

.mdi-card-off-outline::before {
  content: "\\F1603"; }

.mdi-card-outline::before {
  content: "\\F0B76"; }

.mdi-card-plus::before {
  content: "\\F11FF"; }

.mdi-card-plus-outline::before {
  content: "\\F1200"; }

.mdi-card-remove::before {
  content: "\\F1604"; }

.mdi-card-remove-outline::before {
  content: "\\F1605"; }

.mdi-card-search::before {
  content: "\\F1074"; }

.mdi-card-search-outline::before {
  content: "\\F1075"; }

.mdi-card-text::before {
  content: "\\F0B77"; }

.mdi-card-text-outline::before {
  content: "\\F0B78"; }

.mdi-cards::before {
  content: "\\F0638"; }

.mdi-cards-club::before {
  content: "\\F08CE"; }

.mdi-cards-diamond::before {
  content: "\\F08CF"; }

.mdi-cards-diamond-outline::before {
  content: "\\F101D"; }

.mdi-cards-heart::before {
  content: "\\F08D0"; }

.mdi-cards-outline::before {
  content: "\\F0639"; }

.mdi-cards-playing-outline::before {
  content: "\\F063A"; }

.mdi-cards-spade::before {
  content: "\\F08D1"; }

.mdi-cards-variant::before {
  content: "\\F06C7"; }

.mdi-carrot::before {
  content: "\\F010F"; }

.mdi-cart::before {
  content: "\\F0110"; }

.mdi-cart-arrow-down::before {
  content: "\\F0D66"; }

.mdi-cart-arrow-right::before {
  content: "\\F0C4E"; }

.mdi-cart-arrow-up::before {
  content: "\\F0D67"; }

.mdi-cart-check::before {
  content: "\\F15EA"; }

.mdi-cart-minus::before {
  content: "\\F0D68"; }

.mdi-cart-off::before {
  content: "\\F066B"; }

.mdi-cart-outline::before {
  content: "\\F0111"; }

.mdi-cart-plus::before {
  content: "\\F0112"; }

.mdi-cart-remove::before {
  content: "\\F0D69"; }

.mdi-cart-variant::before {
  content: "\\F15EB"; }

.mdi-case-sensitive-alt::before {
  content: "\\F0113"; }

.mdi-cash::before {
  content: "\\F0114"; }

.mdi-cash-100::before {
  content: "\\F0115"; }

.mdi-cash-check::before {
  content: "\\F14EE"; }

.mdi-cash-lock::before {
  content: "\\F14EA"; }

.mdi-cash-lock-open::before {
  content: "\\F14EB"; }

.mdi-cash-marker::before {
  content: "\\F0DB8"; }

.mdi-cash-minus::before {
  content: "\\F1260"; }

.mdi-cash-multiple::before {
  content: "\\F0116"; }

.mdi-cash-plus::before {
  content: "\\F1261"; }

.mdi-cash-refund::before {
  content: "\\F0A9C"; }

.mdi-cash-register::before {
  content: "\\F0CF4"; }

.mdi-cash-remove::before {
  content: "\\F1262"; }

.mdi-cash-usd::before {
  content: "\\F1176"; }

.mdi-cash-usd-outline::before {
  content: "\\F0117"; }

.mdi-cassette::before {
  content: "\\F09D4"; }

.mdi-cast::before {
  content: "\\F0118"; }

.mdi-cast-audio::before {
  content: "\\F101E"; }

.mdi-cast-connected::before {
  content: "\\F0119"; }

.mdi-cast-education::before {
  content: "\\F0E1D"; }

.mdi-cast-off::before {
  content: "\\F078A"; }

.mdi-castle::before {
  content: "\\F011A"; }

.mdi-cat::before {
  content: "\\F011B"; }

.mdi-cctv::before {
  content: "\\F07AE"; }

.mdi-ceiling-light::before {
  content: "\\F0769"; }

.mdi-cellphone::before {
  content: "\\F011C"; }

.mdi-cellphone-android::before {
  content: "\\F011D"; }

.mdi-cellphone-arrow-down::before {
  content: "\\F09D5"; }

.mdi-cellphone-basic::before {
  content: "\\F011E"; }

.mdi-cellphone-charging::before {
  content: "\\F1397"; }

.mdi-cellphone-cog::before {
  content: "\\F0951"; }

.mdi-cellphone-dock::before {
  content: "\\F011F"; }

.mdi-cellphone-erase::before {
  content: "\\F094D"; }

.mdi-cellphone-information::before {
  content: "\\F0F41"; }

.mdi-cellphone-iphone::before {
  content: "\\F0120"; }

.mdi-cellphone-key::before {
  content: "\\F094E"; }

.mdi-cellphone-link::before {
  content: "\\F0121"; }

.mdi-cellphone-link-off::before {
  content: "\\F0122"; }

.mdi-cellphone-lock::before {
  content: "\\F094F"; }

.mdi-cellphone-message::before {
  content: "\\F08D3"; }

.mdi-cellphone-message-off::before {
  content: "\\F10D2"; }

.mdi-cellphone-nfc::before {
  content: "\\F0E90"; }

.mdi-cellphone-nfc-off::before {
  content: "\\F12D8"; }

.mdi-cellphone-off::before {
  content: "\\F0950"; }

.mdi-cellphone-play::before {
  content: "\\F101F"; }

.mdi-cellphone-screenshot::before {
  content: "\\F0A35"; }

.mdi-cellphone-settings::before {
  content: "\\F0123"; }

.mdi-cellphone-sound::before {
  content: "\\F0952"; }

.mdi-cellphone-text::before {
  content: "\\F08D2"; }

.mdi-cellphone-wireless::before {
  content: "\\F0815"; }

.mdi-celtic-cross::before {
  content: "\\F0CF5"; }

.mdi-centos::before {
  content: "\\F111A"; }

.mdi-certificate::before {
  content: "\\F0124"; }

.mdi-certificate-outline::before {
  content: "\\F1188"; }

.mdi-chair-rolling::before {
  content: "\\F0F48"; }

.mdi-chair-school::before {
  content: "\\F0125"; }

.mdi-charity::before {
  content: "\\F0C4F"; }

.mdi-chart-arc::before {
  content: "\\F0126"; }

.mdi-chart-areaspline::before {
  content: "\\F0127"; }

.mdi-chart-areaspline-variant::before {
  content: "\\F0E91"; }

.mdi-chart-bar::before {
  content: "\\F0128"; }

.mdi-chart-bar-stacked::before {
  content: "\\F076A"; }

.mdi-chart-bell-curve::before {
  content: "\\F0C50"; }

.mdi-chart-bell-curve-cumulative::before {
  content: "\\F0FA7"; }

.mdi-chart-box::before {
  content: "\\F154D"; }

.mdi-chart-box-outline::before {
  content: "\\F154E"; }

.mdi-chart-box-plus-outline::before {
  content: "\\F154F"; }

.mdi-chart-bubble::before {
  content: "\\F05E3"; }

.mdi-chart-donut::before {
  content: "\\F07AF"; }

.mdi-chart-donut-variant::before {
  content: "\\F07B0"; }

.mdi-chart-gantt::before {
  content: "\\F066C"; }

.mdi-chart-histogram::before {
  content: "\\F0129"; }

.mdi-chart-line::before {
  content: "\\F012A"; }

.mdi-chart-line-stacked::before {
  content: "\\F076B"; }

.mdi-chart-line-variant::before {
  content: "\\F07B1"; }

.mdi-chart-multiline::before {
  content: "\\F08D4"; }

.mdi-chart-multiple::before {
  content: "\\F1213"; }

.mdi-chart-pie::before {
  content: "\\F012B"; }

.mdi-chart-ppf::before {
  content: "\\F1380"; }

.mdi-chart-sankey::before {
  content: "\\F11DF"; }

.mdi-chart-sankey-variant::before {
  content: "\\F11E0"; }

.mdi-chart-scatter-plot::before {
  content: "\\F0E92"; }

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\F066D"; }

.mdi-chart-timeline::before {
  content: "\\F066E"; }

.mdi-chart-timeline-variant::before {
  content: "\\F0E93"; }

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\F15B6"; }

.mdi-chart-tree::before {
  content: "\\F0E94"; }

.mdi-chat::before {
  content: "\\F0B79"; }

.mdi-chat-alert::before {
  content: "\\F0B7A"; }

.mdi-chat-alert-outline::before {
  content: "\\F12C9"; }

.mdi-chat-minus::before {
  content: "\\F1410"; }

.mdi-chat-minus-outline::before {
  content: "\\F1413"; }

.mdi-chat-outline::before {
  content: "\\F0EDE"; }

.mdi-chat-plus::before {
  content: "\\F140F"; }

.mdi-chat-plus-outline::before {
  content: "\\F1412"; }

.mdi-chat-processing::before {
  content: "\\F0B7B"; }

.mdi-chat-processing-outline::before {
  content: "\\F12CA"; }

.mdi-chat-question::before {
  content: "\\F1738"; }

.mdi-chat-question-outline::before {
  content: "\\F1739"; }

.mdi-chat-remove::before {
  content: "\\F1411"; }

.mdi-chat-remove-outline::before {
  content: "\\F1414"; }

.mdi-chat-sleep::before {
  content: "\\F12D1"; }

.mdi-chat-sleep-outline::before {
  content: "\\F12D2"; }

.mdi-check::before {
  content: "\\F012C"; }

.mdi-check-all::before {
  content: "\\F012D"; }

.mdi-check-bold::before {
  content: "\\F0E1E"; }

.mdi-check-box-multiple-outline::before {
  content: "\\F0C51"; }

.mdi-check-box-outline::before {
  content: "\\F0C52"; }

.mdi-check-circle::before {
  content: "\\F05E0"; }

.mdi-check-circle-outline::before {
  content: "\\F05E1"; }

.mdi-check-decagram::before {
  content: "\\F0791"; }

.mdi-check-decagram-outline::before {
  content: "\\F1740"; }

.mdi-check-network::before {
  content: "\\F0C53"; }

.mdi-check-network-outline::before {
  content: "\\F0C54"; }

.mdi-check-outline::before {
  content: "\\F0855"; }

.mdi-check-underline::before {
  content: "\\F0E1F"; }

.mdi-check-underline-circle::before {
  content: "\\F0E20"; }

.mdi-check-underline-circle-outline::before {
  content: "\\F0E21"; }

.mdi-checkbook::before {
  content: "\\F0A9D"; }

.mdi-checkbox-blank::before {
  content: "\\F012E"; }

.mdi-checkbox-blank-circle::before {
  content: "\\F012F"; }

.mdi-checkbox-blank-circle-outline::before {
  content: "\\F0130"; }

.mdi-checkbox-blank-off::before {
  content: "\\F12EC"; }

.mdi-checkbox-blank-off-outline::before {
  content: "\\F12ED"; }

.mdi-checkbox-blank-outline::before {
  content: "\\F0131"; }

.mdi-checkbox-intermediate::before {
  content: "\\F0856"; }

.mdi-checkbox-marked::before {
  content: "\\F0132"; }

.mdi-checkbox-marked-circle::before {
  content: "\\F0133"; }

.mdi-checkbox-marked-circle-outline::before {
  content: "\\F0134"; }

.mdi-checkbox-marked-outline::before {
  content: "\\F0135"; }

.mdi-checkbox-multiple-blank::before {
  content: "\\F0136"; }

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\F063B"; }

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\F063C"; }

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\F0137"; }

.mdi-checkbox-multiple-marked::before {
  content: "\\F0138"; }

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\F063D"; }

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\F063E"; }

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\F0139"; }

.mdi-checkerboard::before {
  content: "\\F013A"; }

.mdi-checkerboard-minus::before {
  content: "\\F1202"; }

.mdi-checkerboard-plus::before {
  content: "\\F1201"; }

.mdi-checkerboard-remove::before {
  content: "\\F1203"; }

.mdi-cheese::before {
  content: "\\F12B9"; }

.mdi-cheese-off::before {
  content: "\\F13EE"; }

.mdi-chef-hat::before {
  content: "\\F0B7C"; }

.mdi-chemical-weapon::before {
  content: "\\F013B"; }

.mdi-chess-bishop::before {
  content: "\\F085C"; }

.mdi-chess-king::before {
  content: "\\F0857"; }

.mdi-chess-knight::before {
  content: "\\F0858"; }

.mdi-chess-pawn::before {
  content: "\\F0859"; }

.mdi-chess-queen::before {
  content: "\\F085A"; }

.mdi-chess-rook::before {
  content: "\\F085B"; }

.mdi-chevron-double-down::before {
  content: "\\F013C"; }

.mdi-chevron-double-left::before {
  content: "\\F013D"; }

.mdi-chevron-double-right::before {
  content: "\\F013E"; }

.mdi-chevron-double-up::before {
  content: "\\F013F"; }

.mdi-chevron-down::before {
  content: "\\F0140"; }

.mdi-chevron-down-box::before {
  content: "\\F09D6"; }

.mdi-chevron-down-box-outline::before {
  content: "\\F09D7"; }

.mdi-chevron-down-circle::before {
  content: "\\F0B26"; }

.mdi-chevron-down-circle-outline::before {
  content: "\\F0B27"; }

.mdi-chevron-left::before {
  content: "\\F0141"; }

.mdi-chevron-left-box::before {
  content: "\\F09D8"; }

.mdi-chevron-left-box-outline::before {
  content: "\\F09D9"; }

.mdi-chevron-left-circle::before {
  content: "\\F0B28"; }

.mdi-chevron-left-circle-outline::before {
  content: "\\F0B29"; }

.mdi-chevron-right::before {
  content: "\\F0142"; }

.mdi-chevron-right-box::before {
  content: "\\F09DA"; }

.mdi-chevron-right-box-outline::before {
  content: "\\F09DB"; }

.mdi-chevron-right-circle::before {
  content: "\\F0B2A"; }

.mdi-chevron-right-circle-outline::before {
  content: "\\F0B2B"; }

.mdi-chevron-triple-down::before {
  content: "\\F0DB9"; }

.mdi-chevron-triple-left::before {
  content: "\\F0DBA"; }

.mdi-chevron-triple-right::before {
  content: "\\F0DBB"; }

.mdi-chevron-triple-up::before {
  content: "\\F0DBC"; }

.mdi-chevron-up::before {
  content: "\\F0143"; }

.mdi-chevron-up-box::before {
  content: "\\F09DC"; }

.mdi-chevron-up-box-outline::before {
  content: "\\F09DD"; }

.mdi-chevron-up-circle::before {
  content: "\\F0B2C"; }

.mdi-chevron-up-circle-outline::before {
  content: "\\F0B2D"; }

.mdi-chili-hot::before {
  content: "\\F07B2"; }

.mdi-chili-medium::before {
  content: "\\F07B3"; }

.mdi-chili-mild::before {
  content: "\\F07B4"; }

.mdi-chili-off::before {
  content: "\\F1467"; }

.mdi-chip::before {
  content: "\\F061A"; }

.mdi-christianity::before {
  content: "\\F0953"; }

.mdi-christianity-outline::before {
  content: "\\F0CF6"; }

.mdi-church::before {
  content: "\\F0144"; }

.mdi-cigar::before {
  content: "\\F1189"; }

.mdi-cigar-off::before {
  content: "\\F141B"; }

.mdi-circle::before {
  content: "\\F0765"; }

.mdi-circle-box::before {
  content: "\\F15DC"; }

.mdi-circle-box-outline::before {
  content: "\\F15DD"; }

.mdi-circle-double::before {
  content: "\\F0E95"; }

.mdi-circle-edit-outline::before {
  content: "\\F08D5"; }

.mdi-circle-expand::before {
  content: "\\F0E96"; }

.mdi-circle-half::before {
  content: "\\F1395"; }

.mdi-circle-half-full::before {
  content: "\\F1396"; }

.mdi-circle-medium::before {
  content: "\\F09DE"; }

.mdi-circle-multiple::before {
  content: "\\F0B38"; }

.mdi-circle-multiple-outline::before {
  content: "\\F0695"; }

.mdi-circle-off-outline::before {
  content: "\\F10D3"; }

.mdi-circle-outline::before {
  content: "\\F0766"; }

.mdi-circle-slice-1::before {
  content: "\\F0A9E"; }

.mdi-circle-slice-2::before {
  content: "\\F0A9F"; }

.mdi-circle-slice-3::before {
  content: "\\F0AA0"; }

.mdi-circle-slice-4::before {
  content: "\\F0AA1"; }

.mdi-circle-slice-5::before {
  content: "\\F0AA2"; }

.mdi-circle-slice-6::before {
  content: "\\F0AA3"; }

.mdi-circle-slice-7::before {
  content: "\\F0AA4"; }

.mdi-circle-slice-8::before {
  content: "\\F0AA5"; }

.mdi-circle-small::before {
  content: "\\F09DF"; }

.mdi-circular-saw::before {
  content: "\\F0E22"; }

.mdi-city::before {
  content: "\\F0146"; }

.mdi-city-variant::before {
  content: "\\F0A36"; }

.mdi-city-variant-outline::before {
  content: "\\F0A37"; }

.mdi-clipboard::before {
  content: "\\F0147"; }

.mdi-clipboard-account::before {
  content: "\\F0148"; }

.mdi-clipboard-account-outline::before {
  content: "\\F0C55"; }

.mdi-clipboard-alert::before {
  content: "\\F0149"; }

.mdi-clipboard-alert-outline::before {
  content: "\\F0CF7"; }

.mdi-clipboard-arrow-down::before {
  content: "\\F014A"; }

.mdi-clipboard-arrow-down-outline::before {
  content: "\\F0C56"; }

.mdi-clipboard-arrow-left::before {
  content: "\\F014B"; }

.mdi-clipboard-arrow-left-outline::before {
  content: "\\F0CF8"; }

.mdi-clipboard-arrow-right::before {
  content: "\\F0CF9"; }

.mdi-clipboard-arrow-right-outline::before {
  content: "\\F0CFA"; }

.mdi-clipboard-arrow-up::before {
  content: "\\F0C57"; }

.mdi-clipboard-arrow-up-outline::before {
  content: "\\F0C58"; }

.mdi-clipboard-check::before {
  content: "\\F014E"; }

.mdi-clipboard-check-multiple::before {
  content: "\\F1263"; }

.mdi-clipboard-check-multiple-outline::before {
  content: "\\F1264"; }

.mdi-clipboard-check-outline::before {
  content: "\\F08A8"; }

.mdi-clipboard-clock::before {
  content: "\\F16E2"; }

.mdi-clipboard-clock-outline::before {
  content: "\\F16E3"; }

.mdi-clipboard-edit::before {
  content: "\\F14E5"; }

.mdi-clipboard-edit-outline::before {
  content: "\\F14E6"; }

.mdi-clipboard-file::before {
  content: "\\F1265"; }

.mdi-clipboard-file-outline::before {
  content: "\\F1266"; }

.mdi-clipboard-flow::before {
  content: "\\F06C8"; }

.mdi-clipboard-flow-outline::before {
  content: "\\F1117"; }

.mdi-clipboard-list::before {
  content: "\\F10D4"; }

.mdi-clipboard-list-outline::before {
  content: "\\F10D5"; }

.mdi-clipboard-minus::before {
  content: "\\F1618"; }

.mdi-clipboard-minus-outline::before {
  content: "\\F1619"; }

.mdi-clipboard-multiple::before {
  content: "\\F1267"; }

.mdi-clipboard-multiple-outline::before {
  content: "\\F1268"; }

.mdi-clipboard-off::before {
  content: "\\F161A"; }

.mdi-clipboard-off-outline::before {
  content: "\\F161B"; }

.mdi-clipboard-outline::before {
  content: "\\F014C"; }

.mdi-clipboard-play::before {
  content: "\\F0C59"; }

.mdi-clipboard-play-multiple::before {
  content: "\\F1269"; }

.mdi-clipboard-play-multiple-outline::before {
  content: "\\F126A"; }

.mdi-clipboard-play-outline::before {
  content: "\\F0C5A"; }

.mdi-clipboard-plus::before {
  content: "\\F0751"; }

.mdi-clipboard-plus-outline::before {
  content: "\\F131F"; }

.mdi-clipboard-pulse::before {
  content: "\\F085D"; }

.mdi-clipboard-pulse-outline::before {
  content: "\\F085E"; }

.mdi-clipboard-remove::before {
  content: "\\F161C"; }

.mdi-clipboard-remove-outline::before {
  content: "\\F161D"; }

.mdi-clipboard-search::before {
  content: "\\F161E"; }

.mdi-clipboard-search-outline::before {
  content: "\\F161F"; }

.mdi-clipboard-text::before {
  content: "\\F014D"; }

.mdi-clipboard-text-multiple::before {
  content: "\\F126B"; }

.mdi-clipboard-text-multiple-outline::before {
  content: "\\F126C"; }

.mdi-clipboard-text-off::before {
  content: "\\F1620"; }

.mdi-clipboard-text-off-outline::before {
  content: "\\F1621"; }

.mdi-clipboard-text-outline::before {
  content: "\\F0A38"; }

.mdi-clipboard-text-play::before {
  content: "\\F0C5B"; }

.mdi-clipboard-text-play-outline::before {
  content: "\\F0C5C"; }

.mdi-clipboard-text-search::before {
  content: "\\F1622"; }

.mdi-clipboard-text-search-outline::before {
  content: "\\F1623"; }

.mdi-clippy::before {
  content: "\\F014F"; }

.mdi-clock::before {
  content: "\\F0954"; }

.mdi-clock-alert::before {
  content: "\\F0955"; }

.mdi-clock-alert-outline::before {
  content: "\\F05CE"; }

.mdi-clock-check::before {
  content: "\\F0FA8"; }

.mdi-clock-check-outline::before {
  content: "\\F0FA9"; }

.mdi-clock-digital::before {
  content: "\\F0E97"; }

.mdi-clock-end::before {
  content: "\\F0151"; }

.mdi-clock-fast::before {
  content: "\\F0152"; }

.mdi-clock-in::before {
  content: "\\F0153"; }

.mdi-clock-out::before {
  content: "\\F0154"; }

.mdi-clock-outline::before {
  content: "\\F0150"; }

.mdi-clock-start::before {
  content: "\\F0155"; }

.mdi-clock-time-eight::before {
  content: "\\F1446"; }

.mdi-clock-time-eight-outline::before {
  content: "\\F1452"; }

.mdi-clock-time-eleven::before {
  content: "\\F1449"; }

.mdi-clock-time-eleven-outline::before {
  content: "\\F1455"; }

.mdi-clock-time-five::before {
  content: "\\F1443"; }

.mdi-clock-time-five-outline::before {
  content: "\\F144F"; }

.mdi-clock-time-four::before {
  content: "\\F1442"; }

.mdi-clock-time-four-outline::before {
  content: "\\F144E"; }

.mdi-clock-time-nine::before {
  content: "\\F1447"; }

.mdi-clock-time-nine-outline::before {
  content: "\\F1453"; }

.mdi-clock-time-one::before {
  content: "\\F143F"; }

.mdi-clock-time-one-outline::before {
  content: "\\F144B"; }

.mdi-clock-time-seven::before {
  content: "\\F1445"; }

.mdi-clock-time-seven-outline::before {
  content: "\\F1451"; }

.mdi-clock-time-six::before {
  content: "\\F1444"; }

.mdi-clock-time-six-outline::before {
  content: "\\F1450"; }

.mdi-clock-time-ten::before {
  content: "\\F1448"; }

.mdi-clock-time-ten-outline::before {
  content: "\\F1454"; }

.mdi-clock-time-three::before {
  content: "\\F1441"; }

.mdi-clock-time-three-outline::before {
  content: "\\F144D"; }

.mdi-clock-time-twelve::before {
  content: "\\F144A"; }

.mdi-clock-time-twelve-outline::before {
  content: "\\F1456"; }

.mdi-clock-time-two::before {
  content: "\\F1440"; }

.mdi-clock-time-two-outline::before {
  content: "\\F144C"; }

.mdi-close::before {
  content: "\\F0156"; }

.mdi-close-box::before {
  content: "\\F0157"; }

.mdi-close-box-multiple::before {
  content: "\\F0C5D"; }

.mdi-close-box-multiple-outline::before {
  content: "\\F0C5E"; }

.mdi-close-box-outline::before {
  content: "\\F0158"; }

.mdi-close-circle::before {
  content: "\\F0159"; }

.mdi-close-circle-multiple::before {
  content: "\\F062A"; }

.mdi-close-circle-multiple-outline::before {
  content: "\\F0883"; }

.mdi-close-circle-outline::before {
  content: "\\F015A"; }

.mdi-close-network::before {
  content: "\\F015B"; }

.mdi-close-network-outline::before {
  content: "\\F0C5F"; }

.mdi-close-octagon::before {
  content: "\\F015C"; }

.mdi-close-octagon-outline::before {
  content: "\\F015D"; }

.mdi-close-outline::before {
  content: "\\F06C9"; }

.mdi-close-thick::before {
  content: "\\F1398"; }

.mdi-closed-caption::before {
  content: "\\F015E"; }

.mdi-closed-caption-outline::before {
  content: "\\F0DBD"; }

.mdi-cloud::before {
  content: "\\F015F"; }

.mdi-cloud-alert::before {
  content: "\\F09E0"; }

.mdi-cloud-braces::before {
  content: "\\F07B5"; }

.mdi-cloud-check::before {
  content: "\\F0160"; }

.mdi-cloud-check-outline::before {
  content: "\\F12CC"; }

.mdi-cloud-circle::before {
  content: "\\F0161"; }

.mdi-cloud-download::before {
  content: "\\F0162"; }

.mdi-cloud-download-outline::before {
  content: "\\F0B7D"; }

.mdi-cloud-lock::before {
  content: "\\F11F1"; }

.mdi-cloud-lock-outline::before {
  content: "\\F11F2"; }

.mdi-cloud-off-outline::before {
  content: "\\F0164"; }

.mdi-cloud-outline::before {
  content: "\\F0163"; }

.mdi-cloud-print::before {
  content: "\\F0165"; }

.mdi-cloud-print-outline::before {
  content: "\\F0166"; }

.mdi-cloud-question::before {
  content: "\\F0A39"; }

.mdi-cloud-refresh::before {
  content: "\\F052A"; }

.mdi-cloud-search::before {
  content: "\\F0956"; }

.mdi-cloud-search-outline::before {
  content: "\\F0957"; }

.mdi-cloud-sync::before {
  content: "\\F063F"; }

.mdi-cloud-sync-outline::before {
  content: "\\F12D6"; }

.mdi-cloud-tags::before {
  content: "\\F07B6"; }

.mdi-cloud-upload::before {
  content: "\\F0167"; }

.mdi-cloud-upload-outline::before {
  content: "\\F0B7E"; }

.mdi-clover::before {
  content: "\\F0816"; }

.mdi-coach-lamp::before {
  content: "\\F1020"; }

.mdi-coat-rack::before {
  content: "\\F109E"; }

.mdi-code-array::before {
  content: "\\F0168"; }

.mdi-code-braces::before {
  content: "\\F0169"; }

.mdi-code-braces-box::before {
  content: "\\F10D6"; }

.mdi-code-brackets::before {
  content: "\\F016A"; }

.mdi-code-equal::before {
  content: "\\F016B"; }

.mdi-code-greater-than::before {
  content: "\\F016C"; }

.mdi-code-greater-than-or-equal::before {
  content: "\\F016D"; }

.mdi-code-json::before {
  content: "\\F0626"; }

.mdi-code-less-than::before {
  content: "\\F016E"; }

.mdi-code-less-than-or-equal::before {
  content: "\\F016F"; }

.mdi-code-not-equal::before {
  content: "\\F0170"; }

.mdi-code-not-equal-variant::before {
  content: "\\F0171"; }

.mdi-code-parentheses::before {
  content: "\\F0172"; }

.mdi-code-parentheses-box::before {
  content: "\\F10D7"; }

.mdi-code-string::before {
  content: "\\F0173"; }

.mdi-code-tags::before {
  content: "\\F0174"; }

.mdi-code-tags-check::before {
  content: "\\F0694"; }

.mdi-codepen::before {
  content: "\\F0175"; }

.mdi-coffee::before {
  content: "\\F0176"; }

.mdi-coffee-maker::before {
  content: "\\F109F"; }

.mdi-coffee-off::before {
  content: "\\F0FAA"; }

.mdi-coffee-off-outline::before {
  content: "\\F0FAB"; }

.mdi-coffee-outline::before {
  content: "\\F06CA"; }

.mdi-coffee-to-go::before {
  content: "\\F0177"; }

.mdi-coffee-to-go-outline::before {
  content: "\\F130E"; }

.mdi-coffin::before {
  content: "\\F0B7F"; }

.mdi-cog::before {
  content: "\\F0493"; }

.mdi-cog-box::before {
  content: "\\F0494"; }

.mdi-cog-clockwise::before {
  content: "\\F11DD"; }

.mdi-cog-counterclockwise::before {
  content: "\\F11DE"; }

.mdi-cog-off::before {
  content: "\\F13CE"; }

.mdi-cog-off-outline::before {
  content: "\\F13CF"; }

.mdi-cog-outline::before {
  content: "\\F08BB"; }

.mdi-cog-refresh::before {
  content: "\\F145E"; }

.mdi-cog-refresh-outline::before {
  content: "\\F145F"; }

.mdi-cog-sync::before {
  content: "\\F1460"; }

.mdi-cog-sync-outline::before {
  content: "\\F1461"; }

.mdi-cog-transfer::before {
  content: "\\F105B"; }

.mdi-cog-transfer-outline::before {
  content: "\\F105C"; }

.mdi-cogs::before {
  content: "\\F08D6"; }

.mdi-collage::before {
  content: "\\F0640"; }

.mdi-collapse-all::before {
  content: "\\F0AA6"; }

.mdi-collapse-all-outline::before {
  content: "\\F0AA7"; }

.mdi-color-helper::before {
  content: "\\F0179"; }

.mdi-comma::before {
  content: "\\F0E23"; }

.mdi-comma-box::before {
  content: "\\F0E2B"; }

.mdi-comma-box-outline::before {
  content: "\\F0E24"; }

.mdi-comma-circle::before {
  content: "\\F0E25"; }

.mdi-comma-circle-outline::before {
  content: "\\F0E26"; }

.mdi-comment::before {
  content: "\\F017A"; }

.mdi-comment-account::before {
  content: "\\F017B"; }

.mdi-comment-account-outline::before {
  content: "\\F017C"; }

.mdi-comment-alert::before {
  content: "\\F017D"; }

.mdi-comment-alert-outline::before {
  content: "\\F017E"; }

.mdi-comment-arrow-left::before {
  content: "\\F09E1"; }

.mdi-comment-arrow-left-outline::before {
  content: "\\F09E2"; }

.mdi-comment-arrow-right::before {
  content: "\\F09E3"; }

.mdi-comment-arrow-right-outline::before {
  content: "\\F09E4"; }

.mdi-comment-bookmark::before {
  content: "\\F15AE"; }

.mdi-comment-bookmark-outline::before {
  content: "\\F15AF"; }

.mdi-comment-check::before {
  content: "\\F017F"; }

.mdi-comment-check-outline::before {
  content: "\\F0180"; }

.mdi-comment-edit::before {
  content: "\\F11BF"; }

.mdi-comment-edit-outline::before {
  content: "\\F12C4"; }

.mdi-comment-eye::before {
  content: "\\F0A3A"; }

.mdi-comment-eye-outline::before {
  content: "\\F0A3B"; }

.mdi-comment-flash::before {
  content: "\\F15B0"; }

.mdi-comment-flash-outline::before {
  content: "\\F15B1"; }

.mdi-comment-minus::before {
  content: "\\F15DF"; }

.mdi-comment-minus-outline::before {
  content: "\\F15E0"; }

.mdi-comment-multiple::before {
  content: "\\F085F"; }

.mdi-comment-multiple-outline::before {
  content: "\\F0181"; }

.mdi-comment-off::before {
  content: "\\F15E1"; }

.mdi-comment-off-outline::before {
  content: "\\F15E2"; }

.mdi-comment-outline::before {
  content: "\\F0182"; }

.mdi-comment-plus::before {
  content: "\\F09E5"; }

.mdi-comment-plus-outline::before {
  content: "\\F0183"; }

.mdi-comment-processing::before {
  content: "\\F0184"; }

.mdi-comment-processing-outline::before {
  content: "\\F0185"; }

.mdi-comment-question::before {
  content: "\\F0817"; }

.mdi-comment-question-outline::before {
  content: "\\F0186"; }

.mdi-comment-quote::before {
  content: "\\F1021"; }

.mdi-comment-quote-outline::before {
  content: "\\F1022"; }

.mdi-comment-remove::before {
  content: "\\F05DE"; }

.mdi-comment-remove-outline::before {
  content: "\\F0187"; }

.mdi-comment-search::before {
  content: "\\F0A3C"; }

.mdi-comment-search-outline::before {
  content: "\\F0A3D"; }

.mdi-comment-text::before {
  content: "\\F0188"; }

.mdi-comment-text-multiple::before {
  content: "\\F0860"; }

.mdi-comment-text-multiple-outline::before {
  content: "\\F0861"; }

.mdi-comment-text-outline::before {
  content: "\\F0189"; }

.mdi-compare::before {
  content: "\\F018A"; }

.mdi-compare-horizontal::before {
  content: "\\F1492"; }

.mdi-compare-vertical::before {
  content: "\\F1493"; }

.mdi-compass::before {
  content: "\\F018B"; }

.mdi-compass-off::before {
  content: "\\F0B80"; }

.mdi-compass-off-outline::before {
  content: "\\F0B81"; }

.mdi-compass-outline::before {
  content: "\\F018C"; }

.mdi-compass-rose::before {
  content: "\\F1382"; }

.mdi-concourse-ci::before {
  content: "\\F10A0"; }

.mdi-connection::before {
  content: "\\F1616"; }

.mdi-console::before {
  content: "\\F018D"; }

.mdi-console-line::before {
  content: "\\F07B7"; }

.mdi-console-network::before {
  content: "\\F08A9"; }

.mdi-console-network-outline::before {
  content: "\\F0C60"; }

.mdi-consolidate::before {
  content: "\\F10D8"; }

.mdi-contactless-payment::before {
  content: "\\F0D6A"; }

.mdi-contactless-payment-circle::before {
  content: "\\F0321"; }

.mdi-contactless-payment-circle-outline::before {
  content: "\\F0408"; }

.mdi-contacts::before {
  content: "\\F06CB"; }

.mdi-contacts-outline::before {
  content: "\\F05B8"; }

.mdi-contain::before {
  content: "\\F0A3E"; }

.mdi-contain-end::before {
  content: "\\F0A3F"; }

.mdi-contain-start::before {
  content: "\\F0A40"; }

.mdi-content-copy::before {
  content: "\\F018F"; }

.mdi-content-cut::before {
  content: "\\F0190"; }

.mdi-content-duplicate::before {
  content: "\\F0191"; }

.mdi-content-paste::before {
  content: "\\F0192"; }

.mdi-content-save::before {
  content: "\\F0193"; }

.mdi-content-save-alert::before {
  content: "\\F0F42"; }

.mdi-content-save-alert-outline::before {
  content: "\\F0F43"; }

.mdi-content-save-all::before {
  content: "\\F0194"; }

.mdi-content-save-all-outline::before {
  content: "\\F0F44"; }

.mdi-content-save-cog::before {
  content: "\\F145B"; }

.mdi-content-save-cog-outline::before {
  content: "\\F145C"; }

.mdi-content-save-edit::before {
  content: "\\F0CFB"; }

.mdi-content-save-edit-outline::before {
  content: "\\F0CFC"; }

.mdi-content-save-move::before {
  content: "\\F0E27"; }

.mdi-content-save-move-outline::before {
  content: "\\F0E28"; }

.mdi-content-save-off::before {
  content: "\\F1643"; }

.mdi-content-save-off-outline::before {
  content: "\\F1644"; }

.mdi-content-save-outline::before {
  content: "\\F0818"; }

.mdi-content-save-settings::before {
  content: "\\F061B"; }

.mdi-content-save-settings-outline::before {
  content: "\\F0B2E"; }

.mdi-contrast::before {
  content: "\\F0195"; }

.mdi-contrast-box::before {
  content: "\\F0196"; }

.mdi-contrast-circle::before {
  content: "\\F0197"; }

.mdi-controller-classic::before {
  content: "\\F0B82"; }

.mdi-controller-classic-outline::before {
  content: "\\F0B83"; }

.mdi-cookie::before {
  content: "\\F0198"; }

.mdi-cookie-alert::before {
  content: "\\F16D0"; }

.mdi-cookie-alert-outline::before {
  content: "\\F16D1"; }

.mdi-cookie-check::before {
  content: "\\F16D2"; }

.mdi-cookie-check-outline::before {
  content: "\\F16D3"; }

.mdi-cookie-clock::before {
  content: "\\F16E4"; }

.mdi-cookie-clock-outline::before {
  content: "\\F16E5"; }

.mdi-cookie-cog::before {
  content: "\\F16D4"; }

.mdi-cookie-cog-outline::before {
  content: "\\F16D5"; }

.mdi-cookie-edit::before {
  content: "\\F16E6"; }

.mdi-cookie-edit-outline::before {
  content: "\\F16E7"; }

.mdi-cookie-lock::before {
  content: "\\F16E8"; }

.mdi-cookie-lock-outline::before {
  content: "\\F16E9"; }

.mdi-cookie-minus::before {
  content: "\\F16DA"; }

.mdi-cookie-minus-outline::before {
  content: "\\F16DB"; }

.mdi-cookie-off::before {
  content: "\\F16EA"; }

.mdi-cookie-off-outline::before {
  content: "\\F16EB"; }

.mdi-cookie-outline::before {
  content: "\\F16DE"; }

.mdi-cookie-plus::before {
  content: "\\F16D6"; }

.mdi-cookie-plus-outline::before {
  content: "\\F16D7"; }

.mdi-cookie-refresh::before {
  content: "\\F16EC"; }

.mdi-cookie-refresh-outline::before {
  content: "\\F16ED"; }

.mdi-cookie-remove::before {
  content: "\\F16D8"; }

.mdi-cookie-remove-outline::before {
  content: "\\F16D9"; }

.mdi-cookie-settings::before {
  content: "\\F16DC"; }

.mdi-cookie-settings-outline::before {
  content: "\\F16DD"; }

.mdi-coolant-temperature::before {
  content: "\\F03C8"; }

.mdi-copyright::before {
  content: "\\F05E6"; }

.mdi-cordova::before {
  content: "\\F0958"; }

.mdi-corn::before {
  content: "\\F07B8"; }

.mdi-corn-off::before {
  content: "\\F13EF"; }

.mdi-cosine-wave::before {
  content: "\\F1479"; }

.mdi-counter::before {
  content: "\\F0199"; }

.mdi-cow::before {
  content: "\\F019A"; }

.mdi-cpu-32-bit::before {
  content: "\\F0EDF"; }

.mdi-cpu-64-bit::before {
  content: "\\F0EE0"; }

.mdi-crane::before {
  content: "\\F0862"; }

.mdi-creation::before {
  content: "\\F0674"; }

.mdi-creative-commons::before {
  content: "\\F0D6B"; }

.mdi-credit-card::before {
  content: "\\F0FEF"; }

.mdi-credit-card-check::before {
  content: "\\F13D0"; }

.mdi-credit-card-check-outline::before {
  content: "\\F13D1"; }

.mdi-credit-card-clock::before {
  content: "\\F0EE1"; }

.mdi-credit-card-clock-outline::before {
  content: "\\F0EE2"; }

.mdi-credit-card-marker::before {
  content: "\\F06A8"; }

.mdi-credit-card-marker-outline::before {
  content: "\\F0DBE"; }

.mdi-credit-card-minus::before {
  content: "\\F0FAC"; }

.mdi-credit-card-minus-outline::before {
  content: "\\F0FAD"; }

.mdi-credit-card-multiple::before {
  content: "\\F0FF0"; }

.mdi-credit-card-multiple-outline::before {
  content: "\\F019C"; }

.mdi-credit-card-off::before {
  content: "\\F0FF1"; }

.mdi-credit-card-off-outline::before {
  content: "\\F05E4"; }

.mdi-credit-card-outline::before {
  content: "\\F019B"; }

.mdi-credit-card-plus::before {
  content: "\\F0FF2"; }

.mdi-credit-card-plus-outline::before {
  content: "\\F0676"; }

.mdi-credit-card-refresh::before {
  content: "\\F1645"; }

.mdi-credit-card-refresh-outline::before {
  content: "\\F1646"; }

.mdi-credit-card-refund::before {
  content: "\\F0FF3"; }

.mdi-credit-card-refund-outline::before {
  content: "\\F0AA8"; }

.mdi-credit-card-remove::before {
  content: "\\F0FAE"; }

.mdi-credit-card-remove-outline::before {
  content: "\\F0FAF"; }

.mdi-credit-card-scan::before {
  content: "\\F0FF4"; }

.mdi-credit-card-scan-outline::before {
  content: "\\F019D"; }

.mdi-credit-card-search::before {
  content: "\\F1647"; }

.mdi-credit-card-search-outline::before {
  content: "\\F1648"; }

.mdi-credit-card-settings::before {
  content: "\\F0FF5"; }

.mdi-credit-card-settings-outline::before {
  content: "\\F08D7"; }

.mdi-credit-card-sync::before {
  content: "\\F1649"; }

.mdi-credit-card-sync-outline::before {
  content: "\\F164A"; }

.mdi-credit-card-wireless::before {
  content: "\\F0802"; }

.mdi-credit-card-wireless-off::before {
  content: "\\F057A"; }

.mdi-credit-card-wireless-off-outline::before {
  content: "\\F057B"; }

.mdi-credit-card-wireless-outline::before {
  content: "\\F0D6C"; }

.mdi-cricket::before {
  content: "\\F0D6D"; }

.mdi-crop::before {
  content: "\\F019E"; }

.mdi-crop-free::before {
  content: "\\F019F"; }

.mdi-crop-landscape::before {
  content: "\\F01A0"; }

.mdi-crop-portrait::before {
  content: "\\F01A1"; }

.mdi-crop-rotate::before {
  content: "\\F0696"; }

.mdi-crop-square::before {
  content: "\\F01A2"; }

.mdi-crosshairs::before {
  content: "\\F01A3"; }

.mdi-crosshairs-gps::before {
  content: "\\F01A4"; }

.mdi-crosshairs-off::before {
  content: "\\F0F45"; }

.mdi-crosshairs-question::before {
  content: "\\F1136"; }

.mdi-crown::before {
  content: "\\F01A5"; }

.mdi-crown-outline::before {
  content: "\\F11D0"; }

.mdi-cryengine::before {
  content: "\\F0959"; }

.mdi-crystal-ball::before {
  content: "\\F0B2F"; }

.mdi-cube::before {
  content: "\\F01A6"; }

.mdi-cube-off::before {
  content: "\\F141C"; }

.mdi-cube-off-outline::before {
  content: "\\F141D"; }

.mdi-cube-outline::before {
  content: "\\F01A7"; }

.mdi-cube-scan::before {
  content: "\\F0B84"; }

.mdi-cube-send::before {
  content: "\\F01A8"; }

.mdi-cube-unfolded::before {
  content: "\\F01A9"; }

.mdi-cup::before {
  content: "\\F01AA"; }

.mdi-cup-off::before {
  content: "\\F05E5"; }

.mdi-cup-off-outline::before {
  content: "\\F137D"; }

.mdi-cup-outline::before {
  content: "\\F130F"; }

.mdi-cup-water::before {
  content: "\\F01AB"; }

.mdi-cupboard::before {
  content: "\\F0F46"; }

.mdi-cupboard-outline::before {
  content: "\\F0F47"; }

.mdi-cupcake::before {
  content: "\\F095A"; }

.mdi-curling::before {
  content: "\\F0863"; }

.mdi-currency-bdt::before {
  content: "\\F0864"; }

.mdi-currency-brl::before {
  content: "\\F0B85"; }

.mdi-currency-btc::before {
  content: "\\F01AC"; }

.mdi-currency-cny::before {
  content: "\\F07BA"; }

.mdi-currency-eth::before {
  content: "\\F07BB"; }

.mdi-currency-eur::before {
  content: "\\F01AD"; }

.mdi-currency-eur-off::before {
  content: "\\F1315"; }

.mdi-currency-gbp::before {
  content: "\\F01AE"; }

.mdi-currency-ils::before {
  content: "\\F0C61"; }

.mdi-currency-inr::before {
  content: "\\F01AF"; }

.mdi-currency-jpy::before {
  content: "\\F07BC"; }

.mdi-currency-krw::before {
  content: "\\F07BD"; }

.mdi-currency-kzt::before {
  content: "\\F0865"; }

.mdi-currency-mnt::before {
  content: "\\F1512"; }

.mdi-currency-ngn::before {
  content: "\\F01B0"; }

.mdi-currency-php::before {
  content: "\\F09E6"; }

.mdi-currency-rial::before {
  content: "\\F0E9C"; }

.mdi-currency-rub::before {
  content: "\\F01B1"; }

.mdi-currency-sign::before {
  content: "\\F07BE"; }

.mdi-currency-try::before {
  content: "\\F01B2"; }

.mdi-currency-twd::before {
  content: "\\F07BF"; }

.mdi-currency-usd::before {
  content: "\\F01C1"; }

.mdi-currency-usd-circle::before {
  content: "\\F116B"; }

.mdi-currency-usd-circle-outline::before {
  content: "\\F0178"; }

.mdi-currency-usd-off::before {
  content: "\\F067A"; }

.mdi-current-ac::before {
  content: "\\F1480"; }

.mdi-current-dc::before {
  content: "\\F095C"; }

.mdi-cursor-default::before {
  content: "\\F01C0"; }

.mdi-cursor-default-click::before {
  content: "\\F0CFD"; }

.mdi-cursor-default-click-outline::before {
  content: "\\F0CFE"; }

.mdi-cursor-default-gesture::before {
  content: "\\F1127"; }

.mdi-cursor-default-gesture-outline::before {
  content: "\\F1128"; }

.mdi-cursor-default-outline::before {
  content: "\\F01BF"; }

.mdi-cursor-move::before {
  content: "\\F01BE"; }

.mdi-cursor-pointer::before {
  content: "\\F01BD"; }

.mdi-cursor-text::before {
  content: "\\F05E7"; }

.mdi-dance-ballroom::before {
  content: "\\F15FB"; }

.mdi-dance-pole::before {
  content: "\\F1578"; }

.mdi-data-matrix::before {
  content: "\\F153C"; }

.mdi-data-matrix-edit::before {
  content: "\\F153D"; }

.mdi-data-matrix-minus::before {
  content: "\\F153E"; }

.mdi-data-matrix-plus::before {
  content: "\\F153F"; }

.mdi-data-matrix-remove::before {
  content: "\\F1540"; }

.mdi-data-matrix-scan::before {
  content: "\\F1541"; }

.mdi-database::before {
  content: "\\F01BC"; }

.mdi-database-alert::before {
  content: "\\F163A"; }

.mdi-database-alert-outline::before {
  content: "\\F1624"; }

.mdi-database-arrow-down::before {
  content: "\\F163B"; }

.mdi-database-arrow-down-outline::before {
  content: "\\F1625"; }

.mdi-database-arrow-left::before {
  content: "\\F163C"; }

.mdi-database-arrow-left-outline::before {
  content: "\\F1626"; }

.mdi-database-arrow-right::before {
  content: "\\F163D"; }

.mdi-database-arrow-right-outline::before {
  content: "\\F1627"; }

.mdi-database-arrow-up::before {
  content: "\\F163E"; }

.mdi-database-arrow-up-outline::before {
  content: "\\F1628"; }

.mdi-database-check::before {
  content: "\\F0AA9"; }

.mdi-database-check-outline::before {
  content: "\\F1629"; }

.mdi-database-clock::before {
  content: "\\F163F"; }

.mdi-database-clock-outline::before {
  content: "\\F162A"; }

.mdi-database-cog::before {
  content: "\\F164B"; }

.mdi-database-cog-outline::before {
  content: "\\F164C"; }

.mdi-database-edit::before {
  content: "\\F0B86"; }

.mdi-database-edit-outline::before {
  content: "\\F162B"; }

.mdi-database-export::before {
  content: "\\F095E"; }

.mdi-database-export-outline::before {
  content: "\\F162C"; }

.mdi-database-import::before {
  content: "\\F095D"; }

.mdi-database-import-outline::before {
  content: "\\F162D"; }

.mdi-database-lock::before {
  content: "\\F0AAA"; }

.mdi-database-lock-outline::before {
  content: "\\F162E"; }

.mdi-database-marker::before {
  content: "\\F12F6"; }

.mdi-database-marker-outline::before {
  content: "\\F162F"; }

.mdi-database-minus::before {
  content: "\\F01BB"; }

.mdi-database-minus-outline::before {
  content: "\\F1630"; }

.mdi-database-off::before {
  content: "\\F1640"; }

.mdi-database-off-outline::before {
  content: "\\F1631"; }

.mdi-database-outline::before {
  content: "\\F1632"; }

.mdi-database-plus::before {
  content: "\\F01BA"; }

.mdi-database-plus-outline::before {
  content: "\\F1633"; }

.mdi-database-refresh::before {
  content: "\\F05C2"; }

.mdi-database-refresh-outline::before {
  content: "\\F1634"; }

.mdi-database-remove::before {
  content: "\\F0D00"; }

.mdi-database-remove-outline::before {
  content: "\\F1635"; }

.mdi-database-search::before {
  content: "\\F0866"; }

.mdi-database-search-outline::before {
  content: "\\F1636"; }

.mdi-database-settings::before {
  content: "\\F0D01"; }

.mdi-database-settings-outline::before {
  content: "\\F1637"; }

.mdi-database-sync::before {
  content: "\\F0CFF"; }

.mdi-database-sync-outline::before {
  content: "\\F1638"; }

.mdi-death-star::before {
  content: "\\F08D8"; }

.mdi-death-star-variant::before {
  content: "\\F08D9"; }

.mdi-deathly-hallows::before {
  content: "\\F0B87"; }

.mdi-debian::before {
  content: "\\F08DA"; }

.mdi-debug-step-into::before {
  content: "\\F01B9"; }

.mdi-debug-step-out::before {
  content: "\\F01B8"; }

.mdi-debug-step-over::before {
  content: "\\F01B7"; }

.mdi-decagram::before {
  content: "\\F076C"; }

.mdi-decagram-outline::before {
  content: "\\F076D"; }

.mdi-decimal::before {
  content: "\\F10A1"; }

.mdi-decimal-comma::before {
  content: "\\F10A2"; }

.mdi-decimal-comma-decrease::before {
  content: "\\F10A3"; }

.mdi-decimal-comma-increase::before {
  content: "\\F10A4"; }

.mdi-decimal-decrease::before {
  content: "\\F01B6"; }

.mdi-decimal-increase::before {
  content: "\\F01B5"; }

.mdi-delete::before {
  content: "\\F01B4"; }

.mdi-delete-alert::before {
  content: "\\F10A5"; }

.mdi-delete-alert-outline::before {
  content: "\\F10A6"; }

.mdi-delete-circle::before {
  content: "\\F0683"; }

.mdi-delete-circle-outline::before {
  content: "\\F0B88"; }

.mdi-delete-clock::before {
  content: "\\F1556"; }

.mdi-delete-clock-outline::before {
  content: "\\F1557"; }

.mdi-delete-empty::before {
  content: "\\F06CC"; }

.mdi-delete-empty-outline::before {
  content: "\\F0E9D"; }

.mdi-delete-forever::before {
  content: "\\F05E8"; }

.mdi-delete-forever-outline::before {
  content: "\\F0B89"; }

.mdi-delete-off::before {
  content: "\\F10A7"; }

.mdi-delete-off-outline::before {
  content: "\\F10A8"; }

.mdi-delete-outline::before {
  content: "\\F09E7"; }

.mdi-delete-restore::before {
  content: "\\F0819"; }

.mdi-delete-sweep::before {
  content: "\\F05E9"; }

.mdi-delete-sweep-outline::before {
  content: "\\F0C62"; }

.mdi-delete-variant::before {
  content: "\\F01B3"; }

.mdi-delta::before {
  content: "\\F01C2"; }

.mdi-desk::before {
  content: "\\F1239"; }

.mdi-desk-lamp::before {
  content: "\\F095F"; }

.mdi-deskphone::before {
  content: "\\F01C3"; }

.mdi-desktop-classic::before {
  content: "\\F07C0"; }

.mdi-desktop-mac::before {
  content: "\\F01C4"; }

.mdi-desktop-mac-dashboard::before {
  content: "\\F09E8"; }

.mdi-desktop-tower::before {
  content: "\\F01C5"; }

.mdi-desktop-tower-monitor::before {
  content: "\\F0AAB"; }

.mdi-details::before {
  content: "\\F01C6"; }

.mdi-dev-to::before {
  content: "\\F0D6E"; }

.mdi-developer-board::before {
  content: "\\F0697"; }

.mdi-deviantart::before {
  content: "\\F01C7"; }

.mdi-devices::before {
  content: "\\F0FB0"; }

.mdi-diabetes::before {
  content: "\\F1126"; }

.mdi-dialpad::before {
  content: "\\F061C"; }

.mdi-diameter::before {
  content: "\\F0C63"; }

.mdi-diameter-outline::before {
  content: "\\F0C64"; }

.mdi-diameter-variant::before {
  content: "\\F0C65"; }

.mdi-diamond::before {
  content: "\\F0B8A"; }

.mdi-diamond-outline::before {
  content: "\\F0B8B"; }

.mdi-diamond-stone::before {
  content: "\\F01C8"; }

.mdi-dice-1::before {
  content: "\\F01CA"; }

.mdi-dice-1-outline::before {
  content: "\\F114A"; }

.mdi-dice-2::before {
  content: "\\F01CB"; }

.mdi-dice-2-outline::before {
  content: "\\F114B"; }

.mdi-dice-3::before {
  content: "\\F01CC"; }

.mdi-dice-3-outline::before {
  content: "\\F114C"; }

.mdi-dice-4::before {
  content: "\\F01CD"; }

.mdi-dice-4-outline::before {
  content: "\\F114D"; }

.mdi-dice-5::before {
  content: "\\F01CE"; }

.mdi-dice-5-outline::before {
  content: "\\F114E"; }

.mdi-dice-6::before {
  content: "\\F01CF"; }

.mdi-dice-6-outline::before {
  content: "\\F114F"; }

.mdi-dice-d10::before {
  content: "\\F1153"; }

.mdi-dice-d10-outline::before {
  content: "\\F076F"; }

.mdi-dice-d12::before {
  content: "\\F1154"; }

.mdi-dice-d12-outline::before {
  content: "\\F0867"; }

.mdi-dice-d20::before {
  content: "\\F1155"; }

.mdi-dice-d20-outline::before {
  content: "\\F05EA"; }

.mdi-dice-d4::before {
  content: "\\F1150"; }

.mdi-dice-d4-outline::before {
  content: "\\F05EB"; }

.mdi-dice-d6::before {
  content: "\\F1151"; }

.mdi-dice-d6-outline::before {
  content: "\\F05ED"; }

.mdi-dice-d8::before {
  content: "\\F1152"; }

.mdi-dice-d8-outline::before {
  content: "\\F05EC"; }

.mdi-dice-multiple::before {
  content: "\\F076E"; }

.mdi-dice-multiple-outline::before {
  content: "\\F1156"; }

.mdi-digital-ocean::before {
  content: "\\F1237"; }

.mdi-dip-switch::before {
  content: "\\F07C1"; }

.mdi-directions::before {
  content: "\\F01D0"; }

.mdi-directions-fork::before {
  content: "\\F0641"; }

.mdi-disc::before {
  content: "\\F05EE"; }

.mdi-disc-alert::before {
  content: "\\F01D1"; }

.mdi-disc-player::before {
  content: "\\F0960"; }

.mdi-discord::before {
  content: "\\F066F"; }

.mdi-dishwasher::before {
  content: "\\F0AAC"; }

.mdi-dishwasher-alert::before {
  content: "\\F11B8"; }

.mdi-dishwasher-off::before {
  content: "\\F11B9"; }

.mdi-disqus::before {
  content: "\\F01D2"; }

.mdi-distribute-horizontal-center::before {
  content: "\\F11C9"; }

.mdi-distribute-horizontal-left::before {
  content: "\\F11C8"; }

.mdi-distribute-horizontal-right::before {
  content: "\\F11CA"; }

.mdi-distribute-vertical-bottom::before {
  content: "\\F11CB"; }

.mdi-distribute-vertical-center::before {
  content: "\\F11CC"; }

.mdi-distribute-vertical-top::before {
  content: "\\F11CD"; }

.mdi-diving-flippers::before {
  content: "\\F0DBF"; }

.mdi-diving-helmet::before {
  content: "\\F0DC0"; }

.mdi-diving-scuba::before {
  content: "\\F0DC1"; }

.mdi-diving-scuba-flag::before {
  content: "\\F0DC2"; }

.mdi-diving-scuba-tank::before {
  content: "\\F0DC3"; }

.mdi-diving-scuba-tank-multiple::before {
  content: "\\F0DC4"; }

.mdi-diving-snorkel::before {
  content: "\\F0DC5"; }

.mdi-division::before {
  content: "\\F01D4"; }

.mdi-division-box::before {
  content: "\\F01D5"; }

.mdi-dlna::before {
  content: "\\F0A41"; }

.mdi-dna::before {
  content: "\\F0684"; }

.mdi-dns::before {
  content: "\\F01D6"; }

.mdi-dns-outline::before {
  content: "\\F0B8C"; }

.mdi-do-not-disturb::before {
  content: "\\F0698"; }

.mdi-do-not-disturb-off::before {
  content: "\\F0699"; }

.mdi-dock-bottom::before {
  content: "\\F10A9"; }

.mdi-dock-left::before {
  content: "\\F10AA"; }

.mdi-dock-right::before {
  content: "\\F10AB"; }

.mdi-dock-top::before {
  content: "\\F1513"; }

.mdi-dock-window::before {
  content: "\\F10AC"; }

.mdi-docker::before {
  content: "\\F0868"; }

.mdi-doctor::before {
  content: "\\F0A42"; }

.mdi-dog::before {
  content: "\\F0A43"; }

.mdi-dog-service::before {
  content: "\\F0AAD"; }

.mdi-dog-side::before {
  content: "\\F0A44"; }

.mdi-dog-side-off::before {
  content: "\\F16EE"; }

.mdi-dolby::before {
  content: "\\F06B3"; }

.mdi-dolly::before {
  content: "\\F0E9E"; }

.mdi-domain::before {
  content: "\\F01D7"; }

.mdi-domain-off::before {
  content: "\\F0D6F"; }

.mdi-domain-plus::before {
  content: "\\F10AD"; }

.mdi-domain-remove::before {
  content: "\\F10AE"; }

.mdi-dome-light::before {
  content: "\\F141E"; }

.mdi-domino-mask::before {
  content: "\\F1023"; }

.mdi-donkey::before {
  content: "\\F07C2"; }

.mdi-door::before {
  content: "\\F081A"; }

.mdi-door-closed::before {
  content: "\\F081B"; }

.mdi-door-closed-lock::before {
  content: "\\F10AF"; }

.mdi-door-open::before {
  content: "\\F081C"; }

.mdi-doorbell::before {
  content: "\\F12E6"; }

.mdi-doorbell-video::before {
  content: "\\F0869"; }

.mdi-dot-net::before {
  content: "\\F0AAE"; }

.mdi-dots-grid::before {
  content: "\\F15FC"; }

.mdi-dots-hexagon::before {
  content: "\\F15FF"; }

.mdi-dots-horizontal::before {
  content: "\\F01D8"; }

.mdi-dots-horizontal-circle::before {
  content: "\\F07C3"; }

.mdi-dots-horizontal-circle-outline::before {
  content: "\\F0B8D"; }

.mdi-dots-square::before {
  content: "\\F15FD"; }

.mdi-dots-triangle::before {
  content: "\\F15FE"; }

.mdi-dots-vertical::before {
  content: "\\F01D9"; }

.mdi-dots-vertical-circle::before {
  content: "\\F07C4"; }

.mdi-dots-vertical-circle-outline::before {
  content: "\\F0B8E"; }

.mdi-douban::before {
  content: "\\F069A"; }

.mdi-download::before {
  content: "\\F01DA"; }

.mdi-download-box::before {
  content: "\\F1462"; }

.mdi-download-box-outline::before {
  content: "\\F1463"; }

.mdi-download-circle::before {
  content: "\\F1464"; }

.mdi-download-circle-outline::before {
  content: "\\F1465"; }

.mdi-download-lock::before {
  content: "\\F1320"; }

.mdi-download-lock-outline::before {
  content: "\\F1321"; }

.mdi-download-multiple::before {
  content: "\\F09E9"; }

.mdi-download-network::before {
  content: "\\F06F4"; }

.mdi-download-network-outline::before {
  content: "\\F0C66"; }

.mdi-download-off::before {
  content: "\\F10B0"; }

.mdi-download-off-outline::before {
  content: "\\F10B1"; }

.mdi-download-outline::before {
  content: "\\F0B8F"; }

.mdi-drag::before {
  content: "\\F01DB"; }

.mdi-drag-horizontal::before {
  content: "\\F01DC"; }

.mdi-drag-horizontal-variant::before {
  content: "\\F12F0"; }

.mdi-drag-variant::before {
  content: "\\F0B90"; }

.mdi-drag-vertical::before {
  content: "\\F01DD"; }

.mdi-drag-vertical-variant::before {
  content: "\\F12F1"; }

.mdi-drama-masks::before {
  content: "\\F0D02"; }

.mdi-draw::before {
  content: "\\F0F49"; }

.mdi-drawing::before {
  content: "\\F01DE"; }

.mdi-drawing-box::before {
  content: "\\F01DF"; }

.mdi-dresser::before {
  content: "\\F0F4A"; }

.mdi-dresser-outline::before {
  content: "\\F0F4B"; }

.mdi-drone::before {
  content: "\\F01E2"; }

.mdi-dropbox::before {
  content: "\\F01E3"; }

.mdi-drupal::before {
  content: "\\F01E4"; }

.mdi-duck::before {
  content: "\\F01E5"; }

.mdi-dumbbell::before {
  content: "\\F01E6"; }

.mdi-dump-truck::before {
  content: "\\F0C67"; }

.mdi-ear-hearing::before {
  content: "\\F07C5"; }

.mdi-ear-hearing-off::before {
  content: "\\F0A45"; }

.mdi-earth::before {
  content: "\\F01E7"; }

.mdi-earth-arrow-right::before {
  content: "\\F1311"; }

.mdi-earth-box::before {
  content: "\\F06CD"; }

.mdi-earth-box-minus::before {
  content: "\\F1407"; }

.mdi-earth-box-off::before {
  content: "\\F06CE"; }

.mdi-earth-box-plus::before {
  content: "\\F1406"; }

.mdi-earth-box-remove::before {
  content: "\\F1408"; }

.mdi-earth-minus::before {
  content: "\\F1404"; }

.mdi-earth-off::before {
  content: "\\F01E8"; }

.mdi-earth-plus::before {
  content: "\\F1403"; }

.mdi-earth-remove::before {
  content: "\\F1405"; }

.mdi-egg::before {
  content: "\\F0AAF"; }

.mdi-egg-easter::before {
  content: "\\F0AB0"; }

.mdi-egg-off::before {
  content: "\\F13F0"; }

.mdi-egg-off-outline::before {
  content: "\\F13F1"; }

.mdi-egg-outline::before {
  content: "\\F13F2"; }

.mdi-eiffel-tower::before {
  content: "\\F156B"; }

.mdi-eight-track::before {
  content: "\\F09EA"; }

.mdi-eject::before {
  content: "\\F01EA"; }

.mdi-eject-outline::before {
  content: "\\F0B91"; }

.mdi-electric-switch::before {
  content: "\\F0E9F"; }

.mdi-electric-switch-closed::before {
  content: "\\F10D9"; }

.mdi-electron-framework::before {
  content: "\\F1024"; }

.mdi-elephant::before {
  content: "\\F07C6"; }

.mdi-elevation-decline::before {
  content: "\\F01EB"; }

.mdi-elevation-rise::before {
  content: "\\F01EC"; }

.mdi-elevator::before {
  content: "\\F01ED"; }

.mdi-elevator-down::before {
  content: "\\F12C2"; }

.mdi-elevator-passenger::before {
  content: "\\F1381"; }

.mdi-elevator-up::before {
  content: "\\F12C1"; }

.mdi-ellipse::before {
  content: "\\F0EA0"; }

.mdi-ellipse-outline::before {
  content: "\\F0EA1"; }

.mdi-email::before {
  content: "\\F01EE"; }

.mdi-email-alert::before {
  content: "\\F06CF"; }

.mdi-email-alert-outline::before {
  content: "\\F0D42"; }

.mdi-email-box::before {
  content: "\\F0D03"; }

.mdi-email-check::before {
  content: "\\F0AB1"; }

.mdi-email-check-outline::before {
  content: "\\F0AB2"; }

.mdi-email-edit::before {
  content: "\\F0EE3"; }

.mdi-email-edit-outline::before {
  content: "\\F0EE4"; }

.mdi-email-lock::before {
  content: "\\F01F1"; }

.mdi-email-mark-as-unread::before {
  content: "\\F0B92"; }

.mdi-email-minus::before {
  content: "\\F0EE5"; }

.mdi-email-minus-outline::before {
  content: "\\F0EE6"; }

.mdi-email-multiple::before {
  content: "\\F0EE7"; }

.mdi-email-multiple-outline::before {
  content: "\\F0EE8"; }

.mdi-email-newsletter::before {
  content: "\\F0FB1"; }

.mdi-email-off::before {
  content: "\\F13E3"; }

.mdi-email-off-outline::before {
  content: "\\F13E4"; }

.mdi-email-open::before {
  content: "\\F01EF"; }

.mdi-email-open-multiple::before {
  content: "\\F0EE9"; }

.mdi-email-open-multiple-outline::before {
  content: "\\F0EEA"; }

.mdi-email-open-outline::before {
  content: "\\F05EF"; }

.mdi-email-outline::before {
  content: "\\F01F0"; }

.mdi-email-plus::before {
  content: "\\F09EB"; }

.mdi-email-plus-outline::before {
  content: "\\F09EC"; }

.mdi-email-receive::before {
  content: "\\F10DA"; }

.mdi-email-receive-outline::before {
  content: "\\F10DB"; }

.mdi-email-remove::before {
  content: "\\F1661"; }

.mdi-email-remove-outline::before {
  content: "\\F1662"; }

.mdi-email-search::before {
  content: "\\F0961"; }

.mdi-email-search-outline::before {
  content: "\\F0962"; }

.mdi-email-send::before {
  content: "\\F10DC"; }

.mdi-email-send-outline::before {
  content: "\\F10DD"; }

.mdi-email-sync::before {
  content: "\\F12C7"; }

.mdi-email-sync-outline::before {
  content: "\\F12C8"; }

.mdi-email-variant::before {
  content: "\\F05F0"; }

.mdi-ember::before {
  content: "\\F0B30"; }

.mdi-emby::before {
  content: "\\F06B4"; }

.mdi-emoticon::before {
  content: "\\F0C68"; }

.mdi-emoticon-angry::before {
  content: "\\F0C69"; }

.mdi-emoticon-angry-outline::before {
  content: "\\F0C6A"; }

.mdi-emoticon-confused::before {
  content: "\\F10DE"; }

.mdi-emoticon-confused-outline::before {
  content: "\\F10DF"; }

.mdi-emoticon-cool::before {
  content: "\\F0C6B"; }

.mdi-emoticon-cool-outline::before {
  content: "\\F01F3"; }

.mdi-emoticon-cry::before {
  content: "\\F0C6C"; }

.mdi-emoticon-cry-outline::before {
  content: "\\F0C6D"; }

.mdi-emoticon-dead::before {
  content: "\\F0C6E"; }

.mdi-emoticon-dead-outline::before {
  content: "\\F069B"; }

.mdi-emoticon-devil::before {
  content: "\\F0C6F"; }

.mdi-emoticon-devil-outline::before {
  content: "\\F01F4"; }

.mdi-emoticon-excited::before {
  content: "\\F0C70"; }

.mdi-emoticon-excited-outline::before {
  content: "\\F069C"; }

.mdi-emoticon-frown::before {
  content: "\\F0F4C"; }

.mdi-emoticon-frown-outline::before {
  content: "\\F0F4D"; }

.mdi-emoticon-happy::before {
  content: "\\F0C71"; }

.mdi-emoticon-happy-outline::before {
  content: "\\F01F5"; }

.mdi-emoticon-kiss::before {
  content: "\\F0C72"; }

.mdi-emoticon-kiss-outline::before {
  content: "\\F0C73"; }

.mdi-emoticon-lol::before {
  content: "\\F1214"; }

.mdi-emoticon-lol-outline::before {
  content: "\\F1215"; }

.mdi-emoticon-neutral::before {
  content: "\\F0C74"; }

.mdi-emoticon-neutral-outline::before {
  content: "\\F01F6"; }

.mdi-emoticon-outline::before {
  content: "\\F01F2"; }

.mdi-emoticon-poop::before {
  content: "\\F01F7"; }

.mdi-emoticon-poop-outline::before {
  content: "\\F0C75"; }

.mdi-emoticon-sad::before {
  content: "\\F0C76"; }

.mdi-emoticon-sad-outline::before {
  content: "\\F01F8"; }

.mdi-emoticon-sick::before {
  content: "\\F157C"; }

.mdi-emoticon-sick-outline::before {
  content: "\\F157D"; }

.mdi-emoticon-tongue::before {
  content: "\\F01F9"; }

.mdi-emoticon-tongue-outline::before {
  content: "\\F0C77"; }

.mdi-emoticon-wink::before {
  content: "\\F0C78"; }

.mdi-emoticon-wink-outline::before {
  content: "\\F0C79"; }

.mdi-engine::before {
  content: "\\F01FA"; }

.mdi-engine-off::before {
  content: "\\F0A46"; }

.mdi-engine-off-outline::before {
  content: "\\F0A47"; }

.mdi-engine-outline::before {
  content: "\\F01FB"; }

.mdi-epsilon::before {
  content: "\\F10E0"; }

.mdi-equal::before {
  content: "\\F01FC"; }

.mdi-equal-box::before {
  content: "\\F01FD"; }

.mdi-equalizer::before {
  content: "\\F0EA2"; }

.mdi-equalizer-outline::before {
  content: "\\F0EA3"; }

.mdi-eraser::before {
  content: "\\F01FE"; }

.mdi-eraser-variant::before {
  content: "\\F0642"; }

.mdi-escalator::before {
  content: "\\F01FF"; }

.mdi-escalator-box::before {
  content: "\\F1399"; }

.mdi-escalator-down::before {
  content: "\\F12C0"; }

.mdi-escalator-up::before {
  content: "\\F12BF"; }

.mdi-eslint::before {
  content: "\\F0C7A"; }

.mdi-et::before {
  content: "\\F0AB3"; }

.mdi-ethereum::before {
  content: "\\F086A"; }

.mdi-ethernet::before {
  content: "\\F0200"; }

.mdi-ethernet-cable::before {
  content: "\\F0201"; }

.mdi-ethernet-cable-off::before {
  content: "\\F0202"; }

.mdi-ev-plug-ccs1::before {
  content: "\\F1519"; }

.mdi-ev-plug-ccs2::before {
  content: "\\F151A"; }

.mdi-ev-plug-chademo::before {
  content: "\\F151B"; }

.mdi-ev-plug-tesla::before {
  content: "\\F151C"; }

.mdi-ev-plug-type1::before {
  content: "\\F151D"; }

.mdi-ev-plug-type2::before {
  content: "\\F151E"; }

.mdi-ev-station::before {
  content: "\\F05F1"; }

.mdi-evernote::before {
  content: "\\F0204"; }

.mdi-excavator::before {
  content: "\\F1025"; }

.mdi-exclamation::before {
  content: "\\F0205"; }

.mdi-exclamation-thick::before {
  content: "\\F1238"; }

.mdi-exit-run::before {
  content: "\\F0A48"; }

.mdi-exit-to-app::before {
  content: "\\F0206"; }

.mdi-expand-all::before {
  content: "\\F0AB4"; }

.mdi-expand-all-outline::before {
  content: "\\F0AB5"; }

.mdi-expansion-card::before {
  content: "\\F08AE"; }

.mdi-expansion-card-variant::before {
  content: "\\F0FB2"; }

.mdi-exponent::before {
  content: "\\F0963"; }

.mdi-exponent-box::before {
  content: "\\F0964"; }

.mdi-export::before {
  content: "\\F0207"; }

.mdi-export-variant::before {
  content: "\\F0B93"; }

.mdi-eye::before {
  content: "\\F0208"; }

.mdi-eye-check::before {
  content: "\\F0D04"; }

.mdi-eye-check-outline::before {
  content: "\\F0D05"; }

.mdi-eye-circle::before {
  content: "\\F0B94"; }

.mdi-eye-circle-outline::before {
  content: "\\F0B95"; }

.mdi-eye-minus::before {
  content: "\\F1026"; }

.mdi-eye-minus-outline::before {
  content: "\\F1027"; }

.mdi-eye-off::before {
  content: "\\F0209"; }

.mdi-eye-off-outline::before {
  content: "\\F06D1"; }

.mdi-eye-outline::before {
  content: "\\F06D0"; }

.mdi-eye-plus::before {
  content: "\\F086B"; }

.mdi-eye-plus-outline::before {
  content: "\\F086C"; }

.mdi-eye-remove::before {
  content: "\\F15E3"; }

.mdi-eye-remove-outline::before {
  content: "\\F15E4"; }

.mdi-eye-settings::before {
  content: "\\F086D"; }

.mdi-eye-settings-outline::before {
  content: "\\F086E"; }

.mdi-eyedropper::before {
  content: "\\F020A"; }

.mdi-eyedropper-minus::before {
  content: "\\F13DD"; }

.mdi-eyedropper-off::before {
  content: "\\F13DF"; }

.mdi-eyedropper-plus::before {
  content: "\\F13DC"; }

.mdi-eyedropper-remove::before {
  content: "\\F13DE"; }

.mdi-eyedropper-variant::before {
  content: "\\F020B"; }

.mdi-face::before {
  content: "\\F0643"; }

.mdi-face-agent::before {
  content: "\\F0D70"; }

.mdi-face-mask::before {
  content: "\\F1586"; }

.mdi-face-mask-outline::before {
  content: "\\F1587"; }

.mdi-face-outline::before {
  content: "\\F0B96"; }

.mdi-face-profile::before {
  content: "\\F0644"; }

.mdi-face-profile-woman::before {
  content: "\\F1076"; }

.mdi-face-recognition::before {
  content: "\\F0C7B"; }

.mdi-face-shimmer::before {
  content: "\\F15CC"; }

.mdi-face-shimmer-outline::before {
  content: "\\F15CD"; }

.mdi-face-woman::before {
  content: "\\F1077"; }

.mdi-face-woman-outline::before {
  content: "\\F1078"; }

.mdi-face-woman-shimmer::before {
  content: "\\F15CE"; }

.mdi-face-woman-shimmer-outline::before {
  content: "\\F15CF"; }

.mdi-facebook::before {
  content: "\\F020C"; }

.mdi-facebook-gaming::before {
  content: "\\F07DD"; }

.mdi-facebook-messenger::before {
  content: "\\F020E"; }

.mdi-facebook-workplace::before {
  content: "\\F0B31"; }

.mdi-factory::before {
  content: "\\F020F"; }

.mdi-family-tree::before {
  content: "\\F160E"; }

.mdi-fan::before {
  content: "\\F0210"; }

.mdi-fan-alert::before {
  content: "\\F146C"; }

.mdi-fan-auto::before {
  content: "\\F171D"; }

.mdi-fan-chevron-down::before {
  content: "\\F146D"; }

.mdi-fan-chevron-up::before {
  content: "\\F146E"; }

.mdi-fan-minus::before {
  content: "\\F1470"; }

.mdi-fan-off::before {
  content: "\\F081D"; }

.mdi-fan-plus::before {
  content: "\\F146F"; }

.mdi-fan-remove::before {
  content: "\\F1471"; }

.mdi-fan-speed-1::before {
  content: "\\F1472"; }

.mdi-fan-speed-2::before {
  content: "\\F1473"; }

.mdi-fan-speed-3::before {
  content: "\\F1474"; }

.mdi-fast-forward::before {
  content: "\\F0211"; }

.mdi-fast-forward-10::before {
  content: "\\F0D71"; }

.mdi-fast-forward-30::before {
  content: "\\F0D06"; }

.mdi-fast-forward-5::before {
  content: "\\F11F8"; }

.mdi-fast-forward-60::before {
  content: "\\F160B"; }

.mdi-fast-forward-outline::before {
  content: "\\F06D2"; }

.mdi-fax::before {
  content: "\\F0212"; }

.mdi-feather::before {
  content: "\\F06D3"; }

.mdi-feature-search::before {
  content: "\\F0A49"; }

.mdi-feature-search-outline::before {
  content: "\\F0A4A"; }

.mdi-fedora::before {
  content: "\\F08DB"; }

.mdi-fencing::before {
  content: "\\F14C1"; }

.mdi-ferris-wheel::before {
  content: "\\F0EA4"; }

.mdi-ferry::before {
  content: "\\F0213"; }

.mdi-file::before {
  content: "\\F0214"; }

.mdi-file-account::before {
  content: "\\F073B"; }

.mdi-file-account-outline::before {
  content: "\\F1028"; }

.mdi-file-alert::before {
  content: "\\F0A4B"; }

.mdi-file-alert-outline::before {
  content: "\\F0A4C"; }

.mdi-file-cabinet::before {
  content: "\\F0AB6"; }

.mdi-file-cad::before {
  content: "\\F0EEB"; }

.mdi-file-cad-box::before {
  content: "\\F0EEC"; }

.mdi-file-cancel::before {
  content: "\\F0DC6"; }

.mdi-file-cancel-outline::before {
  content: "\\F0DC7"; }

.mdi-file-certificate::before {
  content: "\\F1186"; }

.mdi-file-certificate-outline::before {
  content: "\\F1187"; }

.mdi-file-chart::before {
  content: "\\F0215"; }

.mdi-file-chart-outline::before {
  content: "\\F1029"; }

.mdi-file-check::before {
  content: "\\F0216"; }

.mdi-file-check-outline::before {
  content: "\\F0E29"; }

.mdi-file-clock::before {
  content: "\\F12E1"; }

.mdi-file-clock-outline::before {
  content: "\\F12E2"; }

.mdi-file-cloud::before {
  content: "\\F0217"; }

.mdi-file-cloud-outline::before {
  content: "\\F102A"; }

.mdi-file-code::before {
  content: "\\F022E"; }

.mdi-file-code-outline::before {
  content: "\\F102B"; }

.mdi-file-cog::before {
  content: "\\F107B"; }

.mdi-file-cog-outline::before {
  content: "\\F107C"; }

.mdi-file-compare::before {
  content: "\\F08AA"; }

.mdi-file-delimited::before {
  content: "\\F0218"; }

.mdi-file-delimited-outline::before {
  content: "\\F0EA5"; }

.mdi-file-document::before {
  content: "\\F0219"; }

.mdi-file-document-edit::before {
  content: "\\F0DC8"; }

.mdi-file-document-edit-outline::before {
  content: "\\F0DC9"; }

.mdi-file-document-multiple::before {
  content: "\\F1517"; }

.mdi-file-document-multiple-outline::before {
  content: "\\F1518"; }

.mdi-file-document-outline::before {
  content: "\\F09EE"; }

.mdi-file-download::before {
  content: "\\F0965"; }

.mdi-file-download-outline::before {
  content: "\\F0966"; }

.mdi-file-edit::before {
  content: "\\F11E7"; }

.mdi-file-edit-outline::before {
  content: "\\F11E8"; }

.mdi-file-excel::before {
  content: "\\F021B"; }

.mdi-file-excel-box::before {
  content: "\\F021C"; }

.mdi-file-excel-box-outline::before {
  content: "\\F102C"; }

.mdi-file-excel-outline::before {
  content: "\\F102D"; }

.mdi-file-export::before {
  content: "\\F021D"; }

.mdi-file-export-outline::before {
  content: "\\F102E"; }

.mdi-file-eye::before {
  content: "\\F0DCA"; }

.mdi-file-eye-outline::before {
  content: "\\F0DCB"; }

.mdi-file-find::before {
  content: "\\F021E"; }

.mdi-file-find-outline::before {
  content: "\\F0B97"; }

.mdi-file-hidden::before {
  content: "\\F0613"; }

.mdi-file-image::before {
  content: "\\F021F"; }

.mdi-file-image-outline::before {
  content: "\\F0EB0"; }

.mdi-file-import::before {
  content: "\\F0220"; }

.mdi-file-import-outline::before {
  content: "\\F102F"; }

.mdi-file-key::before {
  content: "\\F1184"; }

.mdi-file-key-outline::before {
  content: "\\F1185"; }

.mdi-file-link::before {
  content: "\\F1177"; }

.mdi-file-link-outline::before {
  content: "\\F1178"; }

.mdi-file-lock::before {
  content: "\\F0221"; }

.mdi-file-lock-outline::before {
  content: "\\F1030"; }

.mdi-file-move::before {
  content: "\\F0AB9"; }

.mdi-file-move-outline::before {
  content: "\\F1031"; }

.mdi-file-multiple::before {
  content: "\\F0222"; }

.mdi-file-multiple-outline::before {
  content: "\\F1032"; }

.mdi-file-music::before {
  content: "\\F0223"; }

.mdi-file-music-outline::before {
  content: "\\F0E2A"; }

.mdi-file-outline::before {
  content: "\\F0224"; }

.mdi-file-pdf::before {
  content: "\\F0225"; }

.mdi-file-pdf-box::before {
  content: "\\F0226"; }

.mdi-file-pdf-box-outline::before {
  content: "\\F0FB3"; }

.mdi-file-pdf-outline::before {
  content: "\\F0E2D"; }

.mdi-file-percent::before {
  content: "\\F081E"; }

.mdi-file-percent-outline::before {
  content: "\\F1033"; }

.mdi-file-phone::before {
  content: "\\F1179"; }

.mdi-file-phone-outline::before {
  content: "\\F117A"; }

.mdi-file-plus::before {
  content: "\\F0752"; }

.mdi-file-plus-outline::before {
  content: "\\F0EED"; }

.mdi-file-powerpoint::before {
  content: "\\F0227"; }

.mdi-file-powerpoint-box::before {
  content: "\\F0228"; }

.mdi-file-powerpoint-box-outline::before {
  content: "\\F1034"; }

.mdi-file-powerpoint-outline::before {
  content: "\\F1035"; }

.mdi-file-presentation-box::before {
  content: "\\F0229"; }

.mdi-file-question::before {
  content: "\\F086F"; }

.mdi-file-question-outline::before {
  content: "\\F1036"; }

.mdi-file-refresh::before {
  content: "\\F0918"; }

.mdi-file-refresh-outline::before {
  content: "\\F0541"; }

.mdi-file-remove::before {
  content: "\\F0B98"; }

.mdi-file-remove-outline::before {
  content: "\\F1037"; }

.mdi-file-replace::before {
  content: "\\F0B32"; }

.mdi-file-replace-outline::before {
  content: "\\F0B33"; }

.mdi-file-restore::before {
  content: "\\F0670"; }

.mdi-file-restore-outline::before {
  content: "\\F1038"; }

.mdi-file-search::before {
  content: "\\F0C7C"; }

.mdi-file-search-outline::before {
  content: "\\F0C7D"; }

.mdi-file-send::before {
  content: "\\F022A"; }

.mdi-file-send-outline::before {
  content: "\\F1039"; }

.mdi-file-settings::before {
  content: "\\F1079"; }

.mdi-file-settings-outline::before {
  content: "\\F107A"; }

.mdi-file-star::before {
  content: "\\F103A"; }

.mdi-file-star-outline::before {
  content: "\\F103B"; }

.mdi-file-swap::before {
  content: "\\F0FB4"; }

.mdi-file-swap-outline::before {
  content: "\\F0FB5"; }

.mdi-file-sync::before {
  content: "\\F1216"; }

.mdi-file-sync-outline::before {
  content: "\\F1217"; }

.mdi-file-table::before {
  content: "\\F0C7E"; }

.mdi-file-table-box::before {
  content: "\\F10E1"; }

.mdi-file-table-box-multiple::before {
  content: "\\F10E2"; }

.mdi-file-table-box-multiple-outline::before {
  content: "\\F10E3"; }

.mdi-file-table-box-outline::before {
  content: "\\F10E4"; }

.mdi-file-table-outline::before {
  content: "\\F0C7F"; }

.mdi-file-tree::before {
  content: "\\F0645"; }

.mdi-file-tree-outline::before {
  content: "\\F13D2"; }

.mdi-file-undo::before {
  content: "\\F08DC"; }

.mdi-file-undo-outline::before {
  content: "\\F103C"; }

.mdi-file-upload::before {
  content: "\\F0A4D"; }

.mdi-file-upload-outline::before {
  content: "\\F0A4E"; }

.mdi-file-video::before {
  content: "\\F022B"; }

.mdi-file-video-outline::before {
  content: "\\F0E2C"; }

.mdi-file-word::before {
  content: "\\F022C"; }

.mdi-file-word-box::before {
  content: "\\F022D"; }

.mdi-file-word-box-outline::before {
  content: "\\F103D"; }

.mdi-file-word-outline::before {
  content: "\\F103E"; }

.mdi-film::before {
  content: "\\F022F"; }

.mdi-filmstrip::before {
  content: "\\F0230"; }

.mdi-filmstrip-box::before {
  content: "\\F0332"; }

.mdi-filmstrip-box-multiple::before {
  content: "\\F0D18"; }

.mdi-filmstrip-off::before {
  content: "\\F0231"; }

.mdi-filter::before {
  content: "\\F0232"; }

.mdi-filter-menu::before {
  content: "\\F10E5"; }

.mdi-filter-menu-outline::before {
  content: "\\F10E6"; }

.mdi-filter-minus::before {
  content: "\\F0EEE"; }

.mdi-filter-minus-outline::before {
  content: "\\F0EEF"; }

.mdi-filter-off::before {
  content: "\\F14EF"; }

.mdi-filter-off-outline::before {
  content: "\\F14F0"; }

.mdi-filter-outline::before {
  content: "\\F0233"; }

.mdi-filter-plus::before {
  content: "\\F0EF0"; }

.mdi-filter-plus-outline::before {
  content: "\\F0EF1"; }

.mdi-filter-remove::before {
  content: "\\F0234"; }

.mdi-filter-remove-outline::before {
  content: "\\F0235"; }

.mdi-filter-variant::before {
  content: "\\F0236"; }

.mdi-filter-variant-minus::before {
  content: "\\F1112"; }

.mdi-filter-variant-plus::before {
  content: "\\F1113"; }

.mdi-filter-variant-remove::before {
  content: "\\F103F"; }

.mdi-finance::before {
  content: "\\F081F"; }

.mdi-find-replace::before {
  content: "\\F06D4"; }

.mdi-fingerprint::before {
  content: "\\F0237"; }

.mdi-fingerprint-off::before {
  content: "\\F0EB1"; }

.mdi-fire::before {
  content: "\\F0238"; }

.mdi-fire-alert::before {
  content: "\\F15D7"; }

.mdi-fire-extinguisher::before {
  content: "\\F0EF2"; }

.mdi-fire-hydrant::before {
  content: "\\F1137"; }

.mdi-fire-hydrant-alert::before {
  content: "\\F1138"; }

.mdi-fire-hydrant-off::before {
  content: "\\F1139"; }

.mdi-fire-off::before {
  content: "\\F1722"; }

.mdi-fire-truck::before {
  content: "\\F08AB"; }

.mdi-firebase::before {
  content: "\\F0967"; }

.mdi-firefox::before {
  content: "\\F0239"; }

.mdi-fireplace::before {
  content: "\\F0E2E"; }

.mdi-fireplace-off::before {
  content: "\\F0E2F"; }

.mdi-firework::before {
  content: "\\F0E30"; }

.mdi-firework-off::before {
  content: "\\F1723"; }

.mdi-fish::before {
  content: "\\F023A"; }

.mdi-fish-off::before {
  content: "\\F13F3"; }

.mdi-fishbowl::before {
  content: "\\F0EF3"; }

.mdi-fishbowl-outline::before {
  content: "\\F0EF4"; }

.mdi-fit-to-page::before {
  content: "\\F0EF5"; }

.mdi-fit-to-page-outline::before {
  content: "\\F0EF6"; }

.mdi-flag::before {
  content: "\\F023B"; }

.mdi-flag-checkered::before {
  content: "\\F023C"; }

.mdi-flag-minus::before {
  content: "\\F0B99"; }

.mdi-flag-minus-outline::before {
  content: "\\F10B2"; }

.mdi-flag-outline::before {
  content: "\\F023D"; }

.mdi-flag-plus::before {
  content: "\\F0B9A"; }

.mdi-flag-plus-outline::before {
  content: "\\F10B3"; }

.mdi-flag-remove::before {
  content: "\\F0B9B"; }

.mdi-flag-remove-outline::before {
  content: "\\F10B4"; }

.mdi-flag-triangle::before {
  content: "\\F023F"; }

.mdi-flag-variant::before {
  content: "\\F0240"; }

.mdi-flag-variant-outline::before {
  content: "\\F023E"; }

.mdi-flare::before {
  content: "\\F0D72"; }

.mdi-flash::before {
  content: "\\F0241"; }

.mdi-flash-alert::before {
  content: "\\F0EF7"; }

.mdi-flash-alert-outline::before {
  content: "\\F0EF8"; }

.mdi-flash-auto::before {
  content: "\\F0242"; }

.mdi-flash-circle::before {
  content: "\\F0820"; }

.mdi-flash-off::before {
  content: "\\F0243"; }

.mdi-flash-outline::before {
  content: "\\F06D5"; }

.mdi-flash-red-eye::before {
  content: "\\F067B"; }

.mdi-flashlight::before {
  content: "\\F0244"; }

.mdi-flashlight-off::before {
  content: "\\F0245"; }

.mdi-flask::before {
  content: "\\F0093"; }

.mdi-flask-empty::before {
  content: "\\F0094"; }

.mdi-flask-empty-minus::before {
  content: "\\F123A"; }

.mdi-flask-empty-minus-outline::before {
  content: "\\F123B"; }

.mdi-flask-empty-off::before {
  content: "\\F13F4"; }

.mdi-flask-empty-off-outline::before {
  content: "\\F13F5"; }

.mdi-flask-empty-outline::before {
  content: "\\F0095"; }

.mdi-flask-empty-plus::before {
  content: "\\F123C"; }

.mdi-flask-empty-plus-outline::before {
  content: "\\F123D"; }

.mdi-flask-empty-remove::before {
  content: "\\F123E"; }

.mdi-flask-empty-remove-outline::before {
  content: "\\F123F"; }

.mdi-flask-minus::before {
  content: "\\F1240"; }

.mdi-flask-minus-outline::before {
  content: "\\F1241"; }

.mdi-flask-off::before {
  content: "\\F13F6"; }

.mdi-flask-off-outline::before {
  content: "\\F13F7"; }

.mdi-flask-outline::before {
  content: "\\F0096"; }

.mdi-flask-plus::before {
  content: "\\F1242"; }

.mdi-flask-plus-outline::before {
  content: "\\F1243"; }

.mdi-flask-remove::before {
  content: "\\F1244"; }

.mdi-flask-remove-outline::before {
  content: "\\F1245"; }

.mdi-flask-round-bottom::before {
  content: "\\F124B"; }

.mdi-flask-round-bottom-empty::before {
  content: "\\F124C"; }

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\F124D"; }

.mdi-flask-round-bottom-outline::before {
  content: "\\F124E"; }

.mdi-fleur-de-lis::before {
  content: "\\F1303"; }

.mdi-flip-horizontal::before {
  content: "\\F10E7"; }

.mdi-flip-to-back::before {
  content: "\\F0247"; }

.mdi-flip-to-front::before {
  content: "\\F0248"; }

.mdi-flip-vertical::before {
  content: "\\F10E8"; }

.mdi-floor-lamp::before {
  content: "\\F08DD"; }

.mdi-floor-lamp-dual::before {
  content: "\\F1040"; }

.mdi-floor-lamp-variant::before {
  content: "\\F1041"; }

.mdi-floor-plan::before {
  content: "\\F0821"; }

.mdi-floppy::before {
  content: "\\F0249"; }

.mdi-floppy-variant::before {
  content: "\\F09EF"; }

.mdi-flower::before {
  content: "\\F024A"; }

.mdi-flower-outline::before {
  content: "\\F09F0"; }

.mdi-flower-poppy::before {
  content: "\\F0D08"; }

.mdi-flower-tulip::before {
  content: "\\F09F1"; }

.mdi-flower-tulip-outline::before {
  content: "\\F09F2"; }

.mdi-focus-auto::before {
  content: "\\F0F4E"; }

.mdi-focus-field::before {
  content: "\\F0F4F"; }

.mdi-focus-field-horizontal::before {
  content: "\\F0F50"; }

.mdi-focus-field-vertical::before {
  content: "\\F0F51"; }

.mdi-folder::before {
  content: "\\F024B"; }

.mdi-folder-account::before {
  content: "\\F024C"; }

.mdi-folder-account-outline::before {
  content: "\\F0B9C"; }

.mdi-folder-alert::before {
  content: "\\F0DCC"; }

.mdi-folder-alert-outline::before {
  content: "\\F0DCD"; }

.mdi-folder-clock::before {
  content: "\\F0ABA"; }

.mdi-folder-clock-outline::before {
  content: "\\F0ABB"; }

.mdi-folder-cog::before {
  content: "\\F107F"; }

.mdi-folder-cog-outline::before {
  content: "\\F1080"; }

.mdi-folder-download::before {
  content: "\\F024D"; }

.mdi-folder-download-outline::before {
  content: "\\F10E9"; }

.mdi-folder-edit::before {
  content: "\\F08DE"; }

.mdi-folder-edit-outline::before {
  content: "\\F0DCE"; }

.mdi-folder-google-drive::before {
  content: "\\F024E"; }

.mdi-folder-heart::before {
  content: "\\F10EA"; }

.mdi-folder-heart-outline::before {
  content: "\\F10EB"; }

.mdi-folder-home::before {
  content: "\\F10B5"; }

.mdi-folder-home-outline::before {
  content: "\\F10B6"; }

.mdi-folder-image::before {
  content: "\\F024F"; }

.mdi-folder-information::before {
  content: "\\F10B7"; }

.mdi-folder-information-outline::before {
  content: "\\F10B8"; }

.mdi-folder-key::before {
  content: "\\F08AC"; }

.mdi-folder-key-network::before {
  content: "\\F08AD"; }

.mdi-folder-key-network-outline::before {
  content: "\\F0C80"; }

.mdi-folder-key-outline::before {
  content: "\\F10EC"; }

.mdi-folder-lock::before {
  content: "\\F0250"; }

.mdi-folder-lock-open::before {
  content: "\\F0251"; }

.mdi-folder-marker::before {
  content: "\\F126D"; }

.mdi-folder-marker-outline::before {
  content: "\\F126E"; }

.mdi-folder-move::before {
  content: "\\F0252"; }

.mdi-folder-move-outline::before {
  content: "\\F1246"; }

.mdi-folder-multiple::before {
  content: "\\F0253"; }

.mdi-folder-multiple-image::before {
  content: "\\F0254"; }

.mdi-folder-multiple-outline::before {
  content: "\\F0255"; }

.mdi-folder-multiple-plus::before {
  content: "\\F147E"; }

.mdi-folder-multiple-plus-outline::before {
  content: "\\F147F"; }

.mdi-folder-music::before {
  content: "\\F1359"; }

.mdi-folder-music-outline::before {
  content: "\\F135A"; }

.mdi-folder-network::before {
  content: "\\F0870"; }

.mdi-folder-network-outline::before {
  content: "\\F0C81"; }

.mdi-folder-open::before {
  content: "\\F0770"; }

.mdi-folder-open-outline::before {
  content: "\\F0DCF"; }

.mdi-folder-outline::before {
  content: "\\F0256"; }

.mdi-folder-plus::before {
  content: "\\F0257"; }

.mdi-folder-plus-outline::before {
  content: "\\F0B9D"; }

.mdi-folder-pound::before {
  content: "\\F0D09"; }

.mdi-folder-pound-outline::before {
  content: "\\F0D0A"; }

.mdi-folder-refresh::before {
  content: "\\F0749"; }

.mdi-folder-refresh-outline::before {
  content: "\\F0542"; }

.mdi-folder-remove::before {
  content: "\\F0258"; }

.mdi-folder-remove-outline::before {
  content: "\\F0B9E"; }

.mdi-folder-search::before {
  content: "\\F0968"; }

.mdi-folder-search-outline::before {
  content: "\\F0969"; }

.mdi-folder-settings::before {
  content: "\\F107D"; }

.mdi-folder-settings-outline::before {
  content: "\\F107E"; }

.mdi-folder-star::before {
  content: "\\F069D"; }

.mdi-folder-star-multiple::before {
  content: "\\F13D3"; }

.mdi-folder-star-multiple-outline::before {
  content: "\\F13D4"; }

.mdi-folder-star-outline::before {
  content: "\\F0B9F"; }

.mdi-folder-swap::before {
  content: "\\F0FB6"; }

.mdi-folder-swap-outline::before {
  content: "\\F0FB7"; }

.mdi-folder-sync::before {
  content: "\\F0D0B"; }

.mdi-folder-sync-outline::before {
  content: "\\F0D0C"; }

.mdi-folder-table::before {
  content: "\\F12E3"; }

.mdi-folder-table-outline::before {
  content: "\\F12E4"; }

.mdi-folder-text::before {
  content: "\\F0C82"; }

.mdi-folder-text-outline::before {
  content: "\\F0C83"; }

.mdi-folder-upload::before {
  content: "\\F0259"; }

.mdi-folder-upload-outline::before {
  content: "\\F10ED"; }

.mdi-folder-zip::before {
  content: "\\F06EB"; }

.mdi-folder-zip-outline::before {
  content: "\\F07B9"; }

.mdi-font-awesome::before {
  content: "\\F003A"; }

.mdi-food::before {
  content: "\\F025A"; }

.mdi-food-apple::before {
  content: "\\F025B"; }

.mdi-food-apple-outline::before {
  content: "\\F0C84"; }

.mdi-food-croissant::before {
  content: "\\F07C8"; }

.mdi-food-drumstick::before {
  content: "\\F141F"; }

.mdi-food-drumstick-off::before {
  content: "\\F1468"; }

.mdi-food-drumstick-off-outline::before {
  content: "\\F1469"; }

.mdi-food-drumstick-outline::before {
  content: "\\F1420"; }

.mdi-food-fork-drink::before {
  content: "\\F05F2"; }

.mdi-food-halal::before {
  content: "\\F1572"; }

.mdi-food-kosher::before {
  content: "\\F1573"; }

.mdi-food-off::before {
  content: "\\F05F3"; }

.mdi-food-steak::before {
  content: "\\F146A"; }

.mdi-food-steak-off::before {
  content: "\\F146B"; }

.mdi-food-turkey::before {
  content: "\\F171C"; }

.mdi-food-variant::before {
  content: "\\F025C"; }

.mdi-food-variant-off::before {
  content: "\\F13E5"; }

.mdi-foot-print::before {
  content: "\\F0F52"; }

.mdi-football::before {
  content: "\\F025D"; }

.mdi-football-australian::before {
  content: "\\F025E"; }

.mdi-football-helmet::before {
  content: "\\F025F"; }

.mdi-forklift::before {
  content: "\\F07C9"; }

.mdi-form-dropdown::before {
  content: "\\F1400"; }

.mdi-form-select::before {
  content: "\\F1401"; }

.mdi-form-textarea::before {
  content: "\\F1095"; }

.mdi-form-textbox::before {
  content: "\\F060E"; }

.mdi-form-textbox-lock::before {
  content: "\\F135D"; }

.mdi-form-textbox-password::before {
  content: "\\F07F5"; }

.mdi-format-align-bottom::before {
  content: "\\F0753"; }

.mdi-format-align-center::before {
  content: "\\F0260"; }

.mdi-format-align-justify::before {
  content: "\\F0261"; }

.mdi-format-align-left::before {
  content: "\\F0262"; }

.mdi-format-align-middle::before {
  content: "\\F0754"; }

.mdi-format-align-right::before {
  content: "\\F0263"; }

.mdi-format-align-top::before {
  content: "\\F0755"; }

.mdi-format-annotation-minus::before {
  content: "\\F0ABC"; }

.mdi-format-annotation-plus::before {
  content: "\\F0646"; }

.mdi-format-bold::before {
  content: "\\F0264"; }

.mdi-format-clear::before {
  content: "\\F0265"; }

.mdi-format-color-fill::before {
  content: "\\F0266"; }

.mdi-format-color-highlight::before {
  content: "\\F0E31"; }

.mdi-format-color-marker-cancel::before {
  content: "\\F1313"; }

.mdi-format-color-text::before {
  content: "\\F069E"; }

.mdi-format-columns::before {
  content: "\\F08DF"; }

.mdi-format-float-center::before {
  content: "\\F0267"; }

.mdi-format-float-left::before {
  content: "\\F0268"; }

.mdi-format-float-none::before {
  content: "\\F0269"; }

.mdi-format-float-right::before {
  content: "\\F026A"; }

.mdi-format-font::before {
  content: "\\F06D6"; }

.mdi-format-font-size-decrease::before {
  content: "\\F09F3"; }

.mdi-format-font-size-increase::before {
  content: "\\F09F4"; }

.mdi-format-header-1::before {
  content: "\\F026B"; }

.mdi-format-header-2::before {
  content: "\\F026C"; }

.mdi-format-header-3::before {
  content: "\\F026D"; }

.mdi-format-header-4::before {
  content: "\\F026E"; }

.mdi-format-header-5::before {
  content: "\\F026F"; }

.mdi-format-header-6::before {
  content: "\\F0270"; }

.mdi-format-header-decrease::before {
  content: "\\F0271"; }

.mdi-format-header-equal::before {
  content: "\\F0272"; }

.mdi-format-header-increase::before {
  content: "\\F0273"; }

.mdi-format-header-pound::before {
  content: "\\F0274"; }

.mdi-format-horizontal-align-center::before {
  content: "\\F061E"; }

.mdi-format-horizontal-align-left::before {
  content: "\\F061F"; }

.mdi-format-horizontal-align-right::before {
  content: "\\F0620"; }

.mdi-format-indent-decrease::before {
  content: "\\F0275"; }

.mdi-format-indent-increase::before {
  content: "\\F0276"; }

.mdi-format-italic::before {
  content: "\\F0277"; }

.mdi-format-letter-case::before {
  content: "\\F0B34"; }

.mdi-format-letter-case-lower::before {
  content: "\\F0B35"; }

.mdi-format-letter-case-upper::before {
  content: "\\F0B36"; }

.mdi-format-letter-ends-with::before {
  content: "\\F0FB8"; }

.mdi-format-letter-matches::before {
  content: "\\F0FB9"; }

.mdi-format-letter-starts-with::before {
  content: "\\F0FBA"; }

.mdi-format-line-spacing::before {
  content: "\\F0278"; }

.mdi-format-line-style::before {
  content: "\\F05C8"; }

.mdi-format-line-weight::before {
  content: "\\F05C9"; }

.mdi-format-list-bulleted::before {
  content: "\\F0279"; }

.mdi-format-list-bulleted-square::before {
  content: "\\F0DD0"; }

.mdi-format-list-bulleted-triangle::before {
  content: "\\F0EB2"; }

.mdi-format-list-bulleted-type::before {
  content: "\\F027A"; }

.mdi-format-list-checkbox::before {
  content: "\\F096A"; }

.mdi-format-list-checks::before {
  content: "\\F0756"; }

.mdi-format-list-numbered::before {
  content: "\\F027B"; }

.mdi-format-list-numbered-rtl::before {
  content: "\\F0D0D"; }

.mdi-format-list-text::before {
  content: "\\F126F"; }

.mdi-format-overline::before {
  content: "\\F0EB3"; }

.mdi-format-page-break::before {
  content: "\\F06D7"; }

.mdi-format-paint::before {
  content: "\\F027C"; }

.mdi-format-paragraph::before {
  content: "\\F027D"; }

.mdi-format-pilcrow::before {
  content: "\\F06D8"; }

.mdi-format-quote-close::before {
  content: "\\F027E"; }

.mdi-format-quote-close-outline::before {
  content: "\\F11A8"; }

.mdi-format-quote-open::before {
  content: "\\F0757"; }

.mdi-format-quote-open-outline::before {
  content: "\\F11A7"; }

.mdi-format-rotate-90::before {
  content: "\\F06AA"; }

.mdi-format-section::before {
  content: "\\F069F"; }

.mdi-format-size::before {
  content: "\\F027F"; }

.mdi-format-strikethrough::before {
  content: "\\F0280"; }

.mdi-format-strikethrough-variant::before {
  content: "\\F0281"; }

.mdi-format-subscript::before {
  content: "\\F0282"; }

.mdi-format-superscript::before {
  content: "\\F0283"; }

.mdi-format-text::before {
  content: "\\F0284"; }

.mdi-format-text-rotation-angle-down::before {
  content: "\\F0FBB"; }

.mdi-format-text-rotation-angle-up::before {
  content: "\\F0FBC"; }

.mdi-format-text-rotation-down::before {
  content: "\\F0D73"; }

.mdi-format-text-rotation-down-vertical::before {
  content: "\\F0FBD"; }

.mdi-format-text-rotation-none::before {
  content: "\\F0D74"; }

.mdi-format-text-rotation-up::before {
  content: "\\F0FBE"; }

.mdi-format-text-rotation-vertical::before {
  content: "\\F0FBF"; }

.mdi-format-text-variant::before {
  content: "\\F0E32"; }

.mdi-format-text-variant-outline::before {
  content: "\\F150F"; }

.mdi-format-text-wrapping-clip::before {
  content: "\\F0D0E"; }

.mdi-format-text-wrapping-overflow::before {
  content: "\\F0D0F"; }

.mdi-format-text-wrapping-wrap::before {
  content: "\\F0D10"; }

.mdi-format-textbox::before {
  content: "\\F0D11"; }

.mdi-format-textdirection-l-to-r::before {
  content: "\\F0285"; }

.mdi-format-textdirection-r-to-l::before {
  content: "\\F0286"; }

.mdi-format-title::before {
  content: "\\F05F4"; }

.mdi-format-underline::before {
  content: "\\F0287"; }

.mdi-format-vertical-align-bottom::before {
  content: "\\F0621"; }

.mdi-format-vertical-align-center::before {
  content: "\\F0622"; }

.mdi-format-vertical-align-top::before {
  content: "\\F0623"; }

.mdi-format-wrap-inline::before {
  content: "\\F0288"; }

.mdi-format-wrap-square::before {
  content: "\\F0289"; }

.mdi-format-wrap-tight::before {
  content: "\\F028A"; }

.mdi-format-wrap-top-bottom::before {
  content: "\\F028B"; }

.mdi-forum::before {
  content: "\\F028C"; }

.mdi-forum-outline::before {
  content: "\\F0822"; }

.mdi-forward::before {
  content: "\\F028D"; }

.mdi-forwardburger::before {
  content: "\\F0D75"; }

.mdi-fountain::before {
  content: "\\F096B"; }

.mdi-fountain-pen::before {
  content: "\\F0D12"; }

.mdi-fountain-pen-tip::before {
  content: "\\F0D13"; }

.mdi-freebsd::before {
  content: "\\F08E0"; }

.mdi-frequently-asked-questions::before {
  content: "\\F0EB4"; }

.mdi-fridge::before {
  content: "\\F0290"; }

.mdi-fridge-alert::before {
  content: "\\F11B1"; }

.mdi-fridge-alert-outline::before {
  content: "\\F11B2"; }

.mdi-fridge-bottom::before {
  content: "\\F0292"; }

.mdi-fridge-industrial::before {
  content: "\\F15EE"; }

.mdi-fridge-industrial-alert::before {
  content: "\\F15EF"; }

.mdi-fridge-industrial-alert-outline::before {
  content: "\\F15F0"; }

.mdi-fridge-industrial-off::before {
  content: "\\F15F1"; }

.mdi-fridge-industrial-off-outline::before {
  content: "\\F15F2"; }

.mdi-fridge-industrial-outline::before {
  content: "\\F15F3"; }

.mdi-fridge-off::before {
  content: "\\F11AF"; }

.mdi-fridge-off-outline::before {
  content: "\\F11B0"; }

.mdi-fridge-outline::before {
  content: "\\F028F"; }

.mdi-fridge-top::before {
  content: "\\F0291"; }

.mdi-fridge-variant::before {
  content: "\\F15F4"; }

.mdi-fridge-variant-alert::before {
  content: "\\F15F5"; }

.mdi-fridge-variant-alert-outline::before {
  content: "\\F15F6"; }

.mdi-fridge-variant-off::before {
  content: "\\F15F7"; }

.mdi-fridge-variant-off-outline::before {
  content: "\\F15F8"; }

.mdi-fridge-variant-outline::before {
  content: "\\F15F9"; }

.mdi-fruit-cherries::before {
  content: "\\F1042"; }

.mdi-fruit-cherries-off::before {
  content: "\\F13F8"; }

.mdi-fruit-citrus::before {
  content: "\\F1043"; }

.mdi-fruit-citrus-off::before {
  content: "\\F13F9"; }

.mdi-fruit-grapes::before {
  content: "\\F1044"; }

.mdi-fruit-grapes-outline::before {
  content: "\\F1045"; }

.mdi-fruit-pineapple::before {
  content: "\\F1046"; }

.mdi-fruit-watermelon::before {
  content: "\\F1047"; }

.mdi-fuel::before {
  content: "\\F07CA"; }

.mdi-fullscreen::before {
  content: "\\F0293"; }

.mdi-fullscreen-exit::before {
  content: "\\F0294"; }

.mdi-function::before {
  content: "\\F0295"; }

.mdi-function-variant::before {
  content: "\\F0871"; }

.mdi-furigana-horizontal::before {
  content: "\\F1081"; }

.mdi-furigana-vertical::before {
  content: "\\F1082"; }

.mdi-fuse::before {
  content: "\\F0C85"; }

.mdi-fuse-alert::before {
  content: "\\F142D"; }

.mdi-fuse-blade::before {
  content: "\\F0C86"; }

.mdi-fuse-off::before {
  content: "\\F142C"; }

.mdi-gamepad::before {
  content: "\\F0296"; }

.mdi-gamepad-circle::before {
  content: "\\F0E33"; }

.mdi-gamepad-circle-down::before {
  content: "\\F0E34"; }

.mdi-gamepad-circle-left::before {
  content: "\\F0E35"; }

.mdi-gamepad-circle-outline::before {
  content: "\\F0E36"; }

.mdi-gamepad-circle-right::before {
  content: "\\F0E37"; }

.mdi-gamepad-circle-up::before {
  content: "\\F0E38"; }

.mdi-gamepad-down::before {
  content: "\\F0E39"; }

.mdi-gamepad-left::before {
  content: "\\F0E3A"; }

.mdi-gamepad-right::before {
  content: "\\F0E3B"; }

.mdi-gamepad-round::before {
  content: "\\F0E3C"; }

.mdi-gamepad-round-down::before {
  content: "\\F0E3D"; }

.mdi-gamepad-round-left::before {
  content: "\\F0E3E"; }

.mdi-gamepad-round-outline::before {
  content: "\\F0E3F"; }

.mdi-gamepad-round-right::before {
  content: "\\F0E40"; }

.mdi-gamepad-round-up::before {
  content: "\\F0E41"; }

.mdi-gamepad-square::before {
  content: "\\F0EB5"; }

.mdi-gamepad-square-outline::before {
  content: "\\F0EB6"; }

.mdi-gamepad-up::before {
  content: "\\F0E42"; }

.mdi-gamepad-variant::before {
  content: "\\F0297"; }

.mdi-gamepad-variant-outline::before {
  content: "\\F0EB7"; }

.mdi-gamma::before {
  content: "\\F10EE"; }

.mdi-gantry-crane::before {
  content: "\\F0DD1"; }

.mdi-garage::before {
  content: "\\F06D9"; }

.mdi-garage-alert::before {
  content: "\\F0872"; }

.mdi-garage-alert-variant::before {
  content: "\\F12D5"; }

.mdi-garage-open::before {
  content: "\\F06DA"; }

.mdi-garage-open-variant::before {
  content: "\\F12D4"; }

.mdi-garage-variant::before {
  content: "\\F12D3"; }

.mdi-gas-cylinder::before {
  content: "\\F0647"; }

.mdi-gas-station::before {
  content: "\\F0298"; }

.mdi-gas-station-off::before {
  content: "\\F1409"; }

.mdi-gas-station-off-outline::before {
  content: "\\F140A"; }

.mdi-gas-station-outline::before {
  content: "\\F0EB8"; }

.mdi-gate::before {
  content: "\\F0299"; }

.mdi-gate-and::before {
  content: "\\F08E1"; }

.mdi-gate-arrow-right::before {
  content: "\\F1169"; }

.mdi-gate-nand::before {
  content: "\\F08E2"; }

.mdi-gate-nor::before {
  content: "\\F08E3"; }

.mdi-gate-not::before {
  content: "\\F08E4"; }

.mdi-gate-open::before {
  content: "\\F116A"; }

.mdi-gate-or::before {
  content: "\\F08E5"; }

.mdi-gate-xnor::before {
  content: "\\F08E6"; }

.mdi-gate-xor::before {
  content: "\\F08E7"; }

.mdi-gatsby::before {
  content: "\\F0E43"; }

.mdi-gauge::before {
  content: "\\F029A"; }

.mdi-gauge-empty::before {
  content: "\\F0873"; }

.mdi-gauge-full::before {
  content: "\\F0874"; }

.mdi-gauge-low::before {
  content: "\\F0875"; }

.mdi-gavel::before {
  content: "\\F029B"; }

.mdi-gender-female::before {
  content: "\\F029C"; }

.mdi-gender-male::before {
  content: "\\F029D"; }

.mdi-gender-male-female::before {
  content: "\\F029E"; }

.mdi-gender-male-female-variant::before {
  content: "\\F113F"; }

.mdi-gender-non-binary::before {
  content: "\\F1140"; }

.mdi-gender-transgender::before {
  content: "\\F029F"; }

.mdi-gentoo::before {
  content: "\\F08E8"; }

.mdi-gesture::before {
  content: "\\F07CB"; }

.mdi-gesture-double-tap::before {
  content: "\\F073C"; }

.mdi-gesture-pinch::before {
  content: "\\F0ABD"; }

.mdi-gesture-spread::before {
  content: "\\F0ABE"; }

.mdi-gesture-swipe::before {
  content: "\\F0D76"; }

.mdi-gesture-swipe-down::before {
  content: "\\F073D"; }

.mdi-gesture-swipe-horizontal::before {
  content: "\\F0ABF"; }

.mdi-gesture-swipe-left::before {
  content: "\\F073E"; }

.mdi-gesture-swipe-right::before {
  content: "\\F073F"; }

.mdi-gesture-swipe-up::before {
  content: "\\F0740"; }

.mdi-gesture-swipe-vertical::before {
  content: "\\F0AC0"; }

.mdi-gesture-tap::before {
  content: "\\F0741"; }

.mdi-gesture-tap-box::before {
  content: "\\F12A9"; }

.mdi-gesture-tap-button::before {
  content: "\\F12A8"; }

.mdi-gesture-tap-hold::before {
  content: "\\F0D77"; }

.mdi-gesture-two-double-tap::before {
  content: "\\F0742"; }

.mdi-gesture-two-tap::before {
  content: "\\F0743"; }

.mdi-ghost::before {
  content: "\\F02A0"; }

.mdi-ghost-off::before {
  content: "\\F09F5"; }

.mdi-ghost-off-outline::before {
  content: "\\F165C"; }

.mdi-ghost-outline::before {
  content: "\\F165D"; }

.mdi-gif::before {
  content: "\\F0D78"; }

.mdi-gift::before {
  content: "\\F0E44"; }

.mdi-gift-off::before {
  content: "\\F16EF"; }

.mdi-gift-off-outline::before {
  content: "\\F16F0"; }

.mdi-gift-open::before {
  content: "\\F16F1"; }

.mdi-gift-open-outline::before {
  content: "\\F16F2"; }

.mdi-gift-outline::before {
  content: "\\F02A1"; }

.mdi-git::before {
  content: "\\F02A2"; }

.mdi-github::before {
  content: "\\F02A4"; }

.mdi-gitlab::before {
  content: "\\F0BA0"; }

.mdi-glass-cocktail::before {
  content: "\\F0356"; }

.mdi-glass-cocktail-off::before {
  content: "\\F15E6"; }

.mdi-glass-flute::before {
  content: "\\F02A5"; }

.mdi-glass-mug::before {
  content: "\\F02A6"; }

.mdi-glass-mug-off::before {
  content: "\\F15E7"; }

.mdi-glass-mug-variant::before {
  content: "\\F1116"; }

.mdi-glass-mug-variant-off::before {
  content: "\\F15E8"; }

.mdi-glass-pint-outline::before {
  content: "\\F130D"; }

.mdi-glass-stange::before {
  content: "\\F02A7"; }

.mdi-glass-tulip::before {
  content: "\\F02A8"; }

.mdi-glass-wine::before {
  content: "\\F0876"; }

.mdi-glasses::before {
  content: "\\F02AA"; }

.mdi-globe-light::before {
  content: "\\F12D7"; }

.mdi-globe-model::before {
  content: "\\F08E9"; }

.mdi-gmail::before {
  content: "\\F02AB"; }

.mdi-gnome::before {
  content: "\\F02AC"; }

.mdi-go-kart::before {
  content: "\\F0D79"; }

.mdi-go-kart-track::before {
  content: "\\F0D7A"; }

.mdi-gog::before {
  content: "\\F0BA1"; }

.mdi-gold::before {
  content: "\\F124F"; }

.mdi-golf::before {
  content: "\\F0823"; }

.mdi-golf-cart::before {
  content: "\\F11A4"; }

.mdi-golf-tee::before {
  content: "\\F1083"; }

.mdi-gondola::before {
  content: "\\F0686"; }

.mdi-goodreads::before {
  content: "\\F0D7B"; }

.mdi-google::before {
  content: "\\F02AD"; }

.mdi-google-ads::before {
  content: "\\F0C87"; }

.mdi-google-analytics::before {
  content: "\\F07CC"; }

.mdi-google-assistant::before {
  content: "\\F07CD"; }

.mdi-google-cardboard::before {
  content: "\\F02AE"; }

.mdi-google-chrome::before {
  content: "\\F02AF"; }

.mdi-google-circles::before {
  content: "\\F02B0"; }

.mdi-google-circles-communities::before {
  content: "\\F02B1"; }

.mdi-google-circles-extended::before {
  content: "\\F02B2"; }

.mdi-google-circles-group::before {
  content: "\\F02B3"; }

.mdi-google-classroom::before {
  content: "\\F02C0"; }

.mdi-google-cloud::before {
  content: "\\F11F6"; }

.mdi-google-controller::before {
  content: "\\F02B4"; }

.mdi-google-controller-off::before {
  content: "\\F02B5"; }

.mdi-google-downasaur::before {
  content: "\\F1362"; }

.mdi-google-drive::before {
  content: "\\F02B6"; }

.mdi-google-earth::before {
  content: "\\F02B7"; }

.mdi-google-fit::before {
  content: "\\F096C"; }

.mdi-google-glass::before {
  content: "\\F02B8"; }

.mdi-google-hangouts::before {
  content: "\\F02C9"; }

.mdi-google-home::before {
  content: "\\F0824"; }

.mdi-google-keep::before {
  content: "\\F06DC"; }

.mdi-google-lens::before {
  content: "\\F09F6"; }

.mdi-google-maps::before {
  content: "\\F05F5"; }

.mdi-google-my-business::before {
  content: "\\F1048"; }

.mdi-google-nearby::before {
  content: "\\F02B9"; }

.mdi-google-photos::before {
  content: "\\F06DD"; }

.mdi-google-play::before {
  content: "\\F02BC"; }

.mdi-google-plus::before {
  content: "\\F02BD"; }

.mdi-google-podcast::before {
  content: "\\F0EB9"; }

.mdi-google-spreadsheet::before {
  content: "\\F09F7"; }

.mdi-google-street-view::before {
  content: "\\F0C88"; }

.mdi-google-translate::before {
  content: "\\F02BF"; }

.mdi-gradient::before {
  content: "\\F06A0"; }

.mdi-grain::before {
  content: "\\F0D7C"; }

.mdi-graph::before {
  content: "\\F1049"; }

.mdi-graph-outline::before {
  content: "\\F104A"; }

.mdi-graphql::before {
  content: "\\F0877"; }

.mdi-grass::before {
  content: "\\F1510"; }

.mdi-grave-stone::before {
  content: "\\F0BA2"; }

.mdi-grease-pencil::before {
  content: "\\F0648"; }

.mdi-greater-than::before {
  content: "\\F096D"; }

.mdi-greater-than-or-equal::before {
  content: "\\F096E"; }

.mdi-grid::before {
  content: "\\F02C1"; }

.mdi-grid-large::before {
  content: "\\F0758"; }

.mdi-grid-off::before {
  content: "\\F02C2"; }

.mdi-grill::before {
  content: "\\F0E45"; }

.mdi-grill-outline::before {
  content: "\\F118A"; }

.mdi-group::before {
  content: "\\F02C3"; }

.mdi-guitar-acoustic::before {
  content: "\\F0771"; }

.mdi-guitar-electric::before {
  content: "\\F02C4"; }

.mdi-guitar-pick::before {
  content: "\\F02C5"; }

.mdi-guitar-pick-outline::before {
  content: "\\F02C6"; }

.mdi-guy-fawkes-mask::before {
  content: "\\F0825"; }

.mdi-hail::before {
  content: "\\F0AC1"; }

.mdi-hair-dryer::before {
  content: "\\F10EF"; }

.mdi-hair-dryer-outline::before {
  content: "\\F10F0"; }

.mdi-halloween::before {
  content: "\\F0BA3"; }

.mdi-hamburger::before {
  content: "\\F0685"; }

.mdi-hammer::before {
  content: "\\F08EA"; }

.mdi-hammer-screwdriver::before {
  content: "\\F1322"; }

.mdi-hammer-wrench::before {
  content: "\\F1323"; }

.mdi-hand::before {
  content: "\\F0A4F"; }

.mdi-hand-heart::before {
  content: "\\F10F1"; }

.mdi-hand-heart-outline::before {
  content: "\\F157E"; }

.mdi-hand-left::before {
  content: "\\F0E46"; }

.mdi-hand-okay::before {
  content: "\\F0A50"; }

.mdi-hand-peace::before {
  content: "\\F0A51"; }

.mdi-hand-peace-variant::before {
  content: "\\F0A52"; }

.mdi-hand-pointing-down::before {
  content: "\\F0A53"; }

.mdi-hand-pointing-left::before {
  content: "\\F0A54"; }

.mdi-hand-pointing-right::before {
  content: "\\F02C7"; }

.mdi-hand-pointing-up::before {
  content: "\\F0A55"; }

.mdi-hand-right::before {
  content: "\\F0E47"; }

.mdi-hand-saw::before {
  content: "\\F0E48"; }

.mdi-hand-wash::before {
  content: "\\F157F"; }

.mdi-hand-wash-outline::before {
  content: "\\F1580"; }

.mdi-hand-water::before {
  content: "\\F139F"; }

.mdi-handball::before {
  content: "\\F0F53"; }

.mdi-handcuffs::before {
  content: "\\F113E"; }

.mdi-handshake::before {
  content: "\\F1218"; }

.mdi-handshake-outline::before {
  content: "\\F15A1"; }

.mdi-hanger::before {
  content: "\\F02C8"; }

.mdi-hard-hat::before {
  content: "\\F096F"; }

.mdi-harddisk::before {
  content: "\\F02CA"; }

.mdi-harddisk-plus::before {
  content: "\\F104B"; }

.mdi-harddisk-remove::before {
  content: "\\F104C"; }

.mdi-hat-fedora::before {
  content: "\\F0BA4"; }

.mdi-hazard-lights::before {
  content: "\\F0C89"; }

.mdi-hdr::before {
  content: "\\F0D7D"; }

.mdi-hdr-off::before {
  content: "\\F0D7E"; }

.mdi-head::before {
  content: "\\F135E"; }

.mdi-head-alert::before {
  content: "\\F1338"; }

.mdi-head-alert-outline::before {
  content: "\\F1339"; }

.mdi-head-check::before {
  content: "\\F133A"; }

.mdi-head-check-outline::before {
  content: "\\F133B"; }

.mdi-head-cog::before {
  content: "\\F133C"; }

.mdi-head-cog-outline::before {
  content: "\\F133D"; }

.mdi-head-dots-horizontal::before {
  content: "\\F133E"; }

.mdi-head-dots-horizontal-outline::before {
  content: "\\F133F"; }

.mdi-head-flash::before {
  content: "\\F1340"; }

.mdi-head-flash-outline::before {
  content: "\\F1341"; }

.mdi-head-heart::before {
  content: "\\F1342"; }

.mdi-head-heart-outline::before {
  content: "\\F1343"; }

.mdi-head-lightbulb::before {
  content: "\\F1344"; }

.mdi-head-lightbulb-outline::before {
  content: "\\F1345"; }

.mdi-head-minus::before {
  content: "\\F1346"; }

.mdi-head-minus-outline::before {
  content: "\\F1347"; }

.mdi-head-outline::before {
  content: "\\F135F"; }

.mdi-head-plus::before {
  content: "\\F1348"; }

.mdi-head-plus-outline::before {
  content: "\\F1349"; }

.mdi-head-question::before {
  content: "\\F134A"; }

.mdi-head-question-outline::before {
  content: "\\F134B"; }

.mdi-head-remove::before {
  content: "\\F134C"; }

.mdi-head-remove-outline::before {
  content: "\\F134D"; }

.mdi-head-snowflake::before {
  content: "\\F134E"; }

.mdi-head-snowflake-outline::before {
  content: "\\F134F"; }

.mdi-head-sync::before {
  content: "\\F1350"; }

.mdi-head-sync-outline::before {
  content: "\\F1351"; }

.mdi-headphones::before {
  content: "\\F02CB"; }

.mdi-headphones-bluetooth::before {
  content: "\\F0970"; }

.mdi-headphones-box::before {
  content: "\\F02CC"; }

.mdi-headphones-off::before {
  content: "\\F07CE"; }

.mdi-headphones-settings::before {
  content: "\\F02CD"; }

.mdi-headset::before {
  content: "\\F02CE"; }

.mdi-headset-dock::before {
  content: "\\F02CF"; }

.mdi-headset-off::before {
  content: "\\F02D0"; }

.mdi-heart::before {
  content: "\\F02D1"; }

.mdi-heart-box::before {
  content: "\\F02D2"; }

.mdi-heart-box-outline::before {
  content: "\\F02D3"; }

.mdi-heart-broken::before {
  content: "\\F02D4"; }

.mdi-heart-broken-outline::before {
  content: "\\F0D14"; }

.mdi-heart-circle::before {
  content: "\\F0971"; }

.mdi-heart-circle-outline::before {
  content: "\\F0972"; }

.mdi-heart-cog::before {
  content: "\\F1663"; }

.mdi-heart-cog-outline::before {
  content: "\\F1664"; }

.mdi-heart-flash::before {
  content: "\\F0EF9"; }

.mdi-heart-half::before {
  content: "\\F06DF"; }

.mdi-heart-half-full::before {
  content: "\\F06DE"; }

.mdi-heart-half-outline::before {
  content: "\\F06E0"; }

.mdi-heart-minus::before {
  content: "\\F142F"; }

.mdi-heart-minus-outline::before {
  content: "\\F1432"; }

.mdi-heart-multiple::before {
  content: "\\F0A56"; }

.mdi-heart-multiple-outline::before {
  content: "\\F0A57"; }

.mdi-heart-off::before {
  content: "\\F0759"; }

.mdi-heart-off-outline::before {
  content: "\\F1434"; }

.mdi-heart-outline::before {
  content: "\\F02D5"; }

.mdi-heart-plus::before {
  content: "\\F142E"; }

.mdi-heart-plus-outline::before {
  content: "\\F1431"; }

.mdi-heart-pulse::before {
  content: "\\F05F6"; }

.mdi-heart-remove::before {
  content: "\\F1430"; }

.mdi-heart-remove-outline::before {
  content: "\\F1433"; }

.mdi-heart-settings::before {
  content: "\\F1665"; }

.mdi-heart-settings-outline::before {
  content: "\\F1666"; }

.mdi-helicopter::before {
  content: "\\F0AC2"; }

.mdi-help::before {
  content: "\\F02D6"; }

.mdi-help-box::before {
  content: "\\F078B"; }

.mdi-help-circle::before {
  content: "\\F02D7"; }

.mdi-help-circle-outline::before {
  content: "\\F0625"; }

.mdi-help-network::before {
  content: "\\F06F5"; }

.mdi-help-network-outline::before {
  content: "\\F0C8A"; }

.mdi-help-rhombus::before {
  content: "\\F0BA5"; }

.mdi-help-rhombus-outline::before {
  content: "\\F0BA6"; }

.mdi-hexadecimal::before {
  content: "\\F12A7"; }

.mdi-hexagon::before {
  content: "\\F02D8"; }

.mdi-hexagon-multiple::before {
  content: "\\F06E1"; }

.mdi-hexagon-multiple-outline::before {
  content: "\\F10F2"; }

.mdi-hexagon-outline::before {
  content: "\\F02D9"; }

.mdi-hexagon-slice-1::before {
  content: "\\F0AC3"; }

.mdi-hexagon-slice-2::before {
  content: "\\F0AC4"; }

.mdi-hexagon-slice-3::before {
  content: "\\F0AC5"; }

.mdi-hexagon-slice-4::before {
  content: "\\F0AC6"; }

.mdi-hexagon-slice-5::before {
  content: "\\F0AC7"; }

.mdi-hexagon-slice-6::before {
  content: "\\F0AC8"; }

.mdi-hexagram::before {
  content: "\\F0AC9"; }

.mdi-hexagram-outline::before {
  content: "\\F0ACA"; }

.mdi-high-definition::before {
  content: "\\F07CF"; }

.mdi-high-definition-box::before {
  content: "\\F0878"; }

.mdi-highway::before {
  content: "\\F05F7"; }

.mdi-hiking::before {
  content: "\\F0D7F"; }

.mdi-hinduism::before {
  content: "\\F0973"; }

.mdi-history::before {
  content: "\\F02DA"; }

.mdi-hockey-puck::before {
  content: "\\F0879"; }

.mdi-hockey-sticks::before {
  content: "\\F087A"; }

.mdi-hololens::before {
  content: "\\F02DB"; }

.mdi-home::before {
  content: "\\F02DC"; }

.mdi-home-account::before {
  content: "\\F0826"; }

.mdi-home-alert::before {
  content: "\\F087B"; }

.mdi-home-alert-outline::before {
  content: "\\F15D0"; }

.mdi-home-analytics::before {
  content: "\\F0EBA"; }

.mdi-home-assistant::before {
  content: "\\F07D0"; }

.mdi-home-automation::before {
  content: "\\F07D1"; }

.mdi-home-circle::before {
  content: "\\F07D2"; }

.mdi-home-circle-outline::before {
  content: "\\F104D"; }

.mdi-home-city::before {
  content: "\\F0D15"; }

.mdi-home-city-outline::before {
  content: "\\F0D16"; }

.mdi-home-currency-usd::before {
  content: "\\F08AF"; }

.mdi-home-edit::before {
  content: "\\F1159"; }

.mdi-home-edit-outline::before {
  content: "\\F115A"; }

.mdi-home-export-outline::before {
  content: "\\F0F9B"; }

.mdi-home-flood::before {
  content: "\\F0EFA"; }

.mdi-home-floor-0::before {
  content: "\\F0DD2"; }

.mdi-home-floor-1::before {
  content: "\\F0D80"; }

.mdi-home-floor-2::before {
  content: "\\F0D81"; }

.mdi-home-floor-3::before {
  content: "\\F0D82"; }

.mdi-home-floor-a::before {
  content: "\\F0D83"; }

.mdi-home-floor-b::before {
  content: "\\F0D84"; }

.mdi-home-floor-g::before {
  content: "\\F0D85"; }

.mdi-home-floor-l::before {
  content: "\\F0D86"; }

.mdi-home-floor-negative-1::before {
  content: "\\F0DD3"; }

.mdi-home-group::before {
  content: "\\F0DD4"; }

.mdi-home-heart::before {
  content: "\\F0827"; }

.mdi-home-import-outline::before {
  content: "\\F0F9C"; }

.mdi-home-lightbulb::before {
  content: "\\F1251"; }

.mdi-home-lightbulb-outline::before {
  content: "\\F1252"; }

.mdi-home-lock::before {
  content: "\\F08EB"; }

.mdi-home-lock-open::before {
  content: "\\F08EC"; }

.mdi-home-map-marker::before {
  content: "\\F05F8"; }

.mdi-home-minus::before {
  content: "\\F0974"; }

.mdi-home-minus-outline::before {
  content: "\\F13D5"; }

.mdi-home-modern::before {
  content: "\\F02DD"; }

.mdi-home-outline::before {
  content: "\\F06A1"; }

.mdi-home-plus::before {
  content: "\\F0975"; }

.mdi-home-plus-outline::before {
  content: "\\F13D6"; }

.mdi-home-remove::before {
  content: "\\F1247"; }

.mdi-home-remove-outline::before {
  content: "\\F13D7"; }

.mdi-home-roof::before {
  content: "\\F112B"; }

.mdi-home-search::before {
  content: "\\F13B0"; }

.mdi-home-search-outline::before {
  content: "\\F13B1"; }

.mdi-home-thermometer::before {
  content: "\\F0F54"; }

.mdi-home-thermometer-outline::before {
  content: "\\F0F55"; }

.mdi-home-variant::before {
  content: "\\F02DE"; }

.mdi-home-variant-outline::before {
  content: "\\F0BA7"; }

.mdi-hook::before {
  content: "\\F06E2"; }

.mdi-hook-off::before {
  content: "\\F06E3"; }

.mdi-hops::before {
  content: "\\F02DF"; }

.mdi-horizontal-rotate-clockwise::before {
  content: "\\F10F3"; }

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\F10F4"; }

.mdi-horse::before {
  content: "\\F15BF"; }

.mdi-horse-human::before {
  content: "\\F15C0"; }

.mdi-horse-variant::before {
  content: "\\F15C1"; }

.mdi-horseshoe::before {
  content: "\\F0A58"; }

.mdi-hospital::before {
  content: "\\F0FF6"; }

.mdi-hospital-box::before {
  content: "\\F02E0"; }

.mdi-hospital-box-outline::before {
  content: "\\F0FF7"; }

.mdi-hospital-building::before {
  content: "\\F02E1"; }

.mdi-hospital-marker::before {
  content: "\\F02E2"; }

.mdi-hot-tub::before {
  content: "\\F0828"; }

.mdi-hours-24::before {
  content: "\\F1478"; }

.mdi-hubspot::before {
  content: "\\F0D17"; }

.mdi-hulu::before {
  content: "\\F0829"; }

.mdi-human::before {
  content: "\\F02E6"; }

.mdi-human-baby-changing-table::before {
  content: "\\F138B"; }

.mdi-human-cane::before {
  content: "\\F1581"; }

.mdi-human-capacity-decrease::before {
  content: "\\F159B"; }

.mdi-human-capacity-increase::before {
  content: "\\F159C"; }

.mdi-human-child::before {
  content: "\\F02E7"; }

.mdi-human-edit::before {
  content: "\\F14E8"; }

.mdi-human-female::before {
  content: "\\F0649"; }

.mdi-human-female-boy::before {
  content: "\\F0A59"; }

.mdi-human-female-dance::before {
  content: "\\F15C9"; }

.mdi-human-female-female::before {
  content: "\\F0A5A"; }

.mdi-human-female-girl::before {
  content: "\\F0A5B"; }

.mdi-human-greeting::before {
  content: "\\F064A"; }

.mdi-human-greeting-proximity::before {
  content: "\\F159D"; }

.mdi-human-handsdown::before {
  content: "\\F064B"; }

.mdi-human-handsup::before {
  content: "\\F064C"; }

.mdi-human-male::before {
  content: "\\F064D"; }

.mdi-human-male-boy::before {
  content: "\\F0A5C"; }

.mdi-human-male-child::before {
  content: "\\F138C"; }

.mdi-human-male-female::before {
  content: "\\F02E8"; }

.mdi-human-male-girl::before {
  content: "\\F0A5D"; }

.mdi-human-male-height::before {
  content: "\\F0EFB"; }

.mdi-human-male-height-variant::before {
  content: "\\F0EFC"; }

.mdi-human-male-male::before {
  content: "\\F0A5E"; }

.mdi-human-pregnant::before {
  content: "\\F05CF"; }

.mdi-human-queue::before {
  content: "\\F1571"; }

.mdi-human-scooter::before {
  content: "\\F11E9"; }

.mdi-human-wheelchair::before {
  content: "\\F138D"; }

.mdi-humble-bundle::before {
  content: "\\F0744"; }

.mdi-hvac::before {
  content: "\\F1352"; }

.mdi-hvac-off::before {
  content: "\\F159E"; }

.mdi-hydraulic-oil-level::before {
  content: "\\F1324"; }

.mdi-hydraulic-oil-temperature::before {
  content: "\\F1325"; }

.mdi-hydro-power::before {
  content: "\\F12E5"; }

.mdi-ice-cream::before {
  content: "\\F082A"; }

.mdi-ice-cream-off::before {
  content: "\\F0E52"; }

.mdi-ice-pop::before {
  content: "\\F0EFD"; }

.mdi-id-card::before {
  content: "\\F0FC0"; }

.mdi-identifier::before {
  content: "\\F0EFE"; }

.mdi-ideogram-cjk::before {
  content: "\\F1331"; }

.mdi-ideogram-cjk-variant::before {
  content: "\\F1332"; }

.mdi-iframe::before {
  content: "\\F0C8B"; }

.mdi-iframe-array::before {
  content: "\\F10F5"; }

.mdi-iframe-array-outline::before {
  content: "\\F10F6"; }

.mdi-iframe-braces::before {
  content: "\\F10F7"; }

.mdi-iframe-braces-outline::before {
  content: "\\F10F8"; }

.mdi-iframe-outline::before {
  content: "\\F0C8C"; }

.mdi-iframe-parentheses::before {
  content: "\\F10F9"; }

.mdi-iframe-parentheses-outline::before {
  content: "\\F10FA"; }

.mdi-iframe-variable::before {
  content: "\\F10FB"; }

.mdi-iframe-variable-outline::before {
  content: "\\F10FC"; }

.mdi-image::before {
  content: "\\F02E9"; }

.mdi-image-album::before {
  content: "\\F02EA"; }

.mdi-image-area::before {
  content: "\\F02EB"; }

.mdi-image-area-close::before {
  content: "\\F02EC"; }

.mdi-image-auto-adjust::before {
  content: "\\F0FC1"; }

.mdi-image-broken::before {
  content: "\\F02ED"; }

.mdi-image-broken-variant::before {
  content: "\\F02EE"; }

.mdi-image-edit::before {
  content: "\\F11E3"; }

.mdi-image-edit-outline::before {
  content: "\\F11E4"; }

.mdi-image-filter-black-white::before {
  content: "\\F02F0"; }

.mdi-image-filter-center-focus::before {
  content: "\\F02F1"; }

.mdi-image-filter-center-focus-strong::before {
  content: "\\F0EFF"; }

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\F0F00"; }

.mdi-image-filter-center-focus-weak::before {
  content: "\\F02F2"; }

.mdi-image-filter-drama::before {
  content: "\\F02F3"; }

.mdi-image-filter-frames::before {
  content: "\\F02F4"; }

.mdi-image-filter-hdr::before {
  content: "\\F02F5"; }

.mdi-image-filter-none::before {
  content: "\\F02F6"; }

.mdi-image-filter-tilt-shift::before {
  content: "\\F02F7"; }

.mdi-image-filter-vintage::before {
  content: "\\F02F8"; }

.mdi-image-frame::before {
  content: "\\F0E49"; }

.mdi-image-minus::before {
  content: "\\F1419"; }

.mdi-image-move::before {
  content: "\\F09F8"; }

.mdi-image-multiple::before {
  content: "\\F02F9"; }

.mdi-image-multiple-outline::before {
  content: "\\F02EF"; }

.mdi-image-off::before {
  content: "\\F082B"; }

.mdi-image-off-outline::before {
  content: "\\F11D1"; }

.mdi-image-outline::before {
  content: "\\F0976"; }

.mdi-image-plus::before {
  content: "\\F087C"; }

.mdi-image-remove::before {
  content: "\\F1418"; }

.mdi-image-search::before {
  content: "\\F0977"; }

.mdi-image-search-outline::before {
  content: "\\F0978"; }

.mdi-image-size-select-actual::before {
  content: "\\F0C8D"; }

.mdi-image-size-select-large::before {
  content: "\\F0C8E"; }

.mdi-image-size-select-small::before {
  content: "\\F0C8F"; }

.mdi-image-text::before {
  content: "\\F160D"; }

.mdi-import::before {
  content: "\\F02FA"; }

.mdi-inbox::before {
  content: "\\F0687"; }

.mdi-inbox-arrow-down::before {
  content: "\\F02FB"; }

.mdi-inbox-arrow-down-outline::before {
  content: "\\F1270"; }

.mdi-inbox-arrow-up::before {
  content: "\\F03D1"; }

.mdi-inbox-arrow-up-outline::before {
  content: "\\F1271"; }

.mdi-inbox-full::before {
  content: "\\F1272"; }

.mdi-inbox-full-outline::before {
  content: "\\F1273"; }

.mdi-inbox-multiple::before {
  content: "\\F08B0"; }

.mdi-inbox-multiple-outline::before {
  content: "\\F0BA8"; }

.mdi-inbox-outline::before {
  content: "\\F1274"; }

.mdi-inbox-remove::before {
  content: "\\F159F"; }

.mdi-inbox-remove-outline::before {
  content: "\\F15A0"; }

.mdi-incognito::before {
  content: "\\F05F9"; }

.mdi-incognito-circle::before {
  content: "\\F1421"; }

.mdi-incognito-circle-off::before {
  content: "\\F1422"; }

.mdi-incognito-off::before {
  content: "\\F0075"; }

.mdi-infinity::before {
  content: "\\F06E4"; }

.mdi-information::before {
  content: "\\F02FC"; }

.mdi-information-outline::before {
  content: "\\F02FD"; }

.mdi-information-variant::before {
  content: "\\F064E"; }

.mdi-instagram::before {
  content: "\\F02FE"; }

.mdi-instrument-triangle::before {
  content: "\\F104E"; }

.mdi-invert-colors::before {
  content: "\\F0301"; }

.mdi-invert-colors-off::before {
  content: "\\F0E4A"; }

.mdi-iobroker::before {
  content: "\\F12E8"; }

.mdi-ip::before {
  content: "\\F0A5F"; }

.mdi-ip-network::before {
  content: "\\F0A60"; }

.mdi-ip-network-outline::before {
  content: "\\F0C90"; }

.mdi-ipod::before {
  content: "\\F0C91"; }

.mdi-islam::before {
  content: "\\F0979"; }

.mdi-island::before {
  content: "\\F104F"; }

.mdi-iv-bag::before {
  content: "\\F10B9"; }

.mdi-jabber::before {
  content: "\\F0DD5"; }

.mdi-jeepney::before {
  content: "\\F0302"; }

.mdi-jellyfish::before {
  content: "\\F0F01"; }

.mdi-jellyfish-outline::before {
  content: "\\F0F02"; }

.mdi-jira::before {
  content: "\\F0303"; }

.mdi-jquery::before {
  content: "\\F087D"; }

.mdi-jsfiddle::before {
  content: "\\F0304"; }

.mdi-judaism::before {
  content: "\\F097A"; }

.mdi-jump-rope::before {
  content: "\\F12FF"; }

.mdi-kabaddi::before {
  content: "\\F0D87"; }

.mdi-kangaroo::before {
  content: "\\F1558"; }

.mdi-karate::before {
  content: "\\F082C"; }

.mdi-keg::before {
  content: "\\F0305"; }

.mdi-kettle::before {
  content: "\\F05FA"; }

.mdi-kettle-alert::before {
  content: "\\F1317"; }

.mdi-kettle-alert-outline::before {
  content: "\\F1318"; }

.mdi-kettle-off::before {
  content: "\\F131B"; }

.mdi-kettle-off-outline::before {
  content: "\\F131C"; }

.mdi-kettle-outline::before {
  content: "\\F0F56"; }

.mdi-kettle-pour-over::before {
  content: "\\F173C"; }

.mdi-kettle-steam::before {
  content: "\\F1319"; }

.mdi-kettle-steam-outline::before {
  content: "\\F131A"; }

.mdi-kettlebell::before {
  content: "\\F1300"; }

.mdi-key::before {
  content: "\\F0306"; }

.mdi-key-arrow-right::before {
  content: "\\F1312"; }

.mdi-key-chain::before {
  content: "\\F1574"; }

.mdi-key-chain-variant::before {
  content: "\\F1575"; }

.mdi-key-change::before {
  content: "\\F0307"; }

.mdi-key-link::before {
  content: "\\F119F"; }

.mdi-key-minus::before {
  content: "\\F0308"; }

.mdi-key-outline::before {
  content: "\\F0DD6"; }

.mdi-key-plus::before {
  content: "\\F0309"; }

.mdi-key-remove::before {
  content: "\\F030A"; }

.mdi-key-star::before {
  content: "\\F119E"; }

.mdi-key-variant::before {
  content: "\\F030B"; }

.mdi-key-wireless::before {
  content: "\\F0FC2"; }

.mdi-keyboard::before {
  content: "\\F030C"; }

.mdi-keyboard-backspace::before {
  content: "\\F030D"; }

.mdi-keyboard-caps::before {
  content: "\\F030E"; }

.mdi-keyboard-close::before {
  content: "\\F030F"; }

.mdi-keyboard-esc::before {
  content: "\\F12B7"; }

.mdi-keyboard-f1::before {
  content: "\\F12AB"; }

.mdi-keyboard-f10::before {
  content: "\\F12B4"; }

.mdi-keyboard-f11::before {
  content: "\\F12B5"; }

.mdi-keyboard-f12::before {
  content: "\\F12B6"; }

.mdi-keyboard-f2::before {
  content: "\\F12AC"; }

.mdi-keyboard-f3::before {
  content: "\\F12AD"; }

.mdi-keyboard-f4::before {
  content: "\\F12AE"; }

.mdi-keyboard-f5::before {
  content: "\\F12AF"; }

.mdi-keyboard-f6::before {
  content: "\\F12B0"; }

.mdi-keyboard-f7::before {
  content: "\\F12B1"; }

.mdi-keyboard-f8::before {
  content: "\\F12B2"; }

.mdi-keyboard-f9::before {
  content: "\\F12B3"; }

.mdi-keyboard-off::before {
  content: "\\F0310"; }

.mdi-keyboard-off-outline::before {
  content: "\\F0E4B"; }

.mdi-keyboard-outline::before {
  content: "\\F097B"; }

.mdi-keyboard-return::before {
  content: "\\F0311"; }

.mdi-keyboard-settings::before {
  content: "\\F09F9"; }

.mdi-keyboard-settings-outline::before {
  content: "\\F09FA"; }

.mdi-keyboard-space::before {
  content: "\\F1050"; }

.mdi-keyboard-tab::before {
  content: "\\F0312"; }

.mdi-keyboard-variant::before {
  content: "\\F0313"; }

.mdi-khanda::before {
  content: "\\F10FD"; }

.mdi-kickstarter::before {
  content: "\\F0745"; }

.mdi-klingon::before {
  content: "\\F135B"; }

.mdi-knife::before {
  content: "\\F09FB"; }

.mdi-knife-military::before {
  content: "\\F09FC"; }

.mdi-koala::before {
  content: "\\F173F"; }

.mdi-kodi::before {
  content: "\\F0314"; }

.mdi-kubernetes::before {
  content: "\\F10FE"; }

.mdi-label::before {
  content: "\\F0315"; }

.mdi-label-multiple::before {
  content: "\\F1375"; }

.mdi-label-multiple-outline::before {
  content: "\\F1376"; }

.mdi-label-off::before {
  content: "\\F0ACB"; }

.mdi-label-off-outline::before {
  content: "\\F0ACC"; }

.mdi-label-outline::before {
  content: "\\F0316"; }

.mdi-label-percent::before {
  content: "\\F12EA"; }

.mdi-label-percent-outline::before {
  content: "\\F12EB"; }

.mdi-label-variant::before {
  content: "\\F0ACD"; }

.mdi-label-variant-outline::before {
  content: "\\F0ACE"; }

.mdi-ladder::before {
  content: "\\F15A2"; }

.mdi-ladybug::before {
  content: "\\F082D"; }

.mdi-lambda::before {
  content: "\\F0627"; }

.mdi-lamp::before {
  content: "\\F06B5"; }

.mdi-lamps::before {
  content: "\\F1576"; }

.mdi-lan::before {
  content: "\\F0317"; }

.mdi-lan-check::before {
  content: "\\F12AA"; }

.mdi-lan-connect::before {
  content: "\\F0318"; }

.mdi-lan-disconnect::before {
  content: "\\F0319"; }

.mdi-lan-pending::before {
  content: "\\F031A"; }

.mdi-language-c::before {
  content: "\\F0671"; }

.mdi-language-cpp::before {
  content: "\\F0672"; }

.mdi-language-csharp::before {
  content: "\\F031B"; }

.mdi-language-css3::before {
  content: "\\F031C"; }

.mdi-language-fortran::before {
  content: "\\F121A"; }

.mdi-language-go::before {
  content: "\\F07D3"; }

.mdi-language-haskell::before {
  content: "\\F0C92"; }

.mdi-language-html5::before {
  content: "\\F031D"; }

.mdi-language-java::before {
  content: "\\F0B37"; }

.mdi-language-javascript::before {
  content: "\\F031E"; }

.mdi-language-kotlin::before {
  content: "\\F1219"; }

.mdi-language-lua::before {
  content: "\\F08B1"; }

.mdi-language-markdown::before {
  content: "\\F0354"; }

.mdi-language-markdown-outline::before {
  content: "\\F0F5B"; }

.mdi-language-php::before {
  content: "\\F031F"; }

.mdi-language-python::before {
  content: "\\F0320"; }

.mdi-language-r::before {
  content: "\\F07D4"; }

.mdi-language-ruby::before {
  content: "\\F0D2D"; }

.mdi-language-ruby-on-rails::before {
  content: "\\F0ACF"; }

.mdi-language-rust::before {
  content: "\\F1617"; }

.mdi-language-swift::before {
  content: "\\F06E5"; }

.mdi-language-typescript::before {
  content: "\\F06E6"; }

.mdi-language-xaml::before {
  content: "\\F0673"; }

.mdi-laptop::before {
  content: "\\F0322"; }

.mdi-laptop-chromebook::before {
  content: "\\F0323"; }

.mdi-laptop-mac::before {
  content: "\\F0324"; }

.mdi-laptop-off::before {
  content: "\\F06E7"; }

.mdi-laptop-windows::before {
  content: "\\F0325"; }

.mdi-laravel::before {
  content: "\\F0AD0"; }

.mdi-laser-pointer::before {
  content: "\\F1484"; }

.mdi-lasso::before {
  content: "\\F0F03"; }

.mdi-lastpass::before {
  content: "\\F0446"; }

.mdi-latitude::before {
  content: "\\F0F57"; }

.mdi-launch::before {
  content: "\\F0327"; }

.mdi-lava-lamp::before {
  content: "\\F07D5"; }

.mdi-layers::before {
  content: "\\F0328"; }

.mdi-layers-minus::before {
  content: "\\F0E4C"; }

.mdi-layers-off::before {
  content: "\\F0329"; }

.mdi-layers-off-outline::before {
  content: "\\F09FD"; }

.mdi-layers-outline::before {
  content: "\\F09FE"; }

.mdi-layers-plus::before {
  content: "\\F0E4D"; }

.mdi-layers-remove::before {
  content: "\\F0E4E"; }

.mdi-layers-search::before {
  content: "\\F1206"; }

.mdi-layers-search-outline::before {
  content: "\\F1207"; }

.mdi-layers-triple::before {
  content: "\\F0F58"; }

.mdi-layers-triple-outline::before {
  content: "\\F0F59"; }

.mdi-lead-pencil::before {
  content: "\\F064F"; }

.mdi-leaf::before {
  content: "\\F032A"; }

.mdi-leaf-maple::before {
  content: "\\F0C93"; }

.mdi-leaf-maple-off::before {
  content: "\\F12DA"; }

.mdi-leaf-off::before {
  content: "\\F12D9"; }

.mdi-leak::before {
  content: "\\F0DD7"; }

.mdi-leak-off::before {
  content: "\\F0DD8"; }

.mdi-led-off::before {
  content: "\\F032B"; }

.mdi-led-on::before {
  content: "\\F032C"; }

.mdi-led-outline::before {
  content: "\\F032D"; }

.mdi-led-strip::before {
  content: "\\F07D6"; }

.mdi-led-strip-variant::before {
  content: "\\F1051"; }

.mdi-led-variant-off::before {
  content: "\\F032E"; }

.mdi-led-variant-on::before {
  content: "\\F032F"; }

.mdi-led-variant-outline::before {
  content: "\\F0330"; }

.mdi-leek::before {
  content: "\\F117D"; }

.mdi-less-than::before {
  content: "\\F097C"; }

.mdi-less-than-or-equal::before {
  content: "\\F097D"; }

.mdi-library::before {
  content: "\\F0331"; }

.mdi-library-shelves::before {
  content: "\\F0BA9"; }

.mdi-license::before {
  content: "\\F0FC3"; }

.mdi-lifebuoy::before {
  content: "\\F087E"; }

.mdi-light-switch::before {
  content: "\\F097E"; }

.mdi-lightbulb::before {
  content: "\\F0335"; }

.mdi-lightbulb-cfl::before {
  content: "\\F1208"; }

.mdi-lightbulb-cfl-off::before {
  content: "\\F1209"; }

.mdi-lightbulb-cfl-spiral::before {
  content: "\\F1275"; }

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\F12C3"; }

.mdi-lightbulb-group::before {
  content: "\\F1253"; }

.mdi-lightbulb-group-off::before {
  content: "\\F12CD"; }

.mdi-lightbulb-group-off-outline::before {
  content: "\\F12CE"; }

.mdi-lightbulb-group-outline::before {
  content: "\\F1254"; }

.mdi-lightbulb-multiple::before {
  content: "\\F1255"; }

.mdi-lightbulb-multiple-off::before {
  content: "\\F12CF"; }

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\F12D0"; }

.mdi-lightbulb-multiple-outline::before {
  content: "\\F1256"; }

.mdi-lightbulb-off::before {
  content: "\\F0E4F"; }

.mdi-lightbulb-off-outline::before {
  content: "\\F0E50"; }

.mdi-lightbulb-on::before {
  content: "\\F06E8"; }

.mdi-lightbulb-on-outline::before {
  content: "\\F06E9"; }

.mdi-lightbulb-outline::before {
  content: "\\F0336"; }

.mdi-lighthouse::before {
  content: "\\F09FF"; }

.mdi-lighthouse-on::before {
  content: "\\F0A00"; }

.mdi-lightning-bolt::before {
  content: "\\F140B"; }

.mdi-lightning-bolt-outline::before {
  content: "\\F140C"; }

.mdi-lingerie::before {
  content: "\\F1476"; }

.mdi-link::before {
  content: "\\F0337"; }

.mdi-link-box::before {
  content: "\\F0D1A"; }

.mdi-link-box-outline::before {
  content: "\\F0D1B"; }

.mdi-link-box-variant::before {
  content: "\\F0D1C"; }

.mdi-link-box-variant-outline::before {
  content: "\\F0D1D"; }

.mdi-link-lock::before {
  content: "\\F10BA"; }

.mdi-link-off::before {
  content: "\\F0338"; }

.mdi-link-plus::before {
  content: "\\F0C94"; }

.mdi-link-variant::before {
  content: "\\F0339"; }

.mdi-link-variant-minus::before {
  content: "\\F10FF"; }

.mdi-link-variant-off::before {
  content: "\\F033A"; }

.mdi-link-variant-plus::before {
  content: "\\F1100"; }

.mdi-link-variant-remove::before {
  content: "\\F1101"; }

.mdi-linkedin::before {
  content: "\\F033B"; }

.mdi-linux::before {
  content: "\\F033D"; }

.mdi-linux-mint::before {
  content: "\\F08ED"; }

.mdi-lipstick::before {
  content: "\\F13B5"; }

.mdi-list-status::before {
  content: "\\F15AB"; }

.mdi-litecoin::before {
  content: "\\F0A61"; }

.mdi-loading::before {
  content: "\\F0772"; }

.mdi-location-enter::before {
  content: "\\F0FC4"; }

.mdi-location-exit::before {
  content: "\\F0FC5"; }

.mdi-lock::before {
  content: "\\F033E"; }

.mdi-lock-alert::before {
  content: "\\F08EE"; }

.mdi-lock-alert-outline::before {
  content: "\\F15D1"; }

.mdi-lock-check::before {
  content: "\\F139A"; }

.mdi-lock-check-outline::before {
  content: "\\F16A8"; }

.mdi-lock-clock::before {
  content: "\\F097F"; }

.mdi-lock-minus::before {
  content: "\\F16A9"; }

.mdi-lock-minus-outline::before {
  content: "\\F16AA"; }

.mdi-lock-off::before {
  content: "\\F1671"; }

.mdi-lock-off-outline::before {
  content: "\\F1672"; }

.mdi-lock-open::before {
  content: "\\F033F"; }

.mdi-lock-open-alert::before {
  content: "\\F139B"; }

.mdi-lock-open-alert-outline::before {
  content: "\\F15D2"; }

.mdi-lock-open-check::before {
  content: "\\F139C"; }

.mdi-lock-open-check-outline::before {
  content: "\\F16AB"; }

.mdi-lock-open-minus::before {
  content: "\\F16AC"; }

.mdi-lock-open-minus-outline::before {
  content: "\\F16AD"; }

.mdi-lock-open-outline::before {
  content: "\\F0340"; }

.mdi-lock-open-plus::before {
  content: "\\F16AE"; }

.mdi-lock-open-plus-outline::before {
  content: "\\F16AF"; }

.mdi-lock-open-remove::before {
  content: "\\F16B0"; }

.mdi-lock-open-remove-outline::before {
  content: "\\F16B1"; }

.mdi-lock-open-variant::before {
  content: "\\F0FC6"; }

.mdi-lock-open-variant-outline::before {
  content: "\\F0FC7"; }

.mdi-lock-outline::before {
  content: "\\F0341"; }

.mdi-lock-pattern::before {
  content: "\\F06EA"; }

.mdi-lock-plus::before {
  content: "\\F05FB"; }

.mdi-lock-plus-outline::before {
  content: "\\F16B2"; }

.mdi-lock-question::before {
  content: "\\F08EF"; }

.mdi-lock-remove::before {
  content: "\\F16B3"; }

.mdi-lock-remove-outline::before {
  content: "\\F16B4"; }

.mdi-lock-reset::before {
  content: "\\F0773"; }

.mdi-lock-smart::before {
  content: "\\F08B2"; }

.mdi-locker::before {
  content: "\\F07D7"; }

.mdi-locker-multiple::before {
  content: "\\F07D8"; }

.mdi-login::before {
  content: "\\F0342"; }

.mdi-login-variant::before {
  content: "\\F05FC"; }

.mdi-logout::before {
  content: "\\F0343"; }

.mdi-logout-variant::before {
  content: "\\F05FD"; }

.mdi-longitude::before {
  content: "\\F0F5A"; }

.mdi-looks::before {
  content: "\\F0344"; }

.mdi-lotion::before {
  content: "\\F1582"; }

.mdi-lotion-outline::before {
  content: "\\F1583"; }

.mdi-lotion-plus::before {
  content: "\\F1584"; }

.mdi-lotion-plus-outline::before {
  content: "\\F1585"; }

.mdi-loupe::before {
  content: "\\F0345"; }

.mdi-lumx::before {
  content: "\\F0346"; }

.mdi-lungs::before {
  content: "\\F1084"; }

.mdi-magnet::before {
  content: "\\F0347"; }

.mdi-magnet-on::before {
  content: "\\F0348"; }

.mdi-magnify::before {
  content: "\\F0349"; }

.mdi-magnify-close::before {
  content: "\\F0980"; }

.mdi-magnify-minus::before {
  content: "\\F034A"; }

.mdi-magnify-minus-cursor::before {
  content: "\\F0A62"; }

.mdi-magnify-minus-outline::before {
  content: "\\F06EC"; }

.mdi-magnify-plus::before {
  content: "\\F034B"; }

.mdi-magnify-plus-cursor::before {
  content: "\\F0A63"; }

.mdi-magnify-plus-outline::before {
  content: "\\F06ED"; }

.mdi-magnify-remove-cursor::before {
  content: "\\F120C"; }

.mdi-magnify-remove-outline::before {
  content: "\\F120D"; }

.mdi-magnify-scan::before {
  content: "\\F1276"; }

.mdi-mail::before {
  content: "\\F0EBB"; }

.mdi-mailbox::before {
  content: "\\F06EE"; }

.mdi-mailbox-open::before {
  content: "\\F0D88"; }

.mdi-mailbox-open-outline::before {
  content: "\\F0D89"; }

.mdi-mailbox-open-up::before {
  content: "\\F0D8A"; }

.mdi-mailbox-open-up-outline::before {
  content: "\\F0D8B"; }

.mdi-mailbox-outline::before {
  content: "\\F0D8C"; }

.mdi-mailbox-up::before {
  content: "\\F0D8D"; }

.mdi-mailbox-up-outline::before {
  content: "\\F0D8E"; }

.mdi-manjaro::before {
  content: "\\F160A"; }

.mdi-map::before {
  content: "\\F034D"; }

.mdi-map-check::before {
  content: "\\F0EBC"; }

.mdi-map-check-outline::before {
  content: "\\F0EBD"; }

.mdi-map-clock::before {
  content: "\\F0D1E"; }

.mdi-map-clock-outline::before {
  content: "\\F0D1F"; }

.mdi-map-legend::before {
  content: "\\F0A01"; }

.mdi-map-marker::before {
  content: "\\F034E"; }

.mdi-map-marker-alert::before {
  content: "\\F0F05"; }

.mdi-map-marker-alert-outline::before {
  content: "\\F0F06"; }

.mdi-map-marker-check::before {
  content: "\\F0C95"; }

.mdi-map-marker-check-outline::before {
  content: "\\F12FB"; }

.mdi-map-marker-circle::before {
  content: "\\F034F"; }

.mdi-map-marker-distance::before {
  content: "\\F08F0"; }

.mdi-map-marker-down::before {
  content: "\\F1102"; }

.mdi-map-marker-left::before {
  content: "\\F12DB"; }

.mdi-map-marker-left-outline::before {
  content: "\\F12DD"; }

.mdi-map-marker-minus::before {
  content: "\\F0650"; }

.mdi-map-marker-minus-outline::before {
  content: "\\F12F9"; }

.mdi-map-marker-multiple::before {
  content: "\\F0350"; }

.mdi-map-marker-multiple-outline::before {
  content: "\\F1277"; }

.mdi-map-marker-off::before {
  content: "\\F0351"; }

.mdi-map-marker-off-outline::before {
  content: "\\F12FD"; }

.mdi-map-marker-outline::before {
  content: "\\F07D9"; }

.mdi-map-marker-path::before {
  content: "\\F0D20"; }

.mdi-map-marker-plus::before {
  content: "\\F0651"; }

.mdi-map-marker-plus-outline::before {
  content: "\\F12F8"; }

.mdi-map-marker-question::before {
  content: "\\F0F07"; }

.mdi-map-marker-question-outline::before {
  content: "\\F0F08"; }

.mdi-map-marker-radius::before {
  content: "\\F0352"; }

.mdi-map-marker-radius-outline::before {
  content: "\\F12FC"; }

.mdi-map-marker-remove::before {
  content: "\\F0F09"; }

.mdi-map-marker-remove-outline::before {
  content: "\\F12FA"; }

.mdi-map-marker-remove-variant::before {
  content: "\\F0F0A"; }

.mdi-map-marker-right::before {
  content: "\\F12DC"; }

.mdi-map-marker-right-outline::before {
  content: "\\F12DE"; }

.mdi-map-marker-star::before {
  content: "\\F1608"; }

.mdi-map-marker-star-outline::before {
  content: "\\F1609"; }

.mdi-map-marker-up::before {
  content: "\\F1103"; }

.mdi-map-minus::before {
  content: "\\F0981"; }

.mdi-map-outline::before {
  content: "\\F0982"; }

.mdi-map-plus::before {
  content: "\\F0983"; }

.mdi-map-search::before {
  content: "\\F0984"; }

.mdi-map-search-outline::before {
  content: "\\F0985"; }

.mdi-mapbox::before {
  content: "\\F0BAA"; }

.mdi-margin::before {
  content: "\\F0353"; }

.mdi-marker::before {
  content: "\\F0652"; }

.mdi-marker-cancel::before {
  content: "\\F0DD9"; }

.mdi-marker-check::before {
  content: "\\F0355"; }

.mdi-mastodon::before {
  content: "\\F0AD1"; }

.mdi-material-design::before {
  content: "\\F0986"; }

.mdi-material-ui::before {
  content: "\\F0357"; }

.mdi-math-compass::before {
  content: "\\F0358"; }

.mdi-math-cos::before {
  content: "\\F0C96"; }

.mdi-math-integral::before {
  content: "\\F0FC8"; }

.mdi-math-integral-box::before {
  content: "\\F0FC9"; }

.mdi-math-log::before {
  content: "\\F1085"; }

.mdi-math-norm::before {
  content: "\\F0FCA"; }

.mdi-math-norm-box::before {
  content: "\\F0FCB"; }

.mdi-math-sin::before {
  content: "\\F0C97"; }

.mdi-math-tan::before {
  content: "\\F0C98"; }

.mdi-matrix::before {
  content: "\\F0628"; }

.mdi-medal::before {
  content: "\\F0987"; }

.mdi-medal-outline::before {
  content: "\\F1326"; }

.mdi-medical-bag::before {
  content: "\\F06EF"; }

.mdi-meditation::before {
  content: "\\F117B"; }

.mdi-memory::before {
  content: "\\F035B"; }

.mdi-menu::before {
  content: "\\F035C"; }

.mdi-menu-down::before {
  content: "\\F035D"; }

.mdi-menu-down-outline::before {
  content: "\\F06B6"; }

.mdi-menu-left::before {
  content: "\\F035E"; }

.mdi-menu-left-outline::before {
  content: "\\F0A02"; }

.mdi-menu-open::before {
  content: "\\F0BAB"; }

.mdi-menu-right::before {
  content: "\\F035F"; }

.mdi-menu-right-outline::before {
  content: "\\F0A03"; }

.mdi-menu-swap::before {
  content: "\\F0A64"; }

.mdi-menu-swap-outline::before {
  content: "\\F0A65"; }

.mdi-menu-up::before {
  content: "\\F0360"; }

.mdi-menu-up-outline::before {
  content: "\\F06B7"; }

.mdi-merge::before {
  content: "\\F0F5C"; }

.mdi-message::before {
  content: "\\F0361"; }

.mdi-message-alert::before {
  content: "\\F0362"; }

.mdi-message-alert-outline::before {
  content: "\\F0A04"; }

.mdi-message-arrow-left::before {
  content: "\\F12F2"; }

.mdi-message-arrow-left-outline::before {
  content: "\\F12F3"; }

.mdi-message-arrow-right::before {
  content: "\\F12F4"; }

.mdi-message-arrow-right-outline::before {
  content: "\\F12F5"; }

.mdi-message-bookmark::before {
  content: "\\F15AC"; }

.mdi-message-bookmark-outline::before {
  content: "\\F15AD"; }

.mdi-message-bulleted::before {
  content: "\\F06A2"; }

.mdi-message-bulleted-off::before {
  content: "\\F06A3"; }

.mdi-message-cog::before {
  content: "\\F06F1"; }

.mdi-message-cog-outline::before {
  content: "\\F1172"; }

.mdi-message-draw::before {
  content: "\\F0363"; }

.mdi-message-flash::before {
  content: "\\F15A9"; }

.mdi-message-flash-outline::before {
  content: "\\F15AA"; }

.mdi-message-image::before {
  content: "\\F0364"; }

.mdi-message-image-outline::before {
  content: "\\F116C"; }

.mdi-message-lock::before {
  content: "\\F0FCC"; }

.mdi-message-lock-outline::before {
  content: "\\F116D"; }

.mdi-message-minus::before {
  content: "\\F116E"; }

.mdi-message-minus-outline::before {
  content: "\\F116F"; }

.mdi-message-off::before {
  content: "\\F164D"; }

.mdi-message-off-outline::before {
  content: "\\F164E"; }

.mdi-message-outline::before {
  content: "\\F0365"; }

.mdi-message-plus::before {
  content: "\\F0653"; }

.mdi-message-plus-outline::before {
  content: "\\F10BB"; }

.mdi-message-processing::before {
  content: "\\F0366"; }

.mdi-message-processing-outline::before {
  content: "\\F1170"; }

.mdi-message-question::before {
  content: "\\F173A"; }

.mdi-message-question-outline::before {
  content: "\\F173B"; }

.mdi-message-reply::before {
  content: "\\F0367"; }

.mdi-message-reply-outline::before {
  content: "\\F173D"; }

.mdi-message-reply-text::before {
  content: "\\F0368"; }

.mdi-message-reply-text-outline::before {
  content: "\\F173E"; }

.mdi-message-settings::before {
  content: "\\F06F0"; }

.mdi-message-settings-outline::before {
  content: "\\F1171"; }

.mdi-message-text::before {
  content: "\\F0369"; }

.mdi-message-text-clock::before {
  content: "\\F1173"; }

.mdi-message-text-clock-outline::before {
  content: "\\F1174"; }

.mdi-message-text-lock::before {
  content: "\\F0FCD"; }

.mdi-message-text-lock-outline::before {
  content: "\\F1175"; }

.mdi-message-text-outline::before {
  content: "\\F036A"; }

.mdi-message-video::before {
  content: "\\F036B"; }

.mdi-meteor::before {
  content: "\\F0629"; }

.mdi-metronome::before {
  content: "\\F07DA"; }

.mdi-metronome-tick::before {
  content: "\\F07DB"; }

.mdi-micro-sd::before {
  content: "\\F07DC"; }

.mdi-microphone::before {
  content: "\\F036C"; }

.mdi-microphone-minus::before {
  content: "\\F08B3"; }

.mdi-microphone-off::before {
  content: "\\F036D"; }

.mdi-microphone-outline::before {
  content: "\\F036E"; }

.mdi-microphone-plus::before {
  content: "\\F08B4"; }

.mdi-microphone-settings::before {
  content: "\\F036F"; }

.mdi-microphone-variant::before {
  content: "\\F0370"; }

.mdi-microphone-variant-off::before {
  content: "\\F0371"; }

.mdi-microscope::before {
  content: "\\F0654"; }

.mdi-microsoft::before {
  content: "\\F0372"; }

.mdi-microsoft-access::before {
  content: "\\F138E"; }

.mdi-microsoft-azure::before {
  content: "\\F0805"; }

.mdi-microsoft-azure-devops::before {
  content: "\\F0FD5"; }

.mdi-microsoft-bing::before {
  content: "\\F00A4"; }

.mdi-microsoft-dynamics-365::before {
  content: "\\F0988"; }

.mdi-microsoft-edge::before {
  content: "\\F01E9"; }

.mdi-microsoft-edge-legacy::before {
  content: "\\F1250"; }

.mdi-microsoft-excel::before {
  content: "\\F138F"; }

.mdi-microsoft-internet-explorer::before {
  content: "\\F0300"; }

.mdi-microsoft-office::before {
  content: "\\F03C6"; }

.mdi-microsoft-onedrive::before {
  content: "\\F03CA"; }

.mdi-microsoft-onenote::before {
  content: "\\F0747"; }

.mdi-microsoft-outlook::before {
  content: "\\F0D22"; }

.mdi-microsoft-powerpoint::before {
  content: "\\F1390"; }

.mdi-microsoft-sharepoint::before {
  content: "\\F1391"; }

.mdi-microsoft-teams::before {
  content: "\\F02BB"; }

.mdi-microsoft-visual-studio::before {
  content: "\\F0610"; }

.mdi-microsoft-visual-studio-code::before {
  content: "\\F0A1E"; }

.mdi-microsoft-windows::before {
  content: "\\F05B3"; }

.mdi-microsoft-windows-classic::before {
  content: "\\F0A21"; }

.mdi-microsoft-word::before {
  content: "\\F1392"; }

.mdi-microsoft-xbox::before {
  content: "\\F05B9"; }

.mdi-microsoft-xbox-controller::before {
  content: "\\F05BA"; }

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\F074B"; }

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\F0A22"; }

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\F074C"; }

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\F074D"; }

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\F074E"; }

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\F074F"; }

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\F0750"; }

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\F0E6F"; }

.mdi-microsoft-xbox-controller-off::before {
  content: "\\F05BB"; }

.mdi-microsoft-xbox-controller-view::before {
  content: "\\F0E70"; }

.mdi-microsoft-yammer::before {
  content: "\\F0789"; }

.mdi-microwave::before {
  content: "\\F0C99"; }

.mdi-microwave-off::before {
  content: "\\F1423"; }

.mdi-middleware::before {
  content: "\\F0F5D"; }

.mdi-middleware-outline::before {
  content: "\\F0F5E"; }

.mdi-midi::before {
  content: "\\F08F1"; }

.mdi-midi-port::before {
  content: "\\F08F2"; }

.mdi-mine::before {
  content: "\\F0DDA"; }

.mdi-minecraft::before {
  content: "\\F0373"; }

.mdi-mini-sd::before {
  content: "\\F0A05"; }

.mdi-minidisc::before {
  content: "\\F0A06"; }

.mdi-minus::before {
  content: "\\F0374"; }

.mdi-minus-box::before {
  content: "\\F0375"; }

.mdi-minus-box-multiple::before {
  content: "\\F1141"; }

.mdi-minus-box-multiple-outline::before {
  content: "\\F1142"; }

.mdi-minus-box-outline::before {
  content: "\\F06F2"; }

.mdi-minus-circle::before {
  content: "\\F0376"; }

.mdi-minus-circle-multiple::before {
  content: "\\F035A"; }

.mdi-minus-circle-multiple-outline::before {
  content: "\\F0AD3"; }

.mdi-minus-circle-off::before {
  content: "\\F1459"; }

.mdi-minus-circle-off-outline::before {
  content: "\\F145A"; }

.mdi-minus-circle-outline::before {
  content: "\\F0377"; }

.mdi-minus-network::before {
  content: "\\F0378"; }

.mdi-minus-network-outline::before {
  content: "\\F0C9A"; }

.mdi-minus-thick::before {
  content: "\\F1639"; }

.mdi-mirror::before {
  content: "\\F11FD"; }

.mdi-mixed-martial-arts::before {
  content: "\\F0D8F"; }

.mdi-mixed-reality::before {
  content: "\\F087F"; }

.mdi-molecule::before {
  content: "\\F0BAC"; }

.mdi-molecule-co::before {
  content: "\\F12FE"; }

.mdi-molecule-co2::before {
  content: "\\F07E4"; }

.mdi-monitor::before {
  content: "\\F0379"; }

.mdi-monitor-cellphone::before {
  content: "\\F0989"; }

.mdi-monitor-cellphone-star::before {
  content: "\\F098A"; }

.mdi-monitor-clean::before {
  content: "\\F1104"; }

.mdi-monitor-dashboard::before {
  content: "\\F0A07"; }

.mdi-monitor-edit::before {
  content: "\\F12C6"; }

.mdi-monitor-eye::before {
  content: "\\F13B4"; }

.mdi-monitor-lock::before {
  content: "\\F0DDB"; }

.mdi-monitor-multiple::before {
  content: "\\F037A"; }

.mdi-monitor-off::before {
  content: "\\F0D90"; }

.mdi-monitor-screenshot::before {
  content: "\\F0E51"; }

.mdi-monitor-share::before {
  content: "\\F1483"; }

.mdi-monitor-speaker::before {
  content: "\\F0F5F"; }

.mdi-monitor-speaker-off::before {
  content: "\\F0F60"; }

.mdi-monitor-star::before {
  content: "\\F0DDC"; }

.mdi-moon-first-quarter::before {
  content: "\\F0F61"; }

.mdi-moon-full::before {
  content: "\\F0F62"; }

.mdi-moon-last-quarter::before {
  content: "\\F0F63"; }

.mdi-moon-new::before {
  content: "\\F0F64"; }

.mdi-moon-waning-crescent::before {
  content: "\\F0F65"; }

.mdi-moon-waning-gibbous::before {
  content: "\\F0F66"; }

.mdi-moon-waxing-crescent::before {
  content: "\\F0F67"; }

.mdi-moon-waxing-gibbous::before {
  content: "\\F0F68"; }

.mdi-moped::before {
  content: "\\F1086"; }

.mdi-moped-electric::before {
  content: "\\F15B7"; }

.mdi-moped-electric-outline::before {
  content: "\\F15B8"; }

.mdi-moped-outline::before {
  content: "\\F15B9"; }

.mdi-more::before {
  content: "\\F037B"; }

.mdi-mother-heart::before {
  content: "\\F1314"; }

.mdi-mother-nurse::before {
  content: "\\F0D21"; }

.mdi-motion::before {
  content: "\\F15B2"; }

.mdi-motion-outline::before {
  content: "\\F15B3"; }

.mdi-motion-pause::before {
  content: "\\F1590"; }

.mdi-motion-pause-outline::before {
  content: "\\F1592"; }

.mdi-motion-play::before {
  content: "\\F158F"; }

.mdi-motion-play-outline::before {
  content: "\\F1591"; }

.mdi-motion-sensor::before {
  content: "\\F0D91"; }

.mdi-motion-sensor-off::before {
  content: "\\F1435"; }

.mdi-motorbike::before {
  content: "\\F037C"; }

.mdi-motorbike-electric::before {
  content: "\\F15BA"; }

.mdi-mouse::before {
  content: "\\F037D"; }

.mdi-mouse-bluetooth::before {
  content: "\\F098B"; }

.mdi-mouse-move-down::before {
  content: "\\F1550"; }

.mdi-mouse-move-up::before {
  content: "\\F1551"; }

.mdi-mouse-move-vertical::before {
  content: "\\F1552"; }

.mdi-mouse-off::before {
  content: "\\F037E"; }

.mdi-mouse-variant::before {
  content: "\\F037F"; }

.mdi-mouse-variant-off::before {
  content: "\\F0380"; }

.mdi-move-resize::before {
  content: "\\F0655"; }

.mdi-move-resize-variant::before {
  content: "\\F0656"; }

.mdi-movie::before {
  content: "\\F0381"; }

.mdi-movie-check::before {
  content: "\\F16F3"; }

.mdi-movie-check-outline::before {
  content: "\\F16F4"; }

.mdi-movie-cog::before {
  content: "\\F16F5"; }

.mdi-movie-cog-outline::before {
  content: "\\F16F6"; }

.mdi-movie-edit::before {
  content: "\\F1122"; }

.mdi-movie-edit-outline::before {
  content: "\\F1123"; }

.mdi-movie-filter::before {
  content: "\\F1124"; }

.mdi-movie-filter-outline::before {
  content: "\\F1125"; }

.mdi-movie-minus::before {
  content: "\\F16F7"; }

.mdi-movie-minus-outline::before {
  content: "\\F16F8"; }

.mdi-movie-off::before {
  content: "\\F16F9"; }

.mdi-movie-off-outline::before {
  content: "\\F16FA"; }

.mdi-movie-open::before {
  content: "\\F0FCE"; }

.mdi-movie-open-check::before {
  content: "\\F16FB"; }

.mdi-movie-open-check-outline::before {
  content: "\\F16FC"; }

.mdi-movie-open-cog::before {
  content: "\\F16FD"; }

.mdi-movie-open-cog-outline::before {
  content: "\\F16FE"; }

.mdi-movie-open-edit::before {
  content: "\\F16FF"; }

.mdi-movie-open-edit-outline::before {
  content: "\\F1700"; }

.mdi-movie-open-minus::before {
  content: "\\F1701"; }

.mdi-movie-open-minus-outline::before {
  content: "\\F1702"; }

.mdi-movie-open-off::before {
  content: "\\F1703"; }

.mdi-movie-open-off-outline::before {
  content: "\\F1704"; }

.mdi-movie-open-outline::before {
  content: "\\F0FCF"; }

.mdi-movie-open-play::before {
  content: "\\F1705"; }

.mdi-movie-open-play-outline::before {
  content: "\\F1706"; }

.mdi-movie-open-plus::before {
  content: "\\F1707"; }

.mdi-movie-open-plus-outline::before {
  content: "\\F1708"; }

.mdi-movie-open-remove::before {
  content: "\\F1709"; }

.mdi-movie-open-remove-outline::before {
  content: "\\F170A"; }

.mdi-movie-open-settings::before {
  content: "\\F170B"; }

.mdi-movie-open-settings-outline::before {
  content: "\\F170C"; }

.mdi-movie-open-star::before {
  content: "\\F170D"; }

.mdi-movie-open-star-outline::before {
  content: "\\F170E"; }

.mdi-movie-outline::before {
  content: "\\F0DDD"; }

.mdi-movie-play::before {
  content: "\\F170F"; }

.mdi-movie-play-outline::before {
  content: "\\F1710"; }

.mdi-movie-plus::before {
  content: "\\F1711"; }

.mdi-movie-plus-outline::before {
  content: "\\F1712"; }

.mdi-movie-remove::before {
  content: "\\F1713"; }

.mdi-movie-remove-outline::before {
  content: "\\F1714"; }

.mdi-movie-roll::before {
  content: "\\F07DE"; }

.mdi-movie-search::before {
  content: "\\F11D2"; }

.mdi-movie-search-outline::before {
  content: "\\F11D3"; }

.mdi-movie-settings::before {
  content: "\\F1715"; }

.mdi-movie-settings-outline::before {
  content: "\\F1716"; }

.mdi-movie-star::before {
  content: "\\F1717"; }

.mdi-movie-star-outline::before {
  content: "\\F1718"; }

.mdi-mower::before {
  content: "\\F166F"; }

.mdi-mower-bag::before {
  content: "\\F1670"; }

.mdi-muffin::before {
  content: "\\F098C"; }

.mdi-multiplication::before {
  content: "\\F0382"; }

.mdi-multiplication-box::before {
  content: "\\F0383"; }

.mdi-mushroom::before {
  content: "\\F07DF"; }

.mdi-mushroom-off::before {
  content: "\\F13FA"; }

.mdi-mushroom-off-outline::before {
  content: "\\F13FB"; }

.mdi-mushroom-outline::before {
  content: "\\F07E0"; }

.mdi-music::before {
  content: "\\F075A"; }

.mdi-music-accidental-double-flat::before {
  content: "\\F0F69"; }

.mdi-music-accidental-double-sharp::before {
  content: "\\F0F6A"; }

.mdi-music-accidental-flat::before {
  content: "\\F0F6B"; }

.mdi-music-accidental-natural::before {
  content: "\\F0F6C"; }

.mdi-music-accidental-sharp::before {
  content: "\\F0F6D"; }

.mdi-music-box::before {
  content: "\\F0384"; }

.mdi-music-box-multiple::before {
  content: "\\F0333"; }

.mdi-music-box-multiple-outline::before {
  content: "\\F0F04"; }

.mdi-music-box-outline::before {
  content: "\\F0385"; }

.mdi-music-circle::before {
  content: "\\F0386"; }

.mdi-music-circle-outline::before {
  content: "\\F0AD4"; }

.mdi-music-clef-alto::before {
  content: "\\F0F6E"; }

.mdi-music-clef-bass::before {
  content: "\\F0F6F"; }

.mdi-music-clef-treble::before {
  content: "\\F0F70"; }

.mdi-music-note::before {
  content: "\\F0387"; }

.mdi-music-note-bluetooth::before {
  content: "\\F05FE"; }

.mdi-music-note-bluetooth-off::before {
  content: "\\F05FF"; }

.mdi-music-note-eighth::before {
  content: "\\F0388"; }

.mdi-music-note-eighth-dotted::before {
  content: "\\F0F71"; }

.mdi-music-note-half::before {
  content: "\\F0389"; }

.mdi-music-note-half-dotted::before {
  content: "\\F0F72"; }

.mdi-music-note-off::before {
  content: "\\F038A"; }

.mdi-music-note-off-outline::before {
  content: "\\F0F73"; }

.mdi-music-note-outline::before {
  content: "\\F0F74"; }

.mdi-music-note-plus::before {
  content: "\\F0DDE"; }

.mdi-music-note-quarter::before {
  content: "\\F038B"; }

.mdi-music-note-quarter-dotted::before {
  content: "\\F0F75"; }

.mdi-music-note-sixteenth::before {
  content: "\\F038C"; }

.mdi-music-note-sixteenth-dotted::before {
  content: "\\F0F76"; }

.mdi-music-note-whole::before {
  content: "\\F038D"; }

.mdi-music-note-whole-dotted::before {
  content: "\\F0F77"; }

.mdi-music-off::before {
  content: "\\F075B"; }

.mdi-music-rest-eighth::before {
  content: "\\F0F78"; }

.mdi-music-rest-half::before {
  content: "\\F0F79"; }

.mdi-music-rest-quarter::before {
  content: "\\F0F7A"; }

.mdi-music-rest-sixteenth::before {
  content: "\\F0F7B"; }

.mdi-music-rest-whole::before {
  content: "\\F0F7C"; }

.mdi-mustache::before {
  content: "\\F15DE"; }

.mdi-nail::before {
  content: "\\F0DDF"; }

.mdi-nas::before {
  content: "\\F08F3"; }

.mdi-nativescript::before {
  content: "\\F0880"; }

.mdi-nature::before {
  content: "\\F038E"; }

.mdi-nature-people::before {
  content: "\\F038F"; }

.mdi-navigation::before {
  content: "\\F0390"; }

.mdi-navigation-outline::before {
  content: "\\F1607"; }

.mdi-near-me::before {
  content: "\\F05CD"; }

.mdi-necklace::before {
  content: "\\F0F0B"; }

.mdi-needle::before {
  content: "\\F0391"; }

.mdi-netflix::before {
  content: "\\F0746"; }

.mdi-network::before {
  content: "\\F06F3"; }

.mdi-network-off::before {
  content: "\\F0C9B"; }

.mdi-network-off-outline::before {
  content: "\\F0C9C"; }

.mdi-network-outline::before {
  content: "\\F0C9D"; }

.mdi-network-strength-1::before {
  content: "\\F08F4"; }

.mdi-network-strength-1-alert::before {
  content: "\\F08F5"; }

.mdi-network-strength-2::before {
  content: "\\F08F6"; }

.mdi-network-strength-2-alert::before {
  content: "\\F08F7"; }

.mdi-network-strength-3::before {
  content: "\\F08F8"; }

.mdi-network-strength-3-alert::before {
  content: "\\F08F9"; }

.mdi-network-strength-4::before {
  content: "\\F08FA"; }

.mdi-network-strength-4-alert::before {
  content: "\\F08FB"; }

.mdi-network-strength-off::before {
  content: "\\F08FC"; }

.mdi-network-strength-off-outline::before {
  content: "\\F08FD"; }

.mdi-network-strength-outline::before {
  content: "\\F08FE"; }

.mdi-new-box::before {
  content: "\\F0394"; }

.mdi-newspaper::before {
  content: "\\F0395"; }

.mdi-newspaper-minus::before {
  content: "\\F0F0C"; }

.mdi-newspaper-plus::before {
  content: "\\F0F0D"; }

.mdi-newspaper-variant::before {
  content: "\\F1001"; }

.mdi-newspaper-variant-multiple::before {
  content: "\\F1002"; }

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\F1003"; }

.mdi-newspaper-variant-outline::before {
  content: "\\F1004"; }

.mdi-nfc::before {
  content: "\\F0396"; }

.mdi-nfc-search-variant::before {
  content: "\\F0E53"; }

.mdi-nfc-tap::before {
  content: "\\F0397"; }

.mdi-nfc-variant::before {
  content: "\\F0398"; }

.mdi-nfc-variant-off::before {
  content: "\\F0E54"; }

.mdi-ninja::before {
  content: "\\F0774"; }

.mdi-nintendo-game-boy::before {
  content: "\\F1393"; }

.mdi-nintendo-switch::before {
  content: "\\F07E1"; }

.mdi-nintendo-wii::before {
  content: "\\F05AB"; }

.mdi-nintendo-wiiu::before {
  content: "\\F072D"; }

.mdi-nix::before {
  content: "\\F1105"; }

.mdi-nodejs::before {
  content: "\\F0399"; }

.mdi-noodles::before {
  content: "\\F117E"; }

.mdi-not-equal::before {
  content: "\\F098D"; }

.mdi-not-equal-variant::before {
  content: "\\F098E"; }

.mdi-note::before {
  content: "\\F039A"; }

.mdi-note-minus::before {
  content: "\\F164F"; }

.mdi-note-minus-outline::before {
  content: "\\F1650"; }

.mdi-note-multiple::before {
  content: "\\F06B8"; }

.mdi-note-multiple-outline::before {
  content: "\\F06B9"; }

.mdi-note-outline::before {
  content: "\\F039B"; }

.mdi-note-plus::before {
  content: "\\F039C"; }

.mdi-note-plus-outline::before {
  content: "\\F039D"; }

.mdi-note-remove::before {
  content: "\\F1651"; }

.mdi-note-remove-outline::before {
  content: "\\F1652"; }

.mdi-note-search::before {
  content: "\\F1653"; }

.mdi-note-search-outline::before {
  content: "\\F1654"; }

.mdi-note-text::before {
  content: "\\F039E"; }

.mdi-note-text-outline::before {
  content: "\\F11D7"; }

.mdi-notebook::before {
  content: "\\F082E"; }

.mdi-notebook-check::before {
  content: "\\F14F5"; }

.mdi-notebook-check-outline::before {
  content: "\\F14F6"; }

.mdi-notebook-edit::before {
  content: "\\F14E7"; }

.mdi-notebook-edit-outline::before {
  content: "\\F14E9"; }

.mdi-notebook-minus::before {
  content: "\\F1610"; }

.mdi-notebook-minus-outline::before {
  content: "\\F1611"; }

.mdi-notebook-multiple::before {
  content: "\\F0E55"; }

.mdi-notebook-outline::before {
  content: "\\F0EBF"; }

.mdi-notebook-plus::before {
  content: "\\F1612"; }

.mdi-notebook-plus-outline::before {
  content: "\\F1613"; }

.mdi-notebook-remove::before {
  content: "\\F1614"; }

.mdi-notebook-remove-outline::before {
  content: "\\F1615"; }

.mdi-notification-clear-all::before {
  content: "\\F039F"; }

.mdi-npm::before {
  content: "\\F06F7"; }

.mdi-nuke::before {
  content: "\\F06A4"; }

.mdi-null::before {
  content: "\\F07E2"; }

.mdi-numeric::before {
  content: "\\F03A0"; }

.mdi-numeric-0::before {
  content: "\\F0B39"; }

.mdi-numeric-0-box::before {
  content: "\\F03A1"; }

.mdi-numeric-0-box-multiple::before {
  content: "\\F0F0E"; }

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\F03A2"; }

.mdi-numeric-0-box-outline::before {
  content: "\\F03A3"; }

.mdi-numeric-0-circle::before {
  content: "\\F0C9E"; }

.mdi-numeric-0-circle-outline::before {
  content: "\\F0C9F"; }

.mdi-numeric-1::before {
  content: "\\F0B3A"; }

.mdi-numeric-1-box::before {
  content: "\\F03A4"; }

.mdi-numeric-1-box-multiple::before {
  content: "\\F0F0F"; }

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\F03A5"; }

.mdi-numeric-1-box-outline::before {
  content: "\\F03A6"; }

.mdi-numeric-1-circle::before {
  content: "\\F0CA0"; }

.mdi-numeric-1-circle-outline::before {
  content: "\\F0CA1"; }

.mdi-numeric-10::before {
  content: "\\F0FE9"; }

.mdi-numeric-10-box::before {
  content: "\\F0F7D"; }

.mdi-numeric-10-box-multiple::before {
  content: "\\F0FEA"; }

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\F0FEB"; }

.mdi-numeric-10-box-outline::before {
  content: "\\F0F7E"; }

.mdi-numeric-10-circle::before {
  content: "\\F0FEC"; }

.mdi-numeric-10-circle-outline::before {
  content: "\\F0FED"; }

.mdi-numeric-2::before {
  content: "\\F0B3B"; }

.mdi-numeric-2-box::before {
  content: "\\F03A7"; }

.mdi-numeric-2-box-multiple::before {
  content: "\\F0F10"; }

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\F03A8"; }

.mdi-numeric-2-box-outline::before {
  content: "\\F03A9"; }

.mdi-numeric-2-circle::before {
  content: "\\F0CA2"; }

.mdi-numeric-2-circle-outline::before {
  content: "\\F0CA3"; }

.mdi-numeric-3::before {
  content: "\\F0B3C"; }

.mdi-numeric-3-box::before {
  content: "\\F03AA"; }

.mdi-numeric-3-box-multiple::before {
  content: "\\F0F11"; }

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\F03AB"; }

.mdi-numeric-3-box-outline::before {
  content: "\\F03AC"; }

.mdi-numeric-3-circle::before {
  content: "\\F0CA4"; }

.mdi-numeric-3-circle-outline::before {
  content: "\\F0CA5"; }

.mdi-numeric-4::before {
  content: "\\F0B3D"; }

.mdi-numeric-4-box::before {
  content: "\\F03AD"; }

.mdi-numeric-4-box-multiple::before {
  content: "\\F0F12"; }

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\F03B2"; }

.mdi-numeric-4-box-outline::before {
  content: "\\F03AE"; }

.mdi-numeric-4-circle::before {
  content: "\\F0CA6"; }

.mdi-numeric-4-circle-outline::before {
  content: "\\F0CA7"; }

.mdi-numeric-5::before {
  content: "\\F0B3E"; }

.mdi-numeric-5-box::before {
  content: "\\F03B1"; }

.mdi-numeric-5-box-multiple::before {
  content: "\\F0F13"; }

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\F03AF"; }

.mdi-numeric-5-box-outline::before {
  content: "\\F03B0"; }

.mdi-numeric-5-circle::before {
  content: "\\F0CA8"; }

.mdi-numeric-5-circle-outline::before {
  content: "\\F0CA9"; }

.mdi-numeric-6::before {
  content: "\\F0B3F"; }

.mdi-numeric-6-box::before {
  content: "\\F03B3"; }

.mdi-numeric-6-box-multiple::before {
  content: "\\F0F14"; }

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\F03B4"; }

.mdi-numeric-6-box-outline::before {
  content: "\\F03B5"; }

.mdi-numeric-6-circle::before {
  content: "\\F0CAA"; }

.mdi-numeric-6-circle-outline::before {
  content: "\\F0CAB"; }

.mdi-numeric-7::before {
  content: "\\F0B40"; }

.mdi-numeric-7-box::before {
  content: "\\F03B6"; }

.mdi-numeric-7-box-multiple::before {
  content: "\\F0F15"; }

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\F03B7"; }

.mdi-numeric-7-box-outline::before {
  content: "\\F03B8"; }

.mdi-numeric-7-circle::before {
  content: "\\F0CAC"; }

.mdi-numeric-7-circle-outline::before {
  content: "\\F0CAD"; }

.mdi-numeric-8::before {
  content: "\\F0B41"; }

.mdi-numeric-8-box::before {
  content: "\\F03B9"; }

.mdi-numeric-8-box-multiple::before {
  content: "\\F0F16"; }

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\F03BA"; }

.mdi-numeric-8-box-outline::before {
  content: "\\F03BB"; }

.mdi-numeric-8-circle::before {
  content: "\\F0CAE"; }

.mdi-numeric-8-circle-outline::before {
  content: "\\F0CAF"; }

.mdi-numeric-9::before {
  content: "\\F0B42"; }

.mdi-numeric-9-box::before {
  content: "\\F03BC"; }

.mdi-numeric-9-box-multiple::before {
  content: "\\F0F17"; }

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\F03BD"; }

.mdi-numeric-9-box-outline::before {
  content: "\\F03BE"; }

.mdi-numeric-9-circle::before {
  content: "\\F0CB0"; }

.mdi-numeric-9-circle-outline::before {
  content: "\\F0CB1"; }

.mdi-numeric-9-plus::before {
  content: "\\F0FEE"; }

.mdi-numeric-9-plus-box::before {
  content: "\\F03BF"; }

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\F0F18"; }

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\F03C0"; }

.mdi-numeric-9-plus-box-outline::before {
  content: "\\F03C1"; }

.mdi-numeric-9-plus-circle::before {
  content: "\\F0CB2"; }

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\F0CB3"; }

.mdi-numeric-negative-1::before {
  content: "\\F1052"; }

.mdi-numeric-positive-1::before {
  content: "\\F15CB"; }

.mdi-nut::before {
  content: "\\F06F8"; }

.mdi-nutrition::before {
  content: "\\F03C2"; }

.mdi-nuxt::before {
  content: "\\F1106"; }

.mdi-oar::before {
  content: "\\F067C"; }

.mdi-ocarina::before {
  content: "\\F0DE0"; }

.mdi-oci::before {
  content: "\\F12E9"; }

.mdi-ocr::before {
  content: "\\F113A"; }

.mdi-octagon::before {
  content: "\\F03C3"; }

.mdi-octagon-outline::before {
  content: "\\F03C4"; }

.mdi-octagram::before {
  content: "\\F06F9"; }

.mdi-octagram-outline::before {
  content: "\\F0775"; }

.mdi-odnoklassniki::before {
  content: "\\F03C5"; }

.mdi-offer::before {
  content: "\\F121B"; }

.mdi-office-building::before {
  content: "\\F0991"; }

.mdi-office-building-marker::before {
  content: "\\F1520"; }

.mdi-office-building-marker-outline::before {
  content: "\\F1521"; }

.mdi-office-building-outline::before {
  content: "\\F151F"; }

.mdi-oil::before {
  content: "\\F03C7"; }

.mdi-oil-lamp::before {
  content: "\\F0F19"; }

.mdi-oil-level::before {
  content: "\\F1053"; }

.mdi-oil-temperature::before {
  content: "\\F0FF8"; }

.mdi-omega::before {
  content: "\\F03C9"; }

.mdi-one-up::before {
  content: "\\F0BAD"; }

.mdi-onepassword::before {
  content: "\\F0881"; }

.mdi-opacity::before {
  content: "\\F05CC"; }

.mdi-open-in-app::before {
  content: "\\F03CB"; }

.mdi-open-in-new::before {
  content: "\\F03CC"; }

.mdi-open-source-initiative::before {
  content: "\\F0BAE"; }

.mdi-openid::before {
  content: "\\F03CD"; }

.mdi-opera::before {
  content: "\\F03CE"; }

.mdi-orbit::before {
  content: "\\F0018"; }

.mdi-orbit-variant::before {
  content: "\\F15DB"; }

.mdi-order-alphabetical-ascending::before {
  content: "\\F020D"; }

.mdi-order-alphabetical-descending::before {
  content: "\\F0D07"; }

.mdi-order-bool-ascending::before {
  content: "\\F02BE"; }

.mdi-order-bool-ascending-variant::before {
  content: "\\F098F"; }

.mdi-order-bool-descending::before {
  content: "\\F1384"; }

.mdi-order-bool-descending-variant::before {
  content: "\\F0990"; }

.mdi-order-numeric-ascending::before {
  content: "\\F0545"; }

.mdi-order-numeric-descending::before {
  content: "\\F0546"; }

.mdi-origin::before {
  content: "\\F0B43"; }

.mdi-ornament::before {
  content: "\\F03CF"; }

.mdi-ornament-variant::before {
  content: "\\F03D0"; }

.mdi-outdoor-lamp::before {
  content: "\\F1054"; }

.mdi-overscan::before {
  content: "\\F1005"; }

.mdi-owl::before {
  content: "\\F03D2"; }

.mdi-pac-man::before {
  content: "\\F0BAF"; }

.mdi-package::before {
  content: "\\F03D3"; }

.mdi-package-down::before {
  content: "\\F03D4"; }

.mdi-package-up::before {
  content: "\\F03D5"; }

.mdi-package-variant::before {
  content: "\\F03D6"; }

.mdi-package-variant-closed::before {
  content: "\\F03D7"; }

.mdi-page-first::before {
  content: "\\F0600"; }

.mdi-page-last::before {
  content: "\\F0601"; }

.mdi-page-layout-body::before {
  content: "\\F06FA"; }

.mdi-page-layout-footer::before {
  content: "\\F06FB"; }

.mdi-page-layout-header::before {
  content: "\\F06FC"; }

.mdi-page-layout-header-footer::before {
  content: "\\F0F7F"; }

.mdi-page-layout-sidebar-left::before {
  content: "\\F06FD"; }

.mdi-page-layout-sidebar-right::before {
  content: "\\F06FE"; }

.mdi-page-next::before {
  content: "\\F0BB0"; }

.mdi-page-next-outline::before {
  content: "\\F0BB1"; }

.mdi-page-previous::before {
  content: "\\F0BB2"; }

.mdi-page-previous-outline::before {
  content: "\\F0BB3"; }

.mdi-pail::before {
  content: "\\F1417"; }

.mdi-pail-minus::before {
  content: "\\F1437"; }

.mdi-pail-minus-outline::before {
  content: "\\F143C"; }

.mdi-pail-off::before {
  content: "\\F1439"; }

.mdi-pail-off-outline::before {
  content: "\\F143E"; }

.mdi-pail-outline::before {
  content: "\\F143A"; }

.mdi-pail-plus::before {
  content: "\\F1436"; }

.mdi-pail-plus-outline::before {
  content: "\\F143B"; }

.mdi-pail-remove::before {
  content: "\\F1438"; }

.mdi-pail-remove-outline::before {
  content: "\\F143D"; }

.mdi-palette::before {
  content: "\\F03D8"; }

.mdi-palette-advanced::before {
  content: "\\F03D9"; }

.mdi-palette-outline::before {
  content: "\\F0E0C"; }

.mdi-palette-swatch::before {
  content: "\\F08B5"; }

.mdi-palette-swatch-outline::before {
  content: "\\F135C"; }

.mdi-palm-tree::before {
  content: "\\F1055"; }

.mdi-pan::before {
  content: "\\F0BB4"; }

.mdi-pan-bottom-left::before {
  content: "\\F0BB5"; }

.mdi-pan-bottom-right::before {
  content: "\\F0BB6"; }

.mdi-pan-down::before {
  content: "\\F0BB7"; }

.mdi-pan-horizontal::before {
  content: "\\F0BB8"; }

.mdi-pan-left::before {
  content: "\\F0BB9"; }

.mdi-pan-right::before {
  content: "\\F0BBA"; }

.mdi-pan-top-left::before {
  content: "\\F0BBB"; }

.mdi-pan-top-right::before {
  content: "\\F0BBC"; }

.mdi-pan-up::before {
  content: "\\F0BBD"; }

.mdi-pan-vertical::before {
  content: "\\F0BBE"; }

.mdi-panda::before {
  content: "\\F03DA"; }

.mdi-pandora::before {
  content: "\\F03DB"; }

.mdi-panorama::before {
  content: "\\F03DC"; }

.mdi-panorama-fisheye::before {
  content: "\\F03DD"; }

.mdi-panorama-horizontal::before {
  content: "\\F03DE"; }

.mdi-panorama-vertical::before {
  content: "\\F03DF"; }

.mdi-panorama-wide-angle::before {
  content: "\\F03E0"; }

.mdi-paper-cut-vertical::before {
  content: "\\F03E1"; }

.mdi-paper-roll::before {
  content: "\\F1157"; }

.mdi-paper-roll-outline::before {
  content: "\\F1158"; }

.mdi-paperclip::before {
  content: "\\F03E2"; }

.mdi-parachute::before {
  content: "\\F0CB4"; }

.mdi-parachute-outline::before {
  content: "\\F0CB5"; }

.mdi-parking::before {
  content: "\\F03E3"; }

.mdi-party-popper::before {
  content: "\\F1056"; }

.mdi-passport::before {
  content: "\\F07E3"; }

.mdi-passport-biometric::before {
  content: "\\F0DE1"; }

.mdi-pasta::before {
  content: "\\F1160"; }

.mdi-patio-heater::before {
  content: "\\F0F80"; }

.mdi-patreon::before {
  content: "\\F0882"; }

.mdi-pause::before {
  content: "\\F03E4"; }

.mdi-pause-circle::before {
  content: "\\F03E5"; }

.mdi-pause-circle-outline::before {
  content: "\\F03E6"; }

.mdi-pause-octagon::before {
  content: "\\F03E7"; }

.mdi-pause-octagon-outline::before {
  content: "\\F03E8"; }

.mdi-paw::before {
  content: "\\F03E9"; }

.mdi-paw-off::before {
  content: "\\F0657"; }

.mdi-paw-off-outline::before {
  content: "\\F1676"; }

.mdi-paw-outline::before {
  content: "\\F1675"; }

.mdi-pdf-box::before {
  content: "\\F0E56"; }

.mdi-peace::before {
  content: "\\F0884"; }

.mdi-peanut::before {
  content: "\\F0FFC"; }

.mdi-peanut-off::before {
  content: "\\F0FFD"; }

.mdi-peanut-off-outline::before {
  content: "\\F0FFF"; }

.mdi-peanut-outline::before {
  content: "\\F0FFE"; }

.mdi-pen::before {
  content: "\\F03EA"; }

.mdi-pen-lock::before {
  content: "\\F0DE2"; }

.mdi-pen-minus::before {
  content: "\\F0DE3"; }

.mdi-pen-off::before {
  content: "\\F0DE4"; }

.mdi-pen-plus::before {
  content: "\\F0DE5"; }

.mdi-pen-remove::before {
  content: "\\F0DE6"; }

.mdi-pencil::before {
  content: "\\F03EB"; }

.mdi-pencil-box::before {
  content: "\\F03EC"; }

.mdi-pencil-box-multiple::before {
  content: "\\F1144"; }

.mdi-pencil-box-multiple-outline::before {
  content: "\\F1145"; }

.mdi-pencil-box-outline::before {
  content: "\\F03ED"; }

.mdi-pencil-circle::before {
  content: "\\F06FF"; }

.mdi-pencil-circle-outline::before {
  content: "\\F0776"; }

.mdi-pencil-lock::before {
  content: "\\F03EE"; }

.mdi-pencil-lock-outline::before {
  content: "\\F0DE7"; }

.mdi-pencil-minus::before {
  content: "\\F0DE8"; }

.mdi-pencil-minus-outline::before {
  content: "\\F0DE9"; }

.mdi-pencil-off::before {
  content: "\\F03EF"; }

.mdi-pencil-off-outline::before {
  content: "\\F0DEA"; }

.mdi-pencil-outline::before {
  content: "\\F0CB6"; }

.mdi-pencil-plus::before {
  content: "\\F0DEB"; }

.mdi-pencil-plus-outline::before {
  content: "\\F0DEC"; }

.mdi-pencil-remove::before {
  content: "\\F0DED"; }

.mdi-pencil-remove-outline::before {
  content: "\\F0DEE"; }

.mdi-pencil-ruler::before {
  content: "\\F1353"; }

.mdi-penguin::before {
  content: "\\F0EC0"; }

.mdi-pentagon::before {
  content: "\\F0701"; }

.mdi-pentagon-outline::before {
  content: "\\F0700"; }

.mdi-pentagram::before {
  content: "\\F1667"; }

.mdi-percent::before {
  content: "\\F03F0"; }

.mdi-percent-outline::before {
  content: "\\F1278"; }

.mdi-periodic-table::before {
  content: "\\F08B6"; }

.mdi-perspective-less::before {
  content: "\\F0D23"; }

.mdi-perspective-more::before {
  content: "\\F0D24"; }

.mdi-pharmacy::before {
  content: "\\F03F1"; }

.mdi-phone::before {
  content: "\\F03F2"; }

.mdi-phone-alert::before {
  content: "\\F0F1A"; }

.mdi-phone-alert-outline::before {
  content: "\\F118E"; }

.mdi-phone-bluetooth::before {
  content: "\\F03F3"; }

.mdi-phone-bluetooth-outline::before {
  content: "\\F118F"; }

.mdi-phone-cancel::before {
  content: "\\F10BC"; }

.mdi-phone-cancel-outline::before {
  content: "\\F1190"; }

.mdi-phone-check::before {
  content: "\\F11A9"; }

.mdi-phone-check-outline::before {
  content: "\\F11AA"; }

.mdi-phone-classic::before {
  content: "\\F0602"; }

.mdi-phone-classic-off::before {
  content: "\\F1279"; }

.mdi-phone-dial::before {
  content: "\\F1559"; }

.mdi-phone-dial-outline::before {
  content: "\\F155A"; }

.mdi-phone-forward::before {
  content: "\\F03F4"; }

.mdi-phone-forward-outline::before {
  content: "\\F1191"; }

.mdi-phone-hangup::before {
  content: "\\F03F5"; }

.mdi-phone-hangup-outline::before {
  content: "\\F1192"; }

.mdi-phone-in-talk::before {
  content: "\\F03F6"; }

.mdi-phone-in-talk-outline::before {
  content: "\\F1182"; }

.mdi-phone-incoming::before {
  content: "\\F03F7"; }

.mdi-phone-incoming-outline::before {
  content: "\\F1193"; }

.mdi-phone-lock::before {
  content: "\\F03F8"; }

.mdi-phone-lock-outline::before {
  content: "\\F1194"; }

.mdi-phone-log::before {
  content: "\\F03F9"; }

.mdi-phone-log-outline::before {
  content: "\\F1195"; }

.mdi-phone-message::before {
  content: "\\F1196"; }

.mdi-phone-message-outline::before {
  content: "\\F1197"; }

.mdi-phone-minus::before {
  content: "\\F0658"; }

.mdi-phone-minus-outline::before {
  content: "\\F1198"; }

.mdi-phone-missed::before {
  content: "\\F03FA"; }

.mdi-phone-missed-outline::before {
  content: "\\F11A5"; }

.mdi-phone-off::before {
  content: "\\F0DEF"; }

.mdi-phone-off-outline::before {
  content: "\\F11A6"; }

.mdi-phone-outgoing::before {
  content: "\\F03FB"; }

.mdi-phone-outgoing-outline::before {
  content: "\\F1199"; }

.mdi-phone-outline::before {
  content: "\\F0DF0"; }

.mdi-phone-paused::before {
  content: "\\F03FC"; }

.mdi-phone-paused-outline::before {
  content: "\\F119A"; }

.mdi-phone-plus::before {
  content: "\\F0659"; }

.mdi-phone-plus-outline::before {
  content: "\\F119B"; }

.mdi-phone-remove::before {
  content: "\\F152F"; }

.mdi-phone-remove-outline::before {
  content: "\\F1530"; }

.mdi-phone-return::before {
  content: "\\F082F"; }

.mdi-phone-return-outline::before {
  content: "\\F119C"; }

.mdi-phone-ring::before {
  content: "\\F11AB"; }

.mdi-phone-ring-outline::before {
  content: "\\F11AC"; }

.mdi-phone-rotate-landscape::before {
  content: "\\F0885"; }

.mdi-phone-rotate-portrait::before {
  content: "\\F0886"; }

.mdi-phone-settings::before {
  content: "\\F03FD"; }

.mdi-phone-settings-outline::before {
  content: "\\F119D"; }

.mdi-phone-voip::before {
  content: "\\F03FE"; }

.mdi-pi::before {
  content: "\\F03FF"; }

.mdi-pi-box::before {
  content: "\\F0400"; }

.mdi-pi-hole::before {
  content: "\\F0DF1"; }

.mdi-piano::before {
  content: "\\F067D"; }

.mdi-pickaxe::before {
  content: "\\F08B7"; }

.mdi-picture-in-picture-bottom-right::before {
  content: "\\F0E57"; }

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\F0E58"; }

.mdi-picture-in-picture-top-right::before {
  content: "\\F0E59"; }

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\F0E5A"; }

.mdi-pier::before {
  content: "\\F0887"; }

.mdi-pier-crane::before {
  content: "\\F0888"; }

.mdi-pig::before {
  content: "\\F0401"; }

.mdi-pig-variant::before {
  content: "\\F1006"; }

.mdi-pig-variant-outline::before {
  content: "\\F1678"; }

.mdi-piggy-bank::before {
  content: "\\F1007"; }

.mdi-piggy-bank-outline::before {
  content: "\\F1679"; }

.mdi-pill::before {
  content: "\\F0402"; }

.mdi-pillar::before {
  content: "\\F0702"; }

.mdi-pin::before {
  content: "\\F0403"; }

.mdi-pin-off::before {
  content: "\\F0404"; }

.mdi-pin-off-outline::before {
  content: "\\F0930"; }

.mdi-pin-outline::before {
  content: "\\F0931"; }

.mdi-pine-tree::before {
  content: "\\F0405"; }

.mdi-pine-tree-box::before {
  content: "\\F0406"; }

.mdi-pine-tree-fire::before {
  content: "\\F141A"; }

.mdi-pinterest::before {
  content: "\\F0407"; }

.mdi-pinwheel::before {
  content: "\\F0AD5"; }

.mdi-pinwheel-outline::before {
  content: "\\F0AD6"; }

.mdi-pipe::before {
  content: "\\F07E5"; }

.mdi-pipe-disconnected::before {
  content: "\\F07E6"; }

.mdi-pipe-leak::before {
  content: "\\F0889"; }

.mdi-pipe-wrench::before {
  content: "\\F1354"; }

.mdi-pirate::before {
  content: "\\F0A08"; }

.mdi-pistol::before {
  content: "\\F0703"; }

.mdi-piston::before {
  content: "\\F088A"; }

.mdi-pitchfork::before {
  content: "\\F1553"; }

.mdi-pizza::before {
  content: "\\F0409"; }

.mdi-play::before {
  content: "\\F040A"; }

.mdi-play-box::before {
  content: "\\F127A"; }

.mdi-play-box-multiple::before {
  content: "\\F0D19"; }

.mdi-play-box-multiple-outline::before {
  content: "\\F13E6"; }

.mdi-play-box-outline::before {
  content: "\\F040B"; }

.mdi-play-circle::before {
  content: "\\F040C"; }

.mdi-play-circle-outline::before {
  content: "\\F040D"; }

.mdi-play-network::before {
  content: "\\F088B"; }

.mdi-play-network-outline::before {
  content: "\\F0CB7"; }

.mdi-play-outline::before {
  content: "\\F0F1B"; }

.mdi-play-pause::before {
  content: "\\F040E"; }

.mdi-play-protected-content::before {
  content: "\\F040F"; }

.mdi-play-speed::before {
  content: "\\F08FF"; }

.mdi-playlist-check::before {
  content: "\\F05C7"; }

.mdi-playlist-edit::before {
  content: "\\F0900"; }

.mdi-playlist-minus::before {
  content: "\\F0410"; }

.mdi-playlist-music::before {
  content: "\\F0CB8"; }

.mdi-playlist-music-outline::before {
  content: "\\F0CB9"; }

.mdi-playlist-play::before {
  content: "\\F0411"; }

.mdi-playlist-plus::before {
  content: "\\F0412"; }

.mdi-playlist-remove::before {
  content: "\\F0413"; }

.mdi-playlist-star::before {
  content: "\\F0DF2"; }

.mdi-plex::before {
  content: "\\F06BA"; }

.mdi-plus::before {
  content: "\\F0415"; }

.mdi-plus-box::before {
  content: "\\F0416"; }

.mdi-plus-box-multiple::before {
  content: "\\F0334"; }

.mdi-plus-box-multiple-outline::before {
  content: "\\F1143"; }

.mdi-plus-box-outline::before {
  content: "\\F0704"; }

.mdi-plus-circle::before {
  content: "\\F0417"; }

.mdi-plus-circle-multiple::before {
  content: "\\F034C"; }

.mdi-plus-circle-multiple-outline::before {
  content: "\\F0418"; }

.mdi-plus-circle-outline::before {
  content: "\\F0419"; }

.mdi-plus-minus::before {
  content: "\\F0992"; }

.mdi-plus-minus-box::before {
  content: "\\F0993"; }

.mdi-plus-minus-variant::before {
  content: "\\F14C9"; }

.mdi-plus-network::before {
  content: "\\F041A"; }

.mdi-plus-network-outline::before {
  content: "\\F0CBA"; }

.mdi-plus-one::before {
  content: "\\F041B"; }

.mdi-plus-outline::before {
  content: "\\F0705"; }

.mdi-plus-thick::before {
  content: "\\F11EC"; }

.mdi-podcast::before {
  content: "\\F0994"; }

.mdi-podium::before {
  content: "\\F0D25"; }

.mdi-podium-bronze::before {
  content: "\\F0D26"; }

.mdi-podium-gold::before {
  content: "\\F0D27"; }

.mdi-podium-silver::before {
  content: "\\F0D28"; }

.mdi-point-of-sale::before {
  content: "\\F0D92"; }

.mdi-pokeball::before {
  content: "\\F041D"; }

.mdi-pokemon-go::before {
  content: "\\F0A09"; }

.mdi-poker-chip::before {
  content: "\\F0830"; }

.mdi-polaroid::before {
  content: "\\F041E"; }

.mdi-police-badge::before {
  content: "\\F1167"; }

.mdi-police-badge-outline::before {
  content: "\\F1168"; }

.mdi-poll::before {
  content: "\\F041F"; }

.mdi-poll-box::before {
  content: "\\F0420"; }

.mdi-poll-box-outline::before {
  content: "\\F127B"; }

.mdi-polo::before {
  content: "\\F14C3"; }

.mdi-polymer::before {
  content: "\\F0421"; }

.mdi-pool::before {
  content: "\\F0606"; }

.mdi-popcorn::before {
  content: "\\F0422"; }

.mdi-post::before {
  content: "\\F1008"; }

.mdi-post-outline::before {
  content: "\\F1009"; }

.mdi-postage-stamp::before {
  content: "\\F0CBB"; }

.mdi-pot::before {
  content: "\\F02E5"; }

.mdi-pot-mix::before {
  content: "\\F065B"; }

.mdi-pot-mix-outline::before {
  content: "\\F0677"; }

.mdi-pot-outline::before {
  content: "\\F02FF"; }

.mdi-pot-steam::before {
  content: "\\F065A"; }

.mdi-pot-steam-outline::before {
  content: "\\F0326"; }

.mdi-pound::before {
  content: "\\F0423"; }

.mdi-pound-box::before {
  content: "\\F0424"; }

.mdi-pound-box-outline::before {
  content: "\\F117F"; }

.mdi-power::before {
  content: "\\F0425"; }

.mdi-power-cycle::before {
  content: "\\F0901"; }

.mdi-power-off::before {
  content: "\\F0902"; }

.mdi-power-on::before {
  content: "\\F0903"; }

.mdi-power-plug::before {
  content: "\\F06A5"; }

.mdi-power-plug-off::before {
  content: "\\F06A6"; }

.mdi-power-plug-off-outline::before {
  content: "\\F1424"; }

.mdi-power-plug-outline::before {
  content: "\\F1425"; }

.mdi-power-settings::before {
  content: "\\F0426"; }

.mdi-power-sleep::before {
  content: "\\F0904"; }

.mdi-power-socket::before {
  content: "\\F0427"; }

.mdi-power-socket-au::before {
  content: "\\F0905"; }

.mdi-power-socket-de::before {
  content: "\\F1107"; }

.mdi-power-socket-eu::before {
  content: "\\F07E7"; }

.mdi-power-socket-fr::before {
  content: "\\F1108"; }

.mdi-power-socket-it::before {
  content: "\\F14FF"; }

.mdi-power-socket-jp::before {
  content: "\\F1109"; }

.mdi-power-socket-uk::before {
  content: "\\F07E8"; }

.mdi-power-socket-us::before {
  content: "\\F07E9"; }

.mdi-power-standby::before {
  content: "\\F0906"; }

.mdi-powershell::before {
  content: "\\F0A0A"; }

.mdi-prescription::before {
  content: "\\F0706"; }

.mdi-presentation::before {
  content: "\\F0428"; }

.mdi-presentation-play::before {
  content: "\\F0429"; }

.mdi-pretzel::before {
  content: "\\F1562"; }

.mdi-printer::before {
  content: "\\F042A"; }

.mdi-printer-3d::before {
  content: "\\F042B"; }

.mdi-printer-3d-nozzle::before {
  content: "\\F0E5B"; }

.mdi-printer-3d-nozzle-alert::before {
  content: "\\F11C0"; }

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\F11C1"; }

.mdi-printer-3d-nozzle-outline::before {
  content: "\\F0E5C"; }

.mdi-printer-alert::before {
  content: "\\F042C"; }

.mdi-printer-check::before {
  content: "\\F1146"; }

.mdi-printer-eye::before {
  content: "\\F1458"; }

.mdi-printer-off::before {
  content: "\\F0E5D"; }

.mdi-printer-pos::before {
  content: "\\F1057"; }

.mdi-printer-search::before {
  content: "\\F1457"; }

.mdi-printer-settings::before {
  content: "\\F0707"; }

.mdi-printer-wireless::before {
  content: "\\F0A0B"; }

.mdi-priority-high::before {
  content: "\\F0603"; }

.mdi-priority-low::before {
  content: "\\F0604"; }

.mdi-professional-hexagon::before {
  content: "\\F042D"; }

.mdi-progress-alert::before {
  content: "\\F0CBC"; }

.mdi-progress-check::before {
  content: "\\F0995"; }

.mdi-progress-clock::before {
  content: "\\F0996"; }

.mdi-progress-close::before {
  content: "\\F110A"; }

.mdi-progress-download::before {
  content: "\\F0997"; }

.mdi-progress-question::before {
  content: "\\F1522"; }

.mdi-progress-upload::before {
  content: "\\F0998"; }

.mdi-progress-wrench::before {
  content: "\\F0CBD"; }

.mdi-projector::before {
  content: "\\F042E"; }

.mdi-projector-screen::before {
  content: "\\F042F"; }

.mdi-projector-screen-outline::before {
  content: "\\F1724"; }

.mdi-propane-tank::before {
  content: "\\F1357"; }

.mdi-propane-tank-outline::before {
  content: "\\F1358"; }

.mdi-protocol::before {
  content: "\\F0FD8"; }

.mdi-publish::before {
  content: "\\F06A7"; }

.mdi-pulse::before {
  content: "\\F0430"; }

.mdi-pump::before {
  content: "\\F1402"; }

.mdi-pumpkin::before {
  content: "\\F0BBF"; }

.mdi-purse::before {
  content: "\\F0F1C"; }

.mdi-purse-outline::before {
  content: "\\F0F1D"; }

.mdi-puzzle::before {
  content: "\\F0431"; }

.mdi-puzzle-check::before {
  content: "\\F1426"; }

.mdi-puzzle-check-outline::before {
  content: "\\F1427"; }

.mdi-puzzle-edit::before {
  content: "\\F14D3"; }

.mdi-puzzle-edit-outline::before {
  content: "\\F14D9"; }

.mdi-puzzle-heart::before {
  content: "\\F14D4"; }

.mdi-puzzle-heart-outline::before {
  content: "\\F14DA"; }

.mdi-puzzle-minus::before {
  content: "\\F14D1"; }

.mdi-puzzle-minus-outline::before {
  content: "\\F14D7"; }

.mdi-puzzle-outline::before {
  content: "\\F0A66"; }

.mdi-puzzle-plus::before {
  content: "\\F14D0"; }

.mdi-puzzle-plus-outline::before {
  content: "\\F14D6"; }

.mdi-puzzle-remove::before {
  content: "\\F14D2"; }

.mdi-puzzle-remove-outline::before {
  content: "\\F14D8"; }

.mdi-puzzle-star::before {
  content: "\\F14D5"; }

.mdi-puzzle-star-outline::before {
  content: "\\F14DB"; }

.mdi-qi::before {
  content: "\\F0999"; }

.mdi-qqchat::before {
  content: "\\F0605"; }

.mdi-qrcode::before {
  content: "\\F0432"; }

.mdi-qrcode-edit::before {
  content: "\\F08B8"; }

.mdi-qrcode-minus::before {
  content: "\\F118C"; }

.mdi-qrcode-plus::before {
  content: "\\F118B"; }

.mdi-qrcode-remove::before {
  content: "\\F118D"; }

.mdi-qrcode-scan::before {
  content: "\\F0433"; }

.mdi-quadcopter::before {
  content: "\\F0434"; }

.mdi-quality-high::before {
  content: "\\F0435"; }

.mdi-quality-low::before {
  content: "\\F0A0C"; }

.mdi-quality-medium::before {
  content: "\\F0A0D"; }

.mdi-quora::before {
  content: "\\F0D29"; }

.mdi-rabbit::before {
  content: "\\F0907"; }

.mdi-racing-helmet::before {
  content: "\\F0D93"; }

.mdi-racquetball::before {
  content: "\\F0D94"; }

.mdi-radar::before {
  content: "\\F0437"; }

.mdi-radiator::before {
  content: "\\F0438"; }

.mdi-radiator-disabled::before {
  content: "\\F0AD7"; }

.mdi-radiator-off::before {
  content: "\\F0AD8"; }

.mdi-radio::before {
  content: "\\F0439"; }

.mdi-radio-am::before {
  content: "\\F0CBE"; }

.mdi-radio-fm::before {
  content: "\\F0CBF"; }

.mdi-radio-handheld::before {
  content: "\\F043A"; }

.mdi-radio-off::before {
  content: "\\F121C"; }

.mdi-radio-tower::before {
  content: "\\F043B"; }

.mdi-radioactive::before {
  content: "\\F043C"; }

.mdi-radioactive-off::before {
  content: "\\F0EC1"; }

.mdi-radiobox-blank::before {
  content: "\\F043D"; }

.mdi-radiobox-marked::before {
  content: "\\F043E"; }

.mdi-radiology-box::before {
  content: "\\F14C5"; }

.mdi-radiology-box-outline::before {
  content: "\\F14C6"; }

.mdi-radius::before {
  content: "\\F0CC0"; }

.mdi-radius-outline::before {
  content: "\\F0CC1"; }

.mdi-railroad-light::before {
  content: "\\F0F1E"; }

.mdi-rake::before {
  content: "\\F1544"; }

.mdi-raspberry-pi::before {
  content: "\\F043F"; }

.mdi-ray-end::before {
  content: "\\F0440"; }

.mdi-ray-end-arrow::before {
  content: "\\F0441"; }

.mdi-ray-start::before {
  content: "\\F0442"; }

.mdi-ray-start-arrow::before {
  content: "\\F0443"; }

.mdi-ray-start-end::before {
  content: "\\F0444"; }

.mdi-ray-start-vertex-end::before {
  content: "\\F15D8"; }

.mdi-ray-vertex::before {
  content: "\\F0445"; }

.mdi-react::before {
  content: "\\F0708"; }

.mdi-read::before {
  content: "\\F0447"; }

.mdi-receipt::before {
  content: "\\F0449"; }

.mdi-record::before {
  content: "\\F044A"; }

.mdi-record-circle::before {
  content: "\\F0EC2"; }

.mdi-record-circle-outline::before {
  content: "\\F0EC3"; }

.mdi-record-player::before {
  content: "\\F099A"; }

.mdi-record-rec::before {
  content: "\\F044B"; }

.mdi-rectangle::before {
  content: "\\F0E5E"; }

.mdi-rectangle-outline::before {
  content: "\\F0E5F"; }

.mdi-recycle::before {
  content: "\\F044C"; }

.mdi-recycle-variant::before {
  content: "\\F139D"; }

.mdi-reddit::before {
  content: "\\F044D"; }

.mdi-redhat::before {
  content: "\\F111B"; }

.mdi-redo::before {
  content: "\\F044E"; }

.mdi-redo-variant::before {
  content: "\\F044F"; }

.mdi-reflect-horizontal::before {
  content: "\\F0A0E"; }

.mdi-reflect-vertical::before {
  content: "\\F0A0F"; }

.mdi-refresh::before {
  content: "\\F0450"; }

.mdi-refresh-circle::before {
  content: "\\F1377"; }

.mdi-regex::before {
  content: "\\F0451"; }

.mdi-registered-trademark::before {
  content: "\\F0A67"; }

.mdi-reiterate::before {
  content: "\\F1588"; }

.mdi-relation-many-to-many::before {
  content: "\\F1496"; }

.mdi-relation-many-to-one::before {
  content: "\\F1497"; }

.mdi-relation-many-to-one-or-many::before {
  content: "\\F1498"; }

.mdi-relation-many-to-only-one::before {
  content: "\\F1499"; }

.mdi-relation-many-to-zero-or-many::before {
  content: "\\F149A"; }

.mdi-relation-many-to-zero-or-one::before {
  content: "\\F149B"; }

.mdi-relation-one-or-many-to-many::before {
  content: "\\F149C"; }

.mdi-relation-one-or-many-to-one::before {
  content: "\\F149D"; }

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\F149E"; }

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\F149F"; }

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\F14A0"; }

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\F14A1"; }

.mdi-relation-one-to-many::before {
  content: "\\F14A2"; }

.mdi-relation-one-to-one::before {
  content: "\\F14A3"; }

.mdi-relation-one-to-one-or-many::before {
  content: "\\F14A4"; }

.mdi-relation-one-to-only-one::before {
  content: "\\F14A5"; }

.mdi-relation-one-to-zero-or-many::before {
  content: "\\F14A6"; }

.mdi-relation-one-to-zero-or-one::before {
  content: "\\F14A7"; }

.mdi-relation-only-one-to-many::before {
  content: "\\F14A8"; }

.mdi-relation-only-one-to-one::before {
  content: "\\F14A9"; }

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\F14AA"; }

.mdi-relation-only-one-to-only-one::before {
  content: "\\F14AB"; }

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\F14AC"; }

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\F14AD"; }

.mdi-relation-zero-or-many-to-many::before {
  content: "\\F14AE"; }

.mdi-relation-zero-or-many-to-one::before {
  content: "\\F14AF"; }

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\F14B0"; }

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\F14B1"; }

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\F14B2"; }

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\F14B3"; }

.mdi-relation-zero-or-one-to-many::before {
  content: "\\F14B4"; }

.mdi-relation-zero-or-one-to-one::before {
  content: "\\F14B5"; }

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\F14B6"; }

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\F14B7"; }

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\F14B8"; }

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\F14B9"; }

.mdi-relative-scale::before {
  content: "\\F0452"; }

.mdi-reload::before {
  content: "\\F0453"; }

.mdi-reload-alert::before {
  content: "\\F110B"; }

.mdi-reminder::before {
  content: "\\F088C"; }

.mdi-remote::before {
  content: "\\F0454"; }

.mdi-remote-desktop::before {
  content: "\\F08B9"; }

.mdi-remote-off::before {
  content: "\\F0EC4"; }

.mdi-remote-tv::before {
  content: "\\F0EC5"; }

.mdi-remote-tv-off::before {
  content: "\\F0EC6"; }

.mdi-rename-box::before {
  content: "\\F0455"; }

.mdi-reorder-horizontal::before {
  content: "\\F0688"; }

.mdi-reorder-vertical::before {
  content: "\\F0689"; }

.mdi-repeat::before {
  content: "\\F0456"; }

.mdi-repeat-off::before {
  content: "\\F0457"; }

.mdi-repeat-once::before {
  content: "\\F0458"; }

.mdi-replay::before {
  content: "\\F0459"; }

.mdi-reply::before {
  content: "\\F045A"; }

.mdi-reply-all::before {
  content: "\\F045B"; }

.mdi-reply-all-outline::before {
  content: "\\F0F1F"; }

.mdi-reply-circle::before {
  content: "\\F11AE"; }

.mdi-reply-outline::before {
  content: "\\F0F20"; }

.mdi-reproduction::before {
  content: "\\F045C"; }

.mdi-resistor::before {
  content: "\\F0B44"; }

.mdi-resistor-nodes::before {
  content: "\\F0B45"; }

.mdi-resize::before {
  content: "\\F0A68"; }

.mdi-resize-bottom-right::before {
  content: "\\F045D"; }

.mdi-responsive::before {
  content: "\\F045E"; }

.mdi-restart::before {
  content: "\\F0709"; }

.mdi-restart-alert::before {
  content: "\\F110C"; }

.mdi-restart-off::before {
  content: "\\F0D95"; }

.mdi-restore::before {
  content: "\\F099B"; }

.mdi-restore-alert::before {
  content: "\\F110D"; }

.mdi-rewind::before {
  content: "\\F045F"; }

.mdi-rewind-10::before {
  content: "\\F0D2A"; }

.mdi-rewind-30::before {
  content: "\\F0D96"; }

.mdi-rewind-5::before {
  content: "\\F11F9"; }

.mdi-rewind-60::before {
  content: "\\F160C"; }

.mdi-rewind-outline::before {
  content: "\\F070A"; }

.mdi-rhombus::before {
  content: "\\F070B"; }

.mdi-rhombus-medium::before {
  content: "\\F0A10"; }

.mdi-rhombus-medium-outline::before {
  content: "\\F14DC"; }

.mdi-rhombus-outline::before {
  content: "\\F070C"; }

.mdi-rhombus-split::before {
  content: "\\F0A11"; }

.mdi-rhombus-split-outline::before {
  content: "\\F14DD"; }

.mdi-ribbon::before {
  content: "\\F0460"; }

.mdi-rice::before {
  content: "\\F07EA"; }

.mdi-rickshaw::before {
  content: "\\F15BB"; }

.mdi-rickshaw-electric::before {
  content: "\\F15BC"; }

.mdi-ring::before {
  content: "\\F07EB"; }

.mdi-rivet::before {
  content: "\\F0E60"; }

.mdi-road::before {
  content: "\\F0461"; }

.mdi-road-variant::before {
  content: "\\F0462"; }

.mdi-robber::before {
  content: "\\F1058"; }

.mdi-robot::before {
  content: "\\F06A9"; }

.mdi-robot-angry::before {
  content: "\\F169D"; }

.mdi-robot-angry-outline::before {
  content: "\\F169E"; }

.mdi-robot-confused::before {
  content: "\\F169F"; }

.mdi-robot-confused-outline::before {
  content: "\\F16A0"; }

.mdi-robot-dead::before {
  content: "\\F16A1"; }

.mdi-robot-dead-outline::before {
  content: "\\F16A2"; }

.mdi-robot-excited::before {
  content: "\\F16A3"; }

.mdi-robot-excited-outline::before {
  content: "\\F16A4"; }

.mdi-robot-happy::before {
  content: "\\F1719"; }

.mdi-robot-happy-outline::before {
  content: "\\F171A"; }

.mdi-robot-industrial::before {
  content: "\\F0B46"; }

.mdi-robot-love::before {
  content: "\\F16A5"; }

.mdi-robot-love-outline::before {
  content: "\\F16A6"; }

.mdi-robot-mower::before {
  content: "\\F11F7"; }

.mdi-robot-mower-outline::before {
  content: "\\F11F3"; }

.mdi-robot-off::before {
  content: "\\F16A7"; }

.mdi-robot-off-outline::before {
  content: "\\F167B"; }

.mdi-robot-outline::before {
  content: "\\F167A"; }

.mdi-robot-vacuum::before {
  content: "\\F070D"; }

.mdi-robot-vacuum-variant::before {
  content: "\\F0908"; }

.mdi-rocket::before {
  content: "\\F0463"; }

.mdi-rocket-launch::before {
  content: "\\F14DE"; }

.mdi-rocket-launch-outline::before {
  content: "\\F14DF"; }

.mdi-rocket-outline::before {
  content: "\\F13AF"; }

.mdi-rodent::before {
  content: "\\F1327"; }

.mdi-roller-skate::before {
  content: "\\F0D2B"; }

.mdi-roller-skate-off::before {
  content: "\\F0145"; }

.mdi-rollerblade::before {
  content: "\\F0D2C"; }

.mdi-rollerblade-off::before {
  content: "\\F002E"; }

.mdi-rollupjs::before {
  content: "\\F0BC0"; }

.mdi-roman-numeral-1::before {
  content: "\\F1088"; }

.mdi-roman-numeral-10::before {
  content: "\\F1091"; }

.mdi-roman-numeral-2::before {
  content: "\\F1089"; }

.mdi-roman-numeral-3::before {
  content: "\\F108A"; }

.mdi-roman-numeral-4::before {
  content: "\\F108B"; }

.mdi-roman-numeral-5::before {
  content: "\\F108C"; }

.mdi-roman-numeral-6::before {
  content: "\\F108D"; }

.mdi-roman-numeral-7::before {
  content: "\\F108E"; }

.mdi-roman-numeral-8::before {
  content: "\\F108F"; }

.mdi-roman-numeral-9::before {
  content: "\\F1090"; }

.mdi-room-service::before {
  content: "\\F088D"; }

.mdi-room-service-outline::before {
  content: "\\F0D97"; }

.mdi-rotate-3d::before {
  content: "\\F0EC7"; }

.mdi-rotate-3d-variant::before {
  content: "\\F0464"; }

.mdi-rotate-left::before {
  content: "\\F0465"; }

.mdi-rotate-left-variant::before {
  content: "\\F0466"; }

.mdi-rotate-orbit::before {
  content: "\\F0D98"; }

.mdi-rotate-right::before {
  content: "\\F0467"; }

.mdi-rotate-right-variant::before {
  content: "\\F0468"; }

.mdi-rounded-corner::before {
  content: "\\F0607"; }

.mdi-router::before {
  content: "\\F11E2"; }

.mdi-router-network::before {
  content: "\\F1087"; }

.mdi-router-wireless::before {
  content: "\\F0469"; }

.mdi-router-wireless-off::before {
  content: "\\F15A3"; }

.mdi-router-wireless-settings::before {
  content: "\\F0A69"; }

.mdi-routes::before {
  content: "\\F046A"; }

.mdi-routes-clock::before {
  content: "\\F1059"; }

.mdi-rowing::before {
  content: "\\F0608"; }

.mdi-rss::before {
  content: "\\F046B"; }

.mdi-rss-box::before {
  content: "\\F046C"; }

.mdi-rss-off::before {
  content: "\\F0F21"; }

.mdi-rug::before {
  content: "\\F1475"; }

.mdi-rugby::before {
  content: "\\F0D99"; }

.mdi-ruler::before {
  content: "\\F046D"; }

.mdi-ruler-square::before {
  content: "\\F0CC2"; }

.mdi-ruler-square-compass::before {
  content: "\\F0EBE"; }

.mdi-run::before {
  content: "\\F070E"; }

.mdi-run-fast::before {
  content: "\\F046E"; }

.mdi-rv-truck::before {
  content: "\\F11D4"; }

.mdi-sack::before {
  content: "\\F0D2E"; }

.mdi-sack-percent::before {
  content: "\\F0D2F"; }

.mdi-safe::before {
  content: "\\F0A6A"; }

.mdi-safe-square::before {
  content: "\\F127C"; }

.mdi-safe-square-outline::before {
  content: "\\F127D"; }

.mdi-safety-goggles::before {
  content: "\\F0D30"; }

.mdi-sail-boat::before {
  content: "\\F0EC8"; }

.mdi-sale::before {
  content: "\\F046F"; }

.mdi-salesforce::before {
  content: "\\F088E"; }

.mdi-sass::before {
  content: "\\F07EC"; }

.mdi-satellite::before {
  content: "\\F0470"; }

.mdi-satellite-uplink::before {
  content: "\\F0909"; }

.mdi-satellite-variant::before {
  content: "\\F0471"; }

.mdi-sausage::before {
  content: "\\F08BA"; }

.mdi-saw-blade::before {
  content: "\\F0E61"; }

.mdi-sawtooth-wave::before {
  content: "\\F147A"; }

.mdi-saxophone::before {
  content: "\\F0609"; }

.mdi-scale::before {
  content: "\\F0472"; }

.mdi-scale-balance::before {
  content: "\\F05D1"; }

.mdi-scale-bathroom::before {
  content: "\\F0473"; }

.mdi-scale-off::before {
  content: "\\F105A"; }

.mdi-scan-helper::before {
  content: "\\F13D8"; }

.mdi-scanner::before {
  content: "\\F06AB"; }

.mdi-scanner-off::before {
  content: "\\F090A"; }

.mdi-scatter-plot::before {
  content: "\\F0EC9"; }

.mdi-scatter-plot-outline::before {
  content: "\\F0ECA"; }

.mdi-school::before {
  content: "\\F0474"; }

.mdi-school-outline::before {
  content: "\\F1180"; }

.mdi-scissors-cutting::before {
  content: "\\F0A6B"; }

.mdi-scooter::before {
  content: "\\F15BD"; }

.mdi-scooter-electric::before {
  content: "\\F15BE"; }

.mdi-scoreboard::before {
  content: "\\F127E"; }

.mdi-scoreboard-outline::before {
  content: "\\F127F"; }

.mdi-screen-rotation::before {
  content: "\\F0475"; }

.mdi-screen-rotation-lock::before {
  content: "\\F0478"; }

.mdi-screw-flat-top::before {
  content: "\\F0DF3"; }

.mdi-screw-lag::before {
  content: "\\F0DF4"; }

.mdi-screw-machine-flat-top::before {
  content: "\\F0DF5"; }

.mdi-screw-machine-round-top::before {
  content: "\\F0DF6"; }

.mdi-screw-round-top::before {
  content: "\\F0DF7"; }

.mdi-screwdriver::before {
  content: "\\F0476"; }

.mdi-script::before {
  content: "\\F0BC1"; }

.mdi-script-outline::before {
  content: "\\F0477"; }

.mdi-script-text::before {
  content: "\\F0BC2"; }

.mdi-script-text-key::before {
  content: "\\F1725"; }

.mdi-script-text-key-outline::before {
  content: "\\F1726"; }

.mdi-script-text-outline::before {
  content: "\\F0BC3"; }

.mdi-script-text-play::before {
  content: "\\F1727"; }

.mdi-script-text-play-outline::before {
  content: "\\F1728"; }

.mdi-sd::before {
  content: "\\F0479"; }

.mdi-seal::before {
  content: "\\F047A"; }

.mdi-seal-variant::before {
  content: "\\F0FD9"; }

.mdi-search-web::before {
  content: "\\F070F"; }

.mdi-seat::before {
  content: "\\F0CC3"; }

.mdi-seat-flat::before {
  content: "\\F047B"; }

.mdi-seat-flat-angled::before {
  content: "\\F047C"; }

.mdi-seat-individual-suite::before {
  content: "\\F047D"; }

.mdi-seat-legroom-extra::before {
  content: "\\F047E"; }

.mdi-seat-legroom-normal::before {
  content: "\\F047F"; }

.mdi-seat-legroom-reduced::before {
  content: "\\F0480"; }

.mdi-seat-outline::before {
  content: "\\F0CC4"; }

.mdi-seat-passenger::before {
  content: "\\F1249"; }

.mdi-seat-recline-extra::before {
  content: "\\F0481"; }

.mdi-seat-recline-normal::before {
  content: "\\F0482"; }

.mdi-seatbelt::before {
  content: "\\F0CC5"; }

.mdi-security::before {
  content: "\\F0483"; }

.mdi-security-network::before {
  content: "\\F0484"; }

.mdi-seed::before {
  content: "\\F0E62"; }

.mdi-seed-off::before {
  content: "\\F13FD"; }

.mdi-seed-off-outline::before {
  content: "\\F13FE"; }

.mdi-seed-outline::before {
  content: "\\F0E63"; }

.mdi-seesaw::before {
  content: "\\F15A4"; }

.mdi-segment::before {
  content: "\\F0ECB"; }

.mdi-select::before {
  content: "\\F0485"; }

.mdi-select-all::before {
  content: "\\F0486"; }

.mdi-select-color::before {
  content: "\\F0D31"; }

.mdi-select-compare::before {
  content: "\\F0AD9"; }

.mdi-select-drag::before {
  content: "\\F0A6C"; }

.mdi-select-group::before {
  content: "\\F0F82"; }

.mdi-select-inverse::before {
  content: "\\F0487"; }

.mdi-select-marker::before {
  content: "\\F1280"; }

.mdi-select-multiple::before {
  content: "\\F1281"; }

.mdi-select-multiple-marker::before {
  content: "\\F1282"; }

.mdi-select-off::before {
  content: "\\F0488"; }

.mdi-select-place::before {
  content: "\\F0FDA"; }

.mdi-select-search::before {
  content: "\\F1204"; }

.mdi-selection::before {
  content: "\\F0489"; }

.mdi-selection-drag::before {
  content: "\\F0A6D"; }

.mdi-selection-ellipse::before {
  content: "\\F0D32"; }

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\F0F22"; }

.mdi-selection-marker::before {
  content: "\\F1283"; }

.mdi-selection-multiple::before {
  content: "\\F1285"; }

.mdi-selection-multiple-marker::before {
  content: "\\F1284"; }

.mdi-selection-off::before {
  content: "\\F0777"; }

.mdi-selection-search::before {
  content: "\\F1205"; }

.mdi-semantic-web::before {
  content: "\\F1316"; }

.mdi-send::before {
  content: "\\F048A"; }

.mdi-send-check::before {
  content: "\\F1161"; }

.mdi-send-check-outline::before {
  content: "\\F1162"; }

.mdi-send-circle::before {
  content: "\\F0DF8"; }

.mdi-send-circle-outline::before {
  content: "\\F0DF9"; }

.mdi-send-clock::before {
  content: "\\F1163"; }

.mdi-send-clock-outline::before {
  content: "\\F1164"; }

.mdi-send-lock::before {
  content: "\\F07ED"; }

.mdi-send-lock-outline::before {
  content: "\\F1166"; }

.mdi-send-outline::before {
  content: "\\F1165"; }

.mdi-serial-port::before {
  content: "\\F065C"; }

.mdi-server::before {
  content: "\\F048B"; }

.mdi-server-minus::before {
  content: "\\F048C"; }

.mdi-server-network::before {
  content: "\\F048D"; }

.mdi-server-network-off::before {
  content: "\\F048E"; }

.mdi-server-off::before {
  content: "\\F048F"; }

.mdi-server-plus::before {
  content: "\\F0490"; }

.mdi-server-remove::before {
  content: "\\F0491"; }

.mdi-server-security::before {
  content: "\\F0492"; }

.mdi-set-all::before {
  content: "\\F0778"; }

.mdi-set-center::before {
  content: "\\F0779"; }

.mdi-set-center-right::before {
  content: "\\F077A"; }

.mdi-set-left::before {
  content: "\\F077B"; }

.mdi-set-left-center::before {
  content: "\\F077C"; }

.mdi-set-left-right::before {
  content: "\\F077D"; }

.mdi-set-merge::before {
  content: "\\F14E0"; }

.mdi-set-none::before {
  content: "\\F077E"; }

.mdi-set-right::before {
  content: "\\F077F"; }

.mdi-set-split::before {
  content: "\\F14E1"; }

.mdi-set-square::before {
  content: "\\F145D"; }

.mdi-set-top-box::before {
  content: "\\F099F"; }

.mdi-settings-helper::before {
  content: "\\F0A6E"; }

.mdi-shaker::before {
  content: "\\F110E"; }

.mdi-shaker-outline::before {
  content: "\\F110F"; }

.mdi-shape::before {
  content: "\\F0831"; }

.mdi-shape-circle-plus::before {
  content: "\\F065D"; }

.mdi-shape-outline::before {
  content: "\\F0832"; }

.mdi-shape-oval-plus::before {
  content: "\\F11FA"; }

.mdi-shape-plus::before {
  content: "\\F0495"; }

.mdi-shape-polygon-plus::before {
  content: "\\F065E"; }

.mdi-shape-rectangle-plus::before {
  content: "\\F065F"; }

.mdi-shape-square-plus::before {
  content: "\\F0660"; }

.mdi-shape-square-rounded-plus::before {
  content: "\\F14FA"; }

.mdi-share::before {
  content: "\\F0496"; }

.mdi-share-all::before {
  content: "\\F11F4"; }

.mdi-share-all-outline::before {
  content: "\\F11F5"; }

.mdi-share-circle::before {
  content: "\\F11AD"; }

.mdi-share-off::before {
  content: "\\F0F23"; }

.mdi-share-off-outline::before {
  content: "\\F0F24"; }

.mdi-share-outline::before {
  content: "\\F0932"; }

.mdi-share-variant::before {
  content: "\\F0497"; }

.mdi-share-variant-outline::before {
  content: "\\F1514"; }

.mdi-shark-fin::before {
  content: "\\F1673"; }

.mdi-shark-fin-outline::before {
  content: "\\F1674"; }

.mdi-sheep::before {
  content: "\\F0CC6"; }

.mdi-shield::before {
  content: "\\F0498"; }

.mdi-shield-account::before {
  content: "\\F088F"; }

.mdi-shield-account-outline::before {
  content: "\\F0A12"; }

.mdi-shield-account-variant::before {
  content: "\\F15A7"; }

.mdi-shield-account-variant-outline::before {
  content: "\\F15A8"; }

.mdi-shield-airplane::before {
  content: "\\F06BB"; }

.mdi-shield-airplane-outline::before {
  content: "\\F0CC7"; }

.mdi-shield-alert::before {
  content: "\\F0ECC"; }

.mdi-shield-alert-outline::before {
  content: "\\F0ECD"; }

.mdi-shield-bug::before {
  content: "\\F13DA"; }

.mdi-shield-bug-outline::before {
  content: "\\F13DB"; }

.mdi-shield-car::before {
  content: "\\F0F83"; }

.mdi-shield-check::before {
  content: "\\F0565"; }

.mdi-shield-check-outline::before {
  content: "\\F0CC8"; }

.mdi-shield-cross::before {
  content: "\\F0CC9"; }

.mdi-shield-cross-outline::before {
  content: "\\F0CCA"; }

.mdi-shield-edit::before {
  content: "\\F11A0"; }

.mdi-shield-edit-outline::before {
  content: "\\F11A1"; }

.mdi-shield-half::before {
  content: "\\F1360"; }

.mdi-shield-half-full::before {
  content: "\\F0780"; }

.mdi-shield-home::before {
  content: "\\F068A"; }

.mdi-shield-home-outline::before {
  content: "\\F0CCB"; }

.mdi-shield-key::before {
  content: "\\F0BC4"; }

.mdi-shield-key-outline::before {
  content: "\\F0BC5"; }

.mdi-shield-link-variant::before {
  content: "\\F0D33"; }

.mdi-shield-link-variant-outline::before {
  content: "\\F0D34"; }

.mdi-shield-lock::before {
  content: "\\F099D"; }

.mdi-shield-lock-outline::before {
  content: "\\F0CCC"; }

.mdi-shield-off::before {
  content: "\\F099E"; }

.mdi-shield-off-outline::before {
  content: "\\F099C"; }

.mdi-shield-outline::before {
  content: "\\F0499"; }

.mdi-shield-plus::before {
  content: "\\F0ADA"; }

.mdi-shield-plus-outline::before {
  content: "\\F0ADB"; }

.mdi-shield-refresh::before {
  content: "\\F00AA"; }

.mdi-shield-refresh-outline::before {
  content: "\\F01E0"; }

.mdi-shield-remove::before {
  content: "\\F0ADC"; }

.mdi-shield-remove-outline::before {
  content: "\\F0ADD"; }

.mdi-shield-search::before {
  content: "\\F0D9A"; }

.mdi-shield-star::before {
  content: "\\F113B"; }

.mdi-shield-star-outline::before {
  content: "\\F113C"; }

.mdi-shield-sun::before {
  content: "\\F105D"; }

.mdi-shield-sun-outline::before {
  content: "\\F105E"; }

.mdi-shield-sync::before {
  content: "\\F11A2"; }

.mdi-shield-sync-outline::before {
  content: "\\F11A3"; }

.mdi-ship-wheel::before {
  content: "\\F0833"; }

.mdi-shoe-ballet::before {
  content: "\\F15CA"; }

.mdi-shoe-cleat::before {
  content: "\\F15C7"; }

.mdi-shoe-formal::before {
  content: "\\F0B47"; }

.mdi-shoe-heel::before {
  content: "\\F0B48"; }

.mdi-shoe-print::before {
  content: "\\F0DFA"; }

.mdi-shoe-sneaker::before {
  content: "\\F15C8"; }

.mdi-shopping::before {
  content: "\\F049A"; }

.mdi-shopping-music::before {
  content: "\\F049B"; }

.mdi-shopping-outline::before {
  content: "\\F11D5"; }

.mdi-shopping-search::before {
  content: "\\F0F84"; }

.mdi-shore::before {
  content: "\\F14F9"; }

.mdi-shovel::before {
  content: "\\F0710"; }

.mdi-shovel-off::before {
  content: "\\F0711"; }

.mdi-shower::before {
  content: "\\F09A0"; }

.mdi-shower-head::before {
  content: "\\F09A1"; }

.mdi-shredder::before {
  content: "\\F049C"; }

.mdi-shuffle::before {
  content: "\\F049D"; }

.mdi-shuffle-disabled::before {
  content: "\\F049E"; }

.mdi-shuffle-variant::before {
  content: "\\F049F"; }

.mdi-shuriken::before {
  content: "\\F137F"; }

.mdi-sigma::before {
  content: "\\F04A0"; }

.mdi-sigma-lower::before {
  content: "\\F062B"; }

.mdi-sign-caution::before {
  content: "\\F04A1"; }

.mdi-sign-direction::before {
  content: "\\F0781"; }

.mdi-sign-direction-minus::before {
  content: "\\F1000"; }

.mdi-sign-direction-plus::before {
  content: "\\F0FDC"; }

.mdi-sign-direction-remove::before {
  content: "\\F0FDD"; }

.mdi-sign-pole::before {
  content: "\\F14F8"; }

.mdi-sign-real-estate::before {
  content: "\\F1118"; }

.mdi-sign-text::before {
  content: "\\F0782"; }

.mdi-signal::before {
  content: "\\F04A2"; }

.mdi-signal-2g::before {
  content: "\\F0712"; }

.mdi-signal-3g::before {
  content: "\\F0713"; }

.mdi-signal-4g::before {
  content: "\\F0714"; }

.mdi-signal-5g::before {
  content: "\\F0A6F"; }

.mdi-signal-cellular-1::before {
  content: "\\F08BC"; }

.mdi-signal-cellular-2::before {
  content: "\\F08BD"; }

.mdi-signal-cellular-3::before {
  content: "\\F08BE"; }

.mdi-signal-cellular-outline::before {
  content: "\\F08BF"; }

.mdi-signal-distance-variant::before {
  content: "\\F0E64"; }

.mdi-signal-hspa::before {
  content: "\\F0715"; }

.mdi-signal-hspa-plus::before {
  content: "\\F0716"; }

.mdi-signal-off::before {
  content: "\\F0783"; }

.mdi-signal-variant::before {
  content: "\\F060A"; }

.mdi-signature::before {
  content: "\\F0DFB"; }

.mdi-signature-freehand::before {
  content: "\\F0DFC"; }

.mdi-signature-image::before {
  content: "\\F0DFD"; }

.mdi-signature-text::before {
  content: "\\F0DFE"; }

.mdi-silo::before {
  content: "\\F0B49"; }

.mdi-silverware::before {
  content: "\\F04A3"; }

.mdi-silverware-clean::before {
  content: "\\F0FDE"; }

.mdi-silverware-fork::before {
  content: "\\F04A4"; }

.mdi-silverware-fork-knife::before {
  content: "\\F0A70"; }

.mdi-silverware-spoon::before {
  content: "\\F04A5"; }

.mdi-silverware-variant::before {
  content: "\\F04A6"; }

.mdi-sim::before {
  content: "\\F04A7"; }

.mdi-sim-alert::before {
  content: "\\F04A8"; }

.mdi-sim-alert-outline::before {
  content: "\\F15D3"; }

.mdi-sim-off::before {
  content: "\\F04A9"; }

.mdi-sim-off-outline::before {
  content: "\\F15D4"; }

.mdi-sim-outline::before {
  content: "\\F15D5"; }

.mdi-simple-icons::before {
  content: "\\F131D"; }

.mdi-sina-weibo::before {
  content: "\\F0ADF"; }

.mdi-sine-wave::before {
  content: "\\F095B"; }

.mdi-sitemap::before {
  content: "\\F04AA"; }

.mdi-size-l::before {
  content: "\\F13A6"; }

.mdi-size-m::before {
  content: "\\F13A5"; }

.mdi-size-s::before {
  content: "\\F13A4"; }

.mdi-size-xl::before {
  content: "\\F13A7"; }

.mdi-size-xs::before {
  content: "\\F13A3"; }

.mdi-size-xxl::before {
  content: "\\F13A8"; }

.mdi-size-xxs::before {
  content: "\\F13A2"; }

.mdi-size-xxxl::before {
  content: "\\F13A9"; }

.mdi-skate::before {
  content: "\\F0D35"; }

.mdi-skateboard::before {
  content: "\\F14C2"; }

.mdi-skew-less::before {
  content: "\\F0D36"; }

.mdi-skew-more::before {
  content: "\\F0D37"; }

.mdi-ski::before {
  content: "\\F1304"; }

.mdi-ski-cross-country::before {
  content: "\\F1305"; }

.mdi-ski-water::before {
  content: "\\F1306"; }

.mdi-skip-backward::before {
  content: "\\F04AB"; }

.mdi-skip-backward-outline::before {
  content: "\\F0F25"; }

.mdi-skip-forward::before {
  content: "\\F04AC"; }

.mdi-skip-forward-outline::before {
  content: "\\F0F26"; }

.mdi-skip-next::before {
  content: "\\F04AD"; }

.mdi-skip-next-circle::before {
  content: "\\F0661"; }

.mdi-skip-next-circle-outline::before {
  content: "\\F0662"; }

.mdi-skip-next-outline::before {
  content: "\\F0F27"; }

.mdi-skip-previous::before {
  content: "\\F04AE"; }

.mdi-skip-previous-circle::before {
  content: "\\F0663"; }

.mdi-skip-previous-circle-outline::before {
  content: "\\F0664"; }

.mdi-skip-previous-outline::before {
  content: "\\F0F28"; }

.mdi-skull::before {
  content: "\\F068C"; }

.mdi-skull-crossbones::before {
  content: "\\F0BC6"; }

.mdi-skull-crossbones-outline::before {
  content: "\\F0BC7"; }

.mdi-skull-outline::before {
  content: "\\F0BC8"; }

.mdi-skull-scan::before {
  content: "\\F14C7"; }

.mdi-skull-scan-outline::before {
  content: "\\F14C8"; }

.mdi-skype::before {
  content: "\\F04AF"; }

.mdi-skype-business::before {
  content: "\\F04B0"; }

.mdi-slack::before {
  content: "\\F04B1"; }

.mdi-slash-forward::before {
  content: "\\F0FDF"; }

.mdi-slash-forward-box::before {
  content: "\\F0FE0"; }

.mdi-sleep::before {
  content: "\\F04B2"; }

.mdi-sleep-off::before {
  content: "\\F04B3"; }

.mdi-slide::before {
  content: "\\F15A5"; }

.mdi-slope-downhill::before {
  content: "\\F0DFF"; }

.mdi-slope-uphill::before {
  content: "\\F0E00"; }

.mdi-slot-machine::before {
  content: "\\F1114"; }

.mdi-slot-machine-outline::before {
  content: "\\F1115"; }

.mdi-smart-card::before {
  content: "\\F10BD"; }

.mdi-smart-card-outline::before {
  content: "\\F10BE"; }

.mdi-smart-card-reader::before {
  content: "\\F10BF"; }

.mdi-smart-card-reader-outline::before {
  content: "\\F10C0"; }

.mdi-smog::before {
  content: "\\F0A71"; }

.mdi-smoke-detector::before {
  content: "\\F0392"; }

.mdi-smoking::before {
  content: "\\F04B4"; }

.mdi-smoking-off::before {
  content: "\\F04B5"; }

.mdi-smoking-pipe::before {
  content: "\\F140D"; }

.mdi-smoking-pipe-off::before {
  content: "\\F1428"; }

.mdi-snail::before {
  content: "\\F1677"; }

.mdi-snake::before {
  content: "\\F150E"; }

.mdi-snapchat::before {
  content: "\\F04B6"; }

.mdi-snowboard::before {
  content: "\\F1307"; }

.mdi-snowflake::before {
  content: "\\F0717"; }

.mdi-snowflake-alert::before {
  content: "\\F0F29"; }

.mdi-snowflake-melt::before {
  content: "\\F12CB"; }

.mdi-snowflake-off::before {
  content: "\\F14E3"; }

.mdi-snowflake-variant::before {
  content: "\\F0F2A"; }

.mdi-snowman::before {
  content: "\\F04B7"; }

.mdi-soccer::before {
  content: "\\F04B8"; }

.mdi-soccer-field::before {
  content: "\\F0834"; }

.mdi-social-distance-2-meters::before {
  content: "\\F1579"; }

.mdi-social-distance-6-feet::before {
  content: "\\F157A"; }

.mdi-sofa::before {
  content: "\\F04B9"; }

.mdi-sofa-outline::before {
  content: "\\F156D"; }

.mdi-sofa-single::before {
  content: "\\F156E"; }

.mdi-sofa-single-outline::before {
  content: "\\F156F"; }

.mdi-solar-panel::before {
  content: "\\F0D9B"; }

.mdi-solar-panel-large::before {
  content: "\\F0D9C"; }

.mdi-solar-power::before {
  content: "\\F0A72"; }

.mdi-soldering-iron::before {
  content: "\\F1092"; }

.mdi-solid::before {
  content: "\\F068D"; }

.mdi-sony-playstation::before {
  content: "\\F0414"; }

.mdi-sort::before {
  content: "\\F04BA"; }

.mdi-sort-alphabetical-ascending::before {
  content: "\\F05BD"; }

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\F1148"; }

.mdi-sort-alphabetical-descending::before {
  content: "\\F05BF"; }

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\F1149"; }

.mdi-sort-alphabetical-variant::before {
  content: "\\F04BB"; }

.mdi-sort-ascending::before {
  content: "\\F04BC"; }

.mdi-sort-bool-ascending::before {
  content: "\\F1385"; }

.mdi-sort-bool-ascending-variant::before {
  content: "\\F1386"; }

.mdi-sort-bool-descending::before {
  content: "\\F1387"; }

.mdi-sort-bool-descending-variant::before {
  content: "\\F1388"; }

.mdi-sort-calendar-ascending::before {
  content: "\\F1547"; }

.mdi-sort-calendar-descending::before {
  content: "\\F1548"; }

.mdi-sort-clock-ascending::before {
  content: "\\F1549"; }

.mdi-sort-clock-ascending-outline::before {
  content: "\\F154A"; }

.mdi-sort-clock-descending::before {
  content: "\\F154B"; }

.mdi-sort-clock-descending-outline::before {
  content: "\\F154C"; }

.mdi-sort-descending::before {
  content: "\\F04BD"; }

.mdi-sort-numeric-ascending::before {
  content: "\\F1389"; }

.mdi-sort-numeric-ascending-variant::before {
  content: "\\F090D"; }

.mdi-sort-numeric-descending::before {
  content: "\\F138A"; }

.mdi-sort-numeric-descending-variant::before {
  content: "\\F0AD2"; }

.mdi-sort-numeric-variant::before {
  content: "\\F04BE"; }

.mdi-sort-reverse-variant::before {
  content: "\\F033C"; }

.mdi-sort-variant::before {
  content: "\\F04BF"; }

.mdi-sort-variant-lock::before {
  content: "\\F0CCD"; }

.mdi-sort-variant-lock-open::before {
  content: "\\F0CCE"; }

.mdi-sort-variant-remove::before {
  content: "\\F1147"; }

.mdi-soundcloud::before {
  content: "\\F04C0"; }

.mdi-source-branch::before {
  content: "\\F062C"; }

.mdi-source-branch-check::before {
  content: "\\F14CF"; }

.mdi-source-branch-minus::before {
  content: "\\F14CB"; }

.mdi-source-branch-plus::before {
  content: "\\F14CA"; }

.mdi-source-branch-refresh::before {
  content: "\\F14CD"; }

.mdi-source-branch-remove::before {
  content: "\\F14CC"; }

.mdi-source-branch-sync::before {
  content: "\\F14CE"; }

.mdi-source-commit::before {
  content: "\\F0718"; }

.mdi-source-commit-end::before {
  content: "\\F0719"; }

.mdi-source-commit-end-local::before {
  content: "\\F071A"; }

.mdi-source-commit-local::before {
  content: "\\F071B"; }

.mdi-source-commit-next-local::before {
  content: "\\F071C"; }

.mdi-source-commit-start::before {
  content: "\\F071D"; }

.mdi-source-commit-start-next-local::before {
  content: "\\F071E"; }

.mdi-source-fork::before {
  content: "\\F04C1"; }

.mdi-source-merge::before {
  content: "\\F062D"; }

.mdi-source-pull::before {
  content: "\\F04C2"; }

.mdi-source-repository::before {
  content: "\\F0CCF"; }

.mdi-source-repository-multiple::before {
  content: "\\F0CD0"; }

.mdi-soy-sauce::before {
  content: "\\F07EE"; }

.mdi-soy-sauce-off::before {
  content: "\\F13FC"; }

.mdi-spa::before {
  content: "\\F0CD1"; }

.mdi-spa-outline::before {
  content: "\\F0CD2"; }

.mdi-space-invaders::before {
  content: "\\F0BC9"; }

.mdi-space-station::before {
  content: "\\F1383"; }

.mdi-spade::before {
  content: "\\F0E65"; }

.mdi-sparkles::before {
  content: "\\F1545"; }

.mdi-speaker::before {
  content: "\\F04C3"; }

.mdi-speaker-bluetooth::before {
  content: "\\F09A2"; }

.mdi-speaker-multiple::before {
  content: "\\F0D38"; }

.mdi-speaker-off::before {
  content: "\\F04C4"; }

.mdi-speaker-wireless::before {
  content: "\\F071F"; }

.mdi-speedometer::before {
  content: "\\F04C5"; }

.mdi-speedometer-medium::before {
  content: "\\F0F85"; }

.mdi-speedometer-slow::before {
  content: "\\F0F86"; }

.mdi-spellcheck::before {
  content: "\\F04C6"; }

.mdi-spider::before {
  content: "\\F11EA"; }

.mdi-spider-thread::before {
  content: "\\F11EB"; }

.mdi-spider-web::before {
  content: "\\F0BCA"; }

.mdi-spirit-level::before {
  content: "\\F14F1"; }

.mdi-spoon-sugar::before {
  content: "\\F1429"; }

.mdi-spotify::before {
  content: "\\F04C7"; }

.mdi-spotlight::before {
  content: "\\F04C8"; }

.mdi-spotlight-beam::before {
  content: "\\F04C9"; }

.mdi-spray::before {
  content: "\\F0665"; }

.mdi-spray-bottle::before {
  content: "\\F0AE0"; }

.mdi-sprinkler::before {
  content: "\\F105F"; }

.mdi-sprinkler-variant::before {
  content: "\\F1060"; }

.mdi-sprout::before {
  content: "\\F0E66"; }

.mdi-sprout-outline::before {
  content: "\\F0E67"; }

.mdi-square::before {
  content: "\\F0764"; }

.mdi-square-circle::before {
  content: "\\F1500"; }

.mdi-square-edit-outline::before {
  content: "\\F090C"; }

.mdi-square-medium::before {
  content: "\\F0A13"; }

.mdi-square-medium-outline::before {
  content: "\\F0A14"; }

.mdi-square-off::before {
  content: "\\F12EE"; }

.mdi-square-off-outline::before {
  content: "\\F12EF"; }

.mdi-square-outline::before {
  content: "\\F0763"; }

.mdi-square-root::before {
  content: "\\F0784"; }

.mdi-square-root-box::before {
  content: "\\F09A3"; }

.mdi-square-rounded::before {
  content: "\\F14FB"; }

.mdi-square-rounded-outline::before {
  content: "\\F14FC"; }

.mdi-square-small::before {
  content: "\\F0A15"; }

.mdi-square-wave::before {
  content: "\\F147B"; }

.mdi-squeegee::before {
  content: "\\F0AE1"; }

.mdi-ssh::before {
  content: "\\F08C0"; }

.mdi-stack-exchange::before {
  content: "\\F060B"; }

.mdi-stack-overflow::before {
  content: "\\F04CC"; }

.mdi-stackpath::before {
  content: "\\F0359"; }

.mdi-stadium::before {
  content: "\\F0FF9"; }

.mdi-stadium-variant::before {
  content: "\\F0720"; }

.mdi-stairs::before {
  content: "\\F04CD"; }

.mdi-stairs-box::before {
  content: "\\F139E"; }

.mdi-stairs-down::before {
  content: "\\F12BE"; }

.mdi-stairs-up::before {
  content: "\\F12BD"; }

.mdi-stamper::before {
  content: "\\F0D39"; }

.mdi-standard-definition::before {
  content: "\\F07EF"; }

.mdi-star::before {
  content: "\\F04CE"; }

.mdi-star-box::before {
  content: "\\F0A73"; }

.mdi-star-box-multiple::before {
  content: "\\F1286"; }

.mdi-star-box-multiple-outline::before {
  content: "\\F1287"; }

.mdi-star-box-outline::before {
  content: "\\F0A74"; }

.mdi-star-check::before {
  content: "\\F1566"; }

.mdi-star-check-outline::before {
  content: "\\F156A"; }

.mdi-star-circle::before {
  content: "\\F04CF"; }

.mdi-star-circle-outline::before {
  content: "\\F09A4"; }

.mdi-star-cog::before {
  content: "\\F1668"; }

.mdi-star-cog-outline::before {
  content: "\\F1669"; }

.mdi-star-face::before {
  content: "\\F09A5"; }

.mdi-star-four-points::before {
  content: "\\F0AE2"; }

.mdi-star-four-points-outline::before {
  content: "\\F0AE3"; }

.mdi-star-half::before {
  content: "\\F0246"; }

.mdi-star-half-full::before {
  content: "\\F04D0"; }

.mdi-star-minus::before {
  content: "\\F1564"; }

.mdi-star-minus-outline::before {
  content: "\\F1568"; }

.mdi-star-off::before {
  content: "\\F04D1"; }

.mdi-star-off-outline::before {
  content: "\\F155B"; }

.mdi-star-outline::before {
  content: "\\F04D2"; }

.mdi-star-plus::before {
  content: "\\F1563"; }

.mdi-star-plus-outline::before {
  content: "\\F1567"; }

.mdi-star-remove::before {
  content: "\\F1565"; }

.mdi-star-remove-outline::before {
  content: "\\F1569"; }

.mdi-star-settings::before {
  content: "\\F166A"; }

.mdi-star-settings-outline::before {
  content: "\\F166B"; }

.mdi-star-shooting::before {
  content: "\\F1741"; }

.mdi-star-shooting-outline::before {
  content: "\\F1742"; }

.mdi-star-three-points::before {
  content: "\\F0AE4"; }

.mdi-star-three-points-outline::before {
  content: "\\F0AE5"; }

.mdi-state-machine::before {
  content: "\\F11EF"; }

.mdi-steam::before {
  content: "\\F04D3"; }

.mdi-steering::before {
  content: "\\F04D4"; }

.mdi-steering-off::before {
  content: "\\F090E"; }

.mdi-step-backward::before {
  content: "\\F04D5"; }

.mdi-step-backward-2::before {
  content: "\\F04D6"; }

.mdi-step-forward::before {
  content: "\\F04D7"; }

.mdi-step-forward-2::before {
  content: "\\F04D8"; }

.mdi-stethoscope::before {
  content: "\\F04D9"; }

.mdi-sticker::before {
  content: "\\F1364"; }

.mdi-sticker-alert::before {
  content: "\\F1365"; }

.mdi-sticker-alert-outline::before {
  content: "\\F1366"; }

.mdi-sticker-check::before {
  content: "\\F1367"; }

.mdi-sticker-check-outline::before {
  content: "\\F1368"; }

.mdi-sticker-circle-outline::before {
  content: "\\F05D0"; }

.mdi-sticker-emoji::before {
  content: "\\F0785"; }

.mdi-sticker-minus::before {
  content: "\\F1369"; }

.mdi-sticker-minus-outline::before {
  content: "\\F136A"; }

.mdi-sticker-outline::before {
  content: "\\F136B"; }

.mdi-sticker-plus::before {
  content: "\\F136C"; }

.mdi-sticker-plus-outline::before {
  content: "\\F136D"; }

.mdi-sticker-remove::before {
  content: "\\F136E"; }

.mdi-sticker-remove-outline::before {
  content: "\\F136F"; }

.mdi-stocking::before {
  content: "\\F04DA"; }

.mdi-stomach::before {
  content: "\\F1093"; }

.mdi-stop::before {
  content: "\\F04DB"; }

.mdi-stop-circle::before {
  content: "\\F0666"; }

.mdi-stop-circle-outline::before {
  content: "\\F0667"; }

.mdi-store::before {
  content: "\\F04DC"; }

.mdi-store-24-hour::before {
  content: "\\F04DD"; }

.mdi-store-minus::before {
  content: "\\F165E"; }

.mdi-store-outline::before {
  content: "\\F1361"; }

.mdi-store-plus::before {
  content: "\\F165F"; }

.mdi-store-remove::before {
  content: "\\F1660"; }

.mdi-storefront::before {
  content: "\\F07C7"; }

.mdi-storefront-outline::before {
  content: "\\F10C1"; }

.mdi-stove::before {
  content: "\\F04DE"; }

.mdi-strategy::before {
  content: "\\F11D6"; }

.mdi-stretch-to-page::before {
  content: "\\F0F2B"; }

.mdi-stretch-to-page-outline::before {
  content: "\\F0F2C"; }

.mdi-string-lights::before {
  content: "\\F12BA"; }

.mdi-string-lights-off::before {
  content: "\\F12BB"; }

.mdi-subdirectory-arrow-left::before {
  content: "\\F060C"; }

.mdi-subdirectory-arrow-right::before {
  content: "\\F060D"; }

.mdi-submarine::before {
  content: "\\F156C"; }

.mdi-subtitles::before {
  content: "\\F0A16"; }

.mdi-subtitles-outline::before {
  content: "\\F0A17"; }

.mdi-subway::before {
  content: "\\F06AC"; }

.mdi-subway-alert-variant::before {
  content: "\\F0D9D"; }

.mdi-subway-variant::before {
  content: "\\F04DF"; }

.mdi-summit::before {
  content: "\\F0786"; }

.mdi-sunglasses::before {
  content: "\\F04E0"; }

.mdi-surround-sound::before {
  content: "\\F05C5"; }

.mdi-surround-sound-2-0::before {
  content: "\\F07F0"; }

.mdi-surround-sound-2-1::before {
  content: "\\F1729"; }

.mdi-surround-sound-3-1::before {
  content: "\\F07F1"; }

.mdi-surround-sound-5-1::before {
  content: "\\F07F2"; }

.mdi-surround-sound-5-1-2::before {
  content: "\\F172A"; }

.mdi-surround-sound-7-1::before {
  content: "\\F07F3"; }

.mdi-svg::before {
  content: "\\F0721"; }

.mdi-swap-horizontal::before {
  content: "\\F04E1"; }

.mdi-swap-horizontal-bold::before {
  content: "\\F0BCD"; }

.mdi-swap-horizontal-circle::before {
  content: "\\F0FE1"; }

.mdi-swap-horizontal-circle-outline::before {
  content: "\\F0FE2"; }

.mdi-swap-horizontal-variant::before {
  content: "\\F08C1"; }

.mdi-swap-vertical::before {
  content: "\\F04E2"; }

.mdi-swap-vertical-bold::before {
  content: "\\F0BCE"; }

.mdi-swap-vertical-circle::before {
  content: "\\F0FE3"; }

.mdi-swap-vertical-circle-outline::before {
  content: "\\F0FE4"; }

.mdi-swap-vertical-variant::before {
  content: "\\F08C2"; }

.mdi-swim::before {
  content: "\\F04E3"; }

.mdi-switch::before {
  content: "\\F04E4"; }

.mdi-sword::before {
  content: "\\F04E5"; }

.mdi-sword-cross::before {
  content: "\\F0787"; }

.mdi-syllabary-hangul::before {
  content: "\\F1333"; }

.mdi-syllabary-hiragana::before {
  content: "\\F1334"; }

.mdi-syllabary-katakana::before {
  content: "\\F1335"; }

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\F1336"; }

.mdi-symbol::before {
  content: "\\F1501"; }

.mdi-symfony::before {
  content: "\\F0AE6"; }

.mdi-sync::before {
  content: "\\F04E6"; }

.mdi-sync-alert::before {
  content: "\\F04E7"; }

.mdi-sync-circle::before {
  content: "\\F1378"; }

.mdi-sync-off::before {
  content: "\\F04E8"; }

.mdi-tab::before {
  content: "\\F04E9"; }

.mdi-tab-minus::before {
  content: "\\F0B4B"; }

.mdi-tab-plus::before {
  content: "\\F075C"; }

.mdi-tab-remove::before {
  content: "\\F0B4C"; }

.mdi-tab-unselected::before {
  content: "\\F04EA"; }

.mdi-table::before {
  content: "\\F04EB"; }

.mdi-table-account::before {
  content: "\\F13B9"; }

.mdi-table-alert::before {
  content: "\\F13BA"; }

.mdi-table-arrow-down::before {
  content: "\\F13BB"; }

.mdi-table-arrow-left::before {
  content: "\\F13BC"; }

.mdi-table-arrow-right::before {
  content: "\\F13BD"; }

.mdi-table-arrow-up::before {
  content: "\\F13BE"; }

.mdi-table-border::before {
  content: "\\F0A18"; }

.mdi-table-cancel::before {
  content: "\\F13BF"; }

.mdi-table-chair::before {
  content: "\\F1061"; }

.mdi-table-check::before {
  content: "\\F13C0"; }

.mdi-table-clock::before {
  content: "\\F13C1"; }

.mdi-table-cog::before {
  content: "\\F13C2"; }

.mdi-table-column::before {
  content: "\\F0835"; }

.mdi-table-column-plus-after::before {
  content: "\\F04EC"; }

.mdi-table-column-plus-before::before {
  content: "\\F04ED"; }

.mdi-table-column-remove::before {
  content: "\\F04EE"; }

.mdi-table-column-width::before {
  content: "\\F04EF"; }

.mdi-table-edit::before {
  content: "\\F04F0"; }

.mdi-table-eye::before {
  content: "\\F1094"; }

.mdi-table-eye-off::before {
  content: "\\F13C3"; }

.mdi-table-furniture::before {
  content: "\\F05BC"; }

.mdi-table-headers-eye::before {
  content: "\\F121D"; }

.mdi-table-headers-eye-off::before {
  content: "\\F121E"; }

.mdi-table-heart::before {
  content: "\\F13C4"; }

.mdi-table-key::before {
  content: "\\F13C5"; }

.mdi-table-large::before {
  content: "\\F04F1"; }

.mdi-table-large-plus::before {
  content: "\\F0F87"; }

.mdi-table-large-remove::before {
  content: "\\F0F88"; }

.mdi-table-lock::before {
  content: "\\F13C6"; }

.mdi-table-merge-cells::before {
  content: "\\F09A6"; }

.mdi-table-minus::before {
  content: "\\F13C7"; }

.mdi-table-multiple::before {
  content: "\\F13C8"; }

.mdi-table-network::before {
  content: "\\F13C9"; }

.mdi-table-of-contents::before {
  content: "\\F0836"; }

.mdi-table-off::before {
  content: "\\F13CA"; }

.mdi-table-picnic::before {
  content: "\\F1743"; }

.mdi-table-plus::before {
  content: "\\F0A75"; }

.mdi-table-refresh::before {
  content: "\\F13A0"; }

.mdi-table-remove::before {
  content: "\\F0A76"; }

.mdi-table-row::before {
  content: "\\F0837"; }

.mdi-table-row-height::before {
  content: "\\F04F2"; }

.mdi-table-row-plus-after::before {
  content: "\\F04F3"; }

.mdi-table-row-plus-before::before {
  content: "\\F04F4"; }

.mdi-table-row-remove::before {
  content: "\\F04F5"; }

.mdi-table-search::before {
  content: "\\F090F"; }

.mdi-table-settings::before {
  content: "\\F0838"; }

.mdi-table-split-cell::before {
  content: "\\F142A"; }

.mdi-table-star::before {
  content: "\\F13CB"; }

.mdi-table-sync::before {
  content: "\\F13A1"; }

.mdi-table-tennis::before {
  content: "\\F0E68"; }

.mdi-tablet::before {
  content: "\\F04F6"; }

.mdi-tablet-android::before {
  content: "\\F04F7"; }

.mdi-tablet-cellphone::before {
  content: "\\F09A7"; }

.mdi-tablet-dashboard::before {
  content: "\\F0ECE"; }

.mdi-tablet-ipad::before {
  content: "\\F04F8"; }

.mdi-taco::before {
  content: "\\F0762"; }

.mdi-tag::before {
  content: "\\F04F9"; }

.mdi-tag-arrow-down::before {
  content: "\\F172B"; }

.mdi-tag-arrow-down-outline::before {
  content: "\\F172C"; }

.mdi-tag-arrow-left::before {
  content: "\\F172D"; }

.mdi-tag-arrow-left-outline::before {
  content: "\\F172E"; }

.mdi-tag-arrow-right::before {
  content: "\\F172F"; }

.mdi-tag-arrow-right-outline::before {
  content: "\\F1730"; }

.mdi-tag-arrow-up::before {
  content: "\\F1731"; }

.mdi-tag-arrow-up-outline::before {
  content: "\\F1732"; }

.mdi-tag-faces::before {
  content: "\\F04FA"; }

.mdi-tag-heart::before {
  content: "\\F068B"; }

.mdi-tag-heart-outline::before {
  content: "\\F0BCF"; }

.mdi-tag-minus::before {
  content: "\\F0910"; }

.mdi-tag-minus-outline::before {
  content: "\\F121F"; }

.mdi-tag-multiple::before {
  content: "\\F04FB"; }

.mdi-tag-multiple-outline::before {
  content: "\\F12F7"; }

.mdi-tag-off::before {
  content: "\\F1220"; }

.mdi-tag-off-outline::before {
  content: "\\F1221"; }

.mdi-tag-outline::before {
  content: "\\F04FC"; }

.mdi-tag-plus::before {
  content: "\\F0722"; }

.mdi-tag-plus-outline::before {
  content: "\\F1222"; }

.mdi-tag-remove::before {
  content: "\\F0723"; }

.mdi-tag-remove-outline::before {
  content: "\\F1223"; }

.mdi-tag-text::before {
  content: "\\F1224"; }

.mdi-tag-text-outline::before {
  content: "\\F04FD"; }

.mdi-tailwind::before {
  content: "\\F13FF"; }

.mdi-tank::before {
  content: "\\F0D3A"; }

.mdi-tanker-truck::before {
  content: "\\F0FE5"; }

.mdi-tape-drive::before {
  content: "\\F16DF"; }

.mdi-tape-measure::before {
  content: "\\F0B4D"; }

.mdi-target::before {
  content: "\\F04FE"; }

.mdi-target-account::before {
  content: "\\F0BD0"; }

.mdi-target-variant::before {
  content: "\\F0A77"; }

.mdi-taxi::before {
  content: "\\F04FF"; }

.mdi-tea::before {
  content: "\\F0D9E"; }

.mdi-tea-outline::before {
  content: "\\F0D9F"; }

.mdi-teach::before {
  content: "\\F0890"; }

.mdi-teamviewer::before {
  content: "\\F0500"; }

.mdi-telegram::before {
  content: "\\F0501"; }

.mdi-telescope::before {
  content: "\\F0B4E"; }

.mdi-television::before {
  content: "\\F0502"; }

.mdi-television-ambient-light::before {
  content: "\\F1356"; }

.mdi-television-box::before {
  content: "\\F0839"; }

.mdi-television-classic::before {
  content: "\\F07F4"; }

.mdi-television-classic-off::before {
  content: "\\F083A"; }

.mdi-television-clean::before {
  content: "\\F1110"; }

.mdi-television-guide::before {
  content: "\\F0503"; }

.mdi-television-off::before {
  content: "\\F083B"; }

.mdi-television-pause::before {
  content: "\\F0F89"; }

.mdi-television-play::before {
  content: "\\F0ECF"; }

.mdi-television-stop::before {
  content: "\\F0F8A"; }

.mdi-temperature-celsius::before {
  content: "\\F0504"; }

.mdi-temperature-fahrenheit::before {
  content: "\\F0505"; }

.mdi-temperature-kelvin::before {
  content: "\\F0506"; }

.mdi-tennis::before {
  content: "\\F0DA0"; }

.mdi-tennis-ball::before {
  content: "\\F0507"; }

.mdi-tent::before {
  content: "\\F0508"; }

.mdi-terraform::before {
  content: "\\F1062"; }

.mdi-terrain::before {
  content: "\\F0509"; }

.mdi-test-tube::before {
  content: "\\F0668"; }

.mdi-test-tube-empty::before {
  content: "\\F0911"; }

.mdi-test-tube-off::before {
  content: "\\F0912"; }

.mdi-text::before {
  content: "\\F09A8"; }

.mdi-text-account::before {
  content: "\\F1570"; }

.mdi-text-box::before {
  content: "\\F021A"; }

.mdi-text-box-check::before {
  content: "\\F0EA6"; }

.mdi-text-box-check-outline::before {
  content: "\\F0EA7"; }

.mdi-text-box-minus::before {
  content: "\\F0EA8"; }

.mdi-text-box-minus-outline::before {
  content: "\\F0EA9"; }

.mdi-text-box-multiple::before {
  content: "\\F0AB7"; }

.mdi-text-box-multiple-outline::before {
  content: "\\F0AB8"; }

.mdi-text-box-outline::before {
  content: "\\F09ED"; }

.mdi-text-box-plus::before {
  content: "\\F0EAA"; }

.mdi-text-box-plus-outline::before {
  content: "\\F0EAB"; }

.mdi-text-box-remove::before {
  content: "\\F0EAC"; }

.mdi-text-box-remove-outline::before {
  content: "\\F0EAD"; }

.mdi-text-box-search::before {
  content: "\\F0EAE"; }

.mdi-text-box-search-outline::before {
  content: "\\F0EAF"; }

.mdi-text-recognition::before {
  content: "\\F113D"; }

.mdi-text-search::before {
  content: "\\F13B8"; }

.mdi-text-shadow::before {
  content: "\\F0669"; }

.mdi-text-short::before {
  content: "\\F09A9"; }

.mdi-text-subject::before {
  content: "\\F09AA"; }

.mdi-text-to-speech::before {
  content: "\\F050A"; }

.mdi-text-to-speech-off::before {
  content: "\\F050B"; }

.mdi-texture::before {
  content: "\\F050C"; }

.mdi-texture-box::before {
  content: "\\F0FE6"; }

.mdi-theater::before {
  content: "\\F050D"; }

.mdi-theme-light-dark::before {
  content: "\\F050E"; }

.mdi-thermometer::before {
  content: "\\F050F"; }

.mdi-thermometer-alert::before {
  content: "\\F0E01"; }

.mdi-thermometer-chevron-down::before {
  content: "\\F0E02"; }

.mdi-thermometer-chevron-up::before {
  content: "\\F0E03"; }

.mdi-thermometer-high::before {
  content: "\\F10C2"; }

.mdi-thermometer-lines::before {
  content: "\\F0510"; }

.mdi-thermometer-low::before {
  content: "\\F10C3"; }

.mdi-thermometer-minus::before {
  content: "\\F0E04"; }

.mdi-thermometer-off::before {
  content: "\\F1531"; }

.mdi-thermometer-plus::before {
  content: "\\F0E05"; }

.mdi-thermostat::before {
  content: "\\F0393"; }

.mdi-thermostat-box::before {
  content: "\\F0891"; }

.mdi-thought-bubble::before {
  content: "\\F07F6"; }

.mdi-thought-bubble-outline::before {
  content: "\\F07F7"; }

.mdi-thumb-down::before {
  content: "\\F0511"; }

.mdi-thumb-down-outline::before {
  content: "\\F0512"; }

.mdi-thumb-up::before {
  content: "\\F0513"; }

.mdi-thumb-up-outline::before {
  content: "\\F0514"; }

.mdi-thumbs-up-down::before {
  content: "\\F0515"; }

.mdi-ticket::before {
  content: "\\F0516"; }

.mdi-ticket-account::before {
  content: "\\F0517"; }

.mdi-ticket-confirmation::before {
  content: "\\F0518"; }

.mdi-ticket-confirmation-outline::before {
  content: "\\F13AA"; }

.mdi-ticket-outline::before {
  content: "\\F0913"; }

.mdi-ticket-percent::before {
  content: "\\F0724"; }

.mdi-ticket-percent-outline::before {
  content: "\\F142B"; }

.mdi-tie::before {
  content: "\\F0519"; }

.mdi-tilde::before {
  content: "\\F0725"; }

.mdi-timelapse::before {
  content: "\\F051A"; }

.mdi-timeline::before {
  content: "\\F0BD1"; }

.mdi-timeline-alert::before {
  content: "\\F0F95"; }

.mdi-timeline-alert-outline::before {
  content: "\\F0F98"; }

.mdi-timeline-check::before {
  content: "\\F1532"; }

.mdi-timeline-check-outline::before {
  content: "\\F1533"; }

.mdi-timeline-clock::before {
  content: "\\F11FB"; }

.mdi-timeline-clock-outline::before {
  content: "\\F11FC"; }

.mdi-timeline-help::before {
  content: "\\F0F99"; }

.mdi-timeline-help-outline::before {
  content: "\\F0F9A"; }

.mdi-timeline-minus::before {
  content: "\\F1534"; }

.mdi-timeline-minus-outline::before {
  content: "\\F1535"; }

.mdi-timeline-outline::before {
  content: "\\F0BD2"; }

.mdi-timeline-plus::before {
  content: "\\F0F96"; }

.mdi-timeline-plus-outline::before {
  content: "\\F0F97"; }

.mdi-timeline-remove::before {
  content: "\\F1536"; }

.mdi-timeline-remove-outline::before {
  content: "\\F1537"; }

.mdi-timeline-text::before {
  content: "\\F0BD3"; }

.mdi-timeline-text-outline::before {
  content: "\\F0BD4"; }

.mdi-timer::before {
  content: "\\F13AB"; }

.mdi-timer-10::before {
  content: "\\F051C"; }

.mdi-timer-3::before {
  content: "\\F051D"; }

.mdi-timer-off::before {
  content: "\\F13AC"; }

.mdi-timer-off-outline::before {
  content: "\\F051E"; }

.mdi-timer-outline::before {
  content: "\\F051B"; }

.mdi-timer-sand::before {
  content: "\\F051F"; }

.mdi-timer-sand-empty::before {
  content: "\\F06AD"; }

.mdi-timer-sand-full::before {
  content: "\\F078C"; }

.mdi-timetable::before {
  content: "\\F0520"; }

.mdi-toaster::before {
  content: "\\F1063"; }

.mdi-toaster-off::before {
  content: "\\F11B7"; }

.mdi-toaster-oven::before {
  content: "\\F0CD3"; }

.mdi-toggle-switch::before {
  content: "\\F0521"; }

.mdi-toggle-switch-off::before {
  content: "\\F0522"; }

.mdi-toggle-switch-off-outline::before {
  content: "\\F0A19"; }

.mdi-toggle-switch-outline::before {
  content: "\\F0A1A"; }

.mdi-toilet::before {
  content: "\\F09AB"; }

.mdi-toolbox::before {
  content: "\\F09AC"; }

.mdi-toolbox-outline::before {
  content: "\\F09AD"; }

.mdi-tools::before {
  content: "\\F1064"; }

.mdi-tooltip::before {
  content: "\\F0523"; }

.mdi-tooltip-account::before {
  content: "\\F000C"; }

.mdi-tooltip-check::before {
  content: "\\F155C"; }

.mdi-tooltip-check-outline::before {
  content: "\\F155D"; }

.mdi-tooltip-edit::before {
  content: "\\F0524"; }

.mdi-tooltip-edit-outline::before {
  content: "\\F12C5"; }

.mdi-tooltip-image::before {
  content: "\\F0525"; }

.mdi-tooltip-image-outline::before {
  content: "\\F0BD5"; }

.mdi-tooltip-minus::before {
  content: "\\F155E"; }

.mdi-tooltip-minus-outline::before {
  content: "\\F155F"; }

.mdi-tooltip-outline::before {
  content: "\\F0526"; }

.mdi-tooltip-plus::before {
  content: "\\F0BD6"; }

.mdi-tooltip-plus-outline::before {
  content: "\\F0527"; }

.mdi-tooltip-remove::before {
  content: "\\F1560"; }

.mdi-tooltip-remove-outline::before {
  content: "\\F1561"; }

.mdi-tooltip-text::before {
  content: "\\F0528"; }

.mdi-tooltip-text-outline::before {
  content: "\\F0BD7"; }

.mdi-tooth::before {
  content: "\\F08C3"; }

.mdi-tooth-outline::before {
  content: "\\F0529"; }

.mdi-toothbrush::before {
  content: "\\F1129"; }

.mdi-toothbrush-electric::before {
  content: "\\F112C"; }

.mdi-toothbrush-paste::before {
  content: "\\F112A"; }

.mdi-torch::before {
  content: "\\F1606"; }

.mdi-tortoise::before {
  content: "\\F0D3B"; }

.mdi-toslink::before {
  content: "\\F12B8"; }

.mdi-tournament::before {
  content: "\\F09AE"; }

.mdi-tow-truck::before {
  content: "\\F083C"; }

.mdi-tower-beach::before {
  content: "\\F0681"; }

.mdi-tower-fire::before {
  content: "\\F0682"; }

.mdi-toy-brick::before {
  content: "\\F1288"; }

.mdi-toy-brick-marker::before {
  content: "\\F1289"; }

.mdi-toy-brick-marker-outline::before {
  content: "\\F128A"; }

.mdi-toy-brick-minus::before {
  content: "\\F128B"; }

.mdi-toy-brick-minus-outline::before {
  content: "\\F128C"; }

.mdi-toy-brick-outline::before {
  content: "\\F128D"; }

.mdi-toy-brick-plus::before {
  content: "\\F128E"; }

.mdi-toy-brick-plus-outline::before {
  content: "\\F128F"; }

.mdi-toy-brick-remove::before {
  content: "\\F1290"; }

.mdi-toy-brick-remove-outline::before {
  content: "\\F1291"; }

.mdi-toy-brick-search::before {
  content: "\\F1292"; }

.mdi-toy-brick-search-outline::before {
  content: "\\F1293"; }

.mdi-track-light::before {
  content: "\\F0914"; }

.mdi-trackpad::before {
  content: "\\F07F8"; }

.mdi-trackpad-lock::before {
  content: "\\F0933"; }

.mdi-tractor::before {
  content: "\\F0892"; }

.mdi-tractor-variant::before {
  content: "\\F14C4"; }

.mdi-trademark::before {
  content: "\\F0A78"; }

.mdi-traffic-cone::before {
  content: "\\F137C"; }

.mdi-traffic-light::before {
  content: "\\F052B"; }

.mdi-train::before {
  content: "\\F052C"; }

.mdi-train-car::before {
  content: "\\F0BD8"; }

.mdi-train-car-passenger::before {
  content: "\\F1733"; }

.mdi-train-car-passenger-door::before {
  content: "\\F1734"; }

.mdi-train-car-passenger-door-open::before {
  content: "\\F1735"; }

.mdi-train-car-passenger-variant::before {
  content: "\\F1736"; }

.mdi-train-variant::before {
  content: "\\F08C4"; }

.mdi-tram::before {
  content: "\\F052D"; }

.mdi-tram-side::before {
  content: "\\F0FE7"; }

.mdi-transcribe::before {
  content: "\\F052E"; }

.mdi-transcribe-close::before {
  content: "\\F052F"; }

.mdi-transfer::before {
  content: "\\F1065"; }

.mdi-transfer-down::before {
  content: "\\F0DA1"; }

.mdi-transfer-left::before {
  content: "\\F0DA2"; }

.mdi-transfer-right::before {
  content: "\\F0530"; }

.mdi-transfer-up::before {
  content: "\\F0DA3"; }

.mdi-transit-connection::before {
  content: "\\F0D3C"; }

.mdi-transit-connection-horizontal::before {
  content: "\\F1546"; }

.mdi-transit-connection-variant::before {
  content: "\\F0D3D"; }

.mdi-transit-detour::before {
  content: "\\F0F8B"; }

.mdi-transit-skip::before {
  content: "\\F1515"; }

.mdi-transit-transfer::before {
  content: "\\F06AE"; }

.mdi-transition::before {
  content: "\\F0915"; }

.mdi-transition-masked::before {
  content: "\\F0916"; }

.mdi-translate::before {
  content: "\\F05CA"; }

.mdi-translate-off::before {
  content: "\\F0E06"; }

.mdi-transmission-tower::before {
  content: "\\F0D3E"; }

.mdi-trash-can::before {
  content: "\\F0A79"; }

.mdi-trash-can-outline::before {
  content: "\\F0A7A"; }

.mdi-tray::before {
  content: "\\F1294"; }

.mdi-tray-alert::before {
  content: "\\F1295"; }

.mdi-tray-full::before {
  content: "\\F1296"; }

.mdi-tray-minus::before {
  content: "\\F1297"; }

.mdi-tray-plus::before {
  content: "\\F1298"; }

.mdi-tray-remove::before {
  content: "\\F1299"; }

.mdi-treasure-chest::before {
  content: "\\F0726"; }

.mdi-tree::before {
  content: "\\F0531"; }

.mdi-tree-outline::before {
  content: "\\F0E69"; }

.mdi-trello::before {
  content: "\\F0532"; }

.mdi-trending-down::before {
  content: "\\F0533"; }

.mdi-trending-neutral::before {
  content: "\\F0534"; }

.mdi-trending-up::before {
  content: "\\F0535"; }

.mdi-triangle::before {
  content: "\\F0536"; }

.mdi-triangle-outline::before {
  content: "\\F0537"; }

.mdi-triangle-wave::before {
  content: "\\F147C"; }

.mdi-triforce::before {
  content: "\\F0BD9"; }

.mdi-trophy::before {
  content: "\\F0538"; }

.mdi-trophy-award::before {
  content: "\\F0539"; }

.mdi-trophy-broken::before {
  content: "\\F0DA4"; }

.mdi-trophy-outline::before {
  content: "\\F053A"; }

.mdi-trophy-variant::before {
  content: "\\F053B"; }

.mdi-trophy-variant-outline::before {
  content: "\\F053C"; }

.mdi-truck::before {
  content: "\\F053D"; }

.mdi-truck-check::before {
  content: "\\F0CD4"; }

.mdi-truck-check-outline::before {
  content: "\\F129A"; }

.mdi-truck-delivery::before {
  content: "\\F053E"; }

.mdi-truck-delivery-outline::before {
  content: "\\F129B"; }

.mdi-truck-fast::before {
  content: "\\F0788"; }

.mdi-truck-fast-outline::before {
  content: "\\F129C"; }

.mdi-truck-outline::before {
  content: "\\F129D"; }

.mdi-truck-trailer::before {
  content: "\\F0727"; }

.mdi-trumpet::before {
  content: "\\F1096"; }

.mdi-tshirt-crew::before {
  content: "\\F0A7B"; }

.mdi-tshirt-crew-outline::before {
  content: "\\F053F"; }

.mdi-tshirt-v::before {
  content: "\\F0A7C"; }

.mdi-tshirt-v-outline::before {
  content: "\\F0540"; }

.mdi-tumble-dryer::before {
  content: "\\F0917"; }

.mdi-tumble-dryer-alert::before {
  content: "\\F11BA"; }

.mdi-tumble-dryer-off::before {
  content: "\\F11BB"; }

.mdi-tune::before {
  content: "\\F062E"; }

.mdi-tune-variant::before {
  content: "\\F1542"; }

.mdi-tune-vertical::before {
  content: "\\F066A"; }

.mdi-tune-vertical-variant::before {
  content: "\\F1543"; }

.mdi-turkey::before {
  content: "\\F171B"; }

.mdi-turnstile::before {
  content: "\\F0CD5"; }

.mdi-turnstile-outline::before {
  content: "\\F0CD6"; }

.mdi-turtle::before {
  content: "\\F0CD7"; }

.mdi-twitch::before {
  content: "\\F0543"; }

.mdi-twitter::before {
  content: "\\F0544"; }

.mdi-twitter-retweet::before {
  content: "\\F0547"; }

.mdi-two-factor-authentication::before {
  content: "\\F09AF"; }

.mdi-typewriter::before {
  content: "\\F0F2D"; }

.mdi-ubisoft::before {
  content: "\\F0BDA"; }

.mdi-ubuntu::before {
  content: "\\F0548"; }

.mdi-ufo::before {
  content: "\\F10C4"; }

.mdi-ufo-outline::before {
  content: "\\F10C5"; }

.mdi-ultra-high-definition::before {
  content: "\\F07F9"; }

.mdi-umbraco::before {
  content: "\\F0549"; }

.mdi-umbrella::before {
  content: "\\F054A"; }

.mdi-umbrella-closed::before {
  content: "\\F09B0"; }

.mdi-umbrella-closed-outline::before {
  content: "\\F13E2"; }

.mdi-umbrella-closed-variant::before {
  content: "\\F13E1"; }

.mdi-umbrella-outline::before {
  content: "\\F054B"; }

.mdi-undo::before {
  content: "\\F054C"; }

.mdi-undo-variant::before {
  content: "\\F054D"; }

.mdi-unfold-less-horizontal::before {
  content: "\\F054E"; }

.mdi-unfold-less-vertical::before {
  content: "\\F0760"; }

.mdi-unfold-more-horizontal::before {
  content: "\\F054F"; }

.mdi-unfold-more-vertical::before {
  content: "\\F0761"; }

.mdi-ungroup::before {
  content: "\\F0550"; }

.mdi-unicode::before {
  content: "\\F0ED0"; }

.mdi-unicorn::before {
  content: "\\F15C2"; }

.mdi-unicorn-variant::before {
  content: "\\F15C3"; }

.mdi-unicycle::before {
  content: "\\F15E5"; }

.mdi-unity::before {
  content: "\\F06AF"; }

.mdi-unreal::before {
  content: "\\F09B1"; }

.mdi-untappd::before {
  content: "\\F0551"; }

.mdi-update::before {
  content: "\\F06B0"; }

.mdi-upload::before {
  content: "\\F0552"; }

.mdi-upload-lock::before {
  content: "\\F1373"; }

.mdi-upload-lock-outline::before {
  content: "\\F1374"; }

.mdi-upload-multiple::before {
  content: "\\F083D"; }

.mdi-upload-network::before {
  content: "\\F06F6"; }

.mdi-upload-network-outline::before {
  content: "\\F0CD8"; }

.mdi-upload-off::before {
  content: "\\F10C6"; }

.mdi-upload-off-outline::before {
  content: "\\F10C7"; }

.mdi-upload-outline::before {
  content: "\\F0E07"; }

.mdi-usb::before {
  content: "\\F0553"; }

.mdi-usb-flash-drive::before {
  content: "\\F129E"; }

.mdi-usb-flash-drive-outline::before {
  content: "\\F129F"; }

.mdi-usb-port::before {
  content: "\\F11F0"; }

.mdi-valve::before {
  content: "\\F1066"; }

.mdi-valve-closed::before {
  content: "\\F1067"; }

.mdi-valve-open::before {
  content: "\\F1068"; }

.mdi-van-passenger::before {
  content: "\\F07FA"; }

.mdi-van-utility::before {
  content: "\\F07FB"; }

.mdi-vanish::before {
  content: "\\F07FC"; }

.mdi-vanish-quarter::before {
  content: "\\F1554"; }

.mdi-vanity-light::before {
  content: "\\F11E1"; }

.mdi-variable::before {
  content: "\\F0AE7"; }

.mdi-variable-box::before {
  content: "\\F1111"; }

.mdi-vector-arrange-above::before {
  content: "\\F0554"; }

.mdi-vector-arrange-below::before {
  content: "\\F0555"; }

.mdi-vector-bezier::before {
  content: "\\F0AE8"; }

.mdi-vector-circle::before {
  content: "\\F0556"; }

.mdi-vector-circle-variant::before {
  content: "\\F0557"; }

.mdi-vector-combine::before {
  content: "\\F0558"; }

.mdi-vector-curve::before {
  content: "\\F0559"; }

.mdi-vector-difference::before {
  content: "\\F055A"; }

.mdi-vector-difference-ab::before {
  content: "\\F055B"; }

.mdi-vector-difference-ba::before {
  content: "\\F055C"; }

.mdi-vector-ellipse::before {
  content: "\\F0893"; }

.mdi-vector-intersection::before {
  content: "\\F055D"; }

.mdi-vector-line::before {
  content: "\\F055E"; }

.mdi-vector-link::before {
  content: "\\F0FE8"; }

.mdi-vector-point::before {
  content: "\\F055F"; }

.mdi-vector-polygon::before {
  content: "\\F0560"; }

.mdi-vector-polyline::before {
  content: "\\F0561"; }

.mdi-vector-polyline-edit::before {
  content: "\\F1225"; }

.mdi-vector-polyline-minus::before {
  content: "\\F1226"; }

.mdi-vector-polyline-plus::before {
  content: "\\F1227"; }

.mdi-vector-polyline-remove::before {
  content: "\\F1228"; }

.mdi-vector-radius::before {
  content: "\\F074A"; }

.mdi-vector-rectangle::before {
  content: "\\F05C6"; }

.mdi-vector-selection::before {
  content: "\\F0562"; }

.mdi-vector-square::before {
  content: "\\F0001"; }

.mdi-vector-triangle::before {
  content: "\\F0563"; }

.mdi-vector-union::before {
  content: "\\F0564"; }

.mdi-vhs::before {
  content: "\\F0A1B"; }

.mdi-vibrate::before {
  content: "\\F0566"; }

.mdi-vibrate-off::before {
  content: "\\F0CD9"; }

.mdi-video::before {
  content: "\\F0567"; }

.mdi-video-3d::before {
  content: "\\F07FD"; }

.mdi-video-3d-off::before {
  content: "\\F13D9"; }

.mdi-video-3d-variant::before {
  content: "\\F0ED1"; }

.mdi-video-4k-box::before {
  content: "\\F083E"; }

.mdi-video-account::before {
  content: "\\F0919"; }

.mdi-video-box::before {
  content: "\\F00FD"; }

.mdi-video-box-off::before {
  content: "\\F00FE"; }

.mdi-video-check::before {
  content: "\\F1069"; }

.mdi-video-check-outline::before {
  content: "\\F106A"; }

.mdi-video-high-definition::before {
  content: "\\F152E"; }

.mdi-video-image::before {
  content: "\\F091A"; }

.mdi-video-input-antenna::before {
  content: "\\F083F"; }

.mdi-video-input-component::before {
  content: "\\F0840"; }

.mdi-video-input-hdmi::before {
  content: "\\F0841"; }

.mdi-video-input-scart::before {
  content: "\\F0F8C"; }

.mdi-video-input-svideo::before {
  content: "\\F0842"; }

.mdi-video-minus::before {
  content: "\\F09B2"; }

.mdi-video-minus-outline::before {
  content: "\\F02BA"; }

.mdi-video-off::before {
  content: "\\F0568"; }

.mdi-video-off-outline::before {
  content: "\\F0BDB"; }

.mdi-video-outline::before {
  content: "\\F0BDC"; }

.mdi-video-plus::before {
  content: "\\F09B3"; }

.mdi-video-plus-outline::before {
  content: "\\F01D3"; }

.mdi-video-stabilization::before {
  content: "\\F091B"; }

.mdi-video-switch::before {
  content: "\\F0569"; }

.mdi-video-switch-outline::before {
  content: "\\F0790"; }

.mdi-video-vintage::before {
  content: "\\F0A1C"; }

.mdi-video-wireless::before {
  content: "\\F0ED2"; }

.mdi-video-wireless-outline::before {
  content: "\\F0ED3"; }

.mdi-view-agenda::before {
  content: "\\F056A"; }

.mdi-view-agenda-outline::before {
  content: "\\F11D8"; }

.mdi-view-array::before {
  content: "\\F056B"; }

.mdi-view-array-outline::before {
  content: "\\F1485"; }

.mdi-view-carousel::before {
  content: "\\F056C"; }

.mdi-view-carousel-outline::before {
  content: "\\F1486"; }

.mdi-view-column::before {
  content: "\\F056D"; }

.mdi-view-column-outline::before {
  content: "\\F1487"; }

.mdi-view-comfy::before {
  content: "\\F0E6A"; }

.mdi-view-comfy-outline::before {
  content: "\\F1488"; }

.mdi-view-compact::before {
  content: "\\F0E6B"; }

.mdi-view-compact-outline::before {
  content: "\\F0E6C"; }

.mdi-view-dashboard::before {
  content: "\\F056E"; }

.mdi-view-dashboard-outline::before {
  content: "\\F0A1D"; }

.mdi-view-dashboard-variant::before {
  content: "\\F0843"; }

.mdi-view-dashboard-variant-outline::before {
  content: "\\F1489"; }

.mdi-view-day::before {
  content: "\\F056F"; }

.mdi-view-day-outline::before {
  content: "\\F148A"; }

.mdi-view-grid::before {
  content: "\\F0570"; }

.mdi-view-grid-outline::before {
  content: "\\F11D9"; }

.mdi-view-grid-plus::before {
  content: "\\F0F8D"; }

.mdi-view-grid-plus-outline::before {
  content: "\\F11DA"; }

.mdi-view-headline::before {
  content: "\\F0571"; }

.mdi-view-list::before {
  content: "\\F0572"; }

.mdi-view-list-outline::before {
  content: "\\F148B"; }

.mdi-view-module::before {
  content: "\\F0573"; }

.mdi-view-module-outline::before {
  content: "\\F148C"; }

.mdi-view-parallel::before {
  content: "\\F0728"; }

.mdi-view-parallel-outline::before {
  content: "\\F148D"; }

.mdi-view-quilt::before {
  content: "\\F0574"; }

.mdi-view-quilt-outline::before {
  content: "\\F148E"; }

.mdi-view-sequential::before {
  content: "\\F0729"; }

.mdi-view-sequential-outline::before {
  content: "\\F148F"; }

.mdi-view-split-horizontal::before {
  content: "\\F0BCB"; }

.mdi-view-split-vertical::before {
  content: "\\F0BCC"; }

.mdi-view-stream::before {
  content: "\\F0575"; }

.mdi-view-stream-outline::before {
  content: "\\F1490"; }

.mdi-view-week::before {
  content: "\\F0576"; }

.mdi-view-week-outline::before {
  content: "\\F1491"; }

.mdi-vimeo::before {
  content: "\\F0577"; }

.mdi-violin::before {
  content: "\\F060F"; }

.mdi-virtual-reality::before {
  content: "\\F0894"; }

.mdi-virus::before {
  content: "\\F13B6"; }

.mdi-virus-outline::before {
  content: "\\F13B7"; }

.mdi-vk::before {
  content: "\\F0579"; }

.mdi-vlc::before {
  content: "\\F057C"; }

.mdi-voice-off::before {
  content: "\\F0ED4"; }

.mdi-voicemail::before {
  content: "\\F057D"; }

.mdi-volleyball::before {
  content: "\\F09B4"; }

.mdi-volume-high::before {
  content: "\\F057E"; }

.mdi-volume-low::before {
  content: "\\F057F"; }

.mdi-volume-medium::before {
  content: "\\F0580"; }

.mdi-volume-minus::before {
  content: "\\F075E"; }

.mdi-volume-mute::before {
  content: "\\F075F"; }

.mdi-volume-off::before {
  content: "\\F0581"; }

.mdi-volume-plus::before {
  content: "\\F075D"; }

.mdi-volume-source::before {
  content: "\\F1120"; }

.mdi-volume-variant-off::before {
  content: "\\F0E08"; }

.mdi-volume-vibrate::before {
  content: "\\F1121"; }

.mdi-vote::before {
  content: "\\F0A1F"; }

.mdi-vote-outline::before {
  content: "\\F0A20"; }

.mdi-vpn::before {
  content: "\\F0582"; }

.mdi-vuejs::before {
  content: "\\F0844"; }

.mdi-vuetify::before {
  content: "\\F0E6D"; }

.mdi-walk::before {
  content: "\\F0583"; }

.mdi-wall::before {
  content: "\\F07FE"; }

.mdi-wall-sconce::before {
  content: "\\F091C"; }

.mdi-wall-sconce-flat::before {
  content: "\\F091D"; }

.mdi-wall-sconce-flat-variant::before {
  content: "\\F041C"; }

.mdi-wall-sconce-round::before {
  content: "\\F0748"; }

.mdi-wall-sconce-round-variant::before {
  content: "\\F091E"; }

.mdi-wallet::before {
  content: "\\F0584"; }

.mdi-wallet-giftcard::before {
  content: "\\F0585"; }

.mdi-wallet-membership::before {
  content: "\\F0586"; }

.mdi-wallet-outline::before {
  content: "\\F0BDD"; }

.mdi-wallet-plus::before {
  content: "\\F0F8E"; }

.mdi-wallet-plus-outline::before {
  content: "\\F0F8F"; }

.mdi-wallet-travel::before {
  content: "\\F0587"; }

.mdi-wallpaper::before {
  content: "\\F0E09"; }

.mdi-wan::before {
  content: "\\F0588"; }

.mdi-wardrobe::before {
  content: "\\F0F90"; }

.mdi-wardrobe-outline::before {
  content: "\\F0F91"; }

.mdi-warehouse::before {
  content: "\\F0F81"; }

.mdi-washing-machine::before {
  content: "\\F072A"; }

.mdi-washing-machine-alert::before {
  content: "\\F11BC"; }

.mdi-washing-machine-off::before {
  content: "\\F11BD"; }

.mdi-watch::before {
  content: "\\F0589"; }

.mdi-watch-export::before {
  content: "\\F058A"; }

.mdi-watch-export-variant::before {
  content: "\\F0895"; }

.mdi-watch-import::before {
  content: "\\F058B"; }

.mdi-watch-import-variant::before {
  content: "\\F0896"; }

.mdi-watch-variant::before {
  content: "\\F0897"; }

.mdi-watch-vibrate::before {
  content: "\\F06B1"; }

.mdi-watch-vibrate-off::before {
  content: "\\F0CDA"; }

.mdi-water::before {
  content: "\\F058C"; }

.mdi-water-alert::before {
  content: "\\F1502"; }

.mdi-water-alert-outline::before {
  content: "\\F1503"; }

.mdi-water-boiler::before {
  content: "\\F0F92"; }

.mdi-water-boiler-alert::before {
  content: "\\F11B3"; }

.mdi-water-boiler-off::before {
  content: "\\F11B4"; }

.mdi-water-check::before {
  content: "\\F1504"; }

.mdi-water-check-outline::before {
  content: "\\F1505"; }

.mdi-water-minus::before {
  content: "\\F1506"; }

.mdi-water-minus-outline::before {
  content: "\\F1507"; }

.mdi-water-off::before {
  content: "\\F058D"; }

.mdi-water-off-outline::before {
  content: "\\F1508"; }

.mdi-water-outline::before {
  content: "\\F0E0A"; }

.mdi-water-percent::before {
  content: "\\F058E"; }

.mdi-water-percent-alert::before {
  content: "\\F1509"; }

.mdi-water-plus::before {
  content: "\\F150A"; }

.mdi-water-plus-outline::before {
  content: "\\F150B"; }

.mdi-water-polo::before {
  content: "\\F12A0"; }

.mdi-water-pump::before {
  content: "\\F058F"; }

.mdi-water-pump-off::before {
  content: "\\F0F93"; }

.mdi-water-remove::before {
  content: "\\F150C"; }

.mdi-water-remove-outline::before {
  content: "\\F150D"; }

.mdi-water-well::before {
  content: "\\F106B"; }

.mdi-water-well-outline::before {
  content: "\\F106C"; }

.mdi-watering-can::before {
  content: "\\F1481"; }

.mdi-watering-can-outline::before {
  content: "\\F1482"; }

.mdi-watermark::before {
  content: "\\F0612"; }

.mdi-wave::before {
  content: "\\F0F2E"; }

.mdi-waveform::before {
  content: "\\F147D"; }

.mdi-waves::before {
  content: "\\F078D"; }

.mdi-waze::before {
  content: "\\F0BDE"; }

.mdi-weather-cloudy::before {
  content: "\\F0590"; }

.mdi-weather-cloudy-alert::before {
  content: "\\F0F2F"; }

.mdi-weather-cloudy-arrow-right::before {
  content: "\\F0E6E"; }

.mdi-weather-fog::before {
  content: "\\F0591"; }

.mdi-weather-hail::before {
  content: "\\F0592"; }

.mdi-weather-hazy::before {
  content: "\\F0F30"; }

.mdi-weather-hurricane::before {
  content: "\\F0898"; }

.mdi-weather-lightning::before {
  content: "\\F0593"; }

.mdi-weather-lightning-rainy::before {
  content: "\\F067E"; }

.mdi-weather-night::before {
  content: "\\F0594"; }

.mdi-weather-night-partly-cloudy::before {
  content: "\\F0F31"; }

.mdi-weather-partly-cloudy::before {
  content: "\\F0595"; }

.mdi-weather-partly-lightning::before {
  content: "\\F0F32"; }

.mdi-weather-partly-rainy::before {
  content: "\\F0F33"; }

.mdi-weather-partly-snowy::before {
  content: "\\F0F34"; }

.mdi-weather-partly-snowy-rainy::before {
  content: "\\F0F35"; }

.mdi-weather-pouring::before {
  content: "\\F0596"; }

.mdi-weather-rainy::before {
  content: "\\F0597"; }

.mdi-weather-snowy::before {
  content: "\\F0598"; }

.mdi-weather-snowy-heavy::before {
  content: "\\F0F36"; }

.mdi-weather-snowy-rainy::before {
  content: "\\F067F"; }

.mdi-weather-sunny::before {
  content: "\\F0599"; }

.mdi-weather-sunny-alert::before {
  content: "\\F0F37"; }

.mdi-weather-sunny-off::before {
  content: "\\F14E4"; }

.mdi-weather-sunset::before {
  content: "\\F059A"; }

.mdi-weather-sunset-down::before {
  content: "\\F059B"; }

.mdi-weather-sunset-up::before {
  content: "\\F059C"; }

.mdi-weather-tornado::before {
  content: "\\F0F38"; }

.mdi-weather-windy::before {
  content: "\\F059D"; }

.mdi-weather-windy-variant::before {
  content: "\\F059E"; }

.mdi-web::before {
  content: "\\F059F"; }

.mdi-web-box::before {
  content: "\\F0F94"; }

.mdi-web-clock::before {
  content: "\\F124A"; }

.mdi-webcam::before {
  content: "\\F05A0"; }

.mdi-webcam-off::before {
  content: "\\F1737"; }

.mdi-webhook::before {
  content: "\\F062F"; }

.mdi-webpack::before {
  content: "\\F072B"; }

.mdi-webrtc::before {
  content: "\\F1248"; }

.mdi-wechat::before {
  content: "\\F0611"; }

.mdi-weight::before {
  content: "\\F05A1"; }

.mdi-weight-gram::before {
  content: "\\F0D3F"; }

.mdi-weight-kilogram::before {
  content: "\\F05A2"; }

.mdi-weight-lifter::before {
  content: "\\F115D"; }

.mdi-weight-pound::before {
  content: "\\F09B5"; }

.mdi-whatsapp::before {
  content: "\\F05A3"; }

.mdi-wheel-barrow::before {
  content: "\\F14F2"; }

.mdi-wheelchair-accessibility::before {
  content: "\\F05A4"; }

.mdi-whistle::before {
  content: "\\F09B6"; }

.mdi-whistle-outline::before {
  content: "\\F12BC"; }

.mdi-white-balance-auto::before {
  content: "\\F05A5"; }

.mdi-white-balance-incandescent::before {
  content: "\\F05A6"; }

.mdi-white-balance-iridescent::before {
  content: "\\F05A7"; }

.mdi-white-balance-sunny::before {
  content: "\\F05A8"; }

.mdi-widgets::before {
  content: "\\F072C"; }

.mdi-widgets-outline::before {
  content: "\\F1355"; }

.mdi-wifi::before {
  content: "\\F05A9"; }

.mdi-wifi-alert::before {
  content: "\\F16B5"; }

.mdi-wifi-arrow-down::before {
  content: "\\F16B6"; }

.mdi-wifi-arrow-left::before {
  content: "\\F16B7"; }

.mdi-wifi-arrow-left-right::before {
  content: "\\F16B8"; }

.mdi-wifi-arrow-right::before {
  content: "\\F16B9"; }

.mdi-wifi-arrow-up::before {
  content: "\\F16BA"; }

.mdi-wifi-arrow-up-down::before {
  content: "\\F16BB"; }

.mdi-wifi-cancel::before {
  content: "\\F16BC"; }

.mdi-wifi-check::before {
  content: "\\F16BD"; }

.mdi-wifi-cog::before {
  content: "\\F16BE"; }

.mdi-wifi-lock::before {
  content: "\\F16BF"; }

.mdi-wifi-lock-open::before {
  content: "\\F16C0"; }

.mdi-wifi-marker::before {
  content: "\\F16C1"; }

.mdi-wifi-minus::before {
  content: "\\F16C2"; }

.mdi-wifi-off::before {
  content: "\\F05AA"; }

.mdi-wifi-plus::before {
  content: "\\F16C3"; }

.mdi-wifi-refresh::before {
  content: "\\F16C4"; }

.mdi-wifi-remove::before {
  content: "\\F16C5"; }

.mdi-wifi-settings::before {
  content: "\\F16C6"; }

.mdi-wifi-star::before {
  content: "\\F0E0B"; }

.mdi-wifi-strength-1::before {
  content: "\\F091F"; }

.mdi-wifi-strength-1-alert::before {
  content: "\\F0920"; }

.mdi-wifi-strength-1-lock::before {
  content: "\\F0921"; }

.mdi-wifi-strength-1-lock-open::before {
  content: "\\F16CB"; }

.mdi-wifi-strength-2::before {
  content: "\\F0922"; }

.mdi-wifi-strength-2-alert::before {
  content: "\\F0923"; }

.mdi-wifi-strength-2-lock::before {
  content: "\\F0924"; }

.mdi-wifi-strength-2-lock-open::before {
  content: "\\F16CC"; }

.mdi-wifi-strength-3::before {
  content: "\\F0925"; }

.mdi-wifi-strength-3-alert::before {
  content: "\\F0926"; }

.mdi-wifi-strength-3-lock::before {
  content: "\\F0927"; }

.mdi-wifi-strength-3-lock-open::before {
  content: "\\F16CD"; }

.mdi-wifi-strength-4::before {
  content: "\\F0928"; }

.mdi-wifi-strength-4-alert::before {
  content: "\\F0929"; }

.mdi-wifi-strength-4-lock::before {
  content: "\\F092A"; }

.mdi-wifi-strength-4-lock-open::before {
  content: "\\F16CE"; }

.mdi-wifi-strength-alert-outline::before {
  content: "\\F092B"; }

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\F16CF"; }

.mdi-wifi-strength-lock-outline::before {
  content: "\\F092C"; }

.mdi-wifi-strength-off::before {
  content: "\\F092D"; }

.mdi-wifi-strength-off-outline::before {
  content: "\\F092E"; }

.mdi-wifi-strength-outline::before {
  content: "\\F092F"; }

.mdi-wifi-sync::before {
  content: "\\F16C7"; }

.mdi-wikipedia::before {
  content: "\\F05AC"; }

.mdi-wind-turbine::before {
  content: "\\F0DA5"; }

.mdi-window-close::before {
  content: "\\F05AD"; }

.mdi-window-closed::before {
  content: "\\F05AE"; }

.mdi-window-closed-variant::before {
  content: "\\F11DB"; }

.mdi-window-maximize::before {
  content: "\\F05AF"; }

.mdi-window-minimize::before {
  content: "\\F05B0"; }

.mdi-window-open::before {
  content: "\\F05B1"; }

.mdi-window-open-variant::before {
  content: "\\F11DC"; }

.mdi-window-restore::before {
  content: "\\F05B2"; }

.mdi-window-shutter::before {
  content: "\\F111C"; }

.mdi-window-shutter-alert::before {
  content: "\\F111D"; }

.mdi-window-shutter-open::before {
  content: "\\F111E"; }

.mdi-windsock::before {
  content: "\\F15FA"; }

.mdi-wiper::before {
  content: "\\F0AE9"; }

.mdi-wiper-wash::before {
  content: "\\F0DA6"; }

.mdi-wizard-hat::before {
  content: "\\F1477"; }

.mdi-wordpress::before {
  content: "\\F05B4"; }

.mdi-wrap::before {
  content: "\\F05B6"; }

.mdi-wrap-disabled::before {
  content: "\\F0BDF"; }

.mdi-wrench::before {
  content: "\\F05B7"; }

.mdi-wrench-outline::before {
  content: "\\F0BE0"; }

.mdi-xamarin::before {
  content: "\\F0845"; }

.mdi-xamarin-outline::before {
  content: "\\F0846"; }

.mdi-xing::before {
  content: "\\F05BE"; }

.mdi-xml::before {
  content: "\\F05C0"; }

.mdi-xmpp::before {
  content: "\\F07FF"; }

.mdi-y-combinator::before {
  content: "\\F0624"; }

.mdi-yahoo::before {
  content: "\\F0B4F"; }

.mdi-yeast::before {
  content: "\\F05C1"; }

.mdi-yin-yang::before {
  content: "\\F0680"; }

.mdi-yoga::before {
  content: "\\F117C"; }

.mdi-youtube::before {
  content: "\\F05C3"; }

.mdi-youtube-gaming::before {
  content: "\\F0848"; }

.mdi-youtube-studio::before {
  content: "\\F0847"; }

.mdi-youtube-subscription::before {
  content: "\\F0D40"; }

.mdi-youtube-tv::before {
  content: "\\F0448"; }

.mdi-yurt::before {
  content: "\\F1516"; }

.mdi-z-wave::before {
  content: "\\F0AEA"; }

.mdi-zend::before {
  content: "\\F0AEB"; }

.mdi-zigbee::before {
  content: "\\F0D41"; }

.mdi-zip-box::before {
  content: "\\F05C4"; }

.mdi-zip-box-outline::before {
  content: "\\F0FFA"; }

.mdi-zip-disk::before {
  content: "\\F0A23"; }

.mdi-zodiac-aquarius::before {
  content: "\\F0A7D"; }

.mdi-zodiac-aries::before {
  content: "\\F0A7E"; }

.mdi-zodiac-cancer::before {
  content: "\\F0A7F"; }

.mdi-zodiac-capricorn::before {
  content: "\\F0A80"; }

.mdi-zodiac-gemini::before {
  content: "\\F0A81"; }

.mdi-zodiac-leo::before {
  content: "\\F0A82"; }

.mdi-zodiac-libra::before {
  content: "\\F0A83"; }

.mdi-zodiac-pisces::before {
  content: "\\F0A84"; }

.mdi-zodiac-sagittarius::before {
  content: "\\F0A85"; }

.mdi-zodiac-scorpio::before {
  content: "\\F0A86"; }

.mdi-zodiac-taurus::before {
  content: "\\F0A87"; }

.mdi-zodiac-virgo::before {
  content: "\\F0A88"; }

.mdi-blank::before {
  content: "\\F68C";
  visibility: hidden; }

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px; }

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px; }

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px; }

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px; }

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54); }

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26); }

.mdi-light:before {
  color: white; }

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3); }

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-45:before {
  transform: rotate(45deg); }

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-90:before {
  transform: rotate(90deg); }

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-135:before {
  transform: rotate(135deg); }

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-180:before {
  transform: rotate(180deg); }

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-225:before {
  transform: rotate(225deg); }

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-270:before {
  transform: rotate(270deg); }

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-315:before {
  transform: rotate(315deg); }

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH"; }

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV"; }

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear; }

@keyframes mdi-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(359deg); } }

/*# sourceMappingURL=materialdesignicons.css.map */
@font-face {
  font-family: "dripicons-v2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
  font-weight: normal;
  font-style: normal; }

[data-icon]:before {
  font-family: "dripicons-v2" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

[class^="dripicons-"]:before,
[class*=" dripicons-"]:before {
  font-family: "dripicons-v2" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.dripicons-alarm:before {
  content: "\\61"; }

.dripicons-align-center:before {
  content: "\\62"; }

.dripicons-align-justify:before {
  content: "\\63"; }

.dripicons-align-left:before {
  content: "\\64"; }

.dripicons-align-right:before {
  content: "\\65"; }

.dripicons-anchor:before {
  content: "\\66"; }

.dripicons-archive:before {
  content: "\\67"; }

.dripicons-arrow-down:before {
  content: "\\68"; }

.dripicons-arrow-left:before {
  content: "\\69"; }

.dripicons-arrow-right:before {
  content: "\\6a"; }

.dripicons-arrow-thin-down:before {
  content: "\\6b"; }

.dripicons-arrow-thin-left:before {
  content: "\\6c"; }

.dripicons-arrow-thin-right:before {
  content: "\\6d"; }

.dripicons-arrow-thin-up:before {
  content: "\\6e"; }

.dripicons-arrow-up:before {
  content: "\\6f"; }

.dripicons-article:before {
  content: "\\70"; }

.dripicons-backspace:before {
  content: "\\71"; }

.dripicons-basket:before {
  content: "\\72"; }

.dripicons-basketball:before {
  content: "\\73"; }

.dripicons-battery-empty:before {
  content: "\\74"; }

.dripicons-battery-full:before {
  content: "\\75"; }

.dripicons-battery-low:before {
  content: "\\76"; }

.dripicons-battery-medium:before {
  content: "\\77"; }

.dripicons-bell:before {
  content: "\\78"; }

.dripicons-blog:before {
  content: "\\79"; }

.dripicons-bluetooth:before {
  content: "\\7a"; }

.dripicons-bold:before {
  content: "\\41"; }

.dripicons-bookmark:before {
  content: "\\42"; }

.dripicons-bookmarks:before {
  content: "\\43"; }

.dripicons-box:before {
  content: "\\44"; }

.dripicons-briefcase:before {
  content: "\\45"; }

.dripicons-brightness-low:before {
  content: "\\46"; }

.dripicons-brightness-max:before {
  content: "\\47"; }

.dripicons-brightness-medium:before {
  content: "\\48"; }

.dripicons-broadcast:before {
  content: "\\49"; }

.dripicons-browser:before {
  content: "\\4a"; }

.dripicons-browser-upload:before {
  content: "\\4b"; }

.dripicons-brush:before {
  content: "\\4c"; }

.dripicons-calendar:before {
  content: "\\4d"; }

.dripicons-camcorder:before {
  content: "\\4e"; }

.dripicons-camera:before {
  content: "\\4f"; }

.dripicons-card:before {
  content: "\\50"; }

.dripicons-cart:before {
  content: "\\51"; }

.dripicons-checklist:before {
  content: "\\52"; }

.dripicons-checkmark:before {
  content: "\\53"; }

.dripicons-chevron-down:before {
  content: "\\54"; }

.dripicons-chevron-left:before {
  content: "\\55"; }

.dripicons-chevron-right:before {
  content: "\\56"; }

.dripicons-chevron-up:before {
  content: "\\57"; }

.dripicons-clipboard:before {
  content: "\\58"; }

.dripicons-clock:before {
  content: "\\59"; }

.dripicons-clockwise:before {
  content: "\\5a"; }

.dripicons-cloud:before {
  content: "\\30"; }

.dripicons-cloud-download:before {
  content: "\\31"; }

.dripicons-cloud-upload:before {
  content: "\\32"; }

.dripicons-code:before {
  content: "\\33"; }

.dripicons-contract:before {
  content: "\\34"; }

.dripicons-contract-2:before {
  content: "\\35"; }

.dripicons-conversation:before {
  content: "\\36"; }

.dripicons-copy:before {
  content: "\\37"; }

.dripicons-crop:before {
  content: "\\38"; }

.dripicons-cross:before {
  content: "\\39"; }

.dripicons-crosshair:before {
  content: "\\21"; }

.dripicons-cutlery:before {
  content: "\\22"; }

.dripicons-device-desktop:before {
  content: "\\23"; }

.dripicons-device-mobile:before {
  content: "\\24"; }

.dripicons-device-tablet:before {
  content: "\\25"; }

.dripicons-direction:before {
  content: "\\26"; }

.dripicons-disc:before {
  content: "\\27"; }

.dripicons-document:before {
  content: "\\28"; }

.dripicons-document-delete:before {
  content: "\\29"; }

.dripicons-document-edit:before {
  content: "\\2a"; }

.dripicons-document-new:before {
  content: "\\2b"; }

.dripicons-document-remove:before {
  content: "\\2c"; }

.dripicons-dot:before {
  content: "\\2d"; }

.dripicons-dots-2:before {
  content: "\\2e"; }

.dripicons-dots-3:before {
  content: "\\2f"; }

.dripicons-download:before {
  content: "\\3a"; }

.dripicons-duplicate:before {
  content: "\\3b"; }

.dripicons-enter:before {
  content: "\\3c"; }

.dripicons-exit:before {
  content: "\\3d"; }

.dripicons-expand:before {
  content: "\\3e"; }

.dripicons-expand-2:before {
  content: "\\3f"; }

.dripicons-experiment:before {
  content: "\\40"; }

.dripicons-export:before {
  content: "\\5b"; }

.dripicons-feed:before {
  content: "\\5d"; }

.dripicons-flag:before {
  content: "\\5e"; }

.dripicons-flashlight:before {
  content: "\\5f"; }

.dripicons-folder:before {
  content: "\\60"; }

.dripicons-folder-open:before {
  content: "\\7b"; }

.dripicons-forward:before {
  content: "\\7c"; }

.dripicons-gaming:before {
  content: "\\7d"; }

.dripicons-gear:before {
  content: "\\7e"; }

.dripicons-graduation:before {
  content: "\\5c"; }

.dripicons-graph-bar:before {
  content: "\\e000"; }

.dripicons-graph-line:before {
  content: "\\e001"; }

.dripicons-graph-pie:before {
  content: "\\e002"; }

.dripicons-headset:before {
  content: "\\e003"; }

.dripicons-heart:before {
  content: "\\e004"; }

.dripicons-help:before {
  content: "\\e005"; }

.dripicons-home:before {
  content: "\\e006"; }

.dripicons-hourglass:before {
  content: "\\e007"; }

.dripicons-inbox:before {
  content: "\\e008"; }

.dripicons-information:before {
  content: "\\e009"; }

.dripicons-italic:before {
  content: "\\e00a"; }

.dripicons-jewel:before {
  content: "\\e00b"; }

.dripicons-lifting:before {
  content: "\\e00c"; }

.dripicons-lightbulb:before {
  content: "\\e00d"; }

.dripicons-link:before {
  content: "\\e00e"; }

.dripicons-link-broken:before {
  content: "\\e00f"; }

.dripicons-list:before {
  content: "\\e010"; }

.dripicons-loading:before {
  content: "\\e011"; }

.dripicons-location:before {
  content: "\\e012"; }

.dripicons-lock:before {
  content: "\\e013"; }

.dripicons-lock-open:before {
  content: "\\e014"; }

.dripicons-mail:before {
  content: "\\e015"; }

.dripicons-map:before {
  content: "\\e016"; }

.dripicons-media-loop:before {
  content: "\\e017"; }

.dripicons-media-next:before {
  content: "\\e018"; }

.dripicons-media-pause:before {
  content: "\\e019"; }

.dripicons-media-play:before {
  content: "\\e01a"; }

.dripicons-media-previous:before {
  content: "\\e01b"; }

.dripicons-media-record:before {
  content: "\\e01c"; }

.dripicons-media-shuffle:before {
  content: "\\e01d"; }

.dripicons-media-stop:before {
  content: "\\e01e"; }

.dripicons-medical:before {
  content: "\\e01f"; }

.dripicons-menu:before {
  content: "\\e020"; }

.dripicons-message:before {
  content: "\\e021"; }

.dripicons-meter:before {
  content: "\\e022"; }

.dripicons-microphone:before {
  content: "\\e023"; }

.dripicons-minus:before {
  content: "\\e024"; }

.dripicons-monitor:before {
  content: "\\e025"; }

.dripicons-move:before {
  content: "\\e026"; }

.dripicons-music:before {
  content: "\\e027"; }

.dripicons-network-1:before {
  content: "\\e028"; }

.dripicons-network-2:before {
  content: "\\e029"; }

.dripicons-network-3:before {
  content: "\\e02a"; }

.dripicons-network-4:before {
  content: "\\e02b"; }

.dripicons-network-5:before {
  content: "\\e02c"; }

.dripicons-pamphlet:before {
  content: "\\e02d"; }

.dripicons-paperclip:before {
  content: "\\e02e"; }

.dripicons-pencil:before {
  content: "\\e02f"; }

.dripicons-phone:before {
  content: "\\e030"; }

.dripicons-photo:before {
  content: "\\e031"; }

.dripicons-photo-group:before {
  content: "\\e032"; }

.dripicons-pill:before {
  content: "\\e033"; }

.dripicons-pin:before {
  content: "\\e034"; }

.dripicons-plus:before {
  content: "\\e035"; }

.dripicons-power:before {
  content: "\\e036"; }

.dripicons-preview:before {
  content: "\\e037"; }

.dripicons-print:before {
  content: "\\e038"; }

.dripicons-pulse:before {
  content: "\\e039"; }

.dripicons-question:before {
  content: "\\e03a"; }

.dripicons-reply:before {
  content: "\\e03b"; }

.dripicons-reply-all:before {
  content: "\\e03c"; }

.dripicons-return:before {
  content: "\\e03d"; }

.dripicons-retweet:before {
  content: "\\e03e"; }

.dripicons-rocket:before {
  content: "\\e03f"; }

.dripicons-scale:before {
  content: "\\e040"; }

.dripicons-search:before {
  content: "\\e041"; }

.dripicons-shopping-bag:before {
  content: "\\e042"; }

.dripicons-skip:before {
  content: "\\e043"; }

.dripicons-stack:before {
  content: "\\e044"; }

.dripicons-star:before {
  content: "\\e045"; }

.dripicons-stopwatch:before {
  content: "\\e046"; }

.dripicons-store:before {
  content: "\\e047"; }

.dripicons-suitcase:before {
  content: "\\e048"; }

.dripicons-swap:before {
  content: "\\e049"; }

.dripicons-tag:before {
  content: "\\e04a"; }

.dripicons-tag-delete:before {
  content: "\\e04b"; }

.dripicons-tags:before {
  content: "\\e04c"; }

.dripicons-thumbs-down:before {
  content: "\\e04d"; }

.dripicons-thumbs-up:before {
  content: "\\e04e"; }

.dripicons-ticket:before {
  content: "\\e04f"; }

.dripicons-time-reverse:before {
  content: "\\e050"; }

.dripicons-to-do:before {
  content: "\\e051"; }

.dripicons-toggles:before {
  content: "\\e052"; }

.dripicons-trash:before {
  content: "\\e053"; }

.dripicons-trophy:before {
  content: "\\e054"; }

.dripicons-upload:before {
  content: "\\e055"; }

.dripicons-user:before {
  content: "\\e056"; }

.dripicons-user-group:before {
  content: "\\e057"; }

.dripicons-user-id:before {
  content: "\\e058"; }

.dripicons-vibrate:before {
  content: "\\e059"; }

.dripicons-view-apps:before {
  content: "\\e05a"; }

.dripicons-view-list:before {
  content: "\\e05b"; }

.dripicons-view-list-large:before {
  content: "\\e05c"; }

.dripicons-view-thumb:before {
  content: "\\e05d"; }

.dripicons-volume-full:before {
  content: "\\e05e"; }

.dripicons-volume-low:before {
  content: "\\e05f"; }

.dripicons-volume-medium:before {
  content: "\\e060"; }

.dripicons-volume-off:before {
  content: "\\e061"; }

.dripicons-wallet:before {
  content: "\\e062"; }

.dripicons-warning:before {
  content: "\\e063"; }

.dripicons-web:before {
  content: "\\e064"; }

.dripicons-weight:before {
  content: "\\e065"; }

.dripicons-wifi:before {
  content: "\\e066"; }

.dripicons-wrong:before {
  content: "\\e067"; }

.dripicons-zoom-in:before {
  content: "\\e068"; }

.dripicons-zoom-out:before {
  content: "\\e069"; }

/*
* Remix Icon v2.4.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-04-20
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
  /* iOS 4.1- */
  font-display: swap; }

[class^="ri-"], [class*=" ri-"] {
  font-family: 'remixicon' !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -.075em; }

.ri-xxs {
  font-size: .5em; }

.ri-xs {
  font-size: .75em; }

.ri-sm {
  font-size: .875em; }

.ri-1x {
  font-size: 1em; }

.ri-2x {
  font-size: 2em; }

.ri-3x {
  font-size: 3em; }

.ri-4x {
  font-size: 4em; }

.ri-5x {
  font-size: 5em; }

.ri-6x {
  font-size: 6em; }

.ri-7x {
  font-size: 7em; }

.ri-8x {
  font-size: 8em; }

.ri-9x {
  font-size: 9em; }

.ri-10x {
  font-size: 10em; }

.ri-fw {
  text-align: center;
  width: 1.25em; }

.ri-4k-fill:before {
  content: "\\ea01"; }

.ri-4k-line:before {
  content: "\\ea02"; }

.ri-a-b:before {
  content: "\\ea03"; }

.ri-account-box-fill:before {
  content: "\\ea04"; }

.ri-account-box-line:before {
  content: "\\ea05"; }

.ri-account-circle-fill:before {
  content: "\\ea06"; }

.ri-account-circle-line:before {
  content: "\\ea07"; }

.ri-account-pin-box-fill:before {
  content: "\\ea08"; }

.ri-account-pin-box-line:before {
  content: "\\ea09"; }

.ri-account-pin-circle-fill:before {
  content: "\\ea0a"; }

.ri-account-pin-circle-line:before {
  content: "\\ea0b"; }

.ri-add-box-fill:before {
  content: "\\ea0c"; }

.ri-add-box-line:before {
  content: "\\ea0d"; }

.ri-add-circle-fill:before {
  content: "\\ea0e"; }

.ri-add-circle-line:before {
  content: "\\ea0f"; }

.ri-add-fill:before {
  content: "\\ea10"; }

.ri-add-line:before {
  content: "\\ea11"; }

.ri-admin-fill:before {
  content: "\\ea12"; }

.ri-admin-line:before {
  content: "\\ea13"; }

.ri-advertisement-fill:before {
  content: "\\ea14"; }

.ri-advertisement-line:before {
  content: "\\ea15"; }

.ri-airplay-fill:before {
  content: "\\ea16"; }

.ri-airplay-line:before {
  content: "\\ea17"; }

.ri-alarm-fill:before {
  content: "\\ea18"; }

.ri-alarm-line:before {
  content: "\\ea19"; }

.ri-alarm-warning-fill:before {
  content: "\\ea1a"; }

.ri-alarm-warning-line:before {
  content: "\\ea1b"; }

.ri-album-fill:before {
  content: "\\ea1c"; }

.ri-album-line:before {
  content: "\\ea1d"; }

.ri-alert-fill:before {
  content: "\\ea1e"; }

.ri-alert-line:before {
  content: "\\ea1f"; }

.ri-aliens-fill:before {
  content: "\\ea20"; }

.ri-aliens-line:before {
  content: "\\ea21"; }

.ri-align-bottom:before {
  content: "\\ea22"; }

.ri-align-center:before {
  content: "\\ea23"; }

.ri-align-justify:before {
  content: "\\ea24"; }

.ri-align-left:before {
  content: "\\ea25"; }

.ri-align-right:before {
  content: "\\ea26"; }

.ri-align-top:before {
  content: "\\ea27"; }

.ri-align-vertically:before {
  content: "\\ea28"; }

.ri-alipay-fill:before {
  content: "\\ea29"; }

.ri-alipay-line:before {
  content: "\\ea2a"; }

.ri-amazon-fill:before {
  content: "\\ea2b"; }

.ri-amazon-line:before {
  content: "\\ea2c"; }

.ri-anchor-fill:before {
  content: "\\ea2d"; }

.ri-anchor-line:before {
  content: "\\ea2e"; }

.ri-ancient-gate-fill:before {
  content: "\\ea2f"; }

.ri-ancient-gate-line:before {
  content: "\\ea30"; }

.ri-ancient-pavilion-fill:before {
  content: "\\ea31"; }

.ri-ancient-pavilion-line:before {
  content: "\\ea32"; }

.ri-android-fill:before {
  content: "\\ea33"; }

.ri-android-line:before {
  content: "\\ea34"; }

.ri-angularjs-fill:before {
  content: "\\ea35"; }

.ri-angularjs-line:before {
  content: "\\ea36"; }

.ri-anticlockwise-2-fill:before {
  content: "\\ea37"; }

.ri-anticlockwise-2-line:before {
  content: "\\ea38"; }

.ri-anticlockwise-fill:before {
  content: "\\ea39"; }

.ri-anticlockwise-line:before {
  content: "\\ea3a"; }

.ri-app-store-fill:before {
  content: "\\ea3b"; }

.ri-app-store-line:before {
  content: "\\ea3c"; }

.ri-apple-fill:before {
  content: "\\ea3d"; }

.ri-apple-line:before {
  content: "\\ea3e"; }

.ri-apps-2-fill:before {
  content: "\\ea3f"; }

.ri-apps-2-line:before {
  content: "\\ea40"; }

.ri-apps-fill:before {
  content: "\\ea41"; }

.ri-apps-line:before {
  content: "\\ea42"; }

.ri-archive-drawer-fill:before {
  content: "\\ea43"; }

.ri-archive-drawer-line:before {
  content: "\\ea44"; }

.ri-archive-fill:before {
  content: "\\ea45"; }

.ri-archive-line:before {
  content: "\\ea46"; }

.ri-arrow-down-circle-fill:before {
  content: "\\ea47"; }

.ri-arrow-down-circle-line:before {
  content: "\\ea48"; }

.ri-arrow-down-fill:before {
  content: "\\ea49"; }

.ri-arrow-down-line:before {
  content: "\\ea4a"; }

.ri-arrow-down-s-fill:before {
  content: "\\ea4b"; }

.ri-arrow-down-s-line:before {
  content: "\\ea4c"; }

.ri-arrow-drop-down-fill:before {
  content: "\\ea4d"; }

.ri-arrow-drop-down-line:before {
  content: "\\ea4e"; }

.ri-arrow-drop-left-fill:before {
  content: "\\ea4f"; }

.ri-arrow-drop-left-line:before {
  content: "\\ea50"; }

.ri-arrow-drop-right-fill:before {
  content: "\\ea51"; }

.ri-arrow-drop-right-line:before {
  content: "\\ea52"; }

.ri-arrow-drop-up-fill:before {
  content: "\\ea53"; }

.ri-arrow-drop-up-line:before {
  content: "\\ea54"; }

.ri-arrow-go-back-fill:before {
  content: "\\ea55"; }

.ri-arrow-go-back-line:before {
  content: "\\ea56"; }

.ri-arrow-go-forward-fill:before {
  content: "\\ea57"; }

.ri-arrow-go-forward-line:before {
  content: "\\ea58"; }

.ri-arrow-left-circle-fill:before {
  content: "\\ea59"; }

.ri-arrow-left-circle-line:before {
  content: "\\ea5a"; }

.ri-arrow-left-down-fill:before {
  content: "\\ea5b"; }

.ri-arrow-left-down-line:before {
  content: "\\ea5c"; }

.ri-arrow-left-fill:before {
  content: "\\ea5d"; }

.ri-arrow-left-line:before {
  content: "\\ea5e"; }

.ri-arrow-left-right-fill:before {
  content: "\\ea5f"; }

.ri-arrow-left-right-line:before {
  content: "\\ea60"; }

.ri-arrow-left-s-fill:before {
  content: "\\ea61"; }

.ri-arrow-left-s-line:before {
  content: "\\ea62"; }

.ri-arrow-left-up-fill:before {
  content: "\\ea63"; }

.ri-arrow-left-up-line:before {
  content: "\\ea64"; }

.ri-arrow-right-circle-fill:before {
  content: "\\ea65"; }

.ri-arrow-right-circle-line:before {
  content: "\\ea66"; }

.ri-arrow-right-down-fill:before {
  content: "\\ea67"; }

.ri-arrow-right-down-line:before {
  content: "\\ea68"; }

.ri-arrow-right-fill:before {
  content: "\\ea69"; }

.ri-arrow-right-line:before {
  content: "\\ea6a"; }

.ri-arrow-right-s-fill:before {
  content: "\\ea6b"; }

.ri-arrow-right-s-line:before {
  content: "\\ea6c"; }

.ri-arrow-right-up-fill:before {
  content: "\\ea6d"; }

.ri-arrow-right-up-line:before {
  content: "\\ea6e"; }

.ri-arrow-up-circle-fill:before {
  content: "\\ea6f"; }

.ri-arrow-up-circle-line:before {
  content: "\\ea70"; }

.ri-arrow-up-down-fill:before {
  content: "\\ea71"; }

.ri-arrow-up-down-line:before {
  content: "\\ea72"; }

.ri-arrow-up-fill:before {
  content: "\\ea73"; }

.ri-arrow-up-line:before {
  content: "\\ea74"; }

.ri-arrow-up-s-fill:before {
  content: "\\ea75"; }

.ri-arrow-up-s-line:before {
  content: "\\ea76"; }

.ri-artboard-2-fill:before {
  content: "\\ea77"; }

.ri-artboard-2-line:before {
  content: "\\ea78"; }

.ri-artboard-fill:before {
  content: "\\ea79"; }

.ri-artboard-line:before {
  content: "\\ea7a"; }

.ri-article-fill:before {
  content: "\\ea7b"; }

.ri-article-line:before {
  content: "\\ea7c"; }

.ri-aspect-ratio-fill:before {
  content: "\\ea7d"; }

.ri-aspect-ratio-line:before {
  content: "\\ea7e"; }

.ri-asterisk:before {
  content: "\\ea7f"; }

.ri-at-fill:before {
  content: "\\ea80"; }

.ri-at-line:before {
  content: "\\ea81"; }

.ri-attachment-2:before {
  content: "\\ea82"; }

.ri-attachment-fill:before {
  content: "\\ea83"; }

.ri-attachment-line:before {
  content: "\\ea84"; }

.ri-auction-fill:before {
  content: "\\ea85"; }

.ri-auction-line:before {
  content: "\\ea86"; }

.ri-award-fill:before {
  content: "\\ea87"; }

.ri-award-line:before {
  content: "\\ea88"; }

.ri-baidu-fill:before {
  content: "\\ea89"; }

.ri-baidu-line:before {
  content: "\\ea8a"; }

.ri-ball-pen-fill:before {
  content: "\\ea8b"; }

.ri-ball-pen-line:before {
  content: "\\ea8c"; }

.ri-bank-card-2-fill:before {
  content: "\\ea8d"; }

.ri-bank-card-2-line:before {
  content: "\\ea8e"; }

.ri-bank-card-fill:before {
  content: "\\ea8f"; }

.ri-bank-card-line:before {
  content: "\\ea90"; }

.ri-bank-fill:before {
  content: "\\ea91"; }

.ri-bank-line:before {
  content: "\\ea92"; }

.ri-bar-chart-2-fill:before {
  content: "\\ea93"; }

.ri-bar-chart-2-line:before {
  content: "\\ea94"; }

.ri-bar-chart-box-fill:before {
  content: "\\ea95"; }

.ri-bar-chart-box-line:before {
  content: "\\ea96"; }

.ri-bar-chart-fill:before {
  content: "\\ea97"; }

.ri-bar-chart-grouped-fill:before {
  content: "\\ea98"; }

.ri-bar-chart-grouped-line:before {
  content: "\\ea99"; }

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9a"; }

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9b"; }

.ri-bar-chart-line:before {
  content: "\\ea9c"; }

.ri-barcode-box-fill:before {
  content: "\\ea9d"; }

.ri-barcode-box-line:before {
  content: "\\ea9e"; }

.ri-barcode-fill:before {
  content: "\\ea9f"; }

.ri-barcode-line:before {
  content: "\\eaa0"; }

.ri-barricade-fill:before {
  content: "\\eaa1"; }

.ri-barricade-line:before {
  content: "\\eaa2"; }

.ri-base-station-fill:before {
  content: "\\eaa3"; }

.ri-base-station-line:before {
  content: "\\eaa4"; }

.ri-basketball-fill:before {
  content: "\\eaa5"; }

.ri-basketball-line:before {
  content: "\\eaa6"; }

.ri-battery-2-charge-fill:before {
  content: "\\eaa7"; }

.ri-battery-2-charge-line:before {
  content: "\\eaa8"; }

.ri-battery-2-fill:before {
  content: "\\eaa9"; }

.ri-battery-2-line:before {
  content: "\\eaaa"; }

.ri-battery-charge-fill:before {
  content: "\\eaab"; }

.ri-battery-charge-line:before {
  content: "\\eaac"; }

.ri-battery-fill:before {
  content: "\\eaad"; }

.ri-battery-line:before {
  content: "\\eaae"; }

.ri-battery-low-fill:before {
  content: "\\eaaf"; }

.ri-battery-low-line:before {
  content: "\\eab0"; }

.ri-battery-saver-fill:before {
  content: "\\eab1"; }

.ri-battery-saver-line:before {
  content: "\\eab2"; }

.ri-battery-share-fill:before {
  content: "\\eab3"; }

.ri-battery-share-line:before {
  content: "\\eab4"; }

.ri-bear-smile-fill:before {
  content: "\\eab5"; }

.ri-bear-smile-line:before {
  content: "\\eab6"; }

.ri-behance-fill:before {
  content: "\\eab7"; }

.ri-behance-line:before {
  content: "\\eab8"; }

.ri-bell-fill:before {
  content: "\\eab9"; }

.ri-bell-line:before {
  content: "\\eaba"; }

.ri-bike-fill:before {
  content: "\\eabb"; }

.ri-bike-line:before {
  content: "\\eabc"; }

.ri-bilibili-fill:before {
  content: "\\eabd"; }

.ri-bilibili-line:before {
  content: "\\eabe"; }

.ri-bill-fill:before {
  content: "\\eabf"; }

.ri-bill-line:before {
  content: "\\eac0"; }

.ri-billiards-fill:before {
  content: "\\eac1"; }

.ri-billiards-line:before {
  content: "\\eac2"; }

.ri-bit-coin-fill:before {
  content: "\\eac3"; }

.ri-bit-coin-line:before {
  content: "\\eac4"; }

.ri-blaze-fill:before {
  content: "\\eac5"; }

.ri-blaze-line:before {
  content: "\\eac6"; }

.ri-bluetooth-connect-fill:before {
  content: "\\eac7"; }

.ri-bluetooth-connect-line:before {
  content: "\\eac8"; }

.ri-bluetooth-fill:before {
  content: "\\eac9"; }

.ri-bluetooth-line:before {
  content: "\\eaca"; }

.ri-blur-off-fill:before {
  content: "\\eacb"; }

.ri-blur-off-line:before {
  content: "\\eacc"; }

.ri-body-scan-fill:before {
  content: "\\eacd"; }

.ri-body-scan-line:before {
  content: "\\eace"; }

.ri-bold:before {
  content: "\\eacf"; }

.ri-book-2-fill:before {
  content: "\\ead0"; }

.ri-book-2-line:before {
  content: "\\ead1"; }

.ri-book-3-fill:before {
  content: "\\ead2"; }

.ri-book-3-line:before {
  content: "\\ead3"; }

.ri-book-fill:before {
  content: "\\ead4"; }

.ri-book-line:before {
  content: "\\ead5"; }

.ri-book-mark-fill:before {
  content: "\\ead6"; }

.ri-book-mark-line:before {
  content: "\\ead7"; }

.ri-book-open-fill:before {
  content: "\\ead8"; }

.ri-book-open-line:before {
  content: "\\ead9"; }

.ri-book-read-fill:before {
  content: "\\eada"; }

.ri-book-read-line:before {
  content: "\\eadb"; }

.ri-booklet-fill:before {
  content: "\\eadc"; }

.ri-booklet-line:before {
  content: "\\eadd"; }

.ri-bookmark-2-fill:before {
  content: "\\eade"; }

.ri-bookmark-2-line:before {
  content: "\\eadf"; }

.ri-bookmark-3-fill:before {
  content: "\\eae0"; }

.ri-bookmark-3-line:before {
  content: "\\eae1"; }

.ri-bookmark-fill:before {
  content: "\\eae2"; }

.ri-bookmark-line:before {
  content: "\\eae3"; }

.ri-boxing-fill:before {
  content: "\\eae4"; }

.ri-boxing-line:before {
  content: "\\eae5"; }

.ri-braces-fill:before {
  content: "\\eae6"; }

.ri-braces-line:before {
  content: "\\eae7"; }

.ri-brackets-fill:before {
  content: "\\eae8"; }

.ri-brackets-line:before {
  content: "\\eae9"; }

.ri-briefcase-2-fill:before {
  content: "\\eaea"; }

.ri-briefcase-2-line:before {
  content: "\\eaeb"; }

.ri-briefcase-3-fill:before {
  content: "\\eaec"; }

.ri-briefcase-3-line:before {
  content: "\\eaed"; }

.ri-briefcase-4-fill:before {
  content: "\\eaee"; }

.ri-briefcase-4-line:before {
  content: "\\eaef"; }

.ri-briefcase-5-fill:before {
  content: "\\eaf0"; }

.ri-briefcase-5-line:before {
  content: "\\eaf1"; }

.ri-briefcase-fill:before {
  content: "\\eaf2"; }

.ri-briefcase-line:before {
  content: "\\eaf3"; }

.ri-bring-forward:before {
  content: "\\eaf4"; }

.ri-bring-to-front:before {
  content: "\\eaf5"; }

.ri-broadcast-fill:before {
  content: "\\eaf6"; }

.ri-broadcast-line:before {
  content: "\\eaf7"; }

.ri-brush-2-fill:before {
  content: "\\eaf8"; }

.ri-brush-2-line:before {
  content: "\\eaf9"; }

.ri-brush-3-fill:before {
  content: "\\eafa"; }

.ri-brush-3-line:before {
  content: "\\eafb"; }

.ri-brush-4-fill:before {
  content: "\\eafc"; }

.ri-brush-4-line:before {
  content: "\\eafd"; }

.ri-brush-fill:before {
  content: "\\eafe"; }

.ri-brush-line:before {
  content: "\\eaff"; }

.ri-bubble-chart-fill:before {
  content: "\\eb00"; }

.ri-bubble-chart-line:before {
  content: "\\eb01"; }

.ri-bug-2-fill:before {
  content: "\\eb02"; }

.ri-bug-2-line:before {
  content: "\\eb03"; }

.ri-bug-fill:before {
  content: "\\eb04"; }

.ri-bug-line:before {
  content: "\\eb05"; }

.ri-building-2-fill:before {
  content: "\\eb06"; }

.ri-building-2-line:before {
  content: "\\eb07"; }

.ri-building-3-fill:before {
  content: "\\eb08"; }

.ri-building-3-line:before {
  content: "\\eb09"; }

.ri-building-4-fill:before {
  content: "\\eb0a"; }

.ri-building-4-line:before {
  content: "\\eb0b"; }

.ri-building-fill:before {
  content: "\\eb0c"; }

.ri-building-line:before {
  content: "\\eb0d"; }

.ri-bus-2-fill:before {
  content: "\\eb0e"; }

.ri-bus-2-line:before {
  content: "\\eb0f"; }

.ri-bus-fill:before {
  content: "\\eb10"; }

.ri-bus-line:before {
  content: "\\eb11"; }

.ri-bus-wifi-fill:before {
  content: "\\eb12"; }

.ri-bus-wifi-line:before {
  content: "\\eb13"; }

.ri-cake-2-fill:before {
  content: "\\eb14"; }

.ri-cake-2-line:before {
  content: "\\eb15"; }

.ri-cake-3-fill:before {
  content: "\\eb16"; }

.ri-cake-3-line:before {
  content: "\\eb17"; }

.ri-cake-fill:before {
  content: "\\eb18"; }

.ri-cake-line:before {
  content: "\\eb19"; }

.ri-calculator-fill:before {
  content: "\\eb1a"; }

.ri-calculator-line:before {
  content: "\\eb1b"; }

.ri-calendar-2-fill:before {
  content: "\\eb1c"; }

.ri-calendar-2-line:before {
  content: "\\eb1d"; }

.ri-calendar-check-fill:before {
  content: "\\eb1e"; }

.ri-calendar-check-line:before {
  content: "\\eb1f"; }

.ri-calendar-event-fill:before {
  content: "\\eb20"; }

.ri-calendar-event-line:before {
  content: "\\eb21"; }

.ri-calendar-fill:before {
  content: "\\eb22"; }

.ri-calendar-line:before {
  content: "\\eb23"; }

.ri-calendar-todo-fill:before {
  content: "\\eb24"; }

.ri-calendar-todo-line:before {
  content: "\\eb25"; }

.ri-camera-2-fill:before {
  content: "\\eb26"; }

.ri-camera-2-line:before {
  content: "\\eb27"; }

.ri-camera-3-fill:before {
  content: "\\eb28"; }

.ri-camera-3-line:before {
  content: "\\eb29"; }

.ri-camera-fill:before {
  content: "\\eb2a"; }

.ri-camera-lens-fill:before {
  content: "\\eb2b"; }

.ri-camera-lens-line:before {
  content: "\\eb2c"; }

.ri-camera-line:before {
  content: "\\eb2d"; }

.ri-camera-off-fill:before {
  content: "\\eb2e"; }

.ri-camera-off-line:before {
  content: "\\eb2f"; }

.ri-camera-switch-fill:before {
  content: "\\eb30"; }

.ri-camera-switch-line:before {
  content: "\\eb31"; }

.ri-car-fill:before {
  content: "\\eb32"; }

.ri-car-line:before {
  content: "\\eb33"; }

.ri-car-washing-fill:before {
  content: "\\eb34"; }

.ri-car-washing-line:before {
  content: "\\eb35"; }

.ri-caravan-fill:before {
  content: "\\eb36"; }

.ri-caravan-line:before {
  content: "\\eb37"; }

.ri-cast-fill:before {
  content: "\\eb38"; }

.ri-cast-line:before {
  content: "\\eb39"; }

.ri-cellphone-fill:before {
  content: "\\eb3a"; }

.ri-cellphone-line:before {
  content: "\\eb3b"; }

.ri-celsius-fill:before {
  content: "\\eb3c"; }

.ri-celsius-line:before {
  content: "\\eb3d"; }

.ri-centos-fill:before {
  content: "\\eb3e"; }

.ri-centos-line:before {
  content: "\\eb3f"; }

.ri-character-recognition-fill:before {
  content: "\\eb40"; }

.ri-character-recognition-line:before {
  content: "\\eb41"; }

.ri-charging-pile-2-fill:before {
  content: "\\eb42"; }

.ri-charging-pile-2-line:before {
  content: "\\eb43"; }

.ri-charging-pile-fill:before {
  content: "\\eb44"; }

.ri-charging-pile-line:before {
  content: "\\eb45"; }

.ri-chat-1-fill:before {
  content: "\\eb46"; }

.ri-chat-1-line:before {
  content: "\\eb47"; }

.ri-chat-2-fill:before {
  content: "\\eb48"; }

.ri-chat-2-line:before {
  content: "\\eb49"; }

.ri-chat-3-fill:before {
  content: "\\eb4a"; }

.ri-chat-3-line:before {
  content: "\\eb4b"; }

.ri-chat-4-fill:before {
  content: "\\eb4c"; }

.ri-chat-4-line:before {
  content: "\\eb4d"; }

.ri-chat-check-fill:before {
  content: "\\eb4e"; }

.ri-chat-check-line:before {
  content: "\\eb4f"; }

.ri-chat-delete-fill:before {
  content: "\\eb50"; }

.ri-chat-delete-line:before {
  content: "\\eb51"; }

.ri-chat-download-fill:before {
  content: "\\eb52"; }

.ri-chat-download-line:before {
  content: "\\eb53"; }

.ri-chat-follow-up-fill:before {
  content: "\\eb54"; }

.ri-chat-follow-up-line:before {
  content: "\\eb55"; }

.ri-chat-forward-fill:before {
  content: "\\eb56"; }

.ri-chat-forward-line:before {
  content: "\\eb57"; }

.ri-chat-heart-fill:before {
  content: "\\eb58"; }

.ri-chat-heart-line:before {
  content: "\\eb59"; }

.ri-chat-history-fill:before {
  content: "\\eb5a"; }

.ri-chat-history-line:before {
  content: "\\eb5b"; }

.ri-chat-new-fill:before {
  content: "\\eb5c"; }

.ri-chat-new-line:before {
  content: "\\eb5d"; }

.ri-chat-off-fill:before {
  content: "\\eb5e"; }

.ri-chat-off-line:before {
  content: "\\eb5f"; }

.ri-chat-poll-fill:before {
  content: "\\eb60"; }

.ri-chat-poll-line:before {
  content: "\\eb61"; }

.ri-chat-private-fill:before {
  content: "\\eb62"; }

.ri-chat-private-line:before {
  content: "\\eb63"; }

.ri-chat-quote-fill:before {
  content: "\\eb64"; }

.ri-chat-quote-line:before {
  content: "\\eb65"; }

.ri-chat-settings-fill:before {
  content: "\\eb66"; }

.ri-chat-settings-line:before {
  content: "\\eb67"; }

.ri-chat-smile-2-fill:before {
  content: "\\eb68"; }

.ri-chat-smile-2-line:before {
  content: "\\eb69"; }

.ri-chat-smile-3-fill:before {
  content: "\\eb6a"; }

.ri-chat-smile-3-line:before {
  content: "\\eb6b"; }

.ri-chat-smile-fill:before {
  content: "\\eb6c"; }

.ri-chat-smile-line:before {
  content: "\\eb6d"; }

.ri-chat-upload-fill:before {
  content: "\\eb6e"; }

.ri-chat-upload-line:before {
  content: "\\eb6f"; }

.ri-chat-voice-fill:before {
  content: "\\eb70"; }

.ri-chat-voice-line:before {
  content: "\\eb71"; }

.ri-check-double-fill:before {
  content: "\\eb72"; }

.ri-check-double-line:before {
  content: "\\eb73"; }

.ri-check-fill:before {
  content: "\\eb74"; }

.ri-check-line:before {
  content: "\\eb75"; }

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb76"; }

.ri-checkbox-blank-circle-line:before {
  content: "\\eb77"; }

.ri-checkbox-blank-fill:before {
  content: "\\eb78"; }

.ri-checkbox-blank-line:before {
  content: "\\eb79"; }

.ri-checkbox-circle-fill:before {
  content: "\\eb7a"; }

.ri-checkbox-circle-line:before {
  content: "\\eb7b"; }

.ri-checkbox-fill:before {
  content: "\\eb7c"; }

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb7d"; }

.ri-checkbox-indeterminate-line:before {
  content: "\\eb7e"; }

.ri-checkbox-line:before {
  content: "\\eb7f"; }

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb80"; }

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb81"; }

.ri-checkbox-multiple-fill:before {
  content: "\\eb82"; }

.ri-checkbox-multiple-line:before {
  content: "\\eb83"; }

.ri-china-railway-fill:before {
  content: "\\eb84"; }

.ri-china-railway-line:before {
  content: "\\eb85"; }

.ri-chrome-fill:before {
  content: "\\eb86"; }

.ri-chrome-line:before {
  content: "\\eb87"; }

.ri-clapperboard-fill:before {
  content: "\\eb88"; }

.ri-clapperboard-line:before {
  content: "\\eb89"; }

.ri-clipboard-fill:before {
  content: "\\eb8a"; }

.ri-clipboard-line:before {
  content: "\\eb8b"; }

.ri-clockwise-2-fill:before {
  content: "\\eb8c"; }

.ri-clockwise-2-line:before {
  content: "\\eb8d"; }

.ri-clockwise-fill:before {
  content: "\\eb8e"; }

.ri-clockwise-line:before {
  content: "\\eb8f"; }

.ri-close-circle-fill:before {
  content: "\\eb90"; }

.ri-close-circle-line:before {
  content: "\\eb91"; }

.ri-close-fill:before {
  content: "\\eb92"; }

.ri-close-line:before {
  content: "\\eb93"; }

.ri-cloud-fill:before {
  content: "\\eb94"; }

.ri-cloud-line:before {
  content: "\\eb95"; }

.ri-cloud-off-fill:before {
  content: "\\eb96"; }

.ri-cloud-off-line:before {
  content: "\\eb97"; }

.ri-cloud-windy-fill:before {
  content: "\\eb98"; }

.ri-cloud-windy-line:before {
  content: "\\eb99"; }

.ri-cloudy-2-fill:before {
  content: "\\eb9a"; }

.ri-cloudy-2-line:before {
  content: "\\eb9b"; }

.ri-cloudy-fill:before {
  content: "\\eb9c"; }

.ri-cloudy-line:before {
  content: "\\eb9d"; }

.ri-code-box-fill:before {
  content: "\\eb9e"; }

.ri-code-box-line:before {
  content: "\\eb9f"; }

.ri-code-fill:before {
  content: "\\eba0"; }

.ri-code-line:before {
  content: "\\eba1"; }

.ri-code-s-fill:before {
  content: "\\eba2"; }

.ri-code-s-line:before {
  content: "\\eba3"; }

.ri-code-s-slash-fill:before {
  content: "\\eba4"; }

.ri-code-s-slash-line:before {
  content: "\\eba5"; }

.ri-code-view:before {
  content: "\\eba6"; }

.ri-codepen-fill:before {
  content: "\\eba7"; }

.ri-codepen-line:before {
  content: "\\eba8"; }

.ri-coin-fill:before {
  content: "\\eba9"; }

.ri-coin-line:before {
  content: "\\ebaa"; }

.ri-coins-fill:before {
  content: "\\ebab"; }

.ri-coins-line:before {
  content: "\\ebac"; }

.ri-command-fill:before {
  content: "\\ebad"; }

.ri-command-line:before {
  content: "\\ebae"; }

.ri-community-fill:before {
  content: "\\ebaf"; }

.ri-community-line:before {
  content: "\\ebb0"; }

.ri-compass-2-fill:before {
  content: "\\ebb1"; }

.ri-compass-2-line:before {
  content: "\\ebb2"; }

.ri-compass-3-fill:before {
  content: "\\ebb3"; }

.ri-compass-3-line:before {
  content: "\\ebb4"; }

.ri-compass-4-fill:before {
  content: "\\ebb5"; }

.ri-compass-4-line:before {
  content: "\\ebb6"; }

.ri-compass-discover-fill:before {
  content: "\\ebb7"; }

.ri-compass-discover-line:before {
  content: "\\ebb8"; }

.ri-compass-fill:before {
  content: "\\ebb9"; }

.ri-compass-line:before {
  content: "\\ebba"; }

.ri-compasses-2-fill:before {
  content: "\\ebbb"; }

.ri-compasses-2-line:before {
  content: "\\ebbc"; }

.ri-compasses-fill:before {
  content: "\\ebbd"; }

.ri-compasses-line:before {
  content: "\\ebbe"; }

.ri-computer-fill:before {
  content: "\\ebbf"; }

.ri-computer-line:before {
  content: "\\ebc0"; }

.ri-contacts-book-2-fill:before {
  content: "\\ebc1"; }

.ri-contacts-book-2-line:before {
  content: "\\ebc2"; }

.ri-contacts-book-fill:before {
  content: "\\ebc3"; }

.ri-contacts-book-line:before {
  content: "\\ebc4"; }

.ri-contacts-book-upload-fill:before {
  content: "\\ebc5"; }

.ri-contacts-book-upload-line:before {
  content: "\\ebc6"; }

.ri-contacts-fill:before {
  content: "\\ebc7"; }

.ri-contacts-line:before {
  content: "\\ebc8"; }

.ri-contrast-2-fill:before {
  content: "\\ebc9"; }

.ri-contrast-2-line:before {
  content: "\\ebca"; }

.ri-contrast-drop-2-fill:before {
  content: "\\ebcb"; }

.ri-contrast-drop-2-line:before {
  content: "\\ebcc"; }

.ri-contrast-drop-fill:before {
  content: "\\ebcd"; }

.ri-contrast-drop-line:before {
  content: "\\ebce"; }

.ri-contrast-fill:before {
  content: "\\ebcf"; }

.ri-contrast-line:before {
  content: "\\ebd0"; }

.ri-copper-coin-fill:before {
  content: "\\ebd1"; }

.ri-copper-coin-line:before {
  content: "\\ebd2"; }

.ri-copper-diamond-fill:before {
  content: "\\ebd3"; }

.ri-copper-diamond-line:before {
  content: "\\ebd4"; }

.ri-copyright-fill:before {
  content: "\\ebd5"; }

.ri-copyright-line:before {
  content: "\\ebd6"; }

.ri-coreos-fill:before {
  content: "\\ebd7"; }

.ri-coreos-line:before {
  content: "\\ebd8"; }

.ri-coupon-2-fill:before {
  content: "\\ebd9"; }

.ri-coupon-2-line:before {
  content: "\\ebda"; }

.ri-coupon-3-fill:before {
  content: "\\ebdb"; }

.ri-coupon-3-line:before {
  content: "\\ebdc"; }

.ri-coupon-4-fill:before {
  content: "\\ebdd"; }

.ri-coupon-4-line:before {
  content: "\\ebde"; }

.ri-coupon-5-fill:before {
  content: "\\ebdf"; }

.ri-coupon-5-line:before {
  content: "\\ebe0"; }

.ri-coupon-fill:before {
  content: "\\ebe1"; }

.ri-coupon-line:before {
  content: "\\ebe2"; }

.ri-cpu-fill:before {
  content: "\\ebe3"; }

.ri-cpu-line:before {
  content: "\\ebe4"; }

.ri-creative-commons-by-fill:before {
  content: "\\ebe5"; }

.ri-creative-commons-by-line:before {
  content: "\\ebe6"; }

.ri-creative-commons-fill:before {
  content: "\\ebe7"; }

.ri-creative-commons-line:before {
  content: "\\ebe8"; }

.ri-creative-commons-nc-fill:before {
  content: "\\ebe9"; }

.ri-creative-commons-nc-line:before {
  content: "\\ebea"; }

.ri-creative-commons-nd-fill:before {
  content: "\\ebeb"; }

.ri-creative-commons-nd-line:before {
  content: "\\ebec"; }

.ri-creative-commons-sa-fill:before {
  content: "\\ebed"; }

.ri-creative-commons-sa-line:before {
  content: "\\ebee"; }

.ri-creative-commons-zero-fill:before {
  content: "\\ebef"; }

.ri-creative-commons-zero-line:before {
  content: "\\ebf0"; }

.ri-criminal-fill:before {
  content: "\\ebf1"; }

.ri-criminal-line:before {
  content: "\\ebf2"; }

.ri-crop-2-fill:before {
  content: "\\ebf3"; }

.ri-crop-2-line:before {
  content: "\\ebf4"; }

.ri-crop-fill:before {
  content: "\\ebf5"; }

.ri-crop-line:before {
  content: "\\ebf6"; }

.ri-css3-fill:before {
  content: "\\ebf7"; }

.ri-css3-line:before {
  content: "\\ebf8"; }

.ri-cup-fill:before {
  content: "\\ebf9"; }

.ri-cup-line:before {
  content: "\\ebfa"; }

.ri-currency-fill:before {
  content: "\\ebfb"; }

.ri-currency-line:before {
  content: "\\ebfc"; }

.ri-cursor-fill:before {
  content: "\\ebfd"; }

.ri-cursor-line:before {
  content: "\\ebfe"; }

.ri-customer-service-2-fill:before {
  content: "\\ebff"; }

.ri-customer-service-2-line:before {
  content: "\\ec00"; }

.ri-customer-service-fill:before {
  content: "\\ec01"; }

.ri-customer-service-line:before {
  content: "\\ec02"; }

.ri-dashboard-fill:before {
  content: "\\ec03"; }

.ri-dashboard-line:before {
  content: "\\ec04"; }

.ri-database-2-fill:before {
  content: "\\ec05"; }

.ri-database-2-line:before {
  content: "\\ec06"; }

.ri-database-fill:before {
  content: "\\ec07"; }

.ri-database-line:before {
  content: "\\ec08"; }

.ri-delete-back-2-fill:before {
  content: "\\ec09"; }

.ri-delete-back-2-line:before {
  content: "\\ec0a"; }

.ri-delete-back-fill:before {
  content: "\\ec0b"; }

.ri-delete-back-line:before {
  content: "\\ec0c"; }

.ri-delete-bin-2-fill:before {
  content: "\\ec0d"; }

.ri-delete-bin-2-line:before {
  content: "\\ec0e"; }

.ri-delete-bin-3-fill:before {
  content: "\\ec0f"; }

.ri-delete-bin-3-line:before {
  content: "\\ec10"; }

.ri-delete-bin-4-fill:before {
  content: "\\ec11"; }

.ri-delete-bin-4-line:before {
  content: "\\ec12"; }

.ri-delete-bin-5-fill:before {
  content: "\\ec13"; }

.ri-delete-bin-5-line:before {
  content: "\\ec14"; }

.ri-delete-bin-6-fill:before {
  content: "\\ec15"; }

.ri-delete-bin-6-line:before {
  content: "\\ec16"; }

.ri-delete-bin-7-fill:before {
  content: "\\ec17"; }

.ri-delete-bin-7-line:before {
  content: "\\ec18"; }

.ri-delete-bin-fill:before {
  content: "\\ec19"; }

.ri-delete-bin-line:before {
  content: "\\ec1a"; }

.ri-device-fill:before {
  content: "\\ec1b"; }

.ri-device-line:before {
  content: "\\ec1c"; }

.ri-device-recover-fill:before {
  content: "\\ec1d"; }

.ri-device-recover-line:before {
  content: "\\ec1e"; }

.ri-dingding-fill:before {
  content: "\\ec1f"; }

.ri-dingding-line:before {
  content: "\\ec20"; }

.ri-direction-fill:before {
  content: "\\ec21"; }

.ri-direction-line:before {
  content: "\\ec22"; }

.ri-disc-fill:before {
  content: "\\ec23"; }

.ri-disc-line:before {
  content: "\\ec24"; }

.ri-discord-fill:before {
  content: "\\ec25"; }

.ri-discord-line:before {
  content: "\\ec26"; }

.ri-discuss-fill:before {
  content: "\\ec27"; }

.ri-discuss-line:before {
  content: "\\ec28"; }

.ri-disqus-fill:before {
  content: "\\ec29"; }

.ri-disqus-line:before {
  content: "\\ec2a"; }

.ri-divide-fill:before {
  content: "\\ec2b"; }

.ri-divide-line:before {
  content: "\\ec2c"; }

.ri-donut-chart-fill:before {
  content: "\\ec2d"; }

.ri-donut-chart-line:before {
  content: "\\ec2e"; }

.ri-door-lock-box-fill:before {
  content: "\\ec2f"; }

.ri-door-lock-box-line:before {
  content: "\\ec30"; }

.ri-door-lock-fill:before {
  content: "\\ec31"; }

.ri-door-lock-line:before {
  content: "\\ec32"; }

.ri-douban-fill:before {
  content: "\\ec33"; }

.ri-douban-line:before {
  content: "\\ec34"; }

.ri-double-quotes-l:before {
  content: "\\ec35"; }

.ri-double-quotes-r:before {
  content: "\\ec36"; }

.ri-download-2-fill:before {
  content: "\\ec37"; }

.ri-download-2-line:before {
  content: "\\ec38"; }

.ri-download-cloud-2-fill:before {
  content: "\\ec39"; }

.ri-download-cloud-2-line:before {
  content: "\\ec3a"; }

.ri-download-cloud-fill:before {
  content: "\\ec3b"; }

.ri-download-cloud-line:before {
  content: "\\ec3c"; }

.ri-download-fill:before {
  content: "\\ec3d"; }

.ri-download-line:before {
  content: "\\ec3e"; }

.ri-drag-drop-fill:before {
  content: "\\ec3f"; }

.ri-drag-drop-line:before {
  content: "\\ec40"; }

.ri-drag-move-2-fill:before {
  content: "\\ec41"; }

.ri-drag-move-2-line:before {
  content: "\\ec42"; }

.ri-drag-move-fill:before {
  content: "\\ec43"; }

.ri-drag-move-line:before {
  content: "\\ec44"; }

.ri-dribbble-fill:before {
  content: "\\ec45"; }

.ri-dribbble-line:before {
  content: "\\ec46"; }

.ri-drive-fill:before {
  content: "\\ec47"; }

.ri-drive-line:before {
  content: "\\ec48"; }

.ri-drizzle-fill:before {
  content: "\\ec49"; }

.ri-drizzle-line:before {
  content: "\\ec4a"; }

.ri-drop-fill:before {
  content: "\\ec4b"; }

.ri-drop-line:before {
  content: "\\ec4c"; }

.ri-dropbox-fill:before {
  content: "\\ec4d"; }

.ri-dropbox-line:before {
  content: "\\ec4e"; }

.ri-dual-sim-1-fill:before {
  content: "\\ec4f"; }

.ri-dual-sim-1-line:before {
  content: "\\ec50"; }

.ri-dual-sim-2-fill:before {
  content: "\\ec51"; }

.ri-dual-sim-2-line:before {
  content: "\\ec52"; }

.ri-dv-fill:before {
  content: "\\ec53"; }

.ri-dv-line:before {
  content: "\\ec54"; }

.ri-dvd-fill:before {
  content: "\\ec55"; }

.ri-dvd-line:before {
  content: "\\ec56"; }

.ri-e-bike-2-fill:before {
  content: "\\ec57"; }

.ri-e-bike-2-line:before {
  content: "\\ec58"; }

.ri-e-bike-fill:before {
  content: "\\ec59"; }

.ri-e-bike-line:before {
  content: "\\ec5a"; }

.ri-earth-fill:before {
  content: "\\ec5b"; }

.ri-earth-line:before {
  content: "\\ec5c"; }

.ri-earthquake-fill:before {
  content: "\\ec5d"; }

.ri-earthquake-line:before {
  content: "\\ec5e"; }

.ri-edge-fill:before {
  content: "\\ec5f"; }

.ri-edge-line:before {
  content: "\\ec60"; }

.ri-edit-2-fill:before {
  content: "\\ec61"; }

.ri-edit-2-line:before {
  content: "\\ec62"; }

.ri-edit-box-fill:before {
  content: "\\ec63"; }

.ri-edit-box-line:before {
  content: "\\ec64"; }

.ri-edit-circle-fill:before {
  content: "\\ec65"; }

.ri-edit-circle-line:before {
  content: "\\ec66"; }

.ri-edit-fill:before {
  content: "\\ec67"; }

.ri-edit-line:before {
  content: "\\ec68"; }

.ri-eject-fill:before {
  content: "\\ec69"; }

.ri-eject-line:before {
  content: "\\ec6a"; }

.ri-emotion-2-fill:before {
  content: "\\ec6b"; }

.ri-emotion-2-line:before {
  content: "\\ec6c"; }

.ri-emotion-fill:before {
  content: "\\ec6d"; }

.ri-emotion-happy-fill:before {
  content: "\\ec6e"; }

.ri-emotion-happy-line:before {
  content: "\\ec6f"; }

.ri-emotion-laugh-fill:before {
  content: "\\ec70"; }

.ri-emotion-laugh-line:before {
  content: "\\ec71"; }

.ri-emotion-line:before {
  content: "\\ec72"; }

.ri-emotion-normal-fill:before {
  content: "\\ec73"; }

.ri-emotion-normal-line:before {
  content: "\\ec74"; }

.ri-emotion-sad-fill:before {
  content: "\\ec75"; }

.ri-emotion-sad-line:before {
  content: "\\ec76"; }

.ri-emotion-unhappy-fill:before {
  content: "\\ec77"; }

.ri-emotion-unhappy-line:before {
  content: "\\ec78"; }

.ri-emphasis-cn:before {
  content: "\\ec79"; }

.ri-emphasis:before {
  content: "\\ec7a"; }

.ri-english-input:before {
  content: "\\ec7b"; }

.ri-equalizer-fill:before {
  content: "\\ec7c"; }

.ri-equalizer-line:before {
  content: "\\ec7d"; }

.ri-eraser-fill:before {
  content: "\\ec7e"; }

.ri-eraser-line:before {
  content: "\\ec7f"; }

.ri-error-warning-fill:before {
  content: "\\ec80"; }

.ri-error-warning-line:before {
  content: "\\ec81"; }

.ri-evernote-fill:before {
  content: "\\ec82"; }

.ri-evernote-line:before {
  content: "\\ec83"; }

.ri-exchange-box-fill:before {
  content: "\\ec84"; }

.ri-exchange-box-line:before {
  content: "\\ec85"; }

.ri-exchange-cny-fill:before {
  content: "\\ec86"; }

.ri-exchange-cny-line:before {
  content: "\\ec87"; }

.ri-exchange-dollar-fill:before {
  content: "\\ec88"; }

.ri-exchange-dollar-line:before {
  content: "\\ec89"; }

.ri-exchange-fill:before {
  content: "\\ec8a"; }

.ri-exchange-funds-fill:before {
  content: "\\ec8b"; }

.ri-exchange-funds-line:before {
  content: "\\ec8c"; }

.ri-exchange-line:before {
  content: "\\ec8d"; }

.ri-external-link-fill:before {
  content: "\\ec8e"; }

.ri-external-link-line:before {
  content: "\\ec8f"; }

.ri-eye-2-fill:before {
  content: "\\ec90"; }

.ri-eye-2-line:before {
  content: "\\ec91"; }

.ri-eye-close-fill:before {
  content: "\\ec92"; }

.ri-eye-close-line:before {
  content: "\\ec93"; }

.ri-eye-fill:before {
  content: "\\ec94"; }

.ri-eye-line:before {
  content: "\\ec95"; }

.ri-eye-off-fill:before {
  content: "\\ec96"; }

.ri-eye-off-line:before {
  content: "\\ec97"; }

.ri-facebook-box-fill:before {
  content: "\\ec98"; }

.ri-facebook-box-line:before {
  content: "\\ec99"; }

.ri-facebook-circle-fill:before {
  content: "\\ec9a"; }

.ri-facebook-circle-line:before {
  content: "\\ec9b"; }

.ri-facebook-fill:before {
  content: "\\ec9c"; }

.ri-facebook-line:before {
  content: "\\ec9d"; }

.ri-fahrenheit-fill:before {
  content: "\\ec9e"; }

.ri-fahrenheit-line:before {
  content: "\\ec9f"; }

.ri-feedback-fill:before {
  content: "\\eca0"; }

.ri-feedback-line:before {
  content: "\\eca1"; }

.ri-file-2-fill:before {
  content: "\\eca2"; }

.ri-file-2-line:before {
  content: "\\eca3"; }

.ri-file-3-fill:before {
  content: "\\eca4"; }

.ri-file-3-line:before {
  content: "\\eca5"; }

.ri-file-4-fill:before {
  content: "\\eca6"; }

.ri-file-4-line:before {
  content: "\\eca7"; }

.ri-file-add-fill:before {
  content: "\\eca8"; }

.ri-file-add-line:before {
  content: "\\eca9"; }

.ri-file-chart-2-fill:before {
  content: "\\ecaa"; }

.ri-file-chart-2-line:before {
  content: "\\ecab"; }

.ri-file-chart-fill:before {
  content: "\\ecac"; }

.ri-file-chart-line:before {
  content: "\\ecad"; }

.ri-file-cloud-fill:before {
  content: "\\ecae"; }

.ri-file-cloud-line:before {
  content: "\\ecaf"; }

.ri-file-code-fill:before {
  content: "\\ecb0"; }

.ri-file-code-line:before {
  content: "\\ecb1"; }

.ri-file-copy-2-fill:before {
  content: "\\ecb2"; }

.ri-file-copy-2-line:before {
  content: "\\ecb3"; }

.ri-file-copy-fill:before {
  content: "\\ecb4"; }

.ri-file-copy-line:before {
  content: "\\ecb5"; }

.ri-file-damage-fill:before {
  content: "\\ecb6"; }

.ri-file-damage-line:before {
  content: "\\ecb7"; }

.ri-file-download-fill:before {
  content: "\\ecb8"; }

.ri-file-download-line:before {
  content: "\\ecb9"; }

.ri-file-edit-fill:before {
  content: "\\ecba"; }

.ri-file-edit-line:before {
  content: "\\ecbb"; }

.ri-file-excel-2-fill:before {
  content: "\\ecbc"; }

.ri-file-excel-2-line:before {
  content: "\\ecbd"; }

.ri-file-excel-fill:before {
  content: "\\ecbe"; }

.ri-file-excel-line:before {
  content: "\\ecbf"; }

.ri-file-fill:before {
  content: "\\ecc0"; }

.ri-file-forbid-fill:before {
  content: "\\ecc1"; }

.ri-file-forbid-line:before {
  content: "\\ecc2"; }

.ri-file-gif-fill:before {
  content: "\\ecc3"; }

.ri-file-gif-line:before {
  content: "\\ecc4"; }

.ri-file-history-fill:before {
  content: "\\ecc5"; }

.ri-file-history-line:before {
  content: "\\ecc6"; }

.ri-file-hwp-fill:before {
  content: "\\ecc7"; }

.ri-file-hwp-line:before {
  content: "\\ecc8"; }

.ri-file-info-fill:before {
  content: "\\ecc9"; }

.ri-file-info-line:before {
  content: "\\ecca"; }

.ri-file-line:before {
  content: "\\eccb"; }

.ri-file-list-2-fill:before {
  content: "\\eccc"; }

.ri-file-list-2-line:before {
  content: "\\eccd"; }

.ri-file-list-3-fill:before {
  content: "\\ecce"; }

.ri-file-list-3-line:before {
  content: "\\eccf"; }

.ri-file-list-fill:before {
  content: "\\ecd0"; }

.ri-file-list-line:before {
  content: "\\ecd1"; }

.ri-file-lock-fill:before {
  content: "\\ecd2"; }

.ri-file-lock-line:before {
  content: "\\ecd3"; }

.ri-file-mark-fill:before {
  content: "\\ecd4"; }

.ri-file-mark-line:before {
  content: "\\ecd5"; }

.ri-file-music-fill:before {
  content: "\\ecd6"; }

.ri-file-music-line:before {
  content: "\\ecd7"; }

.ri-file-paper-2-fill:before {
  content: "\\ecd8"; }

.ri-file-paper-2-line:before {
  content: "\\ecd9"; }

.ri-file-paper-fill:before {
  content: "\\ecda"; }

.ri-file-paper-line:before {
  content: "\\ecdb"; }

.ri-file-pdf-fill:before {
  content: "\\ecdc"; }

.ri-file-pdf-line:before {
  content: "\\ecdd"; }

.ri-file-ppt-2-fill:before {
  content: "\\ecde"; }

.ri-file-ppt-2-line:before {
  content: "\\ecdf"; }

.ri-file-ppt-fill:before {
  content: "\\ece0"; }

.ri-file-ppt-line:before {
  content: "\\ece1"; }

.ri-file-reduce-fill:before {
  content: "\\ece2"; }

.ri-file-reduce-line:before {
  content: "\\ece3"; }

.ri-file-search-fill:before {
  content: "\\ece4"; }

.ri-file-search-line:before {
  content: "\\ece5"; }

.ri-file-settings-fill:before {
  content: "\\ece6"; }

.ri-file-settings-line:before {
  content: "\\ece7"; }

.ri-file-shield-2-fill:before {
  content: "\\ece8"; }

.ri-file-shield-2-line:before {
  content: "\\ece9"; }

.ri-file-shield-fill:before {
  content: "\\ecea"; }

.ri-file-shield-line:before {
  content: "\\eceb"; }

.ri-file-shred-fill:before {
  content: "\\ecec"; }

.ri-file-shred-line:before {
  content: "\\eced"; }

.ri-file-text-fill:before {
  content: "\\ecee"; }

.ri-file-text-line:before {
  content: "\\ecef"; }

.ri-file-transfer-fill:before {
  content: "\\ecf0"; }

.ri-file-transfer-line:before {
  content: "\\ecf1"; }

.ri-file-unknow-fill:before {
  content: "\\ecf2"; }

.ri-file-unknow-line:before {
  content: "\\ecf3"; }

.ri-file-upload-fill:before {
  content: "\\ecf4"; }

.ri-file-upload-line:before {
  content: "\\ecf5"; }

.ri-file-user-fill:before {
  content: "\\ecf6"; }

.ri-file-user-line:before {
  content: "\\ecf7"; }

.ri-file-warning-fill:before {
  content: "\\ecf8"; }

.ri-file-warning-line:before {
  content: "\\ecf9"; }

.ri-file-word-2-fill:before {
  content: "\\ecfa"; }

.ri-file-word-2-line:before {
  content: "\\ecfb"; }

.ri-file-word-fill:before {
  content: "\\ecfc"; }

.ri-file-word-line:before {
  content: "\\ecfd"; }

.ri-file-zip-fill:before {
  content: "\\ecfe"; }

.ri-file-zip-line:before {
  content: "\\ecff"; }

.ri-film-fill:before {
  content: "\\ed00"; }

.ri-film-line:before {
  content: "\\ed01"; }

.ri-filter-2-fill:before {
  content: "\\ed02"; }

.ri-filter-2-line:before {
  content: "\\ed03"; }

.ri-filter-3-fill:before {
  content: "\\ed04"; }

.ri-filter-3-line:before {
  content: "\\ed05"; }

.ri-filter-fill:before {
  content: "\\ed06"; }

.ri-filter-line:before {
  content: "\\ed07"; }

.ri-find-replace-fill:before {
  content: "\\ed08"; }

.ri-find-replace-line:before {
  content: "\\ed09"; }

.ri-fingerprint-2-fill:before {
  content: "\\ed0a"; }

.ri-fingerprint-2-line:before {
  content: "\\ed0b"; }

.ri-fingerprint-fill:before {
  content: "\\ed0c"; }

.ri-fingerprint-line:before {
  content: "\\ed0d"; }

.ri-fire-fill:before {
  content: "\\ed0e"; }

.ri-fire-line:before {
  content: "\\ed0f"; }

.ri-firefox-fill:before {
  content: "\\ed10"; }

.ri-firefox-line:before {
  content: "\\ed11"; }

.ri-flag-2-fill:before {
  content: "\\ed12"; }

.ri-flag-2-line:before {
  content: "\\ed13"; }

.ri-flag-fill:before {
  content: "\\ed14"; }

.ri-flag-line:before {
  content: "\\ed15"; }

.ri-flashlight-fill:before {
  content: "\\ed16"; }

.ri-flashlight-line:before {
  content: "\\ed17"; }

.ri-flask-fill:before {
  content: "\\ed18"; }

.ri-flask-line:before {
  content: "\\ed19"; }

.ri-flight-land-fill:before {
  content: "\\ed1a"; }

.ri-flight-land-line:before {
  content: "\\ed1b"; }

.ri-flight-takeoff-fill:before {
  content: "\\ed1c"; }

.ri-flight-takeoff-line:before {
  content: "\\ed1d"; }

.ri-flood-fill:before {
  content: "\\ed1e"; }

.ri-flood-line:before {
  content: "\\ed1f"; }

.ri-flutter-fill:before {
  content: "\\ed20"; }

.ri-flutter-line:before {
  content: "\\ed21"; }

.ri-focus-2-fill:before {
  content: "\\ed22"; }

.ri-focus-2-line:before {
  content: "\\ed23"; }

.ri-focus-3-fill:before {
  content: "\\ed24"; }

.ri-focus-3-line:before {
  content: "\\ed25"; }

.ri-focus-fill:before {
  content: "\\ed26"; }

.ri-focus-line:before {
  content: "\\ed27"; }

.ri-foggy-fill:before {
  content: "\\ed28"; }

.ri-foggy-line:before {
  content: "\\ed29"; }

.ri-folder-2-fill:before {
  content: "\\ed2a"; }

.ri-folder-2-line:before {
  content: "\\ed2b"; }

.ri-folder-3-fill:before {
  content: "\\ed2c"; }

.ri-folder-3-line:before {
  content: "\\ed2d"; }

.ri-folder-4-fill:before {
  content: "\\ed2e"; }

.ri-folder-4-line:before {
  content: "\\ed2f"; }

.ri-folder-5-fill:before {
  content: "\\ed30"; }

.ri-folder-5-line:before {
  content: "\\ed31"; }

.ri-folder-add-fill:before {
  content: "\\ed32"; }

.ri-folder-add-line:before {
  content: "\\ed33"; }

.ri-folder-chart-2-fill:before {
  content: "\\ed34"; }

.ri-folder-chart-2-line:before {
  content: "\\ed35"; }

.ri-folder-chart-fill:before {
  content: "\\ed36"; }

.ri-folder-chart-line:before {
  content: "\\ed37"; }

.ri-folder-download-fill:before {
  content: "\\ed38"; }

.ri-folder-download-line:before {
  content: "\\ed39"; }

.ri-folder-fill:before {
  content: "\\ed3a"; }

.ri-folder-forbid-fill:before {
  content: "\\ed3b"; }

.ri-folder-forbid-line:before {
  content: "\\ed3c"; }

.ri-folder-history-fill:before {
  content: "\\ed3d"; }

.ri-folder-history-line:before {
  content: "\\ed3e"; }

.ri-folder-info-fill:before {
  content: "\\ed3f"; }

.ri-folder-info-line:before {
  content: "\\ed40"; }

.ri-folder-keyhole-fill:before {
  content: "\\ed41"; }

.ri-folder-keyhole-line:before {
  content: "\\ed42"; }

.ri-folder-line:before {
  content: "\\ed43"; }

.ri-folder-lock-fill:before {
  content: "\\ed44"; }

.ri-folder-lock-line:before {
  content: "\\ed45"; }

.ri-folder-music-fill:before {
  content: "\\ed46"; }

.ri-folder-music-line:before {
  content: "\\ed47"; }

.ri-folder-open-fill:before {
  content: "\\ed48"; }

.ri-folder-open-line:before {
  content: "\\ed49"; }

.ri-folder-received-fill:before {
  content: "\\ed4a"; }

.ri-folder-received-line:before {
  content: "\\ed4b"; }

.ri-folder-reduce-fill:before {
  content: "\\ed4c"; }

.ri-folder-reduce-line:before {
  content: "\\ed4d"; }

.ri-folder-settings-fill:before {
  content: "\\ed4e"; }

.ri-folder-settings-line:before {
  content: "\\ed4f"; }

.ri-folder-shared-fill:before {
  content: "\\ed50"; }

.ri-folder-shared-line:before {
  content: "\\ed51"; }

.ri-folder-shield-2-fill:before {
  content: "\\ed52"; }

.ri-folder-shield-2-line:before {
  content: "\\ed53"; }

.ri-folder-shield-fill:before {
  content: "\\ed54"; }

.ri-folder-shield-line:before {
  content: "\\ed55"; }

.ri-folder-transfer-fill:before {
  content: "\\ed56"; }

.ri-folder-transfer-line:before {
  content: "\\ed57"; }

.ri-folder-unknow-fill:before {
  content: "\\ed58"; }

.ri-folder-unknow-line:before {
  content: "\\ed59"; }

.ri-folder-upload-fill:before {
  content: "\\ed5a"; }

.ri-folder-upload-line:before {
  content: "\\ed5b"; }

.ri-folder-user-fill:before {
  content: "\\ed5c"; }

.ri-folder-user-line:before {
  content: "\\ed5d"; }

.ri-folder-warning-fill:before {
  content: "\\ed5e"; }

.ri-folder-warning-line:before {
  content: "\\ed5f"; }

.ri-folder-zip-fill:before {
  content: "\\ed60"; }

.ri-folder-zip-line:before {
  content: "\\ed61"; }

.ri-folders-fill:before {
  content: "\\ed62"; }

.ri-folders-line:before {
  content: "\\ed63"; }

.ri-font-color:before {
  content: "\\ed64"; }

.ri-font-size-2:before {
  content: "\\ed65"; }

.ri-font-size:before {
  content: "\\ed66"; }

.ri-football-fill:before {
  content: "\\ed67"; }

.ri-football-line:before {
  content: "\\ed68"; }

.ri-footprint-fill:before {
  content: "\\ed69"; }

.ri-footprint-line:before {
  content: "\\ed6a"; }

.ri-forbid-2-fill:before {
  content: "\\ed6b"; }

.ri-forbid-2-line:before {
  content: "\\ed6c"; }

.ri-forbid-fill:before {
  content: "\\ed6d"; }

.ri-forbid-line:before {
  content: "\\ed6e"; }

.ri-format-clear:before {
  content: "\\ed6f"; }

.ri-fridge-fill:before {
  content: "\\ed70"; }

.ri-fridge-line:before {
  content: "\\ed71"; }

.ri-fullscreen-exit-fill:before {
  content: "\\ed72"; }

.ri-fullscreen-exit-line:before {
  content: "\\ed73"; }

.ri-fullscreen-fill:before {
  content: "\\ed74"; }

.ri-fullscreen-line:before {
  content: "\\ed75"; }

.ri-function-fill:before {
  content: "\\ed76"; }

.ri-function-line:before {
  content: "\\ed77"; }

.ri-functions:before {
  content: "\\ed78"; }

.ri-funds-box-fill:before {
  content: "\\ed79"; }

.ri-funds-box-line:before {
  content: "\\ed7a"; }

.ri-funds-fill:before {
  content: "\\ed7b"; }

.ri-funds-line:before {
  content: "\\ed7c"; }

.ri-gallery-fill:before {
  content: "\\ed7d"; }

.ri-gallery-line:before {
  content: "\\ed7e"; }

.ri-gallery-upload-fill:before {
  content: "\\ed7f"; }

.ri-gallery-upload-line:before {
  content: "\\ed80"; }

.ri-game-fill:before {
  content: "\\ed81"; }

.ri-game-line:before {
  content: "\\ed82"; }

.ri-gamepad-fill:before {
  content: "\\ed83"; }

.ri-gamepad-line:before {
  content: "\\ed84"; }

.ri-gas-station-fill:before {
  content: "\\ed85"; }

.ri-gas-station-line:before {
  content: "\\ed86"; }

.ri-gatsby-fill:before {
  content: "\\ed87"; }

.ri-gatsby-line:before {
  content: "\\ed88"; }

.ri-genderless-fill:before {
  content: "\\ed89"; }

.ri-genderless-line:before {
  content: "\\ed8a"; }

.ri-ghost-2-fill:before {
  content: "\\ed8b"; }

.ri-ghost-2-line:before {
  content: "\\ed8c"; }

.ri-ghost-fill:before {
  content: "\\ed8d"; }

.ri-ghost-line:before {
  content: "\\ed8e"; }

.ri-ghost-smile-fill:before {
  content: "\\ed8f"; }

.ri-ghost-smile-line:before {
  content: "\\ed90"; }

.ri-gift-2-fill:before {
  content: "\\ed91"; }

.ri-gift-2-line:before {
  content: "\\ed92"; }

.ri-gift-fill:before {
  content: "\\ed93"; }

.ri-gift-line:before {
  content: "\\ed94"; }

.ri-git-branch-fill:before {
  content: "\\ed95"; }

.ri-git-branch-line:before {
  content: "\\ed96"; }

.ri-git-commit-fill:before {
  content: "\\ed97"; }

.ri-git-commit-line:before {
  content: "\\ed98"; }

.ri-git-merge-fill:before {
  content: "\\ed99"; }

.ri-git-merge-line:before {
  content: "\\ed9a"; }

.ri-git-pull-request-fill:before {
  content: "\\ed9b"; }

.ri-git-pull-request-line:before {
  content: "\\ed9c"; }

.ri-git-repository-commits-fill:before {
  content: "\\ed9d"; }

.ri-git-repository-commits-line:before {
  content: "\\ed9e"; }

.ri-git-repository-fill:before {
  content: "\\ed9f"; }

.ri-git-repository-line:before {
  content: "\\eda0"; }

.ri-git-repository-private-fill:before {
  content: "\\eda1"; }

.ri-git-repository-private-line:before {
  content: "\\eda2"; }

.ri-github-fill:before {
  content: "\\eda3"; }

.ri-github-line:before {
  content: "\\eda4"; }

.ri-gitlab-fill:before {
  content: "\\eda5"; }

.ri-gitlab-line:before {
  content: "\\eda6"; }

.ri-global-fill:before {
  content: "\\eda7"; }

.ri-global-line:before {
  content: "\\eda8"; }

.ri-globe-fill:before {
  content: "\\eda9"; }

.ri-globe-line:before {
  content: "\\edaa"; }

.ri-goblet-fill:before {
  content: "\\edab"; }

.ri-goblet-line:before {
  content: "\\edac"; }

.ri-google-fill:before {
  content: "\\edad"; }

.ri-google-line:before {
  content: "\\edae"; }

.ri-google-play-fill:before {
  content: "\\edaf"; }

.ri-google-play-line:before {
  content: "\\edb0"; }

.ri-government-fill:before {
  content: "\\edb1"; }

.ri-government-line:before {
  content: "\\edb2"; }

.ri-gps-fill:before {
  content: "\\edb3"; }

.ri-gps-line:before {
  content: "\\edb4"; }

.ri-gradienter-fill:before {
  content: "\\edb5"; }

.ri-gradienter-line:before {
  content: "\\edb6"; }

.ri-grid-fill:before {
  content: "\\edb7"; }

.ri-grid-line:before {
  content: "\\edb8"; }

.ri-group-2-fill:before {
  content: "\\edb9"; }

.ri-group-2-line:before {
  content: "\\edba"; }

.ri-group-fill:before {
  content: "\\edbb"; }

.ri-group-line:before {
  content: "\\edbc"; }

.ri-guide-fill:before {
  content: "\\edbd"; }

.ri-guide-line:before {
  content: "\\edbe"; }

.ri-hail-fill:before {
  content: "\\edbf"; }

.ri-hail-line:before {
  content: "\\edc0"; }

.ri-hammer-fill:before {
  content: "\\edc1"; }

.ri-hammer-line:before {
  content: "\\edc2"; }

.ri-hand-coin-fill:before {
  content: "\\edc3"; }

.ri-hand-coin-line:before {
  content: "\\edc4"; }

.ri-hand-heart-fill:before {
  content: "\\edc5"; }

.ri-hand-heart-line:before {
  content: "\\edc6"; }

.ri-handbag-fill:before {
  content: "\\edc7"; }

.ri-handbag-line:before {
  content: "\\edc8"; }

.ri-hard-drive-2-fill:before {
  content: "\\edc9"; }

.ri-hard-drive-2-line:before {
  content: "\\edca"; }

.ri-hard-drive-fill:before {
  content: "\\edcb"; }

.ri-hard-drive-line:before {
  content: "\\edcc"; }

.ri-hashtag:before {
  content: "\\edcd"; }

.ri-haze-2-fill:before {
  content: "\\edce"; }

.ri-haze-2-line:before {
  content: "\\edcf"; }

.ri-haze-fill:before {
  content: "\\edd0"; }

.ri-haze-line:before {
  content: "\\edd1"; }

.ri-hd-fill:before {
  content: "\\edd2"; }

.ri-hd-line:before {
  content: "\\edd3"; }

.ri-heading:before {
  content: "\\edd4"; }

.ri-headphone-fill:before {
  content: "\\edd5"; }

.ri-headphone-line:before {
  content: "\\edd6"; }

.ri-heart-2-fill:before {
  content: "\\edd7"; }

.ri-heart-2-line:before {
  content: "\\edd8"; }

.ri-heart-add-fill:before {
  content: "\\edd9"; }

.ri-heart-add-line:before {
  content: "\\edda"; }

.ri-heart-fill:before {
  content: "\\eddb"; }

.ri-heart-line:before {
  content: "\\eddc"; }

.ri-hearts-fill:before {
  content: "\\eddd"; }

.ri-hearts-line:before {
  content: "\\edde"; }

.ri-heavy-showers-fill:before {
  content: "\\eddf"; }

.ri-heavy-showers-line:before {
  content: "\\ede0"; }

.ri-history-fill:before {
  content: "\\ede1"; }

.ri-history-line:before {
  content: "\\ede2"; }

.ri-home-2-fill:before {
  content: "\\ede3"; }

.ri-home-2-line:before {
  content: "\\ede4"; }

.ri-home-3-fill:before {
  content: "\\ede5"; }

.ri-home-3-line:before {
  content: "\\ede6"; }

.ri-home-4-fill:before {
  content: "\\ede7"; }

.ri-home-4-line:before {
  content: "\\ede8"; }

.ri-home-5-fill:before {
  content: "\\ede9"; }

.ri-home-5-line:before {
  content: "\\edea"; }

.ri-home-6-fill:before {
  content: "\\edeb"; }

.ri-home-6-line:before {
  content: "\\edec"; }

.ri-home-7-fill:before {
  content: "\\eded"; }

.ri-home-7-line:before {
  content: "\\edee"; }

.ri-home-8-fill:before {
  content: "\\edef"; }

.ri-home-8-line:before {
  content: "\\edf0"; }

.ri-home-fill:before {
  content: "\\edf1"; }

.ri-home-gear-fill:before {
  content: "\\edf2"; }

.ri-home-gear-line:before {
  content: "\\edf3"; }

.ri-home-heart-fill:before {
  content: "\\edf4"; }

.ri-home-heart-line:before {
  content: "\\edf5"; }

.ri-home-line:before {
  content: "\\edf6"; }

.ri-home-smile-2-fill:before {
  content: "\\edf7"; }

.ri-home-smile-2-line:before {
  content: "\\edf8"; }

.ri-home-smile-fill:before {
  content: "\\edf9"; }

.ri-home-smile-line:before {
  content: "\\edfa"; }

.ri-home-wifi-fill:before {
  content: "\\edfb"; }

.ri-home-wifi-line:before {
  content: "\\edfc"; }

.ri-honor-of-kings-fill:before {
  content: "\\edfd"; }

.ri-honor-of-kings-line:before {
  content: "\\edfe"; }

.ri-honour-fill:before {
  content: "\\edff"; }

.ri-honour-line:before {
  content: "\\ee00"; }

.ri-hospital-fill:before {
  content: "\\ee01"; }

.ri-hospital-line:before {
  content: "\\ee02"; }

.ri-hotel-bed-fill:before {
  content: "\\ee03"; }

.ri-hotel-bed-line:before {
  content: "\\ee04"; }

.ri-hotel-fill:before {
  content: "\\ee05"; }

.ri-hotel-line:before {
  content: "\\ee06"; }

.ri-hotspot-fill:before {
  content: "\\ee07"; }

.ri-hotspot-line:before {
  content: "\\ee08"; }

.ri-hq-fill:before {
  content: "\\ee09"; }

.ri-hq-line:before {
  content: "\\ee0a"; }

.ri-html5-fill:before {
  content: "\\ee0b"; }

.ri-html5-line:before {
  content: "\\ee0c"; }

.ri-ie-fill:before {
  content: "\\ee0d"; }

.ri-ie-line:before {
  content: "\\ee0e"; }

.ri-image-2-fill:before {
  content: "\\ee0f"; }

.ri-image-2-line:before {
  content: "\\ee10"; }

.ri-image-add-fill:before {
  content: "\\ee11"; }

.ri-image-add-line:before {
  content: "\\ee12"; }

.ri-image-fill:before {
  content: "\\ee13"; }

.ri-image-line:before {
  content: "\\ee14"; }

.ri-inbox-archive-fill:before {
  content: "\\ee15"; }

.ri-inbox-archive-line:before {
  content: "\\ee16"; }

.ri-inbox-fill:before {
  content: "\\ee17"; }

.ri-inbox-line:before {
  content: "\\ee18"; }

.ri-inbox-unarchive-fill:before {
  content: "\\ee19"; }

.ri-inbox-unarchive-line:before {
  content: "\\ee1a"; }

.ri-increase-decrease-fill:before {
  content: "\\ee1b"; }

.ri-increase-decrease-line:before {
  content: "\\ee1c"; }

.ri-indent-decrease:before {
  content: "\\ee1d"; }

.ri-indent-increase:before {
  content: "\\ee1e"; }

.ri-indeterminate-circle-fill:before {
  content: "\\ee1f"; }

.ri-indeterminate-circle-line:before {
  content: "\\ee20"; }

.ri-information-fill:before {
  content: "\\ee21"; }

.ri-information-line:before {
  content: "\\ee22"; }

.ri-input-cursor-move:before {
  content: "\\ee23"; }

.ri-input-method-fill:before {
  content: "\\ee24"; }

.ri-input-method-line:before {
  content: "\\ee25"; }

.ri-instagram-fill:before {
  content: "\\ee26"; }

.ri-instagram-line:before {
  content: "\\ee27"; }

.ri-install-fill:before {
  content: "\\ee28"; }

.ri-install-line:before {
  content: "\\ee29"; }

.ri-invision-fill:before {
  content: "\\ee2a"; }

.ri-invision-line:before {
  content: "\\ee2b"; }

.ri-italic:before {
  content: "\\ee2c"; }

.ri-kakao-talk-fill:before {
  content: "\\ee2d"; }

.ri-kakao-talk-line:before {
  content: "\\ee2e"; }

.ri-key-2-fill:before {
  content: "\\ee2f"; }

.ri-key-2-line:before {
  content: "\\ee30"; }

.ri-key-fill:before {
  content: "\\ee31"; }

.ri-key-line:before {
  content: "\\ee32"; }

.ri-keyboard-box-fill:before {
  content: "\\ee33"; }

.ri-keyboard-box-line:before {
  content: "\\ee34"; }

.ri-keyboard-fill:before {
  content: "\\ee35"; }

.ri-keyboard-line:before {
  content: "\\ee36"; }

.ri-keynote-fill:before {
  content: "\\ee37"; }

.ri-keynote-line:before {
  content: "\\ee38"; }

.ri-knife-blood-fill:before {
  content: "\\ee39"; }

.ri-knife-blood-line:before {
  content: "\\ee3a"; }

.ri-knife-fill:before {
  content: "\\ee3b"; }

.ri-knife-line:before {
  content: "\\ee3c"; }

.ri-landscape-fill:before {
  content: "\\ee3d"; }

.ri-landscape-line:before {
  content: "\\ee3e"; }

.ri-layout-2-fill:before {
  content: "\\ee3f"; }

.ri-layout-2-line:before {
  content: "\\ee40"; }

.ri-layout-3-fill:before {
  content: "\\ee41"; }

.ri-layout-3-line:before {
  content: "\\ee42"; }

.ri-layout-4-fill:before {
  content: "\\ee43"; }

.ri-layout-4-line:before {
  content: "\\ee44"; }

.ri-layout-5-fill:before {
  content: "\\ee45"; }

.ri-layout-5-line:before {
  content: "\\ee46"; }

.ri-layout-6-fill:before {
  content: "\\ee47"; }

.ri-layout-6-line:before {
  content: "\\ee48"; }

.ri-layout-bottom-2-fill:before {
  content: "\\ee49"; }

.ri-layout-bottom-2-line:before {
  content: "\\ee4a"; }

.ri-layout-bottom-fill:before {
  content: "\\ee4b"; }

.ri-layout-bottom-line:before {
  content: "\\ee4c"; }

.ri-layout-column-fill:before {
  content: "\\ee4d"; }

.ri-layout-column-line:before {
  content: "\\ee4e"; }

.ri-layout-fill:before {
  content: "\\ee4f"; }

.ri-layout-grid-fill:before {
  content: "\\ee50"; }

.ri-layout-grid-line:before {
  content: "\\ee51"; }

.ri-layout-left-2-fill:before {
  content: "\\ee52"; }

.ri-layout-left-2-line:before {
  content: "\\ee53"; }

.ri-layout-left-fill:before {
  content: "\\ee54"; }

.ri-layout-left-line:before {
  content: "\\ee55"; }

.ri-layout-line:before {
  content: "\\ee56"; }

.ri-layout-masonry-fill:before {
  content: "\\ee57"; }

.ri-layout-masonry-line:before {
  content: "\\ee58"; }

.ri-layout-right-2-fill:before {
  content: "\\ee59"; }

.ri-layout-right-2-line:before {
  content: "\\ee5a"; }

.ri-layout-right-fill:before {
  content: "\\ee5b"; }

.ri-layout-right-line:before {
  content: "\\ee5c"; }

.ri-layout-row-fill:before {
  content: "\\ee5d"; }

.ri-layout-row-line:before {
  content: "\\ee5e"; }

.ri-layout-top-2-fill:before {
  content: "\\ee5f"; }

.ri-layout-top-2-line:before {
  content: "\\ee60"; }

.ri-layout-top-fill:before {
  content: "\\ee61"; }

.ri-layout-top-line:before {
  content: "\\ee62"; }

.ri-leaf-fill:before {
  content: "\\ee63"; }

.ri-leaf-line:before {
  content: "\\ee64"; }

.ri-lifebuoy-fill:before {
  content: "\\ee65"; }

.ri-lifebuoy-line:before {
  content: "\\ee66"; }

.ri-lightbulb-fill:before {
  content: "\\ee67"; }

.ri-lightbulb-flash-fill:before {
  content: "\\ee68"; }

.ri-lightbulb-flash-line:before {
  content: "\\ee69"; }

.ri-lightbulb-line:before {
  content: "\\ee6a"; }

.ri-line-chart-fill:before {
  content: "\\ee6b"; }

.ri-line-chart-line:before {
  content: "\\ee6c"; }

.ri-line-fill:before {
  content: "\\ee6d"; }

.ri-line-height:before {
  content: "\\ee6e"; }

.ri-line-line:before {
  content: "\\ee6f"; }

.ri-link-m:before {
  content: "\\ee70"; }

.ri-link-unlink-m:before {
  content: "\\ee71"; }

.ri-link-unlink:before {
  content: "\\ee72"; }

.ri-link:before {
  content: "\\ee73"; }

.ri-linkedin-box-fill:before {
  content: "\\ee74"; }

.ri-linkedin-box-line:before {
  content: "\\ee75"; }

.ri-linkedin-fill:before {
  content: "\\ee76"; }

.ri-linkedin-line:before {
  content: "\\ee77"; }

.ri-links-fill:before {
  content: "\\ee78"; }

.ri-links-line:before {
  content: "\\ee79"; }

.ri-list-check-2:before {
  content: "\\ee7a"; }

.ri-list-check:before {
  content: "\\ee7b"; }

.ri-list-ordered:before {
  content: "\\ee7c"; }

.ri-list-settings-fill:before {
  content: "\\ee7d"; }

.ri-list-settings-line:before {
  content: "\\ee7e"; }

.ri-list-unordered:before {
  content: "\\ee7f"; }

.ri-live-fill:before {
  content: "\\ee80"; }

.ri-live-line:before {
  content: "\\ee81"; }

.ri-loader-2-fill:before {
  content: "\\ee82"; }

.ri-loader-2-line:before {
  content: "\\ee83"; }

.ri-loader-3-fill:before {
  content: "\\ee84"; }

.ri-loader-3-line:before {
  content: "\\ee85"; }

.ri-loader-4-fill:before {
  content: "\\ee86"; }

.ri-loader-4-line:before {
  content: "\\ee87"; }

.ri-loader-5-fill:before {
  content: "\\ee88"; }

.ri-loader-5-line:before {
  content: "\\ee89"; }

.ri-loader-fill:before {
  content: "\\ee8a"; }

.ri-loader-line:before {
  content: "\\ee8b"; }

.ri-lock-2-fill:before {
  content: "\\ee8c"; }

.ri-lock-2-line:before {
  content: "\\ee8d"; }

.ri-lock-fill:before {
  content: "\\ee8e"; }

.ri-lock-line:before {
  content: "\\ee8f"; }

.ri-lock-password-fill:before {
  content: "\\ee90"; }

.ri-lock-password-line:before {
  content: "\\ee91"; }

.ri-lock-unlock-fill:before {
  content: "\\ee92"; }

.ri-lock-unlock-line:before {
  content: "\\ee93"; }

.ri-login-box-fill:before {
  content: "\\ee94"; }

.ri-login-box-line:before {
  content: "\\ee95"; }

.ri-login-circle-fill:before {
  content: "\\ee96"; }

.ri-login-circle-line:before {
  content: "\\ee97"; }

.ri-logout-box-fill:before {
  content: "\\ee98"; }

.ri-logout-box-line:before {
  content: "\\ee99"; }

.ri-logout-box-r-fill:before {
  content: "\\ee9a"; }

.ri-logout-box-r-line:before {
  content: "\\ee9b"; }

.ri-logout-circle-fill:before {
  content: "\\ee9c"; }

.ri-logout-circle-line:before {
  content: "\\ee9d"; }

.ri-logout-circle-r-fill:before {
  content: "\\ee9e"; }

.ri-logout-circle-r-line:before {
  content: "\\ee9f"; }

.ri-luggage-cart-fill:before {
  content: "\\eea0"; }

.ri-luggage-cart-line:before {
  content: "\\eea1"; }

.ri-luggage-deposit-fill:before {
  content: "\\eea2"; }

.ri-luggage-deposit-line:before {
  content: "\\eea3"; }

.ri-mac-fill:before {
  content: "\\eea4"; }

.ri-mac-line:before {
  content: "\\eea5"; }

.ri-macbook-fill:before {
  content: "\\eea6"; }

.ri-macbook-line:before {
  content: "\\eea7"; }

.ri-magic-fill:before {
  content: "\\eea8"; }

.ri-magic-line:before {
  content: "\\eea9"; }

.ri-mail-add-fill:before {
  content: "\\eeaa"; }

.ri-mail-add-line:before {
  content: "\\eeab"; }

.ri-mail-check-fill:before {
  content: "\\eeac"; }

.ri-mail-check-line:before {
  content: "\\eead"; }

.ri-mail-close-fill:before {
  content: "\\eeae"; }

.ri-mail-close-line:before {
  content: "\\eeaf"; }

.ri-mail-download-fill:before {
  content: "\\eeb0"; }

.ri-mail-download-line:before {
  content: "\\eeb1"; }

.ri-mail-fill:before {
  content: "\\eeb2"; }

.ri-mail-forbid-fill:before {
  content: "\\eeb3"; }

.ri-mail-forbid-line:before {
  content: "\\eeb4"; }

.ri-mail-line:before {
  content: "\\eeb5"; }

.ri-mail-lock-fill:before {
  content: "\\eeb6"; }

.ri-mail-lock-line:before {
  content: "\\eeb7"; }

.ri-mail-open-fill:before {
  content: "\\eeb8"; }

.ri-mail-open-line:before {
  content: "\\eeb9"; }

.ri-mail-send-fill:before {
  content: "\\eeba"; }

.ri-mail-send-line:before {
  content: "\\eebb"; }

.ri-mail-settings-fill:before {
  content: "\\eebc"; }

.ri-mail-settings-line:before {
  content: "\\eebd"; }

.ri-mail-star-fill:before {
  content: "\\eebe"; }

.ri-mail-star-line:before {
  content: "\\eebf"; }

.ri-mail-unread-fill:before {
  content: "\\eec0"; }

.ri-mail-unread-line:before {
  content: "\\eec1"; }

.ri-mail-volume-fill:before {
  content: "\\eec2"; }

.ri-mail-volume-line:before {
  content: "\\eec3"; }

.ri-map-2-fill:before {
  content: "\\eec4"; }

.ri-map-2-line:before {
  content: "\\eec5"; }

.ri-map-fill:before {
  content: "\\eec6"; }

.ri-map-line:before {
  content: "\\eec7"; }

.ri-map-pin-2-fill:before {
  content: "\\eec8"; }

.ri-map-pin-2-line:before {
  content: "\\eec9"; }

.ri-map-pin-3-fill:before {
  content: "\\eeca"; }

.ri-map-pin-3-line:before {
  content: "\\eecb"; }

.ri-map-pin-4-fill:before {
  content: "\\eecc"; }

.ri-map-pin-4-line:before {
  content: "\\eecd"; }

.ri-map-pin-5-fill:before {
  content: "\\eece"; }

.ri-map-pin-5-line:before {
  content: "\\eecf"; }

.ri-map-pin-add-fill:before {
  content: "\\eed0"; }

.ri-map-pin-add-line:before {
  content: "\\eed1"; }

.ri-map-pin-fill:before {
  content: "\\eed2"; }

.ri-map-pin-line:before {
  content: "\\eed3"; }

.ri-map-pin-range-fill:before {
  content: "\\eed4"; }

.ri-map-pin-range-line:before {
  content: "\\eed5"; }

.ri-map-pin-time-fill:before {
  content: "\\eed6"; }

.ri-map-pin-time-line:before {
  content: "\\eed7"; }

.ri-map-pin-user-fill:before {
  content: "\\eed8"; }

.ri-map-pin-user-line:before {
  content: "\\eed9"; }

.ri-mark-pen-fill:before {
  content: "\\eeda"; }

.ri-mark-pen-line:before {
  content: "\\eedb"; }

.ri-markdown-fill:before {
  content: "\\eedc"; }

.ri-markdown-line:before {
  content: "\\eedd"; }

.ri-markup-fill:before {
  content: "\\eede"; }

.ri-markup-line:before {
  content: "\\eedf"; }

.ri-mastercard-fill:before {
  content: "\\eee0"; }

.ri-mastercard-line:before {
  content: "\\eee1"; }

.ri-mastodon-fill:before {
  content: "\\eee2"; }

.ri-mastodon-line:before {
  content: "\\eee3"; }

.ri-medal-2-fill:before {
  content: "\\eee4"; }

.ri-medal-2-line:before {
  content: "\\eee5"; }

.ri-medal-fill:before {
  content: "\\eee6"; }

.ri-medal-line:before {
  content: "\\eee7"; }

.ri-medium-fill:before {
  content: "\\eee8"; }

.ri-medium-line:before {
  content: "\\eee9"; }

.ri-men-fill:before {
  content: "\\eeea"; }

.ri-men-line:before {
  content: "\\eeeb"; }

.ri-menu-2-fill:before {
  content: "\\eeec"; }

.ri-menu-2-line:before {
  content: "\\eeed"; }

.ri-menu-3-fill:before {
  content: "\\eeee"; }

.ri-menu-3-line:before {
  content: "\\eeef"; }

.ri-menu-4-fill:before {
  content: "\\eef0"; }

.ri-menu-4-line:before {
  content: "\\eef1"; }

.ri-menu-5-fill:before {
  content: "\\eef2"; }

.ri-menu-5-line:before {
  content: "\\eef3"; }

.ri-menu-add-fill:before {
  content: "\\eef4"; }

.ri-menu-add-line:before {
  content: "\\eef5"; }

.ri-menu-fill:before {
  content: "\\eef6"; }

.ri-menu-line:before {
  content: "\\eef7"; }

.ri-message-2-fill:before {
  content: "\\eef8"; }

.ri-message-2-line:before {
  content: "\\eef9"; }

.ri-message-3-fill:before {
  content: "\\eefa"; }

.ri-message-3-line:before {
  content: "\\eefb"; }

.ri-message-fill:before {
  content: "\\eefc"; }

.ri-message-line:before {
  content: "\\eefd"; }

.ri-messenger-fill:before {
  content: "\\eefe"; }

.ri-messenger-line:before {
  content: "\\eeff"; }

.ri-meteor-fill:before {
  content: "\\ef00"; }

.ri-meteor-line:before {
  content: "\\ef01"; }

.ri-mic-2-fill:before {
  content: "\\ef02"; }

.ri-mic-2-line:before {
  content: "\\ef03"; }

.ri-mic-fill:before {
  content: "\\ef04"; }

.ri-mic-line:before {
  content: "\\ef05"; }

.ri-mic-off-fill:before {
  content: "\\ef06"; }

.ri-mic-off-line:before {
  content: "\\ef07"; }

.ri-mickey-fill:before {
  content: "\\ef08"; }

.ri-mickey-line:before {
  content: "\\ef09"; }

.ri-mini-program-fill:before {
  content: "\\ef0a"; }

.ri-mini-program-line:before {
  content: "\\ef0b"; }

.ri-mist-fill:before {
  content: "\\ef0c"; }

.ri-mist-line:before {
  content: "\\ef0d"; }

.ri-money-cny-box-fill:before {
  content: "\\ef0e"; }

.ri-money-cny-box-line:before {
  content: "\\ef0f"; }

.ri-money-cny-circle-fill:before {
  content: "\\ef10"; }

.ri-money-cny-circle-line:before {
  content: "\\ef11"; }

.ri-money-dollar-box-fill:before {
  content: "\\ef12"; }

.ri-money-dollar-box-line:before {
  content: "\\ef13"; }

.ri-money-dollar-circle-fill:before {
  content: "\\ef14"; }

.ri-money-dollar-circle-line:before {
  content: "\\ef15"; }

.ri-money-euro-box-fill:before {
  content: "\\ef16"; }

.ri-money-euro-box-line:before {
  content: "\\ef17"; }

.ri-money-euro-circle-fill:before {
  content: "\\ef18"; }

.ri-money-euro-circle-line:before {
  content: "\\ef19"; }

.ri-money-pound-box-fill:before {
  content: "\\ef1a"; }

.ri-money-pound-box-line:before {
  content: "\\ef1b"; }

.ri-money-pound-circle-fill:before {
  content: "\\ef1c"; }

.ri-money-pound-circle-line:before {
  content: "\\ef1d"; }

.ri-moon-clear-fill:before {
  content: "\\ef1e"; }

.ri-moon-clear-line:before {
  content: "\\ef1f"; }

.ri-moon-cloudy-fill:before {
  content: "\\ef20"; }

.ri-moon-cloudy-line:before {
  content: "\\ef21"; }

.ri-moon-fill:before {
  content: "\\ef22"; }

.ri-moon-foggy-fill:before {
  content: "\\ef23"; }

.ri-moon-foggy-line:before {
  content: "\\ef24"; }

.ri-moon-line:before {
  content: "\\ef25"; }

.ri-more-2-fill:before {
  content: "\\ef26"; }

.ri-more-2-line:before {
  content: "\\ef27"; }

.ri-more-fill:before {
  content: "\\ef28"; }

.ri-more-line:before {
  content: "\\ef29"; }

.ri-motorbike-fill:before {
  content: "\\ef2a"; }

.ri-motorbike-line:before {
  content: "\\ef2b"; }

.ri-mouse-fill:before {
  content: "\\ef2c"; }

.ri-mouse-line:before {
  content: "\\ef2d"; }

.ri-movie-2-fill:before {
  content: "\\ef2e"; }

.ri-movie-2-line:before {
  content: "\\ef2f"; }

.ri-movie-fill:before {
  content: "\\ef30"; }

.ri-movie-line:before {
  content: "\\ef31"; }

.ri-music-2-fill:before {
  content: "\\ef32"; }

.ri-music-2-line:before {
  content: "\\ef33"; }

.ri-music-fill:before {
  content: "\\ef34"; }

.ri-music-line:before {
  content: "\\ef35"; }

.ri-mv-fill:before {
  content: "\\ef36"; }

.ri-mv-line:before {
  content: "\\ef37"; }

.ri-navigation-fill:before {
  content: "\\ef38"; }

.ri-navigation-line:before {
  content: "\\ef39"; }

.ri-netease-cloud-music-fill:before {
  content: "\\ef3a"; }

.ri-netease-cloud-music-line:before {
  content: "\\ef3b"; }

.ri-netflix-fill:before {
  content: "\\ef3c"; }

.ri-netflix-line:before {
  content: "\\ef3d"; }

.ri-newspaper-fill:before {
  content: "\\ef3e"; }

.ri-newspaper-line:before {
  content: "\\ef3f"; }

.ri-notification-2-fill:before {
  content: "\\ef40"; }

.ri-notification-2-line:before {
  content: "\\ef41"; }

.ri-notification-3-fill:before {
  content: "\\ef42"; }

.ri-notification-3-line:before {
  content: "\\ef43"; }

.ri-notification-4-fill:before {
  content: "\\ef44"; }

.ri-notification-4-line:before {
  content: "\\ef45"; }

.ri-notification-badge-fill:before {
  content: "\\ef46"; }

.ri-notification-badge-line:before {
  content: "\\ef47"; }

.ri-notification-fill:before {
  content: "\\ef48"; }

.ri-notification-line:before {
  content: "\\ef49"; }

.ri-notification-off-fill:before {
  content: "\\ef4a"; }

.ri-notification-off-line:before {
  content: "\\ef4b"; }

.ri-npmjs-fill:before {
  content: "\\ef4c"; }

.ri-npmjs-line:before {
  content: "\\ef4d"; }

.ri-number-0:before {
  content: "\\ef4e"; }

.ri-number-1:before {
  content: "\\ef4f"; }

.ri-number-2:before {
  content: "\\ef50"; }

.ri-number-3:before {
  content: "\\ef51"; }

.ri-number-4:before {
  content: "\\ef52"; }

.ri-number-5:before {
  content: "\\ef53"; }

.ri-number-6:before {
  content: "\\ef54"; }

.ri-number-7:before {
  content: "\\ef55"; }

.ri-number-8:before {
  content: "\\ef56"; }

.ri-number-9:before {
  content: "\\ef57"; }

.ri-numbers-fill:before {
  content: "\\ef58"; }

.ri-numbers-line:before {
  content: "\\ef59"; }

.ri-oil-fill:before {
  content: "\\ef5a"; }

.ri-oil-line:before {
  content: "\\ef5b"; }

.ri-omega:before {
  content: "\\ef5c"; }

.ri-open-arm-fill:before {
  content: "\\ef5d"; }

.ri-open-arm-line:before {
  content: "\\ef5e"; }

.ri-open-source-fill:before {
  content: "\\ef5f"; }

.ri-open-source-line:before {
  content: "\\ef60"; }

.ri-opera-fill:before {
  content: "\\ef61"; }

.ri-opera-line:before {
  content: "\\ef62"; }

.ri-order-play-fill:before {
  content: "\\ef63"; }

.ri-order-play-line:before {
  content: "\\ef64"; }

.ri-outlet-2-fill:before {
  content: "\\ef65"; }

.ri-outlet-2-line:before {
  content: "\\ef66"; }

.ri-outlet-fill:before {
  content: "\\ef67"; }

.ri-outlet-line:before {
  content: "\\ef68"; }

.ri-page-separator:before {
  content: "\\ef69"; }

.ri-pages-fill:before {
  content: "\\ef6a"; }

.ri-pages-line:before {
  content: "\\ef6b"; }

.ri-paint-brush-fill:before {
  content: "\\ef6c"; }

.ri-paint-brush-line:before {
  content: "\\ef6d"; }

.ri-paint-fill:before {
  content: "\\ef6e"; }

.ri-paint-line:before {
  content: "\\ef6f"; }

.ri-palette-fill:before {
  content: "\\ef70"; }

.ri-palette-line:before {
  content: "\\ef71"; }

.ri-pantone-fill:before {
  content: "\\ef72"; }

.ri-pantone-line:before {
  content: "\\ef73"; }

.ri-paragraph:before {
  content: "\\ef74"; }

.ri-parent-fill:before {
  content: "\\ef75"; }

.ri-parent-line:before {
  content: "\\ef76"; }

.ri-parentheses-fill:before {
  content: "\\ef77"; }

.ri-parentheses-line:before {
  content: "\\ef78"; }

.ri-parking-box-fill:before {
  content: "\\ef79"; }

.ri-parking-box-line:before {
  content: "\\ef7a"; }

.ri-parking-fill:before {
  content: "\\ef7b"; }

.ri-parking-line:before {
  content: "\\ef7c"; }

.ri-passport-fill:before {
  content: "\\ef7d"; }

.ri-passport-line:before {
  content: "\\ef7e"; }

.ri-patreon-fill:before {
  content: "\\ef7f"; }

.ri-patreon-line:before {
  content: "\\ef80"; }

.ri-pause-circle-fill:before {
  content: "\\ef81"; }

.ri-pause-circle-line:before {
  content: "\\ef82"; }

.ri-pause-fill:before {
  content: "\\ef83"; }

.ri-pause-line:before {
  content: "\\ef84"; }

.ri-pause-mini-fill:before {
  content: "\\ef85"; }

.ri-pause-mini-line:before {
  content: "\\ef86"; }

.ri-paypal-fill:before {
  content: "\\ef87"; }

.ri-paypal-line:before {
  content: "\\ef88"; }

.ri-pen-nib-fill:before {
  content: "\\ef89"; }

.ri-pen-nib-line:before {
  content: "\\ef8a"; }

.ri-pencil-fill:before {
  content: "\\ef8b"; }

.ri-pencil-line:before {
  content: "\\ef8c"; }

.ri-pencil-ruler-2-fill:before {
  content: "\\ef8d"; }

.ri-pencil-ruler-2-line:before {
  content: "\\ef8e"; }

.ri-pencil-ruler-fill:before {
  content: "\\ef8f"; }

.ri-pencil-ruler-line:before {
  content: "\\ef90"; }

.ri-percent-fill:before {
  content: "\\ef91"; }

.ri-percent-line:before {
  content: "\\ef92"; }

.ri-phone-camera-fill:before {
  content: "\\ef93"; }

.ri-phone-camera-line:before {
  content: "\\ef94"; }

.ri-phone-fill:before {
  content: "\\ef95"; }

.ri-phone-find-fill:before {
  content: "\\ef96"; }

.ri-phone-find-line:before {
  content: "\\ef97"; }

.ri-phone-line:before {
  content: "\\ef98"; }

.ri-phone-lock-fill:before {
  content: "\\ef99"; }

.ri-phone-lock-line:before {
  content: "\\ef9a"; }

.ri-picture-in-picture-2-fill:before {
  content: "\\ef9b"; }

.ri-picture-in-picture-2-line:before {
  content: "\\ef9c"; }

.ri-picture-in-picture-exit-fill:before {
  content: "\\ef9d"; }

.ri-picture-in-picture-exit-line:before {
  content: "\\ef9e"; }

.ri-picture-in-picture-fill:before {
  content: "\\ef9f"; }

.ri-picture-in-picture-line:before {
  content: "\\efa0"; }

.ri-pie-chart-2-fill:before {
  content: "\\efa1"; }

.ri-pie-chart-2-line:before {
  content: "\\efa2"; }

.ri-pie-chart-box-fill:before {
  content: "\\efa3"; }

.ri-pie-chart-box-line:before {
  content: "\\efa4"; }

.ri-pie-chart-fill:before {
  content: "\\efa5"; }

.ri-pie-chart-line:before {
  content: "\\efa6"; }

.ri-pin-distance-fill:before {
  content: "\\efa7"; }

.ri-pin-distance-line:before {
  content: "\\efa8"; }

.ri-ping-pong-fill:before {
  content: "\\efa9"; }

.ri-ping-pong-line:before {
  content: "\\efaa"; }

.ri-pinterest-fill:before {
  content: "\\efab"; }

.ri-pinterest-line:before {
  content: "\\efac"; }

.ri-pinyin-input:before {
  content: "\\efad"; }

.ri-pixelfed-fill:before {
  content: "\\efae"; }

.ri-pixelfed-line:before {
  content: "\\efaf"; }

.ri-plane-fill:before {
  content: "\\efb0"; }

.ri-plane-line:before {
  content: "\\efb1"; }

.ri-plant-fill:before {
  content: "\\efb2"; }

.ri-plant-line:before {
  content: "\\efb3"; }

.ri-play-circle-fill:before {
  content: "\\efb4"; }

.ri-play-circle-line:before {
  content: "\\efb5"; }

.ri-play-fill:before {
  content: "\\efb6"; }

.ri-play-line:before {
  content: "\\efb7"; }

.ri-play-list-add-fill:before {
  content: "\\efb8"; }

.ri-play-list-add-line:before {
  content: "\\efb9"; }

.ri-play-list-fill:before {
  content: "\\efba"; }

.ri-play-list-line:before {
  content: "\\efbb"; }

.ri-play-mini-fill:before {
  content: "\\efbc"; }

.ri-play-mini-line:before {
  content: "\\efbd"; }

.ri-playstation-fill:before {
  content: "\\efbe"; }

.ri-playstation-line:before {
  content: "\\efbf"; }

.ri-plug-2-fill:before {
  content: "\\efc0"; }

.ri-plug-2-line:before {
  content: "\\efc1"; }

.ri-plug-fill:before {
  content: "\\efc2"; }

.ri-plug-line:before {
  content: "\\efc3"; }

.ri-polaroid-2-fill:before {
  content: "\\efc4"; }

.ri-polaroid-2-line:before {
  content: "\\efc5"; }

.ri-polaroid-fill:before {
  content: "\\efc6"; }

.ri-polaroid-line:before {
  content: "\\efc7"; }

.ri-police-car-fill:before {
  content: "\\efc8"; }

.ri-police-car-line:before {
  content: "\\efc9"; }

.ri-price-tag-2-fill:before {
  content: "\\efca"; }

.ri-price-tag-2-line:before {
  content: "\\efcb"; }

.ri-price-tag-3-fill:before {
  content: "\\efcc"; }

.ri-price-tag-3-line:before {
  content: "\\efcd"; }

.ri-price-tag-fill:before {
  content: "\\efce"; }

.ri-price-tag-line:before {
  content: "\\efcf"; }

.ri-printer-cloud-fill:before {
  content: "\\efd0"; }

.ri-printer-cloud-line:before {
  content: "\\efd1"; }

.ri-printer-fill:before {
  content: "\\efd2"; }

.ri-printer-line:before {
  content: "\\efd3"; }

.ri-product-hunt-fill:before {
  content: "\\efd4"; }

.ri-product-hunt-line:before {
  content: "\\efd5"; }

.ri-profile-fill:before {
  content: "\\efd6"; }

.ri-profile-line:before {
  content: "\\efd7"; }

.ri-projector-2-fill:before {
  content: "\\efd8"; }

.ri-projector-2-line:before {
  content: "\\efd9"; }

.ri-projector-fill:before {
  content: "\\efda"; }

.ri-projector-line:before {
  content: "\\efdb"; }

.ri-pushpin-2-fill:before {
  content: "\\efdc"; }

.ri-pushpin-2-line:before {
  content: "\\efdd"; }

.ri-pushpin-fill:before {
  content: "\\efde"; }

.ri-pushpin-line:before {
  content: "\\efdf"; }

.ri-qq-fill:before {
  content: "\\efe0"; }

.ri-qq-line:before {
  content: "\\efe1"; }

.ri-qr-code-fill:before {
  content: "\\efe2"; }

.ri-qr-code-line:before {
  content: "\\efe3"; }

.ri-qr-scan-2-fill:before {
  content: "\\efe4"; }

.ri-qr-scan-2-line:before {
  content: "\\efe5"; }

.ri-qr-scan-fill:before {
  content: "\\efe6"; }

.ri-qr-scan-line:before {
  content: "\\efe7"; }

.ri-question-answer-fill:before {
  content: "\\efe8"; }

.ri-question-answer-line:before {
  content: "\\efe9"; }

.ri-question-fill:before {
  content: "\\efea"; }

.ri-question-line:before {
  content: "\\efeb"; }

.ri-questionnaire-fill:before {
  content: "\\efec"; }

.ri-questionnaire-line:before {
  content: "\\efed"; }

.ri-quill-pen-fill:before {
  content: "\\efee"; }

.ri-quill-pen-line:before {
  content: "\\efef"; }

.ri-radar-fill:before {
  content: "\\eff0"; }

.ri-radar-line:before {
  content: "\\eff1"; }

.ri-radio-2-fill:before {
  content: "\\eff2"; }

.ri-radio-2-line:before {
  content: "\\eff3"; }

.ri-radio-button-fill:before {
  content: "\\eff4"; }

.ri-radio-button-line:before {
  content: "\\eff5"; }

.ri-radio-fill:before {
  content: "\\eff6"; }

.ri-radio-line:before {
  content: "\\eff7"; }

.ri-rainbow-fill:before {
  content: "\\eff8"; }

.ri-rainbow-line:before {
  content: "\\eff9"; }

.ri-rainy-fill:before {
  content: "\\effa"; }

.ri-rainy-line:before {
  content: "\\effb"; }

.ri-reactjs-fill:before {
  content: "\\effc"; }

.ri-reactjs-line:before {
  content: "\\effd"; }

.ri-record-circle-fill:before {
  content: "\\effe"; }

.ri-record-circle-line:before {
  content: "\\efff"; }

.ri-record-mail-fill:before {
  content: "\\f000"; }

.ri-record-mail-line:before {
  content: "\\f001"; }

.ri-recycle-fill:before {
  content: "\\f002"; }

.ri-recycle-line:before {
  content: "\\f003"; }

.ri-red-packet-fill:before {
  content: "\\f004"; }

.ri-red-packet-line:before {
  content: "\\f005"; }

.ri-reddit-fill:before {
  content: "\\f006"; }

.ri-reddit-line:before {
  content: "\\f007"; }

.ri-refresh-fill:before {
  content: "\\f008"; }

.ri-refresh-line:before {
  content: "\\f009"; }

.ri-refund-2-fill:before {
  content: "\\f00a"; }

.ri-refund-2-line:before {
  content: "\\f00b"; }

.ri-refund-fill:before {
  content: "\\f00c"; }

.ri-refund-line:before {
  content: "\\f00d"; }

.ri-registered-fill:before {
  content: "\\f00e"; }

.ri-registered-line:before {
  content: "\\f00f"; }

.ri-remixicon-fill:before {
  content: "\\f010"; }

.ri-remixicon-line:before {
  content: "\\f011"; }

.ri-remote-control-2-fill:before {
  content: "\\f012"; }

.ri-remote-control-2-line:before {
  content: "\\f013"; }

.ri-remote-control-fill:before {
  content: "\\f014"; }

.ri-remote-control-line:before {
  content: "\\f015"; }

.ri-repeat-2-fill:before {
  content: "\\f016"; }

.ri-repeat-2-line:before {
  content: "\\f017"; }

.ri-repeat-fill:before {
  content: "\\f018"; }

.ri-repeat-line:before {
  content: "\\f019"; }

.ri-repeat-one-fill:before {
  content: "\\f01a"; }

.ri-repeat-one-line:before {
  content: "\\f01b"; }

.ri-reply-fill:before {
  content: "\\f01c"; }

.ri-reply-line:before {
  content: "\\f01d"; }

.ri-reserved-fill:before {
  content: "\\f01e"; }

.ri-reserved-line:before {
  content: "\\f01f"; }

.ri-restart-fill:before {
  content: "\\f020"; }

.ri-restart-line:before {
  content: "\\f021"; }

.ri-restaurant-2-fill:before {
  content: "\\f022"; }

.ri-restaurant-2-line:before {
  content: "\\f023"; }

.ri-restaurant-fill:before {
  content: "\\f024"; }

.ri-restaurant-line:before {
  content: "\\f025"; }

.ri-rewind-fill:before {
  content: "\\f026"; }

.ri-rewind-line:before {
  content: "\\f027"; }

.ri-rewind-mini-fill:before {
  content: "\\f028"; }

.ri-rewind-mini-line:before {
  content: "\\f029"; }

.ri-rhythm-fill:before {
  content: "\\f02a"; }

.ri-rhythm-line:before {
  content: "\\f02b"; }

.ri-riding-fill:before {
  content: "\\f02c"; }

.ri-riding-line:before {
  content: "\\f02d"; }

.ri-road-map-fill:before {
  content: "\\f02e"; }

.ri-road-map-line:before {
  content: "\\f02f"; }

.ri-roadster-fill:before {
  content: "\\f030"; }

.ri-roadster-line:before {
  content: "\\f031"; }

.ri-robot-fill:before {
  content: "\\f032"; }

.ri-robot-line:before {
  content: "\\f033"; }

.ri-rocket-2-fill:before {
  content: "\\f034"; }

.ri-rocket-2-line:before {
  content: "\\f035"; }

.ri-rocket-fill:before {
  content: "\\f036"; }

.ri-rocket-line:before {
  content: "\\f037"; }

.ri-rotate-lock-fill:before {
  content: "\\f038"; }

.ri-rotate-lock-line:before {
  content: "\\f039"; }

.ri-route-fill:before {
  content: "\\f03a"; }

.ri-route-line:before {
  content: "\\f03b"; }

.ri-router-fill:before {
  content: "\\f03c"; }

.ri-router-line:before {
  content: "\\f03d"; }

.ri-rss-fill:before {
  content: "\\f03e"; }

.ri-rss-line:before {
  content: "\\f03f"; }

.ri-ruler-2-fill:before {
  content: "\\f040"; }

.ri-ruler-2-line:before {
  content: "\\f041"; }

.ri-ruler-fill:before {
  content: "\\f042"; }

.ri-ruler-line:before {
  content: "\\f043"; }

.ri-run-fill:before {
  content: "\\f044"; }

.ri-run-line:before {
  content: "\\f045"; }

.ri-safari-fill:before {
  content: "\\f046"; }

.ri-safari-line:before {
  content: "\\f047"; }

.ri-safe-2-fill:before {
  content: "\\f048"; }

.ri-safe-2-line:before {
  content: "\\f049"; }

.ri-safe-fill:before {
  content: "\\f04a"; }

.ri-safe-line:before {
  content: "\\f04b"; }

.ri-sailboat-fill:before {
  content: "\\f04c"; }

.ri-sailboat-line:before {
  content: "\\f04d"; }

.ri-save-2-fill:before {
  content: "\\f04e"; }

.ri-save-2-line:before {
  content: "\\f04f"; }

.ri-save-3-fill:before {
  content: "\\f050"; }

.ri-save-3-line:before {
  content: "\\f051"; }

.ri-save-fill:before {
  content: "\\f052"; }

.ri-save-line:before {
  content: "\\f053"; }

.ri-scales-2-fill:before {
  content: "\\f054"; }

.ri-scales-2-line:before {
  content: "\\f055"; }

.ri-scales-fill:before {
  content: "\\f056"; }

.ri-scales-line:before {
  content: "\\f057"; }

.ri-scan-2-fill:before {
  content: "\\f058"; }

.ri-scan-2-line:before {
  content: "\\f059"; }

.ri-scan-fill:before {
  content: "\\f05a"; }

.ri-scan-line:before {
  content: "\\f05b"; }

.ri-scissors-2-fill:before {
  content: "\\f05c"; }

.ri-scissors-2-line:before {
  content: "\\f05d"; }

.ri-scissors-cut-fill:before {
  content: "\\f05e"; }

.ri-scissors-cut-line:before {
  content: "\\f05f"; }

.ri-scissors-fill:before {
  content: "\\f060"; }

.ri-scissors-line:before {
  content: "\\f061"; }

.ri-screenshot-2-fill:before {
  content: "\\f062"; }

.ri-screenshot-2-line:before {
  content: "\\f063"; }

.ri-screenshot-fill:before {
  content: "\\f064"; }

.ri-screenshot-line:before {
  content: "\\f065"; }

.ri-sd-card-fill:before {
  content: "\\f066"; }

.ri-sd-card-line:before {
  content: "\\f067"; }

.ri-sd-card-mini-fill:before {
  content: "\\f068"; }

.ri-sd-card-mini-line:before {
  content: "\\f069"; }

.ri-search-2-fill:before {
  content: "\\f06a"; }

.ri-search-2-line:before {
  content: "\\f06b"; }

.ri-search-eye-fill:before {
  content: "\\f06c"; }

.ri-search-eye-line:before {
  content: "\\f06d"; }

.ri-search-fill:before {
  content: "\\f06e"; }

.ri-search-line:before {
  content: "\\f06f"; }

.ri-secure-payment-fill:before {
  content: "\\f070"; }

.ri-secure-payment-line:before {
  content: "\\f071"; }

.ri-send-backward:before {
  content: "\\f072"; }

.ri-send-plane-2-fill:before {
  content: "\\f073"; }

.ri-send-plane-2-line:before {
  content: "\\f074"; }

.ri-send-plane-fill:before {
  content: "\\f075"; }

.ri-send-plane-line:before {
  content: "\\f076"; }

.ri-send-to-back:before {
  content: "\\f077"; }

.ri-sensor-fill:before {
  content: "\\f078"; }

.ri-sensor-line:before {
  content: "\\f079"; }

.ri-separator:before {
  content: "\\f07a"; }

.ri-server-fill:before {
  content: "\\f07b"; }

.ri-server-line:before {
  content: "\\f07c"; }

.ri-service-fill:before {
  content: "\\f07d"; }

.ri-service-line:before {
  content: "\\f07e"; }

.ri-settings-2-fill:before {
  content: "\\f07f"; }

.ri-settings-2-line:before {
  content: "\\f080"; }

.ri-settings-3-fill:before {
  content: "\\f081"; }

.ri-settings-3-line:before {
  content: "\\f082"; }

.ri-settings-4-fill:before {
  content: "\\f083"; }

.ri-settings-4-line:before {
  content: "\\f084"; }

.ri-settings-5-fill:before {
  content: "\\f085"; }

.ri-settings-5-line:before {
  content: "\\f086"; }

.ri-settings-6-fill:before {
  content: "\\f087"; }

.ri-settings-6-line:before {
  content: "\\f088"; }

.ri-settings-fill:before {
  content: "\\f089"; }

.ri-settings-line:before {
  content: "\\f08a"; }

.ri-shape-2-fill:before {
  content: "\\f08b"; }

.ri-shape-2-line:before {
  content: "\\f08c"; }

.ri-shape-fill:before {
  content: "\\f08d"; }

.ri-shape-line:before {
  content: "\\f08e"; }

.ri-share-box-fill:before {
  content: "\\f08f"; }

.ri-share-box-line:before {
  content: "\\f090"; }

.ri-share-circle-fill:before {
  content: "\\f091"; }

.ri-share-circle-line:before {
  content: "\\f092"; }

.ri-share-fill:before {
  content: "\\f093"; }

.ri-share-forward-2-fill:before {
  content: "\\f094"; }

.ri-share-forward-2-line:before {
  content: "\\f095"; }

.ri-share-forward-box-fill:before {
  content: "\\f096"; }

.ri-share-forward-box-line:before {
  content: "\\f097"; }

.ri-share-forward-fill:before {
  content: "\\f098"; }

.ri-share-forward-line:before {
  content: "\\f099"; }

.ri-share-line:before {
  content: "\\f09a"; }

.ri-shield-cross-fill:before {
  content: "\\f09b"; }

.ri-shield-cross-line:before {
  content: "\\f09c"; }

.ri-shield-fill:before {
  content: "\\f09d"; }

.ri-shield-flash-fill:before {
  content: "\\f09e"; }

.ri-shield-flash-line:before {
  content: "\\f09f"; }

.ri-shield-keyhole-fill:before {
  content: "\\f0a0"; }

.ri-shield-keyhole-line:before {
  content: "\\f0a1"; }

.ri-shield-line:before {
  content: "\\f0a2"; }

.ri-shield-star-fill:before {
  content: "\\f0a3"; }

.ri-shield-star-line:before {
  content: "\\f0a4"; }

.ri-shield-user-fill:before {
  content: "\\f0a5"; }

.ri-shield-user-line:before {
  content: "\\f0a6"; }

.ri-ship-2-fill:before {
  content: "\\f0a7"; }

.ri-ship-2-line:before {
  content: "\\f0a8"; }

.ri-ship-fill:before {
  content: "\\f0a9"; }

.ri-ship-line:before {
  content: "\\f0aa"; }

.ri-shirt-fill:before {
  content: "\\f0ab"; }

.ri-shirt-line:before {
  content: "\\f0ac"; }

.ri-shopping-bag-2-fill:before {
  content: "\\f0ad"; }

.ri-shopping-bag-2-line:before {
  content: "\\f0ae"; }

.ri-shopping-bag-3-fill:before {
  content: "\\f0af"; }

.ri-shopping-bag-3-line:before {
  content: "\\f0b0"; }

.ri-shopping-bag-fill:before {
  content: "\\f0b1"; }

.ri-shopping-bag-line:before {
  content: "\\f0b2"; }

.ri-shopping-basket-2-fill:before {
  content: "\\f0b3"; }

.ri-shopping-basket-2-line:before {
  content: "\\f0b4"; }

.ri-shopping-basket-fill:before {
  content: "\\f0b5"; }

.ri-shopping-basket-line:before {
  content: "\\f0b6"; }

.ri-shopping-cart-2-fill:before {
  content: "\\f0b7"; }

.ri-shopping-cart-2-line:before {
  content: "\\f0b8"; }

.ri-shopping-cart-fill:before {
  content: "\\f0b9"; }

.ri-shopping-cart-line:before {
  content: "\\f0ba"; }

.ri-showers-fill:before {
  content: "\\f0bb"; }

.ri-showers-line:before {
  content: "\\f0bc"; }

.ri-shuffle-fill:before {
  content: "\\f0bd"; }

.ri-shuffle-line:before {
  content: "\\f0be"; }

.ri-shut-down-fill:before {
  content: "\\f0bf"; }

.ri-shut-down-line:before {
  content: "\\f0c0"; }

.ri-side-bar-fill:before {
  content: "\\f0c1"; }

.ri-side-bar-line:before {
  content: "\\f0c2"; }

.ri-signal-tower-fill:before {
  content: "\\f0c3"; }

.ri-signal-tower-line:before {
  content: "\\f0c4"; }

.ri-signal-wifi-1-fill:before {
  content: "\\f0c5"; }

.ri-signal-wifi-1-line:before {
  content: "\\f0c6"; }

.ri-signal-wifi-2-fill:before {
  content: "\\f0c7"; }

.ri-signal-wifi-2-line:before {
  content: "\\f0c8"; }

.ri-signal-wifi-3-fill:before {
  content: "\\f0c9"; }

.ri-signal-wifi-3-line:before {
  content: "\\f0ca"; }

.ri-signal-wifi-error-fill:before {
  content: "\\f0cb"; }

.ri-signal-wifi-error-line:before {
  content: "\\f0cc"; }

.ri-signal-wifi-fill:before {
  content: "\\f0cd"; }

.ri-signal-wifi-line:before {
  content: "\\f0ce"; }

.ri-signal-wifi-off-fill:before {
  content: "\\f0cf"; }

.ri-signal-wifi-off-line:before {
  content: "\\f0d0"; }

.ri-sim-card-2-fill:before {
  content: "\\f0d1"; }

.ri-sim-card-2-line:before {
  content: "\\f0d2"; }

.ri-sim-card-fill:before {
  content: "\\f0d3"; }

.ri-sim-card-line:before {
  content: "\\f0d4"; }

.ri-single-quotes-l:before {
  content: "\\f0d5"; }

.ri-single-quotes-r:before {
  content: "\\f0d6"; }

.ri-sip-fill:before {
  content: "\\f0d7"; }

.ri-sip-line:before {
  content: "\\f0d8"; }

.ri-skip-back-fill:before {
  content: "\\f0d9"; }

.ri-skip-back-line:before {
  content: "\\f0da"; }

.ri-skip-back-mini-fill:before {
  content: "\\f0db"; }

.ri-skip-back-mini-line:before {
  content: "\\f0dc"; }

.ri-skip-forward-fill:before {
  content: "\\f0dd"; }

.ri-skip-forward-line:before {
  content: "\\f0de"; }

.ri-skip-forward-mini-fill:before {
  content: "\\f0df"; }

.ri-skip-forward-mini-line:before {
  content: "\\f0e0"; }

.ri-skull-2-fill:before {
  content: "\\f0e1"; }

.ri-skull-2-line:before {
  content: "\\f0e2"; }

.ri-skull-fill:before {
  content: "\\f0e3"; }

.ri-skull-line:before {
  content: "\\f0e4"; }

.ri-skype-fill:before {
  content: "\\f0e5"; }

.ri-skype-line:before {
  content: "\\f0e6"; }

.ri-slack-fill:before {
  content: "\\f0e7"; }

.ri-slack-line:before {
  content: "\\f0e8"; }

.ri-slice-fill:before {
  content: "\\f0e9"; }

.ri-slice-line:before {
  content: "\\f0ea"; }

.ri-slideshow-2-fill:before {
  content: "\\f0eb"; }

.ri-slideshow-2-line:before {
  content: "\\f0ec"; }

.ri-slideshow-3-fill:before {
  content: "\\f0ed"; }

.ri-slideshow-3-line:before {
  content: "\\f0ee"; }

.ri-slideshow-4-fill:before {
  content: "\\f0ef"; }

.ri-slideshow-4-line:before {
  content: "\\f0f0"; }

.ri-slideshow-fill:before {
  content: "\\f0f1"; }

.ri-slideshow-line:before {
  content: "\\f0f2"; }

.ri-smartphone-fill:before {
  content: "\\f0f3"; }

.ri-smartphone-line:before {
  content: "\\f0f4"; }

.ri-snapchat-fill:before {
  content: "\\f0f5"; }

.ri-snapchat-line:before {
  content: "\\f0f6"; }

.ri-snowy-fill:before {
  content: "\\f0f7"; }

.ri-snowy-line:before {
  content: "\\f0f8"; }

.ri-sort-asc:before {
  content: "\\f0f9"; }

.ri-sort-desc:before {
  content: "\\f0fa"; }

.ri-sound-module-fill:before {
  content: "\\f0fb"; }

.ri-sound-module-line:before {
  content: "\\f0fc"; }

.ri-soundcloud-fill:before {
  content: "\\f0fd"; }

.ri-soundcloud-line:before {
  content: "\\f0fe"; }

.ri-space-ship-fill:before {
  content: "\\f0ff"; }

.ri-space-ship-line:before {
  content: "\\f100"; }

.ri-space:before {
  content: "\\f101"; }

.ri-spam-2-fill:before {
  content: "\\f102"; }

.ri-spam-2-line:before {
  content: "\\f103"; }

.ri-spam-3-fill:before {
  content: "\\f104"; }

.ri-spam-3-line:before {
  content: "\\f105"; }

.ri-spam-fill:before {
  content: "\\f106"; }

.ri-spam-line:before {
  content: "\\f107"; }

.ri-speaker-2-fill:before {
  content: "\\f108"; }

.ri-speaker-2-line:before {
  content: "\\f109"; }

.ri-speaker-3-fill:before {
  content: "\\f10a"; }

.ri-speaker-3-line:before {
  content: "\\f10b"; }

.ri-speaker-fill:before {
  content: "\\f10c"; }

.ri-speaker-line:before {
  content: "\\f10d"; }

.ri-spectrum-fill:before {
  content: "\\f10e"; }

.ri-spectrum-line:before {
  content: "\\f10f"; }

.ri-speed-fill:before {
  content: "\\f110"; }

.ri-speed-line:before {
  content: "\\f111"; }

.ri-speed-mini-fill:before {
  content: "\\f112"; }

.ri-speed-mini-line:before {
  content: "\\f113"; }

.ri-spotify-fill:before {
  content: "\\f114"; }

.ri-spotify-line:before {
  content: "\\f115"; }

.ri-spy-fill:before {
  content: "\\f116"; }

.ri-spy-line:before {
  content: "\\f117"; }

.ri-stack-fill:before {
  content: "\\f118"; }

.ri-stack-line:before {
  content: "\\f119"; }

.ri-stack-overflow-fill:before {
  content: "\\f11a"; }

.ri-stack-overflow-line:before {
  content: "\\f11b"; }

.ri-stackshare-fill:before {
  content: "\\f11c"; }

.ri-stackshare-line:before {
  content: "\\f11d"; }

.ri-star-fill:before {
  content: "\\f11e"; }

.ri-star-half-fill:before {
  content: "\\f11f"; }

.ri-star-half-line:before {
  content: "\\f120"; }

.ri-star-half-s-fill:before {
  content: "\\f121"; }

.ri-star-half-s-line:before {
  content: "\\f122"; }

.ri-star-line:before {
  content: "\\f123"; }

.ri-star-s-fill:before {
  content: "\\f124"; }

.ri-star-s-line:before {
  content: "\\f125"; }

.ri-star-smile-fill:before {
  content: "\\f126"; }

.ri-star-smile-line:before {
  content: "\\f127"; }

.ri-steam-fill:before {
  content: "\\f128"; }

.ri-steam-line:before {
  content: "\\f129"; }

.ri-steering-2-fill:before {
  content: "\\f12a"; }

.ri-steering-2-line:before {
  content: "\\f12b"; }

.ri-steering-fill:before {
  content: "\\f12c"; }

.ri-steering-line:before {
  content: "\\f12d"; }

.ri-sticky-note-2-fill:before {
  content: "\\f12e"; }

.ri-sticky-note-2-line:before {
  content: "\\f12f"; }

.ri-sticky-note-fill:before {
  content: "\\f130"; }

.ri-sticky-note-line:before {
  content: "\\f131"; }

.ri-stock-fill:before {
  content: "\\f132"; }

.ri-stock-line:before {
  content: "\\f133"; }

.ri-stop-circle-fill:before {
  content: "\\f134"; }

.ri-stop-circle-line:before {
  content: "\\f135"; }

.ri-stop-fill:before {
  content: "\\f136"; }

.ri-stop-line:before {
  content: "\\f137"; }

.ri-stop-mini-fill:before {
  content: "\\f138"; }

.ri-stop-mini-line:before {
  content: "\\f139"; }

.ri-store-2-fill:before {
  content: "\\f13a"; }

.ri-store-2-line:before {
  content: "\\f13b"; }

.ri-store-3-fill:before {
  content: "\\f13c"; }

.ri-store-3-line:before {
  content: "\\f13d"; }

.ri-store-fill:before {
  content: "\\f13e"; }

.ri-store-line:before {
  content: "\\f13f"; }

.ri-strikethrough-2:before {
  content: "\\f140"; }

.ri-strikethrough:before {
  content: "\\f141"; }

.ri-subscript-2:before {
  content: "\\f142"; }

.ri-subscript:before {
  content: "\\f143"; }

.ri-subtract-fill:before {
  content: "\\f144"; }

.ri-subtract-line:before {
  content: "\\f145"; }

.ri-subway-fill:before {
  content: "\\f146"; }

.ri-subway-line:before {
  content: "\\f147"; }

.ri-subway-wifi-fill:before {
  content: "\\f148"; }

.ri-subway-wifi-line:before {
  content: "\\f149"; }

.ri-suitcase-2-fill:before {
  content: "\\f14a"; }

.ri-suitcase-2-line:before {
  content: "\\f14b"; }

.ri-suitcase-3-fill:before {
  content: "\\f14c"; }

.ri-suitcase-3-line:before {
  content: "\\f14d"; }

.ri-suitcase-fill:before {
  content: "\\f14e"; }

.ri-suitcase-line:before {
  content: "\\f14f"; }

.ri-sun-cloudy-fill:before {
  content: "\\f150"; }

.ri-sun-cloudy-line:before {
  content: "\\f151"; }

.ri-sun-fill:before {
  content: "\\f152"; }

.ri-sun-foggy-fill:before {
  content: "\\f153"; }

.ri-sun-foggy-line:before {
  content: "\\f154"; }

.ri-sun-line:before {
  content: "\\f155"; }

.ri-superscript-2:before {
  content: "\\f156"; }

.ri-superscript:before {
  content: "\\f157"; }

.ri-surround-sound-fill:before {
  content: "\\f158"; }

.ri-surround-sound-line:before {
  content: "\\f159"; }

.ri-survey-fill:before {
  content: "\\f15a"; }

.ri-survey-line:before {
  content: "\\f15b"; }

.ri-swap-box-fill:before {
  content: "\\f15c"; }

.ri-swap-box-line:before {
  content: "\\f15d"; }

.ri-swap-fill:before {
  content: "\\f15e"; }

.ri-swap-line:before {
  content: "\\f15f"; }

.ri-switch-fill:before {
  content: "\\f160"; }

.ri-switch-line:before {
  content: "\\f161"; }

.ri-sword-fill:before {
  content: "\\f162"; }

.ri-sword-line:before {
  content: "\\f163"; }

.ri-t-box-fill:before {
  content: "\\f164"; }

.ri-t-box-line:before {
  content: "\\f165"; }

.ri-t-shirt-2-fill:before {
  content: "\\f166"; }

.ri-t-shirt-2-line:before {
  content: "\\f167"; }

.ri-t-shirt-air-fill:before {
  content: "\\f168"; }

.ri-t-shirt-air-line:before {
  content: "\\f169"; }

.ri-t-shirt-fill:before {
  content: "\\f16a"; }

.ri-t-shirt-line:before {
  content: "\\f16b"; }

.ri-table-2:before {
  content: "\\f16c"; }

.ri-table-alt-fill:before {
  content: "\\f16d"; }

.ri-table-alt-line:before {
  content: "\\f16e"; }

.ri-table-fill:before {
  content: "\\f16f"; }

.ri-table-line:before {
  content: "\\f170"; }

.ri-tablet-fill:before {
  content: "\\f171"; }

.ri-tablet-line:before {
  content: "\\f172"; }

.ri-takeaway-fill:before {
  content: "\\f173"; }

.ri-takeaway-line:before {
  content: "\\f174"; }

.ri-taobao-fill:before {
  content: "\\f175"; }

.ri-taobao-line:before {
  content: "\\f176"; }

.ri-tape-fill:before {
  content: "\\f177"; }

.ri-tape-line:before {
  content: "\\f178"; }

.ri-task-fill:before {
  content: "\\f179"; }

.ri-task-line:before {
  content: "\\f17a"; }

.ri-taxi-fill:before {
  content: "\\f17b"; }

.ri-taxi-line:before {
  content: "\\f17c"; }

.ri-taxi-wifi-fill:before {
  content: "\\f17d"; }

.ri-taxi-wifi-line:before {
  content: "\\f17e"; }

.ri-team-fill:before {
  content: "\\f17f"; }

.ri-team-line:before {
  content: "\\f180"; }

.ri-telegram-fill:before {
  content: "\\f181"; }

.ri-telegram-line:before {
  content: "\\f182"; }

.ri-temp-cold-fill:before {
  content: "\\f183"; }

.ri-temp-cold-line:before {
  content: "\\f184"; }

.ri-temp-hot-fill:before {
  content: "\\f185"; }

.ri-temp-hot-line:before {
  content: "\\f186"; }

.ri-terminal-box-fill:before {
  content: "\\f187"; }

.ri-terminal-box-line:before {
  content: "\\f188"; }

.ri-terminal-fill:before {
  content: "\\f189"; }

.ri-terminal-line:before {
  content: "\\f18a"; }

.ri-terminal-window-fill:before {
  content: "\\f18b"; }

.ri-terminal-window-line:before {
  content: "\\f18c"; }

.ri-text-direction-l:before {
  content: "\\f18d"; }

.ri-text-direction-r:before {
  content: "\\f18e"; }

.ri-text-spacing:before {
  content: "\\f18f"; }

.ri-text-wrap:before {
  content: "\\f190"; }

.ri-text:before {
  content: "\\f191"; }

.ri-thumb-down-fill:before {
  content: "\\f192"; }

.ri-thumb-down-line:before {
  content: "\\f193"; }

.ri-thumb-up-fill:before {
  content: "\\f194"; }

.ri-thumb-up-line:before {
  content: "\\f195"; }

.ri-thunderstorms-fill:before {
  content: "\\f196"; }

.ri-thunderstorms-line:before {
  content: "\\f197"; }

.ri-ticket-2-fill:before {
  content: "\\f198"; }

.ri-ticket-2-line:before {
  content: "\\f199"; }

.ri-ticket-fill:before {
  content: "\\f19a"; }

.ri-ticket-line:before {
  content: "\\f19b"; }

.ri-time-fill:before {
  content: "\\f19c"; }

.ri-time-line:before {
  content: "\\f19d"; }

.ri-timer-2-fill:before {
  content: "\\f19e"; }

.ri-timer-2-line:before {
  content: "\\f19f"; }

.ri-timer-fill:before {
  content: "\\f1a0"; }

.ri-timer-flash-fill:before {
  content: "\\f1a1"; }

.ri-timer-flash-line:before {
  content: "\\f1a2"; }

.ri-timer-line:before {
  content: "\\f1a3"; }

.ri-todo-fill:before {
  content: "\\f1a4"; }

.ri-todo-line:before {
  content: "\\f1a5"; }

.ri-toggle-fill:before {
  content: "\\f1a6"; }

.ri-toggle-line:before {
  content: "\\f1a7"; }

.ri-tools-fill:before {
  content: "\\f1a8"; }

.ri-tools-line:before {
  content: "\\f1a9"; }

.ri-tornado-fill:before {
  content: "\\f1aa"; }

.ri-tornado-line:before {
  content: "\\f1ab"; }

.ri-trademark-fill:before {
  content: "\\f1ac"; }

.ri-trademark-line:before {
  content: "\\f1ad"; }

.ri-traffic-light-fill:before {
  content: "\\f1ae"; }

.ri-traffic-light-line:before {
  content: "\\f1af"; }

.ri-train-fill:before {
  content: "\\f1b0"; }

.ri-train-line:before {
  content: "\\f1b1"; }

.ri-train-wifi-fill:before {
  content: "\\f1b2"; }

.ri-train-wifi-line:before {
  content: "\\f1b3"; }

.ri-translate-2:before {
  content: "\\f1b4"; }

.ri-translate:before {
  content: "\\f1b5"; }

.ri-travesti-fill:before {
  content: "\\f1b6"; }

.ri-travesti-line:before {
  content: "\\f1b7"; }

.ri-treasure-map-fill:before {
  content: "\\f1b8"; }

.ri-treasure-map-line:before {
  content: "\\f1b9"; }

.ri-trello-fill:before {
  content: "\\f1ba"; }

.ri-trello-line:before {
  content: "\\f1bb"; }

.ri-trophy-fill:before {
  content: "\\f1bc"; }

.ri-trophy-line:before {
  content: "\\f1bd"; }

.ri-truck-fill:before {
  content: "\\f1be"; }

.ri-truck-line:before {
  content: "\\f1bf"; }

.ri-tumblr-fill:before {
  content: "\\f1c0"; }

.ri-tumblr-line:before {
  content: "\\f1c1"; }

.ri-tv-2-fill:before {
  content: "\\f1c2"; }

.ri-tv-2-line:before {
  content: "\\f1c3"; }

.ri-tv-fill:before {
  content: "\\f1c4"; }

.ri-tv-line:before {
  content: "\\f1c5"; }

.ri-twitch-fill:before {
  content: "\\f1c6"; }

.ri-twitch-line:before {
  content: "\\f1c7"; }

.ri-twitter-fill:before {
  content: "\\f1c8"; }

.ri-twitter-line:before {
  content: "\\f1c9"; }

.ri-typhoon-fill:before {
  content: "\\f1ca"; }

.ri-typhoon-line:before {
  content: "\\f1cb"; }

.ri-u-disk-fill:before {
  content: "\\f1cc"; }

.ri-u-disk-line:before {
  content: "\\f1cd"; }

.ri-ubuntu-fill:before {
  content: "\\f1ce"; }

.ri-ubuntu-line:before {
  content: "\\f1cf"; }

.ri-umbrella-fill:before {
  content: "\\f1d0"; }

.ri-umbrella-line:before {
  content: "\\f1d1"; }

.ri-underline:before {
  content: "\\f1d2"; }

.ri-uninstall-fill:before {
  content: "\\f1d3"; }

.ri-uninstall-line:before {
  content: "\\f1d4"; }

.ri-unsplash-fill:before {
  content: "\\f1d5"; }

.ri-unsplash-line:before {
  content: "\\f1d6"; }

.ri-upload-2-fill:before {
  content: "\\f1d7"; }

.ri-upload-2-line:before {
  content: "\\f1d8"; }

.ri-upload-cloud-2-fill:before {
  content: "\\f1d9"; }

.ri-upload-cloud-2-line:before {
  content: "\\f1da"; }

.ri-upload-cloud-fill:before {
  content: "\\f1db"; }

.ri-upload-cloud-line:before {
  content: "\\f1dc"; }

.ri-upload-fill:before {
  content: "\\f1dd"; }

.ri-upload-line:before {
  content: "\\f1de"; }

.ri-user-2-fill:before {
  content: "\\f1df"; }

.ri-user-2-line:before {
  content: "\\f1e0"; }

.ri-user-3-fill:before {
  content: "\\f1e1"; }

.ri-user-3-line:before {
  content: "\\f1e2"; }

.ri-user-4-fill:before {
  content: "\\f1e3"; }

.ri-user-4-line:before {
  content: "\\f1e4"; }

.ri-user-5-fill:before {
  content: "\\f1e5"; }

.ri-user-5-line:before {
  content: "\\f1e6"; }

.ri-user-6-fill:before {
  content: "\\f1e7"; }

.ri-user-6-line:before {
  content: "\\f1e8"; }

.ri-user-add-fill:before {
  content: "\\f1e9"; }

.ri-user-add-line:before {
  content: "\\f1ea"; }

.ri-user-fill:before {
  content: "\\f1eb"; }

.ri-user-follow-fill:before {
  content: "\\f1ec"; }

.ri-user-follow-line:before {
  content: "\\f1ed"; }

.ri-user-heart-fill:before {
  content: "\\f1ee"; }

.ri-user-heart-line:before {
  content: "\\f1ef"; }

.ri-user-line:before {
  content: "\\f1f0"; }

.ri-user-location-fill:before {
  content: "\\f1f1"; }

.ri-user-location-line:before {
  content: "\\f1f2"; }

.ri-user-received-2-fill:before {
  content: "\\f1f3"; }

.ri-user-received-2-line:before {
  content: "\\f1f4"; }

.ri-user-received-fill:before {
  content: "\\f1f5"; }

.ri-user-received-line:before {
  content: "\\f1f6"; }

.ri-user-search-fill:before {
  content: "\\f1f7"; }

.ri-user-search-line:before {
  content: "\\f1f8"; }

.ri-user-settings-fill:before {
  content: "\\f1f9"; }

.ri-user-settings-line:before {
  content: "\\f1fa"; }

.ri-user-shared-2-fill:before {
  content: "\\f1fb"; }

.ri-user-shared-2-line:before {
  content: "\\f1fc"; }

.ri-user-shared-fill:before {
  content: "\\f1fd"; }

.ri-user-shared-line:before {
  content: "\\f1fe"; }

.ri-user-smile-fill:before {
  content: "\\f1ff"; }

.ri-user-smile-line:before {
  content: "\\f200"; }

.ri-user-star-fill:before {
  content: "\\f201"; }

.ri-user-star-line:before {
  content: "\\f202"; }

.ri-user-unfollow-fill:before {
  content: "\\f203"; }

.ri-user-unfollow-line:before {
  content: "\\f204"; }

.ri-user-voice-fill:before {
  content: "\\f205"; }

.ri-user-voice-line:before {
  content: "\\f206"; }

.ri-video-add-fill:before {
  content: "\\f207"; }

.ri-video-add-line:before {
  content: "\\f208"; }

.ri-video-chat-fill:before {
  content: "\\f209"; }

.ri-video-chat-line:before {
  content: "\\f20a"; }

.ri-video-download-fill:before {
  content: "\\f20b"; }

.ri-video-download-line:before {
  content: "\\f20c"; }

.ri-video-fill:before {
  content: "\\f20d"; }

.ri-video-line:before {
  content: "\\f20e"; }

.ri-video-upload-fill:before {
  content: "\\f20f"; }

.ri-video-upload-line:before {
  content: "\\f210"; }

.ri-vidicon-2-fill:before {
  content: "\\f211"; }

.ri-vidicon-2-line:before {
  content: "\\f212"; }

.ri-vidicon-fill:before {
  content: "\\f213"; }

.ri-vidicon-line:before {
  content: "\\f214"; }

.ri-vip-crown-2-fill:before {
  content: "\\f215"; }

.ri-vip-crown-2-line:before {
  content: "\\f216"; }

.ri-vip-crown-fill:before {
  content: "\\f217"; }

.ri-vip-crown-line:before {
  content: "\\f218"; }

.ri-vip-diamond-fill:before {
  content: "\\f219"; }

.ri-vip-diamond-line:before {
  content: "\\f21a"; }

.ri-vip-fill:before {
  content: "\\f21b"; }

.ri-vip-line:before {
  content: "\\f21c"; }

.ri-visa-fill:before {
  content: "\\f21d"; }

.ri-visa-line:before {
  content: "\\f21e"; }

.ri-voice-recognition-fill:before {
  content: "\\f21f"; }

.ri-voice-recognition-line:before {
  content: "\\f220"; }

.ri-voiceprint-fill:before {
  content: "\\f221"; }

.ri-voiceprint-line:before {
  content: "\\f222"; }

.ri-volume-down-fill:before {
  content: "\\f223"; }

.ri-volume-down-line:before {
  content: "\\f224"; }

.ri-volume-mute-fill:before {
  content: "\\f225"; }

.ri-volume-mute-line:before {
  content: "\\f226"; }

.ri-volume-off-vibrate-fill:before {
  content: "\\f227"; }

.ri-volume-off-vibrate-line:before {
  content: "\\f228"; }

.ri-volume-up-fill:before {
  content: "\\f229"; }

.ri-volume-up-line:before {
  content: "\\f22a"; }

.ri-volume-vibrate-fill:before {
  content: "\\f22b"; }

.ri-volume-vibrate-line:before {
  content: "\\f22c"; }

.ri-vuejs-fill:before {
  content: "\\f22d"; }

.ri-vuejs-line:before {
  content: "\\f22e"; }

.ri-walk-fill:before {
  content: "\\f22f"; }

.ri-walk-line:before {
  content: "\\f230"; }

.ri-wallet-2-fill:before {
  content: "\\f231"; }

.ri-wallet-2-line:before {
  content: "\\f232"; }

.ri-wallet-3-fill:before {
  content: "\\f233"; }

.ri-wallet-3-line:before {
  content: "\\f234"; }

.ri-wallet-fill:before {
  content: "\\f235"; }

.ri-wallet-line:before {
  content: "\\f236"; }

.ri-water-flash-fill:before {
  content: "\\f237"; }

.ri-water-flash-line:before {
  content: "\\f238"; }

.ri-webcam-fill:before {
  content: "\\f239"; }

.ri-webcam-line:before {
  content: "\\f23a"; }

.ri-wechat-2-fill:before {
  content: "\\f23b"; }

.ri-wechat-2-line:before {
  content: "\\f23c"; }

.ri-wechat-fill:before {
  content: "\\f23d"; }

.ri-wechat-line:before {
  content: "\\f23e"; }

.ri-wechat-pay-fill:before {
  content: "\\f23f"; }

.ri-wechat-pay-line:before {
  content: "\\f240"; }

.ri-weibo-fill:before {
  content: "\\f241"; }

.ri-weibo-line:before {
  content: "\\f242"; }

.ri-whatsapp-fill:before {
  content: "\\f243"; }

.ri-whatsapp-line:before {
  content: "\\f244"; }

.ri-wheelchair-fill:before {
  content: "\\f245"; }

.ri-wheelchair-line:before {
  content: "\\f246"; }

.ri-wifi-fill:before {
  content: "\\f247"; }

.ri-wifi-line:before {
  content: "\\f248"; }

.ri-wifi-off-fill:before {
  content: "\\f249"; }

.ri-wifi-off-line:before {
  content: "\\f24a"; }

.ri-window-2-fill:before {
  content: "\\f24b"; }

.ri-window-2-line:before {
  content: "\\f24c"; }

.ri-window-fill:before {
  content: "\\f24d"; }

.ri-window-line:before {
  content: "\\f24e"; }

.ri-windows-fill:before {
  content: "\\f24f"; }

.ri-windows-line:before {
  content: "\\f250"; }

.ri-windy-fill:before {
  content: "\\f251"; }

.ri-windy-line:before {
  content: "\\f252"; }

.ri-wireless-charging-fill:before {
  content: "\\f253"; }

.ri-wireless-charging-line:before {
  content: "\\f254"; }

.ri-women-fill:before {
  content: "\\f255"; }

.ri-women-line:before {
  content: "\\f256"; }

.ri-wubi-input:before {
  content: "\\f257"; }

.ri-xbox-fill:before {
  content: "\\f258"; }

.ri-xbox-line:before {
  content: "\\f259"; }

.ri-xing-fill:before {
  content: "\\f25a"; }

.ri-xing-line:before {
  content: "\\f25b"; }

.ri-youtube-fill:before {
  content: "\\f25c"; }

.ri-youtube-line:before {
  content: "\\f25d"; }

.ri-zcool-fill:before {
  content: "\\f25e"; }

.ri-zcool-line:before {
  content: "\\f25f"; }

.ri-zhihu-fill:before {
  content: "\\f260"; }

.ri-zhihu-line:before {
  content: "\\f261"; }

.ri-zoom-in-fill:before {
  content: "\\f262"; }

.ri-zoom-in-line:before {
  content: "\\f263"; }

.ri-zoom-out-fill:before {
  content: "\\f264"; }

.ri-zoom-out-line:before {
  content: "\\f265"; }

/*
Template Name: Upzet -  Admin & Dashboard Template
Author: Themesdesign
Version: 1.1.0
Contact: themesdesign.in@gmail.com
File: Custom Bootstrap Css File
*/
/*!
   * Bootstrap  v5.3.8 (https://getbootstrap.com/)
   * Copyright 2011-2025 The Bootstrap Authors
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
:root,
[data-bs-theme="light"] {
  --bs-blue: #244EA2;
  --bs-indigo: #564ab1;
  --bs-purple: #5664d2;
  --bs-pink: #e83e8c;
  --bs-red: #EC221F;
  --bs-orange: #f1734f;
  --bs-yellow: #fece22;
  --bs-green: #4bb543;
  --bs-teal: #050505;
  --bs-cyan: #4aa3ff;
  --bs-white: #fff;
  --bs-gray: #74788d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #eff2f7;
  --bs-gray-300: #f1f5f7;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #74788d;
  --bs-gray-700: #505d69;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #244EA2;
  --bs-primary-dark: #263874;
  --bs-gray-secundary: #6C6C6C;
  --bs-secondary: #74788d;
  --bs-success: #4bb543;
  --bs-info: #F0F0F0;
  --bs-warning: #fece22;
  --bs-danger: #EC221F;
  --bs-pink: #e83e8c;
  --bs-light: #eff2f7;
  --bs-dark: #343a40;
  --bs-dark-gray-primary: #353535;
  --bs-light-gray-05: #D9D9D9;
  --bs-light-gray-03: #E2E2E2;
  --bs-light_gray_04: #E6E6E6;
  --bs-light-gray-06: #CDCDCD;
  --bs-light_blue_04: #0075A2;
  --bs-light-blue-01: #498EF2;
  --bs-light-blue-11: #596CA3;
  --bs-light-blue-06: #1FA3CC;
  --bs-light-blue-08: #D6D9E2;
  --bs-light-blue-13: #e5e7ee;
  --bs-light-blue-14: #98A1BB;
  --bs-color-azul1: #0F1D42;
  --bs-color-azul2: #263874;
  --bs-color-azul2-hover: #364B8C;
  --bs-color-azul3: #244EA2;
  --bs-color-azul4: #498EF2;
  --bs-color-azul5: #82C0F9;
  --bs-color-azul6: #005366;
  --bs-color-azul7: #0075A2;
  --bs-color-azul8: #1FA3CC;
  --bs-color-azul9: #7DC3DC;
  --bs-color-azul10: #9DE6E6;
  --bs-color-azul11: #D6D9E2;
  --bs-color-azul410: #C1E0FF;
  --bs-color-azul130: #6A799C;
  --bs-color-azul405: #E5F3FF;
  --bs-color-branco2: #F5F5F5;
  --bs-color-branco3: #F0F0F0;
  --bs-color-cinza1: #E2E2E2;
  --bs-color-cinza2: #D9D9D9;
  --bs-color-cinza2-5: #CDCDCD;
  --bs-color-cinza3: #A8A8A8;
  --bs-color-cinza4: #6C6C6C;
  --bs-color-cinza5: #353535;
  --bs-color-cinza6: #B4B4B412;
  --bs-color-vermelho1: #ec221f;
  --bs-color-vermelho2: #BA0501;
  --bs-color-vermelho3: #ec221f25;
  --bs-color-verde1: #4bb543;
  --bs-color-verde2: #0a7702;
  --bs-color-verde3: #4bb54325;
  --bs-color-amarelo1: #fece22;
  --bs-color-amarelo2: #7f6d31;
  --bs-color-amarelo3: #fece2225;
  --bs-color-laranja1: #ff6241;
  --bs-primary-rgb: 36, 78, 162;
  --bs-primary-dark-rgb: 38, 56, 116;
  --bs-gray-secundary-rgb: 108, 108, 108;
  --bs-secondary-rgb: 116, 120, 141;
  --bs-success-rgb: 75, 181, 67;
  --bs-info-rgb: 240, 240, 240;
  --bs-warning-rgb: 254, 206, 34;
  --bs-danger-rgb: 236, 34, 31;
  --bs-pink-rgb: 232, 62, 140;
  --bs-light-rgb: 239, 242, 247;
  --bs-dark-rgb: 52, 58, 64;
  --bs-dark-gray-primary-rgb: 53, 53, 53;
  --bs-light-gray-05-rgb: 217, 217, 217;
  --bs-light-gray-03-rgb: 226, 226, 226;
  --bs-light_gray_04-rgb: 230, 230, 230;
  --bs-light-gray-06-rgb: 205, 205, 205;
  --bs-light_blue_04-rgb: 0, 117, 162;
  --bs-light-blue-01-rgb: 73, 142, 242;
  --bs-light-blue-11-rgb: 89, 108, 163;
  --bs-light-blue-06-rgb: 31, 163, 204;
  --bs-light-blue-08-rgb: 214, 217, 226;
  --bs-light-blue-13-rgb: 229, 231, 238;
  --bs-light-blue-14-rgb: 152, 161, 187;
  --bs-color-azul1-rgb: 15, 29, 66;
  --bs-color-azul2-rgb: 38, 56, 116;
  --bs-color-azul2-hover-rgb: 54, 75, 140;
  --bs-color-azul3-rgb: 36, 78, 162;
  --bs-color-azul4-rgb: 73, 142, 242;
  --bs-color-azul5-rgb: 130, 192, 249;
  --bs-color-azul6-rgb: 0, 83, 102;
  --bs-color-azul7-rgb: 0, 117, 162;
  --bs-color-azul8-rgb: 31, 163, 204;
  --bs-color-azul9-rgb: 125, 195, 220;
  --bs-color-azul10-rgb: 157, 230, 230;
  --bs-color-azul11-rgb: 214, 217, 226;
  --bs-color-azul410-rgb: 193, 224, 255;
  --bs-color-azul130-rgb: 106, 121, 156;
  --bs-color-azul405-rgb: 229, 243, 255;
  --bs-color-branco2-rgb: 245, 245, 245;
  --bs-color-branco3-rgb: 240, 240, 240;
  --bs-color-cinza1-rgb: 226, 226, 226;
  --bs-color-cinza2-rgb: 217, 217, 217;
  --bs-color-cinza2-5-rgb: 205, 205, 205;
  --bs-color-cinza3-rgb: 168, 168, 168;
  --bs-color-cinza4-rgb: 108, 108, 108;
  --bs-color-cinza5-rgb: 53, 53, 53;
  --bs-color-cinza6-rgb: 180, 180, 180;
  --bs-color-vermelho1-rgb: 236, 34, 31;
  --bs-color-vermelho2-rgb: 186, 5, 1;
  --bs-color-vermelho3-rgb: 236, 34, 31;
  --bs-color-verde1-rgb: 75, 181, 67;
  --bs-color-verde2-rgb: 10, 119, 2;
  --bs-color-verde3-rgb: 75, 181, 67;
  --bs-color-amarelo1-rgb: 254, 206, 34;
  --bs-color-amarelo2-rgb: 127, 109, 49;
  --bs-color-amarelo3-rgb: 254, 206, 34;
  --bs-color-laranja1-rgb: 255, 98, 65;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Poppins", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #505d69;
  --bs-body-color-rgb: 80, 93, 105;
  --bs-body-bg: #f3f3f4;
  --bs-body-bg-rgb: 243, 243, 244;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #244EA2;
  --bs-link-color-rgb: 36, 78, 162;
  --bs-link-decoration: none;
  --bs-link-hover-color: #163063;
  --bs-link-hover-color-rgb: 22.09091, 47.86364, 99.40909;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #e83e8c;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #eff2f7;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.4rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  --bs-box-shadow-sm: 0 1px 1px rgba(0, 0, 0, 0.05);
  --bs-box-shadow-lg: 0 5px 12px rgba(0, 0, 0, 0.1);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545; }

[data-bs-theme="dark"] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f; }

*,
*::before,
*::after {
  box-sizing: border-box; }

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth; } }

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

hr {
  margin: 1rem 0;
  color: rgba(0, 0, 0, 0.1);
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.7; }

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color); }

h1, .h1 {
  font-size: calc(1.34375rem + 1.125vw); }
  @media (min-width: 1200px) {
    h1, .h1 {
      font-size: 2.1875rem; } }

h2, .h2 {
  font-size: calc(1.3rem + 0.6vw); }
  @media (min-width: 1200px) {
    h2, .h2 {
      font-size: 1.75rem; } }

h3, .h3 {
  font-size: calc(1.27813rem + 0.3375vw); }
  @media (min-width: 1200px) {
    h3, .h3 {
      font-size: 1.53125rem; } }

h4, .h4 {
  font-size: calc(1.25625rem + 0.075vw); }
  @media (min-width: 1200px) {
    h4, .h4 {
      font-size: 1.3125rem; } }

h5, .h5 {
  font-size: 1.09375rem; }

h6, .h6 {
  font-size: 0.875rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul {
  padding-left: 2rem; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 600; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small, .small {
  font-size: 80%; }

mark, .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg); }

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none; }
  a:hover {
    --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
    text-decoration: underline; }

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em; }

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
  color: #212529; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

code {
  font-size: 87.5%;
  color: var(--bs-code-color);
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 1em;
    font-weight: 600; }

figure {
  margin: 0 0 1rem; }

img,
svg {
  vertical-align: middle; }

table {
  caption-side: bottom;
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #74788d;
  text-align: left; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0; }

label {
  display: inline-block; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }
  select:disabled {
    opacity: 1; }

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }
  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer; }

::-moz-focus-inner {
  padding: 0;
  border-style: none; }

textarea {
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw); }
  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem; } }
  legend + * {
    clear: left; }

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0; }

::-webkit-inner-spin-button {
  height: auto; }

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px; }
  [type="search"]::-webkit-search-cancel-button {
    cursor: pointer;
    filter: grayscale(1); }

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-color-swatch-wrapper {
  padding: 0; }

::file-selector-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

iframe {
  border: 0; }

summary {
  display: list-item;
  cursor: pointer; }

progress {
  vertical-align: baseline; }

[hidden] {
  display: none !important; }

.lead {
  font-size: 1.09375rem;
  font-weight: 300; }

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.725rem + 5.7vw); }
  @media (min-width: 1200px) {
    .display-1 {
      font-size: 6rem; } }

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.675rem + 5.1vw); }
  @media (min-width: 1200px) {
    .display-2 {
      font-size: 5.5rem; } }

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw); }
  @media (min-width: 1200px) {
    .display-3 {
      font-size: 4.5rem; } }

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw); }
  @media (min-width: 1200px) {
    .display-4 {
      font-size: 3.5rem; } }

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw); }
  @media (min-width: 1200px) {
    .display-5 {
      font-size: 3rem; } }

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw); }
  @media (min-width: 1200px) {
    .display-6 {
      font-size: 2.5rem; } }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 80%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem; }
  .blockquote > :last-child {
    margin-bottom: 0; }

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 80%;
  color: #74788d; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f3f3f4;
  border: 1px solid #f1f5f7;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 80%;
  color: #74788d; }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px; }

.row {
  --bs-gutter-x: 48px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x)); }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) * .5);
    padding-left: calc(var(--bs-gutter-x) * .5);
    margin-top: var(--bs-gutter-y); }

.col {
  flex: 1 0; }

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto; }

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%; }

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%; }

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%; }

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%; }

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto; }

.col-1 {
  flex: 0 0 auto;
  width: 8.33333%; }

.col-2 {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-3 {
  flex: 0 0 auto;
  width: 25%; }

.col-4 {
  flex: 0 0 auto;
  width: 33.33333%; }

.col-5 {
  flex: 0 0 auto;
  width: 41.66667%; }

.col-6 {
  flex: 0 0 auto;
  width: 50%; }

.col-7 {
  flex: 0 0 auto;
  width: 58.33333%; }

.col-8 {
  flex: 0 0 auto;
  width: 66.66667%; }

.col-9 {
  flex: 0 0 auto;
  width: 75%; }

.col-10 {
  flex: 0 0 auto;
  width: 83.33333%; }

.col-11 {
  flex: 0 0 auto;
  width: 91.66667%; }

.col-12 {
  flex: 0 0 auto;
  width: 100%; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

.g-0,
.gx-0 {
  --bs-gutter-x: 0; }

.g-0,
.gy-0 {
  --bs-gutter-y: 0; }

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem; }

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem; }

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem; }

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem; }

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem; }

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem; }

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem; }

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem; }

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem; }

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem; }

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0; }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0; }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0; }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem; }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem; }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem; }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem; }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem; }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem; }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem; }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem; }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem; }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 768px) {
  .col-md {
    flex: 1 0; }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0; }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0; }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem; }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem; }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem; }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem; }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem; }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem; }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem; }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem; }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem; }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0; }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0; }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0; }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem; }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem; }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem; }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem; }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem; }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem; }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem; }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem; }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem; }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0; }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0; }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0; }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem; }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem; }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem; }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0; }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xxl-0 {
    margin-left: 0; }
  .offset-xxl-1 {
    margin-left: 8.33333%; }
  .offset-xxl-2 {
    margin-left: 16.66667%; }
  .offset-xxl-3 {
    margin-left: 25%; }
  .offset-xxl-4 {
    margin-left: 33.33333%; }
  .offset-xxl-5 {
    margin-left: 41.66667%; }
  .offset-xxl-6 {
    margin-left: 50%; }
  .offset-xxl-7 {
    margin-left: 58.33333%; }
  .offset-xxl-8 {
    margin-left: 66.66667%; }
  .offset-xxl-9 {
    margin-left: 75%; }
  .offset-xxl-10 {
    margin-left: 83.33333%; }
  .offset-xxl-11 {
    margin-left: 91.66667%; }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0; }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0; }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem; }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem; }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem; }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem; } }

.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: #505d69;
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: #eff2f7;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #505d69;
  --bs-table-striped-bg: #f8f9fa;
  --bs-table-active-color: #505d69;
  --bs-table-active-bg: #f8f9fa;
  --bs-table-hover-color: #505d69;
  --bs-table-hover-bg: #f8f9fa;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color); }
  .table > :not(caption) > * > * {
    padding: 0.75rem 0.75rem;
    color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
    background-color: var(--bs-table-bg);
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg))); }
  .table > tbody {
    vertical-align: inherit; }
  .table > thead {
    vertical-align: bottom; }

.table-group-divider {
  border-top: calc(1px * 2) solid #eff2f7; }

.caption-top {
  caption-side: top; }

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.3rem; }

.table-bordered > :not(caption) > * {
  border-width: 1px 0; }
  .table-bordered > :not(caption) > * > * {
    border-width: 0 1px; }

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0; }

.table-borderless > :not(:first-child) {
  border-top-width: 0; }

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg); }

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg); }

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg); }

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg); }

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #d3dcec;
  --bs-table-border-color: #bec6d4;
  --bs-table-striped-bg: #c8d1e0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bec6d4;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #c3ccda;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e3e4e8;
  --bs-table-border-color: #cccdd1;
  --bs-table-striped-bg: #d8d9dc;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cccdd1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d2d3d7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #dbf0d9;
  --bs-table-border-color: #c5d8c3;
  --bs-table-striped-bg: #d0e4ce;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c5d8c3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #cbdec9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #fcfcfc;
  --bs-table-border-color: #e3e3e3;
  --bs-table-striped-bg: #efefef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e3e3e3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e9e9e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff5d3;
  --bs-table-border-color: #e6ddbe;
  --bs-table-striped-bg: #f2e9c8;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6ddbe;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece3c3;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #fbd3d2;
  --bs-table-border-color: #e2bebd;
  --bs-table-striped-bg: #eec8c8;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e2bebd;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #e8c3c2;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #dfe0e1;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: #484e53;
  --bs-table-striped-bg: #3e444a;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #484e53;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #43494e;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

.form-label {
  margin-bottom: 0.5rem; }

.col-form-label {
  padding-top: calc(0.47rem + 1px);
  padding-bottom: calc(0.47rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.125rem; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem; }

.form-text {
  margin-top: 0.25rem;
  font-size: 80%;
  color: #74788d; }

.form-control {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #505d69;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control[type="file"] {
    overflow: hidden; }
    .form-control[type="file"]:not(:disabled):not([readonly]) {
      cursor: pointer; }
  .form-control:focus {
    color: #505d69;
    background-color: #fff;
    border-color: #b1bbc4;
    outline: 0;
    box-shadow: none; }
  .form-control::-webkit-date-and-time-value {
    min-width: 85px;
    height: 1.5em;
    margin: 0; }
  .form-control::-webkit-datetime-edit {
    display: block;
    padding: 0; }
  .form-control::placeholder {
    color: #74788d;
    opacity: 1; }
  .form-control:disabled {
    background-color: #eff2f7;
    opacity: 1; }
  .form-control::file-selector-button {
    padding: 0.47rem 0.75rem;
    margin: -0.47rem -0.75rem;
    margin-inline-end: 0.75rem;
    color: #505d69;
    background-color: #eff2f7;
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 1px;
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-control::file-selector-button {
        transition: none; } }
  .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: #e3e6eb; }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.47rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #505d69;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext:focus {
    outline: 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.2rem; }
  .form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: 0.5rem; }

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  border-radius: 0.4rem; }
  .form-control-lg::file-selector-button {
    padding: 0.5rem 1rem;
    margin: -0.5rem -1rem;
    margin-inline-end: 1rem; }

textarea.form-control {
  min-height: 40px; }

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px); }

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px); }

.form-control-color {
  width: 3rem;
  height: 40px;
  padding: 0.47rem; }
  .form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer; }
  .form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: 0.25rem; }
  .form-control-color::-webkit-color-swatch {
    border: 0 !important;
    border-radius: 0.25rem; }
  .form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + 2px); }
  .form-control-color.form-control-lg {
    height: calc(1.5em + 1rem + 2px); }

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  display: block;
  width: 100%;
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #505d69;
  appearance: none;
  background-color: #fff;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-select {
      transition: none; } }
  .form-select:focus {
    border-color: #b1bbc4;
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgba(36, 78, 162, 0.25); }
  .form-select[multiple], .form-select[size]:not([size="1"]) {
    padding-right: 0.75rem;
    background-image: none; }
  .form-select:disabled {
    color: #74788d;
    background-color: #eff2f7; }
  .form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #505d69; }

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.2rem; }

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.125rem;
  border-radius: 0.4rem; }

[data-bs-theme="dark"] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_17___}); }

.form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem; }
  .form-check .form-check-input {
    float: left;
    margin-left: -1.5em; }

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right; }
  .form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.5em;
    margin-left: 0; }

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-check-input {
      transition: none; } }
  .form-check-input[type="checkbox"] {
    border-radius: 0.25em; }
  .form-check-input[type="radio"] {
    border-radius: 50%; }
  .form-check-input:active {
    filter: brightness(90%); }
  .form-check-input:focus {
    border-color: #b1bbc4;
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgba(36, 78, 162, 0.25); }
  .form-check-input:checked {
    background-color: #244EA2;
    border-color: #244EA2; }
    .form-check-input:checked[type="checkbox"] {
      --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); }
    .form-check-input:checked[type="radio"] {
      --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}); }
  .form-check-input[type="checkbox"]:indeterminate {
    background-color: #244EA2;
    border-color: #244EA2;
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}); }
  .form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5; }
  .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
    cursor: default;
    opacity: 0.5; }

.form-switch {
  padding-left: 2.5em; }
  .form-switch .form-check-input {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    width: 2em;
    margin-left: -2.5em;
    background-image: var(--bs-form-switch-bg);
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch .form-check-input {
        transition: none; } }
    .form-switch .form-check-input:focus {
      --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_22___}); }
    .form-switch .form-check-input:checked {
      background-position: right center;
      --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_23___}); }
  .form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0; }
    .form-switch.form-check-reverse .form-check-input {
      margin-right: -2.5em;
      margin-left: 0; }

.form-check-inline {
  display: inline-block;
  margin-right: 1rem; }

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none; }
  .btn-check[disabled] + .btn, .btn-check:disabled + .btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65; }

[data-bs-theme="dark"] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); }

.form-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  appearance: none;
  background-color: transparent; }
  .form-range:focus {
    outline: 0; }
    .form-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #f3f3f4, none; }
    .form-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #f3f3f4, none; }
  .form-range::-moz-focus-outer {
    border: 0; }
  .form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    appearance: none;
    background-color: #244EA2;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .form-range::-webkit-slider-thumb:active {
      background-color: #bdcae3; }
  .form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #f1f5f7;
    border-color: transparent;
    border-radius: 1rem; }
  .form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    appearance: none;
    background-color: #244EA2;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .form-range::-moz-range-thumb:active {
      background-color: #bdcae3; }
  .form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #f1f5f7;
    border-color: transparent;
    border-radius: 1rem; }
  .form-range:disabled {
    pointer-events: none; }
    .form-range:disabled::-webkit-slider-thumb {
      background-color: #adb5bd; }
    .form-range:disabled::-moz-range-thumb {
      background-color: #adb5bd; }

.form-floating {
  position: relative; }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: calc(3.5rem + 2px);
    min-height: calc(3.5rem + 2px);
    line-height: 1.25; }
  .form-floating > label {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    max-width: 100%;
    height: 100%;
    padding: 1rem 0.75rem;
    overflow: hidden;
    color: rgba(var(--bs-body-color-rgb), 0.65);
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-floating > label {
        transition: none; } }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext {
    padding: 1rem 0.75rem; }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
      color: transparent; }
    .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
  .form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem;
    padding-left: 0.75rem; }
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label,
  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-select ~ label {
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control:-webkit-autofill ~ label {
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > textarea:focus ~ label::after,
  .form-floating > textarea:not(:placeholder-shown) ~ label::after {
    position: absolute;
    inset: 1rem 0.375rem;
    z-index: -1;
    height: 1.5em;
    content: "";
    background-color: #fff;
    border-radius: 0.25rem; }
  .form-floating > textarea:disabled ~ label::after {
    background-color: #eff2f7; }
  .form-floating > .form-control-plaintext ~ label {
    border-width: 1px 0; }
  .form-floating > :disabled ~ label,
  .form-floating > .form-control:disabled ~ label {
    color: #6c757d; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-select,
  .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0; }
  .input-group > .form-control:focus,
  .input-group > .form-select:focus,
  .input-group > .form-floating:focus-within {
    z-index: 5; }
  .input-group .btn {
    position: relative;
    z-index: 2; }
    .input-group .btn:focus {
      z-index: 5; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.47rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #505d69;
  text-align: center;
  white-space: nowrap;
  background-color: #eff2f7;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  border-radius: 0.4rem; }

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.2rem; }

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.5rem; }

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * 1px);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #4bb543; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(75, 181, 67, 0.9);
  border-radius: 0.25rem; }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #4bb543;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #4bb543;
    box-shadow: 0 0 0 0.15rem rgba(75, 181, 67, 0.25); }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem); }

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #4bb543; }
  .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
    padding-right: calc(0.75em + 3.205rem);
    background-position: right 0.75rem center, center right 2.5rem;
    background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-select:valid:focus, .form-select.is-valid:focus {
    border-color: #4bb543;
    box-shadow: 0 0 0 0.15rem rgba(75, 181, 67, 0.25); }

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.94rem)); }

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #4bb543; }
  .was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
    background-color: #4bb543; }
  .was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0.15rem rgba(75, 181, 67, 0.25); }
  .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: #4bb543; }

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid, .was-validated
.input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid, .was-validated
.input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3; }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #EC221F; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(236, 34, 31, 0.9);
  border-radius: 0.25rem; }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #EC221F;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #EC221F;
    box-shadow: 0 0 0 0.15rem rgba(236, 34, 31, 0.25); }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem); }

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #EC221F; }
  .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
    padding-right: calc(0.75em + 3.205rem);
    background-position: right 0.75rem center, center right 2.5rem;
    background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem); }
  .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
    border-color: #EC221F;
    box-shadow: 0 0 0 0.15rem rgba(236, 34, 31, 0.25); }

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.94rem)); }

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #EC221F; }
  .was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
    background-color: #EC221F; }
  .was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0.15rem rgba(236, 34, 31, 0.25); }
  .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: #EC221F; }

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid, .was-validated
.input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid, .was-validated
.input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4; }

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.47rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.25rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.15rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: var(--bs-btn-hover-color);
    text-decoration: none;
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color); }
  .btn-check + .btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: var(--bs-btn-border-color); }
  .btn:focus-visible {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:focus-visible + .btn {
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:checked + .btn,
  :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
    color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);
    border-color: var(--bs-btn-active-border-color); }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
      box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:checked:focus-visible + .btn {
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn:disabled, .btn.disabled,
  fieldset:disabled .btn {
    color: var(--bs-btn-disabled-color);
    pointer-events: none;
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
    opacity: var(--bs-btn-disabled-opacity); }

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #244EA2;
  --bs-btn-border-color: #244EA2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1f428a;
  --bs-btn-hover-border-color: #1d3e82;
  --bs-btn-focus-shadow-rgb: 69, 105, 176;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1d3e82;
  --bs-btn-active-border-color: #1b3b7a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #244EA2;
  --bs-btn-disabled-border-color: #244EA2; }

.btn-primary-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #263874;
  --bs-btn-border-color: #263874;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #203063;
  --bs-btn-hover-border-color: #1e2d5d;
  --bs-btn-focus-shadow-rgb: 71, 86, 137;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1e2d5d;
  --bs-btn-active-border-color: #1d2a57;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #263874;
  --bs-btn-disabled-border-color: #263874; }

.btn-gray-secundary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6C6C6C;
  --bs-btn-border-color: #6C6C6C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c5c5c;
  --bs-btn-hover-border-color: #565656;
  --bs-btn-focus-shadow-rgb: 130, 130, 130;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565656;
  --bs-btn-active-border-color: #515151;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6C6C6C;
  --bs-btn-disabled-border-color: #6C6C6C; }

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #636678;
  --bs-btn-hover-border-color: #5d6071;
  --bs-btn-focus-shadow-rgb: 137, 140, 158;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5d6071;
  --bs-btn-active-border-color: #575a6a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #74788d;
  --bs-btn-disabled-border-color: #74788d; }

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4bb543;
  --bs-btn-border-color: #4bb543;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #409a39;
  --bs-btn-hover-border-color: #3c9136;
  --bs-btn-focus-shadow-rgb: 102, 192, 95;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3c9136;
  --bs-btn-active-border-color: #388832;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4bb543;
  --bs-btn-disabled-border-color: #4bb543; }

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #F0F0F0;
  --bs-btn-border-color: #F0F0F0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f2f2f2;
  --bs-btn-hover-border-color: #f2f2f2;
  --bs-btn-focus-shadow-rgb: 204, 204, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f3f3f3;
  --bs-btn-active-border-color: #f2f2f2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #F0F0F0;
  --bs-btn-disabled-border-color: #F0F0F0; }

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #fece22;
  --bs-btn-border-color: #fece22;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fed543;
  --bs-btn-hover-border-color: #fed338;
  --bs-btn-focus-shadow-rgb: 216, 175, 29;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fed84e;
  --bs-btn-active-border-color: #fed338;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #fece22;
  --bs-btn-disabled-border-color: #fece22; }

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #EC221F;
  --bs-btn-border-color: #EC221F;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #c91d1a;
  --bs-btn-hover-border-color: #bd1b19;
  --bs-btn-focus-shadow-rgb: 239, 67, 65;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #bd1b19;
  --bs-btn-active-border-color: #b11a17;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #EC221F;
  --bs-btn-disabled-border-color: #EC221F; }

.btn-pink {
  --bs-btn-color: #fff;
  --bs-btn-bg: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #c53577;
  --bs-btn-hover-border-color: #ba3270;
  --bs-btn-focus-shadow-rgb: 235, 91, 157;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ba3270;
  --bs-btn-active-border-color: #ae2f69;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #e83e8c;
  --bs-btn-disabled-border-color: #e83e8c; }

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eff2f7;
  --bs-btn-border-color: #eff2f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #cbced2;
  --bs-btn-hover-border-color: #bfc2c6;
  --bs-btn-focus-shadow-rgb: 203, 206, 210;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #bfc2c6;
  --bs-btn-active-border-color: #b3b6b9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eff2f7;
  --bs-btn-disabled-border-color: #eff2f7; }

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #52585d;
  --bs-btn-hover-border-color: #484e53;
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5d6166;
  --bs-btn-active-border-color: #484e53;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40; }

.btn-dark-gray-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #353535;
  --bs-btn-border-color: #353535;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2d2d2d;
  --bs-btn-hover-border-color: #2a2a2a;
  --bs-btn-focus-shadow-rgb: 83, 83, 83;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2a2a2a;
  --bs-btn-active-border-color: #282828;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #353535;
  --bs-btn-disabled-border-color: #353535; }

.btn-light-gray-05 {
  --bs-btn-color: #000;
  --bs-btn-bg: #D9D9D9;
  --bs-btn-border-color: #D9D9D9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #dfdfdf;
  --bs-btn-hover-border-color: #dddddd;
  --bs-btn-focus-shadow-rgb: 184, 184, 184;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e1e1e1;
  --bs-btn-active-border-color: #dddddd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #D9D9D9;
  --bs-btn-disabled-border-color: #D9D9D9; }

.btn-light-gray-03 {
  --bs-btn-color: #000;
  --bs-btn-bg: #E2E2E2;
  --bs-btn-border-color: #E2E2E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e6e6e6;
  --bs-btn-hover-border-color: #e5e5e5;
  --bs-btn-focus-shadow-rgb: 192, 192, 192;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e8e8e8;
  --bs-btn-active-border-color: #e5e5e5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #E2E2E2;
  --bs-btn-disabled-border-color: #E2E2E2; }

.btn-light_gray_04 {
  --bs-btn-color: #000;
  --bs-btn-bg: #E6E6E6;
  --bs-btn-border-color: #E6E6E6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eaeaea;
  --bs-btn-hover-border-color: #e9e9e9;
  --bs-btn-focus-shadow-rgb: 196, 196, 196;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ebebeb;
  --bs-btn-active-border-color: #e9e9e9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #E6E6E6;
  --bs-btn-disabled-border-color: #E6E6E6; }

.btn-light-gray-06 {
  --bs-btn-color: #000;
  --bs-btn-bg: #CDCDCD;
  --bs-btn-border-color: #CDCDCD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d5d5d5;
  --bs-btn-hover-border-color: #d2d2d2;
  --bs-btn-focus-shadow-rgb: 174, 174, 174;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d7d7d7;
  --bs-btn-active-border-color: #d2d2d2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #CDCDCD;
  --bs-btn-disabled-border-color: #CDCDCD; }

.btn-light_blue_04 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0075A2;
  --bs-btn-border-color: #0075A2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #00638a;
  --bs-btn-hover-border-color: #005e82;
  --bs-btn-focus-shadow-rgb: 38, 138, 176;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #005e82;
  --bs-btn-active-border-color: #00587a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0075A2;
  --bs-btn-disabled-border-color: #0075A2; }

.btn-light-blue-01 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #498EF2;
  --bs-btn-border-color: #498EF2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3e79ce;
  --bs-btn-hover-border-color: #3a72c2;
  --bs-btn-focus-shadow-rgb: 100, 159, 244;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3a72c2;
  --bs-btn-active-border-color: #376bb6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #498EF2;
  --bs-btn-disabled-border-color: #498EF2; }

.btn-light-blue-11 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #596CA3;
  --bs-btn-border-color: #596CA3;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4c5c8b;
  --bs-btn-hover-border-color: #475682;
  --bs-btn-focus-shadow-rgb: 114, 130, 177;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #475682;
  --bs-btn-active-border-color: #43517a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #596CA3;
  --bs-btn-disabled-border-color: #596CA3; }

.btn-light-blue-06 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #1FA3CC;
  --bs-btn-border-color: #1FA3CC;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1a8bad;
  --bs-btn-hover-border-color: #1982a3;
  --bs-btn-focus-shadow-rgb: 65, 177, 212;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1982a3;
  --bs-btn-active-border-color: #177a99;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #1FA3CC;
  --bs-btn-disabled-border-color: #1FA3CC; }

.btn-light-blue-08 {
  --bs-btn-color: #000;
  --bs-btn-bg: #D6D9E2;
  --bs-btn-border-color: #D6D9E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #dcdfe6;
  --bs-btn-hover-border-color: #dadde5;
  --bs-btn-focus-shadow-rgb: 182, 184, 192;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #dee1e8;
  --bs-btn-active-border-color: #dadde5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #D6D9E2;
  --bs-btn-disabled-border-color: #D6D9E2; }

.btn-light-blue-13 {
  --bs-btn-color: #000;
  --bs-btn-bg: #e5e7ee;
  --bs-btn-border-color: #e5e7ee;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e9ebf1;
  --bs-btn-hover-border-color: #e8e9f0;
  --bs-btn-focus-shadow-rgb: 195, 196, 202;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eaecf1;
  --bs-btn-active-border-color: #e8e9f0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #e5e7ee;
  --bs-btn-disabled-border-color: #e5e7ee; }

.btn-light-blue-14 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #98A1BB;
  --bs-btn-border-color: #98A1BB;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #81899f;
  --bs-btn-hover-border-color: #7a8196;
  --bs-btn-focus-shadow-rgb: 167, 175, 197;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7a8196;
  --bs-btn-active-border-color: #72798c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #98A1BB;
  --bs-btn-disabled-border-color: #98A1BB; }

.btn-color-azul1 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0F1D42;
  --bs-btn-border-color: #0F1D42;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d1938;
  --bs-btn-hover-border-color: #0c1735;
  --bs-btn-focus-shadow-rgb: 51, 63, 94;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0c1735;
  --bs-btn-active-border-color: #0b1632;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0F1D42;
  --bs-btn-disabled-border-color: #0F1D42; }

.btn-color-azul2 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #263874;
  --bs-btn-border-color: #263874;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #203063;
  --bs-btn-hover-border-color: #1e2d5d;
  --bs-btn-focus-shadow-rgb: 71, 86, 137;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1e2d5d;
  --bs-btn-active-border-color: #1d2a57;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #263874;
  --bs-btn-disabled-border-color: #263874; }

.btn-color-azul2-hover {
  --bs-btn-color: #fff;
  --bs-btn-bg: #364B8C;
  --bs-btn-border-color: #364B8C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2e4077;
  --bs-btn-hover-border-color: #2b3c70;
  --bs-btn-focus-shadow-rgb: 84, 102, 157;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2b3c70;
  --bs-btn-active-border-color: #293869;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #364B8C;
  --bs-btn-disabled-border-color: #364B8C; }

.btn-color-azul3 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #244EA2;
  --bs-btn-border-color: #244EA2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1f428a;
  --bs-btn-hover-border-color: #1d3e82;
  --bs-btn-focus-shadow-rgb: 69, 105, 176;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1d3e82;
  --bs-btn-active-border-color: #1b3b7a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #244EA2;
  --bs-btn-disabled-border-color: #244EA2; }

.btn-color-azul4 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #498EF2;
  --bs-btn-border-color: #498EF2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3e79ce;
  --bs-btn-hover-border-color: #3a72c2;
  --bs-btn-focus-shadow-rgb: 100, 159, 244;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3a72c2;
  --bs-btn-active-border-color: #376bb6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #498EF2;
  --bs-btn-disabled-border-color: #498EF2; }

.btn-color-azul5 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #82C0F9;
  --bs-btn-border-color: #82C0F9;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6fa3d4;
  --bs-btn-hover-border-color: #689ac7;
  --bs-btn-focus-shadow-rgb: 149, 201, 250;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #689ac7;
  --bs-btn-active-border-color: #6290bb;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #82C0F9;
  --bs-btn-disabled-border-color: #82C0F9; }

.btn-color-azul6 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #005366;
  --bs-btn-border-color: #005366;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #004757;
  --bs-btn-hover-border-color: #004252;
  --bs-btn-focus-shadow-rgb: 38, 109, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #004252;
  --bs-btn-active-border-color: #003e4d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #005366;
  --bs-btn-disabled-border-color: #005366; }

.btn-color-azul7 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0075A2;
  --bs-btn-border-color: #0075A2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #00638a;
  --bs-btn-hover-border-color: #005e82;
  --bs-btn-focus-shadow-rgb: 38, 138, 176;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #005e82;
  --bs-btn-active-border-color: #00587a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0075A2;
  --bs-btn-disabled-border-color: #0075A2; }

.btn-color-azul8 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #1FA3CC;
  --bs-btn-border-color: #1FA3CC;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1a8bad;
  --bs-btn-hover-border-color: #1982a3;
  --bs-btn-focus-shadow-rgb: 65, 177, 212;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1982a3;
  --bs-btn-active-border-color: #177a99;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #1FA3CC;
  --bs-btn-disabled-border-color: #1FA3CC; }

.btn-color-azul9 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7DC3DC;
  --bs-btn-border-color: #7DC3DC;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6aa6bb;
  --bs-btn-hover-border-color: #649cb0;
  --bs-btn-focus-shadow-rgb: 145, 204, 225;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #649cb0;
  --bs-btn-active-border-color: #5e92a5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7DC3DC;
  --bs-btn-disabled-border-color: #7DC3DC; }

.btn-color-azul10 {
  --bs-btn-color: #000;
  --bs-btn-bg: #9DE6E6;
  --bs-btn-border-color: #9DE6E6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #aceaea;
  --bs-btn-hover-border-color: #a7e9e9;
  --bs-btn-focus-shadow-rgb: 133, 196, 196;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #b1ebeb;
  --bs-btn-active-border-color: #a7e9e9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #9DE6E6;
  --bs-btn-disabled-border-color: #9DE6E6; }

.btn-color-azul11 {
  --bs-btn-color: #000;
  --bs-btn-bg: #D6D9E2;
  --bs-btn-border-color: #D6D9E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #dcdfe6;
  --bs-btn-hover-border-color: #dadde5;
  --bs-btn-focus-shadow-rgb: 182, 184, 192;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #dee1e8;
  --bs-btn-active-border-color: #dadde5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #D6D9E2;
  --bs-btn-disabled-border-color: #D6D9E2; }

.btn-color-azul410 {
  --bs-btn-color: #000;
  --bs-btn-bg: #C1E0FF;
  --bs-btn-border-color: #C1E0FF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #cae5ff;
  --bs-btn-hover-border-color: #c7e3ff;
  --bs-btn-focus-shadow-rgb: 164, 190, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #cde6ff;
  --bs-btn-active-border-color: #c7e3ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #C1E0FF;
  --bs-btn-disabled-border-color: #C1E0FF; }

.btn-color-azul130 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6A799C;
  --bs-btn-border-color: #6A799C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5a6785;
  --bs-btn-hover-border-color: #55617d;
  --bs-btn-focus-shadow-rgb: 128, 141, 171;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #55617d;
  --bs-btn-active-border-color: #505b75;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6A799C;
  --bs-btn-disabled-border-color: #6A799C; }

.btn-color-azul405 {
  --bs-btn-color: #000;
  --bs-btn-bg: #E5F3FF;
  --bs-btn-border-color: #E5F3FF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e9f5ff;
  --bs-btn-hover-border-color: #e8f4ff;
  --bs-btn-focus-shadow-rgb: 195, 207, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eaf5ff;
  --bs-btn-active-border-color: #e8f4ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #E5F3FF;
  --bs-btn-disabled-border-color: #E5F3FF; }

.btn-color-branco2 {
  --bs-btn-color: #000;
  --bs-btn-bg: #F5F5F5;
  --bs-btn-border-color: #F5F5F5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f7f7f7;
  --bs-btn-hover-border-color: #f6f6f6;
  --bs-btn-focus-shadow-rgb: 208, 208, 208;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f7f7f7;
  --bs-btn-active-border-color: #f6f6f6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #F5F5F5;
  --bs-btn-disabled-border-color: #F5F5F5; }

.btn-color-branco3 {
  --bs-btn-color: #000;
  --bs-btn-bg: #F0F0F0;
  --bs-btn-border-color: #F0F0F0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f2f2f2;
  --bs-btn-hover-border-color: #f2f2f2;
  --bs-btn-focus-shadow-rgb: 204, 204, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f3f3f3;
  --bs-btn-active-border-color: #f2f2f2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #F0F0F0;
  --bs-btn-disabled-border-color: #F0F0F0; }

.btn-color-cinza1 {
  --bs-btn-color: #000;
  --bs-btn-bg: #E2E2E2;
  --bs-btn-border-color: #E2E2E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e6e6e6;
  --bs-btn-hover-border-color: #e5e5e5;
  --bs-btn-focus-shadow-rgb: 192, 192, 192;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e8e8e8;
  --bs-btn-active-border-color: #e5e5e5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #E2E2E2;
  --bs-btn-disabled-border-color: #E2E2E2; }

.btn-color-cinza2 {
  --bs-btn-color: #000;
  --bs-btn-bg: #D9D9D9;
  --bs-btn-border-color: #D9D9D9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #dfdfdf;
  --bs-btn-hover-border-color: #dddddd;
  --bs-btn-focus-shadow-rgb: 184, 184, 184;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e1e1e1;
  --bs-btn-active-border-color: #dddddd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #D9D9D9;
  --bs-btn-disabled-border-color: #D9D9D9; }

.btn-color-cinza2-5 {
  --bs-btn-color: #000;
  --bs-btn-bg: #CDCDCD;
  --bs-btn-border-color: #CDCDCD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d5d5d5;
  --bs-btn-hover-border-color: #d2d2d2;
  --bs-btn-focus-shadow-rgb: 174, 174, 174;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d7d7d7;
  --bs-btn-active-border-color: #d2d2d2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #CDCDCD;
  --bs-btn-disabled-border-color: #CDCDCD; }

.btn-color-cinza3 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #A8A8A8;
  --bs-btn-border-color: #A8A8A8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #8f8f8f;
  --bs-btn-hover-border-color: #868686;
  --bs-btn-focus-shadow-rgb: 181, 181, 181;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #868686;
  --bs-btn-active-border-color: #7e7e7e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #A8A8A8;
  --bs-btn-disabled-border-color: #A8A8A8; }

.btn-color-cinza4 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6C6C6C;
  --bs-btn-border-color: #6C6C6C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c5c5c;
  --bs-btn-hover-border-color: #565656;
  --bs-btn-focus-shadow-rgb: 130, 130, 130;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565656;
  --bs-btn-active-border-color: #515151;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6C6C6C;
  --bs-btn-disabled-border-color: #6C6C6C; }

.btn-color-cinza5 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #353535;
  --bs-btn-border-color: #353535;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2d2d2d;
  --bs-btn-hover-border-color: #2a2a2a;
  --bs-btn-focus-shadow-rgb: 83, 83, 83;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2a2a2a;
  --bs-btn-active-border-color: #282828;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #353535;
  --bs-btn-disabled-border-color: #353535; }

.btn-color-cinza6 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #B4B4B412;
  --bs-btn-border-color: #B4B4B412;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(31, 31, 31, 0.21);
  --bs-btn-hover-border-color: rgba(23, 23, 23, 0.256471);
  --bs-btn-focus-shadow-rgb: 242, 242, 242;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgba(23, 23, 23, 0.256471);
  --bs-btn-active-border-color: rgba(18, 18, 18, 0.302941);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #B4B4B412;
  --bs-btn-disabled-border-color: #B4B4B412; }

.btn-color-vermelho1 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ec221f;
  --bs-btn-border-color: #ec221f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #c91d1a;
  --bs-btn-hover-border-color: #bd1b19;
  --bs-btn-focus-shadow-rgb: 239, 67, 65;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #bd1b19;
  --bs-btn-active-border-color: #b11a17;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ec221f;
  --bs-btn-disabled-border-color: #ec221f; }

.btn-color-vermelho2 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #BA0501;
  --bs-btn-border-color: #BA0501;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #9e0401;
  --bs-btn-hover-border-color: #950401;
  --bs-btn-focus-shadow-rgb: 196, 43, 39;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #950401;
  --bs-btn-active-border-color: #8c0401;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #BA0501;
  --bs-btn-disabled-border-color: #BA0501; }

.btn-color-vermelho3 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ec221f25;
  --bs-btn-border-color: #ec221f25;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(72, 10, 10, 0.273333);
  --bs-btn-hover-border-color: rgba(56, 8, 7, 0.316078);
  --bs-btn-focus-shadow-rgb: 249, 187, 186;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgba(56, 8, 7, 0.316078);
  --bs-btn-active-border-color: rgba(45, 6, 6, 0.358824);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ec221f25;
  --bs-btn-disabled-border-color: #ec221f25; }

.btn-color-verde1 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4bb543;
  --bs-btn-border-color: #4bb543;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #409a39;
  --bs-btn-hover-border-color: #3c9136;
  --bs-btn-focus-shadow-rgb: 102, 192, 95;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3c9136;
  --bs-btn-active-border-color: #388832;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4bb543;
  --bs-btn-disabled-border-color: #4bb543; }

.btn-color-verde2 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0a7702;
  --bs-btn-border-color: #0a7702;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #096502;
  --bs-btn-hover-border-color: #085f02;
  --bs-btn-focus-shadow-rgb: 47, 139, 40;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #085f02;
  --bs-btn-active-border-color: #085902;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0a7702;
  --bs-btn-disabled-border-color: #0a7702; }

.btn-color-verde3 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4bb54325;
  --bs-btn-border-color: #4bb54325;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(23, 56, 21, 0.273333);
  --bs-btn-hover-border-color: rgba(18, 43, 16, 0.316078);
  --bs-btn-focus-shadow-rgb: 200, 232, 197;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgba(18, 43, 16, 0.316078);
  --bs-btn-active-border-color: rgba(14, 34, 13, 0.358824);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4bb54325;
  --bs-btn-disabled-border-color: #4bb54325; }

.btn-color-amarelo1 {
  --bs-btn-color: #000;
  --bs-btn-bg: #fece22;
  --bs-btn-border-color: #fece22;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fed543;
  --bs-btn-hover-border-color: #fed338;
  --bs-btn-focus-shadow-rgb: 216, 175, 29;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fed84e;
  --bs-btn-active-border-color: #fed338;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #fece22;
  --bs-btn-disabled-border-color: #fece22; }

.btn-color-amarelo2 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7f6d31;
  --bs-btn-border-color: #7f6d31;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c5d2a;
  --bs-btn-hover-border-color: #665727;
  --bs-btn-focus-shadow-rgb: 146, 131, 80;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #665727;
  --bs-btn-active-border-color: #5f5225;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7f6d31;
  --bs-btn-disabled-border-color: #7f6d31; }

.btn-color-amarelo3 {
  --bs-btn-color: #000;
  --bs-btn-bg: #fece2225;
  --bs-btn-border-color: #fece2225;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgba(255, 240, 187, 0.273333);
  --bs-btn-hover-border-color: rgba(255, 235, 164, 0.230588);
  --bs-btn-focus-shadow-rgb: 78, 63, 10;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgba(255, 243, 202, 0.316078);
  --bs-btn-active-border-color: rgba(255, 235, 164, 0.230588);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #fece2225;
  --bs-btn-disabled-border-color: #fece2225; }

.btn-color-laranja1 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ff6241;
  --bs-btn-border-color: #ff6241;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d95337;
  --bs-btn-hover-border-color: #cc4e34;
  --bs-btn-focus-shadow-rgb: 255, 122, 94;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #cc4e34;
  --bs-btn-active-border-color: #bf4a31;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ff6241;
  --bs-btn-disabled-border-color: #ff6241; }

.btn-outline-primary {
  --bs-btn-color: #244EA2;
  --bs-btn-border-color: #244EA2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #244EA2;
  --bs-btn-hover-border-color: #244EA2;
  --bs-btn-focus-shadow-rgb: 36, 78, 162;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #244EA2;
  --bs-btn-active-border-color: #244EA2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #244EA2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #244EA2;
  --bs-gradient: none; }

.btn-outline-primary-dark {
  --bs-btn-color: #263874;
  --bs-btn-border-color: #263874;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #263874;
  --bs-btn-hover-border-color: #263874;
  --bs-btn-focus-shadow-rgb: 38, 56, 116;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #263874;
  --bs-btn-active-border-color: #263874;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #263874;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #263874;
  --bs-gradient: none; }

.btn-outline-gray-secundary {
  --bs-btn-color: #6C6C6C;
  --bs-btn-border-color: #6C6C6C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6C6C6C;
  --bs-btn-hover-border-color: #6C6C6C;
  --bs-btn-focus-shadow-rgb: 108, 108, 108;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6C6C6C;
  --bs-btn-active-border-color: #6C6C6C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6C6C6C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6C6C6C;
  --bs-gradient: none; }

.btn-outline-secondary {
  --bs-btn-color: #74788d;
  --bs-btn-border-color: #74788d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #74788d;
  --bs-btn-hover-border-color: #74788d;
  --bs-btn-focus-shadow-rgb: 116, 120, 141;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #74788d;
  --bs-btn-active-border-color: #74788d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #74788d;
  --bs-gradient: none; }

.btn-outline-success {
  --bs-btn-color: #4bb543;
  --bs-btn-border-color: #4bb543;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4bb543;
  --bs-btn-hover-border-color: #4bb543;
  --bs-btn-focus-shadow-rgb: 75, 181, 67;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4bb543;
  --bs-btn-active-border-color: #4bb543;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4bb543;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4bb543;
  --bs-gradient: none; }

.btn-outline-info {
  --bs-btn-color: #F0F0F0;
  --bs-btn-border-color: #F0F0F0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #F0F0F0;
  --bs-btn-hover-border-color: #F0F0F0;
  --bs-btn-focus-shadow-rgb: 240, 240, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #F0F0F0;
  --bs-btn-active-border-color: #F0F0F0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F0F0F0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F0F0F0;
  --bs-gradient: none; }

.btn-outline-warning {
  --bs-btn-color: #fece22;
  --bs-btn-border-color: #fece22;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fece22;
  --bs-btn-hover-border-color: #fece22;
  --bs-btn-focus-shadow-rgb: 254, 206, 34;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fece22;
  --bs-btn-active-border-color: #fece22;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fece22;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fece22;
  --bs-gradient: none; }

.btn-outline-danger {
  --bs-btn-color: #EC221F;
  --bs-btn-border-color: #EC221F;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #EC221F;
  --bs-btn-hover-border-color: #EC221F;
  --bs-btn-focus-shadow-rgb: 236, 34, 31;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #EC221F;
  --bs-btn-active-border-color: #EC221F;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #EC221F;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #EC221F;
  --bs-gradient: none; }

.btn-outline-pink {
  --bs-btn-color: #e83e8c;
  --bs-btn-border-color: #e83e8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #e83e8c;
  --bs-btn-hover-border-color: #e83e8c;
  --bs-btn-focus-shadow-rgb: 232, 62, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #e83e8c;
  --bs-btn-active-border-color: #e83e8c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e83e8c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e83e8c;
  --bs-gradient: none; }

.btn-outline-light {
  --bs-btn-color: #eff2f7;
  --bs-btn-border-color: #eff2f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eff2f7;
  --bs-btn-hover-border-color: #eff2f7;
  --bs-btn-focus-shadow-rgb: 239, 242, 247;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eff2f7;
  --bs-btn-active-border-color: #eff2f7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eff2f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eff2f7;
  --bs-gradient: none; }

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none; }

.btn-outline-dark-gray-primary {
  --bs-btn-color: #353535;
  --bs-btn-border-color: #353535;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #353535;
  --bs-btn-hover-border-color: #353535;
  --bs-btn-focus-shadow-rgb: 53, 53, 53;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #353535;
  --bs-btn-active-border-color: #353535;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #353535;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #353535;
  --bs-gradient: none; }

.btn-outline-light-gray-05 {
  --bs-btn-color: #D9D9D9;
  --bs-btn-border-color: #D9D9D9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #D9D9D9;
  --bs-btn-hover-border-color: #D9D9D9;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #D9D9D9;
  --bs-btn-active-border-color: #D9D9D9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D9D9D9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D9D9D9;
  --bs-gradient: none; }

.btn-outline-light-gray-03 {
  --bs-btn-color: #E2E2E2;
  --bs-btn-border-color: #E2E2E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #E2E2E2;
  --bs-btn-hover-border-color: #E2E2E2;
  --bs-btn-focus-shadow-rgb: 226, 226, 226;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #E2E2E2;
  --bs-btn-active-border-color: #E2E2E2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E2E2E2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E2E2E2;
  --bs-gradient: none; }

.btn-outline-light_gray_04 {
  --bs-btn-color: #E6E6E6;
  --bs-btn-border-color: #E6E6E6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #E6E6E6;
  --bs-btn-hover-border-color: #E6E6E6;
  --bs-btn-focus-shadow-rgb: 230, 230, 230;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #E6E6E6;
  --bs-btn-active-border-color: #E6E6E6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E6E6E6;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E6E6E6;
  --bs-gradient: none; }

.btn-outline-light-gray-06 {
  --bs-btn-color: #CDCDCD;
  --bs-btn-border-color: #CDCDCD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #CDCDCD;
  --bs-btn-hover-border-color: #CDCDCD;
  --bs-btn-focus-shadow-rgb: 205, 205, 205;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #CDCDCD;
  --bs-btn-active-border-color: #CDCDCD;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #CDCDCD;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #CDCDCD;
  --bs-gradient: none; }

.btn-outline-light_blue_04 {
  --bs-btn-color: #0075A2;
  --bs-btn-border-color: #0075A2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0075A2;
  --bs-btn-hover-border-color: #0075A2;
  --bs-btn-focus-shadow-rgb: 0, 117, 162;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0075A2;
  --bs-btn-active-border-color: #0075A2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0075A2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0075A2;
  --bs-gradient: none; }

.btn-outline-light-blue-01 {
  --bs-btn-color: #498EF2;
  --bs-btn-border-color: #498EF2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #498EF2;
  --bs-btn-hover-border-color: #498EF2;
  --bs-btn-focus-shadow-rgb: 73, 142, 242;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #498EF2;
  --bs-btn-active-border-color: #498EF2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #498EF2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #498EF2;
  --bs-gradient: none; }

.btn-outline-light-blue-11 {
  --bs-btn-color: #596CA3;
  --bs-btn-border-color: #596CA3;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #596CA3;
  --bs-btn-hover-border-color: #596CA3;
  --bs-btn-focus-shadow-rgb: 89, 108, 163;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #596CA3;
  --bs-btn-active-border-color: #596CA3;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #596CA3;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #596CA3;
  --bs-gradient: none; }

.btn-outline-light-blue-06 {
  --bs-btn-color: #1FA3CC;
  --bs-btn-border-color: #1FA3CC;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1FA3CC;
  --bs-btn-hover-border-color: #1FA3CC;
  --bs-btn-focus-shadow-rgb: 31, 163, 204;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1FA3CC;
  --bs-btn-active-border-color: #1FA3CC;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #1FA3CC;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1FA3CC;
  --bs-gradient: none; }

.btn-outline-light-blue-08 {
  --bs-btn-color: #D6D9E2;
  --bs-btn-border-color: #D6D9E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #D6D9E2;
  --bs-btn-hover-border-color: #D6D9E2;
  --bs-btn-focus-shadow-rgb: 214, 217, 226;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #D6D9E2;
  --bs-btn-active-border-color: #D6D9E2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D6D9E2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D6D9E2;
  --bs-gradient: none; }

.btn-outline-light-blue-13 {
  --bs-btn-color: #e5e7ee;
  --bs-btn-border-color: #e5e7ee;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e5e7ee;
  --bs-btn-hover-border-color: #e5e7ee;
  --bs-btn-focus-shadow-rgb: 229, 231, 238;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e5e7ee;
  --bs-btn-active-border-color: #e5e7ee;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e5e7ee;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e5e7ee;
  --bs-gradient: none; }

.btn-outline-light-blue-14 {
  --bs-btn-color: #98A1BB;
  --bs-btn-border-color: #98A1BB;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #98A1BB;
  --bs-btn-hover-border-color: #98A1BB;
  --bs-btn-focus-shadow-rgb: 152, 161, 187;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #98A1BB;
  --bs-btn-active-border-color: #98A1BB;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #98A1BB;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #98A1BB;
  --bs-gradient: none; }

.btn-outline-color-azul1 {
  --bs-btn-color: #0F1D42;
  --bs-btn-border-color: #0F1D42;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0F1D42;
  --bs-btn-hover-border-color: #0F1D42;
  --bs-btn-focus-shadow-rgb: 15, 29, 66;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0F1D42;
  --bs-btn-active-border-color: #0F1D42;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0F1D42;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0F1D42;
  --bs-gradient: none; }

.btn-outline-color-azul2 {
  --bs-btn-color: #263874;
  --bs-btn-border-color: #263874;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #263874;
  --bs-btn-hover-border-color: #263874;
  --bs-btn-focus-shadow-rgb: 38, 56, 116;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #263874;
  --bs-btn-active-border-color: #263874;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #263874;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #263874;
  --bs-gradient: none; }

.btn-outline-color-azul2-hover {
  --bs-btn-color: #364B8C;
  --bs-btn-border-color: #364B8C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #364B8C;
  --bs-btn-hover-border-color: #364B8C;
  --bs-btn-focus-shadow-rgb: 54, 75, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #364B8C;
  --bs-btn-active-border-color: #364B8C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #364B8C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #364B8C;
  --bs-gradient: none; }

.btn-outline-color-azul3 {
  --bs-btn-color: #244EA2;
  --bs-btn-border-color: #244EA2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #244EA2;
  --bs-btn-hover-border-color: #244EA2;
  --bs-btn-focus-shadow-rgb: 36, 78, 162;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #244EA2;
  --bs-btn-active-border-color: #244EA2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #244EA2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #244EA2;
  --bs-gradient: none; }

.btn-outline-color-azul4 {
  --bs-btn-color: #498EF2;
  --bs-btn-border-color: #498EF2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #498EF2;
  --bs-btn-hover-border-color: #498EF2;
  --bs-btn-focus-shadow-rgb: 73, 142, 242;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #498EF2;
  --bs-btn-active-border-color: #498EF2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #498EF2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #498EF2;
  --bs-gradient: none; }

.btn-outline-color-azul5 {
  --bs-btn-color: #82C0F9;
  --bs-btn-border-color: #82C0F9;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #82C0F9;
  --bs-btn-hover-border-color: #82C0F9;
  --bs-btn-focus-shadow-rgb: 130, 192, 249;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #82C0F9;
  --bs-btn-active-border-color: #82C0F9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #82C0F9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #82C0F9;
  --bs-gradient: none; }

.btn-outline-color-azul6 {
  --bs-btn-color: #005366;
  --bs-btn-border-color: #005366;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #005366;
  --bs-btn-hover-border-color: #005366;
  --bs-btn-focus-shadow-rgb: 0, 83, 102;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #005366;
  --bs-btn-active-border-color: #005366;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #005366;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #005366;
  --bs-gradient: none; }

.btn-outline-color-azul7 {
  --bs-btn-color: #0075A2;
  --bs-btn-border-color: #0075A2;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0075A2;
  --bs-btn-hover-border-color: #0075A2;
  --bs-btn-focus-shadow-rgb: 0, 117, 162;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0075A2;
  --bs-btn-active-border-color: #0075A2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0075A2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0075A2;
  --bs-gradient: none; }

.btn-outline-color-azul8 {
  --bs-btn-color: #1FA3CC;
  --bs-btn-border-color: #1FA3CC;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1FA3CC;
  --bs-btn-hover-border-color: #1FA3CC;
  --bs-btn-focus-shadow-rgb: 31, 163, 204;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1FA3CC;
  --bs-btn-active-border-color: #1FA3CC;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #1FA3CC;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1FA3CC;
  --bs-gradient: none; }

.btn-outline-color-azul9 {
  --bs-btn-color: #7DC3DC;
  --bs-btn-border-color: #7DC3DC;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7DC3DC;
  --bs-btn-hover-border-color: #7DC3DC;
  --bs-btn-focus-shadow-rgb: 125, 195, 220;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7DC3DC;
  --bs-btn-active-border-color: #7DC3DC;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7DC3DC;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7DC3DC;
  --bs-gradient: none; }

.btn-outline-color-azul10 {
  --bs-btn-color: #9DE6E6;
  --bs-btn-border-color: #9DE6E6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #9DE6E6;
  --bs-btn-hover-border-color: #9DE6E6;
  --bs-btn-focus-shadow-rgb: 157, 230, 230;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #9DE6E6;
  --bs-btn-active-border-color: #9DE6E6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #9DE6E6;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #9DE6E6;
  --bs-gradient: none; }

.btn-outline-color-azul11 {
  --bs-btn-color: #D6D9E2;
  --bs-btn-border-color: #D6D9E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #D6D9E2;
  --bs-btn-hover-border-color: #D6D9E2;
  --bs-btn-focus-shadow-rgb: 214, 217, 226;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #D6D9E2;
  --bs-btn-active-border-color: #D6D9E2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D6D9E2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D6D9E2;
  --bs-gradient: none; }

.btn-outline-color-azul410 {
  --bs-btn-color: #C1E0FF;
  --bs-btn-border-color: #C1E0FF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #C1E0FF;
  --bs-btn-hover-border-color: #C1E0FF;
  --bs-btn-focus-shadow-rgb: 193, 224, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #C1E0FF;
  --bs-btn-active-border-color: #C1E0FF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #C1E0FF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #C1E0FF;
  --bs-gradient: none; }

.btn-outline-color-azul130 {
  --bs-btn-color: #6A799C;
  --bs-btn-border-color: #6A799C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6A799C;
  --bs-btn-hover-border-color: #6A799C;
  --bs-btn-focus-shadow-rgb: 106, 121, 156;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6A799C;
  --bs-btn-active-border-color: #6A799C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6A799C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6A799C;
  --bs-gradient: none; }

.btn-outline-color-azul405 {
  --bs-btn-color: #E5F3FF;
  --bs-btn-border-color: #E5F3FF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #E5F3FF;
  --bs-btn-hover-border-color: #E5F3FF;
  --bs-btn-focus-shadow-rgb: 229, 243, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #E5F3FF;
  --bs-btn-active-border-color: #E5F3FF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E5F3FF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E5F3FF;
  --bs-gradient: none; }

.btn-outline-color-branco2 {
  --bs-btn-color: #F5F5F5;
  --bs-btn-border-color: #F5F5F5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #F5F5F5;
  --bs-btn-hover-border-color: #F5F5F5;
  --bs-btn-focus-shadow-rgb: 245, 245, 245;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #F5F5F5;
  --bs-btn-active-border-color: #F5F5F5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F5F5F5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F5F5F5;
  --bs-gradient: none; }

.btn-outline-color-branco3 {
  --bs-btn-color: #F0F0F0;
  --bs-btn-border-color: #F0F0F0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #F0F0F0;
  --bs-btn-hover-border-color: #F0F0F0;
  --bs-btn-focus-shadow-rgb: 240, 240, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #F0F0F0;
  --bs-btn-active-border-color: #F0F0F0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F0F0F0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F0F0F0;
  --bs-gradient: none; }

.btn-outline-color-cinza1 {
  --bs-btn-color: #E2E2E2;
  --bs-btn-border-color: #E2E2E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #E2E2E2;
  --bs-btn-hover-border-color: #E2E2E2;
  --bs-btn-focus-shadow-rgb: 226, 226, 226;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #E2E2E2;
  --bs-btn-active-border-color: #E2E2E2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E2E2E2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E2E2E2;
  --bs-gradient: none; }

.btn-outline-color-cinza2 {
  --bs-btn-color: #D9D9D9;
  --bs-btn-border-color: #D9D9D9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #D9D9D9;
  --bs-btn-hover-border-color: #D9D9D9;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #D9D9D9;
  --bs-btn-active-border-color: #D9D9D9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D9D9D9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D9D9D9;
  --bs-gradient: none; }

.btn-outline-color-cinza2-5 {
  --bs-btn-color: #CDCDCD;
  --bs-btn-border-color: #CDCDCD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #CDCDCD;
  --bs-btn-hover-border-color: #CDCDCD;
  --bs-btn-focus-shadow-rgb: 205, 205, 205;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #CDCDCD;
  --bs-btn-active-border-color: #CDCDCD;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #CDCDCD;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #CDCDCD;
  --bs-gradient: none; }

.btn-outline-color-cinza3 {
  --bs-btn-color: #A8A8A8;
  --bs-btn-border-color: #A8A8A8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #A8A8A8;
  --bs-btn-hover-border-color: #A8A8A8;
  --bs-btn-focus-shadow-rgb: 168, 168, 168;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #A8A8A8;
  --bs-btn-active-border-color: #A8A8A8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #A8A8A8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #A8A8A8;
  --bs-gradient: none; }

.btn-outline-color-cinza4 {
  --bs-btn-color: #6C6C6C;
  --bs-btn-border-color: #6C6C6C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6C6C6C;
  --bs-btn-hover-border-color: #6C6C6C;
  --bs-btn-focus-shadow-rgb: 108, 108, 108;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6C6C6C;
  --bs-btn-active-border-color: #6C6C6C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6C6C6C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6C6C6C;
  --bs-gradient: none; }

.btn-outline-color-cinza5 {
  --bs-btn-color: #353535;
  --bs-btn-border-color: #353535;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #353535;
  --bs-btn-hover-border-color: #353535;
  --bs-btn-focus-shadow-rgb: 53, 53, 53;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #353535;
  --bs-btn-active-border-color: #353535;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #353535;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #353535;
  --bs-gradient: none; }

.btn-outline-color-cinza6 {
  --bs-btn-color: #B4B4B412;
  --bs-btn-border-color: #B4B4B412;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #B4B4B412;
  --bs-btn-hover-border-color: #B4B4B412;
  --bs-btn-focus-shadow-rgb: 180, 180, 180;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #B4B4B412;
  --bs-btn-active-border-color: #B4B4B412;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #B4B4B412;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #B4B4B412;
  --bs-gradient: none; }

.btn-outline-color-vermelho1 {
  --bs-btn-color: #ec221f;
  --bs-btn-border-color: #ec221f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ec221f;
  --bs-btn-hover-border-color: #ec221f;
  --bs-btn-focus-shadow-rgb: 236, 34, 31;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ec221f;
  --bs-btn-active-border-color: #ec221f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ec221f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ec221f;
  --bs-gradient: none; }

.btn-outline-color-vermelho2 {
  --bs-btn-color: #BA0501;
  --bs-btn-border-color: #BA0501;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #BA0501;
  --bs-btn-hover-border-color: #BA0501;
  --bs-btn-focus-shadow-rgb: 186, 5, 1;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #BA0501;
  --bs-btn-active-border-color: #BA0501;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #BA0501;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #BA0501;
  --bs-gradient: none; }

.btn-outline-color-vermelho3 {
  --bs-btn-color: #ec221f25;
  --bs-btn-border-color: #ec221f25;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ec221f25;
  --bs-btn-hover-border-color: #ec221f25;
  --bs-btn-focus-shadow-rgb: 236, 34, 31;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ec221f25;
  --bs-btn-active-border-color: #ec221f25;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ec221f25;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ec221f25;
  --bs-gradient: none; }

.btn-outline-color-verde1 {
  --bs-btn-color: #4bb543;
  --bs-btn-border-color: #4bb543;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4bb543;
  --bs-btn-hover-border-color: #4bb543;
  --bs-btn-focus-shadow-rgb: 75, 181, 67;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4bb543;
  --bs-btn-active-border-color: #4bb543;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4bb543;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4bb543;
  --bs-gradient: none; }

.btn-outline-color-verde2 {
  --bs-btn-color: #0a7702;
  --bs-btn-border-color: #0a7702;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0a7702;
  --bs-btn-hover-border-color: #0a7702;
  --bs-btn-focus-shadow-rgb: 10, 119, 2;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a7702;
  --bs-btn-active-border-color: #0a7702;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0a7702;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0a7702;
  --bs-gradient: none; }

.btn-outline-color-verde3 {
  --bs-btn-color: #4bb54325;
  --bs-btn-border-color: #4bb54325;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4bb54325;
  --bs-btn-hover-border-color: #4bb54325;
  --bs-btn-focus-shadow-rgb: 75, 181, 67;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4bb54325;
  --bs-btn-active-border-color: #4bb54325;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4bb54325;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4bb54325;
  --bs-gradient: none; }

.btn-outline-color-amarelo1 {
  --bs-btn-color: #fece22;
  --bs-btn-border-color: #fece22;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fece22;
  --bs-btn-hover-border-color: #fece22;
  --bs-btn-focus-shadow-rgb: 254, 206, 34;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fece22;
  --bs-btn-active-border-color: #fece22;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fece22;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fece22;
  --bs-gradient: none; }

.btn-outline-color-amarelo2 {
  --bs-btn-color: #7f6d31;
  --bs-btn-border-color: #7f6d31;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7f6d31;
  --bs-btn-hover-border-color: #7f6d31;
  --bs-btn-focus-shadow-rgb: 127, 109, 49;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7f6d31;
  --bs-btn-active-border-color: #7f6d31;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7f6d31;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7f6d31;
  --bs-gradient: none; }

.btn-outline-color-amarelo3 {
  --bs-btn-color: #fece2225;
  --bs-btn-border-color: #fece2225;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fece2225;
  --bs-btn-hover-border-color: #fece2225;
  --bs-btn-focus-shadow-rgb: 254, 206, 34;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fece2225;
  --bs-btn-active-border-color: #fece2225;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fece2225;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fece2225;
  --bs-gradient: none; }

.btn-outline-color-laranja1 {
  --bs-btn-color: #ff6241;
  --bs-btn-border-color: #ff6241;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff6241;
  --bs-btn-hover-border-color: #ff6241;
  --bs-btn-focus-shadow-rgb: 255, 98, 65;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff6241;
  --bs-btn-active-border-color: #ff6241;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff6241;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff6241;
  --bs-gradient: none; }

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #244EA2;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #163063;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #163063;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none; }
  .btn-link:hover, .btn-link:focus-visible {
    text-decoration: underline; }
  .btn-link:focus-visible {
    color: var(--bs-btn-color); }
  .btn-link:hover {
    color: var(--bs-btn-hover-color); }

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.125rem;
  --bs-btn-border-radius: 0.4rem; }

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.75rem;
  --bs-btn-border-radius: 0.2rem; }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.collapse-horizontal {
        transition: none; } }

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.875rem;
  --bs-dropdown-color: #505d69;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: calc(0.25rem - 0);
  --bs-dropdown-divider-bg: #eff2f7;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  --bs-dropdown-link-color: #212529;
  --bs-dropdown-link-hover-color: #16181b;
  --bs-dropdown-link-hover-bg: #f8f9fa;
  --bs-dropdown-link-active-color: #16181b;
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #74788d;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #74788d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius); }
  .dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--bs-dropdown-spacer); }

.dropdown-menu-start {
  --bs-position: start; }
  .dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0; }

.dropdown-menu-end {
  --bs-position: end; }
  .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start; }
    .dropdown-menu-sm-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-sm-end {
    --bs-position: end; }
    .dropdown-menu-sm-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start; }
    .dropdown-menu-md-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-md-end {
    --bs-position: end; }
    .dropdown-menu-md-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start; }
    .dropdown-menu-lg-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-lg-end {
    --bs-position: end; }
    .dropdown-menu-lg-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start; }
    .dropdown-menu-xl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xl-end {
    --bs-position: end; }
    .dropdown-menu-xl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start; }
    .dropdown-menu-xxl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xxl-end {
    --bs-position: end; }
    .dropdown-menu-xxl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer); }

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer); }

.dropend .dropdown-toggle::after {
  vertical-align: 0; }

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer); }

.dropstart .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0); }
  .dropdown-item:hover, .dropdown-item:focus {
    color: var(--bs-dropdown-link-hover-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-hover-bg); }
  .dropdown-item.active, .dropdown-item:active {
    color: var(--bs-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-active-bg); }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: var(--bs-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.75rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color); }

.dropdown-menu-dark {
  --bs-dropdown-color: #f1f5f7;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: rgba(0, 0, 0, 0.15);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #f1f5f7;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #eff2f7;
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #16181b;
  --bs-dropdown-link-active-bg: #f8f9fa;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
  .btn-group > .btn-check:checked + .btn,
  .btn-group > .btn-check:focus + .btn,
  .btn-group > .btn:hover,
  .btn-group > .btn:focus,
  .btn-group > .btn:active,
  .btn-group > .btn.active,
  .btn-group-vertical > .btn-check:checked + .btn,
  .btn-group-vertical > .btn-check:focus + .btn,
  .btn-group-vertical > .btn:hover,
  .btn-group-vertical > .btn:focus,
  .btn-group-vertical > .btn:active,
  .btn-group-vertical > .btn.active {
    z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group {
  border-radius: 0.25rem; }
  .btn-group > :not(.btn-check:first-child) + .btn,
  .btn-group > .btn-group:not(:first-child) {
    margin-left: calc(-1 * 1px); }
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group > .btn.dropdown-toggle-split:first-child,
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .btn-group > .btn:nth-child(n + 3),
  .btn-group > :not(.btn-check) + .btn,
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropend .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropstart .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: calc(-1 * 1px); }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:nth-child(n + 3),
  .btn-group-vertical > :not(.btn-check) + .btn,
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .nav-link {
      transition: none; } }
  .nav-link:hover, .nav-link:focus {
    color: var(--bs-nav-link-hover-color);
    text-decoration: none; }
  .nav-link:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
  .nav-link.disabled, .nav-link:disabled {
    color: var(--bs-nav-link-disabled-color);
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #ced4da;
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: #eff2f7 #eff2f7 #ced4da;
  --bs-nav-tabs-link-active-color: #505d69;
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: #ced4da #ced4da var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color); }
  .nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
    border: var(--bs-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--bs-nav-tabs-border-radius);
    border-top-right-radius: var(--bs-nav-tabs-border-radius); }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: var(--bs-nav-tabs-link-hover-border-color); }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: var(--bs-nav-tabs-link-active-color);
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color); }
  .nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #244EA2; }
  .nav-pills .nav-link {
    border-radius: var(--bs-nav-pills-border-radius); }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: var(--bs-nav-pills-link-active-bg); }

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap); }
  .nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    border-bottom: var(--bs-nav-underline-border-width) solid transparent; }
    .nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
      border-bottom-color: currentcolor; }
  .nav-underline .nav-link.active,
  .nav-underline .show > .nav-link {
    font-weight: 600;
    color: var(--bs-nav-underline-link-active-color);
    border-bottom-color: currentcolor; }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center; }

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.125rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.125rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.25rem;
  --bs-navbar-toggler-focus-width: 0.15rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x); }
  .navbar > .container,
  .navbar > .container-fluid, .navbar > .container-sm, .navbar > .container-md, .navbar > .container-lg, .navbar > .container-xl, .navbar > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    color: var(--bs-navbar-brand-hover-color);
    text-decoration: none; }

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
    color: var(--bs-navbar-active-color); }
  .navbar-nav .dropdown-menu {
    position: static; }

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color); }
  .navbar-text a,
  .navbar-text a:hover,
  .navbar-text a:focus {
    color: var(--bs-navbar-active-color); }

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center; }

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition); }
  @media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
      transition: none; } }
  .navbar-toggler:hover {
    text-decoration: none; }
  .navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width); }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%; }

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto; }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-md .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xxl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; }
    .navbar-expand-xxl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: var(--bs-navbar-nav-link-padding-x);
      padding-left: var(--bs-navbar-nav-link-padding-x); }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none; }
    .navbar-expand .offcanvas .offcanvas-header {
      display: none; }
    .navbar-expand .offcanvas .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible; }

.navbar-dark,
.navbar[data-bs-theme="dark"] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_28___}); }

[data-bs-theme="dark"] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_28___}); }

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: #f1f5f7;
  --bs-card-border-radius: 0.4rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: 0.4rem;
  --bs-card-cap-padding-y: 0.625rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: #f1f5f7;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius); }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: var(--bs-card-inner-border-radius);
      border-top-right-radius: var(--bs-card-inner-border-radius); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: var(--bs-card-inner-border-radius);
      border-bottom-left-radius: var(--bs-card-inner-border-radius); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color); }

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color); }

.card-subtitle {
  margin-top: calc(-.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color); }

.card-text:last-child {
  margin-bottom: 0; }

.card-link:hover {
  text-decoration: none; }

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x); }

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0; }

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-footer:last-child {
    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius); }

.card-header-tabs {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0; }
  .card-header-tabs .nav-link.active {
    background-color: var(--bs-card-bg);
    border-bottom-color: var(--bs-card-bg); }

.card-header-pills {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x)); }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius); }

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin); }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) > .card-img-top,
        .card-group > .card:not(:last-child) > .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) > .card-img-bottom,
        .card-group > .card:not(:last-child) > .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) > .card-img-top,
        .card-group > .card:not(:first-child) > .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) > .card-img-bottom,
        .card-group > .card:not(:first-child) > .card-footer {
          border-bottom-left-radius: 0; } }

.accordion {
  --bs-accordion-color: #505d69;
  --bs-accordion-bg: transparent;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: rgba(0, 0, 0, 0.125);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.25rem;
  --bs-accordion-inner-border-radius: calc(0.25rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: #505d69;
  --bs-accordion-btn-bg: transparent;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  --bs-accordion-btn-icon-width: 16px;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #204692;
  --bs-accordion-active-bg: #e9edf6; }

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition); }
  @media (prefers-reduced-motion: reduce) {
    .accordion-button {
      transition: none; } }
  .accordion-button:not(.collapsed) {
    color: var(--bs-accordion-active-color);
    background-color: var(--bs-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color); }
    .accordion-button:not(.collapsed)::after {
      background-image: var(--bs-accordion-btn-active-icon);
      transform: var(--bs-accordion-btn-icon-transform); }
  .accordion-button::after {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition); }
    @media (prefers-reduced-motion: reduce) {
      .accordion-button::after {
        transition: none; } }
  .accordion-button:hover {
    z-index: 2; }
  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: var(--bs-accordion-btn-focus-box-shadow); }

.accordion-header {
  margin-bottom: 0; }

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color); }
  .accordion-item:first-of-type {
    border-top-left-radius: var(--bs-accordion-border-radius);
    border-top-right-radius: var(--bs-accordion-border-radius); }
    .accordion-item:first-of-type > .accordion-header .accordion-button {
      border-top-left-radius: var(--bs-accordion-inner-border-radius);
      border-top-right-radius: var(--bs-accordion-inner-border-radius); }
  .accordion-item:not(:first-of-type) {
    border-top: 0; }
  .accordion-item:last-of-type {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius); }
    .accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
      border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
      border-bottom-left-radius: var(--bs-accordion-inner-border-radius); }
    .accordion-item:last-of-type > .accordion-collapse {
      border-bottom-right-radius: var(--bs-accordion-border-radius);
      border-bottom-left-radius: var(--bs-accordion-border-radius); }

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x); }

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
  .accordion-flush > .accordion-item:first-child {
    border-top: 0; }
  .accordion-flush > .accordion-item:last-child {
    border-bottom: 0; }
  .accordion-flush > .accordion-item > .accordion-collapse,
  .accordion-flush > .accordion-item > .accordion-header .accordion-button,
  .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
    border-radius: 0; }

[data-bs-theme="dark"] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_31___}); }

.breadcrumb {
  --bs-breadcrumb-padding-x: 1rem;
  --bs-breadcrumb-padding-y: 0.75rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #74788d;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius); }

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x); }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: var(--bs-breadcrumb-item-padding-x);
    color: var(--bs-breadcrumb-divider-color);
    content: var(--bs-breadcrumb-divider, "󰅂") /* rtl: var(--bs-breadcrumb-divider, "󰅂") */; }

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color); }

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: #74788d;
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #ced4da;
  --bs-pagination-border-radius: 0.25rem;
  --bs-pagination-hover-color: #163063;
  --bs-pagination-hover-bg: #eff2f7;
  --bs-pagination-hover-border-color: #ced4da;
  --bs-pagination-focus-color: #163063;
  --bs-pagination-focus-bg: #eff2f7;
  --bs-pagination-focus-box-shadow: 0 0 0 0.15rem rgba(36, 78, 162, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #244EA2;
  --bs-pagination-active-border-color: #244EA2;
  --bs-pagination-disabled-color: #ced4da;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #ced4da;
  display: flex;
  padding-left: 0;
  list-style: none; }

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .page-link {
      transition: none; } }
  .page-link:hover {
    z-index: 2;
    color: var(--bs-pagination-hover-color);
    text-decoration: none;
    background-color: var(--bs-pagination-hover-bg);
    border-color: var(--bs-pagination-hover-border-color); }
  .page-link:focus {
    z-index: 3;
    color: var(--bs-pagination-focus-color);
    background-color: var(--bs-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--bs-pagination-focus-box-shadow); }
  .page-link.active,
  .active > .page-link {
    z-index: 3;
    color: var(--bs-pagination-active-color);
    background-color: var(--bs-pagination-active-bg);
    border-color: var(--bs-pagination-active-border-color); }
  .page-link.disabled,
  .disabled > .page-link {
    color: var(--bs-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--bs-pagination-disabled-bg);
    border-color: var(--bs-pagination-disabled-border-color); }

.page-item:not(:first-child) .page-link {
  margin-left: -1px; }

.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius); }

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.125rem;
  --bs-pagination-border-radius: 0.4rem; }

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.75rem;
  --bs-pagination-border-radius: 0.2rem; }

.badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 75%;
  --bs-badge-font-weight: 500;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius); }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius); }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color); }

.alert-dismissible {
  padding-right: 3.75rem; }
  .alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 0.9375rem 1.25rem; }

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis); }

.alert-primary-dark {
  --bs-alert-color: var(--bs-primary-dark-text-emphasis);
  --bs-alert-bg: var(--bs-primary-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-dark-border-subtle);
  --bs-alert-link-color: var(--bs-primary-dark-text-emphasis); }

.alert-gray-secundary {
  --bs-alert-color: var(--bs-gray-secundary-text-emphasis);
  --bs-alert-bg: var(--bs-gray-secundary-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-secundary-border-subtle);
  --bs-alert-link-color: var(--bs-gray-secundary-text-emphasis); }

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis); }

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis); }

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis); }

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis); }

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis); }

.alert-pink {
  --bs-alert-color: var(--bs-pink-text-emphasis);
  --bs-alert-bg: var(--bs-pink-bg-subtle);
  --bs-alert-border-color: var(--bs-pink-border-subtle);
  --bs-alert-link-color: var(--bs-pink-text-emphasis); }

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis); }

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis); }

.alert-dark-gray-primary {
  --bs-alert-color: var(--bs-dark-gray-primary-text-emphasis);
  --bs-alert-bg: var(--bs-dark-gray-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-gray-primary-border-subtle);
  --bs-alert-link-color: var(--bs-dark-gray-primary-text-emphasis); }

.alert-light-gray-05 {
  --bs-alert-color: var(--bs-light-gray-05-text-emphasis);
  --bs-alert-bg: var(--bs-light-gray-05-bg-subtle);
  --bs-alert-border-color: var(--bs-light-gray-05-border-subtle);
  --bs-alert-link-color: var(--bs-light-gray-05-text-emphasis); }

.alert-light-gray-03 {
  --bs-alert-color: var(--bs-light-gray-03-text-emphasis);
  --bs-alert-bg: var(--bs-light-gray-03-bg-subtle);
  --bs-alert-border-color: var(--bs-light-gray-03-border-subtle);
  --bs-alert-link-color: var(--bs-light-gray-03-text-emphasis); }

.alert-light_gray_04 {
  --bs-alert-color: var(--bs-light_gray_04-text-emphasis);
  --bs-alert-bg: var(--bs-light_gray_04-bg-subtle);
  --bs-alert-border-color: var(--bs-light_gray_04-border-subtle);
  --bs-alert-link-color: var(--bs-light_gray_04-text-emphasis); }

.alert-light-gray-06 {
  --bs-alert-color: var(--bs-light-gray-06-text-emphasis);
  --bs-alert-bg: var(--bs-light-gray-06-bg-subtle);
  --bs-alert-border-color: var(--bs-light-gray-06-border-subtle);
  --bs-alert-link-color: var(--bs-light-gray-06-text-emphasis); }

.alert-light_blue_04 {
  --bs-alert-color: var(--bs-light_blue_04-text-emphasis);
  --bs-alert-bg: var(--bs-light_blue_04-bg-subtle);
  --bs-alert-border-color: var(--bs-light_blue_04-border-subtle);
  --bs-alert-link-color: var(--bs-light_blue_04-text-emphasis); }

.alert-light-blue-01 {
  --bs-alert-color: var(--bs-light-blue-01-text-emphasis);
  --bs-alert-bg: var(--bs-light-blue-01-bg-subtle);
  --bs-alert-border-color: var(--bs-light-blue-01-border-subtle);
  --bs-alert-link-color: var(--bs-light-blue-01-text-emphasis); }

.alert-light-blue-11 {
  --bs-alert-color: var(--bs-light-blue-11-text-emphasis);
  --bs-alert-bg: var(--bs-light-blue-11-bg-subtle);
  --bs-alert-border-color: var(--bs-light-blue-11-border-subtle);
  --bs-alert-link-color: var(--bs-light-blue-11-text-emphasis); }

.alert-light-blue-06 {
  --bs-alert-color: var(--bs-light-blue-06-text-emphasis);
  --bs-alert-bg: var(--bs-light-blue-06-bg-subtle);
  --bs-alert-border-color: var(--bs-light-blue-06-border-subtle);
  --bs-alert-link-color: var(--bs-light-blue-06-text-emphasis); }

.alert-light-blue-08 {
  --bs-alert-color: var(--bs-light-blue-08-text-emphasis);
  --bs-alert-bg: var(--bs-light-blue-08-bg-subtle);
  --bs-alert-border-color: var(--bs-light-blue-08-border-subtle);
  --bs-alert-link-color: var(--bs-light-blue-08-text-emphasis); }

.alert-light-blue-13 {
  --bs-alert-color: var(--bs-light-blue-13-text-emphasis);
  --bs-alert-bg: var(--bs-light-blue-13-bg-subtle);
  --bs-alert-border-color: var(--bs-light-blue-13-border-subtle);
  --bs-alert-link-color: var(--bs-light-blue-13-text-emphasis); }

.alert-light-blue-14 {
  --bs-alert-color: var(--bs-light-blue-14-text-emphasis);
  --bs-alert-bg: var(--bs-light-blue-14-bg-subtle);
  --bs-alert-border-color: var(--bs-light-blue-14-border-subtle);
  --bs-alert-link-color: var(--bs-light-blue-14-text-emphasis); }

.alert-color-azul1 {
  --bs-alert-color: var(--bs-color-azul1-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul1-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul1-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul1-text-emphasis); }

.alert-color-azul2 {
  --bs-alert-color: var(--bs-color-azul2-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul2-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul2-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul2-text-emphasis); }

.alert-color-azul2-hover {
  --bs-alert-color: var(--bs-color-azul2-hover-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul2-hover-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul2-hover-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul2-hover-text-emphasis); }

.alert-color-azul3 {
  --bs-alert-color: var(--bs-color-azul3-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul3-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul3-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul3-text-emphasis); }

.alert-color-azul4 {
  --bs-alert-color: var(--bs-color-azul4-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul4-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul4-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul4-text-emphasis); }

.alert-color-azul5 {
  --bs-alert-color: var(--bs-color-azul5-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul5-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul5-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul5-text-emphasis); }

.alert-color-azul6 {
  --bs-alert-color: var(--bs-color-azul6-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul6-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul6-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul6-text-emphasis); }

.alert-color-azul7 {
  --bs-alert-color: var(--bs-color-azul7-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul7-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul7-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul7-text-emphasis); }

.alert-color-azul8 {
  --bs-alert-color: var(--bs-color-azul8-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul8-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul8-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul8-text-emphasis); }

.alert-color-azul9 {
  --bs-alert-color: var(--bs-color-azul9-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul9-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul9-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul9-text-emphasis); }

.alert-color-azul10 {
  --bs-alert-color: var(--bs-color-azul10-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul10-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul10-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul10-text-emphasis); }

.alert-color-azul11 {
  --bs-alert-color: var(--bs-color-azul11-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul11-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul11-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul11-text-emphasis); }

.alert-color-azul410 {
  --bs-alert-color: var(--bs-color-azul410-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul410-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul410-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul410-text-emphasis); }

.alert-color-azul130 {
  --bs-alert-color: var(--bs-color-azul130-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul130-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul130-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul130-text-emphasis); }

.alert-color-azul405 {
  --bs-alert-color: var(--bs-color-azul405-text-emphasis);
  --bs-alert-bg: var(--bs-color-azul405-bg-subtle);
  --bs-alert-border-color: var(--bs-color-azul405-border-subtle);
  --bs-alert-link-color: var(--bs-color-azul405-text-emphasis); }

.alert-color-branco2 {
  --bs-alert-color: var(--bs-color-branco2-text-emphasis);
  --bs-alert-bg: var(--bs-color-branco2-bg-subtle);
  --bs-alert-border-color: var(--bs-color-branco2-border-subtle);
  --bs-alert-link-color: var(--bs-color-branco2-text-emphasis); }

.alert-color-branco3 {
  --bs-alert-color: var(--bs-color-branco3-text-emphasis);
  --bs-alert-bg: var(--bs-color-branco3-bg-subtle);
  --bs-alert-border-color: var(--bs-color-branco3-border-subtle);
  --bs-alert-link-color: var(--bs-color-branco3-text-emphasis); }

.alert-color-cinza1 {
  --bs-alert-color: var(--bs-color-cinza1-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza1-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza1-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza1-text-emphasis); }

.alert-color-cinza2 {
  --bs-alert-color: var(--bs-color-cinza2-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza2-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza2-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza2-text-emphasis); }

.alert-color-cinza2-5 {
  --bs-alert-color: var(--bs-color-cinza2-5-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza2-5-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza2-5-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza2-5-text-emphasis); }

.alert-color-cinza3 {
  --bs-alert-color: var(--bs-color-cinza3-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza3-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza3-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza3-text-emphasis); }

.alert-color-cinza4 {
  --bs-alert-color: var(--bs-color-cinza4-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza4-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza4-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza4-text-emphasis); }

.alert-color-cinza5 {
  --bs-alert-color: var(--bs-color-cinza5-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza5-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza5-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza5-text-emphasis); }

.alert-color-cinza6 {
  --bs-alert-color: var(--bs-color-cinza6-text-emphasis);
  --bs-alert-bg: var(--bs-color-cinza6-bg-subtle);
  --bs-alert-border-color: var(--bs-color-cinza6-border-subtle);
  --bs-alert-link-color: var(--bs-color-cinza6-text-emphasis); }

.alert-color-vermelho1 {
  --bs-alert-color: var(--bs-color-vermelho1-text-emphasis);
  --bs-alert-bg: var(--bs-color-vermelho1-bg-subtle);
  --bs-alert-border-color: var(--bs-color-vermelho1-border-subtle);
  --bs-alert-link-color: var(--bs-color-vermelho1-text-emphasis); }

.alert-color-vermelho2 {
  --bs-alert-color: var(--bs-color-vermelho2-text-emphasis);
  --bs-alert-bg: var(--bs-color-vermelho2-bg-subtle);
  --bs-alert-border-color: var(--bs-color-vermelho2-border-subtle);
  --bs-alert-link-color: var(--bs-color-vermelho2-text-emphasis); }

.alert-color-vermelho3 {
  --bs-alert-color: var(--bs-color-vermelho3-text-emphasis);
  --bs-alert-bg: var(--bs-color-vermelho3-bg-subtle);
  --bs-alert-border-color: var(--bs-color-vermelho3-border-subtle);
  --bs-alert-link-color: var(--bs-color-vermelho3-text-emphasis); }

.alert-color-verde1 {
  --bs-alert-color: var(--bs-color-verde1-text-emphasis);
  --bs-alert-bg: var(--bs-color-verde1-bg-subtle);
  --bs-alert-border-color: var(--bs-color-verde1-border-subtle);
  --bs-alert-link-color: var(--bs-color-verde1-text-emphasis); }

.alert-color-verde2 {
  --bs-alert-color: var(--bs-color-verde2-text-emphasis);
  --bs-alert-bg: var(--bs-color-verde2-bg-subtle);
  --bs-alert-border-color: var(--bs-color-verde2-border-subtle);
  --bs-alert-link-color: var(--bs-color-verde2-text-emphasis); }

.alert-color-verde3 {
  --bs-alert-color: var(--bs-color-verde3-text-emphasis);
  --bs-alert-bg: var(--bs-color-verde3-bg-subtle);
  --bs-alert-border-color: var(--bs-color-verde3-border-subtle);
  --bs-alert-link-color: var(--bs-color-verde3-text-emphasis); }

.alert-color-amarelo1 {
  --bs-alert-color: var(--bs-color-amarelo1-text-emphasis);
  --bs-alert-bg: var(--bs-color-amarelo1-bg-subtle);
  --bs-alert-border-color: var(--bs-color-amarelo1-border-subtle);
  --bs-alert-link-color: var(--bs-color-amarelo1-text-emphasis); }

.alert-color-amarelo2 {
  --bs-alert-color: var(--bs-color-amarelo2-text-emphasis);
  --bs-alert-bg: var(--bs-color-amarelo2-bg-subtle);
  --bs-alert-border-color: var(--bs-color-amarelo2-border-subtle);
  --bs-alert-link-color: var(--bs-color-amarelo2-text-emphasis); }

.alert-color-amarelo3 {
  --bs-alert-color: var(--bs-color-amarelo3-text-emphasis);
  --bs-alert-bg: var(--bs-color-amarelo3-bg-subtle);
  --bs-alert-border-color: var(--bs-color-amarelo3-border-subtle);
  --bs-alert-link-color: var(--bs-color-amarelo3-text-emphasis); }

.alert-color-laranja1 {
  --bs-alert-color: var(--bs-color-laranja1-text-emphasis);
  --bs-alert-bg: var(--bs-color-laranja1-bg-subtle);
  --bs-alert-border-color: var(--bs-color-laranja1-border-subtle);
  --bs-alert-link-color: var(--bs-color-laranja1-text-emphasis); }

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height); } }

.progress,
.progress-stacked {
  --bs-progress-height: 0.625rem;
  --bs-progress-font-size: 0.65625rem;
  --bs-progress-bg: #f1f5f7;
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #244EA2;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition); }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height); }

.progress-stacked > .progress {
  overflow: visible; }

.progress-stacked > .progress > .progress-bar {
  width: 100%; }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: #eff2f7;
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1.25rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: #505d69;
  --bs-list-group-action-hover-color: #505d69;
  --bs-list-group-action-hover-bg: #f8f9fa;
  --bs-list-group-action-active-color: #505d69;
  --bs-list-group-action-active-bg: #eff2f7;
  --bs-list-group-disabled-color: #74788d;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #244EA2;
  --bs-list-group-active-border-color: #244EA2;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius); }

.list-group-numbered {
  list-style-type: none;
  counter-reset: section; }
  .list-group-numbered > .list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section; }

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: var(--bs-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--bs-list-group-disabled-bg); }
  .list-group-item.active {
    z-index: 2;
    color: var(--bs-list-group-active-color);
    background-color: var(--bs-list-group-active-bg);
    border-color: var(--bs-list-group-active-border-color); }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: calc(-1 * var(--bs-list-group-border-width));
      border-top-width: var(--bs-list-group-border-width); }

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit; }
  .list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--bs-list-group-action-hover-bg); }
  .list-group-item-action:not(.active):active {
    color: var(--bs-list-group-action-active-color);
    background-color: var(--bs-list-group-action-active-bg); }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: calc(-1 * var(--bs-list-group-border-width));
      border-left-width: var(--bs-list-group-border-width); }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 var(--bs-list-group-border-width); }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis); }

.list-group-item-primary-dark {
  --bs-list-group-color: var(--bs-primary-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-dark-text-emphasis); }

.list-group-item-gray-secundary {
  --bs-list-group-color: var(--bs-gray-secundary-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-secundary-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-secundary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-secundary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-secundary-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-secundary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-secundary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-secundary-text-emphasis); }

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis); }

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis); }

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis); }

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis); }

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis); }

.list-group-item-pink {
  --bs-list-group-color: var(--bs-pink-text-emphasis);
  --bs-list-group-bg: var(--bs-pink-bg-subtle);
  --bs-list-group-border-color: var(--bs-pink-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);
  --bs-list-group-active-color: var(--bs-pink-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis); }

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis); }

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis); }

.list-group-item-dark-gray-primary {
  --bs-list-group-color: var(--bs-dark-gray-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-gray-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-gray-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-gray-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-gray-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-gray-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-gray-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-gray-primary-text-emphasis); }

.list-group-item-light-gray-05 {
  --bs-list-group-color: var(--bs-light-gray-05-text-emphasis);
  --bs-list-group-bg: var(--bs-light-gray-05-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-gray-05-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-gray-05-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-gray-05-border-subtle);
  --bs-list-group-active-color: var(--bs-light-gray-05-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-gray-05-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-gray-05-text-emphasis); }

.list-group-item-light-gray-03 {
  --bs-list-group-color: var(--bs-light-gray-03-text-emphasis);
  --bs-list-group-bg: var(--bs-light-gray-03-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-gray-03-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-gray-03-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-gray-03-border-subtle);
  --bs-list-group-active-color: var(--bs-light-gray-03-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-gray-03-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-gray-03-text-emphasis); }

.list-group-item-light_gray_04 {
  --bs-list-group-color: var(--bs-light_gray_04-text-emphasis);
  --bs-list-group-bg: var(--bs-light_gray_04-bg-subtle);
  --bs-list-group-border-color: var(--bs-light_gray_04-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light_gray_04-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light_gray_04-border-subtle);
  --bs-list-group-active-color: var(--bs-light_gray_04-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light_gray_04-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light_gray_04-text-emphasis); }

.list-group-item-light-gray-06 {
  --bs-list-group-color: var(--bs-light-gray-06-text-emphasis);
  --bs-list-group-bg: var(--bs-light-gray-06-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-gray-06-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-gray-06-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-gray-06-border-subtle);
  --bs-list-group-active-color: var(--bs-light-gray-06-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-gray-06-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-gray-06-text-emphasis); }

.list-group-item-light_blue_04 {
  --bs-list-group-color: var(--bs-light_blue_04-text-emphasis);
  --bs-list-group-bg: var(--bs-light_blue_04-bg-subtle);
  --bs-list-group-border-color: var(--bs-light_blue_04-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light_blue_04-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light_blue_04-border-subtle);
  --bs-list-group-active-color: var(--bs-light_blue_04-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light_blue_04-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light_blue_04-text-emphasis); }

.list-group-item-light-blue-01 {
  --bs-list-group-color: var(--bs-light-blue-01-text-emphasis);
  --bs-list-group-bg: var(--bs-light-blue-01-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-blue-01-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-blue-01-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-blue-01-border-subtle);
  --bs-list-group-active-color: var(--bs-light-blue-01-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-blue-01-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-blue-01-text-emphasis); }

.list-group-item-light-blue-11 {
  --bs-list-group-color: var(--bs-light-blue-11-text-emphasis);
  --bs-list-group-bg: var(--bs-light-blue-11-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-blue-11-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-blue-11-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-blue-11-border-subtle);
  --bs-list-group-active-color: var(--bs-light-blue-11-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-blue-11-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-blue-11-text-emphasis); }

.list-group-item-light-blue-06 {
  --bs-list-group-color: var(--bs-light-blue-06-text-emphasis);
  --bs-list-group-bg: var(--bs-light-blue-06-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-blue-06-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-blue-06-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-blue-06-border-subtle);
  --bs-list-group-active-color: var(--bs-light-blue-06-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-blue-06-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-blue-06-text-emphasis); }

.list-group-item-light-blue-08 {
  --bs-list-group-color: var(--bs-light-blue-08-text-emphasis);
  --bs-list-group-bg: var(--bs-light-blue-08-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-blue-08-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-blue-08-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-blue-08-border-subtle);
  --bs-list-group-active-color: var(--bs-light-blue-08-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-blue-08-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-blue-08-text-emphasis); }

.list-group-item-light-blue-13 {
  --bs-list-group-color: var(--bs-light-blue-13-text-emphasis);
  --bs-list-group-bg: var(--bs-light-blue-13-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-blue-13-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-blue-13-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-blue-13-border-subtle);
  --bs-list-group-active-color: var(--bs-light-blue-13-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-blue-13-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-blue-13-text-emphasis); }

.list-group-item-light-blue-14 {
  --bs-list-group-color: var(--bs-light-blue-14-text-emphasis);
  --bs-list-group-bg: var(--bs-light-blue-14-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-blue-14-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-blue-14-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-blue-14-border-subtle);
  --bs-list-group-active-color: var(--bs-light-blue-14-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-blue-14-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-blue-14-text-emphasis); }

.list-group-item-color-azul1 {
  --bs-list-group-color: var(--bs-color-azul1-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul1-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul1-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul1-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul1-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul1-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul1-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul1-text-emphasis); }

.list-group-item-color-azul2 {
  --bs-list-group-color: var(--bs-color-azul2-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul2-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul2-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul2-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul2-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul2-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul2-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul2-text-emphasis); }

.list-group-item-color-azul2-hover {
  --bs-list-group-color: var(--bs-color-azul2-hover-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul2-hover-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul2-hover-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul2-hover-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul2-hover-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul2-hover-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul2-hover-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul2-hover-text-emphasis); }

.list-group-item-color-azul3 {
  --bs-list-group-color: var(--bs-color-azul3-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul3-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul3-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul3-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul3-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul3-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul3-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul3-text-emphasis); }

.list-group-item-color-azul4 {
  --bs-list-group-color: var(--bs-color-azul4-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul4-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul4-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul4-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul4-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul4-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul4-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul4-text-emphasis); }

.list-group-item-color-azul5 {
  --bs-list-group-color: var(--bs-color-azul5-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul5-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul5-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul5-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul5-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul5-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul5-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul5-text-emphasis); }

.list-group-item-color-azul6 {
  --bs-list-group-color: var(--bs-color-azul6-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul6-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul6-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul6-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul6-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul6-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul6-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul6-text-emphasis); }

.list-group-item-color-azul7 {
  --bs-list-group-color: var(--bs-color-azul7-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul7-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul7-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul7-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul7-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul7-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul7-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul7-text-emphasis); }

.list-group-item-color-azul8 {
  --bs-list-group-color: var(--bs-color-azul8-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul8-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul8-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul8-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul8-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul8-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul8-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul8-text-emphasis); }

.list-group-item-color-azul9 {
  --bs-list-group-color: var(--bs-color-azul9-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul9-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul9-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul9-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul9-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul9-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul9-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul9-text-emphasis); }

.list-group-item-color-azul10 {
  --bs-list-group-color: var(--bs-color-azul10-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul10-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul10-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul10-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul10-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul10-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul10-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul10-text-emphasis); }

.list-group-item-color-azul11 {
  --bs-list-group-color: var(--bs-color-azul11-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul11-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul11-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul11-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul11-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul11-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul11-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul11-text-emphasis); }

.list-group-item-color-azul410 {
  --bs-list-group-color: var(--bs-color-azul410-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul410-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul410-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul410-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul410-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul410-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul410-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul410-text-emphasis); }

.list-group-item-color-azul130 {
  --bs-list-group-color: var(--bs-color-azul130-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul130-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul130-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul130-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul130-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul130-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul130-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul130-text-emphasis); }

.list-group-item-color-azul405 {
  --bs-list-group-color: var(--bs-color-azul405-text-emphasis);
  --bs-list-group-bg: var(--bs-color-azul405-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-azul405-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-azul405-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-azul405-border-subtle);
  --bs-list-group-active-color: var(--bs-color-azul405-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-azul405-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-azul405-text-emphasis); }

.list-group-item-color-branco2 {
  --bs-list-group-color: var(--bs-color-branco2-text-emphasis);
  --bs-list-group-bg: var(--bs-color-branco2-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-branco2-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-branco2-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-branco2-border-subtle);
  --bs-list-group-active-color: var(--bs-color-branco2-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-branco2-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-branco2-text-emphasis); }

.list-group-item-color-branco3 {
  --bs-list-group-color: var(--bs-color-branco3-text-emphasis);
  --bs-list-group-bg: var(--bs-color-branco3-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-branco3-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-branco3-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-branco3-border-subtle);
  --bs-list-group-active-color: var(--bs-color-branco3-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-branco3-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-branco3-text-emphasis); }

.list-group-item-color-cinza1 {
  --bs-list-group-color: var(--bs-color-cinza1-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza1-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza1-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza1-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza1-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza1-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza1-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza1-text-emphasis); }

.list-group-item-color-cinza2 {
  --bs-list-group-color: var(--bs-color-cinza2-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza2-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza2-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza2-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza2-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza2-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza2-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza2-text-emphasis); }

.list-group-item-color-cinza2-5 {
  --bs-list-group-color: var(--bs-color-cinza2-5-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza2-5-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza2-5-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza2-5-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza2-5-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza2-5-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza2-5-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza2-5-text-emphasis); }

.list-group-item-color-cinza3 {
  --bs-list-group-color: var(--bs-color-cinza3-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza3-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza3-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza3-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza3-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza3-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza3-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza3-text-emphasis); }

.list-group-item-color-cinza4 {
  --bs-list-group-color: var(--bs-color-cinza4-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza4-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza4-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza4-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza4-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza4-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza4-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza4-text-emphasis); }

.list-group-item-color-cinza5 {
  --bs-list-group-color: var(--bs-color-cinza5-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza5-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza5-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza5-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza5-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza5-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza5-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza5-text-emphasis); }

.list-group-item-color-cinza6 {
  --bs-list-group-color: var(--bs-color-cinza6-text-emphasis);
  --bs-list-group-bg: var(--bs-color-cinza6-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-cinza6-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-cinza6-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-cinza6-border-subtle);
  --bs-list-group-active-color: var(--bs-color-cinza6-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-cinza6-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-cinza6-text-emphasis); }

.list-group-item-color-vermelho1 {
  --bs-list-group-color: var(--bs-color-vermelho1-text-emphasis);
  --bs-list-group-bg: var(--bs-color-vermelho1-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-vermelho1-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-vermelho1-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-vermelho1-border-subtle);
  --bs-list-group-active-color: var(--bs-color-vermelho1-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-vermelho1-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-vermelho1-text-emphasis); }

.list-group-item-color-vermelho2 {
  --bs-list-group-color: var(--bs-color-vermelho2-text-emphasis);
  --bs-list-group-bg: var(--bs-color-vermelho2-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-vermelho2-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-vermelho2-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-vermelho2-border-subtle);
  --bs-list-group-active-color: var(--bs-color-vermelho2-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-vermelho2-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-vermelho2-text-emphasis); }

.list-group-item-color-vermelho3 {
  --bs-list-group-color: var(--bs-color-vermelho3-text-emphasis);
  --bs-list-group-bg: var(--bs-color-vermelho3-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-vermelho3-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-vermelho3-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-vermelho3-border-subtle);
  --bs-list-group-active-color: var(--bs-color-vermelho3-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-vermelho3-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-vermelho3-text-emphasis); }

.list-group-item-color-verde1 {
  --bs-list-group-color: var(--bs-color-verde1-text-emphasis);
  --bs-list-group-bg: var(--bs-color-verde1-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-verde1-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-verde1-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-verde1-border-subtle);
  --bs-list-group-active-color: var(--bs-color-verde1-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-verde1-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-verde1-text-emphasis); }

.list-group-item-color-verde2 {
  --bs-list-group-color: var(--bs-color-verde2-text-emphasis);
  --bs-list-group-bg: var(--bs-color-verde2-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-verde2-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-verde2-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-verde2-border-subtle);
  --bs-list-group-active-color: var(--bs-color-verde2-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-verde2-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-verde2-text-emphasis); }

.list-group-item-color-verde3 {
  --bs-list-group-color: var(--bs-color-verde3-text-emphasis);
  --bs-list-group-bg: var(--bs-color-verde3-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-verde3-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-verde3-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-verde3-border-subtle);
  --bs-list-group-active-color: var(--bs-color-verde3-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-verde3-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-verde3-text-emphasis); }

.list-group-item-color-amarelo1 {
  --bs-list-group-color: var(--bs-color-amarelo1-text-emphasis);
  --bs-list-group-bg: var(--bs-color-amarelo1-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-amarelo1-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-amarelo1-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-amarelo1-border-subtle);
  --bs-list-group-active-color: var(--bs-color-amarelo1-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-amarelo1-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-amarelo1-text-emphasis); }

.list-group-item-color-amarelo2 {
  --bs-list-group-color: var(--bs-color-amarelo2-text-emphasis);
  --bs-list-group-bg: var(--bs-color-amarelo2-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-amarelo2-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-amarelo2-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-amarelo2-border-subtle);
  --bs-list-group-active-color: var(--bs-color-amarelo2-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-amarelo2-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-amarelo2-text-emphasis); }

.list-group-item-color-amarelo3 {
  --bs-list-group-color: var(--bs-color-amarelo3-text-emphasis);
  --bs-list-group-bg: var(--bs-color-amarelo3-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-amarelo3-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-amarelo3-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-amarelo3-border-subtle);
  --bs-list-group-active-color: var(--bs-color-amarelo3-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-amarelo3-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-amarelo3-text-emphasis); }

.list-group-item-color-laranja1 {
  --bs-list-group-color: var(--bs-color-laranja1-text-emphasis);
  --bs-list-group-bg: var(--bs-color-laranja1-bg-subtle);
  --bs-list-group-border-color: var(--bs-color-laranja1-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-color-laranja1-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-color-laranja1-border-subtle);
  --bs-list-group-active-color: var(--bs-color-laranja1-bg-subtle);
  --bs-list-group-active-bg: var(--bs-color-laranja1-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-color-laranja1-text-emphasis); }

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity); }
  .btn-close:hover {
    color: var(--bs-btn-close-color);
    text-decoration: none;
    opacity: var(--bs-btn-close-hover-opacity); }
  .btn-close:focus {
    outline: 0;
    box-shadow: var(--bs-btn-close-focus-shadow);
    opacity: var(--bs-btn-close-focus-opacity); }
  .btn-close:disabled, .btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: var(--bs-btn-close-disabled-opacity); }

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%); }

:root,
[data-bs-theme="light"] {
  --bs-btn-close-filter: ; }

[data-bs-theme="dark"] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%); }

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.25rem;
  --bs-toast-spacing: 24px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: rgba(0, 0, 0, 0.1);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  --bs-toast-header-color: #74788d;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius); }
  .toast.showing {
    opacity: 0; }
  .toast:not(.show) {
    display: none; }

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none; }
  .toast-container > :not(:last-child) {
    margin-bottom: var(--bs-toast-spacing); }

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width)); }
  .toast-header .btn-close {
    margin-right: calc(-.5 * var(--bs-toast-padding-x));
    margin-left: var(--bs-toast-padding-x); }

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word; }

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: #fff;
  --bs-modal-border-color: #f1f5f7;
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.4rem;
  --bs-modal-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  --bs-modal-inner-border-radius: calc(0.4rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: #eff2f7;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #eff2f7;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transform: translate(0, -50px);
    transition: transform 0.3s ease-out; }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2); }
  .modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0; }

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg); }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: var(--bs-backdrop-opacity); }

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius); }
  .modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-modal-header-padding-y));
    margin-right: calc(-.5 * var(--bs-modal-header-padding-x));
    margin-bottom: calc(-.5 * var(--bs-modal-header-padding-y));
    margin-left: auto; }

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height); }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding); }

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius); }
  .modal-footer > * {
    margin: calc(var(--bs-modal-footer-gap) * .5); }

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08); }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto; }
  .modal-sm {
    --bs-modal-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px; } }

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0; }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0; }
  .modal-fullscreen .modal-header,
  .modal-fullscreen .modal-footer {
    border-radius: 0; }
  .modal-fullscreen .modal-body {
    overflow-y: auto; }

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-sm-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-md-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-lg-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xxl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-body {
      overflow-y: auto; } }

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.7rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.75rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.25rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: var(--bs-tooltip-opacity); }
  .tooltip .tooltip-arrow {
    display: block;
    width: var(--bs-tooltip-arrow-width);
    height: var(--bs-tooltip-arrow-height); }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height)); }
  .bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-top-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-right-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height)); }
  .bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-bottom-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-left-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius); }

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.75rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: #eff2f7;
  --bs-popover-border-radius: 0.4rem;
  --bs-popover-inner-border-radius: calc(0.4rem - 1px);
  --bs-popover-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
  --bs-popover-header-padding-x: 0.75rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: #f7f7f7;
  --bs-popover-body-padding-x: 0.75rem;
  --bs-popover-body-padding-y: 0.5rem;
  --bs-popover-body-color: #505d69;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius); }
  .popover .popover-arrow {
    display: block;
    width: var(--bs-popover-arrow-width);
    height: var(--bs-popover-arrow-height); }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;
      border-width: 0; }

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
    bottom: 0;
    border-top-color: var(--bs-popover-arrow-border); }
  .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    bottom: var(--bs-popover-border-width);
    border-top-color: var(--bs-popover-bg); }

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
    left: 0;
    border-right-color: var(--bs-popover-arrow-border); }
  .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    left: var(--bs-popover-border-width);
    border-right-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
    top: 0;
    border-bottom-color: var(--bs-popover-arrow-border); }
  .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    top: var(--bs-popover-border-width);
    border-bottom-color: var(--bs-popover-bg); }

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg); }

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
    right: 0;
    border-left-color: var(--bs-popover-arrow-border); }
  .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    right: var(--bs-popover-border-width);
    border-left-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color); }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/; }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/; }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%; }
  .carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: var(--bs-carousel-indicator-active-bg);
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators [data-bs-target] {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center; }

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100); }

:root,
[data-bs-theme="light"] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ; }

[data-bs-theme="dark"] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100); }

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name); }

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */; } }

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent; }

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0; }

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s; } }

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: #f1f5f7;
  --bs-offcanvas-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5; }

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
      transition: none; } }

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-sm.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-sm.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-sm.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
      transform: none; }
    .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
      visibility: visible; } }

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-sm .offcanvas-header {
      display: none; }
    .offcanvas-sm .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
      transition: none; } }

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-md.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-md.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-md.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
      transform: none; }
    .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
      visibility: visible; } }

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-md .offcanvas-header {
      display: none; }
    .offcanvas-md .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
      transition: none; } }

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-lg.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-lg.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-lg.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
      transform: none; }
    .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
      visibility: visible; } }

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-lg .offcanvas-header {
      display: none; }
    .offcanvas-lg .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
      transition: none; } }

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
      visibility: visible; } }

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xl .offcanvas-header {
      display: none; }
    .offcanvas-xl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
      transition: none; } }

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xxl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xxl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xxl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
      visibility: visible; } }

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xxl .offcanvas-header {
      display: none; }
    .offcanvas-xxl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition); }
  @media (prefers-reduced-motion: reduce) {
    .offcanvas {
      transition: none; } }
  .offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%); }
  .offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%); }
  .offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%); }
  .offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%); }
  .offcanvas.showing, .offcanvas.show:not(.hiding) {
    transform: none; }
  .offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
    visibility: visible; }

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .offcanvas-backdrop.fade {
    opacity: 0; }
  .offcanvas-backdrop.show {
    opacity: 0.5; }

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x); }
  .offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-right: calc(-.5 * var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-left: auto; }

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height); }

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto; }

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5; }
  .placeholder.btn::before {
    display: inline-block;
    content: ""; }

.placeholder-xs {
  min-height: .6em; }

.placeholder-sm {
  min-height: .8em; }

.placeholder-lg {
  min-height: 1.2em; }

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite; }

@keyframes placeholder-glow {
  50% {
    opacity: 0.2; } }

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite; }

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%; } }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-primary-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-dark-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-gray-secundary {
  color: #fff !important;
  background-color: RGBA(var(--bs-gray-secundary-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-pink {
  color: #fff !important;
  background-color: RGBA(var(--bs-pink-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-dark-gray-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-gray-primary-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-gray-05 {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-gray-05-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-gray-03 {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-gray-03-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light_gray_04 {
  color: #000 !important;
  background-color: RGBA(var(--bs-light_gray_04-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-gray-06 {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-gray-06-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light_blue_04 {
  color: #fff !important;
  background-color: RGBA(var(--bs-light_blue_04-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-blue-01 {
  color: #fff !important;
  background-color: RGBA(var(--bs-light-blue-01-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-blue-11 {
  color: #fff !important;
  background-color: RGBA(var(--bs-light-blue-11-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-blue-06 {
  color: #fff !important;
  background-color: RGBA(var(--bs-light-blue-06-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-blue-08 {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-blue-08-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-blue-13 {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-blue-13-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light-blue-14 {
  color: #fff !important;
  background-color: RGBA(var(--bs-light-blue-14-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul1 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul1-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul2 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul2-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul2-hover {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul2-hover-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul3 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul3-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul4 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul4-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul5 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul5-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul6 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul6-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul7 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul7-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul8 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul8-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul9 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul9-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul10 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-azul10-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul11 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-azul11-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul410 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-azul410-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul130 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-azul130-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-azul405 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-azul405-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-branco2 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-branco2-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-branco3 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-branco3-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza1 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-cinza1-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza2 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-cinza2-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza2-5 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-cinza2-5-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza3 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-cinza3-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza4 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-cinza4-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza5 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-cinza5-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-cinza6 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-cinza6-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-vermelho1 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-vermelho1-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-vermelho2 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-vermelho2-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-vermelho3 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-vermelho3-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-verde1 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-verde1-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-verde2 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-verde2-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-verde3 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-verde3-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-amarelo1 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-amarelo1-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-amarelo2 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-amarelo2-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-amarelo3 {
  color: #000 !important;
  background-color: RGBA(var(--bs-color-amarelo3-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-color-laranja1 {
  color: #fff !important;
  background-color: RGBA(var(--bs-color-laranja1-rgb), var(--bs-bg-opacity, 1)) !important; }

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-primary:hover, .link-primary:focus {
    color: RGBA(29, 62, 130, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(29, 62, 130, var(--bs-link-underline-opacity, 1)) !important; }

.link-primary-dark {
  color: RGBA(var(--bs-primary-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-dark-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-primary-dark:hover, .link-primary-dark:focus {
    color: RGBA(30, 45, 93, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(30, 45, 93, var(--bs-link-underline-opacity, 1)) !important; }

.link-gray-secundary {
  color: RGBA(var(--bs-gray-secundary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-secundary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-gray-secundary:hover, .link-gray-secundary:focus {
    color: RGBA(86, 86, 86, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(86, 86, 86, var(--bs-link-underline-opacity, 1)) !important; }

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-secondary:hover, .link-secondary:focus {
    color: RGBA(93, 96, 113, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(93, 96, 113, var(--bs-link-underline-opacity, 1)) !important; }

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-success:hover, .link-success:focus {
    color: RGBA(60, 145, 54, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(60, 145, 54, var(--bs-link-underline-opacity, 1)) !important; }

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-info:hover, .link-info:focus {
    color: RGBA(243, 243, 243, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(243, 243, 243, var(--bs-link-underline-opacity, 1)) !important; }

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-warning:hover, .link-warning:focus {
    color: RGBA(254, 216, 78, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(254, 216, 78, var(--bs-link-underline-opacity, 1)) !important; }

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-danger:hover, .link-danger:focus {
    color: RGBA(189, 27, 25, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(189, 27, 25, var(--bs-link-underline-opacity, 1)) !important; }

.link-pink {
  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-pink:hover, .link-pink:focus {
    color: RGBA(186, 50, 112, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(186, 50, 112, var(--bs-link-underline-opacity, 1)) !important; }

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light:hover, .link-light:focus {
    color: RGBA(242, 245, 249, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(242, 245, 249, var(--bs-link-underline-opacity, 1)) !important; }

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-dark:hover, .link-dark:focus {
    color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important; }

.link-dark-gray-primary {
  color: RGBA(var(--bs-dark-gray-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-gray-primary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-dark-gray-primary:hover, .link-dark-gray-primary:focus {
    color: RGBA(42, 42, 42, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(42, 42, 42, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-gray-05 {
  color: RGBA(var(--bs-light-gray-05-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-gray-05-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-gray-05:hover, .link-light-gray-05:focus {
    color: RGBA(225, 225, 225, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(225, 225, 225, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-gray-03 {
  color: RGBA(var(--bs-light-gray-03-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-gray-03-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-gray-03:hover, .link-light-gray-03:focus {
    color: RGBA(232, 232, 232, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(232, 232, 232, var(--bs-link-underline-opacity, 1)) !important; }

.link-light_gray_04 {
  color: RGBA(var(--bs-light_gray_04-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light_gray_04-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light_gray_04:hover, .link-light_gray_04:focus {
    color: RGBA(235, 235, 235, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(235, 235, 235, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-gray-06 {
  color: RGBA(var(--bs-light-gray-06-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-gray-06-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-gray-06:hover, .link-light-gray-06:focus {
    color: RGBA(215, 215, 215, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(215, 215, 215, var(--bs-link-underline-opacity, 1)) !important; }

.link-light_blue_04 {
  color: RGBA(var(--bs-light_blue_04-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light_blue_04-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light_blue_04:hover, .link-light_blue_04:focus {
    color: RGBA(0, 94, 130, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(0, 94, 130, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-blue-01 {
  color: RGBA(var(--bs-light-blue-01-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-blue-01-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-blue-01:hover, .link-light-blue-01:focus {
    color: RGBA(58, 114, 194, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(58, 114, 194, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-blue-11 {
  color: RGBA(var(--bs-light-blue-11-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-blue-11-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-blue-11:hover, .link-light-blue-11:focus {
    color: RGBA(71, 86, 130, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(71, 86, 130, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-blue-06 {
  color: RGBA(var(--bs-light-blue-06-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-blue-06-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-blue-06:hover, .link-light-blue-06:focus {
    color: RGBA(25, 130, 163, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(25, 130, 163, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-blue-08 {
  color: RGBA(var(--bs-light-blue-08-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-blue-08-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-blue-08:hover, .link-light-blue-08:focus {
    color: RGBA(222, 225, 232, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(222, 225, 232, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-blue-13 {
  color: RGBA(var(--bs-light-blue-13-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-blue-13-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-blue-13:hover, .link-light-blue-13:focus {
    color: RGBA(234, 236, 241, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(234, 236, 241, var(--bs-link-underline-opacity, 1)) !important; }

.link-light-blue-14 {
  color: RGBA(var(--bs-light-blue-14-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-blue-14-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light-blue-14:hover, .link-light-blue-14:focus {
    color: RGBA(122, 129, 150, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(122, 129, 150, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul1 {
  color: RGBA(var(--bs-color-azul1-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul1-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul1:hover, .link-color-azul1:focus {
    color: RGBA(12, 23, 53, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(12, 23, 53, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul2 {
  color: RGBA(var(--bs-color-azul2-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul2-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul2:hover, .link-color-azul2:focus {
    color: RGBA(30, 45, 93, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(30, 45, 93, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul2-hover {
  color: RGBA(var(--bs-color-azul2-hover-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul2-hover-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul2-hover:hover, .link-color-azul2-hover:focus {
    color: RGBA(43, 60, 112, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(43, 60, 112, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul3 {
  color: RGBA(var(--bs-color-azul3-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul3-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul3:hover, .link-color-azul3:focus {
    color: RGBA(29, 62, 130, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(29, 62, 130, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul4 {
  color: RGBA(var(--bs-color-azul4-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul4-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul4:hover, .link-color-azul4:focus {
    color: RGBA(58, 114, 194, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(58, 114, 194, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul5 {
  color: RGBA(var(--bs-color-azul5-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul5-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul5:hover, .link-color-azul5:focus {
    color: RGBA(104, 154, 199, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(104, 154, 199, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul6 {
  color: RGBA(var(--bs-color-azul6-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul6-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul6:hover, .link-color-azul6:focus {
    color: RGBA(0, 66, 82, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(0, 66, 82, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul7 {
  color: RGBA(var(--bs-color-azul7-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul7-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul7:hover, .link-color-azul7:focus {
    color: RGBA(0, 94, 130, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(0, 94, 130, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul8 {
  color: RGBA(var(--bs-color-azul8-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul8-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul8:hover, .link-color-azul8:focus {
    color: RGBA(25, 130, 163, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(25, 130, 163, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul9 {
  color: RGBA(var(--bs-color-azul9-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul9-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul9:hover, .link-color-azul9:focus {
    color: RGBA(100, 156, 176, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(100, 156, 176, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul10 {
  color: RGBA(var(--bs-color-azul10-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul10-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul10:hover, .link-color-azul10:focus {
    color: RGBA(177, 235, 235, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(177, 235, 235, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul11 {
  color: RGBA(var(--bs-color-azul11-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul11-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul11:hover, .link-color-azul11:focus {
    color: RGBA(222, 225, 232, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(222, 225, 232, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul410 {
  color: RGBA(var(--bs-color-azul410-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul410-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul410:hover, .link-color-azul410:focus {
    color: RGBA(205, 230, 255, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(205, 230, 255, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul130 {
  color: RGBA(var(--bs-color-azul130-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul130-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul130:hover, .link-color-azul130:focus {
    color: RGBA(85, 97, 125, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(85, 97, 125, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-azul405 {
  color: RGBA(var(--bs-color-azul405-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-azul405-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-azul405:hover, .link-color-azul405:focus {
    color: RGBA(234, 245, 255, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(234, 245, 255, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-branco2 {
  color: RGBA(var(--bs-color-branco2-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-branco2-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-branco2:hover, .link-color-branco2:focus {
    color: RGBA(247, 247, 247, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(247, 247, 247, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-branco3 {
  color: RGBA(var(--bs-color-branco3-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-branco3-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-branco3:hover, .link-color-branco3:focus {
    color: RGBA(243, 243, 243, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(243, 243, 243, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza1 {
  color: RGBA(var(--bs-color-cinza1-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza1-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza1:hover, .link-color-cinza1:focus {
    color: RGBA(232, 232, 232, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(232, 232, 232, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza2 {
  color: RGBA(var(--bs-color-cinza2-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza2-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza2:hover, .link-color-cinza2:focus {
    color: RGBA(225, 225, 225, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(225, 225, 225, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza2-5 {
  color: RGBA(var(--bs-color-cinza2-5-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza2-5-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza2-5:hover, .link-color-cinza2-5:focus {
    color: RGBA(215, 215, 215, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(215, 215, 215, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza3 {
  color: RGBA(var(--bs-color-cinza3-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza3-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza3:hover, .link-color-cinza3:focus {
    color: RGBA(134, 134, 134, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(134, 134, 134, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza4 {
  color: RGBA(var(--bs-color-cinza4-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza4-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza4:hover, .link-color-cinza4:focus {
    color: RGBA(86, 86, 86, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(86, 86, 86, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza5 {
  color: RGBA(var(--bs-color-cinza5-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza5-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza5:hover, .link-color-cinza5:focus {
    color: RGBA(42, 42, 42, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(42, 42, 42, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-cinza6 {
  color: RGBA(var(--bs-color-cinza6-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-cinza6-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-cinza6:hover, .link-color-cinza6:focus {
    color: RGBA(23, 23, 23, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(23, 23, 23, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-vermelho1 {
  color: RGBA(var(--bs-color-vermelho1-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-vermelho1-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-vermelho1:hover, .link-color-vermelho1:focus {
    color: RGBA(189, 27, 25, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(189, 27, 25, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-vermelho2 {
  color: RGBA(var(--bs-color-vermelho2-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-vermelho2-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-vermelho2:hover, .link-color-vermelho2:focus {
    color: RGBA(149, 4, 1, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(149, 4, 1, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-vermelho3 {
  color: RGBA(var(--bs-color-vermelho3-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-vermelho3-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-vermelho3:hover, .link-color-vermelho3:focus {
    color: RGBA(56, 8, 7, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(56, 8, 7, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-verde1 {
  color: RGBA(var(--bs-color-verde1-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-verde1-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-verde1:hover, .link-color-verde1:focus {
    color: RGBA(60, 145, 54, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(60, 145, 54, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-verde2 {
  color: RGBA(var(--bs-color-verde2-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-verde2-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-verde2:hover, .link-color-verde2:focus {
    color: RGBA(8, 95, 2, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(8, 95, 2, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-verde3 {
  color: RGBA(var(--bs-color-verde3-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-verde3-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-verde3:hover, .link-color-verde3:focus {
    color: RGBA(18, 43, 16, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(18, 43, 16, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-amarelo1 {
  color: RGBA(var(--bs-color-amarelo1-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-amarelo1-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-amarelo1:hover, .link-color-amarelo1:focus {
    color: RGBA(254, 216, 78, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(254, 216, 78, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-amarelo2 {
  color: RGBA(var(--bs-color-amarelo2-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-amarelo2-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-amarelo2:hover, .link-color-amarelo2:focus {
    color: RGBA(102, 87, 39, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(102, 87, 39, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-amarelo3 {
  color: RGBA(var(--bs-color-amarelo3-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-amarelo3-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-amarelo3:hover, .link-color-amarelo3:focus {
    color: RGBA(255, 243, 202, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(255, 243, 202, var(--bs-link-underline-opacity, 1)) !important; }

.link-color-laranja1 {
  color: RGBA(var(--bs-color-laranja1-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-color-laranja1-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-color-laranja1:hover, .link-color-laranja1:focus {
    color: RGBA(204, 78, 52, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(204, 78, 52, var(--bs-link-underline-opacity, 1)) !important; }

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-body-emphasis:hover, .link-body-emphasis:focus {
    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important; }

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color); }

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden; }
  .icon-link > .bi {
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    fill: currentcolor;
    transition: 0.2s ease-in-out transform; }
    @media (prefers-reduced-motion: reduce) {
      .icon-link > .bi {
        transition: none; } }

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0)); }

.ratio {
  position: relative;
  width: 100%; }
  .ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: ""; }
  .ratio > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; }

.ratio-1x1 {
  --bs-aspect-ratio: 100%; }

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%); }

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%); }

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%); }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020; }

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020; }

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch; }

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch; }

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }
  .visually-hidden:not(caption),
  .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
    position: absolute !important; }
  .visually-hidden *,
  .visually-hidden-focusable:not(:focus):not(:focus-within) * {
    overflow: hidden !important; }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: ""; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.7; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.float-start {
  float: left !important; }

.float-end {
  float: right !important; }

.float-none {
  float: none !important; }

.object-fit-contain {
  object-fit: contain !important; }

.object-fit-cover {
  object-fit: cover !important; }

.object-fit-fill {
  object-fit: fill !important; }

.object-fit-scale {
  object-fit: scale-down !important; }

.object-fit-none {
  object-fit: none !important; }

.opacity-0 {
  opacity: 0 !important; }

.opacity-25 {
  opacity: 0.25 !important; }

.opacity-50 {
  opacity: 0.5 !important; }

.opacity-75 {
  opacity: 0.75 !important; }

.opacity-100 {
  opacity: 1 !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.overflow-visible {
  overflow: visible !important; }

.overflow-scroll {
  overflow: scroll !important; }

.overflow-x-auto {
  overflow-x: auto !important; }

.overflow-x-hidden {
  overflow-x: hidden !important; }

.overflow-x-visible {
  overflow-x: visible !important; }

.overflow-x-scroll {
  overflow-x: scroll !important; }

.overflow-y-auto {
  overflow-y: auto !important; }

.overflow-y-hidden {
  overflow-y: hidden !important; }

.overflow-y-visible {
  overflow-y: visible !important; }

.overflow-y-scroll {
  overflow-y: scroll !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-grid {
  display: grid !important; }

.d-inline-grid {
  display: inline-grid !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

.d-none {
  display: none !important; }

.shadow {
  box-shadow: var(--bs-box-shadow) !important; }

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important; }

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important; }

.shadow-none {
  box-shadow: none !important; }

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-primary-dark {
  --bs-focus-ring-color: rgba(var(--bs-primary-dark-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-gray-secundary {
  --bs-focus-ring-color: rgba(var(--bs-gray-secundary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-pink {
  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-dark-gray-primary {
  --bs-focus-ring-color: rgba(var(--bs-dark-gray-primary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-gray-05 {
  --bs-focus-ring-color: rgba(var(--bs-light-gray-05-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-gray-03 {
  --bs-focus-ring-color: rgba(var(--bs-light-gray-03-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light_gray_04 {
  --bs-focus-ring-color: rgba(var(--bs-light_gray_04-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-gray-06 {
  --bs-focus-ring-color: rgba(var(--bs-light-gray-06-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light_blue_04 {
  --bs-focus-ring-color: rgba(var(--bs-light_blue_04-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-blue-01 {
  --bs-focus-ring-color: rgba(var(--bs-light-blue-01-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-blue-11 {
  --bs-focus-ring-color: rgba(var(--bs-light-blue-11-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-blue-06 {
  --bs-focus-ring-color: rgba(var(--bs-light-blue-06-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-blue-08 {
  --bs-focus-ring-color: rgba(var(--bs-light-blue-08-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-blue-13 {
  --bs-focus-ring-color: rgba(var(--bs-light-blue-13-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light-blue-14 {
  --bs-focus-ring-color: rgba(var(--bs-light-blue-14-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul1 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul1-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul2 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul2-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul2-hover {
  --bs-focus-ring-color: rgba(var(--bs-color-azul2-hover-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul3 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul3-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul4 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul4-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul5 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul5-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul6 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul6-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul7 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul7-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul8 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul8-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul9 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul9-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul10 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul10-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul11 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul11-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul410 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul410-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul130 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul130-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-azul405 {
  --bs-focus-ring-color: rgba(var(--bs-color-azul405-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-branco2 {
  --bs-focus-ring-color: rgba(var(--bs-color-branco2-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-branco3 {
  --bs-focus-ring-color: rgba(var(--bs-color-branco3-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza1 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza1-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza2 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza2-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza2-5 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza2-5-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza3 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza3-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza4 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza4-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza5 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza5-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-cinza6 {
  --bs-focus-ring-color: rgba(var(--bs-color-cinza6-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-vermelho1 {
  --bs-focus-ring-color: rgba(var(--bs-color-vermelho1-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-vermelho2 {
  --bs-focus-ring-color: rgba(var(--bs-color-vermelho2-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-vermelho3 {
  --bs-focus-ring-color: rgba(var(--bs-color-vermelho3-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-verde1 {
  --bs-focus-ring-color: rgba(var(--bs-color-verde1-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-verde2 {
  --bs-focus-ring-color: rgba(var(--bs-color-verde2-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-verde3 {
  --bs-focus-ring-color: rgba(var(--bs-color-verde3-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-amarelo1 {
  --bs-focus-ring-color: rgba(var(--bs-color-amarelo1-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-amarelo2 {
  --bs-focus-ring-color: rgba(var(--bs-color-amarelo2-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-amarelo3 {
  --bs-focus-ring-color: rgba(var(--bs-color-amarelo3-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-color-laranja1 {
  --bs-focus-ring-color: rgba(var(--bs-color-laranja1-rgb), var(--bs-focus-ring-opacity)); }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.top-0 {
  top: 0 !important; }

.top-50 {
  top: 50% !important; }

.top-100 {
  top: 100% !important; }

.bottom-0 {
  bottom: 0 !important; }

.bottom-50 {
  bottom: 50% !important; }

.bottom-100 {
  bottom: 100% !important; }

.start-0 {
  left: 0 !important; }

.start-50 {
  left: 50% !important; }

.start-100 {
  left: 100% !important; }

.end-0 {
  right: 0 !important; }

.end-50 {
  right: 50% !important; }

.end-100 {
  right: 100% !important; }

.translate-middle {
  transform: translate(-50%, -50%) !important; }

.translate-middle-x {
  transform: translateX(-50%) !important; }

.translate-middle-y {
  transform: translateY(-50%) !important; }

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-0 {
  border: 0 !important; }

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-end-0 {
  border-right: 0 !important; }

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-start-0 {
  border-left: 0 !important; }

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important; }

.border-primary-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-dark-rgb), var(--bs-border-opacity)) !important; }

.border-gray-secundary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-secundary-rgb), var(--bs-border-opacity)) !important; }

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important; }

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important; }

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important; }

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important; }

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important; }

.border-pink {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important; }

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important; }

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important; }

.border-dark-gray-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-gray-primary-rgb), var(--bs-border-opacity)) !important; }

.border-light-gray-05 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-gray-05-rgb), var(--bs-border-opacity)) !important; }

.border-light-gray-03 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-gray-03-rgb), var(--bs-border-opacity)) !important; }

.border-light_gray_04 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light_gray_04-rgb), var(--bs-border-opacity)) !important; }

.border-light-gray-06 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-gray-06-rgb), var(--bs-border-opacity)) !important; }

.border-light_blue_04 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light_blue_04-rgb), var(--bs-border-opacity)) !important; }

.border-light-blue-01 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-blue-01-rgb), var(--bs-border-opacity)) !important; }

.border-light-blue-11 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-blue-11-rgb), var(--bs-border-opacity)) !important; }

.border-light-blue-06 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-blue-06-rgb), var(--bs-border-opacity)) !important; }

.border-light-blue-08 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-blue-08-rgb), var(--bs-border-opacity)) !important; }

.border-light-blue-13 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-blue-13-rgb), var(--bs-border-opacity)) !important; }

.border-light-blue-14 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-blue-14-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul1 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul1-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul2 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul2-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul2-hover {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul2-hover-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul3 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul3-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul4 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul4-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul5 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul5-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul6 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul6-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul7 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul7-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul8 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul8-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul9 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul9-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul10 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul10-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul11 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul11-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul410 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul410-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul130 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul130-rgb), var(--bs-border-opacity)) !important; }

.border-color-azul405 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-azul405-rgb), var(--bs-border-opacity)) !important; }

.border-color-branco2 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-branco2-rgb), var(--bs-border-opacity)) !important; }

.border-color-branco3 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-branco3-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza1 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza1-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza2 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza2-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza2-5 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza2-5-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza3 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza3-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza4 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza4-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza5 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza5-rgb), var(--bs-border-opacity)) !important; }

.border-color-cinza6 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-cinza6-rgb), var(--bs-border-opacity)) !important; }

.border-color-vermelho1 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-vermelho1-rgb), var(--bs-border-opacity)) !important; }

.border-color-vermelho2 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-vermelho2-rgb), var(--bs-border-opacity)) !important; }

.border-color-vermelho3 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-vermelho3-rgb), var(--bs-border-opacity)) !important; }

.border-color-verde1 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-verde1-rgb), var(--bs-border-opacity)) !important; }

.border-color-verde2 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-verde2-rgb), var(--bs-border-opacity)) !important; }

.border-color-verde3 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-verde3-rgb), var(--bs-border-opacity)) !important; }

.border-color-amarelo1 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-amarelo1-rgb), var(--bs-border-opacity)) !important; }

.border-color-amarelo2 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-amarelo2-rgb), var(--bs-border-opacity)) !important; }

.border-color-amarelo3 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-amarelo3-rgb), var(--bs-border-opacity)) !important; }

.border-color-laranja1 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-color-laranja1-rgb), var(--bs-border-opacity)) !important; }

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important; }

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important; }

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important; }

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important; }

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important; }

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important; }

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important; }

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important; }

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important; }

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important; }

.border-0 {
  border-width: 0 !important; }

.border-1 {
  border-width: 1px !important; }

.border-2 {
  border-width: 2px !important; }

.border-3 {
  border-width: 3px !important; }

.border-4 {
  border-width: 4px !important; }

.border-5 {
  border-width: 5px !important; }

.border-opacity-10 {
  --bs-border-opacity: 0.1; }

.border-opacity-25 {
  --bs-border-opacity: 0.25; }

.border-opacity-50 {
  --bs-border-opacity: 0.5; }

.border-opacity-75 {
  --bs-border-opacity: 0.75; }

.border-opacity-100 {
  --bs-border-opacity: 1; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.vw-100 {
  width: 100vw !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mh-100 {
  max-height: 100% !important; }

.vh-100 {
  height: 100vh !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.justify-content-evenly {
  justify-content: space-evenly !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

.order-first {
  order: -1 !important; }

.order-0 {
  order: 0 !important; }

.order-1 {
  order: 1 !important; }

.order-2 {
  order: 2 !important; }

.order-3 {
  order: 3 !important; }

.order-4 {
  order: 4 !important; }

.order-5 {
  order: 5 !important; }

.order-last {
  order: 6 !important; }

.m-0 {
  margin: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important; }

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important; }

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important; }

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important; }

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important; }

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important; }

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important; }

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important; }

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important; }

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important; }

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important; }

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important; }

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important; }

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important; }

.mt-0 {
  margin-top: 0 !important; }

.mt-1 {
  margin-top: 0.25rem !important; }

.mt-2 {
  margin-top: 0.5rem !important; }

.mt-3 {
  margin-top: 1rem !important; }

.mt-4 {
  margin-top: 1.5rem !important; }

.mt-5 {
  margin-top: 3rem !important; }

.mt-auto {
  margin-top: auto !important; }

.me-0 {
  margin-right: 0 !important; }

.me-1 {
  margin-right: 0.25rem !important; }

.me-2 {
  margin-right: 0.5rem !important; }

.me-3 {
  margin-right: 1rem !important; }

.me-4 {
  margin-right: 1.5rem !important; }

.me-5 {
  margin-right: 3rem !important; }

.me-auto {
  margin-right: auto !important; }

.mb-0 {
  margin-bottom: 0 !important; }

.mb-1 {
  margin-bottom: 0.25rem !important; }

.mb-2 {
  margin-bottom: 0.5rem !important; }

.mb-3 {
  margin-bottom: 1rem !important; }

.mb-4 {
  margin-bottom: 1.5rem !important; }

.mb-5 {
  margin-bottom: 3rem !important; }

.mb-auto {
  margin-bottom: auto !important; }

.ms-0 {
  margin-left: 0 !important; }

.ms-1 {
  margin-left: 0.25rem !important; }

.ms-2 {
  margin-left: 0.5rem !important; }

.ms-3 {
  margin-left: 1rem !important; }

.ms-4 {
  margin-left: 1.5rem !important; }

.ms-5 {
  margin-left: 3rem !important; }

.ms-auto {
  margin-left: auto !important; }

.m-n1 {
  margin: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important; }

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important; }

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important; }

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important; }

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important; }

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important; }

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important; }

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important; }

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important; }

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important; }

.mt-n1 {
  margin-top: -0.25rem !important; }

.mt-n2 {
  margin-top: -0.5rem !important; }

.mt-n3 {
  margin-top: -1rem !important; }

.mt-n4 {
  margin-top: -1.5rem !important; }

.mt-n5 {
  margin-top: -3rem !important; }

.me-n1 {
  margin-right: -0.25rem !important; }

.me-n2 {
  margin-right: -0.5rem !important; }

.me-n3 {
  margin-right: -1rem !important; }

.me-n4 {
  margin-right: -1.5rem !important; }

.me-n5 {
  margin-right: -3rem !important; }

.mb-n1 {
  margin-bottom: -0.25rem !important; }

.mb-n2 {
  margin-bottom: -0.5rem !important; }

.mb-n3 {
  margin-bottom: -1rem !important; }

.mb-n4 {
  margin-bottom: -1.5rem !important; }

.mb-n5 {
  margin-bottom: -3rem !important; }

.ms-n1 {
  margin-left: -0.25rem !important; }

.ms-n2 {
  margin-left: -0.5rem !important; }

.ms-n3 {
  margin-left: -1rem !important; }

.ms-n4 {
  margin-left: -1.5rem !important; }

.ms-n5 {
  margin-left: -3rem !important; }

.p-0 {
  padding: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important; }

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important; }

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important; }

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important; }

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important; }

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important; }

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important; }

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important; }

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important; }

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important; }

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important; }

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important; }

.pt-0 {
  padding-top: 0 !important; }

.pt-1 {
  padding-top: 0.25rem !important; }

.pt-2 {
  padding-top: 0.5rem !important; }

.pt-3 {
  padding-top: 1rem !important; }

.pt-4 {
  padding-top: 1.5rem !important; }

.pt-5 {
  padding-top: 3rem !important; }

.pe-0 {
  padding-right: 0 !important; }

.pe-1 {
  padding-right: 0.25rem !important; }

.pe-2 {
  padding-right: 0.5rem !important; }

.pe-3 {
  padding-right: 1rem !important; }

.pe-4 {
  padding-right: 1.5rem !important; }

.pe-5 {
  padding-right: 3rem !important; }

.pb-0 {
  padding-bottom: 0 !important; }

.pb-1 {
  padding-bottom: 0.25rem !important; }

.pb-2 {
  padding-bottom: 0.5rem !important; }

.pb-3 {
  padding-bottom: 1rem !important; }

.pb-4 {
  padding-bottom: 1.5rem !important; }

.pb-5 {
  padding-bottom: 3rem !important; }

.ps-0 {
  padding-left: 0 !important; }

.ps-1 {
  padding-left: 0.25rem !important; }

.ps-2 {
  padding-left: 0.5rem !important; }

.ps-3 {
  padding-left: 1rem !important; }

.ps-4 {
  padding-left: 1.5rem !important; }

.ps-5 {
  padding-left: 3rem !important; }

.gap-0 {
  gap: 0 !important; }

.gap-1 {
  gap: 0.25rem !important; }

.gap-2 {
  gap: 0.5rem !important; }

.gap-3 {
  gap: 1rem !important; }

.gap-4 {
  gap: 1.5rem !important; }

.gap-5 {
  gap: 3rem !important; }

.row-gap-0 {
  row-gap: 0 !important; }

.row-gap-1 {
  row-gap: 0.25rem !important; }

.row-gap-2 {
  row-gap: 0.5rem !important; }

.row-gap-3 {
  row-gap: 1rem !important; }

.row-gap-4 {
  row-gap: 1.5rem !important; }

.row-gap-5 {
  row-gap: 3rem !important; }

.column-gap-0 {
  column-gap: 0 !important; }

.column-gap-1 {
  column-gap: 0.25rem !important; }

.column-gap-2 {
  column-gap: 0.5rem !important; }

.column-gap-3 {
  column-gap: 1rem !important; }

.column-gap-4 {
  column-gap: 1.5rem !important; }

.column-gap-5 {
  column-gap: 3rem !important; }

.font-monospace {
  font-family: var(--bs-font-monospace) !important; }

.fs-1 {
  font-size: calc(1.34375rem + 1.125vw) !important; }

.fs-2 {
  font-size: calc(1.3rem + 0.6vw) !important; }

.fs-3 {
  font-size: calc(1.27813rem + 0.3375vw) !important; }

.fs-4 {
  font-size: calc(1.25625rem + 0.075vw) !important; }

.fs-5 {
  font-size: 1.09375rem !important; }

.fs-6 {
  font-size: 0.875rem !important; }

.fst-italic {
  font-style: italic !important; }

.fst-normal {
  font-style: normal !important; }

.fw-lighter {
  font-weight: lighter !important; }

.fw-light {
  font-weight: 300 !important; }

.fw-normal {
  font-weight: 400 !important; }

.fw-medium {
  font-weight: 500 !important; }

.fw-semibold {
  font-weight: 600 !important; }

.fw-bold {
  font-weight: 600 !important; }

.fw-bolder {
  font-weight: bolder !important; }

.lh-1 {
  line-height: 1 !important; }

.lh-sm {
  line-height: 1.25 !important; }

.lh-base {
  line-height: 1.5 !important; }

.lh-lg {
  line-height: 2 !important; }

.text-start {
  text-align: left !important; }

.text-end {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

.text-decoration-none {
  text-decoration: none !important; }

.text-decoration-underline {
  text-decoration: underline !important; }

.text-decoration-line-through {
  text-decoration: line-through !important; }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important; }

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important; }

.text-primary-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-dark-rgb), var(--bs-text-opacity)) !important; }

.text-gray-secundary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-secundary-rgb), var(--bs-text-opacity)) !important; }

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important; }

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important; }

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important; }

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important; }

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important; }

.text-pink {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important; }

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important; }

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important; }

.text-dark-gray-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-gray-primary-rgb), var(--bs-text-opacity)) !important; }

.text-light-gray-05 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-gray-05-rgb), var(--bs-text-opacity)) !important; }

.text-light-gray-03 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-gray-03-rgb), var(--bs-text-opacity)) !important; }

.text-light_gray_04 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light_gray_04-rgb), var(--bs-text-opacity)) !important; }

.text-light-gray-06 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-gray-06-rgb), var(--bs-text-opacity)) !important; }

.text-light_blue_04 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light_blue_04-rgb), var(--bs-text-opacity)) !important; }

.text-light-blue-01 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-blue-01-rgb), var(--bs-text-opacity)) !important; }

.text-light-blue-11 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-blue-11-rgb), var(--bs-text-opacity)) !important; }

.text-light-blue-06 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-blue-06-rgb), var(--bs-text-opacity)) !important; }

.text-light-blue-08 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-blue-08-rgb), var(--bs-text-opacity)) !important; }

.text-light-blue-13 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-blue-13-rgb), var(--bs-text-opacity)) !important; }

.text-light-blue-14 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-blue-14-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul1 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul1-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul2 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul2-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul2-hover {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul2-hover-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul3 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul3-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul4 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul4-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul5 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul5-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul6 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul6-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul7 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul7-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul8 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul8-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul9 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul9-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul10 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul10-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul11 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul11-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul410 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul410-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul130 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul130-rgb), var(--bs-text-opacity)) !important; }

.text-color-azul405 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-azul405-rgb), var(--bs-text-opacity)) !important; }

.text-color-branco2 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-branco2-rgb), var(--bs-text-opacity)) !important; }

.text-color-branco3 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-branco3-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza1 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza1-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza2 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza2-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza2-5 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza2-5-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza3 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza3-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza4 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza4-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza5 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza5-rgb), var(--bs-text-opacity)) !important; }

.text-color-cinza6 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-cinza6-rgb), var(--bs-text-opacity)) !important; }

.text-color-vermelho1 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-vermelho1-rgb), var(--bs-text-opacity)) !important; }

.text-color-vermelho2 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-vermelho2-rgb), var(--bs-text-opacity)) !important; }

.text-color-vermelho3 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-vermelho3-rgb), var(--bs-text-opacity)) !important; }

.text-color-verde1 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-verde1-rgb), var(--bs-text-opacity)) !important; }

.text-color-verde2 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-verde2-rgb), var(--bs-text-opacity)) !important; }

.text-color-verde3 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-verde3-rgb), var(--bs-text-opacity)) !important; }

.text-color-amarelo1 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-amarelo1-rgb), var(--bs-text-opacity)) !important; }

.text-color-amarelo2 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-amarelo2-rgb), var(--bs-text-opacity)) !important; }

.text-color-amarelo3 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-amarelo3-rgb), var(--bs-text-opacity)) !important; }

.text-color-laranja1 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-color-laranja1-rgb), var(--bs-text-opacity)) !important; }

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important; }

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important; }

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important; }

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important; }

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important; }

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important; }

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important; }

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important; }

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important; }

.text-opacity-25 {
  --bs-text-opacity: 0.25; }

.text-opacity-50 {
  --bs-text-opacity: 0.5; }

.text-opacity-75 {
  --bs-text-opacity: 0.75; }

.text-opacity-100 {
  --bs-text-opacity: 1; }

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important; }

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important; }

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important; }

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important; }

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important; }

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important; }

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important; }

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important; }

.link-opacity-10 {
  --bs-link-opacity: 0.1; }

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1; }

.link-opacity-25 {
  --bs-link-opacity: 0.25; }

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25; }

.link-opacity-50 {
  --bs-link-opacity: 0.5; }

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5; }

.link-opacity-75 {
  --bs-link-opacity: 0.75; }

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75; }

.link-opacity-100 {
  --bs-link-opacity: 1; }

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1; }

.link-offset-1 {
  text-underline-offset: 0.125em !important; }

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important; }

.link-offset-2 {
  text-underline-offset: 0.25em !important; }

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important; }

.link-offset-3 {
  text-underline-offset: 0.375em !important; }

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important; }

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-primary-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-dark-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-gray-secundary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-secundary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-pink {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-dark-gray-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-gray-primary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-gray-05 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-gray-05-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-gray-03 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-gray-03-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light_gray_04 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light_gray_04-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-gray-06 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-gray-06-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light_blue_04 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light_blue_04-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-blue-01 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-blue-01-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-blue-11 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-blue-11-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-blue-06 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-blue-06-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-blue-08 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-blue-08-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-blue-13 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-blue-13-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light-blue-14 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-blue-14-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul1 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul1-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul2 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul2-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul2-hover {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul2-hover-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul3 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul3-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul4 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul4-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul5 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul5-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul6 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul6-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul7 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul7-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul8 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul8-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul9 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul9-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul10 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul10-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul11 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul11-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul410 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul410-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul130 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul130-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-azul405 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-azul405-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-branco2 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-branco2-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-branco3 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-branco3-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza1 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza1-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza2 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza2-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza2-5 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza2-5-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza3 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza3-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza4 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza4-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza5 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza5-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-cinza6 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-cinza6-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-vermelho1 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-vermelho1-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-vermelho2 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-vermelho2-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-vermelho3 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-vermelho3-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-verde1 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-verde1-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-verde2 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-verde2-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-verde3 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-verde3-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-amarelo1 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-amarelo1-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-amarelo2 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-amarelo2-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-amarelo3 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-amarelo3-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-color-laranja1 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-color-laranja1-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important; }

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0; }

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0; }

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1; }

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1; }

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25; }

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25; }

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5; }

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5; }

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75; }

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75; }

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1; }

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1; }

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important; }

.bg-primary-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-dark-rgb), var(--bs-bg-opacity)) !important; }

.bg-gray-secundary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-secundary-rgb), var(--bs-bg-opacity)) !important; }

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important; }

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important; }

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important; }

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important; }

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important; }

.bg-pink {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important; }

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important; }

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important; }

.bg-dark-gray-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-gray-primary-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-gray-05 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-gray-05-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-gray-03 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-gray-03-rgb), var(--bs-bg-opacity)) !important; }

.bg-light_gray_04 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light_gray_04-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-gray-06 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-gray-06-rgb), var(--bs-bg-opacity)) !important; }

.bg-light_blue_04 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light_blue_04-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-blue-01 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-blue-01-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-blue-11 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-blue-11-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-blue-06 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-blue-06-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-blue-08 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-blue-08-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-blue-13 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-blue-13-rgb), var(--bs-bg-opacity)) !important; }

.bg-light-blue-14 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-blue-14-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul1 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul1-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul2 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul2-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul2-hover {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul2-hover-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul3 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul3-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul4 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul4-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul5 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul5-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul6 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul6-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul7 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul7-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul8 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul8-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul9 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul9-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul10 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul10-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul11 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul11-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul410 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul410-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul130 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul130-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-azul405 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-azul405-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-branco2 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-branco2-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-branco3 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-branco3-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza1 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza1-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza2 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza2-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza2-5 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza2-5-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza3 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza3-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza4 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza4-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza5 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza5-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-cinza6 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-cinza6-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-vermelho1 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-vermelho1-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-vermelho2 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-vermelho2-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-vermelho3 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-vermelho3-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-verde1 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-verde1-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-verde2 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-verde2-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-verde3 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-verde3-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-amarelo1 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-amarelo1-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-amarelo2 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-amarelo2-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-amarelo3 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-amarelo3-rgb), var(--bs-bg-opacity)) !important; }

.bg-color-laranja1 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-color-laranja1-rgb), var(--bs-bg-opacity)) !important; }

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important; }

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important; }

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important; }

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-opacity-10 {
  --bs-bg-opacity: 0.1; }

.bg-opacity-25 {
  --bs-bg-opacity: 0.25; }

.bg-opacity-50 {
  --bs-bg-opacity: 0.5; }

.bg-opacity-75 {
  --bs-bg-opacity: 0.75; }

.bg-opacity-100 {
  --bs-bg-opacity: 1; }

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important; }

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important; }

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important; }

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important; }

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important; }

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important; }

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important; }

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important; }

.bg-gradient {
  background-image: var(--bs-gradient) !important; }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.pe-none {
  pointer-events: none !important; }

.pe-auto {
  pointer-events: auto !important; }

.rounded {
  border-radius: var(--bs-border-radius) !important; }

.rounded-0 {
  border-radius: 0 !important; }

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important; }

.rounded-2 {
  border-radius: var(--bs-border-radius) !important; }

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important; }

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important; }

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important; }

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important; }

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important; }

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important; }

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important; }

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important; }

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important; }

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important; }

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important; }

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important; }

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important; }

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important; }

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important; }

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; }

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important; }

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important; }

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important; }

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important; }

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important; }

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important; }

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important; }

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important; }

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important; }

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important; }

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important; }

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important; }

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

.z-n1 {
  z-index: -1 !important; }

.z-0 {
  z-index: 0 !important; }

.z-1 {
  z-index: 1 !important; }

.z-2 {
  z-index: 2 !important; }

.z-3 {
  z-index: 3 !important; }

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important; }
  .float-sm-end {
    float: right !important; }
  .float-sm-none {
    float: none !important; }
  .object-fit-sm-contain {
    object-fit: contain !important; }
  .object-fit-sm-cover {
    object-fit: cover !important; }
  .object-fit-sm-fill {
    object-fit: fill !important; }
  .object-fit-sm-scale {
    object-fit: scale-down !important; }
  .object-fit-sm-none {
    object-fit: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-grid {
    display: grid !important; }
  .d-sm-inline-grid {
    display: inline-grid !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; }
  .d-sm-none {
    display: none !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; }
  .order-sm-first {
    order: -1 !important; }
  .order-sm-0 {
    order: 0 !important; }
  .order-sm-1 {
    order: 1 !important; }
  .order-sm-2 {
    order: 2 !important; }
  .order-sm-3 {
    order: 3 !important; }
  .order-sm-4 {
    order: 4 !important; }
  .order-sm-5 {
    order: 5 !important; }
  .order-sm-last {
    order: 6 !important; }
  .m-sm-0 {
    margin: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-sm-0 {
    margin-top: 0 !important; }
  .mt-sm-1 {
    margin-top: 0.25rem !important; }
  .mt-sm-2 {
    margin-top: 0.5rem !important; }
  .mt-sm-3 {
    margin-top: 1rem !important; }
  .mt-sm-4 {
    margin-top: 1.5rem !important; }
  .mt-sm-5 {
    margin-top: 3rem !important; }
  .mt-sm-auto {
    margin-top: auto !important; }
  .me-sm-0 {
    margin-right: 0 !important; }
  .me-sm-1 {
    margin-right: 0.25rem !important; }
  .me-sm-2 {
    margin-right: 0.5rem !important; }
  .me-sm-3 {
    margin-right: 1rem !important; }
  .me-sm-4 {
    margin-right: 1.5rem !important; }
  .me-sm-5 {
    margin-right: 3rem !important; }
  .me-sm-auto {
    margin-right: auto !important; }
  .mb-sm-0 {
    margin-bottom: 0 !important; }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important; }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important; }
  .mb-sm-3 {
    margin-bottom: 1rem !important; }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important; }
  .mb-sm-5 {
    margin-bottom: 3rem !important; }
  .mb-sm-auto {
    margin-bottom: auto !important; }
  .ms-sm-0 {
    margin-left: 0 !important; }
  .ms-sm-1 {
    margin-left: 0.25rem !important; }
  .ms-sm-2 {
    margin-left: 0.5rem !important; }
  .ms-sm-3 {
    margin-left: 1rem !important; }
  .ms-sm-4 {
    margin-left: 1.5rem !important; }
  .ms-sm-5 {
    margin-left: 3rem !important; }
  .ms-sm-auto {
    margin-left: auto !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-sm-n1 {
    margin-top: -0.25rem !important; }
  .mt-sm-n2 {
    margin-top: -0.5rem !important; }
  .mt-sm-n3 {
    margin-top: -1rem !important; }
  .mt-sm-n4 {
    margin-top: -1.5rem !important; }
  .mt-sm-n5 {
    margin-top: -3rem !important; }
  .me-sm-n1 {
    margin-right: -0.25rem !important; }
  .me-sm-n2 {
    margin-right: -0.5rem !important; }
  .me-sm-n3 {
    margin-right: -1rem !important; }
  .me-sm-n4 {
    margin-right: -1.5rem !important; }
  .me-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-sm-n3 {
    margin-bottom: -1rem !important; }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-sm-n5 {
    margin-bottom: -3rem !important; }
  .ms-sm-n1 {
    margin-left: -0.25rem !important; }
  .ms-sm-n2 {
    margin-left: -0.5rem !important; }
  .ms-sm-n3 {
    margin-left: -1rem !important; }
  .ms-sm-n4 {
    margin-left: -1.5rem !important; }
  .ms-sm-n5 {
    margin-left: -3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-sm-0 {
    padding-top: 0 !important; }
  .pt-sm-1 {
    padding-top: 0.25rem !important; }
  .pt-sm-2 {
    padding-top: 0.5rem !important; }
  .pt-sm-3 {
    padding-top: 1rem !important; }
  .pt-sm-4 {
    padding-top: 1.5rem !important; }
  .pt-sm-5 {
    padding-top: 3rem !important; }
  .pe-sm-0 {
    padding-right: 0 !important; }
  .pe-sm-1 {
    padding-right: 0.25rem !important; }
  .pe-sm-2 {
    padding-right: 0.5rem !important; }
  .pe-sm-3 {
    padding-right: 1rem !important; }
  .pe-sm-4 {
    padding-right: 1.5rem !important; }
  .pe-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-0 {
    padding-bottom: 0 !important; }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pb-sm-3 {
    padding-bottom: 1rem !important; }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pb-sm-5 {
    padding-bottom: 3rem !important; }
  .ps-sm-0 {
    padding-left: 0 !important; }
  .ps-sm-1 {
    padding-left: 0.25rem !important; }
  .ps-sm-2 {
    padding-left: 0.5rem !important; }
  .ps-sm-3 {
    padding-left: 1rem !important; }
  .ps-sm-4 {
    padding-left: 1.5rem !important; }
  .ps-sm-5 {
    padding-left: 3rem !important; }
  .gap-sm-0 {
    gap: 0 !important; }
  .gap-sm-1 {
    gap: 0.25rem !important; }
  .gap-sm-2 {
    gap: 0.5rem !important; }
  .gap-sm-3 {
    gap: 1rem !important; }
  .gap-sm-4 {
    gap: 1.5rem !important; }
  .gap-sm-5 {
    gap: 3rem !important; }
  .row-gap-sm-0 {
    row-gap: 0 !important; }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important; }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important; }
  .row-gap-sm-3 {
    row-gap: 1rem !important; }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important; }
  .row-gap-sm-5 {
    row-gap: 3rem !important; }
  .column-gap-sm-0 {
    column-gap: 0 !important; }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important; }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important; }
  .column-gap-sm-3 {
    column-gap: 1rem !important; }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important; }
  .column-gap-sm-5 {
    column-gap: 3rem !important; }
  .text-sm-start {
    text-align: left !important; }
  .text-sm-end {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .float-md-start {
    float: left !important; }
  .float-md-end {
    float: right !important; }
  .float-md-none {
    float: none !important; }
  .object-fit-md-contain {
    object-fit: contain !important; }
  .object-fit-md-cover {
    object-fit: cover !important; }
  .object-fit-md-fill {
    object-fit: fill !important; }
  .object-fit-md-scale {
    object-fit: scale-down !important; }
  .object-fit-md-none {
    object-fit: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-grid {
    display: grid !important; }
  .d-md-inline-grid {
    display: inline-grid !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; }
  .d-md-none {
    display: none !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .justify-content-md-evenly {
    justify-content: space-evenly !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; }
  .order-md-first {
    order: -1 !important; }
  .order-md-0 {
    order: 0 !important; }
  .order-md-1 {
    order: 1 !important; }
  .order-md-2 {
    order: 2 !important; }
  .order-md-3 {
    order: 3 !important; }
  .order-md-4 {
    order: 4 !important; }
  .order-md-5 {
    order: 5 !important; }
  .order-md-last {
    order: 6 !important; }
  .m-md-0 {
    margin: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-md-0 {
    margin-top: 0 !important; }
  .mt-md-1 {
    margin-top: 0.25rem !important; }
  .mt-md-2 {
    margin-top: 0.5rem !important; }
  .mt-md-3 {
    margin-top: 1rem !important; }
  .mt-md-4 {
    margin-top: 1.5rem !important; }
  .mt-md-5 {
    margin-top: 3rem !important; }
  .mt-md-auto {
    margin-top: auto !important; }
  .me-md-0 {
    margin-right: 0 !important; }
  .me-md-1 {
    margin-right: 0.25rem !important; }
  .me-md-2 {
    margin-right: 0.5rem !important; }
  .me-md-3 {
    margin-right: 1rem !important; }
  .me-md-4 {
    margin-right: 1.5rem !important; }
  .me-md-5 {
    margin-right: 3rem !important; }
  .me-md-auto {
    margin-right: auto !important; }
  .mb-md-0 {
    margin-bottom: 0 !important; }
  .mb-md-1 {
    margin-bottom: 0.25rem !important; }
  .mb-md-2 {
    margin-bottom: 0.5rem !important; }
  .mb-md-3 {
    margin-bottom: 1rem !important; }
  .mb-md-4 {
    margin-bottom: 1.5rem !important; }
  .mb-md-5 {
    margin-bottom: 3rem !important; }
  .mb-md-auto {
    margin-bottom: auto !important; }
  .ms-md-0 {
    margin-left: 0 !important; }
  .ms-md-1 {
    margin-left: 0.25rem !important; }
  .ms-md-2 {
    margin-left: 0.5rem !important; }
  .ms-md-3 {
    margin-left: 1rem !important; }
  .ms-md-4 {
    margin-left: 1.5rem !important; }
  .ms-md-5 {
    margin-left: 3rem !important; }
  .ms-md-auto {
    margin-left: auto !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-md-n1 {
    margin-top: -0.25rem !important; }
  .mt-md-n2 {
    margin-top: -0.5rem !important; }
  .mt-md-n3 {
    margin-top: -1rem !important; }
  .mt-md-n4 {
    margin-top: -1.5rem !important; }
  .mt-md-n5 {
    margin-top: -3rem !important; }
  .me-md-n1 {
    margin-right: -0.25rem !important; }
  .me-md-n2 {
    margin-right: -0.5rem !important; }
  .me-md-n3 {
    margin-right: -1rem !important; }
  .me-md-n4 {
    margin-right: -1.5rem !important; }
  .me-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-md-n3 {
    margin-bottom: -1rem !important; }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-md-n5 {
    margin-bottom: -3rem !important; }
  .ms-md-n1 {
    margin-left: -0.25rem !important; }
  .ms-md-n2 {
    margin-left: -0.5rem !important; }
  .ms-md-n3 {
    margin-left: -1rem !important; }
  .ms-md-n4 {
    margin-left: -1.5rem !important; }
  .ms-md-n5 {
    margin-left: -3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-md-0 {
    padding-top: 0 !important; }
  .pt-md-1 {
    padding-top: 0.25rem !important; }
  .pt-md-2 {
    padding-top: 0.5rem !important; }
  .pt-md-3 {
    padding-top: 1rem !important; }
  .pt-md-4 {
    padding-top: 1.5rem !important; }
  .pt-md-5 {
    padding-top: 3rem !important; }
  .pe-md-0 {
    padding-right: 0 !important; }
  .pe-md-1 {
    padding-right: 0.25rem !important; }
  .pe-md-2 {
    padding-right: 0.5rem !important; }
  .pe-md-3 {
    padding-right: 1rem !important; }
  .pe-md-4 {
    padding-right: 1.5rem !important; }
  .pe-md-5 {
    padding-right: 3rem !important; }
  .pb-md-0 {
    padding-bottom: 0 !important; }
  .pb-md-1 {
    padding-bottom: 0.25rem !important; }
  .pb-md-2 {
    padding-bottom: 0.5rem !important; }
  .pb-md-3 {
    padding-bottom: 1rem !important; }
  .pb-md-4 {
    padding-bottom: 1.5rem !important; }
  .pb-md-5 {
    padding-bottom: 3rem !important; }
  .ps-md-0 {
    padding-left: 0 !important; }
  .ps-md-1 {
    padding-left: 0.25rem !important; }
  .ps-md-2 {
    padding-left: 0.5rem !important; }
  .ps-md-3 {
    padding-left: 1rem !important; }
  .ps-md-4 {
    padding-left: 1.5rem !important; }
  .ps-md-5 {
    padding-left: 3rem !important; }
  .gap-md-0 {
    gap: 0 !important; }
  .gap-md-1 {
    gap: 0.25rem !important; }
  .gap-md-2 {
    gap: 0.5rem !important; }
  .gap-md-3 {
    gap: 1rem !important; }
  .gap-md-4 {
    gap: 1.5rem !important; }
  .gap-md-5 {
    gap: 3rem !important; }
  .row-gap-md-0 {
    row-gap: 0 !important; }
  .row-gap-md-1 {
    row-gap: 0.25rem !important; }
  .row-gap-md-2 {
    row-gap: 0.5rem !important; }
  .row-gap-md-3 {
    row-gap: 1rem !important; }
  .row-gap-md-4 {
    row-gap: 1.5rem !important; }
  .row-gap-md-5 {
    row-gap: 3rem !important; }
  .column-gap-md-0 {
    column-gap: 0 !important; }
  .column-gap-md-1 {
    column-gap: 0.25rem !important; }
  .column-gap-md-2 {
    column-gap: 0.5rem !important; }
  .column-gap-md-3 {
    column-gap: 1rem !important; }
  .column-gap-md-4 {
    column-gap: 1.5rem !important; }
  .column-gap-md-5 {
    column-gap: 3rem !important; }
  .text-md-start {
    text-align: left !important; }
  .text-md-end {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important; }
  .float-lg-end {
    float: right !important; }
  .float-lg-none {
    float: none !important; }
  .object-fit-lg-contain {
    object-fit: contain !important; }
  .object-fit-lg-cover {
    object-fit: cover !important; }
  .object-fit-lg-fill {
    object-fit: fill !important; }
  .object-fit-lg-scale {
    object-fit: scale-down !important; }
  .object-fit-lg-none {
    object-fit: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-grid {
    display: grid !important; }
  .d-lg-inline-grid {
    display: inline-grid !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; }
  .d-lg-none {
    display: none !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; }
  .order-lg-first {
    order: -1 !important; }
  .order-lg-0 {
    order: 0 !important; }
  .order-lg-1 {
    order: 1 !important; }
  .order-lg-2 {
    order: 2 !important; }
  .order-lg-3 {
    order: 3 !important; }
  .order-lg-4 {
    order: 4 !important; }
  .order-lg-5 {
    order: 5 !important; }
  .order-lg-last {
    order: 6 !important; }
  .m-lg-0 {
    margin: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-lg-0 {
    margin-top: 0 !important; }
  .mt-lg-1 {
    margin-top: 0.25rem !important; }
  .mt-lg-2 {
    margin-top: 0.5rem !important; }
  .mt-lg-3 {
    margin-top: 1rem !important; }
  .mt-lg-4 {
    margin-top: 1.5rem !important; }
  .mt-lg-5 {
    margin-top: 3rem !important; }
  .mt-lg-auto {
    margin-top: auto !important; }
  .me-lg-0 {
    margin-right: 0 !important; }
  .me-lg-1 {
    margin-right: 0.25rem !important; }
  .me-lg-2 {
    margin-right: 0.5rem !important; }
  .me-lg-3 {
    margin-right: 1rem !important; }
  .me-lg-4 {
    margin-right: 1.5rem !important; }
  .me-lg-5 {
    margin-right: 3rem !important; }
  .me-lg-auto {
    margin-right: auto !important; }
  .mb-lg-0 {
    margin-bottom: 0 !important; }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important; }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important; }
  .mb-lg-3 {
    margin-bottom: 1rem !important; }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important; }
  .mb-lg-5 {
    margin-bottom: 3rem !important; }
  .mb-lg-auto {
    margin-bottom: auto !important; }
  .ms-lg-0 {
    margin-left: 0 !important; }
  .ms-lg-1 {
    margin-left: 0.25rem !important; }
  .ms-lg-2 {
    margin-left: 0.5rem !important; }
  .ms-lg-3 {
    margin-left: 1rem !important; }
  .ms-lg-4 {
    margin-left: 1.5rem !important; }
  .ms-lg-5 {
    margin-left: 3rem !important; }
  .ms-lg-auto {
    margin-left: auto !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-lg-n1 {
    margin-top: -0.25rem !important; }
  .mt-lg-n2 {
    margin-top: -0.5rem !important; }
  .mt-lg-n3 {
    margin-top: -1rem !important; }
  .mt-lg-n4 {
    margin-top: -1.5rem !important; }
  .mt-lg-n5 {
    margin-top: -3rem !important; }
  .me-lg-n1 {
    margin-right: -0.25rem !important; }
  .me-lg-n2 {
    margin-right: -0.5rem !important; }
  .me-lg-n3 {
    margin-right: -1rem !important; }
  .me-lg-n4 {
    margin-right: -1.5rem !important; }
  .me-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-lg-n3 {
    margin-bottom: -1rem !important; }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-lg-n5 {
    margin-bottom: -3rem !important; }
  .ms-lg-n1 {
    margin-left: -0.25rem !important; }
  .ms-lg-n2 {
    margin-left: -0.5rem !important; }
  .ms-lg-n3 {
    margin-left: -1rem !important; }
  .ms-lg-n4 {
    margin-left: -1.5rem !important; }
  .ms-lg-n5 {
    margin-left: -3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-lg-0 {
    padding-top: 0 !important; }
  .pt-lg-1 {
    padding-top: 0.25rem !important; }
  .pt-lg-2 {
    padding-top: 0.5rem !important; }
  .pt-lg-3 {
    padding-top: 1rem !important; }
  .pt-lg-4 {
    padding-top: 1.5rem !important; }
  .pt-lg-5 {
    padding-top: 3rem !important; }
  .pe-lg-0 {
    padding-right: 0 !important; }
  .pe-lg-1 {
    padding-right: 0.25rem !important; }
  .pe-lg-2 {
    padding-right: 0.5rem !important; }
  .pe-lg-3 {
    padding-right: 1rem !important; }
  .pe-lg-4 {
    padding-right: 1.5rem !important; }
  .pe-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-0 {
    padding-bottom: 0 !important; }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pb-lg-3 {
    padding-bottom: 1rem !important; }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pb-lg-5 {
    padding-bottom: 3rem !important; }
  .ps-lg-0 {
    padding-left: 0 !important; }
  .ps-lg-1 {
    padding-left: 0.25rem !important; }
  .ps-lg-2 {
    padding-left: 0.5rem !important; }
  .ps-lg-3 {
    padding-left: 1rem !important; }
  .ps-lg-4 {
    padding-left: 1.5rem !important; }
  .ps-lg-5 {
    padding-left: 3rem !important; }
  .gap-lg-0 {
    gap: 0 !important; }
  .gap-lg-1 {
    gap: 0.25rem !important; }
  .gap-lg-2 {
    gap: 0.5rem !important; }
  .gap-lg-3 {
    gap: 1rem !important; }
  .gap-lg-4 {
    gap: 1.5rem !important; }
  .gap-lg-5 {
    gap: 3rem !important; }
  .row-gap-lg-0 {
    row-gap: 0 !important; }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important; }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important; }
  .row-gap-lg-3 {
    row-gap: 1rem !important; }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important; }
  .row-gap-lg-5 {
    row-gap: 3rem !important; }
  .column-gap-lg-0 {
    column-gap: 0 !important; }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important; }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important; }
  .column-gap-lg-3 {
    column-gap: 1rem !important; }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important; }
  .column-gap-lg-5 {
    column-gap: 3rem !important; }
  .text-lg-start {
    text-align: left !important; }
  .text-lg-end {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important; }
  .float-xl-end {
    float: right !important; }
  .float-xl-none {
    float: none !important; }
  .object-fit-xl-contain {
    object-fit: contain !important; }
  .object-fit-xl-cover {
    object-fit: cover !important; }
  .object-fit-xl-fill {
    object-fit: fill !important; }
  .object-fit-xl-scale {
    object-fit: scale-down !important; }
  .object-fit-xl-none {
    object-fit: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-grid {
    display: grid !important; }
  .d-xl-inline-grid {
    display: inline-grid !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; }
  .d-xl-none {
    display: none !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; }
  .order-xl-first {
    order: -1 !important; }
  .order-xl-0 {
    order: 0 !important; }
  .order-xl-1 {
    order: 1 !important; }
  .order-xl-2 {
    order: 2 !important; }
  .order-xl-3 {
    order: 3 !important; }
  .order-xl-4 {
    order: 4 !important; }
  .order-xl-5 {
    order: 5 !important; }
  .order-xl-last {
    order: 6 !important; }
  .m-xl-0 {
    margin: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xl-0 {
    margin-top: 0 !important; }
  .mt-xl-1 {
    margin-top: 0.25rem !important; }
  .mt-xl-2 {
    margin-top: 0.5rem !important; }
  .mt-xl-3 {
    margin-top: 1rem !important; }
  .mt-xl-4 {
    margin-top: 1.5rem !important; }
  .mt-xl-5 {
    margin-top: 3rem !important; }
  .mt-xl-auto {
    margin-top: auto !important; }
  .me-xl-0 {
    margin-right: 0 !important; }
  .me-xl-1 {
    margin-right: 0.25rem !important; }
  .me-xl-2 {
    margin-right: 0.5rem !important; }
  .me-xl-3 {
    margin-right: 1rem !important; }
  .me-xl-4 {
    margin-right: 1.5rem !important; }
  .me-xl-5 {
    margin-right: 3rem !important; }
  .me-xl-auto {
    margin-right: auto !important; }
  .mb-xl-0 {
    margin-bottom: 0 !important; }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xl-3 {
    margin-bottom: 1rem !important; }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xl-5 {
    margin-bottom: 3rem !important; }
  .mb-xl-auto {
    margin-bottom: auto !important; }
  .ms-xl-0 {
    margin-left: 0 !important; }
  .ms-xl-1 {
    margin-left: 0.25rem !important; }
  .ms-xl-2 {
    margin-left: 0.5rem !important; }
  .ms-xl-3 {
    margin-left: 1rem !important; }
  .ms-xl-4 {
    margin-left: 1.5rem !important; }
  .ms-xl-5 {
    margin-left: 3rem !important; }
  .ms-xl-auto {
    margin-left: auto !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xl-n3 {
    margin-top: -1rem !important; }
  .mt-xl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xl-n5 {
    margin-top: -3rem !important; }
  .me-xl-n1 {
    margin-right: -0.25rem !important; }
  .me-xl-n2 {
    margin-right: -0.5rem !important; }
  .me-xl-n3 {
    margin-right: -1rem !important; }
  .me-xl-n4 {
    margin-right: -1.5rem !important; }
  .me-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xl-n3 {
    margin-left: -1rem !important; }
  .ms-xl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xl-n5 {
    margin-left: -3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xl-0 {
    padding-top: 0 !important; }
  .pt-xl-1 {
    padding-top: 0.25rem !important; }
  .pt-xl-2 {
    padding-top: 0.5rem !important; }
  .pt-xl-3 {
    padding-top: 1rem !important; }
  .pt-xl-4 {
    padding-top: 1.5rem !important; }
  .pt-xl-5 {
    padding-top: 3rem !important; }
  .pe-xl-0 {
    padding-right: 0 !important; }
  .pe-xl-1 {
    padding-right: 0.25rem !important; }
  .pe-xl-2 {
    padding-right: 0.5rem !important; }
  .pe-xl-3 {
    padding-right: 1rem !important; }
  .pe-xl-4 {
    padding-right: 1.5rem !important; }
  .pe-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-0 {
    padding-bottom: 0 !important; }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xl-3 {
    padding-bottom: 1rem !important; }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xl-5 {
    padding-bottom: 3rem !important; }
  .ps-xl-0 {
    padding-left: 0 !important; }
  .ps-xl-1 {
    padding-left: 0.25rem !important; }
  .ps-xl-2 {
    padding-left: 0.5rem !important; }
  .ps-xl-3 {
    padding-left: 1rem !important; }
  .ps-xl-4 {
    padding-left: 1.5rem !important; }
  .ps-xl-5 {
    padding-left: 3rem !important; }
  .gap-xl-0 {
    gap: 0 !important; }
  .gap-xl-1 {
    gap: 0.25rem !important; }
  .gap-xl-2 {
    gap: 0.5rem !important; }
  .gap-xl-3 {
    gap: 1rem !important; }
  .gap-xl-4 {
    gap: 1.5rem !important; }
  .gap-xl-5 {
    gap: 3rem !important; }
  .row-gap-xl-0 {
    row-gap: 0 !important; }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xl-3 {
    row-gap: 1rem !important; }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xl-5 {
    row-gap: 3rem !important; }
  .column-gap-xl-0 {
    column-gap: 0 !important; }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xl-3 {
    column-gap: 1rem !important; }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xl-5 {
    column-gap: 3rem !important; }
  .text-xl-start {
    text-align: left !important; }
  .text-xl-end {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important; }
  .float-xxl-end {
    float: right !important; }
  .float-xxl-none {
    float: none !important; }
  .object-fit-xxl-contain {
    object-fit: contain !important; }
  .object-fit-xxl-cover {
    object-fit: cover !important; }
  .object-fit-xxl-fill {
    object-fit: fill !important; }
  .object-fit-xxl-scale {
    object-fit: scale-down !important; }
  .object-fit-xxl-none {
    object-fit: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-grid {
    display: grid !important; }
  .d-xxl-inline-grid {
    display: inline-grid !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; }
  .d-xxl-none {
    display: none !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; }
  .order-xxl-first {
    order: -1 !important; }
  .order-xxl-0 {
    order: 0 !important; }
  .order-xxl-1 {
    order: 1 !important; }
  .order-xxl-2 {
    order: 2 !important; }
  .order-xxl-3 {
    order: 3 !important; }
  .order-xxl-4 {
    order: 4 !important; }
  .order-xxl-5 {
    order: 5 !important; }
  .order-xxl-last {
    order: 6 !important; }
  .m-xxl-0 {
    margin: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xxl-0 {
    margin-top: 0 !important; }
  .mt-xxl-1 {
    margin-top: 0.25rem !important; }
  .mt-xxl-2 {
    margin-top: 0.5rem !important; }
  .mt-xxl-3 {
    margin-top: 1rem !important; }
  .mt-xxl-4 {
    margin-top: 1.5rem !important; }
  .mt-xxl-5 {
    margin-top: 3rem !important; }
  .mt-xxl-auto {
    margin-top: auto !important; }
  .me-xxl-0 {
    margin-right: 0 !important; }
  .me-xxl-1 {
    margin-right: 0.25rem !important; }
  .me-xxl-2 {
    margin-right: 0.5rem !important; }
  .me-xxl-3 {
    margin-right: 1rem !important; }
  .me-xxl-4 {
    margin-right: 1.5rem !important; }
  .me-xxl-5 {
    margin-right: 3rem !important; }
  .me-xxl-auto {
    margin-right: auto !important; }
  .mb-xxl-0 {
    margin-bottom: 0 !important; }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xxl-3 {
    margin-bottom: 1rem !important; }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xxl-5 {
    margin-bottom: 3rem !important; }
  .mb-xxl-auto {
    margin-bottom: auto !important; }
  .ms-xxl-0 {
    margin-left: 0 !important; }
  .ms-xxl-1 {
    margin-left: 0.25rem !important; }
  .ms-xxl-2 {
    margin-left: 0.5rem !important; }
  .ms-xxl-3 {
    margin-left: 1rem !important; }
  .ms-xxl-4 {
    margin-left: 1.5rem !important; }
  .ms-xxl-5 {
    margin-left: 3rem !important; }
  .ms-xxl-auto {
    margin-left: auto !important; }
  .m-xxl-n1 {
    margin: -0.25rem !important; }
  .m-xxl-n2 {
    margin: -0.5rem !important; }
  .m-xxl-n3 {
    margin: -1rem !important; }
  .m-xxl-n4 {
    margin: -1.5rem !important; }
  .m-xxl-n5 {
    margin: -3rem !important; }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xxl-n3 {
    margin-top: -1rem !important; }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xxl-n5 {
    margin-top: -3rem !important; }
  .me-xxl-n1 {
    margin-right: -0.25rem !important; }
  .me-xxl-n2 {
    margin-right: -0.5rem !important; }
  .me-xxl-n3 {
    margin-right: -1rem !important; }
  .me-xxl-n4 {
    margin-right: -1.5rem !important; }
  .me-xxl-n5 {
    margin-right: -3rem !important; }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xxl-n3 {
    margin-left: -1rem !important; }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xxl-n5 {
    margin-left: -3rem !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xxl-0 {
    padding-top: 0 !important; }
  .pt-xxl-1 {
    padding-top: 0.25rem !important; }
  .pt-xxl-2 {
    padding-top: 0.5rem !important; }
  .pt-xxl-3 {
    padding-top: 1rem !important; }
  .pt-xxl-4 {
    padding-top: 1.5rem !important; }
  .pt-xxl-5 {
    padding-top: 3rem !important; }
  .pe-xxl-0 {
    padding-right: 0 !important; }
  .pe-xxl-1 {
    padding-right: 0.25rem !important; }
  .pe-xxl-2 {
    padding-right: 0.5rem !important; }
  .pe-xxl-3 {
    padding-right: 1rem !important; }
  .pe-xxl-4 {
    padding-right: 1.5rem !important; }
  .pe-xxl-5 {
    padding-right: 3rem !important; }
  .pb-xxl-0 {
    padding-bottom: 0 !important; }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xxl-3 {
    padding-bottom: 1rem !important; }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xxl-5 {
    padding-bottom: 3rem !important; }
  .ps-xxl-0 {
    padding-left: 0 !important; }
  .ps-xxl-1 {
    padding-left: 0.25rem !important; }
  .ps-xxl-2 {
    padding-left: 0.5rem !important; }
  .ps-xxl-3 {
    padding-left: 1rem !important; }
  .ps-xxl-4 {
    padding-left: 1.5rem !important; }
  .ps-xxl-5 {
    padding-left: 3rem !important; }
  .gap-xxl-0 {
    gap: 0 !important; }
  .gap-xxl-1 {
    gap: 0.25rem !important; }
  .gap-xxl-2 {
    gap: 0.5rem !important; }
  .gap-xxl-3 {
    gap: 1rem !important; }
  .gap-xxl-4 {
    gap: 1.5rem !important; }
  .gap-xxl-5 {
    gap: 3rem !important; }
  .row-gap-xxl-0 {
    row-gap: 0 !important; }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xxl-3 {
    row-gap: 1rem !important; }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xxl-5 {
    row-gap: 3rem !important; }
  .column-gap-xxl-0 {
    column-gap: 0 !important; }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xxl-3 {
    column-gap: 1rem !important; }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xxl-5 {
    column-gap: 3rem !important; }
  .text-xxl-start {
    text-align: left !important; }
  .text-xxl-end {
    text-align: right !important; }
  .text-xxl-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.1875rem !important; }
  .fs-2 {
    font-size: 1.75rem !important; }
  .fs-3 {
    font-size: 1.53125rem !important; }
  .fs-4 {
    font-size: 1.3125rem !important; } }

@media print {
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-grid {
    display: grid !important; }
  .d-print-inline-grid {
    display: inline-grid !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; }
  .d-print-none {
    display: none !important; } }

/* =============
   General
============= */
html {
  position: relative;
  min-height: 100%;
  background-color: white; }

.h1,
.h2,
.h3,
.h4,
.h5,
.h6, h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: #343a40;
  font-family: "Work Sans", sans-serif; }

a {
  text-decoration: none !important; }

label {
  font-weight: 600;
  margin-bottom: 0.5rem; }

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid #f1f5f7; }

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #f1f5f7;
  text-align: right; }

.row > * {
  position: relative; }

.bg-soft-primary {
  background-color: rgba(36, 78, 162, 0.25) !important; }

.bg-soft-primary-dark {
  background-color: rgba(38, 56, 116, 0.25) !important; }

.bg-soft-gray-secundary {
  background-color: rgba(108, 108, 108, 0.25) !important; }

.bg-soft-secondary {
  background-color: rgba(116, 120, 141, 0.25) !important; }

.bg-soft-success {
  background-color: rgba(75, 181, 67, 0.25) !important; }

.bg-soft-info {
  background-color: rgba(240, 240, 240, 0.25) !important; }

.bg-soft-warning {
  background-color: rgba(254, 206, 34, 0.25) !important; }

.bg-soft-danger {
  background-color: rgba(236, 34, 31, 0.25) !important; }

.bg-soft-pink {
  background-color: rgba(232, 62, 140, 0.25) !important; }

.bg-soft-light {
  background-color: rgba(239, 242, 247, 0.25) !important; }

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.25) !important; }

.bg-soft-dark-gray-primary {
  background-color: rgba(53, 53, 53, 0.25) !important; }

.bg-soft-light-gray-05 {
  background-color: rgba(217, 217, 217, 0.25) !important; }

.bg-soft-light-gray-03 {
  background-color: rgba(226, 226, 226, 0.25) !important; }

.bg-soft-light_gray_04 {
  background-color: rgba(230, 230, 230, 0.25) !important; }

.bg-soft-light-gray-06 {
  background-color: rgba(205, 205, 205, 0.25) !important; }

.bg-soft-light_blue_04 {
  background-color: rgba(0, 117, 162, 0.25) !important; }

.bg-soft-light-blue-01 {
  background-color: rgba(73, 142, 242, 0.25) !important; }

.bg-soft-light-blue-11 {
  background-color: rgba(89, 108, 163, 0.25) !important; }

.bg-soft-light-blue-06 {
  background-color: rgba(31, 163, 204, 0.25) !important; }

.bg-soft-light-blue-08 {
  background-color: rgba(214, 217, 226, 0.25) !important; }

.bg-soft-light-blue-13 {
  background-color: rgba(229, 231, 238, 0.25) !important; }

.bg-soft-light-blue-14 {
  background-color: rgba(152, 161, 187, 0.25) !important; }

.bg-soft-color-azul1 {
  background-color: rgba(15, 29, 66, 0.25) !important; }

.bg-soft-color-azul2 {
  background-color: rgba(38, 56, 116, 0.25) !important; }

.bg-soft-color-azul2-hover {
  background-color: rgba(54, 75, 140, 0.25) !important; }

.bg-soft-color-azul3 {
  background-color: rgba(36, 78, 162, 0.25) !important; }

.bg-soft-color-azul4 {
  background-color: rgba(73, 142, 242, 0.25) !important; }

.bg-soft-color-azul5 {
  background-color: rgba(130, 192, 249, 0.25) !important; }

.bg-soft-color-azul6 {
  background-color: rgba(0, 83, 102, 0.25) !important; }

.bg-soft-color-azul7 {
  background-color: rgba(0, 117, 162, 0.25) !important; }

.bg-soft-color-azul8 {
  background-color: rgba(31, 163, 204, 0.25) !important; }

.bg-soft-color-azul9 {
  background-color: rgba(125, 195, 220, 0.25) !important; }

.bg-soft-color-azul10 {
  background-color: rgba(157, 230, 230, 0.25) !important; }

.bg-soft-color-azul11 {
  background-color: rgba(214, 217, 226, 0.25) !important; }

.bg-soft-color-azul410 {
  background-color: rgba(193, 224, 255, 0.25) !important; }

.bg-soft-color-azul130 {
  background-color: rgba(106, 121, 156, 0.25) !important; }

.bg-soft-color-azul405 {
  background-color: rgba(229, 243, 255, 0.25) !important; }

.bg-soft-color-branco2 {
  background-color: rgba(245, 245, 245, 0.25) !important; }

.bg-soft-color-branco3 {
  background-color: rgba(240, 240, 240, 0.25) !important; }

.bg-soft-color-cinza1 {
  background-color: rgba(226, 226, 226, 0.25) !important; }

.bg-soft-color-cinza2 {
  background-color: rgba(217, 217, 217, 0.25) !important; }

.bg-soft-color-cinza2-5 {
  background-color: rgba(205, 205, 205, 0.25) !important; }

.bg-soft-color-cinza3 {
  background-color: rgba(168, 168, 168, 0.25) !important; }

.bg-soft-color-cinza4 {
  background-color: rgba(108, 108, 108, 0.25) !important; }

.bg-soft-color-cinza5 {
  background-color: rgba(53, 53, 53, 0.25) !important; }

.bg-soft-color-cinza6 {
  background-color: rgba(180, 180, 180, 0.25) !important; }

.bg-soft-color-vermelho1 {
  background-color: rgba(236, 34, 31, 0.25) !important; }

.bg-soft-color-vermelho2 {
  background-color: rgba(186, 5, 1, 0.25) !important; }

.bg-soft-color-vermelho3 {
  background-color: rgba(236, 34, 31, 0.25) !important; }

.bg-soft-color-verde1 {
  background-color: rgba(75, 181, 67, 0.25) !important; }

.bg-soft-color-verde2 {
  background-color: rgba(10, 119, 2, 0.25) !important; }

.bg-soft-color-verde3 {
  background-color: rgba(75, 181, 67, 0.25) !important; }

.bg-soft-color-amarelo1 {
  background-color: rgba(254, 206, 34, 0.25) !important; }

.bg-soft-color-amarelo2 {
  background-color: rgba(127, 109, 49, 0.25) !important; }

.bg-soft-color-amarelo3 {
  background-color: rgba(254, 206, 34, 0.25) !important; }

.bg-soft-color-laranja1 {
  background-color: rgba(255, 98, 65, 0.25) !important; }

.badge[href]:hover, .badge[href]:focus {
  color: #fff; }

.badge.bg-primary[href]:hover, .badge.bg-primary[href]:focus {
  background-color: #204691 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-primary {
  color: #244EA2;
  background-color: rgba(36, 78, 162, 0.18); }
  .badge-soft-primary[href]:hover, .badge-soft-primary[href]:focus {
    color: #244EA2;
    text-decoration: none;
    background-color: rgba(36, 78, 162, 0.4); }

.badge.bg-primary-dark[href]:hover, .badge.bg-primary-dark[href]:focus {
  background-color: #213165 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-primary-dark {
  color: #263874;
  background-color: rgba(38, 56, 116, 0.18); }
  .badge-soft-primary-dark[href]:hover, .badge-soft-primary-dark[href]:focus {
    color: #263874;
    text-decoration: none;
    background-color: rgba(38, 56, 116, 0.4); }

.badge.bg-gray-secundary[href]:hover, .badge.bg-gray-secundary[href]:focus {
  background-color: #626262 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-gray-secundary {
  color: #6C6C6C;
  background-color: rgba(108, 108, 108, 0.18); }
  .badge-soft-gray-secundary[href]:hover, .badge-soft-gray-secundary[href]:focus {
    color: #6C6C6C;
    text-decoration: none;
    background-color: rgba(108, 108, 108, 0.4); }

.badge.bg-secondary[href]:hover, .badge.bg-secondary[href]:focus {
  background-color: #6b6e82 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18); }
  .badge-soft-secondary[href]:hover, .badge-soft-secondary[href]:focus {
    color: #74788d;
    text-decoration: none;
    background-color: rgba(116, 120, 141, 0.4); }

.badge.bg-success[href]:hover, .badge.bg-success[href]:focus {
  background-color: #45a63d !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-success {
  color: #4bb543;
  background-color: rgba(75, 181, 67, 0.18); }
  .badge-soft-success[href]:hover, .badge-soft-success[href]:focus {
    color: #4bb543;
    text-decoration: none;
    background-color: rgba(75, 181, 67, 0.4); }

.badge.bg-info[href]:hover, .badge.bg-info[href]:focus {
  background-color: #e6e6e6 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-info {
  color: #F0F0F0;
  background-color: rgba(240, 240, 240, 0.18); }
  .badge-soft-info[href]:hover, .badge-soft-info[href]:focus {
    color: #F0F0F0;
    text-decoration: none;
    background-color: rgba(240, 240, 240, 0.4); }

.badge.bg-warning[href]:hover, .badge.bg-warning[href]:focus {
  background-color: #fec90e !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-warning {
  color: #fece22;
  background-color: rgba(254, 206, 34, 0.18); }
  .badge-soft-warning[href]:hover, .badge-soft-warning[href]:focus {
    color: #fece22;
    text-decoration: none;
    background-color: rgba(254, 206, 34, 0.4); }

.badge.bg-danger[href]:hover, .badge.bg-danger[href]:focus {
  background-color: #e31613 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-danger {
  color: #EC221F;
  background-color: rgba(236, 34, 31, 0.18); }
  .badge-soft-danger[href]:hover, .badge-soft-danger[href]:focus {
    color: #EC221F;
    text-decoration: none;
    background-color: rgba(236, 34, 31, 0.4); }

.badge.bg-pink[href]:hover, .badge.bg-pink[href]:focus {
  background-color: #e62c81 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.18); }
  .badge-soft-pink[href]:hover, .badge-soft-pink[href]:focus {
    color: #e83e8c;
    text-decoration: none;
    background-color: rgba(232, 62, 140, 0.4); }

.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  background-color: #e1e7f0 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light {
  color: #eff2f7;
  background-color: rgba(239, 242, 247, 0.18); }
  .badge-soft-light[href]:hover, .badge-soft-light[href]:focus {
    color: #eff2f7;
    text-decoration: none;
    background-color: rgba(239, 242, 247, 0.4); }

.badge.bg-dark[href]:hover, .badge.bg-dark[href]:focus {
  background-color: #2b3035 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18); }
  .badge-soft-dark[href]:hover, .badge-soft-dark[href]:focus {
    color: #343a40;
    text-decoration: none;
    background-color: rgba(52, 58, 64, 0.4); }

.badge.bg-dark-gray-primary[href]:hover, .badge.bg-dark-gray-primary[href]:focus {
  background-color: #2b2b2b !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-dark-gray-primary {
  color: #353535;
  background-color: rgba(53, 53, 53, 0.18); }
  .badge-soft-dark-gray-primary[href]:hover, .badge-soft-dark-gray-primary[href]:focus {
    color: #353535;
    text-decoration: none;
    background-color: rgba(53, 53, 53, 0.4); }

.badge.bg-light-gray-05[href]:hover, .badge.bg-light-gray-05[href]:focus {
  background-color: #cfcfcf !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-gray-05 {
  color: #D9D9D9;
  background-color: rgba(217, 217, 217, 0.18); }
  .badge-soft-light-gray-05[href]:hover, .badge-soft-light-gray-05[href]:focus {
    color: #D9D9D9;
    text-decoration: none;
    background-color: rgba(217, 217, 217, 0.4); }

.badge.bg-light-gray-03[href]:hover, .badge.bg-light-gray-03[href]:focus {
  background-color: #d8d8d8 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-gray-03 {
  color: #E2E2E2;
  background-color: rgba(226, 226, 226, 0.18); }
  .badge-soft-light-gray-03[href]:hover, .badge-soft-light-gray-03[href]:focus {
    color: #E2E2E2;
    text-decoration: none;
    background-color: rgba(226, 226, 226, 0.4); }

.badge.bg-light_gray_04[href]:hover, .badge.bg-light_gray_04[href]:focus {
  background-color: gainsboro !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light_gray_04 {
  color: #E6E6E6;
  background-color: rgba(230, 230, 230, 0.18); }
  .badge-soft-light_gray_04[href]:hover, .badge-soft-light_gray_04[href]:focus {
    color: #E6E6E6;
    text-decoration: none;
    background-color: rgba(230, 230, 230, 0.4); }

.badge.bg-light-gray-06[href]:hover, .badge.bg-light-gray-06[href]:focus {
  background-color: #c3c3c3 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-gray-06 {
  color: #CDCDCD;
  background-color: rgba(205, 205, 205, 0.18); }
  .badge-soft-light-gray-06[href]:hover, .badge-soft-light-gray-06[href]:focus {
    color: #CDCDCD;
    text-decoration: none;
    background-color: rgba(205, 205, 205, 0.4); }

.badge.bg-light_blue_04[href]:hover, .badge.bg-light_blue_04[href]:focus {
  background-color: #00668e !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light_blue_04 {
  color: #0075A2;
  background-color: rgba(0, 117, 162, 0.18); }
  .badge-soft-light_blue_04[href]:hover, .badge-soft-light_blue_04[href]:focus {
    color: #0075A2;
    text-decoration: none;
    background-color: rgba(0, 117, 162, 0.4); }

.badge.bg-light-blue-01[href]:hover, .badge.bg-light-blue-01[href]:focus {
  background-color: #3682f1 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-blue-01 {
  color: #498EF2;
  background-color: rgba(73, 142, 242, 0.18); }
  .badge-soft-light-blue-01[href]:hover, .badge-soft-light-blue-01[href]:focus {
    color: #498EF2;
    text-decoration: none;
    background-color: rgba(73, 142, 242, 0.4); }

.badge.bg-light-blue-11[href]:hover, .badge.bg-light-blue-11[href]:focus {
  background-color: #526396 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-blue-11 {
  color: #596CA3;
  background-color: rgba(89, 108, 163, 0.18); }
  .badge-soft-light-blue-11[href]:hover, .badge-soft-light-blue-11[href]:focus {
    color: #596CA3;
    text-decoration: none;
    background-color: rgba(89, 108, 163, 0.4); }

.badge.bg-light-blue-06[href]:hover, .badge.bg-light-blue-06[href]:focus {
  background-color: #1c95ba !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-blue-06 {
  color: #1FA3CC;
  background-color: rgba(31, 163, 204, 0.18); }
  .badge-soft-light-blue-06[href]:hover, .badge-soft-light-blue-06[href]:focus {
    color: #1FA3CC;
    text-decoration: none;
    background-color: rgba(31, 163, 204, 0.4); }

.badge.bg-light-blue-08[href]:hover, .badge.bg-light-blue-08[href]:focus {
  background-color: #caceda !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-blue-08 {
  color: #D6D9E2;
  background-color: rgba(214, 217, 226, 0.18); }
  .badge-soft-light-blue-08[href]:hover, .badge-soft-light-blue-08[href]:focus {
    color: #D6D9E2;
    text-decoration: none;
    background-color: rgba(214, 217, 226, 0.4); }

.badge.bg-light-blue-13[href]:hover, .badge.bg-light-blue-13[href]:focus {
  background-color: #d9dce6 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-blue-13 {
  color: #e5e7ee;
  background-color: rgba(229, 231, 238, 0.18); }
  .badge-soft-light-blue-13[href]:hover, .badge-soft-light-blue-13[href]:focus {
    color: #e5e7ee;
    text-decoration: none;
    background-color: rgba(229, 231, 238, 0.4); }

.badge.bg-light-blue-14[href]:hover, .badge.bg-light-blue-14[href]:focus {
  background-color: #8c96b3 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-light-blue-14 {
  color: #98A1BB;
  background-color: rgba(152, 161, 187, 0.18); }
  .badge-soft-light-blue-14[href]:hover, .badge-soft-light-blue-14[href]:focus {
    color: #98A1BB;
    text-decoration: none;
    background-color: rgba(152, 161, 187, 0.4); }

.badge.bg-color-azul1[href]:hover, .badge.bg-color-azul1[href]:focus {
  background-color: #0b1631 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul1 {
  color: #0F1D42;
  background-color: rgba(15, 29, 66, 0.18); }
  .badge-soft-color-azul1[href]:hover, .badge-soft-color-azul1[href]:focus {
    color: #0F1D42;
    text-decoration: none;
    background-color: rgba(15, 29, 66, 0.4); }

.badge.bg-color-azul2[href]:hover, .badge.bg-color-azul2[href]:focus {
  background-color: #213165 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul2 {
  color: #263874;
  background-color: rgba(38, 56, 116, 0.18); }
  .badge-soft-color-azul2[href]:hover, .badge-soft-color-azul2[href]:focus {
    color: #263874;
    text-decoration: none;
    background-color: rgba(38, 56, 116, 0.4); }

.badge.bg-color-azul2-hover[href]:hover, .badge.bg-color-azul2-hover[href]:focus {
  background-color: #30437d !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul2-hover {
  color: #364B8C;
  background-color: rgba(54, 75, 140, 0.18); }
  .badge-soft-color-azul2-hover[href]:hover, .badge-soft-color-azul2-hover[href]:focus {
    color: #364B8C;
    text-decoration: none;
    background-color: rgba(54, 75, 140, 0.4); }

.badge.bg-color-azul3[href]:hover, .badge.bg-color-azul3[href]:focus {
  background-color: #204691 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul3 {
  color: #244EA2;
  background-color: rgba(36, 78, 162, 0.18); }
  .badge-soft-color-azul3[href]:hover, .badge-soft-color-azul3[href]:focus {
    color: #244EA2;
    text-decoration: none;
    background-color: rgba(36, 78, 162, 0.4); }

.badge.bg-color-azul4[href]:hover, .badge.bg-color-azul4[href]:focus {
  background-color: #3682f1 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul4 {
  color: #498EF2;
  background-color: rgba(73, 142, 242, 0.18); }
  .badge-soft-color-azul4[href]:hover, .badge-soft-color-azul4[href]:focus {
    color: #498EF2;
    text-decoration: none;
    background-color: rgba(73, 142, 242, 0.4); }

.badge.bg-color-azul5[href]:hover, .badge.bg-color-azul5[href]:focus {
  background-color: #6fb6f8 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul5 {
  color: #82C0F9;
  background-color: rgba(130, 192, 249, 0.18); }
  .badge-soft-color-azul5[href]:hover, .badge-soft-color-azul5[href]:focus {
    color: #82C0F9;
    text-decoration: none;
    background-color: rgba(130, 192, 249, 0.4); }

.badge.bg-color-azul6[href]:hover, .badge.bg-color-azul6[href]:focus {
  background-color: #004252 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul6 {
  color: #005366;
  background-color: rgba(0, 83, 102, 0.18); }
  .badge-soft-color-azul6[href]:hover, .badge-soft-color-azul6[href]:focus {
    color: #005366;
    text-decoration: none;
    background-color: rgba(0, 83, 102, 0.4); }

.badge.bg-color-azul7[href]:hover, .badge.bg-color-azul7[href]:focus {
  background-color: #00668e !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul7 {
  color: #0075A2;
  background-color: rgba(0, 117, 162, 0.18); }
  .badge-soft-color-azul7[href]:hover, .badge-soft-color-azul7[href]:focus {
    color: #0075A2;
    text-decoration: none;
    background-color: rgba(0, 117, 162, 0.4); }

.badge.bg-color-azul8[href]:hover, .badge.bg-color-azul8[href]:focus {
  background-color: #1c95ba !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul8 {
  color: #1FA3CC;
  background-color: rgba(31, 163, 204, 0.18); }
  .badge-soft-color-azul8[href]:hover, .badge-soft-color-azul8[href]:focus {
    color: #1FA3CC;
    text-decoration: none;
    background-color: rgba(31, 163, 204, 0.4); }

.badge.bg-color-azul9[href]:hover, .badge.bg-color-azul9[href]:focus {
  background-color: #6dbcd8 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul9 {
  color: #7DC3DC;
  background-color: rgba(125, 195, 220, 0.18); }
  .badge-soft-color-azul9[href]:hover, .badge-soft-color-azul9[href]:focus {
    color: #7DC3DC;
    text-decoration: none;
    background-color: rgba(125, 195, 220, 0.4); }

.badge.bg-color-azul10[href]:hover, .badge.bg-color-azul10[href]:focus {
  background-color: #8de2e2 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul10 {
  color: #9DE6E6;
  background-color: rgba(157, 230, 230, 0.18); }
  .badge-soft-color-azul10[href]:hover, .badge-soft-color-azul10[href]:focus {
    color: #9DE6E6;
    text-decoration: none;
    background-color: rgba(157, 230, 230, 0.4); }

.badge.bg-color-azul11[href]:hover, .badge.bg-color-azul11[href]:focus {
  background-color: #caceda !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul11 {
  color: #D6D9E2;
  background-color: rgba(214, 217, 226, 0.18); }
  .badge-soft-color-azul11[href]:hover, .badge-soft-color-azul11[href]:focus {
    color: #D6D9E2;
    text-decoration: none;
    background-color: rgba(214, 217, 226, 0.4); }

.badge.bg-color-azul410[href]:hover, .badge.bg-color-azul410[href]:focus {
  background-color: #add6ff !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul410 {
  color: #C1E0FF;
  background-color: rgba(193, 224, 255, 0.18); }
  .badge-soft-color-azul410[href]:hover, .badge-soft-color-azul410[href]:focus {
    color: #C1E0FF;
    text-decoration: none;
    background-color: rgba(193, 224, 255, 0.4); }

.badge.bg-color-azul130[href]:hover, .badge.bg-color-azul130[href]:focus {
  background-color: #606f91 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul130 {
  color: #6A799C;
  background-color: rgba(106, 121, 156, 0.18); }
  .badge-soft-color-azul130[href]:hover, .badge-soft-color-azul130[href]:focus {
    color: #6A799C;
    text-decoration: none;
    background-color: rgba(106, 121, 156, 0.4); }

.badge.bg-color-azul405[href]:hover, .badge.bg-color-azul405[href]:focus {
  background-color: #d1eaff !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-azul405 {
  color: #E5F3FF;
  background-color: rgba(229, 243, 255, 0.18); }
  .badge-soft-color-azul405[href]:hover, .badge-soft-color-azul405[href]:focus {
    color: #E5F3FF;
    text-decoration: none;
    background-color: rgba(229, 243, 255, 0.4); }

.badge.bg-color-branco2[href]:hover, .badge.bg-color-branco2[href]:focus {
  background-color: #ebebeb !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-branco2 {
  color: #F5F5F5;
  background-color: rgba(245, 245, 245, 0.18); }
  .badge-soft-color-branco2[href]:hover, .badge-soft-color-branco2[href]:focus {
    color: #F5F5F5;
    text-decoration: none;
    background-color: rgba(245, 245, 245, 0.4); }

.badge.bg-color-branco3[href]:hover, .badge.bg-color-branco3[href]:focus {
  background-color: #e6e6e6 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-branco3 {
  color: #F0F0F0;
  background-color: rgba(240, 240, 240, 0.18); }
  .badge-soft-color-branco3[href]:hover, .badge-soft-color-branco3[href]:focus {
    color: #F0F0F0;
    text-decoration: none;
    background-color: rgba(240, 240, 240, 0.4); }

.badge.bg-color-cinza1[href]:hover, .badge.bg-color-cinza1[href]:focus {
  background-color: #d8d8d8 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza1 {
  color: #E2E2E2;
  background-color: rgba(226, 226, 226, 0.18); }
  .badge-soft-color-cinza1[href]:hover, .badge-soft-color-cinza1[href]:focus {
    color: #E2E2E2;
    text-decoration: none;
    background-color: rgba(226, 226, 226, 0.4); }

.badge.bg-color-cinza2[href]:hover, .badge.bg-color-cinza2[href]:focus {
  background-color: #cfcfcf !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza2 {
  color: #D9D9D9;
  background-color: rgba(217, 217, 217, 0.18); }
  .badge-soft-color-cinza2[href]:hover, .badge-soft-color-cinza2[href]:focus {
    color: #D9D9D9;
    text-decoration: none;
    background-color: rgba(217, 217, 217, 0.4); }

.badge.bg-color-cinza2-5[href]:hover, .badge.bg-color-cinza2-5[href]:focus {
  background-color: #c3c3c3 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza2-5 {
  color: #CDCDCD;
  background-color: rgba(205, 205, 205, 0.18); }
  .badge-soft-color-cinza2-5[href]:hover, .badge-soft-color-cinza2-5[href]:focus {
    color: #CDCDCD;
    text-decoration: none;
    background-color: rgba(205, 205, 205, 0.4); }

.badge.bg-color-cinza3[href]:hover, .badge.bg-color-cinza3[href]:focus {
  background-color: #9e9e9e !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza3 {
  color: #A8A8A8;
  background-color: rgba(168, 168, 168, 0.18); }
  .badge-soft-color-cinza3[href]:hover, .badge-soft-color-cinza3[href]:focus {
    color: #A8A8A8;
    text-decoration: none;
    background-color: rgba(168, 168, 168, 0.4); }

.badge.bg-color-cinza4[href]:hover, .badge.bg-color-cinza4[href]:focus {
  background-color: #626262 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza4 {
  color: #6C6C6C;
  background-color: rgba(108, 108, 108, 0.18); }
  .badge-soft-color-cinza4[href]:hover, .badge-soft-color-cinza4[href]:focus {
    color: #6C6C6C;
    text-decoration: none;
    background-color: rgba(108, 108, 108, 0.4); }

.badge.bg-color-cinza5[href]:hover, .badge.bg-color-cinza5[href]:focus {
  background-color: #2b2b2b !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza5 {
  color: #353535;
  background-color: rgba(53, 53, 53, 0.18); }
  .badge-soft-color-cinza5[href]:hover, .badge-soft-color-cinza5[href]:focus {
    color: #353535;
    text-decoration: none;
    background-color: rgba(53, 53, 53, 0.4); }

.badge.bg-color-cinza6[href]:hover, .badge.bg-color-cinza6[href]:focus {
  background-color: rgba(170, 170, 170, 0.0705882) !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-cinza6 {
  color: #B4B4B412;
  background-color: rgba(180, 180, 180, 0.18); }
  .badge-soft-color-cinza6[href]:hover, .badge-soft-color-cinza6[href]:focus {
    color: #B4B4B412;
    text-decoration: none;
    background-color: rgba(180, 180, 180, 0.4); }

.badge.bg-color-vermelho1[href]:hover, .badge.bg-color-vermelho1[href]:focus {
  background-color: #e31613 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-vermelho1 {
  color: #ec221f;
  background-color: rgba(236, 34, 31, 0.18); }
  .badge-soft-color-vermelho1[href]:hover, .badge-soft-color-vermelho1[href]:focus {
    color: #ec221f;
    text-decoration: none;
    background-color: rgba(236, 34, 31, 0.4); }

.badge.bg-color-vermelho2[href]:hover, .badge.bg-color-vermelho2[href]:focus {
  background-color: #a60401 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-vermelho2 {
  color: #BA0501;
  background-color: rgba(186, 5, 1, 0.18); }
  .badge-soft-color-vermelho2[href]:hover, .badge-soft-color-vermelho2[href]:focus {
    color: #BA0501;
    text-decoration: none;
    background-color: rgba(186, 5, 1, 0.4); }

.badge.bg-color-vermelho3[href]:hover, .badge.bg-color-vermelho3[href]:focus {
  background-color: rgba(227, 22, 19, 0.145098) !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-vermelho3 {
  color: #ec221f25;
  background-color: rgba(236, 34, 31, 0.18); }
  .badge-soft-color-vermelho3[href]:hover, .badge-soft-color-vermelho3[href]:focus {
    color: #ec221f25;
    text-decoration: none;
    background-color: rgba(236, 34, 31, 0.4); }

.badge.bg-color-verde1[href]:hover, .badge.bg-color-verde1[href]:focus {
  background-color: #45a63d !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-verde1 {
  color: #4bb543;
  background-color: rgba(75, 181, 67, 0.18); }
  .badge-soft-color-verde1[href]:hover, .badge-soft-color-verde1[href]:focus {
    color: #4bb543;
    text-decoration: none;
    background-color: rgba(75, 181, 67, 0.4); }

.badge.bg-color-verde2[href]:hover, .badge.bg-color-verde2[href]:focus {
  background-color: #086302 !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-verde2 {
  color: #0a7702;
  background-color: rgba(10, 119, 2, 0.18); }
  .badge-soft-color-verde2[href]:hover, .badge-soft-color-verde2[href]:focus {
    color: #0a7702;
    text-decoration: none;
    background-color: rgba(10, 119, 2, 0.4); }

.badge.bg-color-verde3[href]:hover, .badge.bg-color-verde3[href]:focus {
  background-color: rgba(69, 166, 61, 0.145098) !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-verde3 {
  color: #4bb54325;
  background-color: rgba(75, 181, 67, 0.18); }
  .badge-soft-color-verde3[href]:hover, .badge-soft-color-verde3[href]:focus {
    color: #4bb54325;
    text-decoration: none;
    background-color: rgba(75, 181, 67, 0.4); }

.badge.bg-color-amarelo1[href]:hover, .badge.bg-color-amarelo1[href]:focus {
  background-color: #fec90e !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-amarelo1 {
  color: #fece22;
  background-color: rgba(254, 206, 34, 0.18); }
  .badge-soft-color-amarelo1[href]:hover, .badge-soft-color-amarelo1[href]:focus {
    color: #fece22;
    text-decoration: none;
    background-color: rgba(254, 206, 34, 0.4); }

.badge.bg-color-amarelo2[href]:hover, .badge.bg-color-amarelo2[href]:focus {
  background-color: #70602b !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-amarelo2 {
  color: #7f6d31;
  background-color: rgba(127, 109, 49, 0.18); }
  .badge-soft-color-amarelo2[href]:hover, .badge-soft-color-amarelo2[href]:focus {
    color: #7f6d31;
    text-decoration: none;
    background-color: rgba(127, 109, 49, 0.4); }

.badge.bg-color-amarelo3[href]:hover, .badge.bg-color-amarelo3[href]:focus {
  background-color: rgba(254, 201, 14, 0.145098) !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-amarelo3 {
  color: #fece2225;
  background-color: rgba(254, 206, 34, 0.18); }
  .badge-soft-color-amarelo3[href]:hover, .badge-soft-color-amarelo3[href]:focus {
    color: #fece2225;
    text-decoration: none;
    background-color: rgba(254, 206, 34, 0.4); }

.badge.bg-color-laranja1[href]:hover, .badge.bg-color-laranja1[href]:focus {
  background-color: #ff512d !important; }

.badge.bg-light {
  color: #505d69; }
  .badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
    color: #505d69; }

.badge-soft-color-laranja1 {
  color: #ff6241;
  background-color: rgba(255, 98, 65, 0.18); }
  .badge-soft-color-laranja1[href]:hover, .badge-soft-color-laranja1[href]:focus {
    color: #ff6241;
    text-decoration: none;
    background-color: rgba(255, 98, 65, 0.4); }

.badge-h-30 {
  height: 30px; }

.rounded-pill {
  padding-right: .6em;
  padding-left: .6em; }

.badge.bg-dark {
  color: #eff2f7; }

.badge-filter-applied-dynamic:hover {
  color: white !important;
  background-color: #244EA2 !important; }
  .badge-filter-applied-dynamic:hover i {
    color: white !important; }

button,
a {
  outline: none !important; }

.btn-light {
  border: 1px solid #e8ecf4; }

.btn-rounded {
  border-radius: 30px; }

.btn-dark,
.btn-secondary {
  color: #eff2f7 !important; }

.btn-outline-light {
  color: #212529; }

.btn-soft-primary {
  color: #244EA2;
  background-color: rgba(36, 78, 162, 0.1);
  border-color: transparent; }
  .btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary:active {
    color: #fff;
    background-color: #244EA2; }

.btn-soft-primary-dark {
  color: #263874;
  background-color: rgba(38, 56, 116, 0.1);
  border-color: transparent; }
  .btn-soft-primary-dark:hover, .btn-soft-primary-dark:focus, .btn-soft-primary-dark:active {
    color: #fff;
    background-color: #263874; }

.btn-soft-gray-secundary {
  color: #6C6C6C;
  background-color: rgba(108, 108, 108, 0.1);
  border-color: transparent; }
  .btn-soft-gray-secundary:hover, .btn-soft-gray-secundary:focus, .btn-soft-gray-secundary:active {
    color: #fff;
    background-color: #6C6C6C; }

.btn-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.1);
  border-color: transparent; }
  .btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary:active {
    color: #fff;
    background-color: #74788d; }

.btn-soft-success {
  color: #4bb543;
  background-color: rgba(75, 181, 67, 0.1);
  border-color: transparent; }
  .btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success:active {
    color: #fff;
    background-color: #4bb543; }

.btn-soft-info {
  color: #F0F0F0;
  background-color: rgba(240, 240, 240, 0.1);
  border-color: transparent; }
  .btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info:active {
    color: #fff;
    background-color: #F0F0F0; }

.btn-soft-warning {
  color: #fece22;
  background-color: rgba(254, 206, 34, 0.1);
  border-color: transparent; }
  .btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning:active {
    color: #fff;
    background-color: #fece22; }

.btn-soft-danger {
  color: #EC221F;
  background-color: rgba(236, 34, 31, 0.1);
  border-color: transparent; }
  .btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger:active {
    color: #fff;
    background-color: #EC221F; }

.btn-soft-pink {
  color: #e83e8c;
  background-color: rgba(232, 62, 140, 0.1);
  border-color: transparent; }
  .btn-soft-pink:hover, .btn-soft-pink:focus, .btn-soft-pink:active {
    color: #fff;
    background-color: #e83e8c; }

.btn-soft-light {
  color: #eff2f7;
  background-color: rgba(239, 242, 247, 0.1);
  border-color: transparent; }
  .btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light:active {
    color: #fff;
    background-color: #eff2f7; }

.btn-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.1);
  border-color: transparent; }
  .btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark:active {
    color: #fff;
    background-color: #343a40; }

.btn-soft-dark-gray-primary {
  color: #353535;
  background-color: rgba(53, 53, 53, 0.1);
  border-color: transparent; }
  .btn-soft-dark-gray-primary:hover, .btn-soft-dark-gray-primary:focus, .btn-soft-dark-gray-primary:active {
    color: #fff;
    background-color: #353535; }

.btn-soft-light-gray-05 {
  color: #D9D9D9;
  background-color: rgba(217, 217, 217, 0.1);
  border-color: transparent; }
  .btn-soft-light-gray-05:hover, .btn-soft-light-gray-05:focus, .btn-soft-light-gray-05:active {
    color: #fff;
    background-color: #D9D9D9; }

.btn-soft-light-gray-03 {
  color: #E2E2E2;
  background-color: rgba(226, 226, 226, 0.1);
  border-color: transparent; }
  .btn-soft-light-gray-03:hover, .btn-soft-light-gray-03:focus, .btn-soft-light-gray-03:active {
    color: #fff;
    background-color: #E2E2E2; }

.btn-soft-light_gray_04 {
  color: #E6E6E6;
  background-color: rgba(230, 230, 230, 0.1);
  border-color: transparent; }
  .btn-soft-light_gray_04:hover, .btn-soft-light_gray_04:focus, .btn-soft-light_gray_04:active {
    color: #fff;
    background-color: #E6E6E6; }

.btn-soft-light-gray-06 {
  color: #CDCDCD;
  background-color: rgba(205, 205, 205, 0.1);
  border-color: transparent; }
  .btn-soft-light-gray-06:hover, .btn-soft-light-gray-06:focus, .btn-soft-light-gray-06:active {
    color: #fff;
    background-color: #CDCDCD; }

.btn-soft-light_blue_04 {
  color: #0075A2;
  background-color: rgba(0, 117, 162, 0.1);
  border-color: transparent; }
  .btn-soft-light_blue_04:hover, .btn-soft-light_blue_04:focus, .btn-soft-light_blue_04:active {
    color: #fff;
    background-color: #0075A2; }

.btn-soft-light-blue-01 {
  color: #498EF2;
  background-color: rgba(73, 142, 242, 0.1);
  border-color: transparent; }
  .btn-soft-light-blue-01:hover, .btn-soft-light-blue-01:focus, .btn-soft-light-blue-01:active {
    color: #fff;
    background-color: #498EF2; }

.btn-soft-light-blue-11 {
  color: #596CA3;
  background-color: rgba(89, 108, 163, 0.1);
  border-color: transparent; }
  .btn-soft-light-blue-11:hover, .btn-soft-light-blue-11:focus, .btn-soft-light-blue-11:active {
    color: #fff;
    background-color: #596CA3; }

.btn-soft-light-blue-06 {
  color: #1FA3CC;
  background-color: rgba(31, 163, 204, 0.1);
  border-color: transparent; }
  .btn-soft-light-blue-06:hover, .btn-soft-light-blue-06:focus, .btn-soft-light-blue-06:active {
    color: #fff;
    background-color: #1FA3CC; }

.btn-soft-light-blue-08 {
  color: #D6D9E2;
  background-color: rgba(214, 217, 226, 0.1);
  border-color: transparent; }
  .btn-soft-light-blue-08:hover, .btn-soft-light-blue-08:focus, .btn-soft-light-blue-08:active {
    color: #fff;
    background-color: #D6D9E2; }

.btn-soft-light-blue-13 {
  color: #e5e7ee;
  background-color: rgba(229, 231, 238, 0.1);
  border-color: transparent; }
  .btn-soft-light-blue-13:hover, .btn-soft-light-blue-13:focus, .btn-soft-light-blue-13:active {
    color: #fff;
    background-color: #e5e7ee; }

.btn-soft-light-blue-14 {
  color: #98A1BB;
  background-color: rgba(152, 161, 187, 0.1);
  border-color: transparent; }
  .btn-soft-light-blue-14:hover, .btn-soft-light-blue-14:focus, .btn-soft-light-blue-14:active {
    color: #fff;
    background-color: #98A1BB; }

.btn-soft-color-azul1 {
  color: #0F1D42;
  background-color: rgba(15, 29, 66, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul1:hover, .btn-soft-color-azul1:focus, .btn-soft-color-azul1:active {
    color: #fff;
    background-color: #0F1D42; }

.btn-soft-color-azul2 {
  color: #263874;
  background-color: rgba(38, 56, 116, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul2:hover, .btn-soft-color-azul2:focus, .btn-soft-color-azul2:active {
    color: #fff;
    background-color: #263874; }

.btn-soft-color-azul2-hover {
  color: #364B8C;
  background-color: rgba(54, 75, 140, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul2-hover:hover, .btn-soft-color-azul2-hover:focus, .btn-soft-color-azul2-hover:active {
    color: #fff;
    background-color: #364B8C; }

.btn-soft-color-azul3 {
  color: #244EA2;
  background-color: rgba(36, 78, 162, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul3:hover, .btn-soft-color-azul3:focus, .btn-soft-color-azul3:active {
    color: #fff;
    background-color: #244EA2; }

.btn-soft-color-azul4 {
  color: #498EF2;
  background-color: rgba(73, 142, 242, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul4:hover, .btn-soft-color-azul4:focus, .btn-soft-color-azul4:active {
    color: #fff;
    background-color: #498EF2; }

.btn-soft-color-azul5 {
  color: #82C0F9;
  background-color: rgba(130, 192, 249, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul5:hover, .btn-soft-color-azul5:focus, .btn-soft-color-azul5:active {
    color: #fff;
    background-color: #82C0F9; }

.btn-soft-color-azul6 {
  color: #005366;
  background-color: rgba(0, 83, 102, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul6:hover, .btn-soft-color-azul6:focus, .btn-soft-color-azul6:active {
    color: #fff;
    background-color: #005366; }

.btn-soft-color-azul7 {
  color: #0075A2;
  background-color: rgba(0, 117, 162, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul7:hover, .btn-soft-color-azul7:focus, .btn-soft-color-azul7:active {
    color: #fff;
    background-color: #0075A2; }

.btn-soft-color-azul8 {
  color: #1FA3CC;
  background-color: rgba(31, 163, 204, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul8:hover, .btn-soft-color-azul8:focus, .btn-soft-color-azul8:active {
    color: #fff;
    background-color: #1FA3CC; }

.btn-soft-color-azul9 {
  color: #7DC3DC;
  background-color: rgba(125, 195, 220, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul9:hover, .btn-soft-color-azul9:focus, .btn-soft-color-azul9:active {
    color: #fff;
    background-color: #7DC3DC; }

.btn-soft-color-azul10 {
  color: #9DE6E6;
  background-color: rgba(157, 230, 230, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul10:hover, .btn-soft-color-azul10:focus, .btn-soft-color-azul10:active {
    color: #fff;
    background-color: #9DE6E6; }

.btn-soft-color-azul11 {
  color: #D6D9E2;
  background-color: rgba(214, 217, 226, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul11:hover, .btn-soft-color-azul11:focus, .btn-soft-color-azul11:active {
    color: #fff;
    background-color: #D6D9E2; }

.btn-soft-color-azul410 {
  color: #C1E0FF;
  background-color: rgba(193, 224, 255, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul410:hover, .btn-soft-color-azul410:focus, .btn-soft-color-azul410:active {
    color: #fff;
    background-color: #C1E0FF; }

.btn-soft-color-azul130 {
  color: #6A799C;
  background-color: rgba(106, 121, 156, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul130:hover, .btn-soft-color-azul130:focus, .btn-soft-color-azul130:active {
    color: #fff;
    background-color: #6A799C; }

.btn-soft-color-azul405 {
  color: #E5F3FF;
  background-color: rgba(229, 243, 255, 0.1);
  border-color: transparent; }
  .btn-soft-color-azul405:hover, .btn-soft-color-azul405:focus, .btn-soft-color-azul405:active {
    color: #fff;
    background-color: #E5F3FF; }

.btn-soft-color-branco2 {
  color: #F5F5F5;
  background-color: rgba(245, 245, 245, 0.1);
  border-color: transparent; }
  .btn-soft-color-branco2:hover, .btn-soft-color-branco2:focus, .btn-soft-color-branco2:active {
    color: #fff;
    background-color: #F5F5F5; }

.btn-soft-color-branco3 {
  color: #F0F0F0;
  background-color: rgba(240, 240, 240, 0.1);
  border-color: transparent; }
  .btn-soft-color-branco3:hover, .btn-soft-color-branco3:focus, .btn-soft-color-branco3:active {
    color: #fff;
    background-color: #F0F0F0; }

.btn-soft-color-cinza1 {
  color: #E2E2E2;
  background-color: rgba(226, 226, 226, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza1:hover, .btn-soft-color-cinza1:focus, .btn-soft-color-cinza1:active {
    color: #fff;
    background-color: #E2E2E2; }

.btn-soft-color-cinza2 {
  color: #D9D9D9;
  background-color: rgba(217, 217, 217, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza2:hover, .btn-soft-color-cinza2:focus, .btn-soft-color-cinza2:active {
    color: #fff;
    background-color: #D9D9D9; }

.btn-soft-color-cinza2-5 {
  color: #CDCDCD;
  background-color: rgba(205, 205, 205, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza2-5:hover, .btn-soft-color-cinza2-5:focus, .btn-soft-color-cinza2-5:active {
    color: #fff;
    background-color: #CDCDCD; }

.btn-soft-color-cinza3 {
  color: #A8A8A8;
  background-color: rgba(168, 168, 168, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza3:hover, .btn-soft-color-cinza3:focus, .btn-soft-color-cinza3:active {
    color: #fff;
    background-color: #A8A8A8; }

.btn-soft-color-cinza4 {
  color: #6C6C6C;
  background-color: rgba(108, 108, 108, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza4:hover, .btn-soft-color-cinza4:focus, .btn-soft-color-cinza4:active {
    color: #fff;
    background-color: #6C6C6C; }

.btn-soft-color-cinza5 {
  color: #353535;
  background-color: rgba(53, 53, 53, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza5:hover, .btn-soft-color-cinza5:focus, .btn-soft-color-cinza5:active {
    color: #fff;
    background-color: #353535; }

.btn-soft-color-cinza6 {
  color: #B4B4B412;
  background-color: rgba(180, 180, 180, 0.1);
  border-color: transparent; }
  .btn-soft-color-cinza6:hover, .btn-soft-color-cinza6:focus, .btn-soft-color-cinza6:active {
    color: #fff;
    background-color: #B4B4B412; }

.btn-soft-color-vermelho1 {
  color: #ec221f;
  background-color: rgba(236, 34, 31, 0.1);
  border-color: transparent; }
  .btn-soft-color-vermelho1:hover, .btn-soft-color-vermelho1:focus, .btn-soft-color-vermelho1:active {
    color: #fff;
    background-color: #ec221f; }

.btn-soft-color-vermelho2 {
  color: #BA0501;
  background-color: rgba(186, 5, 1, 0.1);
  border-color: transparent; }
  .btn-soft-color-vermelho2:hover, .btn-soft-color-vermelho2:focus, .btn-soft-color-vermelho2:active {
    color: #fff;
    background-color: #BA0501; }

.btn-soft-color-vermelho3 {
  color: #ec221f25;
  background-color: rgba(236, 34, 31, 0.1);
  border-color: transparent; }
  .btn-soft-color-vermelho3:hover, .btn-soft-color-vermelho3:focus, .btn-soft-color-vermelho3:active {
    color: #fff;
    background-color: #ec221f25; }

.btn-soft-color-verde1 {
  color: #4bb543;
  background-color: rgba(75, 181, 67, 0.1);
  border-color: transparent; }
  .btn-soft-color-verde1:hover, .btn-soft-color-verde1:focus, .btn-soft-color-verde1:active {
    color: #fff;
    background-color: #4bb543; }

.btn-soft-color-verde2 {
  color: #0a7702;
  background-color: rgba(10, 119, 2, 0.1);
  border-color: transparent; }
  .btn-soft-color-verde2:hover, .btn-soft-color-verde2:focus, .btn-soft-color-verde2:active {
    color: #fff;
    background-color: #0a7702; }

.btn-soft-color-verde3 {
  color: #4bb54325;
  background-color: rgba(75, 181, 67, 0.1);
  border-color: transparent; }
  .btn-soft-color-verde3:hover, .btn-soft-color-verde3:focus, .btn-soft-color-verde3:active {
    color: #fff;
    background-color: #4bb54325; }

.btn-soft-color-amarelo1 {
  color: #fece22;
  background-color: rgba(254, 206, 34, 0.1);
  border-color: transparent; }
  .btn-soft-color-amarelo1:hover, .btn-soft-color-amarelo1:focus, .btn-soft-color-amarelo1:active {
    color: #fff;
    background-color: #fece22; }

.btn-soft-color-amarelo2 {
  color: #7f6d31;
  background-color: rgba(127, 109, 49, 0.1);
  border-color: transparent; }
  .btn-soft-color-amarelo2:hover, .btn-soft-color-amarelo2:focus, .btn-soft-color-amarelo2:active {
    color: #fff;
    background-color: #7f6d31; }

.btn-soft-color-amarelo3 {
  color: #fece2225;
  background-color: rgba(254, 206, 34, 0.1);
  border-color: transparent; }
  .btn-soft-color-amarelo3:hover, .btn-soft-color-amarelo3:focus, .btn-soft-color-amarelo3:active {
    color: #fff;
    background-color: #fece2225; }

.btn-soft-color-laranja1 {
  color: #ff6241;
  background-color: rgba(255, 98, 65, 0.1);
  border-color: transparent; }
  .btn-soft-color-laranja1:hover, .btn-soft-color-laranja1:focus, .btn-soft-color-laranja1:active {
    color: #fff;
    background-color: #ff6241; }

.btn-group-vertical label {
  margin-bottom: 0; }

.btn-fechar {
  background: transparent;
  border: none;
  color: #6c757d;
  height: 32px;
  padding: 0 12px; }
  .btn-fechar:hover {
    background-color: #f1f3f5;
    color: #498ef2; }
  .btn-fechar:focus, .btn-fechar:active {
    box-shadow: none;
    outline: none; }

.btn-comparar {
  background-color: #263874;
  border-color: #263874;
  color: #fff; }
  .btn-comparar:hover {
    background-color: #364b8c;
    border-color: #364b8c;
    color: #fff; }
  .btn-comparar:focus, .btn-comparar:active {
    background-color: #364b8c;
    border-color: #364b8c;
    box-shadow: none; }
  .btn-comparar:disabled {
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    color: #8c8c8c;
    cursor: not-allowed; }

.btn-primary-dark,
.btn-color-azul2 {
  height: 40px;
  display: flex;
  align-items: center;
  transition: 0.2s ease-in-out;
  justify-content: center; }
  .btn-primary-dark:hover,
  .btn-color-azul2:hover {
    background-color: #364B8C !important; }

.bg-primary-dark-inverse {
  border: 1px solid #A8A8A8;
  background-color: transparent;
  color: #263874; }
  .bg-primary-dark-inverse:hover, .bg-primary-dark-inverse:active {
    background-color: #263874;
    color: #fff; }
  .bg-primary-dark-inverse.hover-cancel:hover, .bg-primary-dark-inverse.hover-cancel:active {
    background-color: transparent !important;
    color: #ec221f !important; }

.btn-confirmar-co0005 {
  background-color: #263874;
  border-color: #263874;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  transition: 0.2s ease-in-out; }
  .btn-confirmar-co0005:hover {
    background-color: #596CA3 !important;
    border-color: #596CA3 !important;
    color: #fff; }

.btn-cancelar-co0005 {
  background-color: transparent;
  border: none;
  color: #0F1D42;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  transition: 0.2s ease-in-out; }
  .btn-cancelar-co0005:hover {
    background-color: transparent;
    border: none;
    color: #ec221f; }

.df-co0010-btn-transition, .btn-cancelar-split, .btn-salvar-split {
  transition: 0.2s ease-in-out; }

.btn-cancelar-split {
  background: transparent;
  color: #0f1d42; }
  .btn-cancelar-split:hover {
    color: #ec221f !important; }

.btn-salvar-split {
  background: #263874;
  color: #ffffff; }
  .btn-salvar-split:hover {
    background: #364b8c !important;
    color: #ffffff; }
  .btn-salvar-split:disabled {
    opacity: 0.7; }

.calendary-picker-bizin {
  position: relative;
  display: inline-flex;
  align-items: center; }

.flatpickr-icon-bizin {
  position: absolute;
  right: 1rem;
  cursor: pointer;
  font-size: 1.2rem;
  color: #555;
  color: #263874; }

.flatpickr-bizin {
  border: 1px solid #a8a8a8;
  border-radius: 0.375rem;
  overflow: hidden;
  display: flex !important;
  flex-wrap: nowrap !important;
  border-radius: 12px;
  width: 0% !important;
  display: none;
  border-left: 0px !important;
  border-radius: 0px 10px 10px 0px !important;
  padding: 22px !important; }

.flatpickr-input-bizin {
  padding-right: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 10px 0px 0px 10px !important; }

.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  box-shadow: 0 3px 13px rgba(0, 0, 0, 0.08); }

.flatpickr-calendar.open,
.flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible; }

.flatpickr-calendar.open {
  display: inline-block;
  z-index: 99999; }

.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1); }

.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px; }

.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px); }

.flatpickr-calendar.static.open {
  z-index: 999;
  display: block; }

.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
  box-shadow: none !important; }

.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6; }

.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }

.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0; }

.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid rgba(72, 72, 72, 0.2); }

.flatpickr-calendar.hasTime .flatpickr-innerContainer {
  border-bottom: 0; }

.flatpickr-calendar.hasTime .flatpickr-time {
  border: 1px solid rgba(72, 72, 72, 0.2); }

.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto; }

.flatpickr-calendar:before,
.flatpickr-calendar:after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: '';
  height: 0;
  width: 0;
  left: 22px; }

.flatpickr-calendar.rightMost:before,
.flatpickr-calendar.arrowRight:before,
.flatpickr-calendar.rightMost:after,
.flatpickr-calendar.arrowRight:after {
  left: auto;
  right: 22px; }

.flatpickr-calendar.arrowCenter:before,
.flatpickr-calendar.arrowCenter:after {
  left: 50%;
  right: 50%; }

.flatpickr-calendar:before {
  border-width: 5px;
  margin: 0 -5px; }

.flatpickr-calendar:after {
  border-width: 4px;
  margin: 0 -4px; }

.flatpickr-calendar.arrowTop:before,
.flatpickr-calendar.arrowTop:after {
  bottom: 100%; }

.flatpickr-calendar.arrowTop:before {
  border-bottom-color: rgba(72, 72, 72, 0.2); }

.flatpickr-calendar.arrowTop:after {
  border-bottom-color: #263874; }

.flatpickr-calendar.arrowBottom:before,
.flatpickr-calendar.arrowBottom:after {
  top: 100%; }

.flatpickr-calendar.arrowBottom:before {
  border-top-color: rgba(72, 72, 72, 0.2); }

.flatpickr-calendar.arrowBottom:after {
  border-top-color: #263874; }

.flatpickr-calendar:focus {
  outline: 0; }

.flatpickr-wrapper {
  position: relative;
  display: inline-block; }

.flatpickr-months {
  display: flex; }

.flatpickr-months .flatpickr-month {
  border-radius: 5px 5px 0 0;
  background: #263874;
  color: #fff;
  fill: #fff;
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
  flex: 1 1; }

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: #fff;
  fill: #fff; }

.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
  display: none; }

.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative; }

.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  left: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */ }

/*
        /*rtl:begin:ignore*/
/*
        /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  right: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */ }

/*
        /*rtl:begin:ignore*/
/*
        /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #bbb; }

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #f64747; }

.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px; }

.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: inherit; }

.numInputWrapper {
  position: relative;
  height: auto; }

.numInputWrapper input,
.numInputWrapper span {
  display: inline-block; }

.numInputWrapper input {
  width: 100%; }

.numInputWrapper input::-ms-clear {
  display: none; }

.numInputWrapper input::-webkit-outer-spin-button,
.numInputWrapper input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none; }

.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(72, 72, 72, 0.15);
  box-sizing: border-box; }

.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1); }

.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2); }

.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute; }

.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0; }

.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(72, 72, 72, 0.6);
  top: 26%; }

.numInputWrapper span.arrowDown {
  top: 50%; }

.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(72, 72, 72, 0.6);
  top: 40%; }

.numInputWrapper span svg {
  width: inherit;
  height: auto; }

.numInputWrapper span svg path {
  fill: rgba(255, 255, 255, 0.5); }

.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05); }

.numInputWrapper:hover span {
  opacity: 1; }

.flatpickr-current-month {
  font-size: 135%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px); }

.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0; }

.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05); }

.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch\\0;
  display: inline-block; }

.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: #fff; }

.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: #fff; }

.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  appearance: textfield; }

.flatpickr-current-month input.cur-year:focus {
  outline: 0; }

.flatpickr-current-month input.cur-year[disabled],
.flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(255, 255, 255, 0.5);
  background: transparent;
  pointer-events: none; }

.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: #263874;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  -webkit-box-sizing: border-box;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  width: auto; }

.flatpickr-current-month .flatpickr-monthDropdown-months:focus,
.flatpickr-current-month .flatpickr-monthDropdown-months:active {
  outline: none; }

.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: rgba(0, 0, 0, 0.05); }

.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: #263874;
  outline: none;
  padding: 0; }

.flatpickr-weekdays {
  background: #263874;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 28px; }

.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1 1; }

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #263874;
  color: white;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: bolder; }

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0; }

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
  border-left: 1px solid rgba(72, 72, 72, 0.2);
  border-right: 1px solid rgba(72, 72, 72, 0.2); }

.flatpickr-days:focus {
  outline: 0; }

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1; }

.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 rgba(72, 72, 72, 0.2); }

.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: #484848;
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center; }

.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background: #e2e2e2;
  border-color: #e2e2e2; }

.flatpickr-day.today {
  border-color: #bbb; }

.flatpickr-day.today:hover,
.flatpickr-day.today:focus {
  border-color: #bbb;
  background: #bbb;
  color: #fff; }

.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: #244EA2;
  box-shadow: none;
  color: #fff;
  border-color: #244EA2; }

.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange,
.flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px; }

.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange,
.flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0; }

.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #263874; }

.flatpickr-day.selected.startRange.endRange,
.flatpickr-day.startRange.startRange.endRange,
.flatpickr-day.endRange.startRange.endRange {
  border-radius: 50px; }

.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2; }

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(72, 72, 72, 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default; }

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(72, 72, 72, 0.1); }

.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #263874, 5px 0 0 #263874; }

.flatpickr-day.hidden {
  visibility: hidden; }

.rangeMode .flatpickr-day {
  margin-top: 1px; }

.flatpickr-weekwrapper {
  float: left; }

.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  border-left: 1px solid rgba(72, 72, 72, 0.2); }

.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 28px; }

.flatpickr-weekwrapper span.flatpickr-day,
.flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(72, 72, 72, 0.3);
  background: transparent;
  cursor: default;
  border: none; }

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid rgba(72, 72, 72, 0.2); }

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box; }

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  background: #fff;
  border-radius: 0 0 5px 5px; }

.flatpickr-time:after {
  content: "";
  display: table;
  clear: both; }

.flatpickr-time .numInputWrapper {
  flex: 1 1;
  width: 40%;
  height: 40px;
  float: left; }

.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: #484848; }

.flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-color: #484848; }

.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%; }

.flatpickr-time.time24hr .numInputWrapper {
  width: 49%; }

.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: #484848;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  appearance: textfield; }

.flatpickr-time input.flatpickr-hour {
  font-weight: bold; }

.flatpickr-time input.flatpickr-minute,
.flatpickr-time input.flatpickr-second {
  font-weight: 400; }

.flatpickr-time input:focus {
  outline: 0;
  border: 0; }

.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  float: left;
  line-height: inherit;
  color: #484848;
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
  user-select: none;
  align-self: center; }

.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400; }

.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: #eaeaea; }

.flatpickr-input[readonly] {
  cursor: pointer; }

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0); }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0); } }

.breadcrumb-item > a {
  color: #505d69;
  font-size: 14px; }

.breadcrumb-item + .breadcrumb-item {
  padding-left: 8px; }
  .breadcrumb-item + .breadcrumb-item::before {
    content: "";
    border: solid #505d69;
    border-width: 0 1px 1px 0;
    background-color: transparent;
    display: inline-block;
    padding: 0;
    margin-top: 8px;
    margin-right: 10px;
    height: 8px;
    width: 8px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg); }

.describe-transation {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center; }
  .describe-transation span {
    font-family: "Poppins", sans-serif;
    font-weight: 300; }
  .describe-transation span, .describe-transation i {
    font-size: 14px;
    color: #A8A8A8; }

[dir="rtl"] .breadcrumb-item + .breadcrumb-item {
  padding-right: 0.5rem; }
  [dir="rtl"] .breadcrumb-item + .breadcrumb-item::before {
    font-family: "Material Design Icons";
    padding-left: 0;
    content: "\\F0141"; }

.card {
  margin-bottom: 48px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08); }

.card-drop {
  font-size: 20px;
  line-height: 0;
  color: inherit; }

.card-title {
  font-size: 15px;
  margin: 0 0 7px 0;
  font-weight: 500; }

.card-title-desc {
  color: #74788d;
  margin-bottom: 24px; }

.card-primary {
  color: #fff;
  background-color: #244EA2; }
  .card-primary .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-primary .card-title {
    color: #fff; }

.card-primary-dark {
  color: #fff;
  background-color: #263874; }
  .card-primary-dark .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-primary-dark .card-title {
    color: #fff; }

.card-gray-secundary {
  color: #fff;
  background-color: #6C6C6C; }
  .card-gray-secundary .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-gray-secundary .card-title {
    color: #fff; }

.card-secondary {
  color: #fff;
  background-color: #74788d; }
  .card-secondary .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-secondary .card-title {
    color: #fff; }

.card-success {
  color: #fff;
  background-color: #4bb543; }
  .card-success .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-success .card-title {
    color: #fff; }

.card-info {
  color: #fff;
  background-color: #F0F0F0; }
  .card-info .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-info .card-title {
    color: #fff; }

.card-warning {
  color: #fff;
  background-color: #fece22; }
  .card-warning .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-warning .card-title {
    color: #fff; }

.card-danger {
  color: #fff;
  background-color: #EC221F; }
  .card-danger .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-danger .card-title {
    color: #fff; }

.card-pink {
  color: #fff;
  background-color: #e83e8c; }
  .card-pink .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-pink .card-title {
    color: #fff; }

.card-light {
  color: #fff;
  background-color: #eff2f7; }
  .card-light .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light .card-title {
    color: #fff; }

.card-dark {
  color: #fff;
  background-color: #343a40; }
  .card-dark .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-dark .card-title {
    color: #fff; }

.card-dark-gray-primary {
  color: #fff;
  background-color: #353535; }
  .card-dark-gray-primary .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-dark-gray-primary .card-title {
    color: #fff; }

.card-light-gray-05 {
  color: #fff;
  background-color: #D9D9D9; }
  .card-light-gray-05 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-gray-05 .card-title {
    color: #fff; }

.card-light-gray-03 {
  color: #fff;
  background-color: #E2E2E2; }
  .card-light-gray-03 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-gray-03 .card-title {
    color: #fff; }

.card-light_gray_04 {
  color: #fff;
  background-color: #E6E6E6; }
  .card-light_gray_04 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light_gray_04 .card-title {
    color: #fff; }

.card-light-gray-06 {
  color: #fff;
  background-color: #CDCDCD; }
  .card-light-gray-06 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-gray-06 .card-title {
    color: #fff; }

.card-light_blue_04 {
  color: #fff;
  background-color: #0075A2; }
  .card-light_blue_04 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light_blue_04 .card-title {
    color: #fff; }

.card-light-blue-01 {
  color: #fff;
  background-color: #498EF2; }
  .card-light-blue-01 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-blue-01 .card-title {
    color: #fff; }

.card-light-blue-11 {
  color: #fff;
  background-color: #596CA3; }
  .card-light-blue-11 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-blue-11 .card-title {
    color: #fff; }

.card-light-blue-06 {
  color: #fff;
  background-color: #1FA3CC; }
  .card-light-blue-06 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-blue-06 .card-title {
    color: #fff; }

.card-light-blue-08 {
  color: #fff;
  background-color: #D6D9E2; }
  .card-light-blue-08 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-blue-08 .card-title {
    color: #fff; }

.card-light-blue-13 {
  color: #fff;
  background-color: #e5e7ee; }
  .card-light-blue-13 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-blue-13 .card-title {
    color: #fff; }

.card-light-blue-14 {
  color: #fff;
  background-color: #98A1BB; }
  .card-light-blue-14 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-light-blue-14 .card-title {
    color: #fff; }

.card-color-azul1 {
  color: #fff;
  background-color: #0F1D42; }
  .card-color-azul1 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul1 .card-title {
    color: #fff; }

.card-color-azul2 {
  color: #fff;
  background-color: #263874; }
  .card-color-azul2 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul2 .card-title {
    color: #fff; }

.card-color-azul2-hover {
  color: #fff;
  background-color: #364B8C; }
  .card-color-azul2-hover .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul2-hover .card-title {
    color: #fff; }

.card-color-azul3 {
  color: #fff;
  background-color: #244EA2; }
  .card-color-azul3 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul3 .card-title {
    color: #fff; }

.card-color-azul4 {
  color: #fff;
  background-color: #498EF2; }
  .card-color-azul4 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul4 .card-title {
    color: #fff; }

.card-color-azul5 {
  color: #fff;
  background-color: #82C0F9; }
  .card-color-azul5 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul5 .card-title {
    color: #fff; }

.card-color-azul6 {
  color: #fff;
  background-color: #005366; }
  .card-color-azul6 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul6 .card-title {
    color: #fff; }

.card-color-azul7 {
  color: #fff;
  background-color: #0075A2; }
  .card-color-azul7 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul7 .card-title {
    color: #fff; }

.card-color-azul8 {
  color: #fff;
  background-color: #1FA3CC; }
  .card-color-azul8 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul8 .card-title {
    color: #fff; }

.card-color-azul9 {
  color: #fff;
  background-color: #7DC3DC; }
  .card-color-azul9 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul9 .card-title {
    color: #fff; }

.card-color-azul10 {
  color: #fff;
  background-color: #9DE6E6; }
  .card-color-azul10 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul10 .card-title {
    color: #fff; }

.card-color-azul11 {
  color: #fff;
  background-color: #D6D9E2; }
  .card-color-azul11 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul11 .card-title {
    color: #fff; }

.card-color-azul410 {
  color: #fff;
  background-color: #C1E0FF; }
  .card-color-azul410 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul410 .card-title {
    color: #fff; }

.card-color-azul130 {
  color: #fff;
  background-color: #6A799C; }
  .card-color-azul130 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul130 .card-title {
    color: #fff; }

.card-color-azul405 {
  color: #fff;
  background-color: #E5F3FF; }
  .card-color-azul405 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-azul405 .card-title {
    color: #fff; }

.card-color-branco2 {
  color: #fff;
  background-color: #F5F5F5; }
  .card-color-branco2 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-branco2 .card-title {
    color: #fff; }

.card-color-branco3 {
  color: #fff;
  background-color: #F0F0F0; }
  .card-color-branco3 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-branco3 .card-title {
    color: #fff; }

.card-color-cinza1 {
  color: #fff;
  background-color: #E2E2E2; }
  .card-color-cinza1 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza1 .card-title {
    color: #fff; }

.card-color-cinza2 {
  color: #fff;
  background-color: #D9D9D9; }
  .card-color-cinza2 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza2 .card-title {
    color: #fff; }

.card-color-cinza2-5 {
  color: #fff;
  background-color: #CDCDCD; }
  .card-color-cinza2-5 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza2-5 .card-title {
    color: #fff; }

.card-color-cinza3 {
  color: #fff;
  background-color: #A8A8A8; }
  .card-color-cinza3 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza3 .card-title {
    color: #fff; }

.card-color-cinza4 {
  color: #fff;
  background-color: #6C6C6C; }
  .card-color-cinza4 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza4 .card-title {
    color: #fff; }

.card-color-cinza5 {
  color: #fff;
  background-color: #353535; }
  .card-color-cinza5 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza5 .card-title {
    color: #fff; }

.card-color-cinza6 {
  color: #fff;
  background-color: #B4B4B412; }
  .card-color-cinza6 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-cinza6 .card-title {
    color: #fff; }

.card-color-vermelho1 {
  color: #fff;
  background-color: #ec221f; }
  .card-color-vermelho1 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-vermelho1 .card-title {
    color: #fff; }

.card-color-vermelho2 {
  color: #fff;
  background-color: #BA0501; }
  .card-color-vermelho2 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-vermelho2 .card-title {
    color: #fff; }

.card-color-vermelho3 {
  color: #fff;
  background-color: #ec221f25; }
  .card-color-vermelho3 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-vermelho3 .card-title {
    color: #fff; }

.card-color-verde1 {
  color: #fff;
  background-color: #4bb543; }
  .card-color-verde1 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-verde1 .card-title {
    color: #fff; }

.card-color-verde2 {
  color: #fff;
  background-color: #0a7702; }
  .card-color-verde2 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-verde2 .card-title {
    color: #fff; }

.card-color-verde3 {
  color: #fff;
  background-color: #4bb54325; }
  .card-color-verde3 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-verde3 .card-title {
    color: #fff; }

.card-color-amarelo1 {
  color: #fff;
  background-color: #fece22; }
  .card-color-amarelo1 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-amarelo1 .card-title {
    color: #fff; }

.card-color-amarelo2 {
  color: #fff;
  background-color: #7f6d31; }
  .card-color-amarelo2 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-amarelo2 .card-title {
    color: #fff; }

.card-color-amarelo3 {
  color: #fff;
  background-color: #fece2225; }
  .card-color-amarelo3 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-amarelo3 .card-title {
    color: #fff; }

.card-color-laranja1 {
  color: #fff;
  background-color: #ff6241; }
  .card-color-laranja1 .card-header {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff; }
  .card-color-laranja1 .card-title {
    color: #fff; }

.card-border-primary {
  border: 1px solid #244EA2; }
  .card-border-primary .card-header {
    border-bottom: 1px solid #244EA2;
    background: transparent; }
  .card-border-primary .card-footer {
    border-top: 1px solid #244EA2;
    background: transparent; }

.card-border-primary-dark {
  border: 1px solid #263874; }
  .card-border-primary-dark .card-header {
    border-bottom: 1px solid #263874;
    background: transparent; }
  .card-border-primary-dark .card-footer {
    border-top: 1px solid #263874;
    background: transparent; }

.card-border-gray-secundary {
  border: 1px solid #6C6C6C; }
  .card-border-gray-secundary .card-header {
    border-bottom: 1px solid #6C6C6C;
    background: transparent; }
  .card-border-gray-secundary .card-footer {
    border-top: 1px solid #6C6C6C;
    background: transparent; }

.card-border-secondary {
  border: 1px solid #74788d; }
  .card-border-secondary .card-header {
    border-bottom: 1px solid #74788d;
    background: transparent; }
  .card-border-secondary .card-footer {
    border-top: 1px solid #74788d;
    background: transparent; }

.card-border-success {
  border: 1px solid #4bb543; }
  .card-border-success .card-header {
    border-bottom: 1px solid #4bb543;
    background: transparent; }
  .card-border-success .card-footer {
    border-top: 1px solid #4bb543;
    background: transparent; }

.card-border-info {
  border: 1px solid #F0F0F0; }
  .card-border-info .card-header {
    border-bottom: 1px solid #F0F0F0;
    background: transparent; }
  .card-border-info .card-footer {
    border-top: 1px solid #F0F0F0;
    background: transparent; }

.card-border-warning {
  border: 1px solid #fece22; }
  .card-border-warning .card-header {
    border-bottom: 1px solid #fece22;
    background: transparent; }
  .card-border-warning .card-footer {
    border-top: 1px solid #fece22;
    background: transparent; }

.card-border-danger {
  border: 1px solid #EC221F; }
  .card-border-danger .card-header {
    border-bottom: 1px solid #EC221F;
    background: transparent; }
  .card-border-danger .card-footer {
    border-top: 1px solid #EC221F;
    background: transparent; }

.card-border-pink {
  border: 1px solid #e83e8c; }
  .card-border-pink .card-header {
    border-bottom: 1px solid #e83e8c;
    background: transparent; }
  .card-border-pink .card-footer {
    border-top: 1px solid #e83e8c;
    background: transparent; }

.card-border-light {
  border: 1px solid #eff2f7; }
  .card-border-light .card-header {
    border-bottom: 1px solid #eff2f7;
    background: transparent; }
  .card-border-light .card-footer {
    border-top: 1px solid #eff2f7;
    background: transparent; }

.card-border-dark {
  border: 1px solid #343a40; }
  .card-border-dark .card-header {
    border-bottom: 1px solid #343a40;
    background: transparent; }
  .card-border-dark .card-footer {
    border-top: 1px solid #343a40;
    background: transparent; }

.card-border-dark-gray-primary {
  border: 1px solid #353535; }
  .card-border-dark-gray-primary .card-header {
    border-bottom: 1px solid #353535;
    background: transparent; }
  .card-border-dark-gray-primary .card-footer {
    border-top: 1px solid #353535;
    background: transparent; }

.card-border-light-gray-05 {
  border: 1px solid #D9D9D9; }
  .card-border-light-gray-05 .card-header {
    border-bottom: 1px solid #D9D9D9;
    background: transparent; }
  .card-border-light-gray-05 .card-footer {
    border-top: 1px solid #D9D9D9;
    background: transparent; }

.card-border-light-gray-03 {
  border: 1px solid #E2E2E2; }
  .card-border-light-gray-03 .card-header {
    border-bottom: 1px solid #E2E2E2;
    background: transparent; }
  .card-border-light-gray-03 .card-footer {
    border-top: 1px solid #E2E2E2;
    background: transparent; }

.card-border-light_gray_04 {
  border: 1px solid #E6E6E6; }
  .card-border-light_gray_04 .card-header {
    border-bottom: 1px solid #E6E6E6;
    background: transparent; }
  .card-border-light_gray_04 .card-footer {
    border-top: 1px solid #E6E6E6;
    background: transparent; }

.card-border-light-gray-06 {
  border: 1px solid #CDCDCD; }
  .card-border-light-gray-06 .card-header {
    border-bottom: 1px solid #CDCDCD;
    background: transparent; }
  .card-border-light-gray-06 .card-footer {
    border-top: 1px solid #CDCDCD;
    background: transparent; }

.card-border-light_blue_04 {
  border: 1px solid #0075A2; }
  .card-border-light_blue_04 .card-header {
    border-bottom: 1px solid #0075A2;
    background: transparent; }
  .card-border-light_blue_04 .card-footer {
    border-top: 1px solid #0075A2;
    background: transparent; }

.card-border-light-blue-01 {
  border: 1px solid #498EF2; }
  .card-border-light-blue-01 .card-header {
    border-bottom: 1px solid #498EF2;
    background: transparent; }
  .card-border-light-blue-01 .card-footer {
    border-top: 1px solid #498EF2;
    background: transparent; }

.card-border-light-blue-11 {
  border: 1px solid #596CA3; }
  .card-border-light-blue-11 .card-header {
    border-bottom: 1px solid #596CA3;
    background: transparent; }
  .card-border-light-blue-11 .card-footer {
    border-top: 1px solid #596CA3;
    background: transparent; }

.card-border-light-blue-06 {
  border: 1px solid #1FA3CC; }
  .card-border-light-blue-06 .card-header {
    border-bottom: 1px solid #1FA3CC;
    background: transparent; }
  .card-border-light-blue-06 .card-footer {
    border-top: 1px solid #1FA3CC;
    background: transparent; }

.card-border-light-blue-08 {
  border: 1px solid #D6D9E2; }
  .card-border-light-blue-08 .card-header {
    border-bottom: 1px solid #D6D9E2;
    background: transparent; }
  .card-border-light-blue-08 .card-footer {
    border-top: 1px solid #D6D9E2;
    background: transparent; }

.card-border-light-blue-13 {
  border: 1px solid #e5e7ee; }
  .card-border-light-blue-13 .card-header {
    border-bottom: 1px solid #e5e7ee;
    background: transparent; }
  .card-border-light-blue-13 .card-footer {
    border-top: 1px solid #e5e7ee;
    background: transparent; }

.card-border-light-blue-14 {
  border: 1px solid #98A1BB; }
  .card-border-light-blue-14 .card-header {
    border-bottom: 1px solid #98A1BB;
    background: transparent; }
  .card-border-light-blue-14 .card-footer {
    border-top: 1px solid #98A1BB;
    background: transparent; }

.card-border-color-azul1 {
  border: 1px solid #0F1D42; }
  .card-border-color-azul1 .card-header {
    border-bottom: 1px solid #0F1D42;
    background: transparent; }
  .card-border-color-azul1 .card-footer {
    border-top: 1px solid #0F1D42;
    background: transparent; }

.card-border-color-azul2 {
  border: 1px solid #263874; }
  .card-border-color-azul2 .card-header {
    border-bottom: 1px solid #263874;
    background: transparent; }
  .card-border-color-azul2 .card-footer {
    border-top: 1px solid #263874;
    background: transparent; }

.card-border-color-azul2-hover {
  border: 1px solid #364B8C; }
  .card-border-color-azul2-hover .card-header {
    border-bottom: 1px solid #364B8C;
    background: transparent; }
  .card-border-color-azul2-hover .card-footer {
    border-top: 1px solid #364B8C;
    background: transparent; }

.card-border-color-azul3 {
  border: 1px solid #244EA2; }
  .card-border-color-azul3 .card-header {
    border-bottom: 1px solid #244EA2;
    background: transparent; }
  .card-border-color-azul3 .card-footer {
    border-top: 1px solid #244EA2;
    background: transparent; }

.card-border-color-azul4 {
  border: 1px solid #498EF2; }
  .card-border-color-azul4 .card-header {
    border-bottom: 1px solid #498EF2;
    background: transparent; }
  .card-border-color-azul4 .card-footer {
    border-top: 1px solid #498EF2;
    background: transparent; }

.card-border-color-azul5 {
  border: 1px solid #82C0F9; }
  .card-border-color-azul5 .card-header {
    border-bottom: 1px solid #82C0F9;
    background: transparent; }
  .card-border-color-azul5 .card-footer {
    border-top: 1px solid #82C0F9;
    background: transparent; }

.card-border-color-azul6 {
  border: 1px solid #005366; }
  .card-border-color-azul6 .card-header {
    border-bottom: 1px solid #005366;
    background: transparent; }
  .card-border-color-azul6 .card-footer {
    border-top: 1px solid #005366;
    background: transparent; }

.card-border-color-azul7 {
  border: 1px solid #0075A2; }
  .card-border-color-azul7 .card-header {
    border-bottom: 1px solid #0075A2;
    background: transparent; }
  .card-border-color-azul7 .card-footer {
    border-top: 1px solid #0075A2;
    background: transparent; }

.card-border-color-azul8 {
  border: 1px solid #1FA3CC; }
  .card-border-color-azul8 .card-header {
    border-bottom: 1px solid #1FA3CC;
    background: transparent; }
  .card-border-color-azul8 .card-footer {
    border-top: 1px solid #1FA3CC;
    background: transparent; }

.card-border-color-azul9 {
  border: 1px solid #7DC3DC; }
  .card-border-color-azul9 .card-header {
    border-bottom: 1px solid #7DC3DC;
    background: transparent; }
  .card-border-color-azul9 .card-footer {
    border-top: 1px solid #7DC3DC;
    background: transparent; }

.card-border-color-azul10 {
  border: 1px solid #9DE6E6; }
  .card-border-color-azul10 .card-header {
    border-bottom: 1px solid #9DE6E6;
    background: transparent; }
  .card-border-color-azul10 .card-footer {
    border-top: 1px solid #9DE6E6;
    background: transparent; }

.card-border-color-azul11 {
  border: 1px solid #D6D9E2; }
  .card-border-color-azul11 .card-header {
    border-bottom: 1px solid #D6D9E2;
    background: transparent; }
  .card-border-color-azul11 .card-footer {
    border-top: 1px solid #D6D9E2;
    background: transparent; }

.card-border-color-azul410 {
  border: 1px solid #C1E0FF; }
  .card-border-color-azul410 .card-header {
    border-bottom: 1px solid #C1E0FF;
    background: transparent; }
  .card-border-color-azul410 .card-footer {
    border-top: 1px solid #C1E0FF;
    background: transparent; }

.card-border-color-azul130 {
  border: 1px solid #6A799C; }
  .card-border-color-azul130 .card-header {
    border-bottom: 1px solid #6A799C;
    background: transparent; }
  .card-border-color-azul130 .card-footer {
    border-top: 1px solid #6A799C;
    background: transparent; }

.card-border-color-azul405 {
  border: 1px solid #E5F3FF; }
  .card-border-color-azul405 .card-header {
    border-bottom: 1px solid #E5F3FF;
    background: transparent; }
  .card-border-color-azul405 .card-footer {
    border-top: 1px solid #E5F3FF;
    background: transparent; }

.card-border-color-branco2 {
  border: 1px solid #F5F5F5; }
  .card-border-color-branco2 .card-header {
    border-bottom: 1px solid #F5F5F5;
    background: transparent; }
  .card-border-color-branco2 .card-footer {
    border-top: 1px solid #F5F5F5;
    background: transparent; }

.card-border-color-branco3 {
  border: 1px solid #F0F0F0; }
  .card-border-color-branco3 .card-header {
    border-bottom: 1px solid #F0F0F0;
    background: transparent; }
  .card-border-color-branco3 .card-footer {
    border-top: 1px solid #F0F0F0;
    background: transparent; }

.card-border-color-cinza1 {
  border: 1px solid #E2E2E2; }
  .card-border-color-cinza1 .card-header {
    border-bottom: 1px solid #E2E2E2;
    background: transparent; }
  .card-border-color-cinza1 .card-footer {
    border-top: 1px solid #E2E2E2;
    background: transparent; }

.card-border-color-cinza2 {
  border: 1px solid #D9D9D9; }
  .card-border-color-cinza2 .card-header {
    border-bottom: 1px solid #D9D9D9;
    background: transparent; }
  .card-border-color-cinza2 .card-footer {
    border-top: 1px solid #D9D9D9;
    background: transparent; }

.card-border-color-cinza2-5 {
  border: 1px solid #CDCDCD; }
  .card-border-color-cinza2-5 .card-header {
    border-bottom: 1px solid #CDCDCD;
    background: transparent; }
  .card-border-color-cinza2-5 .card-footer {
    border-top: 1px solid #CDCDCD;
    background: transparent; }

.card-border-color-cinza3 {
  border: 1px solid #A8A8A8; }
  .card-border-color-cinza3 .card-header {
    border-bottom: 1px solid #A8A8A8;
    background: transparent; }
  .card-border-color-cinza3 .card-footer {
    border-top: 1px solid #A8A8A8;
    background: transparent; }

.card-border-color-cinza4 {
  border: 1px solid #6C6C6C; }
  .card-border-color-cinza4 .card-header {
    border-bottom: 1px solid #6C6C6C;
    background: transparent; }
  .card-border-color-cinza4 .card-footer {
    border-top: 1px solid #6C6C6C;
    background: transparent; }

.card-border-color-cinza5 {
  border: 1px solid #353535; }
  .card-border-color-cinza5 .card-header {
    border-bottom: 1px solid #353535;
    background: transparent; }
  .card-border-color-cinza5 .card-footer {
    border-top: 1px solid #353535;
    background: transparent; }

.card-border-color-cinza6 {
  border: 1px solid #B4B4B412; }
  .card-border-color-cinza6 .card-header {
    border-bottom: 1px solid #B4B4B412;
    background: transparent; }
  .card-border-color-cinza6 .card-footer {
    border-top: 1px solid #B4B4B412;
    background: transparent; }

.card-border-color-vermelho1 {
  border: 1px solid #ec221f; }
  .card-border-color-vermelho1 .card-header {
    border-bottom: 1px solid #ec221f;
    background: transparent; }
  .card-border-color-vermelho1 .card-footer {
    border-top: 1px solid #ec221f;
    background: transparent; }

.card-border-color-vermelho2 {
  border: 1px solid #BA0501; }
  .card-border-color-vermelho2 .card-header {
    border-bottom: 1px solid #BA0501;
    background: transparent; }
  .card-border-color-vermelho2 .card-footer {
    border-top: 1px solid #BA0501;
    background: transparent; }

.card-border-color-vermelho3 {
  border: 1px solid #ec221f25; }
  .card-border-color-vermelho3 .card-header {
    border-bottom: 1px solid #ec221f25;
    background: transparent; }
  .card-border-color-vermelho3 .card-footer {
    border-top: 1px solid #ec221f25;
    background: transparent; }

.card-border-color-verde1 {
  border: 1px solid #4bb543; }
  .card-border-color-verde1 .card-header {
    border-bottom: 1px solid #4bb543;
    background: transparent; }
  .card-border-color-verde1 .card-footer {
    border-top: 1px solid #4bb543;
    background: transparent; }

.card-border-color-verde2 {
  border: 1px solid #0a7702; }
  .card-border-color-verde2 .card-header {
    border-bottom: 1px solid #0a7702;
    background: transparent; }
  .card-border-color-verde2 .card-footer {
    border-top: 1px solid #0a7702;
    background: transparent; }

.card-border-color-verde3 {
  border: 1px solid #4bb54325; }
  .card-border-color-verde3 .card-header {
    border-bottom: 1px solid #4bb54325;
    background: transparent; }
  .card-border-color-verde3 .card-footer {
    border-top: 1px solid #4bb54325;
    background: transparent; }

.card-border-color-amarelo1 {
  border: 1px solid #fece22; }
  .card-border-color-amarelo1 .card-header {
    border-bottom: 1px solid #fece22;
    background: transparent; }
  .card-border-color-amarelo1 .card-footer {
    border-top: 1px solid #fece22;
    background: transparent; }

.card-border-color-amarelo2 {
  border: 1px solid #7f6d31; }
  .card-border-color-amarelo2 .card-header {
    border-bottom: 1px solid #7f6d31;
    background: transparent; }
  .card-border-color-amarelo2 .card-footer {
    border-top: 1px solid #7f6d31;
    background: transparent; }

.card-border-color-amarelo3 {
  border: 1px solid #fece2225; }
  .card-border-color-amarelo3 .card-header {
    border-bottom: 1px solid #fece2225;
    background: transparent; }
  .card-border-color-amarelo3 .card-footer {
    border-top: 1px solid #fece2225;
    background: transparent; }

.card-border-color-laranja1 {
  border: 1px solid #ff6241; }
  .card-border-color-laranja1 .card-header {
    border-bottom: 1px solid #ff6241;
    background: transparent; }
  .card-border-color-laranja1 .card-footer {
    border-top: 1px solid #ff6241;
    background: transparent; }

.card-context-dynamic-wrapper.cb-variant-bordered .card-context-dynamic {
  border: 1px solid #E2E2E2; }

.card-context-dynamic-wrapper .card-context-dynamic {
  background-color: #fff;
  border: 1px solid #D9D9D9;
  box-shadow: 0px 1px 2px 0px #0000004d;
  border-radius: 12px; }
  .card-context-dynamic-wrapper .card-context-dynamic.pdf-preview {
    box-shadow: none !important; }
  .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item {
    min-width: 120px; }
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .card-context-text,
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .card-context-text * {
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word; }
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .flex-gap-xs {
      gap: 0.125rem;
      display: flex;
      flex-wrap: wrap; }
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .img-card {
      width: 32px;
      height: 32px;
      object-fit: cover;
      border-radius: 50%;
      flex-shrink: 0; }
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .img-context-user {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: 12px;
      flex-shrink: 0;
      font-size: 48px !important; }
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .far.fa-user-circle {
      line-height: 1; }
    .card-context-dynamic-wrapper .card-context-dynamic .card-context-dynamic-item .gap-8 {
      gap: 8px; }

.card-flow-dynamic-container {
  display: inline-flex;
  gap: 10px; }
  .card-flow-dynamic-container .card-flow-logo-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden; }
    .is-modal-page .card-flow-dynamic-container .card-flow-logo-wrapper,
    .modal-dinamic-table-simple .card-flow-dynamic-container .card-flow-logo-wrapper {
      width: 32px;
      height: 32px; }
  .card-flow-dynamic-container .user-photo-label {
    font-size: 48px; }
  .is-modal-page .card-flow-dynamic-container .user-photo-label {
    font-size: 32px; }
  .is-modal-page .card-flow-dynamic-container .card-flow-logo-wrapper {
    width: 32px;
    height: 32px; }
  .card-flow-dynamic-container .card-flow-logo {
    width: 100%;
    height: 100%;
    object-fit: cover; }
  .card-flow-dynamic-container .flow-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px; }
    .card-flow-dynamic-container .flow-item .card-flow-name {
      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0;
      color: #0F1D42;
      max-width: 200px;
      overflow-wrap: break-word; }
    .card-flow-dynamic-container .flow-item .card-flow-size {
      font-size: 0.9em;
      color: #6C6C6C; }
  .card-flow-dynamic-container .card-flow-arrow {
    font-size: 2em;
    color: #676A6C; }

.title-log-cancelamento .accordion-button {
  color: #0F1D42 !important; }

.dropdown {
  width: 100%; }

.dropdown-menu {
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  position: absolute;
  z-index: 1000;
  border-radius: 0;
  padding: 0px; }
  .dropdown-menu.show {
    overflow: visible;
    max-height: calc(100vh - 150px);
    height: auto; }
  .dropdown-menu .dropdown-item .dropdown-menu {
    overflow: visible !important;
    max-height: none !important; }
  .dropdown-menu .dropdown-item .submenu-custom-wrapper {
    overflow: visible !important; }
    .dropdown-menu .dropdown-item .submenu-custom-wrapper .submenu-custom {
      overflow: visible !important; }

.dropdown-kebab-custom-table {
  background-color: #F5F5F5;
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px #0000004d;
  padding: 8px 0; }
  .dropdown-kebab-custom-table .dropdown-item {
    height: 32px;
    padding: 8px;
    font-weight: 400;
    font-size: 14px; }
    .dropdown-kebab-custom-table .dropdown-item i {
      font-size: 18px; }
    .dropdown-kebab-custom-table .dropdown-item:hover {
      background-color: #C1E0FF; }

@media (min-width: 600px) {
  .dropdown-menu-lg {
    width: 320px; }
  .dropdown-menu-md {
    width: 240px; } }

.dropdown-divider {
  border-top-color: #eff2f7; }

.dropdown-mega {
  position: static !important; }

.dropdown-megamenu[style] {
  padding: 20px;
  left: 20px !important;
  right: 20px !important; }

.dropdown-mega-menu-xl {
  width: 40rem; }

.dropdown-mega-menu-lg {
  width: 26rem; }

.dropdown-export-dynamic {
  width: 110px; }
  .dropdown-export-dynamic .dropdown-menu.show {
    border-radius: 4px;
    box-shadow: 0px 1px 2px 0px #0000004d; }
  .dropdown-export-dynamic button {
    color: #263874;
    font-weight: 400; }
    .dropdown-export-dynamic button::after {
      display: none; }
    .dropdown-export-dynamic button:hover {
      background-color: #C1E0FF; }
  .dropdown-export-dynamic i {
    font-size: 24px;
    color: #1FA3CC; }

.dropdown-preset-table .dropdown-menu.show {
  background: #F5F5F5;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0px 1px 2px 0px #0000004d;
  margin-top: 20px;
  margin-left: -240px;
  overflow: auto; }
  .dropdown-preset-table .dropdown-menu.show::-webkit-scrollbar {
    width: 2px; }

.reasons-dropdown {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 999;
  max-height: 250px;
  overflow-y: auto;
  border-radius: 6px;
  box-sizing: border-box;
  background-color: #F5F5F5; }

.reason-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 14px;
  margin: 4px 8px;
  cursor: pointer;
  color: #263874;
  border-radius: 4px;
  transition: background-color 0.2s ease; }

.reason-item:hover {
  background-color: #C1E0FF; }

.reason-item.active {
  background-color: #C1E0FF; }

.reason-item i {
  color: #263874; }

.shadow.mt-1 {
  box-shadow: -1px 3px 0px 0px rgba(0, 0, 0, 0.23) !important; }

.nav-tabs > li > a, .nav-pills > li > a {
  color: #74788d; }

.nav-pills > a {
  color: #74788d; }

.nav-tabs-custom .nav-item {
  margin: 0px 7px;
  position: relative; }
  .nav-tabs-custom .nav-item:first-child {
    margin-left: 0px; }
  .nav-tabs-custom .nav-item:last-child {
    margin-right: 0px; }
  .nav-tabs-custom .nav-item .nav-link {
    background-color: #f1f5f7; }
    .nav-tabs-custom .nav-item .nav-link.active {
      color: #244EA2; }
      .nav-tabs-custom .nav-item .nav-link.active:after {
        transform: scale(1); }
    .nav-tabs-custom .nav-item .nav-link:after {
      content: "";
      background: #244EA2;
      height: 2px;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: -1px;
      transition: all 250ms ease 0s;
      transform: scale(0); }

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px; }
  .vertical-nav .nav .nav-link .nav-icon {
    font-size: 24px; }

.table th {
  font-weight: 600; }

.table .table-light {
  color: #505d69;
  border-color: #eff2f7;
  background-color: #f8f9fa; }

.table-bordered {
  border: 1px solid #eff2f7; }

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap; }

.table > :not(:first-child) {
  border-top: 0; }

.table-centered td,
.table-centered th {
  vertical-align: middle !important; }

.dataTable-custom-primary:has(.p-datatable-row-expansion) .p-datatable-table table thead tr th:last-child {
  border-top-right-radius: 0px !important; }

.dataTable-custom-primary:has(.p-datatable-row-expansion) .p-datatable-table table thead tr th:first-child {
  border-top-left-radius: 0px !important; }

.dataTable-custom-primary button.p-row-toggler.p-link:hover,
.dataTable-custom-primary button.p-row-toggler.p-link:focus,
.dataTable-custom-primary button.p-row-toggler.p-link:active {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important; }

.dataTable-custom-primary .header-expander-icon {
  color: #6c6c6c;
  font-size: 24px;
  width: 16px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center; }

.dataTable-custom-primary button.p-row-toggler {
  width: auto;
  position: relative;
  color: transparent !important; }

.dataTable-custom-primary button.p-row-toggler::after {
  content: "\\f0da";
  font-family: "Font Awesome 7 Pro";
  font-weight: 900;
  font-size: 14px;
  width: 9px;
  height: 14px;
  line-height: 14px;
  color: #6c6c6c;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%); }

.dataTable-custom-primary button.p-row-toggler[aria-expanded="true"]::after {
  content: "\\f0d7"; }

.dataTable-custom-primary table thead tr th {
  border: none; }

.dataTable-custom-primary table thead tr th:last-child {
  border-top-right-radius: 12px; }

.dataTable-custom-primary table thead tr th:first-child {
  border-top-left-radius: 12px; }

.dataTable-custom-primary table tr {
  border-bottom: 1px solid #A8A8A8;
  background-color: transparent; }
  .dataTable-custom-primary table tr:first-child {
    border-top: 1px solid #A8A8A8; }
  .dataTable-custom-primary table tr:last-child {
    border: none !important; }

.dataTable-custom-primary table thead .p-checkbox-box svg {
  fill: white !important;
  color: white !important; }

.dataTable-custom-primary table thead svg {
  fill: #596CA3;
  color: #596CA3; }

.dataTable-custom-primary table thead tr {
  border-color: white;
  border-left: 1px; }
  .dataTable-custom-primary table thead tr th {
    align-content: center;
    height: 56px;
    padding: 0 10px;
    font-size: 0.875rem; }
    .dataTable-custom-primary table thead tr th div {
      color: #263874;
      display: flex;
      align-items: center; }
      .dataTable-custom-primary table thead tr th div span[data-pc-section="sort"] {
        display: none; }

.dataTable-custom-primary table tbody .p-datatable-row-expansion:hover {
  background-color: transparent !important; }

.dataTable-custom-primary table tbody .p-datatable-row-expansion td {
  padding: 0; }

.dataTable-custom-primary table tbody tr {
  position: relative; }
  .dataTable-custom-primary table tbody tr:nth-last-child(1) td:last-child {
    border-end-end-radius: 12px !important; }
  .dataTable-custom-primary table tbody tr:nth-last-child(1) td:first-child {
    border-end-start-radius: 12px !important; }
  .dataTable-custom-primary table tbody tr.p-datatable-emptymessage td {
    padding: 0 10px; }
  .dataTable-custom-primary table tbody tr:hover {
    background-color: #e5e7ee !important; }
  .dataTable-custom-primary table tbody tr:has(.flag-error):hover {
    background-color: #ec221f20 !important; }
  .dataTable-custom-primary table tbody tr:has(.flag-alert):hover {
    background-color: #fece2220 !important; }
  .dataTable-custom-primary table tbody tr:has(.flag-success):hover {
    background-color: #C1E0FF !important; }
  .dataTable-custom-primary table tbody tr:nth-of-type(even) {
    background-color: #F0F0F0; }
  .dataTable-custom-primary table tbody tr:nth-of-type(odd) {
    background-color: #b4b4b41f; }
  .dataTable-custom-primary table tbody tr:has(.no-visited)::after {
    content: "";
    height: 100%;
    top: 0;
    border-left: 4px solid #263874;
    left: 0;
    position: absolute; }
  .dataTable-custom-primary table tbody tr:has(.flag-error)::after {
    content: "";
    height: 100%;
    top: 0;
    border-left: 4px solid #ec221f;
    left: 0;
    position: absolute; }
  .dataTable-custom-primary table tbody tr:has(.flag-alert)::after {
    content: "";
    height: 100%;
    top: 0;
    border-left: 4px solid #fece22;
    left: 0;
    position: absolute; }
  .dataTable-custom-primary table tbody tr:has(.flag-success)::after {
    content: "";
    height: 100%;
    top: 0;
    border-left: 4px solid #244EA2;
    left: 0;
    position: absolute; }
  .dataTable-custom-primary table tbody tr:has(.flag-info)::after {
    content: "";
    height: 100%;
    top: 0;
    border-left: 4px solid #244EA2;
    left: 0;
    position: absolute; }
  .dataTable-custom-primary table tbody tr td {
    font-size: 13px;
    background-color: transparent;
    align-content: center;
    height: 52px;
    border: none;
    color: #353535;
    letter-spacing: -0.3px; }
    .dataTable-custom-primary table tbody tr td > div {
      align-content: center;
      height: 100%;
      display: block; }
    .dataTable-custom-primary table tbody tr td p {
      margin: 0; }
    .dataTable-custom-primary table tbody tr td img {
      max-height: 40px; }
    .dataTable-custom-primary table tbody tr td .no-visited span {
      color: #263874 !important;
      font-weight: 700; }

.dataTable-custom-primary table tfoot tr {
  background-color: #D8F5F5; }
  .dataTable-custom-primary table tfoot tr td {
    color: #263874;
    font-size: 1rem;
    background-color: transparent;
    align-content: center;
    height: 56px; }
    .dataTable-custom-primary table tfoot tr td:last-child {
      border-bottom-right-radius: 10px; }
    .dataTable-custom-primary table tfoot tr td:first-child {
      border-bottom-left-radius: 10px; }

.dataTable-custom-primary.no-header-checkbox table thead .p-column-header-content .p-checkbox {
  display: none !important; }

.dataTable-custom-primary thead th {
  border-bottom: none !important; }

.dataTable-custom-primary thead th:hover,
.dataTable-custom-primary thead th:focus,
.dataTable-custom-primary thead th:active {
  border-bottom: none !important; }

.dataTable-custom-primary .p-column-header-content {
  border: none !important;
  box-shadow: none !important; }
  .dataTable-custom-primary .p-column-header-content .p-column-title {
    font-weight: 800; }

.dataTable-custom-primary .p-cell-editor {
  width: 100%; }

.dataTable-custom-primary .p-cell-editor input {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 34px;
  min-height: 34px;
  max-height: 34px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0 0.75rem;
  display: flex;
  align-items: center;
  box-sizing: border-box; }

.dataTable-custom-primary .p-cell-editor-key-helper {
  display: flex;
  align-items: center;
  height: 34px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  padding: 0 0.75rem;
  box-sizing: border-box; }

.dataTable-custom-primary .p-cell-editor-key-helper {
  cursor: text; }

.dataTable-custom-primary tbody td {
  white-space: normal !important;
  word-break: break-word; }

.dataTable-custom-primary .header-icon-status {
  font-size: 24px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center; }

.row-error-validacao,
.row-error-validacao > td {
  background-color: #EC221F26 !important; }

.modal-dinamic-table-simple .dataTable-custom-primary table thead tr th:last-child {
  border-top-right-radius: 10px; }

.modal-dinamic-table-simple .dataTable-custom-primary table thead tr th:first-child {
  border-top-left-radius: 10px; }

.modal-dinamic-table-simple .dataTable-custom-primary table tbody tr td:last-child {
  border-bottom-right-radius: 10px; }

.modal-dinamic-table-simple .dataTable-custom-primary table tbody tr td:first-child {
  border-bottom-left-radius: 10px; }

.p-dropdown:not(.p-disabled):hover, .p-dropdown:not(.p-disabled):focus-within, .p-dropdown:not(.p-disabled):focus, .p-dropdown:not(.p-disabled):active {
  box-shadow: none !important;
  border-color: #263874;
  outline: none; }

.p-dropdown-panel .p-dropdown-items-wrapper {
  max-height: none !important;
  border-radius: 4px;
  border: 1px solid #A8A8A8;
  padding: 8px 0;
  background-color: #F5F5F5; }
  .p-dropdown-panel .p-dropdown-items-wrapper .p-dropdown-items {
    margin-bottom: 0 !important; }

.p-dropdown-panel .p-dropdown-items {
  padding: 0; }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    color: #263874;
    font-size: 12px;
    font-weight: 400; }
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover {
      background-color: #C1E0FF; }
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
      background-color: #263874;
      border-color: #263874;
      color: white; }

.paginator-table-custom {
  flex-wrap: nowrap;
  background-color: transparent; }
  .paginator-table-custom .p-dropdown {
    height: 36px;
    box-shadow: none !important;
    border-color: #A8A8A8;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0 10px; }
    .paginator-table-custom .p-dropdown.p-inputwrapper-focus {
      border-color: #244EA2; }
    .paginator-table-custom .p-dropdown .p-dropdown-items {
      padding: 0; }
    .paginator-table-custom .p-dropdown .p-dropdown-label {
      padding: 0;
      font-family: "Poppins", sans-serif;
      font-weight: 400;
      font-size: 16px;
      color: black; }
    .paginator-table-custom .p-dropdown .p-dropdown-trigger {
      width: auto; }
      .paginator-table-custom .p-dropdown .p-dropdown-trigger svg {
        width: 8px;
        height: 8px; }
        .paginator-table-custom .p-dropdown .p-dropdown-trigger svg path {
          fill: black; }
  .paginator-table-custom .p-paginator-left-content {
    background-color: #F0F0F0;
    flex: auto;
    border-start-start-radius: 1rem;
    border-end-start-radius: 1rem; }
  .paginator-table-custom .p-paginator-pages .p-link,
  .paginator-table-custom .p-paginator-pages .p-link.no-hover,
  .paginator-table-custom .p-paginator-first,
  .paginator-table-custom .p-paginator-last,
  .paginator-table-custom .p-paginator-prev,
  .paginator-table-custom .p-paginator-next {
    min-height: 32px;
    min-width: 32px;
    height: 32px; }
  .paginator-table-custom .p-paginator-prev:hover,
  .paginator-table-custom .p-paginator-next:hover {
    background-color: #C1E0FF;
    color: #263874; }
  .paginator-table-custom .p-paginator-pages .p-link:not(.no-hover):hover,
  .paginator-table-custom .p-paginator-first:hover,
  .paginator-table-custom .p-paginator-last:hover {
    background-color: #C1E0FF; }
  .paginator-table-custom .p-paginator-pages .p-link.p-highlight {
    background-color: transparent;
    border-bottom: 4px solid #244EA2;
    color: #263874;
    font-weight: 600; }
  .paginator-table-custom .p-link {
    transition: 0.2s ease-in-out;
    font-size: 1.125rem;
    border: 4px solid transparent;
    color: #353535; }
  .paginator-table-custom .p-paginator-pages,
  .paginator-table-custom .p-paginator-first,
  .paginator-table-custom .p-paginator-last {
    background-color: transparent; }
  .paginator-table-custom .p-disabled {
    color: #A8A8A8 !important;
    opacity: 1 !important; }
  .paginator-table-custom.p-paginator-bottom {
    border: none; }

.table-simple-container.active-min-height .p-datatable-wrapper {
  min-height: calc(100vh - 335px); }

.validation-row {
  transition: background-color 0.2s ease; }

.validation-row.success {
  background-color: #eef8ee !important; }

.validation-row.error {
  background-color: #fdecec !important; }

.validation-row.warning {
  background-color: #fff9e5 !important; }

.validation-row.info {
  background-color: #eef5ff !important; }

.validation-row.error:hover {
  background-color: #ec221f40 !important; }

.validation-row.warning:hover {
  background-color: #fece2240 !important; }

.validation-row.success:hover {
  background-color: #4caf5040 !important; }

.validation-row.info:hover {
  background-color: #C1E0FF !important; }

.pagination-rounded .page-link {
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
  text-align: center;
  padding: 0; }

.progress-sm {
  height: 5px; }

.progress-md {
  height: 8px; }

.progress-lg {
  height: 12px; }

.progress-xl {
  height: 16px; }

.animated-progess {
  position: relative; }
  .animated-progess .progress-bar {
    position: relative;
    border-radius: 6px;
    animation: animate-positive 2s; }

.progress-animate {
  position: relative;
  overflow: visible; }
  .progress-animate .progress-bar {
    position: relative;
    border-radius: 6px;
    animation: animate-positive 2s; }
  .progress-animate .progress-value {
    display: block;
    position: absolute;
    top: -26px;
    right: -14px; }

.progress-label {
  display: inline-block;
  position: relative;
  padding: 1px 8px;
  background-color: #fff;
  border: 1px solid;
  border-radius: 0.25rem; }
  .progress-label::after {
    content: "";
    position: absolute;
    height: 10px;
    width: 3px;
    background: #adb5bd;
    left: 0;
    right: 0;
    margin: 0px auto;
    bottom: -11px; }

@keyframes animate-positive {
  0% {
    width: 0; } }

.sortable-list-custom {
  width: auto; }
  .sortable-list-custom .sortable-item {
    padding: 8px 10px;
    height: 42px;
    margin-bottom: 8px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #fff;
    cursor: move;
    -webkit-user-select: none;
            user-select: none;
    transition: .2s ease-in-out; }
    .sortable-list-custom .sortable-item:hover {
      background: #fff;
      border: 1px solid #0F1D42; }
    .sortable-list-custom .sortable-item:active {
      cursor: grabbing; }

/*
Template Name: Upzet -  Admin & Dashboard Template
Author: Themesdesign
Version: 1.1.0
Contact: themesdesign.in@gmail.com
File: Main Css File
*/
#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 80px;
  z-index: 1002;
  background-color: #263874;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08); }
  #page-topbar .dropdown .dropdown-menu-end {
    border-radius: 5px;
    border: 1px solid #A8A8A8; }
    #page-topbar .dropdown .dropdown-menu-end .dropdown-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 16px;
      font-size: 0.75rem; }
      #page-topbar .dropdown .dropdown-menu-end .dropdown-item i {
        font-size: 20px; }
    #page-topbar .dropdown .dropdown-menu-end .container-infos {
      display: flex;
      padding: 6px 15px;
      flex-direction: column;
      color: #0F1D42;
      gap: 4px; }
    #page-topbar .dropdown .dropdown-menu-end .info-business .business-name, #page-topbar .dropdown .dropdown-menu-end .info-profile .business-name {
      font-weight: 600;
      font-size: 1.25rem;
      line-height: 100%;
      padding: 5px 0 0 0; }
    #page-topbar .dropdown .dropdown-menu-end .info-business .business-cnpj, #page-topbar .dropdown .dropdown-menu-end .info-profile .business-cnpj {
      font-weight: 500;
      font-size: 0.75rem; }
    #page-topbar .dropdown .dropdown-menu-end .info-business .business-description, #page-topbar .dropdown .dropdown-menu-end .info-profile .business-description {
      font-weight: 400;
      font-size: 0.75rem; }

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 76px;
  padding: 0 calc(48px / 2) 0 0; }
  .navbar-header .dropdown .show.header-item {
    background-color: #fafafa; }

.navbar-brand-box {
  padding: 0 1rem;
  width: 160px; }

/* Search */
.app-search {
  display: flex;
  align-self: center; }
  .app-search .form-control {
    border: 2px solid transparent;
    height: 42px;
    width: 400px;
    font-size: 1rem;
    color: #eff2f7;
    padding-left: 18px;
    font-weight: 400;
    padding-right: 36px;
    background-color: #182C59;
    box-shadow: none;
    border-radius: 10px; }
    .app-search .form-control:hover, .app-search .form-control:focus, .app-search .form-control:active, .app-search .form-control:focus-within {
      border-color: white !important; }
    .app-search .form-control::placeholder {
      color: #9DE6E6; }
  .app-search i {
    position: absolute;
    z-index: 10;
    padding: 0 16px;
    font-size: 1.25rem;
    line-height: 42px;
    right: 0;
    cursor: pointer;
    top: 0;
    color: #7DC3DC;
    transition: all ease-in-out; }

@media (max-width: 991px) {
  #page-topbar {
    left: 0 !important; }
    #page-topbar .navbar-header .header-item.logo-business div {
      width: auto; }
    #page-topbar .navbar-header .app-search input {
      width: auto; }
  .navbar-brand-box {
    width: auto; }
  .logo span.logo-lg {
    display: none; }
  .logo span.logo-sm {
    display: inline-block; } }

.page-content {
  padding: 30px 15px;
  overflow-x: hidden; }

.page-breadcrumb {
  padding: 0 calc(48px / 2) 0 calc(48px / 2); }

.header-item {
  height: 76px;
  box-shadow: none !important;
  color: #e9ecef;
  border: 0;
  border-radius: 0px; }
  .header-item:hover {
    background-color: #244EA2; }
  .header-item.header-container-profile-user div {
    height: 42px;
    width: 42px;
    object-fit: cover; }
  .header-item.logo-business {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .2s ease-in-out; }
    .header-item.logo-business div {
      height: 42px;
      width: 190px;
      object-fit: cover;
      background-color: #eff2f7;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center; }
      .header-item.logo-business div img {
        height: 32px;
        max-width: 160px; }

.logo-business, .header-container-profile-user {
  background-color: transparent; }
  .logo-business.active-dropdown, .header-container-profile-user.active-dropdown {
    background-color: #244EA2; }

.header-container-profile-user {
  display: flex;
  align-items: center; }
  .header-container-profile-user .header-profile-user {
    height: 42px;
    width: 42px;
    background-color: #f1f5f7;
    padding: 0; }

.header-container-profile-user-dropdown-menu .dropdown-item {
  font-weight: 400; }
  .header-container-profile-user-dropdown-menu .dropdown-item:hover {
    font-weight: 500;
    color: #244EA2;
    background-color: #e5e7ee; }

.noti-icon i {
  font-size: 32px;
  color: #636e75; }

.noti-icon .noti-dot {
  font-size: 10px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #EC221F;
  border-radius: 50%;
  top: 15px;
  min-width: 18px;
  min-height: 18px;
  height: auto;
  width: auto;
  padding: 0px;
  right: 10px; }

.notification-item .d-flex {
  padding: 0.75rem 1rem; }
  .notification-item .d-flex:hover {
    background-color: #f1f5f7; }

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: #74788d; }
  .dropdown-icon-item img {
    height: 24px; }
  .dropdown-icon-item span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .dropdown-icon-item:hover {
    border-color: #eff2f7; }

.fullscreen-enable [data-toggle="fullscreen"] .ri-fullscreen-line:before {
  content: "\\ed73"; }

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static; }
    .navbar-header .dropdown .dropdown-menu {
      left: 10px !important;
      right: 10px !important; } }

@media (max-width: 380px) {
  .navbar-brand-box {
    display: none; } }

body[data-layout="horizontal"] #page-topbar {
  box-shadow: none; }

body[data-layout="horizontal"] .navbar-brand-box {
  width: auto; }

body[data-layout="horizontal"] .page-content {
  margin-top: 76px;
  padding: calc(55px + 48px) calc(48px / 2) 120px calc(48px / 2); }

@media (max-width: 992px) {
  body[data-layout="horizontal"] .page-content {
    margin-top: 15px; } }

#page-topbarInsideTopBarInside {
  position: relative;
  z-index: 1000;
  overflow: visible !important; }
  #page-topbarInsideTopBarInside .navbar-container {
    overflow-x: auto;
    overflow-y: visible !important;
    position: relative;
    display: flex;
    justify-content: center;
    z-index: 1000; }
    #page-topbarInsideTopBarInside .navbar-container::-webkit-scrollbar {
      height: 8px;
      background: rgba(255, 255, 255, 0.1); }
    #page-topbarInsideTopBarInside .navbar-container::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 4px; }
      #page-topbarInsideTopBarInside .navbar-container::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.5); }
    #page-topbarInsideTopBarInside .navbar-container .items {
      position: fixed;
      display: flex;
      background-color: #244EA2;
      width: -webkit-fill-available;
      overflow-x: auto;
      overflow-y: visible !important;
      flex-wrap: nowrap;
      z-index: 1000;
      contain: none !important; }
      #page-topbarInsideTopBarInside .navbar-container .items::-webkit-scrollbar {
        height: 8px;
        background: rgba(255, 255, 255, 0.2); }
      #page-topbarInsideTopBarInside .navbar-container .items::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.4);
        border-radius: 4px; }
        #page-topbarInsideTopBarInside .navbar-container .items::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.6); }
      #page-topbarInsideTopBarInside .navbar-container .items > div {
        flex-shrink: 0; }
      #page-topbarInsideTopBarInside .navbar-container .items .btn-item-topbar-inside {
        text-wrap: nowrap; }
      #page-topbarInsideTopBarInside .navbar-container .items .btn-item-topbar-inside, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-custom {
        display: flex;
        align-items: center;
        gap: 6px;
        height: 36px;
        font-size: 13px;
        padding: 0 12.5px;
        font-weight: 500;
        color: #eff2f7;
        border: none;
        border-radius: 0;
        transition: .2s ease-in-out; }
      #page-topbarInsideTopBarInside .navbar-container .items > div {
        position: relative !important;
        display: inline-block !important; }
      #page-topbarInsideTopBarInside .navbar-container .items .dropdown-wrapper {
        position: relative !important;
        display: inline-block !important;
        width: 100%;
        z-index: 1002 !important; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-wrapper .dropdown {
          position: relative !important;
          width: 100%;
          z-index: 1002 !important; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-wrapper .dropdown-menu {
          position: absolute !important;
          top: 100% !important;
          left: 0 !important;
          right: auto !important;
          margin-top: 0 !important;
          transform: none !important;
          z-index: 1003 !important;
          overflow: visible !important;
          max-height: calc(100vh - 150px);
          clip-path: none !important;
          clip: auto !important; }
      #page-topbarInsideTopBarInside .navbar-container .items .dropdown-custom[aria-expanded^=true],
      #page-topbarInsideTopBarInside .navbar-container .items .dropdown-custom.is-open {
        background-color: #0F1D42 !important;
        color: white !important; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-custom[aria-expanded^=true] i,
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-custom.is-open i {
          color: white !important; }
      #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #0F1D42;
        width: 220px;
        text-wrap: auto;
        line-height: 22.5px;
        position: relative;
        overflow: visible !important;
        z-index: auto;
        font-size: 15px;
        font-weight: 600;
        height: 36px; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item.actived,
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item.actived a, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item:hover, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a.actived,
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a.actived a, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a:hover {
          color: #0F1D42;
          background-color: #F7F7F7; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item.actived a, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a.actived a {
          font-weight: 600; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item .dropdown-custom[aria-expanded^=true], #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a .dropdown-custom[aria-expanded^=true] {
          background-color: transparent; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item .dropdown-custom, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a .dropdown-custom, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a a {
          padding: 8px 6px;
          height: auto;
          font-weight: 600;
          color: #0F1D42;
          width: 100%;
          display: flex;
          font-size: 15px; }
        #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item .submenu-custom-wrapper, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a .submenu-custom-wrapper {
          position: relative !important;
          width: 100% !important;
          z-index: 1002 !important; }
          #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item .submenu-custom-wrapper .submenu-toggle:hover, #page-topbarInsideTopBarInside .navbar-container .items .dropdown-item a .submenu-custom-wrapper .submenu-toggle:hover {
            background-color: #F7F7F7; }

.main-menu-portal {
  z-index: 1003 !important;
  overflow: visible !important;
  background-color: white !important;
  border-radius: 0 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  padding: 0px !important;
  margin: 0 !important;
  min-width: 220px !important;
  width: auto !important;
  position: fixed !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important; }
  .main-menu-portal .dropdown-item, .main-menu-portal .dropdown-item a {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    color: #0F1D42 !important;
    width: auto !important;
    min-width: 100% !important;
    text-wrap: auto !important;
    line-height: 22.5px !important;
    position: relative !important;
    overflow: visible !important;
    z-index: auto !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    height: 36px !important; }
    .main-menu-portal .dropdown-item.actived,
    .main-menu-portal .dropdown-item.actived a, .main-menu-portal .dropdown-item:hover, .main-menu-portal .dropdown-item a.actived,
    .main-menu-portal .dropdown-item a.actived a, .main-menu-portal .dropdown-item a:hover {
      color: #0F1D42 !important;
      background-color: #F7F7F7 !important; }
    .main-menu-portal .dropdown-item.actived a, .main-menu-portal .dropdown-item a.actived a {
      font-weight: 600 !important; }
    .main-menu-portal .dropdown-item .dropdown-custom[aria-expanded^=true], .main-menu-portal .dropdown-item a .dropdown-custom[aria-expanded^=true] {
      background-color: transparent !important; }
    .main-menu-portal .dropdown-item .dropdown-custom, .main-menu-portal .dropdown-item a, .main-menu-portal .dropdown-item a .dropdown-custom, .main-menu-portal .dropdown-item a a {
      padding: 8px 6px !important;
      height: auto !important;
      font-weight: 600 !important;
      color: #0F1D42 !important;
      width: 100% !important;
      display: flex !important;
      font-size: 15px !important; }
    .main-menu-portal .dropdown-item .submenu-custom-wrapper, .main-menu-portal .dropdown-item a .submenu-custom-wrapper {
      position: relative !important;
      width: 100% !important;
      z-index: 1002 !important; }

.submenu-custom {
  z-index: 1003 !important;
  overflow: visible !important;
  min-width: 220px !important;
  width: auto !important;
  max-width: 400px !important;
  background-color: white !important;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  padding: 0 !important;
  margin-left: 0 !important; }
  .submenu-custom .dropdown-item {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    color: #0F1D42 !important;
    width: 100% !important;
    min-width: 220px !important;
    line-height: 1 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    padding: 8px 12px !important;
    background-color: white !important;
    cursor: pointer !important;
    margin: 0 !important;
    border: none !important;
    white-space: nowrap !important;
    height: 36px !important; }
    .submenu-custom .dropdown-item:hover {
      color: #0F1D42 !important;
      background-color: #F7F7F7 !important; }
    .submenu-custom .dropdown-item a {
      padding: 8px 12px !important;
      height: auto !important;
      font-weight: 400 !important;
      color: #0F1D42 !important;
      width: 100% !important;
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      font-size: 14px !important;
      text-decoration: none !important;
      cursor: pointer !important;
      line-height: 1 !important;
      margin: 0 !important;
      white-space: nowrap !important; }
      .submenu-custom .dropdown-item a:hover {
        color: #0F1D42 !important; }
    .submenu-custom .dropdown-item span {
      color: #0F1D42 !important;
      font-size: 14px !important;
      font-weight: 400 !important; }
    .submenu-custom .dropdown-item i {
      color: #0F1D42 !important;
      font-size: 15px !important; }

.page-title-box {
  padding-top: calc(48px / 2);
  padding-bottom: 16px; }
  .page-title-box .breadcrumb {
    background-color: transparent;
    padding: 0; }
  .page-title-box h4, .page-title-box .h4 {
    font-size: 18px;
    font-weight: 600; }

.footer {
  bottom: 0;
  padding: 20px calc(48px / 2);
  position: absolute;
  right: 0;
  color: #74788d;
  left: 250px;
  height: 120px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff; }

@media (max-width: 992px) {
  .footer {
    left: 0; } }

.vertical-collpsed .footer {
  left: 70px; }

body[data-layout="horizontal"] .footer {
  left: 0 !important; }

.right-bar {
  background-color: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 280px;
  z-index: 9999;
  float: right !important;
  right: -290px;
  top: 0;
  bottom: 0; }
  .right-bar .right-bar-toggle {
    background-color: #444c54;
    height: 24px;
    width: 24px;
    line-height: 24px;
    color: #eff2f7;
    text-align: center;
    border-radius: 50%; }
    .right-bar .right-bar-toggle:hover {
      background-color: #4b545c; }

.rightbar-overlay {
  background-color: rgba(52, 58, 64, 0.55);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 100vh;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all .2s ease-out; }

.right-bar-enabled .right-bar {
  right: 0; }

.right-bar-enabled .rightbar-overlay {
  display: block; }

@media (max-width: 767.98px) {
  .right-bar {
    overflow: auto; }
    .right-bar .slimscroll-menu {
      height: auto !important; } }

.right-bar-custom-filter .simplebar-content {
  height: 100%;
  display: flex;
  flex-grow: 1;
  overflow: hidden !important; }

.right-bar-custom-filter .content-filters {
  overflow: auto; }
  .right-bar-custom-filter .content-filters::-webkit-scrollbar {
    width: 5px;
    margin-left: 10px; }
  .right-bar-custom-filter .content-filters::-webkit-scrollbar-track {
    background: #cecece;
    border-radius: 10px; }
  .right-bar-custom-filter .content-filters::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px; }
  .right-bar-custom-filter .content-filters::-webkit-scrollbar-thumb:hover {
    background: #555; }

.right-bar-custom-filter .container-button-submit button {
  background-color: #244EA2;
  color: white;
  padding: 8px 16px;
  transition: .2s ease-in-out;
  height: 54px;
  font-weight: 600;
  font-size: 1.125rem; }
  .right-bar-custom-filter .container-button-submit button:hover {
    background-color: #1d3e81; }

.right-bar-custom-filter .rightbar-title a {
  text-decoration: underline;
  color: #676A6C; }

.right-bar-custom-filter .rightbar-title button {
  display: flex;
  gap: 5px;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 10px 0px;
  transition: .2s ease-in-out;
  color: #6C6C6C !important; }
  .right-bar-custom-filter .rightbar-title button:hover {
    color: #585858; }

.metismenu {
  margin: 0; }
  .metismenu li {
    display: block;
    width: 100%;
    margin: 15px 0; }
  .metismenu .mm-collapse {
    display: none; }
    .metismenu .mm-collapse:not(.mm-show) {
      display: none; }
    .metismenu .mm-collapse.mm-show {
      display: block; }
  .metismenu .mm-collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    transition-timing-function: ease;
    transition-duration: 0.35s;
    transition-property: height, visibility; }

.vertical-menu {
  width: 250px;
  z-index: 1001;
  background: #ffffff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08); }
  .vertical-menu .card-menu-sidebar-info {
    width: 315px;
    border: 1px solid #D6D9E2;
    border-radius: 5px;
    background-color: #E2E2E2; }
    .vertical-menu .card-menu-sidebar-info .card-header {
      background-color: #E2E2E2;
      height: 60px;
      font-family: "Poppins", sans-serif;
      font-weight: 500;
      padding: 0 16px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 1.25rem;
      color: #0F1D42; }
    .vertical-menu .card-menu-sidebar-info .card-body {
      text-align: left;
      background-color: #EEEEEE;
      height: auto;
      font-size: 0.75rem;
      color: #232323;
      padding: 16px; }

.main-content {
  overflow: hidden; }
  .is-modal-page .main-content {
    height: 100vh !important;
    overflow: auto !important; }
  .main-content .content {
    padding: 0 15px 10px 15px;
    margin-top: 76px; }
  .main-content:has(#page-topbarInsideTopBarInside) .page-content {
    padding-top: 0 !important; }
  .main-content:has(#page-topbarInsideTopBarInside) .page-breadcrumb {
    padding-top: calc(36px + 4px) !important; }

#sidebar-top-logo {
  display: flex;
  justify-content: center;
  height: 76px;
  border-right: 1px solid #D7D7D7; }
  #sidebar-top-logo img {
    border-bottom: 1px solid #A8A8A8;
    padding: 12px; }

#sidebar-menu {
  padding: 0 10px 30px; }
  #sidebar-menu .mm-active > .has-arrow:after {
    transform: rotate(-180deg); }
  #sidebar-menu .mm-active .active {
    color: #263874 !important; }
    #sidebar-menu .mm-active .active .icone {
      background-color: #B4D8FB !important; }
  #sidebar-menu .has-arrow:after {
    content: "\\F0140";
    font-family: "Material Design Icons";
    display: block;
    float: right;
    transition: transform 0.2s;
    font-size: 1rem; }
  #sidebar-menu ul li.disabled a, #sidebar-menu ul li.disabled .icone i, #sidebar-menu ul li.disabled .icone svg path {
    color: #A8A8A8;
    fill: #A8A8A8; }
  #sidebar-menu ul li :hover .icone {
    background-color: #C2CADF !important;
    padding: 0 20px; }
  #sidebar-menu ul li a {
    display: block;
    padding: 0;
    color: #193576;
    position: relative;
    line-height: 1em;
    font-size: 11px;
    font-weight: 500;
    font-family: "Work Sans", sans-serif;
    margin-bottom: 12px; }
    #sidebar-menu ul li a .icone {
      border-radius: 50px;
      transition: all 0.4s;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px; }
      #sidebar-menu ul li a .icone div svg {
        width: auto;
        height: auto; }
      #sidebar-menu ul li a .icone i, #sidebar-menu ul li a .icone div svg {
        font-size: 24px;
        padding: 8px;
        display: block;
        color: #193576;
        transition: all 0.4s; }
  #sidebar-menu ul li .badge {
    margin-top: 4px; }
  #sidebar-menu ul li ul.sub-menu {
    padding: 0; }
    #sidebar-menu ul li ul.sub-menu li a {
      padding: 0.4rem 1.5rem 0.4rem 3.2rem;
      font-size: 14px;
      color: #7c8a96; }
    #sidebar-menu ul li ul.sub-menu li ul.sub-menu {
      padding: 0; }
      #sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
        padding: 0.4rem 1.5rem 0.4rem 4.2rem;
        font-size: 14px; }

.card-float-menu {
  position: absolute;
  padding-left: 30px;
  background-color: transparent;
  border: none;
  outline: none;
  box-shadow: none; }

@media (max-width: 992px) {
  .vertical-menu {
    display: none; }
  .main-content {
    margin-left: 0 !important; }
  body.sidebar-enable .vertical-menu {
    display: block; } }

.vertical-collpsed .main-content {
  margin-left: 70px; }

.vertical-collpsed .navbar-brand-box {
  width: 70px !important;
  padding: 0; }

.vertical-collpsed .logo span.logo-lg {
  display: none; }

.vertical-collpsed .logo span.logo-sm {
  display: block; }

.vertical-collpsed .vertical-menu {
  position: absolute;
  width: 70px !important;
  z-index: 5; }
  .vertical-collpsed .vertical-menu .simplebar-mask,
  .vertical-collpsed .vertical-menu .simplebar-content-wrapper {
    overflow: visible !important; }
  .vertical-collpsed .vertical-menu .simplebar-scrollbar {
    display: none !important; }
  .vertical-collpsed .vertical-menu .simplebar-offset {
    bottom: 0 !important; }
  .vertical-collpsed .vertical-menu #sidebar-menu .badge,
  .vertical-collpsed .vertical-menu #sidebar-menu .collapse.in {
    display: none !important; }
  .vertical-collpsed .vertical-menu #sidebar-menu .nav.collapse {
    height: inherit !important; }
  .vertical-collpsed .vertical-menu #sidebar-menu .has-arrow:after {
    display: none; }
  .vertical-collpsed .vertical-menu #sidebar-menu > ul > li {
    position: relative;
    white-space: nowrap; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a {
      padding: 15px 20px;
      min-height: 55px;
      transition: none; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:active, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:focus {
        color: #383c40; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
        font-size: 20px;
        margin-left: 4px; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a span {
        display: none;
        padding-left: 25px; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
      position: relative;
      width: calc(80px + 70px);
      color: #244EA2;
      background-color: whitesmoke;
      transition: none; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
        color: #244EA2; }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a span {
        display: inline; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul {
      display: block;
      left: 70px;
      position: absolute;
      width: 190px;
      height: auto !important;
      box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1); }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul ul {
        box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1); }
      .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
        box-shadow: none;
        padding: 8px 20px;
        position: relative;
        width: 190px;
        z-index: 6;
        color: #7c8a96; }
        .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
          color: #383c40; }
  .vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
    padding: 5px 0;
    z-index: 9999;
    display: none;
    background-color: #ffffff; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul ul li:hover > ul {
      display: block;
      left: 190px;
      height: auto !important;
      margin-top: -36px;
      position: absolute;
      width: 190px; }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul ul li > a span.pull-right {
      position: absolute;
      right: 20px;
      top: 12px;
      transform: rotate(270deg); }
    .vertical-collpsed .vertical-menu #sidebar-menu > ul ul li.active a {
      color: #f8f9fa; }

body[data-layout="horizontal"] .main-content {
  margin-left: 0 !important; }

body[data-sidebar-size="small"] .navbar-brand-box {
  width: auto;
  display: flex;
  align-items: center; }
  @media (max-width: 992px) {
    body[data-sidebar-size="small"] .navbar-brand-box {
      width: auto; } }

body[data-sidebar-size="small"] .vertical-menu {
  width: 80px;
  text-align: center; }
  body[data-sidebar-size="small"] .vertical-menu .has-arrow:after,
  body[data-sidebar-size="small"] .vertical-menu .badge {
    display: none !important; }

body[data-sidebar-size="small"] .footer {
  left: 80px; }
  @media (max-width: 991px) {
    body[data-sidebar-size="small"] .footer {
      left: 0; } }

body[data-sidebar-size="small"].vertical-collpsed .main-content {
  margin-left: 70px; }

body[data-sidebar-size="small"].vertical-collpsed .vertical-menu #sidebar-menu {
  text-align: left; }
  body[data-sidebar-size="small"].vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
    display: inline-block; }

body[data-sidebar-size="small"].vertical-collpsed .footer {
  left: 70px; }

.topnav {
  background: #fff;
  padding: 0 calc(48px / 2);
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 76px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100; }
  .topnav .topnav-menu {
    margin: 0;
    padding: 0; }
  .topnav .navbar-nav .nav-link {
    font-size: 15px;
    position: relative;
    padding: 1rem 1.3rem;
    color: #74788d;
    font-family: "Work Sans", sans-serif; }
    .topnav .navbar-nav .nav-link i {
      font-size: 15px;
      vertical-align: middle;
      display: inline-block; }
    .topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {
      color: #0bb197;
      background-color: transparent; }
  .topnav .navbar-nav .dropdown-item {
    color: #74788d; }
    .topnav .navbar-nav .dropdown-item.active, .topnav .navbar-nav .dropdown-item:hover {
      color: #0bb197; }
  .topnav .navbar-nav .nav-item .nav-link.active {
    color: #0bb197; }
  .topnav .navbar-nav .dropdown.active > a {
    color: #0bb197;
    background-color: transparent; }

@media (min-width: 1200px) {
  body[data-layout="horizontal"] .container-fluid, body[data-layout="horizontal"] .container-sm, body[data-layout="horizontal"] .container-md, body[data-layout="horizontal"] .container-lg, body[data-layout="horizontal"] .container-xl, body[data-layout="horizontal"] .container-xxl,
  body[data-layout="horizontal"] .navbar-header {
    max-width: 85%; } }

@media (min-width: 992px) {
  .topnav .navbar-nav .nav-item:first-of-type .nav-link {
    padding-left: 0; }
  .topnav .dropdown-item {
    padding: .5rem 1.5rem;
    min-width: 180px; }
  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {
    left: 0px;
    right: auto; }
  .topnav .dropdown .dropdown-menu {
    margin-top: 0;
    border-radius: 0 0 0.25rem 0.25rem; }
    .topnav .dropdown .dropdown-menu .arrow-down::after {
      right: 15px;
      transform: rotate(-135deg) translateY(-50%);
      position: absolute; }
    .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
      position: absolute;
      top: 0 !important;
      left: 100%;
      display: none; }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block; }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block; }
  .navbar-toggle {
    display: none; } }

.arrow-down {
  display: inline-block; }
  .arrow-down:after {
    border-color: initial;
    border-style: solid;
    border-width: 0 0 1px 1px;
    content: "";
    height: .4em;
    display: inline-block;
    right: 5px;
    top: 50%;
    margin-left: 10px;
    transform: rotate(-45deg) translateY(-50%);
    transform-origin: top;
    transition: all .3s ease-out;
    width: .4em; }

@media (max-width: 1199.98px) {
  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {
    right: 100%;
    left: auto; } }

@media (max-width: 991.98px) {
  .navbar-brand-box .logo-dark {
    display: block; }
    .navbar-brand-box .logo-dark span.logo-sm {
      display: block; }
  .navbar-brand-box .logo-light {
    display: none; }
  .topnav {
    max-height: 360px;
    overflow-y: auto;
    padding: 0; }
    .topnav .navbar-nav .nav-link {
      padding: 0.75rem 1.1rem; }
    .topnav .dropdown .dropdown-menu {
      background-color: transparent;
      border: none;
      box-shadow: none;
      padding-left: 15px; }
      .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl {
        width: auto; }
        .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl .row {
          margin: 0px; }
    .topnav .dropdown .dropdown-item {
      position: relative;
      background-color: transparent; }
      .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {
        color: #244EA2; }
    .topnav .arrow-down::after {
      right: 15px;
      position: absolute; } }

@media (min-width: 992px) {
  body[data-layout="horizontal"][data-topbar="light"] .navbar-brand-box .logo-dark {
    display: block; }
  body[data-layout="horizontal"][data-topbar="light"] .navbar-brand-box .logo-light {
    display: none; }
  body[data-layout="horizontal"][data-topbar="light"] .topnav {
    background-color: #244EA2; }
    body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav .nav-link {
      color: rgba(255, 255, 255, 0.7); }
      body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav .nav-link:focus, body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav .nav-link:hover {
        color: rgba(255, 255, 255, 0.9); }
    body[data-layout="horizontal"][data-topbar="light"] .topnav .navbar-nav > .dropdown.active > a {
      color: rgba(255, 255, 255, 0.9) !important; } }

#header-default-body a::before {
  content: "";
  border: solid #0F1D42;
  border-width: 0 3px 3px 0;
  display: inline-block;
  background-color: transparent;
  margin-left: 5px;
  width: 18px;
  height: 18px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg); }

.loading-overlay {
  top: 0;
  left: 0;
  position: absolute;
  background-color: #CDCDCD60;
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 4px;
  align-items: center;
  transition: .2s ease-in-out;
  justify-content: center;
  z-index: 10; }

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent; }

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none; }

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%); }

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2); }

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4); }

.waves-notransition {
  transition: none !important; }

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%); }

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1; }

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em; }

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em; }

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom; }

.waves-input-wrapper.waves-button {
  padding: 0; }

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1; }

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%; }

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms; }

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3); }

.waves-block {
  display: block; }

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4); }

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(36, 78, 162, 0.4); }

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(75, 181, 67, 0.4); }

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(240, 240, 240, 0.4); }

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(254, 206, 34, 0.4); }

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(236, 34, 31, 0.4); }

.avatar-xs {
  height: 2rem;
  width: 2rem; }

.avatar-sm {
  height: 3rem;
  width: 3rem; }

.avatar-md {
  height: 4.5rem;
  width: 4.5rem; }

.avatar-lg {
  height: 6rem;
  width: 6rem; }

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem; }

.avatar-xxl {
  height: 9.5rem;
  width: 9.5rem; }

.avatar-title {
  align-items: center;
  background-color: #244EA2;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%; }

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap; }
  .avatar-group .avatar-group-item {
    margin-left: -12px;
    border: 2px solid #fff;
    border-radius: 50%;
    transition: all 0.2s; }
    .avatar-group .avatar-group-item:hover {
      position: relative;
      transform: translateY(-2px); }

.container-avatar-with-box-info {
  position: relative; }
  .container-avatar-with-box-info .container-avatar {
    position: relative;
    cursor: pointer; }
    .container-avatar-with-box-info .container-avatar:hover .modal-info {
      display: block; }
    .container-avatar-with-box-info .container-avatar .modal-info {
      display: none;
      transition: .2s ease-in-out;
      background-color: #ffffff;
      border: 1px solid #D9D9D9;
      border-radius: 16px;
      padding: 24px;
      width: 480px;
      top: 0;
      z-index: 99;
      position: absolute; }
      .container-avatar-with-box-info .container-avatar .modal-info.right-box {
        right: 33px; }
      .container-avatar-with-box-info .container-avatar .modal-info.left-box {
        left: 33px; }

.custom-accordion .card + .card {
  margin-top: 0.5rem; }

.custom-accordion a.collapsed i.accor-plus-icon:before {
  content: "\\F0415"; }

.custom-accordion .card-header {
  border-radius: 7px; }

.custom-accordion-arrow .card {
  border: 1px solid #eff2f7;
  box-shadow: none; }

.custom-accordion-arrow .card-header {
  padding-left: 45px;
  position: relative; }
  .custom-accordion-arrow .card-header .accor-arrow-icon {
    position: absolute;
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 1rem;
    background-color: #244EA2;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    left: 10px;
    top: 50%;
    transform: translateY(-50%); }

.custom-accordion-arrow a.collapsed i.accor-arrow-icon:before {
  content: "\\F0142"; }

.nav-accordion-custom ul {
  border: none; }
  .nav-accordion-custom ul li {
    height: 54px;
    background-color: #F0F0F0;
    transition: .2s ease-in-out;
    border-bottom: 4px solid #F0F0F0; }
    .nav-accordion-custom ul li:last-child {
      border-radius: 0 10px 10px 0; }
    .nav-accordion-custom ul li:first-child {
      border-radius: 10px 0 0 10px; }
    .nav-accordion-custom ul li:hover {
      background-color: #C2CADF;
      border-bottom-color: #C2CADF; }
    .nav-accordion-custom ul li:has(.active) {
      border-color: #244EA2;
      border-bottom-color: #244EA2; }
    .nav-accordion-custom ul li:has(.active),
    .nav-accordion-custom ul li .nav-link.active {
      color: #0F1D42;
      background-color: transparent; }
    .nav-accordion-custom ul li .nav-link {
      border: 0;
      height: 54px;
      color: #6C6C6C;
      font-weight: 600;
      font-size: 1rem;
      display: flex;
      width: 125px;
      padding: 0;
      align-items: center;
      justify-content: center; }

.card-accordion-custom .accordion-item {
  border: 0;
  box-shadow: none;
  background-color: transparent;
  border-radius: 0; }

.card-accordion-custom .accordion-header {
  border-bottom: 1px solid #D9D9D9;
  height: 50px;
  display: flex;
  align-items: center; }

.card-accordion-custom .accordion-body {
  padding: 0; }

.card-accordion-custom .accordion-button {
  padding: 0;
  border: 0;
  box-shadow: none;
  background-color: transparent;
  border-radius: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #6C6C6C; }

.card-accordion-custom .accordion-button::after {
  display: none; }

.font-family-secondary {
  font-family: "Work Sans", sans-serif; }

.font-size-10 {
  font-size: 10px !important; }

.font-size-11 {
  font-size: 11px !important; }

.font-size-12 {
  font-size: 12px !important; }

.font-size-13 {
  font-size: 13px !important; }

.font-size-14 {
  font-size: 14px !important; }

.font-size-15 {
  font-size: 15px !important; }

.font-size-16 {
  font-size: 1rem !important; }

.font-size-17 {
  font-size: 17px !important; }

.font-size-18 {
  font-size: 18px !important; }

.font-size-20 {
  font-size: 1.25rem !important; }

.font-size-22 {
  font-size: 22px !important; }

.font-size-24 {
  font-size: 24px !important; }

.font-size-25 {
  font-size: 25px !important; }

.font-size-26 {
  font-size: 26px !important; }

.font-size-28 {
  font-size: 28px !important; }

.font-size-30 {
  font-size: 30px !important; }

.font-size-32 {
  font-size: 32px !important; }

.font-w-300 {
  font-weight: 300 !important; }

.font-w-400 {
  font-weight: 400 !important; }

.font-w-500 {
  font-weight: 500 !important; }

.font-w-600 {
  font-weight: 600 !important; }

.font-w-700 {
  font-weight: 700 !important; }

.font-w-bold {
  font-weight: bold !important; }

.cursor-pointer {
  cursor: pointer; }

.logo-user {
  width: 50px;
  height: 50px;
  background-color: #A8A8A8;
  border-radius: 50%;
  object-fit: cover; }

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 2px);
  display: block;
  border: 1px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s; }
  .social-list-item:hover {
    color: #74788d;
    background-color: #eff2f7; }

.w-xs {
  min-width: 80px; }

.w-sm {
  min-width: 95px; }

.w-md {
  min-width: 110px; }

.w-lg {
  min-width: 140px; }

.w-xl {
  min-width: 160px; }

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #000; }

.alert-dismissible .btn-close {
  font-size: 10px;
  padding: 1.05rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_32___}) center/1em auto no-repeat; }

.search-box {
  position: relative; }
  .search-box .form-control {
    padding-left: 40px; }
  .search-box .search-icon {
    font-size: 14px;
    position: absolute;
    left: 13px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    color: #74788d; }

.page-erros {
  height: 100vh; }
  .page-erros h4, .page-erros .h4 {
    font-size: 46px;
    font-weight: 700;
    font-family: "Poppins", sans-serif;
    color: #6C6C6C; }
  .page-erros p {
    color: #6C6C6C;
    font-weight: 400;
    font-size: 1rem; }
  .page-erros a {
    font-weight: 600;
    font-size: 1rem;
    border: 1px solid #00000026; }

.flip-icon {
  transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -ms-transform: scaleX(-1); }

.user-photo-label {
  border-radius: 50%;
  color: #A8A8A8;
  width: auto;
  display: flex; }

.digit-input {
  width: 5rem !important;
  height: 6.5rem;
  font-size: 6.5rem !important;
  text-align: center;
  color: #999;
  background: transparent;
  border: none;
  border-bottom: 6px solid #ccc !important;
  outline: none;
  margin: 0 0.25rem;
  font-weight: 500; }

.select-filter-custom.select-filter-custom--is-disabled {
  opacity: 0.7; }

.select-filter-custom.is-invalid .select-filter-custom__control {
  border-color: #dc3545 !important; }

.select-filter-custom .select-filter-custom__control {
  border: 1px solid #a8a8a8 !important;
  background-color: white;
  border-radius: 4px;
  transition: border-color 0.2s ease; }

.select-filter-custom:hover,
.select-filter-custom__control:hover {
  border-color: #244ea2 !important;
  box-shadow: none !important;
  color: #a8a8a8 !important; }

.select-filter-custom__control--is-focused {
  border-color: #244ea2 !important;
  box-shadow: none !important; }

.select-filter-custom__value-container {
  padding: 0 8px;
  display: flex;
  align-items: center; }

.select-filter-custom__placeholder,
.select-filter-custom__single-value {
  color: #6C6C6C !important; }

.select-filter-custom__option {
  background-color: #F5F5F5 !important; }

.select-filter-custom__option--is-focused {
  background-color: #C1E0FF !important; }

.select-filter-custom__option--is-selected {
  background-color: #263874 !important;
  color: #ffffff !important; }

.select-filter-custom__menu {
  padding: 10px 0;
  background-color: #F5F5F5 !important; }

.form-check-right {
  padding-left: 0;
  display: inline-block;
  padding-right: 1.5em; }
  .form-check-right .form-check-input {
    float: right;
    margin-left: 0;
    margin-right: -1.5em; }
  .form-check-right .form-check-label {
    display: block; }

.form-check {
  position: relative;
  text-align: left;
  -webkit-user-select: none;
          user-select: none; }

.form-check-input,
.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
  -webkit-user-select: none;
          user-select: none; }

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 24px;
  line-height: 24px; }
  .form-switch-md .form-check-input {
    width: 40px;
    height: 20px;
    left: -0.5rem;
    position: relative; }
  .form-switch-md .form-check-label {
    vertical-align: middle; }

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px; }
  .form-switch-lg .form-check-input {
    width: 48px;
    height: 24px;
    left: -0.75rem;
    position: relative; }

.form-custom01-filter .btn-filter-submit {
  transition: 0.2s ease-in-out;
  background-color: #498EF2;
  font-weight: 400; }
  .form-custom01-filter .btn-filter-submit:hover {
    background-color: #244EA2; }

.form-custom01-filter .form-control,
.form-custom01-filter .btn-filter-submit {
  height: 40px;
  border-color: #A8A8A8; }

.form-custom01-filter .form-control:focus:focus-within:hover {
  border-color: #244EA2 !important;
  box-shadow: none !important; }

.form-custom01-filter .form-control {
  box-shadow: none;
  border: 1px solid #A8A8A8;
  border-radius: 4px;
  color: #6C6C6C;
  font-size: 15px;
  padding-left: 18px;
  cursor: pointer; }

.form-custom01-filter label {
  color: #6C6C6C;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px; }

.btn-hover-primary {
  transition: 0.2s ease-in-out; }
  .btn-hover-primary:hover {
    background-color: #244EA2 !important; }

.input-custom-search {
  position: relative;
  display: flex; }
  .input-custom-search input {
    height: 40px;
    width: 100%;
    color: #A8A8A8;
    border-radius: 0.25rem;
    border-color: #A8A8A8;
    background-color: white;
    font-family: "Poppins", sans-serif;
    font-weight: 400; }
    .input-custom-search input:hover, .input-custom-search input:focus {
      box-shadow: 0px 0px 1px 1px #7DC3DC;
      border-color: #7DC3DC; }
    .input-custom-search input::placeholder {
      color: #A8A8A8 !important; }
  .input-custom-search i {
    cursor: pointer;
    position: absolute;
    right: 18px;
    display: flex;
    align-self: center;
    color: #7DC3DC; }

.input-radio-custom {
  appearance: none;
  cursor: pointer;
  width: 20px !important;
  height: 20px !important;
  padding: 1px !important;
  background-clip: content-box;
  border: 2px solid #244EA2 !important;
  border-radius: 50% !important;
  background-color: white !important; }
  .input-radio-custom.form-check-input {
    background-image: none !important; }
  .input-radio-custom:checked {
    background-color: #244EA2 !important; }

.input-checkbox-custom {
  cursor: pointer;
  width: 22px !important;
  height: 22px !important;
  padding: 0;
  margin: 0;
  border: 2px solid #244EA2 !important;
  border-radius: 4px !important;
  background-color: white !important; }
  .input-checkbox-custom:checked {
    background-color: #498EF2 !important;
    border-color: #498EF2 !important; }
  .input-checkbox-custom:disabled {
    background-color: #6A799C !important;
    border-color: #6A799C !important; }

.form-default-primary .form-control:has(input:disabled) {
  background-color: #ebebeb !important;
  border-color: #d7d7d7 !important; }
  .form-default-primary .form-control:has(input:disabled) i {
    color: #A8A8A8 !important; }

.form-default-primary .form-label {
  margin-bottom: 0.25rem; }

.form-default-primary input:disabled {
  background-color: #F0F0F0 !important;
  border-color: #A8A8A8 !important;
  cursor: not-allowed; }
  .form-default-primary input:disabled:hover, .form-default-primary input:disabled:active, .form-default-primary input:disabled:focus {
    border-color: #A8A8A8 !important; }

.form-default-primary input.is-valid,
.form-default-primary select.is-valid {
  border-color: #4bb543 !important; }

.form-default-primary input.is-invalid,
.form-default-primary select.is-invalid {
  border-color: #ec221f !important; }

.form-default-primary input,
.form-default-primary .form-control {
  font-family: "Poppins", sans-serif;
  height: 40px;
  font-size: 1rem;
  width: 100%;
  border-radius: 0.25rem;
  padding: 16px;
  background-color: white;
  color: #6C6C6C;
  border: 1px solid #A8A8A8; }
  .form-default-primary input:hover, .form-default-primary input:active, .form-default-primary input:focus,
  .form-default-primary .form-control:hover,
  .form-default-primary .form-control:active,
  .form-default-primary .form-control:focus {
    border-color: #244EA2 !important; }
  .form-default-primary input i,
  .form-default-primary .form-control i {
    font-size: 24px;
    color: #7DC3DC;
    display: contents; }
  .form-default-primary input input,
  .form-default-primary .form-control input {
    border: none;
    border-radius: 0;
    padding: 0;
    height: auto !important;
    width: 100%;
    font-size: 14px;
    color: #6C6C6C; }
    .form-default-primary input input::placeholder,
    .form-default-primary .form-control input::placeholder {
      color: #A8A8A8; }

.input-date-group-custom .date-input::-webkit-calendar-picker-indicator {
  display: none; }

.input-date-group-custom input:hover + .date-icon-bizin {
  border-color: #263874 !important; }

.input-date-group-custom .active,
.input-date-group-custom .date-input:hover {
  border-color: #263874 !important; }

.input-date-group-custom .date-input {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: none; }

.input-date-group-custom .date-icon-bizin {
  background-color: white;
  width: 54px;
  height: 40px;
  border: 1px solid #A8A8A8;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-end-end-radius: 4px;
  border-start-end-radius: 4px;
  transition: 0.2s ease-in-out;
  cursor: pointer; }
  .input-date-group-custom .date-icon-bizin i {
    font-size: 1.2rem;
    color: #263874; }
  .input-date-group-custom .date-icon-bizin:hover {
    border-color: #263874 !important; }

#container-input-send-message {
  width: 100%;
  min-height: 56px;
  display: flex;
  border-radius: 12px;
  justify-content: space-between;
  align-items: center;
  padding-right: 0;
  padding-left: 0;
  border: 1px solid #A8A8A8;
  background-color: white;
  transition: 0.2s ease-in-out; }
  #container-input-send-message:hover {
    box-shadow: 0px 0px 0px 2px #244EA2; }
  #container-input-send-message:focus-within, #container-input-send-message:focus-visible {
    box-shadow: 0px 0px 0px 2px #498EF2; }
  #container-input-send-message #input-editor-custom:focus-within .ql-toolbar,
  #container-input-send-message #input-editor-custom:active .ql-toolbar,
  #container-input-send-message #input-editor-custom:focus-visible .ql-toolbar {
    display: block; }
  #container-input-send-message .btn-upload-file-chat.p-button:focus {
    box-shadow: none !important; }
  #container-input-send-message .btn-send-message button {
    padding-right: 16px;
    outline: none !important;
    box-shadow: none !important;
    transition: 0.2s ease-in-out;
    border-radius: 0px;
    padding: 0 20px 0 12px;
    border: 0px;
    border-left: 1px solid #D9D9D9; }
    #container-input-send-message .btn-send-message button i:hover {
      color: #498EF2 !important; }

#input-editor-custom {
  font-family: "Poppins", sans-serif;
  display: flex;
  flex-direction: column-reverse; }
  #input-editor-custom .ql-editor {
    border: none;
    color: #6C6C6C;
    font-weight: 400;
    padding-left: 16px;
    border-radius: 12px;
    font-size: 1rem;
    word-break: break-all; }
    #input-editor-custom .ql-editor p {
      color: #6C6C6C; }
    #input-editor-custom .ql-editor::before {
      color: #6C6C6C;
      font-style: normal; }
    #input-editor-custom .ql-editor img {
      max-height: 120px !important; }
  #input-editor-custom .ql-toolbar {
    display: none;
    padding-top: 0; }
  #input-editor-custom .ql-toolbar,
  #input-editor-custom .ql-container {
    border: none; }

.checkbox-annul {
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: 1.5px solid #353535;
  border-radius: 2px;
  background-color: #fff;
  position: relative; }

.checkbox-annul {
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: 1px solid #263874;
  border-radius: 2px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; }

.checkbox-annul:checked {
  background: #498ef2;
  border-color: #498ef2; }

.checkbox-annul:checked::after {
  content: "✓";
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1; }

.box-local-desembarque {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); }

.box-local-desembarque .row {
  row-gap: 16px; }

.box-local-desembarque .form-group {
  margin-bottom: 0; }

.checkbox-container {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  height: auto; }

.checkbox-container-title {
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #263874;
  margin-bottom: 8px; }

.df-ot0055-background {
  background-color: #f5f5f5; }

.df-ot0055-page {
  background: transparent; }

.df-ot0055-page-func {
  background: #ffffff; }
  .df-ot0055-page-func.page-content {
    padding: 24px !important; }
  .df-ot0055-page-func > .dataTable-custom-primary.container-fluid, .df-ot0055-page-func > .dataTable-custom-primary.container-sm, .df-ot0055-page-func > .dataTable-custom-primary.container-md, .df-ot0055-page-func > .dataTable-custom-primary.container-lg, .df-ot0055-page-func > .dataTable-custom-primary.container-xl, .df-ot0055-page-func > .dataTable-custom-primary.container-xxl {
    padding-left: 0 !important;
    padding-right: 0 !important; }

.checkbox-scroll {
  height: 165px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #9a9a9a transparent; }

.checkbox-scroll::-webkit-scrollbar {
  width: 8px; }

.checkbox-scroll::-webkit-scrollbar-track {
  background: transparent; }

.checkbox-scroll::-webkit-scrollbar-thumb {
  background: #9b9b9b;
  border-radius: 999px; }

.checkbox-scroll::-webkit-scrollbar-thumb:hover {
  background: #7f7f7f; }

.checkbox-scroll::-webkit-scrollbar-button {
  display: none; }

.df-ot0086-page input[type="time"] {
  border-radius: 12px !important; }

.input-time-group {
  position: relative; }
  .input-time-group .input-time-popup {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 9999;
    display: flex;
    width: 180px;
    margin-top: 4px;
    background: #ffffff;
    border: 1px solid #a8a8a8;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); }
  .input-time-group .input-time-column {
    width: 50%;
    max-height: 220px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none; }
    .input-time-group .input-time-column::-webkit-scrollbar {
      display: none; }
    .input-time-group .input-time-column::-webkit-scrollbar-thumb {
      background: #a8a8a8;
      border-radius: 8px; }
    .input-time-group .input-time-column::-webkit-scrollbar-track {
      background: transparent; }
  .input-time-group .input-time-column-left {
    border-right: 1px solid #e9ecef; }
  .input-time-group .input-time-item {
    padding: 8px;
    text-align: center;
    cursor: pointer;
    color: #263874;
    -webkit-user-select: none;
            user-select: none;
    transition: background-color 0.15s ease, color 0.15s ease; }
    .input-time-group .input-time-item:hover {
      background: #c1e0ff; }
    .input-time-group .input-time-item.input-time-item-selected {
      background: #263874;
      color: #ffffff; }

.grid-horarios .mb-3 {
  margin-bottom: 24px !important; }

.mfp-popup-form {
  max-width: 1140px; }

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block; }

.icon-demo-content {
  color: #adb5bd; }
  .icon-demo-content i {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 36px;
    font-size: 22px;
    color: #74788d;
    border: 2px solid #f1f5f7;
    border-radius: 4px;
    transition: all 0.4s;
    text-align: center;
    margin-right: 16px;
    vertical-align: middle; }
  .icon-demo-content .col-lg-4 {
    margin-top: 24px; }
    .icon-demo-content .col-lg-4:hover i {
      color: #fff;
      background-color: #244EA2;
      border-color: #244EA2; }

.icon-demo-content-dripicons {
  color: #adb5bd; }
  .icon-demo-content-dripicons i {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 43px;
    font-size: 22px;
    color: #74788d;
    border: 2px solid #f1f5f7;
    border-radius: 4px;
    transition: all 0.4s;
    text-align: center;
    margin-right: 16px;
    vertical-align: middle; }
  .icon-demo-content-dripicons .col-lg-4 {
    margin-top: 24px; }
    .icon-demo-content-dripicons .col-lg-4:hover i {
      color: #fff;
      background-color: #244EA2;
      border-color: #244EA2; }

.grid-structure .grid-container {
  background-color: #f8f9fa;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px; }

.card-radio {
  background-color: #fff;
  border: 2px solid #f1f5f7;
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }
  .card-radio:hover {
    cursor: pointer; }

.card-radio-label {
  display: block; }

.card-radio-input {
  display: none; }
  .card-radio-input:checked + .card-radio {
    border-color: #244EA2 !important; }

.navs-carousel .owl-nav {
  margin-top: 16px; }
  .navs-carousel .owl-nav button {
    width: 30px;
    height: 30px;
    line-height: 28px !important;
    font-size: 20px !important;
    border-radius: 50% !important;
    background-color: rgba(36, 78, 162, 0.25) !important;
    color: #244EA2 !important;
    margin: 4px 8px !important; }

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .footer {
    display: none !important; }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0; }
  .card {
    border: 0; } }

.avatar-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer; }

.avatar-img {
  object-fit: cover;
  border-radius: 50%;
  transition: opacity .2s ease; }

.avatar-upload {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .2s ease; }

.upload-icon {
  color: #fff; }

.avatar-wrapper:hover .avatar-upload {
  opacity: 1; }

.avatar-wrapper:hover .avatar-img {
  opacity: .6; }

.avatar-modal .modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; }

.avatar-modal {
  max-width: 650px !important;
  width: 100% !important; }

.avatar-modal .modal-body .rounded-circle {
  width: 300px;
  height: 300px;
  object-fit: cover; }

.avatar-modal-margem {
  margin-left: 100px;
  margin-right: 100px; }

.crop-container {
  width: 300px;
  height: 300px;
  background: #ffffff;
  position: relative;
  overflow: hidden; }

.avatar-modal .modal-body {
  display: flex;
  flex-direction: column;
  align-items: center; }

.iframe-wrapper {
  width: 725px !important;
  height: 456px !important;
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center; }

.iframe-avatar {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 12px;
  overflow: hidden; }

.modal-avatar-iframe .modal-dialog {
  max-width: 725px !important;
  margin: 0 auto !important; }

.modal-avatar-iframe .modal-content {
  border-radius: 12px !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: transparent !important;
  border: none !important; }

body.iframe-avatar-mode .page-content {
  height: 456px !important;
  min-height: 456px !important;
  overflow: hidden !important;
  padding: 0 !important; }

.tooltip-custom .tooltip-inner {
  background-color: #fff;
  color: #444;
  border: 1px solid #ddd; }

.tooltip-custom.bs-tooltip-bottom .arrow::before, .tooltip-custom.bs-tooltip-auto[data-popper-placement^="bottom"] .arrow::before {
  border-bottom-color: #fff; }

.tooltip-custom .bs-tooltip-auto .arrow::before {
  border-bottom-color: #fff; }

.tooltip-custom .bs-tooltip-auto .tooltip-inner {
  text-align: left; }

.tooltip-table-dinamic .tooltip-arrow {
  display: none; }

.tooltip-table-dinamic .bs-tooltip-auto {
  padding-bottom: 5px; }
  .tooltip-table-dinamic .bs-tooltip-auto .tooltip-inner {
    background-color: white;
    color: black;
    font-size: 10px; }

.tooltip-pre-filter .tooltip-arrow {
  display: none; }

.tooltip-pre-filter .bs-tooltip-auto {
  padding: 5px; }
  .tooltip-pre-filter .bs-tooltip-auto .tooltip-inner {
    background-color: white;
    color: black;
    font-size: 10px; }

.tooltip-info-search .tooltip-arrow {
  display: none; }

.tooltip-info-search .bs-tooltip-auto {
  padding: 5px; }
  .tooltip-info-search .bs-tooltip-auto .tooltip-inner {
    background-color: white;
    border: 1px solid #D9D9D9;
    color: #0F1D42;
    font-size: 10px; }

#notification-modal {
  max-width: 380px; }
  #notification-modal .notification-div-icon {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 1rem;
    border-radius: 50%;
    padding: 34px;
    width: 75px;
    height: 75px; }
    #notification-modal .notification-div-icon i {
      color: #fff;
      font-size: 30px; }
  #notification-modal .notification-msg {
    font-family: "Poppins", sans-serif;
    color: #353535;
    line-height: 1.4; }

.modal-direct-render {
  margin: 0 auto;
  max-width: none; }
  .modal-direct-render .modal-header {
    padding: 16px 24px;
    border-color: #A8A8A8; }
  .modal-direct-render .modal-body {
    padding: 20px 24px; }
  .modal-direct-render .select-filter-custom.select-filter-custom--is-disabled .select-filter-custom__control {
    background-color: #e9ecef !important;
    cursor: not-allowed; }
  .modal-direct-render .select-filter-custom.select-filter-custom--is-disabled .select-filter-custom__indicator {
    cursor: not-allowed;
    opacity: 0.5; }

.modal-dinamic-table-simple {
  margin: 0 auto;
  height: 100%;
  align-content: center;
  max-width: none;
  width: 860px; }
  .modal-dinamic-table-simple .modal-header {
    padding: 24px;
    border-color: #A8A8A8; }
  .modal-dinamic-table-simple .modal-body {
    padding: 16px 24px 24px 24px;
    height: calc(100% - 100px); }
  .modal-dinamic-table-simple .message-content-box-right {
    display: flex;
    justify-content: flex-end; }
    .modal-dinamic-table-simple .message-content-box-right .message-content-box {
      background-color: #e5f3fd !important; }
  .modal-dinamic-table-simple .message-content-box {
    background-color: #F5F5F5;
    padding: 16px;
    border-radius: 12px;
    margin-bottom: 5px;
    width: auto;
    max-width: 66%;
    overflow-wrap: break-word; }
    .modal-dinamic-table-simple .message-content-box p,
    .modal-dinamic-table-simple .message-content-box > div {
      color: #353535;
      font-weight: 400;
      font-size: 14px;
      margin: 0; }
  .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body {
    display: flex;
    flex-direction: column; }
    .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body .photo-user img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      object-fit: cover; }
    .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body .container-flow {
      height: 90px; }
    .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body .list-messages {
      overflow: auto;
      flex-grow: 1;
      display: flex;
      flex-direction: column-reverse;
      justify-content: end;
      max-height: 422px; }
      .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body .list-messages .divider-no-view {
        display: flex;
        align-items: center; }
        .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body .list-messages .divider-no-view hr {
          color: #498EF2;
          border-width: 2px;
          width: 100%; }
        .modal-dinamic-table-simple.type-VIEW_MESSAGE .modal-body .list-messages .divider-no-view .label {
          background-color: white;
          margin: 0;
          width: 180px;
          font-size: 14px;
          color: #498EF2;
          font-weight: 600; }
  .modal-dinamic-table-simple.type-VIEW_TIMELINE {
    height: auto !important;
    max-height: 90vh; }
    .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-body {
      height: calc(90vh - 150px) !important;
      max-height: calc(90vh - 150px) !important;
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none; }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-body::-webkit-scrollbar {
        display: none; }
    .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-header-content {
      background: #f8f9fa;
      border-bottom: 1px solid #e9ecef;
      padding: 20px;
      border-radius: 8px 8px 0 0; }
    .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-body-content {
      padding: 20px;
      background: #ffffff; }
    .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom {
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom .document-history-header {
        margin-bottom: 0;
        border-radius: 0;
        box-shadow: none; }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom .vertical-timeline {
        margin-top: 20px; }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom .timeline-section {
        margin-bottom: 15px; }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom .timeline-event {
        padding: 12px 15px; }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom .timeline-step {
        width: 35px;
        height: 35px; }
      .modal-dinamic-table-simple.type-VIEW_TIMELINE .modal-content-custom .timeline-dot {
        width: 18px;
        height: 18px; }

.is-modal-page .page-content {
  padding: 0 !important; }

/* modal container */
.custom-modal {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); }

.icon-warning {
  width: 80px;
  height: 80px;
  background: #f4c430;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px; }

.modal-title-custom {
  font-weight: 600;
  color: #1f2a44;
  margin-bottom: 10px; }

.modal-subtext {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 20px; }

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px; }

.btn-cancel {
  background: transparent;
  border: none;
  color: #1f2a44;
  font-weight: 500;
  padding: 10px 16px; }

.btn-confirm {
  background: #2f3e6e;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: 0.2s; }

.btn-confirm:hover {
  background: #24325a; }

.icon-success {
  width: 80px;
  height: 80px;
  background: #4caf50;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px; }

.icon-error {
  width: 80px;
  height: 80px;
  background: #f44336;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px; }

.success-alert-custom {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  background: #eef8ea;
  border: none;
  border-radius: 4px; }
  .success-alert-custom i {
    color: #43b02a;
    font-size: 24px; }
  .success-alert-custom .success-title {
    color: #178a1f;
    font-size: 16px;
    font-weight: 700; }
  .success-alert-custom .success-message {
    color: #6c757d;
    font-size: 16px;
    font-weight: 400; }

.error-alert-custom-box {
  display: flex;
  align-items: center;
  background: #fbe1e1;
  border-radius: 4px;
  padding: 16px 18px;
  color: #ec221f;
  width: fit-content;
  max-width: 100%; }

.error-alert-custom-box .error-icon {
  color: #ec221f;
  font-size: 18px;
  flex-shrink: 0; }

.error-alert-custom-box .error-bold {
  color: #ec221f;
  font-weight: 700;
  margin-right: 6px; }

.error-alert-custom-box span {
  color: #ec221f;
  font-size: 14px;
  line-height: 20px; }

.rota-date-input-group {
  display: flex;
  align-items: stretch;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ced4da; }
  .rota-date-input-group:focus-within {
    border-color: #263973;
    box-shadow: 0 0 0 0.15rem rgba(38, 57, 115, 0.15); }
  .rota-date-input-group .rota-date-wrapper {
    flex: 1 1;
    display: flex;
    align-items: center; }
  .rota-date-input-group .rota-date-input {
    border: none;
    border-radius: 8px 0 0 8px;
    padding: 0.45rem 0.75rem;
    font-size: 14px;
    color: #495057;
    width: 100%; }
    .rota-date-input-group .rota-date-input:focus {
      box-shadow: none;
      border: none;
      outline: none; }
    .rota-date-input-group .rota-date-input::placeholder {
      color: #adb5bd; }
    .rota-date-input-group .rota-date-input:disabled {
      background-color: #e9ecef;
      opacity: 1;
      cursor: not-allowed; }
  .rota-date-input-group .rota-date-addon {
    background-color: #fff;
    border-left: 1px solid #ced4da;
    border-radius: 0 8px 8px 0;
    padding: 0 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer; }

.rota-form-container {
  display: flex;
  flex-direction: column; }

.rota-form-section:not(:last-child) {
  margin-bottom: 24px; }

.rota-section-title {
  font-weight: 700;
  color: #1f2a44;
  font-size: 16px;
  margin-bottom: 12px; }

.rota-form-grid {
  display: grid;
  row-gap: 16px; }

.rota-grid-2col {
  grid-template-columns: 1fr 1fr;
  column-gap: 16px; }

.rota-grid-3col {
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 16px; }

.rota-grid-uf-municipio {
  grid-template-columns: 35% 1fr;
  column-gap: 16px; }

.rota-field {
  display: flex;
  flex-direction: column;
  min-width: 0; }
  .rota-field > label {
    margin-bottom: 2px; }
  .rota-field > .form-group,
  .rota-field > div > .form-group {
    margin-bottom: 0; }
    .rota-field > .form-group > label:empty,
    .rota-field > div > .form-group > label:empty {
      display: none;
      margin: 0;
      padding: 0;
      height: 0; }
  .rota-field > .transpale-wrapper {
    margin-bottom: 0; }
  .rota-field > small, .rota-field > .small,
  .rota-field > .rota-field-hint {
    margin-top: 0; }

.rota-form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 32px; }

.historico-rota-container {
  display: flex;
  flex-direction: column;
  gap: 16px; }

.historico-header-card {
  background: transparent;
  border: none;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  gap: 12px; }
  .historico-header-card .historico-flow-section {
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%; }
  .historico-header-card .historico-context-section {
    padding: 8px 0;
    width: 100%;
    display: flex;
    justify-content: center; }
    .historico-header-card .historico-context-section .card-context-dynamic-wrapper {
      width: 100%; }

.historico-accordion-wrapper {
  background: #f8fafc;
  border-radius: 12px;
  padding: 8px; }

.historico-accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #dbeafe;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s; }
  .historico-accordion-header:hover {
    background: #bfdbfe; }

.historico-accordion-body {
  padding: 16px 8px 8px 8px; }

.historico-timeline {
  display: flex;
  flex-direction: column; }

.historico-timeline-item {
  display: flex;
  gap: 16px;
  position: relative; }

.historico-timeline-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0; }

.historico-timeline-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0; }

.historico-timeline-line {
  width: 2px;
  flex-grow: 1;
  min-height: 24px;
  margin-top: 4px;
  margin-bottom: 4px;
  opacity: 0.4; }

.historico-timeline-content {
  flex-grow: 1;
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 4px 0;
  margin-bottom: 12px; }

.historico-timeline-badge {
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 14px;
  color: #334155; }
  .historico-timeline-badge i {
    color: #3B82F6; }

.status-active {
  color: #22c55e;
  font-size: 18px; }

.status-inactive {
  color: #ef4444;
  font-size: 18px; }

.rota-confirm-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 40px 24px;
  max-width: 400px;
  margin: 0 auto; }

.calendar-multi-month {
  display: flex;
  gap: 32px;
  background: #F5F5F5;
  border-radius: 12px;
  padding: 37px 20px; }
  .calendar-multi-month .calendar-month {
    flex: 1 1;
    min-width: 0; }
    .calendar-multi-month .calendar-month .calendar-month-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 16px;
      color: #263874;
      margin-bottom: 20px; }
      .calendar-multi-month .calendar-month .calendar-month-header .calendar-nav-btn {
        background: transparent;
        border: 0;
        padding: 4px 8px;
        color: #263874;
        cursor: pointer; }
        .calendar-multi-month .calendar-month .calendar-month-header .calendar-nav-btn[disabled] {
          display: none; }
    .calendar-multi-month .calendar-month .calendar-weekdays {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      text-align: center;
      color: #498EF2;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 8px; }
      .calendar-multi-month .calendar-month .calendar-weekdays span {
        /* height: 37px; */
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center; }
    .calendar-multi-month .calendar-month .calendar-days {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 4px; }
    .calendar-multi-month .calendar-month .calendar-day {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 30px;
      height: 30px;
      max-height: 30px;
      margin: 0 auto;
      border-radius: 50%;
      font-size: 13px;
      color: #244EA2;
      cursor: pointer;
      -webkit-user-select: none;
              user-select: none;
      transition: background-color 0.15s, color 0.15s; }
      .calendar-multi-month .calendar-month .calendar-day:not(.calendar-day--disabled):not(.calendar-day--past):not(.calendar-day--other-month):hover {
        background-color: #82C0F9;
        color: #244EA2; }
      .calendar-multi-month .calendar-month .calendar-day--selected {
        background-color: #244EA2;
        color: #fff;
        font-weight: 600; }
      .calendar-multi-month .calendar-month .calendar-day--disabled {
        background-color: #D9D9D9;
        color: #676A6C;
        cursor: default; }
      .calendar-multi-month .calendar-month .calendar-day--past {
        color: #CDCDCD;
        cursor: default; }
      .calendar-multi-month .calendar-month .calendar-day--other-month {
        color: #D9D9D9;
        cursor: default; }

.text-color-azul4-hover:hover {
  color: #498EF2 !important; }

.bootstrap-touchspin.input-group > .input-group-prepend > .btn, .bootstrap-touchspin.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.bootstrap-touchspin.input-group > .input-group-append > .btn, .bootstrap-touchspin.input-group > .input-group-append > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.fc-toolbar h2, .fc-toolbar .h2 {
  font-size: 1rem;
  line-height: 30px;
  text-transform: uppercase; }

.fc th.fc-widget-header {
  background: #eff2f7;
  font-size: 13px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 600; }

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #eff2f7; }

.fc-unthemed td.fc-today {
  background: #fdfdfe; }

.fc-button {
  background: #fff;
  border-color: #eff2f7;
  color: #505d69;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important; }

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #244EA2;
  color: #fff;
  text-shadow: none; }

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center; }

#external-events .external-event {
  text-align: left !important;
  padding: 8px 16px; }

.fc-event, .fc-event-dot {
  background-color: #244EA2; }

.fc-event .fc-content {
  color: #fff; }

.fc .table-bordered td, .fc .table-bordered th {
  border-color: #eff2f7; }

@media (max-width: 575.98px) {
  .fc .fc-toolbar {
    display: block; } }

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 1rem;
  line-height: 30px;
  text-transform: uppercase; }

@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc .fc-toolbar .fc-today-button {
    display: none; } }

.fc .fc-toolbar .btn {
  text-transform: capitalize; }

.fc-bootstrap .fc-today.alert-info {
  background-color: #f1f5f7; }

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {
  background-color: #000 !important; }

[dir="rtl"] .fc-header-toolbar {
  direction: ltr !important; }

[dir="rtl"] .fc-toolbar > * > :not(:first-child) {
  margin-left: .75em; }

.sp-container {
  background-color: #fff; }
  .sp-container button {
    padding: 0.25rem 0.5rem;
    font-size: 0.71094rem;
    border-radius: 0.2rem;
    font-weight: 400;
    color: #343a40; }
    .sp-container button.sp-palette-toggle {
      background-color: #eff2f7; }
    .sp-container button.sp-choose {
      background-color: #4bb543;
      margin-left: 5px;
      margin-right: 0; }

.sp-palette-container {
  border-right: 1px solid #eff2f7; }

.sp-input {
  background-color: #fff;
  border-color: #ced4da !important;
  color: #505d69; }
  .sp-input:focus {
    outline: none; }

.sp-colorize-container.sp-add-on {
  border: 1px solid #ced4da !important; }

.sp-original-input-container .sp-add-on {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important; }

input.spectrum.with-add-on {
  border: 1px solid #ced4da;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; }

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  border-right: 1px solid #D7D7D7; }

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit; }

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0; }

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch; }

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important; }

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none; }

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table; }

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none; }

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0; }

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1; }

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden; }

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none; }

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all; }

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px; }

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear; }

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear; }

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px; }

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px; }

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto; }

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0; }

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll; }

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none; }

.custom-scroll {
  height: 100%; }

.dataTables_wrapper.container-fluid, .dataTables_wrapper.container-sm, .dataTables_wrapper.container-md, .dataTables_wrapper.container-lg, .dataTables_wrapper.container-xl, .dataTables_wrapper.container-xxl {
  padding: 0; }

div.dataTables_wrapper div.dataTables_filter {
  text-align: right; }
  @media (max-width: 767px) {
    div.dataTables_wrapper div.dataTables_filter {
      text-align: center; } }
  div.dataTables_wrapper div.dataTables_filter input {
    margin-left: 0.5em;
    margin-right: 0; }

.datatable td:focus {
  outline: none; }

div.table-responsive > div.dataTables_wrapper > div.row > div[class^="col-"]:first-child {
  padding-left: 0; }

div.table-responsive > div.dataTables_wrapper > div.row > div[class^="col-"]:last-child {
  padding-right: 0; }

table.dataTable {
  border-collapse: collapse !important;
  margin-bottom: 15px !important; }
  table.dataTable thead .sorting:before,
  table.dataTable thead .sorting_asc:before,
  table.dataTable thead .sorting_desc:before,
  table.dataTable thead .sorting_asc_disabled:before,
  table.dataTable thead .sorting_desc_disabled:before {
    left: auto;
    right: 0.5rem;
    content: "\\F0360";
    font-family: "Material Design Icons";
    font-size: 1rem;
    top: 9px; }
  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after,
  table.dataTable thead .sorting_asc_disabled:after,
  table.dataTable thead .sorting_desc_disabled:after {
    left: auto;
    right: 0.5em;
    content: "\\F035D";
    font-family: "Material Design Icons";
    top: 15px;
    font-size: 1rem; }
  table.dataTable thead tr th.sorting_asc, table.dataTable thead tr th.sorting_desc, table.dataTable thead tr th.sorting,
  table.dataTable thead tr td.sorting_asc,
  table.dataTable thead tr td.sorting_desc,
  table.dataTable thead tr td.sorting {
    padding-left: 12px;
    padding-right: 30px; }
  table.dataTable tbody > tr.selected, table.dataTable tbody > tr > .selected {
    background-color: rgba(36, 78, 162, 0.2); }
    table.dataTable tbody > tr.selected td, table.dataTable tbody > tr > .selected td {
      border-color: rgba(36, 78, 162, 0.2);
      color: #244EA2; }
  table.dataTable tbody td:focus {
    outline: none !important; }
  table.dataTable tbody th.focus, table.dataTable tbody td.focus {
    outline: 2px solid #244EA2 !important;
    outline-offset: -1px;
    background-color: rgba(36, 78, 162, 0.15); }

.dataTables_info {
  font-weight: 600; }

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  background-color: #4bb543;
  bottom: auto; }

table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  background-color: #EC221F; }

div.dt-button-info {
  background-color: #244EA2;
  border: none;
  color: #fff;
  box-shadow: none;
  border-radius: 3px;
  text-align: center;
  z-index: 21; }
  div.dt-button-info h2, div.dt-button-info .h2 {
    border-bottom: none;
    background-color: rgba(255, 255, 255, 0.2);
    color: #fff; }

@media (max-width: 767.98px) {
  li.paginate_button.previous,
  li.paginate_button.next {
    display: inline-block;
    font-size: 1.5rem; }
  li.paginate_button {
    display: none; }
  .dataTables_paginate ul {
    text-align: center;
    display: block;
    margin: 1rem 0 0 !important; }
  div.dt-buttons {
    display: inline-table;
    margin-bottom: 1rem; }
  .sorting_1 {
    cursor: pointer; } }

.activate-select .sorting_1 {
  background-color: #f8f9fa; }

.table-bordered {
  border: 1px solid #eff2f7; }

.table.dataTable.dtr-inline.collapsed > tbody > tr > td,
table.dataTable.dtr-inline.collapsed > tbody > tr > td {
  position: relative; }
  .table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control,
  table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control {
    padding-left: 30px; }
    .table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before,
    table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before {
      top: 64%;
      left: 5px;
      height: 14px;
      width: 14px;
      margin-top: -14px;
      display: block;
      position: absolute;
      color: #fff;
      border: 2px solid #fff;
      border-radius: 14px;
      box-sizing: content-box;
      text-align: center;
      text-indent: 0 !important;
      line-height: 12px;
      content: '+';
      background-color: #244EA2; }

.datepicker {
  border: 1px solid #f8f9fa;
  padding: 8px;
  z-index: 999 !important; }
  .datepicker table tr th {
    font-weight: 500; }
  .datepicker table tr td.active, .datepicker table tr td.active:hover, .datepicker table tr td .active.disabled, .datepicker table tr td.active.disabled:hover, .datepicker table tr td.today, .datepicker table tr td.today:hover, .datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:hover, .datepicker table tr td.selected, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.disabled, .datepicker table tr td.selected.disabled:hover {
    background-color: #244EA2 !important;
    background-image: none;
    box-shadow: none;
    color: #fff !important; }
  .datepicker table tr td.day.focused, .datepicker table tr td.day:hover,
  .datepicker table tr td span.focused,
  .datepicker table tr td span:hover {
    background: #eff2f7; }
  .datepicker table tr td.new, .datepicker table tr td.old,
  .datepicker table tr td span.new,
  .datepicker table tr td span.old {
    color: #adb5bd;
    opacity: 0.6; }
  .datepicker table tr td.range, .datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:hover, .datepicker table tr td.range:hover {
    background-color: #f1f5f7; }

.table-condensed > thead > tr > th, .table-condensed > tbody > tr > td {
  padding: 7px; }

/* Flot chart */
.flot-charts-height {
  height: 320px; }

.flotTip {
  padding: 8px 12px;
  background-color: #fff !important;
  z-index: 100;
  color: #74788d !important;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 4px; }

.legendLabel {
  color: #adb5bd; }

.legend div {
  background-color: transparent !important; }

.ql-container {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
  font-family: var(--bs-font-sans-serif); }
  .ql-container.ql-snow {
    border-color: #ced4da; }

.ql-bubble {
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }

.ql-toolbar {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
  font-family: var(--bs-font-sans-serif) !important; }
  .ql-toolbar span {
    outline: none !important;
    color: #505d69; }
    .ql-toolbar span:hover {
      color: #244EA2 !important; }
  .ql-toolbar.ql-snow {
    border-color: #ced4da; }
    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
      border-color: transparent; }

.ql-editing {
  right: 0 !important;
  top: 0 !important;
  left: auto !important; }

.ql-snow .ql-tooltip {
  background-color: #fff;
  color: #212529;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  border: 0 solid rgba(0, 0, 0, 0.15); }
  .ql-snow .ql-tooltip input {
    background: #fff;
    color: #505d69;
    border-color: #b1bbc4 !important; }

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: #505d69; }

.ql-snow .ql-fill {
  fill: #505d69; }

.ql-snow .ql-picker-options {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.15) !important; }

/* Dropzone */
.dropzone {
  min-height: 230px;
  border: 2px dashed #ced4da;
  background: #fff;
  border-radius: 6px; }
  .dropzone .dz-message {
    font-size: 24px;
    width: 100%;
    text-align: center;
    padding: 30px; }
    .dropzone .dz-message:focus {
      outline: none; }

.twitter-bs-wizard .twitter-bs-wizard-nav {
  position: relative; }
  .twitter-bs-wizard .twitter-bs-wizard-nav:before {
    content: "";
    width: 100%;
    height: 2px;
    background-color: #f1f5f7;
    position: absolute;
    left: 0;
    top: 26px; }
  .twitter-bs-wizard .twitter-bs-wizard-nav .step-number {
    display: inline-block;
    width: 38px;
    height: 38px;
    line-height: 34px;
    border: 2px solid #244EA2;
    color: #244EA2;
    text-align: center;
    border-radius: 50%;
    position: relative;
    background-color: #fff; }
    @media (max-width: 991.98px) {
      .twitter-bs-wizard .twitter-bs-wizard-nav .step-number {
        display: block;
        margin: 0 auto 8px !important; } }
  .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link .step-title {
    display: block;
    margin-top: 8px;
    font-weight: 600; }
    @media (max-width: 575.98px) {
      .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link .step-title {
        display: none; } }
  .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link.active {
    background-color: transparent;
    color: #505d69; }
    .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link.active .step-number {
      background-color: #244EA2;
      color: #fff; }

.twitter-bs-wizard .twitter-bs-wizard-pager-link {
  padding-top: 24px;
  padding-left: 0;
  list-style: none;
  margin-bottom: 0; }
  .twitter-bs-wizard .twitter-bs-wizard-pager-link li {
    display: inline-block; }
    .twitter-bs-wizard .twitter-bs-wizard-pager-link li a {
      display: inline-block;
      padding: .47rem .75rem;
      background-color: #244EA2;
      color: #fff;
      border-radius: .25rem; }
    .twitter-bs-wizard .twitter-bs-wizard-pager-link li.disabled a {
      cursor: not-allowed;
      background-color: #2b5ec3; }
    .twitter-bs-wizard .twitter-bs-wizard-pager-link li.next {
      float: right; }

.twitter-bs-wizard-tab-content {
  padding-top: 24px;
  min-height: 262px; }

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f8f9fa;
  border-radius: 3px; }

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 1rem;
  line-height: 40px;
  background: #244EA2;
  border-radius: 4px;
  padding: 10px 20px; }

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute; }
  .gmaps-overlay_arrow.above {
    bottom: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid #244EA2; }
  .gmaps-overlay_arrow.below {
    top: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 16px solid #244EA2; }

.error {
  color: #EC221F; }

.parsley-error {
  border-color: #EC221F; }

.parsley-errors-list {
  display: none;
  margin: 0;
  padding: 0; }
  .parsley-errors-list.filled {
    display: block; }
  .parsley-errors-list > li {
    font-size: 12px;
    list-style: none;
    color: #EC221F;
    margin-top: 5px; }

.irs .irs--square {
  cursor: pointer; }

.irs--round .irs-bar,
.irs--round .irs-to,
.irs--round .irs-from,
.irs--round .irs-single {
  background: #244EA2 !important;
  font-size: 11px; }

.irs--round .irs-to,
.irs--round .irs-from,
.irs--round .irs-single {
  top: 5px; }
  .irs--round .irs-to:before,
  .irs--round .irs-from:before,
  .irs--round .irs-single:before {
    display: none; }

.irs--round .irs-line {
  background: #f1f5f7;
  border-color: #f1f5f7;
  cursor: pointer; }

.irs--round .irs-grid-text {
  font-size: 11px;
  color: #ced4da; }

.irs--round .irs-min,
.irs--round .irs-max {
  color: #adb5bd;
  background: #f1f5f7;
  font-size: 11px; }

.irs--round .irs-handle {
  border: 2px solid #244EA2;
  width: 12px;
  height: 12px;
  top: 31px;
  background-color: #fff !important;
  cursor: pointer; }
  .irs--round .irs-handle:active {
    cursor: pointer; }

.symbol {
  border-color: #fff; }

.rating-symbol-background, .rating-symbol-foreground {
  font-size: 24px; }

.rating-symbol-foreground {
  top: 0px; }

.rating-star > span {
  display: inline-block;
  vertical-align: middle; }
  .rating-star > span.badge {
    margin-left: 4px; }

.table-rep-plugin .btn-toolbar {
  display: block; }

.table-rep-plugin .table-responsive {
  border: none !important; }

.table-rep-plugin .btn-group .btn-default {
  background-color: #eff2f7;
  color: #343a40;
  border: 1px solid #e8ecf4; }
  .table-rep-plugin .btn-group .btn-default.btn-primary {
    background-color: #244EA2;
    border-color: #244EA2;
    color: #fff; }

.table-rep-plugin .btn-group.pull-right {
  float: right; }
  .table-rep-plugin .btn-group.pull-right .dropdown-menu {
    right: 0;
    transform: none !important;
    top: 100% !important; }

.table-rep-plugin tbody th {
  font-size: 14px;
  font-weight: normal; }

.table-rep-plugin .checkbox-row {
  padding-left: 40px;
  color: #505d69 !important; }
  .table-rep-plugin .checkbox-row:hover {
    background-color: #f6f8fa !important; }
  .table-rep-plugin .checkbox-row label {
    display: inline-block;
    padding-left: 5px;
    position: relative; }
    .table-rep-plugin .checkbox-row label::before {
      -o-transition: 0.3s ease-in-out;
      -webkit-transition: 0.3s ease-in-out;
      background-color: #fff;
      border-radius: 3px;
      border: 1px solid #f1f5f7;
      content: "";
      display: inline-block;
      height: 17px;
      left: 0;
      margin-left: -20px;
      position: absolute;
      transition: 0.3s ease-in-out;
      width: 17px;
      outline: none !important; }
    .table-rep-plugin .checkbox-row label::after {
      color: #eff2f7;
      display: inline-block;
      font-size: 11px;
      height: 16px;
      left: 0;
      margin-left: -20px;
      padding-left: 3px;
      padding-top: 1px;
      position: absolute;
      top: -1px;
      width: 16px; }
  .table-rep-plugin .checkbox-row input[type="checkbox"] {
    cursor: pointer;
    opacity: 0;
    z-index: 1;
    outline: none !important; }
    .table-rep-plugin .checkbox-row input[type="checkbox"]:disabled + label {
      opacity: 0.65; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:focus + label::before {
    outline-offset: -2px;
    outline: none; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:checked + label::after {
    content: "\\f00c";
    font-family: 'Font Awesome 5 Free';
    font-weight: 900; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:disabled + label::before {
    background-color: #f8f9fa;
    cursor: not-allowed; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:checked + label::before {
    background-color: #244EA2;
    border-color: #244EA2; }
  .table-rep-plugin .checkbox-row input[type="checkbox"]:checked + label::after {
    color: #fff; }

.table-rep-plugin .fixed-solution .sticky-table-header {
  top: 76px !important;
  background-color: #244EA2; }
  .table-rep-plugin .fixed-solution .sticky-table-header table {
    color: #fff; }

@media (min-width: 992px) {
  body[data-layout="horizontal"] .fixed-solution .sticky-table-header {
    top: 126px !important; } }

.select2-container {
  display: block; }
  .select2-container .select2-selection--single {
    background-color: #fff;
    border: 1px solid #ced4da;
    height: 38px; }
    .select2-container .select2-selection--single:focus {
      outline: none; }
    .select2-container .select2-selection--single .select2-selection__rendered {
      line-height: 36px;
      padding-left: 12px;
      color: #505d69; }
    .select2-container .select2-selection--single .select2-selection__arrow {
      height: 34px;
      width: 34px;
      right: 3px; }
      .select2-container .select2-selection--single .select2-selection__arrow b {
        border-color: #adb5bd transparent transparent transparent;
        border-width: 6px 6px 0 6px; }
    .select2-container .select2-selection--single .select2-selection__placeholder {
      color: #505d69; }

[dir="rtl"] .select2-selection__rendered {
  text-align: end; }

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent #adb5bd transparent !important;
  border-width: 0 6px 6px 6px !important; }

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: #fff; }
  .select2-container--default .select2-search--dropdown .select2-search__field {
    border: 1px solid #ced4da;
    background-color: #fff;
    color: #74788d;
    outline: none; }

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #244EA2; }

.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: #f8f9fa;
  color: #16181b; }
  .select2-container--default .select2-results__option[aria-selected="true"]:hover {
    background-color: #244EA2;
    color: #fff; }

.select2-results__option {
  padding: 6px 12px; }

.select2-dropdown {
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #fff;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08); }

.select2-search input {
  border: 1px solid #f1f5f7; }

.select2-container .select2-selection--multiple {
  min-height: 38px;
  background-color: #fff;
  border: 1px solid #ced4da !important; }
  .select2-container .select2-selection--multiple .select2-selection__rendered {
    padding: 2px 10px; }
  .select2-container .select2-selection--multiple .select2-search__field {
    border: 0;
    color: #505d69; }
    .select2-container .select2-selection--multiple .select2-search__field::placeholder {
      color: #505d69; }
  .select2-container .select2-selection--multiple .select2-selection__choice {
    background-color: #eff2f7;
    border: 1px solid #f1f5f7;
    border-radius: 1px;
    padding: 0 7px; }

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #ced4da; }

.select2-container--default .select2-results__group {
  font-weight: 600; }

.select2-result-repository__avatar {
  float: left;
  width: 60px;
  margin-right: 10px; }
  .select2-result-repository__avatar img {
    width: 100%;
    height: auto;
    border-radius: 2px; }

.select2-result-repository__statistics {
  margin-top: 7px; }

.select2-result-repository__forks,
.select2-result-repository__stargazers,
.select2-result-repository__watchers {
  display: inline-block;
  font-size: 11px;
  margin-right: 1em;
  color: #adb5bd; }
  .select2-result-repository__forks .fa,
  .select2-result-repository__stargazers .fa,
  .select2-result-repository__watchers .fa {
    margin-right: 4px; }
    .select2-result-repository__forks .fa.fa-flash::before,
    .select2-result-repository__stargazers .fa.fa-flash::before,
    .select2-result-repository__watchers .fa.fa-flash::before {
      content: "\\f0e7";
      font-family: "Font Awesome 5 Free"; }

.select2-results__option--highlighted .select2-result-repository__forks,
.select2-results__option--highlighted .select2-result-repository__stargazers,
.select2-results__option--highlighted .select2-result-repository__watchers {
  color: rgba(255, 255, 255, 0.8); }

.select2-result-repository__meta {
  overflow: hidden; }

.img-flag {
  margin-right: 7px;
  height: 15px;
  width: 18px; }

#session-timeout-dialog .close {
  display: none; }

#session-timeout-dialog .countdown-holder {
  color: #EC221F;
  font-weight: 500; }

#session-timeout-dialog .btn-default {
  background-color: #fff;
  color: #EC221F;
  box-shadow: none; }

.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #343a40 !important;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  padding: 5px 10px !important;
  border-radius: 3px;
  border-color: #212529 !important; }

.jqsfield {
  color: #eff2f7 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-weight: 500 !important; }

.swal2-container .swal2-title {
  font-size: 24px;
  font-weight: 500; }

.swal2-content {
  font-size: 1rem; }

.swal2-icon.swal2-question {
  border-color: #F0F0F0;
  color: #F0F0F0; }

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #4bb543; }

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(75, 181, 67, 0.3); }

.swal2-icon.swal2-warning {
  border-color: #fece22;
  color: #fece22; }

.swal2-styled:focus {
  box-shadow: none; }

.swal2-progress-steps .swal2-progress-step {
  background: #244EA2; }
  .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
    background: #244EA2; }
    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
      background: rgba(36, 78, 162, 0.3); }

.swal2-progress-steps .swal2-progress-step-line {
  background: #244EA2; }

.swal2-loader {
  border-color: #244EA2 transparent #244EA2 transparent; }

/* CSS Switch */
input[switch] {
  display: none; }
  input[switch] + label {
    font-size: 1em;
    line-height: 1;
    width: 56px;
    height: 24px;
    background-color: #ced4da;
    background-image: none;
    border-radius: 2rem;
    padding: 0.16667rem;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    position: relative;
    font-weight: 500;
    transition: all 0.1s ease-in-out; }
    input[switch] + label:before {
      color: #343a40;
      content: attr(data-off-label);
      display: block;
      font-family: inherit;
      font-weight: 500;
      font-size: 12px;
      line-height: 21px;
      position: absolute;
      right: 1px;
      margin: 3px;
      top: -2px;
      text-align: center;
      min-width: 1.66667rem;
      overflow: hidden;
      transition: all 0.1s ease-in-out; }
    input[switch] + label:after {
      content: '';
      position: absolute;
      left: 3px;
      background-color: #eff2f7;
      box-shadow: none;
      border-radius: 2rem;
      height: 20px;
      width: 20px;
      top: 2px;
      transition: all 0.1s ease-in-out; }
  input[switch]:checked + label {
    background-color: #244EA2; }

input[switch]:checked + label {
  background-color: #244EA2; }
  input[switch]:checked + label:before {
    color: #fff;
    content: attr(data-on-label);
    right: auto;
    left: 3px; }
  input[switch]:checked + label:after {
    left: 33px;
    background-color: #eff2f7; }

input[switch="bool"] + label {
  background-color: #EC221F; }

input[switch="bool"] + label:before, input[switch="bool"]:checked + label:before,
input[switch="default"]:checked + label:before {
  color: #fff; }

input[switch="bool"]:checked + label {
  background-color: #4bb543; }

input[switch="default"]:checked + label {
  background-color: #a2a2a2; }

input[switch="primary"]:checked + label {
  background-color: #244EA2; }

input[switch="success"]:checked + label {
  background-color: #4bb543; }

input[switch="info"]:checked + label {
  background-color: #F0F0F0; }

input[switch="warning"]:checked + label {
  background-color: #fece22; }

input[switch="danger"]:checked + label {
  background-color: #EC221F; }

input[switch="dark"]:checked + label {
  background-color: #343a40; }

.square-switch {
  margin-right: 7px; }
  .square-switch input[switch] + label, .square-switch input[switch] + label:after {
    border-radius: 4px; }

.table-edits input, .table-edits select {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  background-color: #fff;
  color: #505d69;
  border-radius: 0.25rem; }
  .table-edits input:focus, .table-edits select:focus {
    outline: none;
    border-color: #b1bbc4; }

.jqvmap-label {
  background-color: #343a40;
  color: #eff2f7;
  font-size: 0.875rem;
  padding: 0.3rem 0.6rem; }

.jqvmap-zoomin, .jqvmap-zoomout {
  width: 24px;
  height: 24px;
  line-height: 18px; }

.jqvmap-zoomout {
  top: 40px; }

.editable-input .form-control {
  display: inline-block; }

.editable-buttons {
  margin-left: 7px; }
  .editable-buttons .editable-cancel {
    margin-left: 7px; }

body, input, button, p, h1, .h1, h2, .h2, h3, .h3, h4, .h4, span, strong, div, a {
  font-family: 'Poppins', sans-serif; }

.texto1-login {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  text-align: left;
  color: #333333; }
  @media (max-width: 992px) {
    .texto1-login {
      font-size: 26px; } }

@media only screen and (max-height: 680px) {
  .texto1-login {
    font-size: 24px !important;
    line-height: 36px !important; }
  .col-login .card-body {
    padding: 0 30px !important; } }

.bg-pattern {
  background: #EBEBEB;
  left: 0px;
  top: 0px;
  right: 0px; }

.card-login {
  box-shadow: none;
  background: transparent; }

.auth-logo.logo-light {
  display: none !important; }

.bold-01 {
  font-weight: 800;
  text-align: left;
  color: #333333; }

.logo-login {
  width: 250px;
  height: auto; }

.logo-app {
  width: 10vw;
  height: auto; }

.col-login {
  height: 100vh;
  background: #ebebeb; }

.banner-login {
  width: 100vh;
  height: 100vh;
  object-fit: cover; }

.carouselExampleIndicators {
  z-index: 2001; }

.carousel-indicators {
  z-index: 2002 !important; }

.carousel-indicators [data-bs-target] {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  /* Transformar em bolinhas */
  background-color: #9de6e6;
  opacity: 1;
  z-index: 2003; }

.carousel-control-next,
.carousel-control-prev {
  z-index: 2000; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 4rem;
  height: 4rem; }

.carousel-indicators .active {
  background-color: white; }

.t-right {
  text-align: right; }

.t-left {
  text-align: left; }

.botao-voltar-login {
  padding-bottom: 10px;
  color: #757575; }

.fale-conosco {
  padding-left: 5px; }

.overlay-banner-login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #001a4f54;
  z-index: 500; }

.azul-claro {
  color: #7dc3dc; }

.input-icone-login {
  background: #fff;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem; }

.input-login {
  border-left: 0px;
  font-size: 1rem !important;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
  height: 45px; }

.bt-icone-login {
  position: absolute;
  right: 0px;
  top: 7px;
  z-index: 3000; }

button.btn.btn-primary.waves-effect.waves-light {
  height: 45px;
  border-radius: #eff2f7 !important;
  font-size: 1rem !important;
  background-color: #263874 !important; }

.col-login .card-body {
  padding: 0 80px; }
  @media (max-width: 992px) {
    .col-login .card-body {
      padding: 0 40px; } }

.fala-conosco {
  padding-left: 4px; }

.page-search input[type="date"]::-webkit-inner-spin-button,
.page-search input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none; }

.page-search .content-page .sidebar {
  width: 110px;
  display: flex;
  gap: 8px;
  flex-direction: column; }
  .page-search .content-page .sidebar button {
    transition: .2s ease-in-out;
    text-align: center;
    width: 100%;
    min-height: 36px;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-size: 13px;
    padding: 6px 0;
    background-color: transparent;
    border-radius: 18px;
    border: 2px solid #0F1D42;
    position: relative; }
    .page-search .content-page .sidebar button.actived, .page-search .content-page .sidebar button:hover:not(.disabled) {
      background-color: #0F1D42;
      border-color: #0F1D42;
      color: white; }
    .page-search .content-page .sidebar button.disabled {
      cursor: not-allowed;
      color: #CDCDCD;
      border-color: #CDCDCD; }
      .page-search .content-page .sidebar button.disabled span.dot {
        color: white !important;
        background-color: #CDCDCD !important; }
    .page-search .content-page .sidebar button span.dot {
      position: absolute;
      right: -8px;
      top: -2px;
      z-index: 1;
      height: 16px;
      border-radius: 8px;
      background-color: #498EF2;
      color: white;
      font-size: 11px;
      padding: 0px 4px;
      margin: 0; }
  .page-search .content-page .sidebar .dropdown-filter div:first-child > a {
    background-color: transparent;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #263874;
    width: 100%;
    text-align: center;
    margin: 8px 0 10px; }
    .page-search .content-page .sidebar .dropdown-filter div:first-child > a.disabled, .page-search .content-page .sidebar .dropdown-filter div:first-child > a.disabled:hover {
      cursor: not-allowed;
      color: #CDCDCD; }
    .page-search .content-page .sidebar .dropdown-filter div:first-child > a:hover, .page-search .content-page .sidebar .dropdown-filter div:first-child > a.actived {
      color: #244EA2; }
    .page-search .content-page .sidebar .dropdown-filter div:first-child > a::after {
      display: none; }
  .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter {
    display: none;
    position: absolute;
    width: 280px;
    transition: .2s ease-in-out;
    height: auto;
    top: 0;
    left: 130px;
    border-radius: 4px;
    padding: 8px 0;
    background-color: #F5F5F5;
    box-shadow: 0px 1px 3px 1px #00000026;
    z-index: 99; }
    .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .pre-filters {
      position: relative;
      padding: 0 12px 12px;
      border-bottom: 1px solid #CDCDCD; }
      .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .pre-filters .header-title {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 20px;
        display: block;
        margin-bottom: 5px;
        color: #263874; }
      .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .pre-filters button {
        text-align: left;
        border: none;
        color: #263874;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
        height: 36px;
        font-size: 16px; }
        .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .pre-filters button:hover {
          background-color: transparent;
          text-decoration: underline; }
    .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs {
      padding: 12px 12px 0; }
      .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs label {
        font-family: "Poppins", sans-serif;
        font-weight: 500;
        font-size: 14px;
        color: #6C6C6C; }
      .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group {
        width: 100%;
        height: 54px;
        border-radius: 12px;
        background-color: white;
        justify-content: space-between;
        border: 1px solid #A8A8A8;
        display: flex;
        align-items: center;
        cursor: pointer; }
        .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group:has(input:active), .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group:hover, .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group:has(input:focus) {
          border-color: #244EA2 !important; }
        .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group input {
          border: none;
          background-color: transparent;
          font-weight: 400;
          font-size: 16px;
          color: #A8A8A8; }
          .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group input::placeholder {
            color: #A8A8A8; }
        .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group .input-group-append {
          width: 54px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border-left: 1px solid #A8A8A8; }
          .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .input-group .input-group-append i {
            font-size: 19px;
            color: #263874; }
      .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .footer-btn button {
        height: 54px;
        border-radius: 10px;
        transition: .2s ease-in-out;
        padding: 8px 16px;
        font-weight: 600;
        font-size: 16px;
        font-family: "Poppins", sans-serif; }
        .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .footer-btn button[type="button"]:hover {
          color: #244EA2 !important;
          background-color: transparent !important; }
        .page-search .content-page .sidebar .dropdown-filter div:first-child .dropdown-content-filter .content-inputs .footer-btn button[type="submit"] {
          color: white;
          background-color: #0F1D42; }

.page-search .content-page .overlay {
  background-color: #00000018;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  position: absolute;
  overflow: auto; }

.page-search .content-page .rightbar {
  margin-left: 20px; }
  .page-search .content-page .rightbar hr {
    color: #CDCDCD; }
  .page-search .content-page .rightbar .subtitle-item-container {
    margin-bottom: 12px; }
    .page-search .content-page .rightbar .subtitle-item-container span.dot {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 43px;
      margin-left: 20px;
      height: 32px;
      border-radius: 18px;
      padding-top: 4px 16px;
      color: white;
      background-color: #498EF2; }
  .page-search .content-page .rightbar .more-see-link {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-size: 14px;
    padding: 4px;
    background-color: transparent;
    color: #498EF2;
    border: none;
    outline: none;
    text-decoration: underline; }
  .page-search .content-page .rightbar .item-container {
    width: 935px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0px 1px 3px 1px #00000026;
    background-color: white;
    border-radius: 12px;
    border: 1px solid #A8A8A8;
    border-left: 5px solid #193576;
    transition: .2s ease-in-out; }
    .page-search .content-page .rightbar .item-container .item-content-header .icon-arrow {
      font-size: 24px;
      color: #A8A8A8;
      margin-top: 1px; }
    .page-search .content-page .rightbar .item-container .item-content-header .external-link {
      font-size: 16px;
      color: #263874;
      cursor: pointer; }
    .page-search .content-page .rightbar .item-container .item-content-body .item-badge-info {
      gap: 10px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      height: 40px;
      border-radius: 12px;
      background-color: #F0F0F0;
      font-family: "Poppins", sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: #353535; }
      .page-search .content-page .rightbar .item-container .item-content-body .item-badge-info i {
        font-size: 22px;
        color: #263874; }
    .page-search .content-page .rightbar .item-container .item-content-body .container-status .flag {
      height: 30px;
      border-radius: 18px;
      padding: 6px 16px;
      color: white;
      background-color: #244EA2;
      font-family: "Poppins", sans-serif;
      font-weight: 400;
      font-size: 12px; }
    .page-search .content-page .rightbar .item-container .item-content-body .container-status i {
      color: #498EF2;
      font-size: 16px !important; }
    .page-search .content-page .rightbar .item-container .item-content-footer {
      margin-top: 8px; }
      .page-search .content-page .rightbar .item-container .item-content-footer i, .page-search .content-page .rightbar .item-container .item-content-footer span, .page-search .content-page .rightbar .item-container .item-content-footer .info-footer {
        font-size: 16px;
        color: #6C6C6C; }
      .page-search .content-page .rightbar .item-container .item-content-footer span, .page-search .content-page .rightbar .item-container .item-content-footer .info-footer {
        font-size: 12px !important;
        line-height: 100%;
        font-family: "Poppins", sans-serif; }
      .page-search .content-page .rightbar .item-container .item-content-footer span {
        font-weight: 400; }
      .page-search .content-page .rightbar .item-container .item-content-footer .info-footer {
        color: #263874 !important;
        font-weight: 500; }
    .page-search .content-page .rightbar .item-container .name, .page-search .content-page .rightbar .item-container .full-date, .page-search .content-page .rightbar .item-container .info {
      color: #353535; }
    .page-search .content-page .rightbar .item-container .name {
      font-family: "Poppins", sans-serif;
      font-family: Poppins;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%; }
    .page-search .content-page .rightbar .item-container.visited {
      border-left: 1px solid #A8A8A8 !important; }
    .page-search .content-page .rightbar .item-container.visited {
      opacity: .7; }
    .page-search .content-page .rightbar .item-container .info {
      font-family: "Poppins", sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px; }
    .page-search .content-page .rightbar .item-container.container-message .date-message, .page-search .content-page .rightbar .item-container.container-message .name-user, .page-search .content-page .rightbar .item-container.container-message .info-message, .page-search .content-page .rightbar .item-container.container-message .label-info-message, .page-search .content-page .rightbar .item-container.container-transation .date-message, .page-search .content-page .rightbar .item-container.container-transation .name-user, .page-search .content-page .rightbar .item-container.container-transation .info-message, .page-search .content-page .rightbar .item-container.container-transation .label-info-message {
      color: black;
      font-family: "Poppins", sans-serif; }
    .page-search .content-page .rightbar .item-container.container-message .date-message, .page-search .content-page .rightbar .item-container.container-transation .date-message {
      font-weight: 400;
      color: #353535 !important;
      font-size: 14px !important; }
    .page-search .content-page .rightbar .item-container.container-message i, .page-search .content-page .rightbar .item-container.container-transation i {
      font-size: 15px;
      color: #263874; }
    .page-search .content-page .rightbar .item-container.container-message .label-info-message, .page-search .content-page .rightbar .item-container.container-transation .label-info-message {
      font-size: 16px;
      font-weight: 500; }
    .page-search .content-page .rightbar .item-container.container-message .name-user, .page-search .content-page .rightbar .item-container.container-transation .name-user {
      font-weight: 600;
      font-size: 18px;
      color: #0F1D42; }
    .page-search .content-page .rightbar .item-container.container-message .info-message, .page-search .content-page .rightbar .item-container.container-transation .info-message {
      font-size: 14px;
      color: #353535 !important; }
    .page-search .content-page .rightbar .item-container.container-message .code-transation, .page-search .content-page .rightbar .item-container.container-transation .code-transation {
      font-family: "Poppins", sans-serif;
      font-weight: 300;
      font-size: 16px;
      color: #A8A8A8; }
      .page-search .content-page .rightbar .item-container.container-message .code-transation i, .page-search .content-page .rightbar .item-container.container-transation .code-transation i {
        color: #A8A8A8;
        font-size: 15px; }

.page-search .content-page .container-filters-applied .label {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 0.75rem;
  color: black; }

.page-search .content-page .container-filters-applied button {
  background-color: #D6D9E2;
  border: none;
  height: 30px;
  gap: 8px;
  border-radius: 18px;
  padding: 0 16px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  transition: .2s ease-in-out;
  color: #263874;
  cursor: default; }
  .page-search .content-page .container-filters-applied button:hover {
    background-color: #244EA2;
    color: white; }
    .page-search .content-page .container-filters-applied button:hover i {
      color: white; }
  .page-search .content-page .container-filters-applied button i {
    color: #263874;
    font-size: 0.75rem;
    cursor: pointer; }

.page-search .content-page .no-content {
  margin-top: 24px; }
  .page-search .content-page .no-content h6, .page-search .content-page .no-content .h6 {
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 100%;
    color: #0F1D42;
    padding-bottom: 16px; }
  .page-search .content-page .no-content p {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #232323B2; }

/* Estilos customizados para BI_AUT003 */
.document-history-header {
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }

.timeline-step {
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); }
  .timeline-step:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); }

.timeline-connector {
  opacity: 0.3; }

.vertical-timeline {
  position: relative; }

.timeline-section {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px #00000057; }
  .timeline-section:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); }

.timeline-events {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef; }

.timeline-event {
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef; }
  .timeline-event:last-child {
    border-bottom: none; }

.timeline-marker {
  min-width: 40px; }

.timeline-dot {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 2px solid #ffffff; }

.timeline-line {
  opacity: 0.5; }

.timeline-content h6, .timeline-content .h6 {
  color: #495057;
  font-weight: 600; }

.status-indicator {
  transition: all 0.3s ease; }
  .status-indicator:hover {
    transform: scale(1.1); }

.document-flow {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 15px; }

@media (max-width: 768px) {
  .horizontal-timeline .d-flex {
    flex-wrap: wrap;
    justify-content: center; }
  .timeline-step {
    margin: 5px; }
  .timeline-connector {
    display: none; }
  .document-flow {
    text-align: center; }
  .timeline-event {
    padding: 10px 15px; } }

.timeline-section .collapse {
  transition: all 0.3s ease; }

@keyframes gradualGrow {
  0% {
    transform: scale(1); }
  5% {
    transform: scale(1.01); }
  10% {
    transform: scale(1.02); }
  15% {
    transform: scale(1.03); }
  20% {
    transform: scale(1.04); }
  25% {
    transform: scale(1.05); }
  30% {
    transform: scale(1.06); }
  35% {
    transform: scale(1.07); }
  40% {
    transform: scale(1.08); }
  45% {
    transform: scale(1.09); }
  50% {
    transform: scale(1.1); }
  55% {
    transform: scale(1.11); }
  60% {
    transform: scale(1.12); }
  65% {
    transform: scale(1.13); }
  70% {
    transform: scale(1.14); }
  75% {
    transform: scale(1.15); }
  80% {
    transform: scale(1.16); }
  85% {
    transform: scale(1.17); }
  90% {
    transform: scale(1.18); }
  95% {
    transform: scale(1.19); }
  100% {
    transform: scale(1.2); } }

@keyframes gradualShrink {
  0% {
    transform: scale(1.15); }
  6.67% {
    transform: scale(1.14); }
  13.33% {
    transform: scale(1.13); }
  20% {
    transform: scale(1.12); }
  26.67% {
    transform: scale(1.11); }
  33.33% {
    transform: scale(1.1); }
  40% {
    transform: scale(1.09); }
  46.67% {
    transform: scale(1.08); }
  53.33% {
    transform: scale(1.07); }
  60% {
    transform: scale(1.06); }
  66.67% {
    transform: scale(1.05); }
  73.33% {
    transform: scale(1.04); }
  80% {
    transform: scale(1.03); }
  86.67% {
    transform: scale(1.02); }
  93.33% {
    transform: scale(1.01); }
  100% {
    transform: scale(1); } }

/* ==============
  Email
===================*/
.mail-list a {
  display: block;
  color: #74788d;
  line-height: 24px;
  padding: 6px 5px; }
  .mail-list a.active {
    color: #EC221F;
    font-weight: 500; }
  .mail-list a i {
    font-size: 18px; }

.chat-user-box p.user-title {
  color: #343a40;
  font-weight: 500; }

.chat-user-box p {
  font-size: 13px; }

.message-list {
  display: block;
  padding-left: 0; }
  .message-list li {
    position: relative;
    display: block;
    height: 50px;
    line-height: 50px;
    cursor: default;
    transition-duration: .3s; }
    .message-list li a {
      color: #74788d; }
    .message-list li:hover {
      background: #f1f5f7;
      transition-duration: .05s; }
    .message-list li .col-mail {
      float: left;
      position: relative; }
    .message-list li .col-mail-1 {
      width: 320px; }
      .message-list li .col-mail-1 .star-toggle,
      .message-list li .col-mail-1 .checkbox-wrapper-mail,
      .message-list li .col-mail-1 .dot {
        display: block;
        float: left; }
      .message-list li .col-mail-1 .dot {
        border: 4px solid transparent;
        border-radius: 100px;
        margin: 22px 26px 0;
        height: 0;
        width: 0;
        line-height: 0;
        font-size: 0; }
      .message-list li .col-mail-1 .checkbox-wrapper-mail {
        margin: 15px 10px 0 20px; }
      .message-list li .col-mail-1 .star-toggle {
        margin-top: 18px;
        margin-left: 5px; }
      .message-list li .col-mail-1 .title {
        position: absolute;
        top: 0;
        left: 110px;
        right: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 0; }
    .message-list li .col-mail-2 {
      position: absolute;
      top: 0;
      left: 320px;
      right: 0;
      bottom: 0; }
      .message-list li .col-mail-2 .subject,
      .message-list li .col-mail-2 .date {
        position: absolute;
        top: 0; }
      .message-list li .col-mail-2 .subject {
        left: 0;
        right: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap; }
      .message-list li .col-mail-2 .date {
        right: 0;
        width: 170px;
        padding-left: 80px; }
    .message-list li.active, .message-list li.active:hover {
      box-shadow: inset 3px 0 0 #244EA2; }
    .message-list li.unread {
      background-color: #f1f5f7;
      font-weight: 500;
      color: #292d32; }
      .message-list li.unread a {
        color: #292d32;
        font-weight: 500; }
  .message-list .checkbox-wrapper-mail {
    cursor: pointer;
    height: 20px;
    width: 20px;
    position: relative;
    display: inline-block;
    box-shadow: inset 0 0 0 1px #ced4da;
    border-radius: 1px; }
    .message-list .checkbox-wrapper-mail input {
      opacity: 0;
      cursor: pointer; }
    .message-list .checkbox-wrapper-mail input:checked ~ label {
      opacity: 1; }
    .message-list .checkbox-wrapper-mail label {
      position: absolute;
      height: 20px;
      width: 20px;
      left: 0;
      cursor: pointer;
      opacity: 0;
      margin-bottom: 0;
      transition-duration: .05s;
      top: 0; }
      .message-list .checkbox-wrapper-mail label:before {
        content: "\\F012C";
        font-family: "Material Design Icons";
        top: 0;
        height: 20px;
        color: #292d32;
        width: 20px;
        position: absolute;
        margin-top: -16px;
        left: 4px;
        font-size: 13px; }

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px; } }

.counter-number {
  font-size: 32px;
  font-weight: 500;
  text-align: center; }
  .counter-number span {
    font-size: 1rem;
    font-weight: 400;
    display: block;
    padding-top: 7px; }

.coming-box {
  float: left;
  width: 21%;
  padding: 14px 7px;
  margin: 0px 24px 48px 24px;
  background-color: #fff;
  border-radius: 0.4rem;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08); }

@media (max-width: 991.98px) {
  .coming-box {
    width: 40%; } }

/************** vertical timeline **************/
/************** Horizontal timeline **************/
.slick-slide {
  margin: 10px 12px;
  transition: all ease-in-out .3s;
  opacity: .2;
  padding: 7px;
  border-radius: 4px; }
  .slick-slide:focus {
    outline: none; }

.slick-prev:before, .slick-next:before {
  color: #343a40; }

.slick-active {
  opacity: 1; }

.slick-slider.hori-timeline-desc {
  padding: 12px 24px 0;
  text-align: center;
  border-radius: 7px; }

.slick-slider.hori-timeline-nav .slick-active {
  opacity: 0.5; }

.slick-slider.hori-timeline-nav .slick-current {
  opacity: 1;
  background-color: rgba(36, 78, 162, 0.2); }
  .slick-slider.hori-timeline-nav .slick-current .nav-title {
    color: #244EA2; }

.slick-slider.hori-timeline-nav .slider-nav-item {
  text-align: center; }

.slick-slider.fade:not(slow) {
  opacity: 1; }

/************** vertical timeline **************/
.verti-timeline {
  border-left: 2px solid #f1f5f7;
  margin: 0 5px; }
  .verti-timeline .event-list {
    position: relative;
    padding: 0px 0px 25px 30px; }
    .verti-timeline .event-list:before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      left: -2px;
      top: 8px;
      border-top: 6px double #f1f5f7;
      border-left: 2px solid #f1f5f7;
      border-top-left-radius: 15px; }
    .verti-timeline .event-list .event-content {
      position: relative;
      border: 2px solid #e9ecef;
      border-radius: 7px; }
    .verti-timeline .event-list.active .event-timeline-dot {
      color: #244EA2; }
    .verti-timeline .event-list:last-child {
      padding-bottom: 0px; }

/*********************
    Faqs
**********************/
.gallery-box a .gallery-content {
  border-radius: 4px;
  overflow: hidden; }

.gallery-box a .gallery-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #244EA2;
  opacity: 0;
  transition: all 0.5s; }

.gallery-box a .overlay-content {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -60px;
  background-color: #fff;
  transition: all 0.5s;
  padding: 16px 12px 12px 12px;
  margin: 0px 12px;
  border-radius: 4px; }

.gallery-box a .gallery-overlay-icon {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-85%);
  transition: all 0.5s; }
  .gallery-box a .gallery-overlay-icon i {
    font-size: 28px; }

.gallery-box a:hover .gallery-overlay {
  opacity: 0.7; }

.gallery-box a:hover .overlay-content {
  position: absolute;
  bottom: 12px; }

/* BI_WS0025 - Linha Total da tabela */
.row-total-agendamento td {
  background-color: #f1f1f1 !important;
  color: #1f3566 !important;
  font-weight: 600 !important; }

.row-total-agendamento td:nth-child(1),
.row-total-agendamento td:nth-child(2) {
  background-color: #d9d9d9 !important;
  color: #1f3566 !important;
  font-weight: 700 !important; }

.error-text {
  text-shadow: 4px 4px rgba(36, 78, 162, 0.4); }

.terms-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff; }

.terms-header {
  background-color: #244EA2;
  min-height: 80px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  position: relative;
  color: #fff;
  overflow: visible; }

.terms-side {
  display: flex;
  align-items: center; }

.terms-side.left {
  justify-content: flex-start; }

.terms-side.right {
  justify-content: flex-end; }

.terms-back-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  padding: 6px 10px; }
  .terms-back-button i {
    font-size: 16px; }

.terms-logo {
  display: flex;
  justify-content: center; }

.terms-language {
  position: relative;
  display: flex;
  align-items: center; }
  .terms-language .lang-button {
    background-color: #244EA2;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    transition: background 0.2s ease;
    position: relative;
    box-shadow: none; }
  .terms-language .flag-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
    pointer-events: none;
    border: 2px solid white;
    transition: border-color 0.2s ease; }
    .terms-language .flag-icon.active-flag {
      border-color: white; }
  .terms-language .chevron-icon {
    width: 10px;
    height: 6px;
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    fill: white;
    margin-left: 4px; }
  .terms-language.dropdown-open .chevron-icon {
    transform: rotate(180deg); }
  .terms-language .lang-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #fff;
    border: 1px transparent;
    border-radius: 1px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;
    display: flex;
    flex-direction: column;
    width: 60px; }
    .terms-language .lang-dropdown .dropdown-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 0;
      height: 40px;
      cursor: pointer;
      transition: background-color 0.2s ease, transform 0.2s ease; }
      .terms-language .lang-dropdown .dropdown-item:hover {
        background-color: #bfe1fc;
        transform: scale(1.02); }
      .terms-language .lang-dropdown .dropdown-item.selected-language-item {
        background-color: #244EA2; }
        .terms-language .lang-dropdown .dropdown-item.selected-language-item:hover {
          background-color: #244EA2;
          transform: scale(1); }
      .terms-language .lang-dropdown .dropdown-item img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid white;
        transition: border-color 0.2s ease; }

.terms-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px;
  flex-grow: 1; }
  .terms-content ul,
  .terms-content ol {
    margin-bottom: 24px; }
  .terms-content li {
    margin-bottom: 8px; }
  .terms-content h1, .terms-content .h1 {
    font-size: 32px;
    line-height: 100%;
    color: #0F1D42;
    margin-bottom: 24px; }
  .terms-content h2, .terms-content .h2 {
    font-size: 24px;
    line-height: 100%;
    color: #0F1D42;
    margin-top: 40px;
    margin-bottom: 16px; }
  .terms-content h3, .terms-content .h3 {
    font-size: 20px;
    line-height: 100%;
    color: #0F1D42; }

.terms-footer {
  background-color: #F2F2F2;
  color: #555555;
  text-align: center;
  padding: 1rem;
  font-size: 12px;
  font-family: 'Poppins', sans-serif; }

.legal-links-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px; }
  .legal-links-container .legal-link-item {
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0%;
    color: #007bff;
    text-decoration: none; }
  .legal-links-container .legal-link-separator {
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0%;
    color: #007bff; }

.app-store-buttons {
  margin-top: 30px; }

.text-light-blue-01 {
  color: #007bff; }

.power-off-active, .power-off-inactive {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 6px; }

.power-off-active {
  background-color: #D1E7DD; }
  .power-off-active i {
    color: #198754 !important; }

.power-off-inactive {
  background-color: #F8D7DA; }
  .power-off-inactive i {
    color: #DC3545 !important; }

.btn-criar-rota {
  background-color: #fff;
  transition: all 0.2s ease; }
  .btn-criar-rota:hover {
    background-color: #263874;
    color: #FFFFFF !important;
    border-color: #263874; }

html {
  background-color: white !important; }

body * {
  outline: none;
  font-family: "Poppins", sans-serif; }

.ReactModalPortal > div {
  z-index: 1056 !important; }

.close {
  background: transparent;
  border: 0;
  font-size: 10px;
  padding: 1.35rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_32___}) center/1em auto no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2; }
  .close span {
    display: none; }

.modal-backdrop {
  width: 100%;
  height: 100%; }

.modal-content {
  border-radius: 1em; }

.modal-content p, .modal-content span, .modal-content strong {
  color: #353535; }

.btn-danger {
  background: #EC221F; }

button.mx-2.btn.btn-danger-dark {
  border: 1px solid #EC221F;
  background-color: #EC221F;
  font-family: "Poppins", sans-serif; }

button.mx-2.btn.btn-primary-dark {
  font-family: "Poppins", sans-serif;
  border: 1px solid #263874;
  background-color: #263874; }

button.waves-effect.mx-2.btn.btn-link.primary-dark {
  color: #263874;
  font-weight: 600; }

.hover-red:hover {
  color: #EC221F !important;
  text-decoration: none; }

.gray-700-text {
  color: #505d69 !important; }

.bg-yellow {
  background: #fece22 !important; }

.dados-pessoais {
  height: fit-content; }
  .dados-pessoais .card {
    box-shadow: none !important;
    padding: 8px; }

label {
  font-weight: 400; }

.shadow-card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  border-radius: 12px; }

.link-primary-01 {
  color: #498EF2; }

.notify-circle {
  background-color: #498EF2;
  color: white !important;
  border-radius: 50px;
  font-size: 0.75rem;
  width: 33px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin-left: 10px; }

@media print {
  .no-print {
    display: none !important; } }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_dripicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_backgrounds.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_calendaryFlatpickr.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_table.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/custom/components/_dragdrop.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_topbar-inside.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_vertical.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/structure/_general.scss","webpack://./src/assets/scss/custom/components/_waves.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_accordion.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_demos.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/components/_avatarUpload.scss","webpack://./src/assets/scss/custom/components/_tooltip.scss","webpack://./src/assets/scss/custom/components/_notificationModal.scss","webpack://./src/assets/scss/custom/components/_modals.scss","webpack://./src/assets/scss/custom/components/_calendar.scss","webpack://./src/assets/scss/custom/components/_houvers.scss","webpack://./src/assets/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/assets/scss/custom/plugins/_calendar.scss","webpack://./src/assets/scss/custom/plugins/_color-picker.scss","webpack://./src/assets/scss/custom/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/custom/plugins/_datatable.scss","webpack://./src/assets/scss/custom/plugins/_datepicker.scss","webpack://./src/assets/scss/custom/plugins/_flot.scss","webpack://./src/assets/scss/custom/plugins/_form-editors.scss","webpack://./src/assets/scss/custom/plugins/_form-upload.scss","webpack://./src/assets/scss/custom/plugins/_form-wizard.scss","webpack://./src/assets/scss/custom/plugins/_google-map.scss","webpack://./src/assets/scss/custom/plugins/_parsley.scss","webpack://./src/assets/scss/custom/plugins/_range-slider.scss","webpack://./src/assets/scss/custom/plugins/_rating.scss","webpack://./src/assets/scss/custom/plugins/_responsive-table.scss","webpack://./src/assets/scss/custom/plugins/_select2.scss","webpack://./src/assets/scss/custom/plugins/_session-timeout.scss","webpack://./src/assets/scss/custom/plugins/_sparkline-chart.scss","webpack://./src/assets/scss/custom/plugins/_sweatalert2.scss","webpack://./src/assets/scss/custom/plugins/_switch.scss","webpack://./src/assets/scss/custom/plugins/_table-editable.scss","webpack://./src/assets/scss/custom/plugins/_vector-maps.scss","webpack://./src/assets/scss/custom/plugins/_x-editable.scss","webpack://./src/assets/scss/custom/pages/_authentication.scss","webpack://./src/assets/scss/custom/pages/_search.scss","webpack://./src/assets/scss/custom/pages/_BI_AUT003.scss","webpack://./src/assets/scss/custom/pages/_email.scss","webpack://./src/assets/scss/custom/pages/_coming-soon.scss","webpack://./src/assets/scss/custom/pages/_timeline.scss","webpack://./src/assets/scss/custom/pages/_extras-pages.scss","webpack://./src/assets/scss/custom/pages/_LegalContentPage.scss","webpack://./src/assets/scss/custom/pages/_df-lo0020.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;CDOC;AEPD,4BAAA;AACA;EACE,oCAAoC;EACpC,4CAAsE;EACtE,qPAAuW;EACvW,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;;EAEE,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,YAAY,EAAA;;AAGd;EACE,+BAA+B,EAAA;;AAGjC;EACE;;;;;;;;;;;;;;;SFrzLO,EEo0LC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SFvzLO,EEs0LC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SFzzLO,EEw0LC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF3zLO,EE00LC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF7zLO,EE40LC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF/zLO,EE80LC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SFj0LO,EEg1LC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,sCAAsC,EAAA;;AAcxC;EACE;IAEE,uBAAuB,EAAA;EAEzB;IAEE,yBAAyB,EAAA,EAAA;;AAI7B,kDAAA;AC3hvBA;EACE,2BAA2B;EAC3B,4CAA6C;EAC7C,mPAGsE;EACtE,mBAAmB;EACnB,kBAAkB,EAAA;;AHgsjBpB;EG3rjBE,sCAAsC;EACtC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC,EAAA;;AH8rjBpC;;EGzrjBE,sCAAsC;EACtC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AC9nBlB;;;;;;;;;CJm0kBC;AIzzkBD;EACE,wBAAwB;EACxB,6CAA2D;EAAE,OAAA;EAC7D,iTAI8E;EAAE,aAAA;EAChF,kBAAkB,EAAA;;AJ0zkBpB;EItzkBE,mCAAmC;EACnC,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EAAS,mBAAmB;EAAE,mBAAmB;EAAE,wBAAwB,EAAA;;AAC3E;EAAS,gBAAgB;EAAE,qBAAqB;EAAE,uBAAuB,EAAA;;AACzE;EAAU,eAAe,EAAA;;AACzB;EAAS,gBAAgB,EAAA;;AACzB;EAAS,iBAAkB,EAAA;;AAC3B;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAU,eAAe,EAAA;;AACzB;EAAS,kBAAkB;EAAE,aAAa,EAAA;;AAE1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAiB,gBAAgB,EAAA;;AACjC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAsB,gBAAgB,EAAA;;AACtC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkB,gBAAgB,EAAA;;AAClC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0C,gBAAgB,EAAA;;AAC1D;EAA0C,gBAAgB,EAAA;;AAC1D;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAqB,gBAAgB,EAAA;;AACrC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAoB,gBAAgB,EAAA;;AACpC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAoB,gBAAgB,EAAA;;AACpC;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAkB,gBAAgB,EAAA;;AAClC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAmB,gBAAgB,EAAA;;AACnC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA0C,gBAAgB,EAAA;;AAC1D;EAA0C,gBAAgB,EAAA;;AAC1D;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAuB,gBAAgB,EAAA;;AACvC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmB,gBAAgB,EAAA;;AACnC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAkB,gBAAgB,EAAA;;AAClC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;ACjpE3C;;;;;;CL4rxBC;AM3rxBC;;;;INgsxBE;AOjsxBJ;;EASI,kBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,iBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,kBAAwB;EAAxB,gBAAwB;EAAxB,kBAAwB;EAAxB,uBAAwB;EAIxB,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAIlC,qBAAwB;EAAxB,0BAAwB;EAAxB,4BAAwB;EAAxB,uBAAwB;EAAxB,qBAAwB;EAAxB,kBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,+BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,+BAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,yBAAwB;EAAxB,0BAAwB;EAAxB,0BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,2BAAwB;EAAxB,0BAAwB;EAAxB,0BAAwB;EAAxB,4BAAwB;EAAxB,0BAAwB;EAAxB,0BAAwB;EAAxB,0BAAwB;EAAxB,4BAAwB;EAAxB,6BAAwB;EAAxB,6BAAwB;EAAxB,+BAAwB;EAAxB,0BAAwB;EAAxB,0BAAwB;EAAxB,4BAAwB;EAAxB,4BAAwB;EAAxB,4BAAwB;EAAxB,8BAAwB;EAAxB,4BAAwB;EAIxB,6BAAgC;EAAhC,kCAAgC;EAAhC,sCAAgC;EAAhC,iCAAgC;EAAhC,6BAAgC;EAAhC,4BAAgC;EAAhC,8BAAgC;EAAhC,4BAAgC;EAAhC,2BAAgC;EAAhC,6BAAgC;EAAhC,yBAAgC;EAAhC,sCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,mCAAgC;EAAhC,oCAAgC;EAAhC,oCAAgC;EAAhC,oCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,gCAAgC;EAAhC,iCAAgC;EAAhC,uCAAgC;EAAhC,iCAAgC;EAAhC,kCAAgC;EAAhC,mCAAgC;EAAhC,gCAAgC;EAAhC,iCAAgC;EAAhC,kCAAgC;EAAhC,mCAAgC;EAAhC,oCAAgC;EAAhC,oCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,oCAAgC;EAAhC,oCAAgC;EAAhC,sCAAgC;EAAhC,oCAAgC;EAAhC,oCAAgC;EAAhC,iCAAgC;EAAhC,oCAAgC;EAAhC,qCAAgC;EAAhC,mCAAgC;EAAhC,qCAAgC;EAAhC,kCAAgC;EAAhC,iCAAgC;EAAhC,kCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,qCAAgC;EAAhC,oCAAgC;EAIhC,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAIpD,+BAA4C;EAA5C,iCAA4C;EAA5C,+BAA4C;EAA5C,4BAA4C;EAA5C,+BAA4C;EAA5C,8BAA4C;EAA5C,6BAA4C;EAA5C,4BAA4C;EAI5C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAGtD,6BAAiC;EACjC,uBAAiC;EAMjC,2CAA6C;EAC7C,yGAA2C;EAC3C,yFAA+B;EAO/B,gDAA+C;EC2O3C,6BAnE+B;EDtKnC,0BAA+C;EAC/C,0BAA+C;EAK/C,wBAAmC;EACnC,gCAA2C;EAC3C,qBAA6B;EAC7B,+BAAqC;EAErC,yBAA2C;EAC3C,gCAAmD;EAEnD,4CAA6C;EAC7C,oCAAqD;EACrD,0BAAuC;EACvC,oCAA+C;EAE/C,0CAA2C;EAC3C,mCAAmD;EACnD,yBAAqC;EACrC,mCAA6C;EAG7C,2BAAyC;EAEzC,wBAAmC;EACnC,gCAA2C;EAC3C,0BAA6C;EAE7C,8BAA+C;EAC/C,uDAAuD;EAGrD,qCAAyD;EAG3D,wBAAmC;EACnC,6BAA6C;EAC7C,0BAAuC;EAGvC,sBAAuC;EACvC,wBAAuC;EACvC,0BAAuC;EACvC,mDAA+D;EAE/D,2BAAyC;EACzC,6BAA+C;EAC/C,6BAA+C;EAC/C,2BAA+C;EAC/C,4BAAiD;EACjD,mDAAiD;EACjD,8BAAmD;EAGnD,iDAAmC;EACnC,iDAAyC;EACzC,iDAAyC;EACzC,2DAA+C;EAI/C,8BAA+C;EAC/C,6BAAmD;EACnD,+CAA+C;EAI/C,8BAA+C;EAC/C,qCAA6D;EAC7D,gCAAmD;EACnD,uCAAiE,EAAA;;AP6xxBnE;EOvxxBI,kBAAkB;EAGlB,wBAAmC;EACnC,kCAA2C;EAC3C,qBAA6B;EAC7B,4BAAqC;EAErC,yBAA2C;EAC3C,sCAAmD;EAEnD,+CAA6C;EAC7C,uCAAqD;EACrD,0BAAuC;EACvC,iCAA+C;EAE/C,6CAA2C;EAC3C,sCAAmD;EACnD,yBAAqC;EACrC,gCAA6C;EAG3C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAIpD,+BAA4C;EAA5C,iCAA4C;EAA5C,+BAA4C;EAA5C,4BAA4C;EAA5C,+BAA4C;EAA5C,8BAA4C;EAA5C,6BAA4C;EAA5C,4BAA4C;EAI5C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAGtD,2BAAyC;EAEzC,wBAAmC;EACnC,8BAA+C;EAC/C,kCAA2C;EAC3C,wCAAuD;EAEvD,wBAAmC;EACnC,6BAA6C;EAC7C,0BAAuC;EAEvC,0BAAuC;EACvC,wDAA+D;EAE/D,8BAA+C;EAC/C,qCAA6D;EAC7D,gCAAmD;EACnD,uCAAiE,EAAA;;AExKrE;;;EAGE,sBAAsB,EAAA;;AAepB;EANJ;IAOM,uBAAuB,EAAA,EAG5B;;AAWD;EACE,SAAS;EACT,uCAAgE;ED6O5D,mCAnE+B;ECxKnC,uCAAgE;EAChE,uCAAgE;EAChE,2BAA8C;EAC9C,qCAA6D;EAC7D,mCAAmD;EACnD,8BAA8B;EAC9B,6CCwHa,EAAA;;AD/Gf;EACE,cAAsB;EACtB,yBC6Ga;ED5Gb,SAAS;EACT,wCAAkC;EAClC,YCyyB8B,EAAA;;AD/xBhC;EACE,aAAa;EACb,qBCmvBuC;EDhvBvC,gBCmvB+B;EDlvB/B,gBCmvB+B;EDlvB/B,8BAAoD,EAAA;;AAGtD;EDuMQ,qCAf6B,EAAA;EA7IjC;IC3CJ;MD8MQ,oBA9E6B,EAAA,EC7HpC;;AAED;EDkMQ,+BAf6B,EAAA;EA7IjC;ICtCJ;MDyMQ,kBA9E6B,EAAA,ECxHpC;;AAED;ED6LQ,sCAf6B,EAAA;EA7IjC;ICjCJ;MDoMQ,qBA9E6B,EAAA,ECnHpC;;AAED;EDwLQ,qCAf6B,EAAA;EA7IjC;IC5BJ;MD+LQ,oBA9E6B,EAAA,EC9GpC;;AAED;ED+KM,qBAnE+B,EAAA;;ACvGrC;ED0KM,mBAnE+B,EAAA;;AC5FrC;EACE,aAAa;EACb,mBCyhB8B,EAAA;;AD/gBhC;EACE,iCAAiC;EACjC,YAAY;EACZ,8BAA8B,EAAA;;AAMhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAMtB;;EAEE,kBAAkB,EAAA;;AAGpB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBCynB+B,EAAA;;ADpnBjC;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAMhB;EACE,gBAAgB,EAAA;;AAQlB;;EAEE,mBCkmBkC,EAAA;;AD1lBpC;ED6EM,cAnE+B,EAAA;;ACHrC;EACE,cC6pBgC;ED5pBhC,gCAAwD;EACxD,wCAA6D,EAAA;;AAS/D;;EAEE,kBAAkB;EDwDd,iBAnE+B;ECanC,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAKhB;EACE,gEAA4G;EAC5G,qBC0Z4C,EAAA;ED5Z9C;IAKI,mDAA2C;IAC3C,0BCyZ+C,EAAA;;ADhZnD;EAGI,cAAc;EACd,qBAAqB,EAAA;;AAOzB;;;;EAIE,qCEgV2E;EHlUvE,cAnE+B,EAAA;;AC6DrC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EDEV,gBAnE+B;ECmEnC,cC9GgB,EAAA;EDwGlB;IDMM,kBAnE+B;ICwEjC,cAAc;IACd,kBAAkB,EAAA;;AAItB;EDVM,gBAnE+B;EC+EnC,2BAA8C;EAC9C,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAIlB;EACE,sBC2gDuC;EFjiDnC,gBAnE+B;EC2FnC,WC/Ia;EDgJb,yBCvIgB;EE9Jd,qBFqtB+B,EAAA;EDpbnC;IAQI,UAAU;ID7BR,cAnE+B;ICkGjC,gBC6e6B,EAAA;;ADpejC;EACE,gBAAgB,EAAA;;AAMlB;;EAEE,sBAAsB,EAAA;;AAQxB;EACE,oBAAoB;EACpB,yBAAyB,EAAA;;AAG3B;EACE,oBC0iBkC;EDziBlC,uBCyiBkC;EDxiBlC,cClLgB;EDmLhB,gBAAgB,EAAA;;AAOlB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAGlC;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAA;;AAQjB;EACE,qBAAqB,EAAA;;AAMvB;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAKZ;;;;;EAKE,SAAS;EACT,oBAAoB;ED5HhB,kBAnE+B;ECiMnC,oBAAoB,EAAA;;AAItB;;EAEE,oBAAoB,EAAA;;ATwxxBtB;ESlxxBE,eAAe,EAAA;;AAGjB;EAGE,iBAAiB,EAAA;EAHnB;IAOI,UAAU,EAAA;;ATgxxBd;ESxwxBE,wBAAwB,EAAA;;AAQ1B;;;;EAIE,0BAA0B,EAAA;EAJ5B;;;;IAQM,eAAe,EAAA;;AAOrB;EACE,UAAU;EACV,kBAAkB,EAAA;;AAKpB;EACE,gBAAgB,EAAA;;AAUlB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAQX;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,qBC+XiC;ED7XjC,oBAAoB;EDnNd,iCAf6B,EAAA;EA7IjC;ICyWJ;MDtMQ,iBA9E6B,EAAA,ECgSpC;EAZD;IAUI,WAAW,EAAA;;AAOf;;;;;;;EAOE,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AT2uxBd;ESjuxBE,6BAA6B;EAC7B,oBAAoB,EAAA;ETmuxBpB;IS/txBE,eAAe;IACf,oBAAoB,EAAA;;AASxB;;;;;;;CTguxBC;ASrtxBD;EACE,wBAAwB,EAAA;;AAK1B;EACE,UAAU,EAAA;;AAOZ;EACE,aAAa;EACb,0BAA0B,EAAA;;AAK5B;EACE,qBAAqB,EAAA;;AAKvB;EACE,SAAS,EAAA;;AAOX;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAQjB;EACE,wBAAwB,EAAA;;AT+rxB1B;EStrxBE,wBAAwB,EAAA;;AI3kB1B;ELmQM,qBAnE+B;EK9LnC,gBHi0B+B,EAAA;;AG5zB/B;EAGE,gBHmzBqB;EGlzBrB,gBHoyB6B;EFxiBzB,iCAf6B,EAAA;EA7IjC;IKpGF;MLuQM,eA9E6B,EAAA,EKnLlC;;AAND;EAGE,gBHmzBqB;EGlzBrB,gBHoyB6B;EFxiBzB,iCAf6B,EAAA;EA7IjC;IKpGF;MLuQM,iBA9E6B,EAAA,EKnLlC;;AAND;EAGE,gBHmzBqB;EGlzBrB,gBHoyB6B;EFxiBzB,iCAf6B,EAAA;EA7IjC;IKpGF;MLuQM,iBA9E6B,EAAA,EKnLlC;;AAND;EAGE,gBHmzBqB;EGlzBrB,gBHoyB6B;EFxiBzB,iCAf6B,EAAA;EA7IjC;IKpGF;MLuQM,iBA9E6B,EAAA,EKnLlC;;AAND;EAGE,gBHmzBqB;EGlzBrB,gBHoyB6B;EFxiBzB,iCAf6B,EAAA;EA7IjC;IKpGF;MLuQM,eA9E6B,EAAA,EKnLlC;;AAND;EAGE,gBHmzBqB;EGlzBrB,gBHoyB6B;EFxiBzB,iCAf6B,EAAA;EA7IjC;IKpGF;MLuQM,iBA9E6B,EAAA,EKnLlC;;AAkBH;ECvDE,eAAe;EACf,gBAAgB,EAAA;;AD2DlB;EC5DE,eAAe;EACf,gBAAgB,EAAA;;AD8DlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBHszB+B,EAAA;;AG5yBnC;EL8MM,cAnE+B;EKzInC,yBAAyB,EAAA;;AAI3B;EACE,mBH+eW;EFxSP,qBAnE+B,EAAA;EKrIrC;IAKI,gBAAgB,EAAA;;AAIpB;EACE,iBHseW;EGreX,mBHqeW;EFxSP,cAnE+B;EKxHnC,cH0EgB,EAAA;EG9ElB;IAOI,qBAAqB,EAAA;;AEhGzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBL+qDwC;EK9qDxC,yBLslBiC;EKrlBjC,yBL2JgB;EExJd,sBFmtBgC;EM3tBlC,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;EPyPM,cAnE+B;EOpLnC,cLsIgB,EAAA;;AOxKhB;;;;;;;ECHA,mBAA+B;EAC/B,gBAA+B;EAC/B,WAAW;EACX,4CAA6D;EAC7D,2CAA4D;EAC5D,kBAAkB;EAClB,iBAAiB,EAAA;;ACsDf;EF5CE;IACE,gBPqqBG,EAAA,EOpqBJ;;AE0CH;EF5CE;IACE,gBPsqBG,EAAA,EOrqBJ;;AE0CH;EF5CE;IACE,gBPuqBG,EAAA,EOtqBJ;;AE0CH;EF5CE;IACE,iBPwqBI,EAAA,EOvqBL;;AE0CH;EF5CE;IACE,iBPyqBK,EAAA,EOxqBN;;ARMP;EWrBI,qBAA6C;EAA7C,yBAA6C;EAA7C,yBAA6C;EAA7C,yBAA6C;EAA7C,0BAA6C;EAA7C,2BAA6C,EAAA;;AAK/C;ECNA,mBAA+B;EAC/B,gBAA+B;EAC/B,aAAa;EACb,eAAe;EAEf,yCAA0D;EAC1D,4CAA6D;EAC7D,2CAA4D,EAAA;EDD5D;ICUA,cAAc;IACd,WAAW;IACX,eAAe;IACf,4CAA6D;IAC7D,2CAA4D;IAC5D,8BAA+C,EAAA;;AA+C3C;EACE,SAAW,EAAA;;AAGb;EApCJ,cAAc;EACd,WAAW,EAAA;;AAcX;EACE,cAAc;EACd,WAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,UAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,gBAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,UAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,UAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,gBAAoC,EAAA;;AA+BlC;EAhDJ,cAAc;EACd,WAAW,EAAA;;AAqDH;EAhEN,cAAc;EACd,eAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,WAA0C,EAAA;;AAuElC;EAxDV,qBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAmExC;;EAEE,gBAA+B,EAAA;;AAGjC;;EAEE,gBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AF1DrC;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;ACtHT;EAEE,8BAA+C;EAC/C,2BAAyC;EACzC,+BAAiD;EACjD,4BAA2C;EAE3C,yBAAqC;EACrC,gCAA+B;EAC/B,gCAAmD;EACnD,iCAA6C;EAC7C,iCAAqD;EACrD,8BAA+C;EAC/C,gCAAmD;EACnD,6BAA6C;EAC7C,+BAAiD;EACjD,4BAA2C;EAE3C,WAAW;EACX,mBZgjBW;EY/iBX,mBZq3B+B;EYp3B/B,0CAAqE,EAAA;EArBvE;IA6BI,wBZw2BgC;IYt2BhC,qFAA4J;IAC5J,oCAAqD;IACrD,wBZmrB6B;IYlrB7B,2GAAgL,EAAA;EAlCpL;IAsCI,uBAAuB,EAAA;EAtC3B;IA0CI,sBAAsB,EAAA;;AAI1B;EACE,uCZuHgB,EAAA;;AYhHlB;EACE,iBAAiB,EAAA;;AAQnB;EAGI,sBZq0B+B,EAAA;;AYvzBnC;EAEI,mBAAmC,EAAA;EAFvC;IAMM,mBZ8nB2B,EAAA;;AYznBjC;EAGI,sBAAsB,EAAA;;AAH1B;EAOI,mBAAmB,EAAA;;AASvB;EAEI,oDAA+C;EAC/C,8CAAyC,EAAA;;AAK7C;EAEI,oDAA+C;EAC/C,8CAAyC,EAAA;;AAQ7C;EACE,oDAAiD;EACjD,8CAA2C,EAAA;;AAO7C;EAEI,mDAAiD;EACjD,6CAA2C,EAAA;;AC5I7C;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;ADiJrE;EACE,gBAAgB;EAChB,iCAAiC,EAAA;;AH3FnC;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AEpKL;EACE,qBdihC2C,EAAA;;AcxgC7C;EACE,gCC2N8D;ED1N9D,mCC0N8D;EDzN9D,gBAAgB;EhB8QZ,kBAnE+B;EgBvMnC,gBd0xB+B,EAAA;;ActxBjC;EACE,+BCgN8D;ED/M9D,kCC+M8D;EjBqD1D,mBAnE+B,EAAA;;AgB7LrC;EACE,gCC0M8D;EDzM9D,mCCyM8D;EjBqD1D,kBAnE+B,EAAA;;AkBxNrC;EACE,mBhBygC4C;EF/uBxC,cAnE+B;EkBnNnC,chBqKgB,EAAA;;AiB1KlB;EACE,cAAc;EACd,WAAW;EACX,wBjB27BkC;EFnqB9B,mBAnE+B;EmBlNnC,gBjB+xB+B;EiB9xB/B,gBjBoyB+B;EiBnyB/B,cjBmKgB;EiBlKhB,gBAAgB;EAChB,sBjB0Ja;EiBzJb,4BAA4B;EAC5B,yBjB4JgB;EEzJd,sBFmtBgC;EkBttB9B,wElB6jC4F,EAAA;EkBzjC5F;IDhBN;MCiBQ,gBAAgB,EAAA,ED2FvB;EA5GD;IAqBI,gBAAgB,EAAA;IArBpB;MAwBM,eAAe,EAAA;EAxBrB;IA8BI,cjB6Ic;IiB5Id,sBjBqIW;IiBpIX,qBjBuhCoE;IiBthCpE,UAAU;IAKR,gBjBohCsC,EAAA;EiB1jC5C;IAgDI,eAAe;IAMf,aAAmE;IAKnE,SAAS,EAAA;EA3Db;IAiEI,cAAc;IACd,UAAU,EAAA;EAlEd;IAuEI,cjBmGc;IiBjGd,UAAU,EAAA;EAzEd;IAmFI,yBjBmFc;IiBhFd,UAAU,EAAA;EAtFd;IA2FI,wBjBm2BgC;IiBl2BhC,yBjBk2BgC;IiBj2BhC,0BjBi2BgC;IiBh2BhC,cjB6Ec;ImB3KhB,yBnBsKgB;IiBtEd,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,4BjBgnB6B;IiB/mB7B,gBAAgB;ICzFd,qIlB++B6I,EAAA;IkB3+B7I;MDhBN;QCiBQ,gBAAgB,EAAA,EDsFrB;EAvGH;IA0GI,yBFqGiC,EAAA;;AE5FrC;EACE,cAAc;EACd,WAAW;EACX,kBAA2B;EAC3B,gBAAgB;EAChB,gBjBmrB+B;EiBlrB/B,cjBkDgB;EiBjDhB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC,EAAA;EATrC;IAYI,UAAU,EAAA;EAZd;IAiBI,gBAAgB;IAChB,eAAe,EAAA;;AAWnB;EACE,sCFqF8D;EEpF9D,uBjBwzBiC;EF/qB7B,kBAnE+B;EIzMjC,qBFqtB+B,EAAA;EiBplBnC;IAOI,uBjBmzB+B;IiBlzB/B,wBjBkzB+B;IiBjzB/B,yBjBizB+B,EAAA;;AiB7yBnC;EACE,oCFwE8D;EEvE9D,oBjB+yBgC;EFnrB5B,mBAnE+B;EIzMjC,qBFotB+B,EAAA;EiBtkBnC;IAOI,oBjB0yB8B;IiBzyB9B,qBjByyB8B;IiBxyB9B,uBjBwyB8B,EAAA;;AiBjyBlC;EAEI,gBjBs5BwC,EAAA;;AiBx5B5C;EAMI,sCFmD4D,EAAA;;AEzDhE;EAUI,oCF+C4D,EAAA;;AE1ChE;EACE,WjB64B0C;EiB54B1C,YjBu4B0C;EiBt4B1C,gBjB8vBkC,EAAA;EiBjwBpC;IAMI,eAAe,EAAA;EANnB;IAUI,oBAAoB;IfvLpB,sBFmtBgC,EAAA;EiBtiBpC;IAeI,oBAAoB;If5LpB,sBFmtBgC,EAAA;EiBtiBpC;IAmBsB,kCFuB0C,EAAA;EE1ChE;IAoBsB,gCFsB0C,EAAA;;AKrOhE;EACE,iEAAmD;EAEnD,cAAc;EACd,WAAW;EACX,wCpBw7BkC;EFnqB9B,mBAnE+B;EsB/MnC,gBpB4xB+B;EoB3xB/B,gBpBiyB+B;EoBhyB/B,cpBgKgB;EoB/JhB,gBAAgB;EAChB,sBpBuJa;EoBtJb,mFAA0I;EAC1I,4BAA4B;EAC5B,yCpBsoCqE;EoBroCrE,0BpBsoC2C;EoBroC3C,yBpBsJgB;EEzJd,sBFmtBgC;EkBttB9B,wElB6jC4F,EAAA;EkBzjC5F;IEfN;MFgBQ,gBAAgB,EAAA,EEkCvB;EAlDD;IAuBI,qBpB+hCoE;IoB9hCpE,UAAU;IAKR,iDpB5BgB,EAAA;EoBDtB;IAmCI,sBpB05BgC;IoBz5BhC,sBAAsB,EAAA;EApC1B;IAwCI,cpBiIc;IoBhId,yBpB4Hc,EAAA;EoBrKlB;IA+CI,kBAAkB;IAClB,0BpB0Hc,EAAA;;AoBtHlB;EACE,oBpBm5BkC;EoBl5BlC,uBpBk5BkC;EoBj5BlC,oBpBk5BiC;EF/qB7B,kBAnE+B;EIzMjC,qBFqtB+B,EAAA;;AoBvqBnC;EACE,mBpB+4BiC;EoB94BjC,sBpB84BiC;EoB74BjC,kBpB84BgC;EFnrB5B,mBAnE+B;EIzMjC,qBFotB+B,EAAA;;AVw3zBnC;E8Bnh1BM,iEAAmD,EAAA;;ACxEzD;EACE,cAAc;EACd,qBrB6kC2E;EqB5kC3E,mBrB6kCsE;EqB5kCtE,uBrB6kC+C,EAAA;EqBjlCjD;IAOI,WAAW;IACX,mBAA2C,EAAA;;AAI/C;EACE,oBrBmkCsE;EqBlkCtE,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,YAAY;IACZ,oBAA4C;IAC5C,cAAc,EAAA;;AAIlB;EACE,qCAAyC;EAEzC,cAAc;EACd,UrBkjC2C;EqBjjC3C,WrBijC2C;EqBhjC3C,kBAA8D;EAC9D,mBAAmB;EACnB,gBAAgB;EAChB,yCAA+D;EAC/D,+CAA2E;EAC3E,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,qCrBmjCoE;EqBljCpE,yBAAyB;EH3BrB,mJlBwkCuK,EAAA;EkBpkCvK;IGQN;MHPQ,gBAAgB,EAAA,EG2FvB;EApFD;InBTI,qBF2kC2C,EAAA;EqBlkC/C;IAwBI,kBrB2iCyC,EAAA;EqBnkC7C;IA4BI,uBrBkiCqD,EAAA;EqB9jCzD;IAgCI,qBrB+/BoE;IqB9/BpE,UAAU;IACV,iDrBxDkB,EAAA;EqBsBtB;IAsCI,yBrB5DkB;IqB6DlB,qBrB7DkB,EAAA;IqBsBtB;MA6CQ,kEAAqD,EAAA;IA7C7D;MAqDQ,kEAAqD,EAAA;EArD7D;IA2DI,yBrBjFkB;IqBkFlB,qBrBlFkB;IqBuFhB,kEAAqD,EAAA;EAjE3D;IAsEI,oBAAoB;IACpB,YAAY;IACZ,YrB0gCyC,EAAA;EqBllC7C;IAgFM,eAAe;IACf,YrBigCuC,EAAA;;AqBn/B7C;EACE,mBrB2/ByD,EAAA;EqB5/B3D;IAII,6DAA2C;IAE3C,UrBq/BiC;IqBp/BjC,mBAA4C;IAC5C,0CAAiE;IACjE,gCAAgC;InBjHhC,kBFmmCiC;IkBtmC/B,iDlB0mCgE,EAAA;IkBtmChE;MGuGN;QHtGQ,gBAAgB,EAAA,EGgIrB;IA1BH;MAcM,6DAA2C,EAAA;IAdjD;MAkBM,iCrBo/BwC;MqB/+BtC,6DAA2C,EAAA;EAvBnD;IA6BI,oBrB+9BuD;IqB99BvD,eAAe,EAAA;IA9BnB;MAiCM,oBAA6C;MAC7C,cAAc,EAAA;;AAKpB;EACE,qBAAqB;EACrB,kBrB88BoC,EAAA;;AqB38BtC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB,EAAA;EAHtB;IAQM,oBAAoB;IACpB,YAAY;IACZ,arBk0B2B,EAAA;;AVutzBjC;E+Bjh1BM,6DAA2C,EAAA;;ACnLjD;EACE,WAAW;EACX,cP+N2B;EO9N3B,UAAU;EACV,gBAAgB;EAChB,6BAA6B,EAAA;EAL/B;IAQI,UAAU,EAAA;IARd;MAY8B,mCtB4iCc,EAAA;IsBxjC5C;MAa8B,mCtB2iCc,EAAA;EsBxjC5C;IAiBI,SAAS,EAAA;EAjBb;IAqBI,WtBqqC2C;IsBpqC3C,YtBoqC2C;IsBnqC3C,oBAAsE;IACtE,gBAAgB;IH1BlB,yBnBEoB;IsB0BlB,StBmqCwC;IEhrCxC,mBFirC2C;IkBprCzC,oHlB0rCkI;IkB1rClI,4GlB0rCkI,EAAA;IkBtrClI;MIdN;QJeQ,wBAAgB;QAAhB,gBAAgB,EAAA,EImBrB;IAlCH;MHFE,yBJ0MmC,EAAA;EOxMrC;IAqCI,WtB8oCkC;IsB7oClC,ctB8oCmC;IsB7oCnC,kBAAkB;IAClB,etB6oCqC;IsB5oCrC,yBtB4Hc;IsB3Hd,yBAAyB;IpB7BzB,mBF0qCkC,EAAA;EsBvrCtC;IAgDI,WtB0oC2C;IsBzoC3C,YtByoC2C;IsBxoC3C,gBAAgB;IHpDlB,yBnBEoB;IsBoDlB,StByoCwC;IEhrCxC,mBFirC2C;IkBprCzC,iHlB0rCkI;IkB1rClI,4GlB0rCkI,EAAA;IkBtrClI;MIdN;QJeQ,qBAAgB;QAAhB,gBAAgB,EAAA,EI6CrB;IA5DH;MHFE,yBJ0MmC,EAAA;EOxMrC;IA+DI,WtBonCkC;IsBnnClC,ctBonCmC;IsBnnCnC,kBAAkB;IAClB,etBmnCqC;IsBlnCrC,yBtBkGc;IsBjGd,yBAAyB;IpBvDzB,mBF0qCkC,EAAA;EsBvrCtC;IA0EI,oBAAoB,EAAA;IA1ExB;MA6EM,yBtB0FY,EAAA;IsBvKlB;MAiFM,yBtBsFY,EAAA;;AuB7KlB;EACE,kBAAkB,EAAA;EADpB;;;IAMI,0BRoO4D;IQnO5D,8BRmO4D;IQlO5D,iBvB6sCkC,EAAA;EuBrtCtC;IAYI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,eAAe;IACf,YAAY;IACZ,qBvBg7BgC;IuB/6BhC,gBAAgB;IAChB,2CAA6F;IAC7F,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6C;IAC7C,qBAAqB;ILVnB,gElB4sC8E,EAAA;IkBxsC9E;MKpBN;QLqBQ,gBAAgB,EAAA,EKOrB;EA5BH;;IAgCI,qBvBk6BgC,EAAA;IuBl8BpC;;MAmCM,kBAAkB,EAAA;IAnCxB;;;MAwCM,qBvBgrCoC;MuB/qCpC,wBvBgrCmC,EAAA;IuBztCzC;;MA6CM,qBvB2qCoC;MuB1qCpC,wBvB2qCmC,EAAA;EuBztCzC;IAmDI,qBvBqqCsC;IuBpqCtC,wBvBqqCqC;IuBpqCrC,qBvB64BgC,EAAA;EuBl8BpC;;;;IA6DM,8DvB8pC4E,EAAA;EuB3tClF;IAmEM,8DvBwpC4E,EAAA;EuB3tClF;;IAyEM,kBAAkB;IAClB,oBAA+D;IAC/D,WAAW;IACX,atBw+BuC;IsBv+BvC,WAAW;IACX,sBvB0FS;IErJX,sBFmtBgC,EAAA;EuBtuBpC;IAmFI,yBvBuFc,EAAA;EuB1KlB;IAwFM,mBAAmC,EAAA;EAxFzC;;IA8FI,ctBhFc,EAAA;;AuBVlB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY,EAAA;EAbhB;;;IAoBI,UAAU,EAAA;EApBd;IA2BI,kBAAkB;IAClB,UAAU,EAAA;IA5Bd;MA+BM,UAAU,EAAA;;AAWhB;EACE,aAAa;EACb,mBAAmB;EACnB,wBxBi5BkC;EFnqB9B,mBAnE+B;E0BzKnC,gBxBsvB+B;EwBrvB/B,gBxB2vB+B;EwB1vB/B,cxB0HgB;EwBzHhB,kBAAkB;EAClB,mBAAmB;EACnB,yBxBkHgB;EwBjHhB,yBxBmHgB;EEzJd,sBFmtBgC,EAAA;;AwBnqBpC;;;;EAIE,oBxB24BgC;EFnrB5B,mBAnE+B;EIzMjC,qBFotB+B,EAAA;;AwB3pBnC;;;;EAIE,uBxB83BiC;EF/qB7B,kBAnE+B;EIzMjC,qBFqtB+B,EAAA;;AwBnpBnC;;EAEE,qBAAsE,EAAA;;AAWxE;;;;EtB/DI,0BsBqE8B;EtBpE9B,6BsBoE8B,EAAA;;AANlC;;;;EtB/DI,0BsB8E8B;EtB7E9B,6BsB6E8B,EAAA;;AAflC;EAyBI,2BAA8C;EtB1E9C,yBsB2E8B;EtB1E9B,4BsB0E8B,EAAA;;AA1BlC;;EtBjDI,yBsBgF8B;EtB/E9B,4BsB+E8B,EAAA;;AAP4B;EC/F1D,aAAa;EACb,WAAW;EACX,mBzBi/B0C;EF/uBxC,cAnE+B;E2B5LjC,czB4Ka,EAAA;;AwBlFyB;ECtFtC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBzBq9CqC;EyBp9CrC,iBAAiB;E3BqPf,kBAnE+B;E2BhLjC,gBzBmwB6B;EyBlwB7B,WzB2HW;EyB1HX,wCzB8Ja;EEzLb,sBFmtBgC,EAAA;;AyBhuBhC;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,qBzBiJW;EyB9IT,oCV4KwD;EU3KxD,0DVwE0E;EUvE1E,4BAA4B;EAC5B,0DAA6D;EAC7D,8DVwKwD,EAAA;EUpO5D;IAgEI,qBzBsIS;IyBjIP,iDzBiIO,EAAA;;AyBtMb;EA+EI,oCVqJwD;EUpJxD,gFVoJwD,EAAA;;AUpO5D;EAuFE,qBzB+GW,EAAA;EyBtMb;IA4FM,kEAAqD;IACrD,sCVuIsD;IUtItD,8DzB4jCoG;IyB3jCpG,yEVqIsD,EAAA;EUpO5D;IAoGI,qBzBkGS;IyB7FP,iDzB6FO,EAAA;;AyBtMb;EAkHI,yCVkHwD,EAAA;;AUpO5D;EAyHE,qBzB6EW,EAAA;EyBtMb;IA4HI,yBzB0ES,EAAA;EyBtMb;IAgII,iDzBsES,EAAA;EyBtMb;IAoII,czBkES,EAAA;;AyB9Df;EAEI,iBAAiB,EAAA;;AA1InB;;;;;EAoJM,UAAU,EAAA;;ADhCqF;EC/FrG,aAAa;EACb,WAAW;EACX,mBzBi/B0C;EF/uBxC,cAnE+B;E2B5LjC,czByKa,EAAA;;AwB/EkE;ECtF/E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBzBq9CqC;EyBp9CrC,iBAAiB;E3BqPf,kBAnE+B;E2BhLjC,gBzBmwB6B;EyBlwB7B,WzB2HW;EyB1HX,wCzB2Ja;EEtLb,sBFmtBgC,EAAA;;AyBhuBhC;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,qBzB8IW;EyB3IT,oCV4KwD;EU3KxD,0DVwE0E;EUvE1E,4BAA4B;EAC5B,0DAA6D;EAC7D,8DVwKwD,EAAA;EUpO5D;IAgEI,qBzBmIS;IyB9HP,iDzB8HO,EAAA;;AyBnMb;EA+EI,oCVqJwD;EUpJxD,gFVoJwD,EAAA;;AUpO5D;EAuFE,qBzB4GW,EAAA;EyBnMb;IA4FM,kEAAqD;IACrD,sCVuIsD;IUtItD,8DzB4jCoG;IyB3jCpG,yEVqIsD,EAAA;EUpO5D;IAoGI,qBzB+FS;IyB1FP,iDzB0FO,EAAA;;AyBnMb;EAkHI,yCVkHwD,EAAA;;AUpO5D;EAyHE,qBzB0EW,EAAA;EyBnMb;IA4HI,yBzBuES,EAAA;EyBnMb;IAgII,iDzBmES,EAAA;EyBnMb;IAoII,czB+DS,EAAA;;AyB3Df;EAEI,iBAAiB,EAAA;;AA1InB;;;;;EAsJM,UAAU,EAAA;;ACxJpB;EAEE,2BAAyC;EACzC,2BAAyC;EACzC,sBAA6C;E5BuRzC,4BAnE+B;E4BlNnC,yBAA6C;EAC7C,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,0BAA+C;EAC/C,kCAA+C;EAC/C,+BAAiD;EACjD,wCAA2D;EAC3D,4FAA2C;EAC3C,+BAAuD;EACvD,iFAAuD;EAGvD,qBAAqB;EACrB,wDAAoG;EACpG,sCAA8D;E5BsQ1D,kCAnE+B;E4BjMnC,sCAA8D;EAC9D,sCAA8D;EAC9D,0BAA4C;EAC5C,kBAAkB;EAGlB,sBAAsB;EACtB,eAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;EACjB,mEAAqH;ExBjBnH,0CwBkB0E;EPjC5E,kCOkCoD;ERtBhD,qIlB++B6I,EAAA;EkB3+B7I;IQhBN;MRiBQ,gBAAgB,EAAA,EQqGvB;EAtHD;IAuCI,gCAAwD;IACxD,qBAA6D;IAC7D,wCAA6D;IAC7D,8CAA6E,EAAA;EAG/E;IAEE,0BAA4C;IAC5C,kCAAiD;IACjD,wCAAiE,EAAA;EAjDrE;IAqDI,gCAAwD;IPrD1D,wCOsDkE;IAChE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;IACE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;;IAKE,iCAA0D;IAC1D,yCAA+D;IAG/D,+CAA+E,EAAA;IATjF;;MAiBM,0CAAuE,EAAA;EAK7E;IAKI,0CAAuE,EAAA;EAvG7E;;IA8GI,mCAA8D;IAC9D,oBAAoB;IACpB,2CAAmE;IAEnE,iDAAmF;IACnF,uCAAoE,EAAA;;AAYtE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,sBAA2B;EAC3B,gCAA+C;EAC/C,0BAA6C;EAC7C,yCAAuC;EACvC,uDAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,8CAAyC;EACzC,wDAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,+BAA6C;EAC7C,yCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,sBAA2B;EAC3B,gCAA+C;EAC/C,0BAA6C;EAC7C,6CAAuC;EACvC,qDAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,4CAAyC;EACzC,sDAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,+BAA6C;EAC7C,yCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,sBAA2B;EAC3B,gCAA+C;EAC/C,0BAA6C;EAC7C,6CAAuC;EACvC,uDAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,8CAAyC;EACzC,wDAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,+BAA6C;EAC7C,yCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,sBAA2B;EAC3B,gCAA+C;EAC/C,0BAA6C;EAC7C,gDAAuC;EACvC,0DAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,iDAAyC;EACzC,2DAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,+BAA6C;EAC7C,yCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;AD4HjE;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,yBAAiC;EACjC,gCAA+C;EAC/C,0BAA6C;EAC7C,4BAAuC;EACvC,sCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,6BAAyC;EACzC,uCAA6D;EAC7D,4DAAiD;EACjD,kCAAmD;EACnD,iCAA6C;EAC7C,yCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,oCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,yBAAiC;EACjC,gCAA+C;EAC/C,0BAA6C;EAC7C,4BAAuC;EACvC,sCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,6BAAyC;EACzC,uCAA6D;EAC7D,4DAAiD;EACjD,kCAAmD;EACnD,iCAA6C;EAC7C,yCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,yBAAiC;EACjC,gCAA+C;EAC/C,0BAA6C;EAC7C,4BAAuC;EACvC,sCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,6BAAyC;EACzC,uCAA6D;EAC7D,4DAAiD;EACjD,kCAAmD;EACnD,iCAA6C;EAC7C,yCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,yBAAiC;EACjC,gCAA+C;EAC/C,0BAA6C;EAC7C,4BAAuC;EACvC,sCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,6BAAyC;EACzC,uCAA6D;EAC7D,4DAAiD;EACjD,kCAAmD;EACnD,iCAA6C;EAC7C,yCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD+GjC;EACE,yBAA6C;EAC7C,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,wCAA2D;EAC3D,8BAA+C;EAC/C,yCAA6D;EAC7D,gCAAmD;EACnD,2CAAiE;EACjE,+BAA2C;EAC3C,uCAAuD;EAEvD,qB1Bwd4C,EAAA;E0Bte9C;IAqBI,0B1Bod+C,EAAA;E0BzenD;IAyBI,0BAA4C,EAAA;EAzBhD;IA6BI,gCAAwD,EAAA;;AAW5D;ECjJE,0BAAyC;EACzC,wBAAyC;E7B8NrC,4BAnE+B;E6BzJnC,8BAAiD,EAAA;;ADkJnD;ECrJE,2BAAyC;EACzC,0BAAyC;E7B8NrC,2BAnE+B;E6BzJnC,8BAAiD,EAAA;;ACnEnD;EVgBM,gClB6uB2C,EAAA;EkBzuB3C;IUpBN;MVqBQ,gBAAgB,EAAA,EUfvB;EAND;IAII,UAAU,EAAA;;AAKd;EAEI,aAAa,EAAA;;AAIjB;EACE,SAAS;EACT,gBAAgB;EVDZ,6BlB+uBwC,EAAA;EkB3uBxC;IULN;MVMQ,gBAAgB,EAAA,EUIvB;EAVD;IAMI,QAAQ;IACR,YAAY;IVNV,4BlBgvBuC,EAAA;IkB5uBvC;MULN;QVMQ,gBAAgB,EAAA,EUGrB;;ACvBH;;;;;;EAME,kBAAkB,EAAA;;AL6FG;EKzFrB,mBAAmB,EAAA;;ALyFwB;EKhF3C,0BAA6C;EAC7C,8BAAmD;EACnD,0BAAmD;EACnD,+BAAmD;EACnD,8BAA6C;E/BuQzC,iCAnE+B;E+BlMnC,4BAA2C;EAC3C,sBAAqC;EACrC,+CAAyD;EACzD,oCAA2D;EAC3D,6BAAyD;EACzD,oDAAuE;EACvE,iCAAqD;EACrD,sCAAiE;EACjE,4DAAqD;EACrD,iCAAqD;EACrD,uCAAiE;EACjE,oCAA2D;EAC3D,wCAAmE;EACnE,qCAA6D;EAC7D,0CAAuE;EACvE,kCAA6D;EAC7D,qCAA6D;EAC7D,mCAAyD;EACzD,oCAAiE;EACjE,sCAAiE;EAGjE,kBAAkB;EAClB,kCAA0D;EAC1D,aAAa;EACb,uCAAkE;EAClE,kEAAwH;EACxH,SAAS;E/B0OL,uCAnE+B;E+BrKnC,+BAAsD;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,uCAA2D;EAC3D,4BAA4B;EAC5B,6EAAyI;E3BzCvI,+C2B0CoF,EAAA;EA3CxF;IA+CI,SAAS;IACT,OAAO;IACP,qCAA6D,EAAA;;AAwB7D;EACE,oBAAc,EAAA;EADhB;IAII,WAAW;IACX,OAAO,EAAA;;AAIX;EACE,kBAAc,EAAA;EADhB;IAII,QAAQ;IACR,UAAU,EAAA;;ApB1Cd;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;AAQP;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAgE,EAAA;;AAQpE;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sCAA8D,EAAA;;AANlE;EAYM,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,uCAA+D,EAAA;;AANnE;EAYM,iBAAiB,EAAA;;AAOvB;EACE,SAAS;EACT,6CAA+E;EAC/E,gBAAgB;EAChB,mDAA+E;EAC/E,UAAU,EAAA;;AAMZ;EACE,cAAc;EACd,WAAW;EACX,4EAA4I;EAC5I,WAAW;EACX,gB7BsnB+B;E6BrnB/B,oCAAgE;EAChE,mBAAmB;EAEnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;E3BtKP,uD2BuKiG,EAAA;EAZrG;IAgBI,0CAA4E;IAC5E,qBAA6D;IV3L/D,kDU4LsF,EAAA;EAlBxF;IAuBI,2CAA8E;IAC9E,qBAAqB;IVlMvB,mDUmMwF,EAAA;EAzB1F;IA8BI,6CAAkF;IAClF,oBAAoB;IACpB,6BAA6B,EAAA;;AAMjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,gFAAoJ;EACpJ,gBAAgB;E/BmEZ,kBAnE+B;E+BEnC,sCAAoE;EACpE,mBAAmB,EAAA;;AAIrB;EACE,cAAc;EACd,4EAA4I;EAC5I,oCAAgE,EAAA;;AAIlE;EAEE,4BAA2C;EAC3C,yBAAqC;EACrC,+CAAyD;EACzD,0BAAqD;EACrD,iCAAqD;EACrD,oCAAiE;EACjE,iCAAqD;EACrD,sDAA2D;EAC3D,wCAAmE;EACnE,qCAA6D;EAC7D,0CAAuE;EACvE,mCAAyD,EAAA;;ACtP3D;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;EARlB;;;;;;;;;;;;IAmBI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;E5BhBI,sBFmtBgC,EAAA;E8BnsBpC;;IAMI,2BAA4C,EAAA;EANhD;;;I5BAI,0B4Ba4B;I5BZ5B,6B4BY4B,EAAA;EAbhC;;;I5BcI,yB4BS8B;I5BR9B,4B4BQ8B,EAAA;;AAgBlC;EACE,wBAAmC;EACnC,uBAAkC,EAAA;EAFpC;;;IAOI,cAAc,EAAA;EAGhB;IACE,eAAe,EAAA;;AAInB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,0BAA2C,EAAA;EAZ/C;;I5B1EI,6B4B4F+B;I5B3F/B,4B4B2F+B,EAAA;EAlBnC;;;I5BxFI,yB4BoH4B;I5BnH5B,0B4BmH4B,EAAA;;AC3IhC;EAEE,6BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,yCAA2C;EAC3C,qDAAuD;EACvD,qCAA6D;EAG7D,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,kEAAwH;EjCsQpH,uCAnE+B;EiCjMnC,2CAAwE;EACxE,+BAAsD;EAEtD,gBAAgB;EAChB,SAAS;EbfL,uGlBswCsH,EAAA;EkBlwCtH;IaGN;MbFQ,gBAAgB,EAAA,Ea+BvB;EA7BD;IAaI,qCAAkE;IAClE,qBAA6D,EAAA;EAdjE;IAkBI,UAAU;IACV,kD9BJa,EAAA;E8BfjB;IAyBI,wCAAwE;IACxE,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EAEE,+BAAyD;EACzD,mCAAyD;EACzD,oCAA2D;EAC3D,8DAA+E;EAC/E,wCAAmE;EACnE,+CAA6D;EAC7D,yEAAiF;EAGjF,oFAAgJ,EAAA;EAXlJ;IAcI,yDAAuF;IACvF,yDAAuF;I7B7CvF,wD6B8C0F;I7B7C1F,yD6B6C0F,EAAA;IAhB9F;MAqBM,kBAAkB;MAClB,wDAAiG,EAAA;EAtBvG;;IA4BI,2CAA8E;IAC9E,mDAAmF;IACnF,yDAAmG,EAAA;EA9BvG;IAmCI,sDAAoF;I7BjEpF,yB6BmE4B;I7BlE5B,0B6BkE4B,EAAA;;AAShC;EAEE,qCAA6D;EAC7D,sCAAqE;EACrE,sCAA+D,EAAA;EAJjE;I7BrFI,gD6B6FwF,EAAA;EAR5F;;IAaI,4CAAgF;IZjHlF,oDYkH0F,EAAA;;AAS5F;EAEE,4BAAiD;EACjD,yCAAmE;EACnE,8DAA6E;EAG7E,gCAA0D,EAAA;EAP5D;IAUI,gBAAgB;IAChB,eAAe;IACf,qEAAwG,EAAA;IAZ5G;MAgBM,iCAAiC,EAAA;EAhBvC;;IAsBI,gB/BspB6B;I+BrpB7B,gDAAwF;IACxF,iCAAiC,EAAA;;AASrC;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAA;;AAItB;;EAGI,WAAW,EAAA;;AASf;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;AC7LlB;EAEE,wBAA+C;EAC/C,6BAA+C;EAC/C,sCAAuC;EACvC,2CAAmD;EACnD,8CAAyD;EACzD,4CAAqD;EACrD,sCAA2D;EAC3D,kCAA6D;EAC7D,qCAA2D;EAC3D,2CAAmD;EACnD,iDAA+D;EAC/D,sCAAiE;EACjE,sCAA+D;EAC/D,sCAA+D;EAC/D,uCAA+D;EAC/D,qEAA2D;EAC3D,oDAAqE;EACrE,0CAAuE;EACvE,wCAAmE;EACnE,4DAAiE;EAGjE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8DAAgH,EAAA;EA7BlH;;IAoCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,6CAA4E;EAC5E,gDAA+E;EAC/E,+CAA+E;ElC4N3E,2CAnE+B;EkCvJnC,mCAA8D;EAE9D,mBAAmB,EAAA;EAPrB;IAWI,yCAA0E;IAC1E,qBAA6D,EAAA;;AASjE;EAEE,0BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAG7D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EAflB;IAoBM,oCAAgE,EAAA;EApBtE;IAyBI,gBAAgB,EAAA;;AASpB;EACE,mBhCwpCuC;EgCvpCvC,sBhCupCuC;EgCtpCvC,6BAAkD,EAAA;EAHpD;;;IAQI,oCAAgE,EAAA;;AAapE;EACE,YAAY;EACZ,gBAAgB;EAGhB,mBAAmB,EAAA;;AAIrB;EACE,8EAAgJ;ElCyI5I,6CAnE+B;EkCpEnC,cAAc;EACd,6BAAkD;EAClD,6BAA6B;EAC7B,0EAAmI;E9BxIjI,qD8ByIgG;Ed5I9F,+Cc6IqF,EAAA;EdzIrF;IciIN;MdhIQ,gBAAgB,EAAA,EcmJvB;EAnBD;IAWI,qBAAqB,EAAA;EAXzB;IAeI,qBAAqB;IACrB,UAAU;IACV,sDAAyF,EAAA;;AAM7F;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;AAGvB;EACE,yCAA+D;EAC/D,gBAAgB,EAAA;;AvB1Hd;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB7LP;EuBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md9N9B,gBcgO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AA7DX;EAQQ,iBAAiB;EACjB,2BAA2B,EAAA;EATnC;IAYU,mBAAmB,EAAA;IAZ7B;MAeY,kBAAkB,EAAA;IAf9B;MAmBY,kDAAoF;MACpF,iDAAmF,EAAA;EApB/F;IAyBU,iBAAiB,EAAA;EAzB3B;IA6BU,wBAAwB;IACxB,gBAAgB,EAAA;EA9B1B;IAkCU,aAAa,EAAA;EAlCvB;IAuCU,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;Id9N9B,gBcgO4B,EAAA;IAjDlC;MAqDY,aAAa,EAAA;IArDzB;MAyDY,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB,EAAA;;AAiB/B;;EAGE,4CAAuC;EACvC,kDAAmD;EACnD,qDAAyD;EACzD,8BAAqD;EACrD,6BAAmD;EACnD,mCAA+D;EAC/D,0DAAqE;EACrE,qEAA2D,EAAA;;A1Cy76B7D;E0Cl76BM,qEAA2D,EAAA;;ACzRjE;EAEE,2BAAyC;EACzC,2BAAyC;EACzC,gCAAqD;EACrD,uBAA+C;EAC/C,0BAAqD;EACrD,yBAAiD;EACjD,+BAAiD;EACjD,+BAAmD;EACnD,sBAA6C;EAC7C,qCAA+D;EAC/D,iCAAmD;EACnD,gCAAmD;EACnD,yBAAqC;EACrC,qBAA2C;EAC3C,kBAAqC;EACrC,iBAAmC;EACnC,kBAA6B;EAC7B,mCAA+D;EAC/D,4BAAiD;EAGjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAAiD;EACjD,2BAA8C;EAC9C,qBAAqB;EACrB,mCAAmD;EACnD,2BAA2B;EAC3B,qEAAyH;E/BjBvH,2C+BkB4E,EAAA;EAjChF;IAqCI,eAAe;IACf,cAAc,EAAA;EAtClB;IA0CI,mBAAmB;IACnB,sBAAsB,EAAA;IA3C1B;MA8CM,mBAAmB;M/BtBrB,0D+BuBgG;M/BtBhG,2D+BsBgG,EAAA;IA/CpG;MAmDM,sBAAsB;M/BbxB,8D+BcmG;M/BbnG,6D+BamG,EAAA;EApDvG;;IA4DI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EACd,wDAAoG;EACpG,2BAA8C,EAAA;;AAGhD;EACE,4CAAwE;EACxE,iCAA0D,EAAA;;AAG5D;EACE,qDAAiF;EACjF,gBAAgB;EAChB,oCAAgE,EAAA;;AAGlE;EACE,gBAAgB,EAAA;;AAGlB;EAEI,qBAA6D,EAAA;;AAFjE;EAMI,oCAA0D,EAAA;;AAQ9D;EACE,kEAAwH;EACxH,gBAAgB;EAChB,+BAAsD;EACtD,uCAA2D;EAC3D,4EAAgI,EAAA;EALlI;I/BtFI,wF+B8FkK,EAAA;;AAItK;EACE,kEAAwH;EACxH,+BAAsD;EACtD,uCAA2D;EAC3D,yEAA6H,EAAA;EAJ/H;I/BlGI,wF+ByGkK,EAAA;;AAStK;EACE,sDAAiF;EACjF,sDAAiF;EACjF,qDAAgF;EAChF,gBAAgB,EAAA;EAJlB;IAOI,mCAAmD;IACnD,sCAAsD,EAAA;;AAI1D;EACE,sDAAiF;EACjF,qDAAgF,EAAA;;AAIlF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,2CAA4E;E/B1I1E,iD+B2IwF,EAAA;;AAG5F;;;EAGE,WAAW,EAAA;;AAGb;;E/B3II,0D+B6I4F;E/B5I5F,2D+B4I4F,EAAA;;AAGhG;;E/BlII,8D+BoI+F;E/BnI/F,6D+BmI+F,EAAA;;AAQnG;EAII,0CAAoE,EAAA;;AxB3HpE;EwBuHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAaM,SAAW;MACX,gBAAgB,EAAA;MAdtB;QAiBQ,cAAc;QACd,cAAc,EAAA;MAlBtB;Q/BnJI,0B+B2KkC;Q/B1KlC,6B+B0KkC,EAAA;QAxBtC;;UA6BY,0BAA0B,EAAA;QA7BtC;;UAkCY,6BAA6B,EAAA;MAlCzC;Q/BrII,yB+B4KoC;Q/B3KpC,4B+B2KoC,EAAA;QAvCxC;;UA4CY,yBAAyB,EAAA;QA5CrC;;UAiDY,4BAA4B,EAAA,EAC7B;;ACpOX;EAEE,6BAA6C;EAC7C,8BAAuC;EACvC,8KAAuD;EACvD,iDAA2D;EAC3D,gCAA2D;EAC3D,qCAA6D;EAC7D,uDAAyE;EACzE,qCAA6D;EAC7D,kCAA6D;EAC7D,iCAAqD;EACrD,kCAA+C;EAC/C,iEAAmD;EACnD,mCAA+D;EAC/D,iDAAuE;EACvE,8DAAyE;EACzE,wEAAiE;EACjE,yCAA2E;EAC3E,sCAA+D;EAC/D,mCAA+D;EAC/D,oCAA2D;EAC3D,iCAAqD,EAAA;;AAIvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4EAA4I;EpC4PxI,mBAnE+B;EoCvLnC,oCAAgE;EAChE,gBAAgB;EAChB,4CAAqE;EACrE,SAAS;EhCrBP,gBgCsBsB;EACxB,qBAAqB;EhB1BjB,0CgB2B2E,EAAA;EhBvB3E;IgBUN;MhBTQ,gBAAgB,EAAA,EgByDvB;EAhDD;IAgBI,uCAAsE;IACtE,+CAA2E;IAC3E,kGAAgK,EAAA;IAlBpK;MAqBM,qDAAuF;MACvF,iDAAsF,EAAA;EAtB5F;IA4BI,cAAc;IACd,yCAA0E;IAC1E,0CAA2E;IAC3E,iBAAiB;IACjB,WAAW;IACX,8CAAyE;IACzE,4BAA4B;IAC5B,mDAAoF;IhBjDlF,mDgBkD+F,EAAA;IhB9C/F;MgBUN;QhBTQ,gBAAgB,EAAA,EgB8CrB;EArCH;IAwCI,UAAU,EAAA;EAxCd;IA4CI,UAAU;IACV,UAAU;IACV,oDAA2F,EAAA;;AAI/F;EACE,gBAAgB,EAAA;;AAGlB;EACE,gCAAwD;EACxD,wCAA6D;EAC7D,+EAA6I,EAAA;EAH/I;IhCxDI,yDgC8D4F;IhC7D5F,0DgC6D4F,EAAA;IANhG;MhCxDI,+DgCiE0G;MhChE1G,gEgCgE0G,EAAA;EAT9G;IAcI,aAAa,EAAA;EAdjB;IhC1CI,6DgC6D+F;IhC5D/F,4DgC4D+F,EAAA;IAnBnG;MhC1CI,mEgCiE+G;MhChE/G,kEgCgE+G,EAAA;IAvBnH;MhC1CI,6DgCsEiG;MhCrEjG,4DgCqEiG,EAAA;;AAKrG;EACE,8EAAgJ,EAAA;;AAQlJ;EAEI,eAAe;EACf,cAAc;EhC9Gd,gBgC+GwB,EAAA;EAJ5B;IAMoB,aAAa,EAAA;EANjC;IAOmB,gBAAgB,EAAA;EAPnC;;;IhC3GI,gBgCwH0B,EAAA;;A5Ci17B9B;E4Cx07BM,iEAAmD;EACnD,wEAAiE,EAAA;;ACrJvE;EAEE,+BAAuD;EACvD,kCAAuD;EACvD,mCAA+D;EAE/D,oBAAyC;EACzC,+BAA+D;EAC/D,sCAA+D;EAC/D,sCAAiE;EACjE,0CAAuE;EAGvE,aAAa;EACb,eAAe;EACf,sEAAgI;EAChI,iDAAkF;ErC+Q9E,yCAnE+B;EqC1MnC,gBAAgB;EAChB,yCAA+D;EjCA7D,iDiCCwF,EAAA;;AAG5F;EAGI,iDAAmF,EAAA;EAHvF;IAMM,WAAW;IACX,kDAAoF;IACpF,yCAA0E;IAC1E,yFAAgN,EAAO;;AAT7N;EAcI,6CAAkF,EAAA;;ACrCtF;EAEE,kCAAuD;EACvD,iCAAuD;EtC4RnD,+BAnE+B;EsCvNnC,8BAA+C;EAC/C,wBAAyC;EACzC,iCAA6D;EAC7D,qCAA6D;EAC7D,sCAA+D;EAC/D,oCAA2D;EAC3D,iCAAqD;EACrD,2CAAyE;EACzE,oCAA2D;EAC3D,iCAAqD;EACrD,uEAAqE;EACrE,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAC3E,uCAAiE;EACjE,iCAA2D;EAC3D,8CAA+E;EAG/E,aAAa;EhCpBb,eAAe;EACf,gBAAgB,EAAA;;AgCuBlB;EACE,kBAAkB;EAClB,cAAc;EACd,sEAAgI;EtCgQ5H,yCAnE+B;EsC3LnC,iCAA0D;EAE1D,yCAA+D;EAC/D,iFAAiJ;ElBpB7I,qIlBy5CoJ,EAAA;EkBr5CpJ;IkBQN;MlBPQ,gBAAgB,EAAA,EkBiDvB;EA1CD;IAYI,UAAU;IACV,uCAAsE;IACtE,qBAA6D;IAC7D,+CAA2E;IAC3E,qDAA2F,EAAA;EAhB/F;IAoBI,UAAU;IACV,uCAAsE;IACtE,+CAA2E;IAC3E,UpCw2CiC;IoCv2CjC,iDAAqF,EAAA;EAxBzF;;IA6BI,UAAU;IACV,wCAAwE;IjBtD1E,gDiBuDkF;IAChF,sDAA6F,EAAA;EAhCjG;;IAqCI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF;IACjF,wDAAiG,EAAA;;AAIrG;EAEI,iBpC8oB6B,EAAA;;AoChpBjC;ElCrDI,iDkCyE4F,EAAA;;AAUhG;EClGE,iCAAuD;EACvD,kCAAuD;EvC0RnD,mCAnE+B;EuCrNnC,qCAA+D,EAAA;;ADmGjE;ECtGE,iCAAuD;EACvD,kCAAuD;EvC0RnD,kCAnE+B;EuCrNnC,qCAA+D,EAAA;;ACFjE;EAEE,2BAA6C;EAC7C,4BAA6C;ExCuRzC,yBAnE+B;EwClNnC,2BAAiD;EACjD,sBAAqC;EACrC,iCAAqD;EAGrD,qBAAqB;EACrB,4DAA4G;ExC+QxG,oCAnE+B;EwC1MnC,wCAAkE;EAClE,cAAc;EACd,4BAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EpCJtB,4CoCK8E,EAAA;EAnBlF;IAwBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AChCX;EAEE,0BAA+B;EAC/B,6BAA6C;EAC7C,6BAA6C;EAC7C,8BAAqD;EACrD,yBAAqC;EACrC,oCAAmD;EACnD,yDAAuC;EACvC,iCAAqD;EACrD,8BAA+C;EAG/C,kBAAkB;EAClB,4DAA4G;EAC5G,4CAAwE;EACxE,4BAAgD;EAChD,oCAAqD;EACrD,8BAAmD;ErCHjD,4CqCI8E,EAAA;;AAIlF;EAEE,cAAc,EAAA;;AAIhB;EACE,gBvCywB+B;EuCxwB/B,iCAA0D,EAAA;;AAQ5D;EACE,sBvC8lDsD,EAAA;EuC/lDxD;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UvCkmBuC;IuCjmBvC,0BvC4kDuC,EAAA;;AuCpkDzC;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,wDAAqC;EACrC,iDAA+B;EAC/B,+DAAmD;EACnD,6DAA+C,EAAA;;AAJjD;EACE,mDAAqC;EACrC,4CAA+B;EAC/B,0DAAmD;EACnD,wDAA+C,EAAA;;AAJjD;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AAJjD;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,gDAAqC;EACrC,yCAA+B;EAC/B,uDAAmD;EACnD,qDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AAJjD;EACE,+CAAqC;EACrC,wCAA+B;EAC/B,sDAAmD;EACnD,oDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AAJjD;EACE,2DAAqC;EACrC,oDAA+B;EAC/B,kEAAmD;EACnD,gEAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,2DAAqC;EACrC,oDAA+B;EAC/B,kEAAmD;EACnD,gEAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,qDAAqC;EACrC,8CAA+B;EAC/B,4DAAmD;EACnD,0DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,uDAAqC;EACrC,gDAA+B;EAC/B,8DAAmD;EACnD,4DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,wDAAqC;EACrC,iDAA+B;EAC/B,+DAAmD;EACnD,6DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,yDAAqC;EACrC,kDAA+B;EAC/B,gEAAmD;EACnD,8DAA+C,EAAA;;AAJjD;EACE,yDAAqC;EACrC,kDAA+B;EAC/B,gEAAmD;EACnD,8DAA+C,EAAA;;AAJjD;EACE,yDAAqC;EACrC,kDAA+B;EAC/B,gEAAmD;EACnD,8DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,sDAAqC;EACrC,+CAA+B;EAC/B,6DAAmD;EACnD,2DAA+C,EAAA;;AAJjD;EACE,wDAAqC;EACrC,iDAA+B;EAC/B,+DAAmD;EACnD,6DAA+C,EAAA;;AAJjD;EACE,wDAAqC;EACrC,iDAA+B;EAC/B,+DAAmD;EACnD,6DAA+C,EAAA;;AAJjD;EACE,wDAAqC;EACrC,iDAA+B;EAC/B,+DAAmD;EACnD,6DAA+C,EAAA;;AAJjD;EACE,wDAAqC;EACrC,iDAA+B;EAC/B,+DAAmD;EACnD,6DAA+C,EAAA;;AC5DjD;EACE;IAAK,gDAAwE,EAAA,EAAA;;AAKjF;;EAGE,8BAA6C;E1CkRzC,mCAnE+B;E0C7MnC,yBAAqC;EACrC,oCAA2D;EAC3D,8DAAqD;EACrD,6BAAmD;EACnD,6BAA6C;EAC7C,6CAA6D;EAG7D,aAAa;EACb,iCAAyD;EACzD,gBAAgB;E1CsQZ,uCAnE+B;E0CjMnC,uCAA2D;EtCRzD,+CsCSoF,EAAA;;AAIxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mCAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,2CAAmE;EtBxB/D,6CsByBiF,EAAA;EtBrBjF;IsBYN;MtBXQ,gBAAgB,EAAA,EsBqBvB;;AAED;ErBAE,qMAA6I;EqBE7I,oEAAoH,EAAA;;AAGtH;EACE,iBAAiB,EAAA;;AAGnB;EACE,WAAW,EAAA;;AAIX;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;AC9DH;EAEE,2CAA+C;EAC/C,wBAAyC;EACzC,qCAA6D;EAC7D,iCAA6D;EAC7D,sCAA+D;EAC/D,uCAAiE;EACjE,uCAAiE;EACjE,qCAA6D;EAC7D,2CAAyE;EACzE,wCAAmE;EACnE,4CAA2E;EAC3E,yCAAqE;EACrE,uCAAiE;EACjE,iCAA2D;EAC3D,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAG3E,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB;EvCXd,iDuCYwF,EAAA;;AAG5F;EACE,qBAAqB;EACrB,sBAAsB,EAAA;EAFxB;IAMI,oCAAoC;IACpC,0BAA0B,EAAA;;AAQ9B;EACE,kBAAkB;EAClB,cAAc;EACd,gFAAoJ;EACpJ,iCAA0D;EAE1D,yCAA+D;EAC/D,iFAAiJ,EAAA;EAPnJ;IvCrBI,+BuC+BkC;IvC9BlC,gCuC8BkC,EAAA;EAVtC;IvCPI,mCuCqBqC;IvCpBrC,kCuCoBqC,EAAA;EAdzC;IAmBI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF,EAAA;EArBrF;IA0BI,UAAU;IACV,wCAAwE;IACxE,gDAA6E;IAC7E,sDAA6F,EAAA;EA7BjG;IAkCI,mBAAmB,EAAA;IAlCvB;MAqCM,wDAAwF;MACxF,mDAAmF,EAAA;;AAUzF;EACE,WAAW;EACX,wCAAwE;EACxE,mBAAmB,EAAA;EAHrB;IASM,UAAU;IACV,8CAAoF;IACpF,qBAAqB;IACrB,sDAAyF,EAAA;EAZ/F;IAgBM,+CAAsF;IACtF,uDAA2F,EAAA;;AAa7F;EACE,mBAAmB,EAAA;EADrB;IvCrDA,6DuC0D6G;IvCtE7G,0BuCuEsC,EAAA;EANtC;IvCjEA,2DuC2EwG;IvC/DxG,4BuCgE2C,EAAA;EAX3C;IAeM,aAAa,EAAA;EAfnB;IAmBM,mDAAmF;IACnF,oBAAoB,EAAA;IApB1B;MAuBQ,yDAAyF;MACzF,oDAAoF,EAAA;;AhCxF5F;EgCgEA;IACE,mBAAmB,EAAA;IADrB;MvCrDA,6DuC0D6G;MvCtE7G,0BuCuEsC,EAAA;IANtC;MvCjEA,2DuC2EwG;MvC/DxG,4BuCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCzFP;EgCgEA;IACE,mBAAmB,EAAA;IADrB;MvCrDA,6DuC0D6G;MvCtE7G,0BuCuEsC,EAAA;IANtC;MvCjEA,2DuC2EwG;MvC/DxG,4BuCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCzFP;EgCgEA;IACE,mBAAmB,EAAA;IADrB;MvCrDA,6DuC0D6G;MvCtE7G,0BuCuEsC,EAAA;IANtC;MvCjEA,2DuC2EwG;MvC/DxG,4BuCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCzFP;EgCgEA;IACE,mBAAmB,EAAA;IADrB;MvCrDA,6DuC0D6G;MvCtE7G,0BuCuEsC,EAAA;IANtC;MvCjEA,2DuC2EwG;MvC/DxG,4BuCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AhCzFP;EgCgEA;IACE,mBAAmB,EAAA;IADrB;MvCrDA,6DuC0D6G;MvCtE7G,0BuCuEsC,EAAA;IANtC;MvCjEA,2DuC2EwG;MvC/DxG,4BuCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AAaX;EvClJI,gBuCmJsB,EAAA;EAD1B;IAII,mDAAmF,EAAA;IAJvF;MAOM,sBAAsB,EAAA;;AAa1B;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,6DAA+C;EAC/C,sDAAyC;EACzC,oEAA6D;EAC7D,4DAAyE;EACzE,uEAAmE;EACnE,6DAA2E;EAC3E,wEAAqE;EACrE,gEAA6D;EAC7D,iEAAuD;EACvD,2EAA2E,EAAA;;AAV7E;EACE,wDAA+C;EAC/C,iDAAyC;EACzC,+DAA6D;EAC7D,4DAAyE;EACzE,kEAAmE;EACnE,6DAA2E;EAC3E,mEAAqE;EACrE,2DAA6D;EAC7D,4DAAuD;EACvD,sEAA2E,EAAA;;AAV7E;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AAV7E;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,qDAA+C;EAC/C,8CAAyC;EACzC,4DAA6D;EAC7D,4DAAyE;EACzE,+DAAmE;EACnE,6DAA2E;EAC3E,gEAAqE;EACrE,wDAA6D;EAC7D,yDAAuD;EACvD,mEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AAV7E;EACE,oDAA+C;EAC/C,6CAAyC;EACzC,2DAA6D;EAC7D,4DAAyE;EACzE,8DAAmE;EACnE,6DAA2E;EAC3E,+DAAqE;EACrE,uDAA6D;EAC7D,wDAAuD;EACvD,kEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AAV7E;EACE,gEAA+C;EAC/C,yDAAyC;EACzC,uEAA6D;EAC7D,4DAAyE;EACzE,0EAAmE;EACnE,6DAA2E;EAC3E,2EAAqE;EACrE,mEAA6D;EAC7D,oEAAuD;EACvD,8EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,gEAA+C;EAC/C,yDAAyC;EACzC,uEAA6D;EAC7D,4DAAyE;EACzE,0EAAmE;EACnE,6DAA2E;EAC3E,2EAAqE;EACrE,mEAA6D;EAC7D,oEAAuD;EACvD,8EAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,0DAA+C;EAC/C,mDAAyC;EACzC,iEAA6D;EAC7D,4DAAyE;EACzE,oEAAmE;EACnE,6DAA2E;EAC3E,qEAAqE;EACrE,6DAA6D;EAC7D,8DAAuD;EACvD,wEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,4DAA+C;EAC/C,qDAAyC;EACzC,mEAA6D;EAC7D,4DAAyE;EACzE,sEAAmE;EACnE,6DAA2E;EAC3E,uEAAqE;EACrE,+DAA6D;EAC7D,gEAAuD;EACvD,0EAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,6DAA+C;EAC/C,sDAAyC;EACzC,oEAA6D;EAC7D,4DAAyE;EACzE,uEAAmE;EACnE,6DAA2E;EAC3E,wEAAqE;EACrE,gEAA6D;EAC7D,iEAAuD;EACvD,2EAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,8DAA+C;EAC/C,uDAAyC;EACzC,qEAA6D;EAC7D,4DAAyE;EACzE,wEAAmE;EACnE,6DAA2E;EAC3E,yEAAqE;EACrE,iEAA6D;EAC7D,kEAAuD;EACvD,4EAA2E,EAAA;;AAV7E;EACE,8DAA+C;EAC/C,uDAAyC;EACzC,qEAA6D;EAC7D,4DAAyE;EACzE,wEAAmE;EACnE,6DAA2E;EAC3E,yEAAqE;EACrE,iEAA6D;EAC7D,kEAAuD;EACvD,4EAA2E,EAAA;;AAV7E;EACE,8DAA+C;EAC/C,uDAAyC;EACzC,qEAA6D;EAC7D,4DAAyE;EACzE,wEAAmE;EACnE,6DAA2E;EAC3E,yEAAqE;EACrE,iEAA6D;EAC7D,kEAAuD;EACvD,4EAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,2DAA+C;EAC/C,oDAAyC;EACzC,kEAA6D;EAC7D,4DAAyE;EACzE,qEAAmE;EACnE,6DAA2E;EAC3E,sEAAqE;EACrE,8DAA6D;EAC7D,+DAAuD;EACvD,yEAA2E,EAAA;;AAV7E;EACE,6DAA+C;EAC/C,sDAAyC;EACzC,oEAA6D;EAC7D,4DAAyE;EACzE,uEAAmE;EACnE,6DAA2E;EAC3E,wEAAqE;EACrE,gEAA6D;EAC7D,iEAAuD;EACvD,2EAA2E,EAAA;;AAV7E;EACE,6DAA+C;EAC/C,sDAAyC;EACzC,oEAA6D;EAC7D,4DAAyE;EACzE,uEAAmE;EACnE,6DAA2E;EAC3E,wEAAqE;EACrE,gEAA6D;EAC7D,iEAAuD;EACvD,2EAA2E,EAAA;;AAV7E;EACE,6DAA+C;EAC/C,sDAAyC;EACzC,oEAA6D;EAC7D,4DAAyE;EACzE,uEAAmE;EACnE,6DAA2E;EAC3E,wEAAqE;EACrE,gEAA6D;EAC7D,iEAAuD;EACvD,2EAA2E,EAAA;;AAV7E;EACE,6DAA+C;EAC/C,sDAAyC;EACzC,oEAA6D;EAC7D,4DAAyE;EACzE,uEAAmE;EACnE,6DAA2E;EAC3E,wEAAqE;EACrE,gEAA6D;EAC7D,iEAAuD;EACvD,2EAA2E,EAAA;;AC9L/E;EAEE,0BAA6C;EAC7C,2DAAuC;EACvC,2BAAiD;EACjD,kCAA6D;EAC7D,iCAA2D;EAC3D,+BAA6D;EAC7D,qCAAmE;EAGnE,uBAAuB;EACvB,U1CuwD8B;E0CtwD9B,W1CswD8B;E0CrwD9B,sB1CuwDgC;E0CtwDhC,gCAAwD;EACxD,wEAA4G;EAC5G,kCAA2D;EAC3D,SAAS;ExCJP,sBFmtBgC;E0C7sBlC,oCAA8D,EAAA;EApBhE;IAwBI,gCAAwD;IACxD,qBAAqB;IACrB,0CAA0E,EAAA;EA1B9E;IA8BI,UAAU;IACV,4CAA2E;IAC3E,0CAA0E,EAAA;EAhC9E;IAqCI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,6CAAgF,EAAA;;AAQpF;EAHE,iEAA+C,EAAA;;A7CjDjD;;E6C0DE,uBAA+C,EAAA;;ApDk2+BjD;EoD32+BE,iEAA+C,EAAA;;ACjDjD;EAEE,uBAAuC;EACvC,6BAA6C;EAC7C,6BAA6C;EAC7C,wBAAyC;EACzC,2BAA6C;E7CyRzC,8BAnE+B;E6CpNnC,kBAAqC;EACrC,wCAA+B;EAC/B,4BAAmD;EACnD,2CAAmD;EACnD,iCAAqD;EACrD,uDAA+C;EAC/C,gCAAmD;EACnD,+CAA6C;EAC7C,mDAAiE;EAGjE,gCAAwD;EACxD,eAAe;E7C2QX,oCAnE+B;E6CtMnC,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;EAC7H,sCAA+D;EzCR7D,4CyCS8E,EAAA;EA5BlF;IA+BI,UAAU,EAAA;EA/Bd;IAmCI,aAAa,EAAA;;AAIjB;EACE,uBAAuC;EAEvC,kBAAkB;EAClB,+BAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;EAPtB;IAUI,sCAA4D,EAAA;;AAIhE;EACE,aAAa;EACb,mBAAmB;EACnB,4DAA4G;EAC5G,mCAA8D;EAC9D,2CAAmE;EACnE,4BAA4B;EAC5B,qFAAkJ;EzChChJ,0FyCiCkJ;EzChClJ,2FyCgCkJ,EAAA;EARtJ;IAWI,mDAA2E;IAC3E,sCAA8D,EAAA;;AAIlE;EACE,kCAA0D;EAC1D,qBAAqB,EAAA;;AC9DvB;EAEE,uBAAuC;EACvC,uBAAqC;EACrC,wBAAyC;EACzC,yBAAuC;EACvC,sCAAqC;EACrC,mBAA+B;EAC/B,gCAAmD;EACnD,4BAAmD;EACnD,gCAAqD;EACrD,oDAA+C;EAC/C,kDAAiE;EACjE,iCAA2D;EAC3D,iCAA2D;EAC3D,oCAAuD;EACvD,uCAAiE;EACjE,mCAAiE;EACjE,iCAA6D;EAC7D,6BAA+C;EAC/C,sBAA6C;EAC7C,uCAAiE;EACjE,mCAAiE;EAGjE,eAAe;EACf,MAAM;EACN,OAAO;EACP,+BAAoD;EACpD,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,8BAAmD;EAEnD,oBAAoB,EAAA;EAGpB;IACE,8B5CsjDmD;IkBnmDjD,mClBqmDoD,EAAA;IkBjmDpD;M0BwCJ;Q1BvCM,gBAAgB,EAAA,E0B0CrB;EACD;IACE,e5CmjDoC,EAAA;E4C/iDtC;IACE,sB5CgjD2C,EAAA;;A4C5iD/C;EACE,+CAAoE,EAAA;EADtE;IAII,gBAAgB;IAChB,gBAAgB,EAAA;EALpB;IASI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAwE,EAAA;;AAI1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;E1CrF3H,4C0CsF8E;EAGhF,UAAU,EAAA;;AAIZ;EAEE,0BAA6C;EAC7C,sBAAqC;EACrC,0BAA+C;EClH/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCDkH2E;ECjH3E,YAAY;EACZ,aAAa;EACb,uCD+GsH,EAAA;EC5GtH;IAAS,UAAU,EAAA;EACnB;IAAS,mCD2GkK,EAAA;;AAK7K;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAAoE;EACpE,4FAAgK;E1CrG9J,2D0CsG8F;E1CrG9F,4D0CqG8F,EAAA;EANlG;IASI,gGAA8J;IAE9J,wDAAuF;IACvF,0DAAyF;IACzF,2DAA0F;IAC1F,iBAAiB,EAAA;;AAKrB;EACE,gBAAgB;EAChB,8CAA8E,EAAA;;AAKhF;EACE,kBAAkB;EAGlB,cAAc;EACd,gCAAsD,EAAA;;AAIxD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,wEAAuH;EACvH,2CAAmE;EACnE,yFAA6J;E1C7H3J,+D0C8HiG;E1C7HjG,8D0C6HiG,EAAA;EATrG;IAeI,6CAAsE,EAAA;;AnC/GtE;EmCtDJ;IA4KI,0BAAuC;IACvC,uDAA+C,EAAA;EAlInD;IAuII,gCAAoD;IACpD,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,uBAAqC,EAAA,EACtC;;AnCnIC;EmCuIF;;IAEE,uBAAqC,EAAA,EACtC;;AnC1IC;EmC8IF;IACE,wBAAqC,EAAA,EACtC;;AASC;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS,EAAA;EAJX;IAOI,YAAY;IACZ,SAAS;I1C7Mb,gB0C8M4B,EAAA;EAT5B;;I1CrMA,gB0CmN4B,EAAA;EAd5B;IAkBI,gBAAgB,EAAA;;AnC9JpB;EmC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C7Mb,gB0C8M4B,EAAA;IAT5B;;M1CrMA,gB0CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC/JH;EmC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C7Mb,gB0C8M4B,EAAA;IAT5B;;M1CrMA,gB0CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC/JH;EmC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C7Mb,gB0C8M4B,EAAA;IAT5B;;M1CrMA,gB0CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC/JH;EmC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C7Mb,gB0C8M4B,EAAA;IAT5B;;M1CrMA,gB0CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AnC/JH;EmC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M1C7Mb,gB0C8M4B,EAAA;IAT5B;;M1CrMA,gB0CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AE1OP;EAEE,yBAA2C;EAC3C,6BAAiD;EACjD,8BAAiD;EACjD,8BAAiD;EACjD,sBAA2C;EhDwRvC,+BAnE+B;EgDnNnC,wBAAyC;EACzC,qBAAmC;EACnC,mCAAyD;EACzD,yBAA6C;EAC7C,gCAAqD;EACrD,iCAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,gCAAuD;EClBvD,sC/CuxBsF;E+CrxBtF,kBAAkB;EAClB,gB/CqyB+B;E+CpyB/B,gB/C0yB+B;E+CzyB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EjDgRZ,sCAnE+B;EgDlMnC,qBAAqB;EACrB,UAAU,EAAA;EA1BZ;IA4BW,kCAA0D,EAAA;EA5BrE;IA+BI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IAjCvE;MAoCM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,iDAA8E,EAAA;EADhF;IAII,SAAS;IACT,uFAAgJ;IAChJ,sCAAyD,EAAA;;AAI7D,qBAAA;AACA;EACE,+CAA4E;EAC5E,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,WAAW;IACX,gIAAqN;IACrN,wCAA2D,EAAA;;AAI/D,mBAAA;AAEA;EACE,8CAA2E,EAAA;EAD7E;IAII,YAAY;IACZ,uFAAgJ;IAChJ,yCAA4D,EAAA;;AAIhE,qBAAA;AACA;EACE,gDAA6E;EAC7E,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,UAAU;IACV,gIAAqN;IACrN,uCAA0D,EAAA;;AAI9D,mBAAA;AAkBA;EACE,sCAAgE;EAChE,gEAAoH;EACpH,8BAAoD;EACpD,kBAAkB;EAClB,sCAAyD;E5CjGvD,8C4CkGkF,EAAA;;AErHtF;EAEE,yBAA2C;EAC3C,6BAAiD;ElD4R7C,+BAnE+B;EkDvNnC,qBAAmC;EACnC,8BAAuD;EACvD,kCAAuD;EACvD,kCAAyD;EACzD,oDAAqE;EACrE,4DAAmD;EACnD,sCAA+D;EAC/D,qCAA+D;ElDmR3D,mCAnE+B;EkD9MnC,kCAAuD;EACvD,+BAAiD;EACjD,oCAA2D;EAC3D,mCAA2D;EAC3D,gCAAmD;EACnD,8BAAqD;EACrD,iCAAuD;EACvD,yDAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,sCAAgE;EDzBhE,sC/CuxBsF;E+CrxBtF,kBAAkB;EAClB,gB/CqyB+B;E+CpyB/B,gB/C0yB+B;E+CzyB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EjDgRZ,sCAnE+B;EkD5LnC,qBAAqB;EACrB,sCAAyD;EACzD,4BAA4B;EAC5B,2EAAqI;E9ChBnI,8C8CiBkF,EAAA;EApCtF;IAwCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IA1CvE;MA8CM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;EAEI,oFAA8I,EAAA;EAFlJ;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,SAAS;IACT,gDAA6E,EAAA;EAXnF;IAeM,sCAAmE;IACnE,sCAAyD,EAAA;;AAK/D,qBAAA;AACA;EAEI,kFAA4I;EAC5I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,OAAO;IACP,kDAA+E,EAAA;EAbrF;IAiBM,oCAAiE;IACjE,wCAA2D,EAAA;;AAKjE,mBAAA;AAEA;EAEI,iFAA2I,EAAA;EAF/I;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,MAAM;IACN,mDAAgF,EAAA;EAXtF;IAeM,mCAAgE;IAChE,yCAA4D,EAAA;;AAhBlE;EAsBI,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oCAAgE;EAChE,sDAAkF;EAClF,WAAW;EACX,+EAAsI,EAAA;;AAI1I,qBAAA;AACA;EAEI,mFAA6I;EAC7I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,QAAQ;IACR,iDAA8E,EAAA;EAbpF;IAiBM,qCAAkE;IAClE,uCAA0D,EAAA;;AAKhE,mBAAA;AAkBA;EACE,8EAAgJ;EAChJ,gBAAgB;ElD2GZ,6CAnE+B;EkDtCnC,qCAAkE;EAClE,6CAAuE;EACvE,kFAA4I;E9C5J1I,6D8C6JkG;E9C5JlG,8D8C4JkG,EAAA;EAPtG;IAUI,aAAa,EAAA;;AAIjB;EACE,0EAAwI;EACxI,mCAA8D,EAAA;;ACrLhE;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECtBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADuBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;E/BlBvB,sClB8uDkF,EAAA;EkB1uDlF;I+BQN;M/BPQ,gBAAgB,EAAA,E+BevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;E/B5DR,2BlB6uDkC,EAAA;EkBzuDlC;I+BuCN;;M/BtCQ,gBAAgB,EAAA,E+ByDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UjDqoDsC;EiDpoDtC,UAAU;EACV,WjDsEa;EiDrEb,kBAAkB;EAClB,gBAAgB;EAChB,8CAAmF;EACnF,SAAS;EACT,YjD+nDqC;EkBttDjC,8BlBwtDgD,EAAA;EkBptDhD;I+BkEN;;M/BjEQ,gBAAgB,EAAA,E+B6FvB;EA5BD;;;IAuBI,WjD2DW;IiD1DX,qBAAqB;IACrB,UAAU;IACV,YjDunDmC,EAAA;;AiDpnDvC;EACE,OAAO,EAAA;;AAGT;EACE,QAAQ,EAAA;;AAKV;;EAEE,qBAAqB;EACrB,WjDwnDuC;EiDvnDvC,YjDunDuC;EiDtnDvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B,EAAA;;AAG5B;EACE,2TAA4H,EAAA;;AAE9H;EACE,0TAA4H,EAAA;;AAQ9H;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EAEV,iBjDwkDsC;EiDvkDtC,mBAAmB;EACnB,gBjDskDsC,EAAA;EiDllDxC;IAeI,uBAAuB;IACvB,cAAc;IACd,WjDskDqC;IiDrkDrC,WjDskDoC;IiDrkDpC,UAAU;IACV,iBjDskDoC;IiDrkDpC,gBjDqkDoC;IiDpkDpC,mBAAmB;IACnB,eAAe;IACf,wDAA6F;IAC7F,4BAA4B;IAC5B,SAAS;IAET,kCAAiE;IACjE,qCAAoE;IACpE,YjD6jDmC;IkB9tDjC,6BlBiuD+C,EAAA;IkB7tD/C;M+B+HN;Q/B9HQ,gBAAgB,EAAA,E+B8JrB;EAhCH;IAmCI,UjD0jDkC,EAAA;;AiDjjDtC;EACE,kBAAkB;EAClB,UAA4C;EAC5C,ejDojD0C;EiDnjD1C,SAA2C;EAC3C,oBjDijD0C;EiDhjD1C,uBjDgjD0C;EiD/iD1C,uCAAsE;EACtE,kBAAkB,EAAA;;AAWpB;EALE,uCAAuE;EACvE,iCAA2D;EAC3D,2DAAuE,EAAA;;ApD/MzE;;EoDwNE,uCAAuE;EACvE,iCAA2D;EAC3D,mCAAuE,EAAA;;A3D23/BzE;E2Dx4/BE,uCAAuE;EACvE,iCAA2D;EAC3D,2DAAuE,EAAA;;AE3MzE;;EAEE,qBAAqB;EACrB,cAAc;EACd,8BAAoD;EACpD,gCAAuD;EACvD,gDAA+E;EAE/E,kBAAkB;EAClB,6FAA4J,EAAA;;AAI9J;EACE;IAAK,0CAA+C,EAAA,EAAA;;AAItD;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,iCAAuD;EACvD,mCAA6D;EAC7D,2CAA2D;EAG3D,yDAAsF;EACtF,+BAA+B,EAAA;;AAGjC;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,gCAAuD,EAAA;;AASzD;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAKnB;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,mCAA6D;EAC7D,yCAA2D;EAG3D,8BAA8B;EAC9B,UAAU,EAAA;;AAGZ;EACE,wBAAyC;EACzC,yBAA2C,EAAA;;AAI3C;EACE;;IAEE,kCAA6D,EAAA,EAC9D;;ACjFL;EAEE,2BAA+C;EAC/C,2BAA6C;EAC7C,2BAA+C;EAC/C,8BAAqD;EACrD,8BAAqD;EACrD,0CAA6C;EAC7C,uBAAuC;EACvC,gCAA2D;EAC3D,oCAA2D;EAC3D,wDAAuD;EACvD,qDAAuD;EACvD,qCAAqE,EAAA;;A3C6DnE;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A3CpCL;E2C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IlC5BV,0CkC8B+E,EAAA,EAqElF;ElC/FG;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;;A3CvCC;I2C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A3C7BH;E2C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;AAhFP;EAEI,eAAe;EACf,SAAS;EACT,mCAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gCAAwD;EACxD,kBAAkB;EAClB,wCAA6D;EAC7D,4BAA4B;EAC5B,UAAU;ElC5BV,0CkC8B+E,EAAA;ElC1B/E;IkCYJ;MlCXM,gBAAgB,EAAA,EkC8FrB;EAnFD;IAiBM,MAAM;IACN,OAAO;IACP,gCAAwD;IACxD,qFAAmJ;IACnJ,4BAA4B,EAAA;EArBlC;IAyBM,MAAM;IACN,QAAQ;IACR,gCAAwD;IACxD,oFAAkJ;IAClJ,2BAA2B,EAAA;EA7BjC;IAiCM,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,sFAAoJ;IACpJ,4BAA4B,EAAA;EAvClC;IA2CM,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,mFAAiJ;IACjJ,2BAA2B,EAAA;EAhDjC;IAqDM,eAAe,EAAA;EArDrB;IA2DM,mBAAmB,EAAA;;AA2B3B;EPpHE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a7C+vCsC;E6C9vCtC,YAAY;EACZ,aAAa;EACb,sB7C0Ka,EAAA;E6CvKb;IAAS,UAAU,EAAA;EACnB;IAAS,Y7CylD2B,EAAA;;AoD3+CtC;EACE,aAAa;EACb,mBAAmB;EACnB,oEAA4H,EAAA;EAH9H;IAMI,0FAAkJ;IAElJ,qDAAiF;IACjF,uDAAmF;IACnF,wDAAoF;IACpF,iBAAiB,EAAA;;AAIrB;EACE,gBAAgB;EAChB,kDAAsF,EAAA;;AAGxF;EACE,YAAY;EACZ,oEAA4H;EAC5H,gBAAgB,EAAA;;ACjJlB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YrD66CoC,EAAA;EqDn7CtC;IASI,qBAAqB;IACrB,WAAW,EAAA;;AAKf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAInB;EAEI,mDAAmD,EAAA;;AAIvD;EACE;IACE,YrDg5CkC,EAAA,EAAA;;AqD54CtC;EACE,+EAA8G;EAC9G,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE;IACE,uBAAuB,EAAA,EAAA;;AH9CzB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AIHb;EACE,sBAAwE;EACxE,iFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,wFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,mFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,iFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,8EAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,iFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,gFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,8EAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,+EAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,8EAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,2FAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,2FAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,qFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,uFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,wFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,yFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,yFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,yFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,sFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,wFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,wFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,wFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,wFAAmJ,EAAA;;ACFrJ;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,+EAA4I;EAC5I,yGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,0EAA4I;EAC5I,oGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,uEAA4I;EAC5I,iGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,sEAA4I;EAC5I,gGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,kFAA4I;EAC5I,4GAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,kFAA4I;EAC5I,4GAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,4DAA+H;IAC/H,sFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,4EAA4I;EAC5I,sGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,8EAA4I;EAC5I,wGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,+EAA4I;EAC5I,yGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,gFAA4I;EAC5I,0GAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,gFAA4I;EAC5I,0GAAgL,EAAA;EAFlL;IAQM,4DAA+H;IAC/H,sFAAgK,EAAA;;AATtK;EACE,gFAA4I;EAC5I,0GAAgL,EAAA;EAFlL;IAQM,2DAA+H;IAC/H,qFAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,2DAA+H;IAC/H,qFAAgK,EAAA;;AATtK;EACE,6EAA4I;EAC5I,uGAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AATtK;EACE,+EAA4I;EAC5I,yGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,+EAA4I;EAC5I,yGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,+EAA4I;EAC5I,yGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,+EAA4I;EAC5I,yGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AAOxK;EACE,+EAA+J;EAC/J,yGAAmM,EAAA;EAFrM;IAOM,kFAAiK;IACjK,4GAAqM,EAAA;;AC1B3M;EACE,UAAU;EAEV,kJAAsQ,EAAA;;ACHxQ;EACE,oBAAoB;EACpB,axD6cmC;EwD5cnC,mBAAmB;EACnB,kFAA6H;EAC7H,6BxD2ciC;EwD1cjC,2BAA2B,EAAA;EAN7B;IASI,cAAc;IACd,UxDuc6B;IwDtc7B,WxDsc6B;IwDrc7B,kBAAkB;IvCIhB,sCjBkciD,EAAA;IiB9bjD;MuCpBN;QvCqBQ,gBAAgB,EAAA,EuCPrB;;AAGH;EAIM,mEAA+F,EAAA;;ACnBrG;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,cAAc;IACd,mCAAwD;IACxD,WAAW,EAAA;EAPf;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAA;;AAKd;EACE,uBAAuC,EAAA;;AADzC;EACE,qCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;ACrB3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a3D4vCsC,EAAA;;A2DzvCxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a3DovCsC,EAAA;;A2D5uCpC;EACE,gBAAgB;EAChB,MAAM;EACN,a3DwuCkC,EAAA;;A2DruCpC;EACE,gBAAgB;EAChB,SAAS;EACT,a3DkuCkC,EAAA;;ASnsCpC;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DwuCkC,EAAA;E2DruCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3DkuCkC,EAAA,E2DjuCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DwuCkC,EAAA;E2DruCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3DkuCkC,EAAA,E2DjuCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DwuCkC,EAAA;E2DruCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3DkuCkC,EAAA,E2DjuCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DwuCkC,EAAA;E2DruCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3DkuCkC,EAAA,E2DjuCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DwuCkC,EAAA;E2DruCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3DkuCkC,EAAA,E2DjuCnC;;AChCL;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB,EAAA;;ACRrB;;ECIE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;EAGpB;;IACE,6BAA6B,EAAA;EAI/B;;IACE,2BAA2B,EAAA;;ACpB/B;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,U/D0oBuC;E+DzoBvC,WAAW,EAAA;;ACRf;ECAE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ACNrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6BjEisBuE;EiEhsBvE,eAAe;EACf,8BAA8B;EAC9B,YlE22B8B,EAAA;;AmE/yBxB;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAjBnE;EACE,gFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,uFAAoC,EAAA;;AADtC;EACE,kFAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,+EAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AADtC;EACE,8EAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AADtC;EACE,0FAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,0FAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,oFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,sFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,uFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,wFAAoC,EAAA;;AADtC;EACE,wFAAoC,EAAA;;AADtC;EACE,wFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,uFAAoC,EAAA;;AADtC;EACE,uFAAoC,EAAA;;AADtC;EACE,uFAAoC,EAAA;;AADtC;EACE,uFAAoC,EAAA;;AAStC;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,kBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,uFAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,2FAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,6FAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,8FAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4FAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,wFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,wFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,sFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,sFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,sFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,0DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAjBnE;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AAStC;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,uCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,0BAA+D;EAA/D,yBAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,wBAA+D;EAA/D,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,0BAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,yBAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,0CAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AArBnE,qBAAA;AAcA;EAOI,gCAA+D;EAA/D,iCAA+D,EAAA;;AAmBnE,mBAAA;AA1BA;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,uEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,+EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,+EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,wEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oCAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAjBnE;EACE,uBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AAStC;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,mDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAjBnE;EACE,sBAAoC,EAAA;;AAIpC;EACE,sBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,sBAAoC,EAAA;;AAIpC;EACE,sBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,oBAAoC,EAAA;;AAIpC;EACE,oBAAoC,EAAA;;AAIxC;EAOI,yCAA+D,EAAA;;AAKjE;EAOI,yCAA+D,EAAA;;AAnBrE;EAOI,wCAA+D,EAAA;;AAKjE;EAOI,wCAA+D,EAAA;;AAnBrE;EAOI,yCAA+D,EAAA;;AAKjE;EAOI,yCAA+D,EAAA;;AAnBrE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,sGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,iGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,8FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,6FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,yGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,yGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,mGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,sGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,uGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,uGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,uGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,oGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,sGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,sGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,sGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,sGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAjBnE;EACE,8BAAoC,EAAA;;AAIpC;EACE,8BAAoC,EAAA;;AANxC;EACE,gCAAoC,EAAA;;AAIpC;EACE,gCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,gCAAoC,EAAA;;AAIpC;EACE,gCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,8BAAoC,EAAA;;AAIpC;EACE,8BAAoC,EAAA;;AAIxC;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,oFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,sFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,sFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,sFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,qFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wCAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAjBnE;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,kBAAoC,EAAA;;AAStC;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,0DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,mCAA+D;UAA/D,2BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,oCAA+D;EAA/D,qCAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,+DAA+D,EAAA;;AAPnE;EAOI,sCAA+D;EAA/D,uCAA+D,EAAA;;AAPnE;EAOI,+DAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,qCAA+D;EAA/D,wCAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,+DAA+D;EAA/D,kEAA+D,EAAA;;AAPnE;EAOI,uCAA+D;EAA/D,0CAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,mEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,wCAA+D;EAA/D,uCAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,kEAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,0CAA+D;EAA/D,yCAA+D,EAAA;;AAPnE;EAOI,mEAA+D;EAA/D,kEAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,uCAA+D;EAA/D,oCAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,yCAA+D;EAA/D,sCAA+D,EAAA;;AAPnE;EAOI,kEAA+D;EAA/D,+DAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;A1DVvE;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;ACxDT;ED+CQ;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA,EAElE;;ACrCT;ED4BQ;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA,EAElE;;AE3ET;;e/E+osCe;A+E3osCf;EACI,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB,EAAA;;AAG3B;;;;;;EAYI,crE0Jc;EqEzJd,oCrEsIgD,EAAA;;ADsFpD;EsExNI,gCAAgC,EAAA;;AtEmWpC;EsE/VI,gBAAgB;EAChB,qBAAqB,EAAA;;AlEuDzB;EkEjDI,kBAAkB;EAClB,8BrEoIc,EAAA;;AqEjIlB;EACI,cAAc;EACd,+BrE+Hc;EqE9Hd,iBAAiB,EAAA;;A3DlCnB;E2DyCM,kBAAkB,EAAA;;AC7CtB;EACI,oDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,kDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;ACHzD;EAIM,WvE+JS,EAAA;;AuE1Ib;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEVoB;EuEWpB,yCvEXoB,EAAA;EuEclB;IAEE,cvEhBgB;IuEiBhB,qBAAqB;IACrB,wCvElBgB,EAAA;;AuEwBpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEQmB;EuEPnB,yCvEOmB,EAAA;EuEJjB;IAEE,cvEEe;IuEDf,qBAAqB;IACrB,wCvEAe,EAAA;;AuEMnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEgCsB;EuE/BtB,2CvE+BsB,EAAA;EuE5BpB;IAEE,cvE0BkB;IuEzBlB,qBAAqB;IACrB,0CvEwBkB,EAAA;;AuElBtB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE8JgB;EuE7JhB,2CvE6JgB,EAAA;EuE1Jd;IAEE,cvEwJY;IuEvJZ,qBAAqB;IACrB,0CvEsJY,EAAA;;AuEhJhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE4Le;EuE3Lf,yCvE2Le,EAAA;EuExLb;IAEE,cvEsLW;IuErLX,qBAAqB;IACrB,wCvEoLW,EAAA;;AuE9Kf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEuNqB;EuEtNrB,2CvEsNqB,EAAA;EuEnNnB;IAEE,cvEiNiB;IuEhNjB,qBAAqB;IACrB,0CvE+MiB,EAAA;;AuEzMrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE2Le;EuE1Lf,0CvE0Le,EAAA;EuEvLb;IAEE,cvEqLW;IuEpLX,qBAAqB;IACrB,yCvEmLW,EAAA;;AuE7Kf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEyLe;EuExLf,yCvEwLe,EAAA;EuErLb;IAEE,cvEmLW;IuElLX,qBAAqB;IACrB,wCvEiLW,EAAA;;AuE3Kf;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEwLe;EuEvLf,0CvEuLe,EAAA;EuEpLb;IAEE,cvEkLW;IuEjLX,qBAAqB;IACrB,yCvEgLW,EAAA;;AuE/JjB;EANQ,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE0JgB;EuEzJhB,2CvEyJgB,EAAA;EuEtJd;IAEE,cvEoJY;IuEnJZ,qBAAqB;IACrB,0CvEkJY,EAAA;;AuE5IhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEgKgB;EuE/JhB,wCvE+JgB,EAAA;EuE5Jd;IAEE,cvE0JY;IuEzJZ,qBAAqB;IACrB,uCvEwJY,EAAA;;AuElJhB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEkCyB;EuEjCzB,wCvEiCyB,EAAA;EuE9BvB;IAEE,cvE4BqB;IuE3BrB,qBAAqB;IACrB,uCvE0BqB,EAAA;;AuEpBzB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE6BqB;EuE5BrB,2CvE4BqB,EAAA;EuEzBnB;IAEE,cvEuBiB;IuEtBjB,qBAAqB;IACrB,0CvEqBiB,EAAA;;AuEfrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE2BqB;EuE1BrB,2CvE0BqB,EAAA;EuEvBnB;IAEE,cvEqBiB;IuEpBjB,qBAAqB;IACrB,0CvEmBiB,EAAA;;AuEbrB;EAKM,sCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE4BqB;EuE3BrB,2CvE2BqB,EAAA;EuExBnB;IAEE,cvEsBiB;IuErBjB,qBAAqB;IACrB,0CvEoBiB,EAAA;;AuEdrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE8BqB;EuE7BrB,2CvE6BqB,EAAA;EuE1BnB;IAEE,cvEwBiB;IuEvBjB,qBAAqB;IACrB,0CvEsBiB,EAAA;;AuEhBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvENqB;EuEOrB,yCvEPqB,EAAA;EuEUnB;IAEE,cvEZiB;IuEajB,qBAAqB;IACrB,wCvEdiB,EAAA;;AuEoBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvETqB;EuEUrB,0CvEVqB,EAAA;EuEanB;IAEE,cvEfiB;IuEgBjB,qBAAqB;IACrB,yCvEjBiB,EAAA;;AuEuBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvECqB;EuEArB,0CvEAqB,EAAA;EuEGnB;IAEE,cvELiB;IuEMjB,qBAAqB;IACrB,yCvEPiB,EAAA;;AuEarB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEJqB;EuEKrB,0CvELqB,EAAA;EuEQnB;IAEE,cvEViB;IuEWjB,qBAAqB;IACrB,yCvEZiB,EAAA;;AuEkBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEFqB;EuEGrB,2CvEHqB,EAAA;EuEMnB;IAEE,cvERiB;IuESjB,qBAAqB;IACrB,0CvEViB,EAAA;;AuEgBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEGqB;EuEFrB,2CvEEqB,EAAA;EuECnB;IAEE,cvEHiB;IuEIjB,qBAAqB;IACrB,0CvELiB,EAAA;;AuEWrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEIqB;EuEHrB,2CvEGqB,EAAA;EuEAnB;IAEE,cvEFiB;IuEGjB,qBAAqB;IACrB,0CvEJiB,EAAA;;AuEUrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEOmB;EuENnB,wCvEMmB,EAAA;EuEHjB;IAEE,cvECe;IuEAf,qBAAqB;IACrB,uCvEDe,EAAA;;AuEOnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEQmB;EuEPnB,yCvEOmB,EAAA;EuEJjB;IAEE,cvEEe;IuEDf,qBAAqB;IACrB,wCvEAe,EAAA;;AuEMnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvESyB;EuERzB,yCvEQyB,EAAA;EuELvB;IAEE,cvEGqB;IuEFrB,qBAAqB;IACrB,wCvECqB,EAAA;;AuEKzB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEUmB;EuETnB,yCvESmB,EAAA;EuENjB;IAEE,cvEIe;IuEHf,qBAAqB;IACrB,wCvEEe,EAAA;;AuEInB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEWmB;EuEVnB,0CvEUmB,EAAA;EuEPjB;IAEE,cvEKe;IuEJf,qBAAqB;IACrB,yCvEGe,EAAA;;AuEGnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEYmB;EuEXnB,2CvEWmB,EAAA;EuERjB;IAEE,cvEMe;IuELf,qBAAqB;IACrB,0CvEIe,EAAA;;AuEEnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEamB;EuEZnB,wCvEYmB,EAAA;EuETjB;IAEE,cvEOe;IuENf,qBAAqB;IACrB,uCvEKe,EAAA;;AuECnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEcmB;EuEbnB,yCvEamB,EAAA;EuEVjB;IAEE,cvEQe;IuEPf,qBAAqB;IACrB,wCvEMe,EAAA;;AuEAnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEemB;EuEdnB,0CvEcmB,EAAA;EuEXjB;IAEE,cvESe;IuERf,qBAAqB;IACrB,yCvEOe,EAAA;;AuEDnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEgBmB;EuEfnB,2CvEemB,EAAA;EuEZjB;IAEE,cvEUe;IuETf,qBAAqB;IACrB,0CvEQe,EAAA;;AuEFnB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEiBoB;EuEhBpB,2CvEgBoB,EAAA;EuEblB;IAEE,cvEWgB;IuEVhB,qBAAqB;IACrB,0CvESgB,EAAA;;AuEHpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEkBoB;EuEjBpB,2CvEiBoB,EAAA;EuEdlB;IAEE,cvEYgB;IuEXhB,qBAAqB;IACrB,0CvEUgB,EAAA;;AuEJpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEmBqB;EuElBrB,2CvEkBqB,EAAA;EuEfnB;IAEE,cvEaiB;IuEZjB,qBAAqB;IACrB,0CvEWiB,EAAA;;AuELrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEoBqB;EuEnBrB,2CvEmBqB,EAAA;EuEhBnB;IAEE,cvEciB;IuEbjB,qBAAqB;IACrB,0CvEYiB,EAAA;;AuENrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEqBqB;EuEpBrB,2CvEoBqB,EAAA;EuEjBnB;IAEE,cvEeiB;IuEdjB,qBAAqB;IACrB,0CvEaiB,EAAA;;AuEPrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEqCqB;EuEpCrB,2CvEoCqB,EAAA;EuEjCnB;IAEE,cvE+BiB;IuE9BjB,qBAAqB;IACrB,0CvE6BiB,EAAA;;AuEvBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEsCqB;EuErCrB,2CvEqCqB,EAAA;EuElCnB;IAEE,cvEgCiB;IuE/BjB,qBAAqB;IACrB,0CvE8BiB,EAAA;;AuExBrB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEuCoB;EuEtCpB,2CvEsCoB,EAAA;EuEnClB;IAEE,cvEiCgB;IuEhChB,qBAAqB;IACrB,0CvE+BgB,EAAA;;AuEzBpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEwCoB;EuEvCpB,2CvEuCoB,EAAA;EuEpClB;IAEE,cvEkCgB;IuEjChB,qBAAqB;IACrB,0CvEgCgB,EAAA;;AuE1BpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEyCsB;EuExCtB,2CvEwCsB,EAAA;EuErCpB;IAEE,cvEmCkB;IuElClB,qBAAqB;IACrB,0CvEiCkB,EAAA;;AuE3BtB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE0CoB;EuEzCpB,2CvEyCoB,EAAA;EuEtClB;IAEE,cvEoCgB;IuEnChB,qBAAqB;IACrB,0CvEkCgB,EAAA;;AuE5BpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE2CoB;EuE1CpB,2CvE0CoB,EAAA;EuEvClB;IAEE,cvEqCgB;IuEpChB,qBAAqB;IACrB,0CvEmCgB,EAAA;;AuE7BpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE4CoB;EuE3CpB,wCvE2CoB,EAAA;EuExClB;IAEE,cvEsCgB;IuErChB,qBAAqB;IACrB,uCvEoCgB,EAAA;;AuE9BpB;EAKM,2DAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,gBvE6CsB;EuE5CtB,2CvE4CsB,EAAA;EuEzCpB;IAEE,gBvEuCkB;IuEtClB,qBAAqB;IACrB,0CvEqCkB,EAAA;;AuE/BtB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEoDuB;EuEnDvB,yCvEmDuB,EAAA;EuEhDrB;IAEE,cvE8CmB;IuE7CnB,qBAAqB;IACrB,wCvE4CmB,EAAA;;AuEtCvB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEqDuB;EuEpDvB,uCvEoDuB,EAAA;EuEjDrB;IAEE,cvE+CmB;IuE9CnB,qBAAqB;IACrB,sCvE6CmB,EAAA;;AuEvCvB;EAKM,wDAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,gBvEsDyB;EuErDzB,yCvEqDyB,EAAA;EuElDvB;IAEE,gBvEgDqB;IuE/CrB,qBAAqB;IACrB,wCvE8CqB,EAAA;;AuExCzB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEuDoB;EuEtDpB,yCvEsDoB,EAAA;EuEnDlB;IAEE,cvEiDgB;IuEhDhB,qBAAqB;IACrB,wCvE+CgB,EAAA;;AuEzCpB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvEwDoB;EuEvDpB,wCvEuDoB,EAAA;EuEpDlB;IAEE,cvEkDgB;IuEjDhB,qBAAqB;IACrB,uCvEgDgB,EAAA;;AuE1CpB;EAKM,wDAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,gBvEyDsB;EuExDtB,yCvEwDsB,EAAA;EuErDpB;IAEE,gBvEmDkB;IuElDlB,qBAAqB;IACrB,wCvEiDkB,EAAA;;AuE3CtB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE0DsB;EuEzDtB,0CvEyDsB,EAAA;EuEtDpB;IAEE,cvEoDkB;IuEnDlB,qBAAqB;IACrB,yCvEkDkB,EAAA;;AuE5CtB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE2DsB;EuE1DtB,0CvE0DsB,EAAA;EuEvDpB;IAEE,cvEqDkB;IuEpDlB,qBAAqB;IACrB,yCvEmDkB,EAAA;;AuE7CtB;EAKM,yDAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,gBvE4DwB;EuE3DxB,0CvE2DwB,EAAA;EuExDtB;IAEE,gBvEsDoB;IuErDpB,qBAAqB;IACrB,yCvEoDoB,EAAA;;AuE9CxB;EAKM,oCAA+C,EAAA;;AAMvD;EAEI,cvEoIc,EAAA;EuEtIlB;IAOQ,cvE+HU,EAAA;;AuEzHhB;EAtCA,cvE6DsB;EuE5DtB,yCvE4DsB,EAAA;EuEzDpB;IAEE,cvEuDkB;IuEtDlB,qBAAqB;IACrB,wCvEqDkB,EAAA;;AuEjBxB;EACE,YAAY,EAAA;;AJKN;EIDL,mBAAmB;EAClB,kBAAkB,EAAA;;AAKtB;EACE,cvEkGgB,EAAA;;AuE/FlB;EAEI,uBAAuB;EACvB,oCAAyC,EAAA;EAH7C;IAKM,uBAAuB,EAAA;;AC5E7B;;EAEE,wBAAwB,EAAA;;A9C6HxB;E8CzHA,yBAAoC,EAAA;;AAItC;EACE,mBAAmB,EAAA;;AAGrB;;EAEE,yBAA2B,EAAA;;A9CyI3B;E8CrIA,cxEyJgB,EAAA;;AwEpIhB;EAbA,cxE1BoB;EwE2BpB,wCxE3BoB;EwE4BpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxElCkB,EAAA;;AwEuCpB;EAbA,cxERmB;EwESnB,wCxETmB;EwEUnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEhBiB,EAAA;;AwEqBnB;EAbA,cxEgBsB;EwEftB,0CxEesB;EwEdtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEQoB,EAAA;;AwEHtB;EAbA,cxE8IgB;EwE7IhB,0CxE6IgB;EwE5IhB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEsIc,EAAA;;AwEjIhB;EAbA,cxE4Ke;EwE3Kf,wCxE2Ke;EwE1Kf,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEoKa,EAAA;;AwE/Jf;EAbA,cxEuMqB;EwEtMrB,0CxEsMqB;EwErMrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE+LmB,EAAA;;AwE1LrB;EAbA,cxE2Ke;EwE1Kf,yCxE0Ke;EwEzKf,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEmKa,EAAA;;AwE9Jf;EAbA,cxEyKe;EwExKf,wCxEwKe;EwEvKf,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEiKa,EAAA;;AwE5Jf;EAbA,cxEwKe;EwEvKf,yCxEuKe;EwEtKf,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEgKa,EAAA;;AwE3Jf;EAbA,cxE0IgB;EwEzIhB,0CxEyIgB;EwExIhB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEkIc,EAAA;;AwE7HhB;EAbA,cxEgJgB;EwE/IhB,uCxE+IgB;EwE9IhB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEwIc,EAAA;;AwEnIhB;EAbA,cxEkByB;EwEjBzB,uCxEiByB;EwEhBzB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEUuB,EAAA;;AwELzB;EAbA,cxEaqB;EwEZrB,0CxEYqB;EwEXrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEKmB,EAAA;;AwEArB;EAbA,cxEWqB;EwEVrB,0CxEUqB;EwETrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEGmB,EAAA;;AwEErB;EAbA,cxEYqB;EwEXrB,0CxEWqB;EwEVrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEImB,EAAA;;AwECrB;EAbA,cxEcqB;EwEbrB,0CxEaqB;EwEZrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEMmB,EAAA;;AwEDrB;EAbA,cxEtBqB;EwEuBrB,wCxEvBqB;EwEwBrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE9BmB,EAAA;;AwEmCrB;EAbA,cxEzBqB;EwE0BrB,yCxE1BqB;EwE2BrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEjCmB,EAAA;;AwEsCrB;EAbA,cxEfqB;EwEgBrB,yCxEhBqB;EwEiBrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEvBmB,EAAA;;AwE4BrB;EAbA,cxEpBqB;EwEqBrB,yCxErBqB;EwEsBrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE5BmB,EAAA;;AwEiCrB;EAbA,cxElBqB;EwEmBrB,0CxEnBqB;EwEoBrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE1BmB,EAAA;;AwE+BrB;EAbA,cxEbqB;EwEcrB,0CxEdqB;EwEerB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxErBmB,EAAA;;AwE0BrB;EAbA,cxEZqB;EwEarB,0CxEbqB;EwEcrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEpBmB,EAAA;;AwEyBrB;EAbA,cxETmB;EwEUnB,uCxEVmB;EwEWnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEjBiB,EAAA;;AwEsBnB;EAbA,cxERmB;EwESnB,wCxETmB;EwEUnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEhBiB,EAAA;;AwEqBnB;EAbA,cxEPyB;EwEQzB,wCxERyB;EwESzB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEfuB,EAAA;;AwEoBzB;EAbA,cxENmB;EwEOnB,wCxEPmB;EwEQnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEdiB,EAAA;;AwEmBnB;EAbA,cxELmB;EwEMnB,yCxENmB;EwEOnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEbiB,EAAA;;AwEkBnB;EAbA,cxEJmB;EwEKnB,0CxELmB;EwEMnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEZiB,EAAA;;AwEiBnB;EAbA,cxEHmB;EwEInB,uCxEJmB;EwEKnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEXiB,EAAA;;AwEgBnB;EAbA,cxEFmB;EwEGnB,wCxEHmB;EwEInB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEViB,EAAA;;AwEenB;EAbA,cxEDmB;EwEEnB,yCxEFmB;EwEGnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxETiB,EAAA;;AwEcnB;EAbA,cxEAmB;EwECnB,0CxEDmB;EwEEnB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxERiB,EAAA;;AwEanB;EAbA,cxECoB;EwEApB,0CxEAoB;EwECpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEPkB,EAAA;;AwEYpB;EAbA,cxEEoB;EwEDpB,0CxECoB;EwEApB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxENkB,EAAA;;AwEWpB;EAbA,cxEGqB;EwEFrB,0CxEEqB;EwEDrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxELmB,EAAA;;AwEUrB;EAbA,cxEIqB;EwEHrB,0CxEGqB;EwEFrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEJmB,EAAA;;AwESrB;EAbA,cxEKqB;EwEJrB,0CxEIqB;EwEHrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEHmB,EAAA;;AwEQrB;EAbA,cxEqBqB;EwEpBrB,0CxEoBqB;EwEnBrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEamB,EAAA;;AwERrB;EAbA,cxEsBqB;EwErBrB,0CxEqBqB;EwEpBrB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEcmB,EAAA;;AwETrB;EAbA,cxEuBoB;EwEtBpB,0CxEsBoB;EwErBpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEekB,EAAA;;AwEVpB;EAbA,cxEwBoB;EwEvBpB,0CxEuBoB;EwEtBpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEgBkB,EAAA;;AwEXpB;EAbA,cxEyBsB;EwExBtB,0CxEwBsB;EwEvBtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEiBoB,EAAA;;AwEZtB;EAbA,cxE0BoB;EwEzBpB,0CxEyBoB;EwExBpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEkBkB,EAAA;;AwEbpB;EAbA,cxE2BoB;EwE1BpB,0CxE0BoB;EwEzBpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEmBkB,EAAA;;AwEdpB;EAbA,cxE4BoB;EwE3BpB,uCxE2BoB;EwE1BpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEoBkB,EAAA;;AwEfpB;EAbA,gBxE6BsB;EwE5BtB,0CxE4BsB;EwE3BtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,2BxEqBoB,EAAA;;AwEhBtB;EAbA,cxEoCuB;EwEnCvB,wCxEmCuB;EwElCvB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE4BqB,EAAA;;AwEvBvB;EAbA,cxEqCuB;EwEpCvB,sCxEoCuB;EwEnCvB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE6BqB,EAAA;;AwExBvB;EAbA,gBxEsCyB;EwErCzB,wCxEqCyB;EwEpCzB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,2BxE8BuB,EAAA;;AwEzBzB;EAbA,cxEuCoB;EwEtCpB,wCxEsCoB;EwErCpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxE+BkB,EAAA;;AwE1BpB;EAbA,cxEwCoB;EwEvCpB,uCxEuCoB;EwEtCpB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEgCkB,EAAA;;AwE3BpB;EAbA,gBxEyCsB;EwExCtB,wCxEwCsB;EwEvCtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,2BxEiCoB,EAAA;;AwE5BtB;EAbA,cxE0CsB;EwEzCtB,yCxEyCsB;EwExCtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEkCoB,EAAA;;AwE7BtB;EAbA,cxE2CsB;EwE1CtB,yCxE0CsB;EwEzCtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEmCoB,EAAA;;AwE9BtB;EAbA,gBxE4CwB;EwE3CxB,yCxE2CwB;EwE1CxB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,2BxEoCsB,EAAA;;AwE/BxB;EAbA,cxE6CsB;EwE5CtB,wCxE4CsB;EwE3CtB,yBAAyB,EAAA;EAEzB;IAGE,WxEiIW;IwEhIX,yBxEqCoB,EAAA;;AwE3BxB;EAEI,gBAAgB,EAAA;;AAIpB;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe,EAAA;EALjB;IAQI,yBAAyB;IACzB,cAAc,EAAA;EATlB;IAcI,gBAAgB;IAChB,aAAa,EAAA;;AAIjB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAA;EAHb;IAMI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW,EAAA;EARf;IAaI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB,EAAA;EAfpB;IAmBI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,mBAAmB,EAAA;;AAIvB;;EAEE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB,EAAA;EANzB;;IAQI,oCAA+C,EAAA;;AAInD;EACE,yBxExDoB;EwEyDpB,6BAA6B;EAC7B,cxE5FmB,EAAA;EwEyFrB;IAMI,yBxE/FiB;IwEgGjB,WAAW,EAAA;EAPf;IAaM,wCAAwC;IACxC,yBAAkC,EAAA;;AAKxC;EACE,yBxE7GmB;EwE8GnB,qBxE9GmB;EwE+GnB,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B,EAAA;EAN9B;IAQI,oCAA2C;IAC3C,gCAAuC;IACvC,WAAW,EAAA;;AAIf;EACE,6BAA6B;EAC7B,YAAY;EACZ,cxE9HmB;EwE+HnB,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B,EAAA;EAN9B;IAQI,6BAA6B;IAC7B,YAAY;IACZ,cxExFqB,EAAA;;AwE4FzB;EACE,4BAA4B,EAAA;;AAG9B;EAGE,uBAAuB;EACvB,cAAc,EAAA;EAJhB;IAOI,yBAAyB,EAAA;;AAI7B;EAGE,mBAAmB;EACnB,cAAc,EAAA;EAJhB;IAOI,8BAA8B;IAC9B,cAAc,EAAA;EARlB;IAYI,YAAY,EAAA;;ACzLhB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB,EAAA;;AAIrB;EACQ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,czESa,EAAA;;AyENrB;EACQ,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,2CAA2C;EAC3C,wBAAwB,EAAA;;AAIhC;EACQ,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,2CAA2C,EAAA;;AAOnD;EACI,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EAEF,eAAe;EACvB,cAAc;EACd,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAER,sBAAsB;EAE1B,0BAA0B;EAEtB,0CAAuC,EAAA;;AAE/C;;EAEA,UAAU;EACV,iBAAiB;EACjB,mBAAmB,EAAA;;AAEnB;EACA,qBAAqB;EACrB,cAAc,EAAA;;AAEd;EAEQ,4DAA4D,EAAA;;AAEpE;EACA,cAAc;EACd,kBAAkB;EAClB,QAAQ,EAAA;;AAER;EACA,kBAAkB;EAClB,qBAAqB,EAAA;;AAErB;EACA,YAAY;EACZ,cAAc,EAAA;;AAEd;EAEQ,2BAA2B,EAAA;;AAEnC;EAEQ,6CAA6C,EAAA;;AAErD;;EAEA,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B,EAAA;;AAE5B;EACA,cAAc,EAAA;;AAEd;EACA,YAAY;EACZ,2CAAwC,EAAA;;AAExC;EACA,gBAAgB,EAAA;;AALhB;EAQA,uCAAoC,EAAA;;AAEpC;EACA,YAAY,EAAA;;AAEZ;;EAEA,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,UAAU,EAAA;;AAEV;;;;EAIA,UAAU;EACV,WAAW,EAAA;;AAEX;;EAEA,SAAS;EACT,UAAU,EAAA;;AAEV;EACA,iBAAiB;EACjB,cAAc,EAAA;;AAEd;EACA,iBAAiB;EACjB,cAAc,EAAA;;AAEd;;EAEA,YAAY,EAAA;;AAEZ;EACA,0CAAuC,EAAA;;AAEvC;EACA,4BzE3IiB,EAAA;;AyE6IjB;;EAEA,SAAS,EAAA;;AAET;EACA,uCAAoC,EAAA;;AAEpC;EACA,yBzErJiB,EAAA;;AyEuJjB;EACA,UAAU,EAAA;;AAEV;EACA,kBAAkB;EAClB,qBAAqB,EAAA;;AAErB;EAIA,aAAa,EAAA;;AAEb;EACA,0BAA0B;EAC1B,mBzEtKiB;EyEuKjB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EAGjB,iBAAiB;EACzB,gBAAgB;EAIR,SAAO,EAAA;;AAEf;;EAEA,yBAAyB;EAGjB,iBAAiB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,UAAU,EAAA;;AAEV;;EAEA,aAAa,EAAA;;AAEb;;EAEA,kBAAkB,EAAA;;AAElB;;EAEA;2BnF+yvCuB;EmF7yvCvB;SnF+yvCK;EmF7yvCL,OAAO;EACP;yBnF+yvCqB;EmF7yvCrB;SnF+yvCK,EmF9yvCC;;AAEN;2BnF+yvCuB;AmF7yvCvB;yBnF+yvCqB;AmF7yvCrB;;EAEA;2BnF+yvCuB;EmF7yvCvB;SnF+yvCK;EmF7yvCL,QAAQ;EACR;yBnF+yvCqB;EmF7yvCrB;SnF+yvCK,EmF9yvCC;;AAEN;2BnF+yvCuB;AmF7yvCvB;yBnF+yvCqB;AmF7yvCrB;;EAEA,WAAW,EAAA;;AAEX;;EAEA,aAAa,EAAA;;AAEb;;EAEA,WAAW;EACX,YAAY,EAAA;;AAEZ;;EAGA,qBAAqB;EACrB,aAAa,EAAA;;AAEb;EACA,kBAAkB;EAClB,YAAY,EAAA;;AAEZ;;EAEA,qBAAqB,EAAA;;AAErB;EACA,WAAW,EAAA;;AAEX;EACA,aAAa,EAAA;;AAEb;;EAEA,SAAS;EACT,wBAAwB,EAAA;;AAExB;EACA,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,wCAAqC;EAE7B,sBAAsB,EAAA;;AAE9B;EACA,8BAA2B,EAAA;;AAE3B;EACA,8BAA2B,EAAA;;AAE3B;EACA,cAAc;EACd,WAAW;EACX,kBAAkB,EAAA;;AAElB;EACA,MAAM;EACN,gBAAgB,EAAA;;AAEhB;EACA,kCAAkC;EAClC,mCAAmC;EACnC,8CAA2C;EAC3C,QAAQ,EAAA;;AAER;EACA,QAAQ,EAAA;;AAER;EACA,kCAAkC;EAClC,mCAAmC;EACnC,2CAAwC;EACxC,QAAQ,EAAA;;AAER;EACA,cAAc;EACd,YAAY,EAAA;;AAEZ;EACA,8BAA2B,EAAA;;AAE3B;EACA,+BAA4B,EAAA;;AAE5B;EACA,UAAU,EAAA;;AAEV;EACA,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAEV,qCAAqC,EAAA;;AAE7C;EACA,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,UAAU,EAAA;;AAEV;EACA,+BAA4B,EAAA;;AAE5B;EACA,UAAU;EACV,YAAY;EACZ,qBAAqB,EAAA;;AAErB;EACA,yBAAyB,EAAA;;AAEzB;EACA,sBAAsB,EAAA;;AAEtB;EACA,uBAAuB;EAEf,sBAAsB;EAC9B,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EAGvB,qBAAqB,EAAA;;AAErB;EACA,UAAU,EAAA;;AAEV;;EAEA,eAAe;EACf,+BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB,EAAA;;AAEpB;EACA,oBAAoB;EACpB,mBzEpZiB;EyEqZjB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,WAAW,EAAA;;AAEX;;EAEA,aAAa,EAAA;;AAEb;EACA,+BAA4B,EAAA;;AAE5B;EACA,yBzEjbiB;EyEkbjB,aAAa;EACb,UAAU,EAAA;;AAEV;EACA,mBzEtbiB;EyEubjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EAIX,aAAa;EAIL,mBAAmB;EAC3B,YAAY,EAAA;;AAEZ;EAIA,aAAa;EAIL,SAAO,EAAA;;AAEf;EACA,eAAe;EACf,cAAc;EACd,mBzEjdiB;EyEkdjB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;EAIN,SAAO;EACf,mBAAmB,EAAA;;AAEnB;;EAEA,kBAAkB,EAAA;;AAElB;EACA,kBAAkB;EAClB,gBAAgB;EAIhB,aAAa;EAIL,uBAAuB;EAC/B,gBAAgB;EAChB,4CAAyC;EACzC,6CAA0C,EAAA;;AAE1C;EACA,UAAU,EAAA;;AAEV;EACA,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EAEZ,sBAAsB;EAC9B,qBAAqB;EAIrB,aAAa;EAEL,eAAe;EACvB,mBAAmB;EAGX,6BAA6B;EAE7B,qCAAqC;EAC7C,UAAU,EAAA;;AAEV;EAEQ,0CAAuC,EAAA;;AAE/C;EACA,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EAEZ,sBAAsB;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAGV,uBAAuB;EAC/B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAIV,uBAAuB;EAC/B,kBAAkB,EAAA;;AAElB;;;;;;;;;;;;EAYA,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,qBAAqB,EAAA;;AAErB;EACA,kBAAkB,EAAA;;AAElB;;EAEA,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAA;;AAEX;;;;;;;;;;;;;;;;;;EAkBA,mBzEtmBkB;EyEwmBV,gBAAgB;EACxB,WAAW;EACX,qBzE1mBkB,EAAA;;AyE4mBlB;;;EAGA,4BAA4B,EAAA;;AAE5B;;;EAGA,4BAA4B,EAAA;;AAE5B;;;EAIQ,6BzExmBS,EAAA;;AyE0mBjB;;;EAGA,mBAAmB,EAAA;;AAEnB;EACA,gBAAgB;EAER,6CAA6C,EAAA;;AAErD;;;;;;;EAOA,4BAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe,EAAA;;AAEf;;EAEA,mBAAmB;EACnB,4BAAyB,EAAA;;AAEzB;EACA,gBAAgB;EAER,6CzExoBS,EAAA;;AyE0oBjB;EACA,kBAAkB,EAAA;;AAElB;EACA,eAAe,EAAA;;AAEf;EACA,WAAW,EAAA;;AAEX;EACA,eAAe;EACf,4CAAyC,EAAA;;AAEzC;EACA,WAAW;EACX,WAAW;EACX,iBAAiB,EAAA;;AAEjB;;EAEA,cAAc;EACd,WAAW;EACX,eAAe;EACf,4BAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,YAAY,EAAA;;AAEZ;EACA,cAAc;EAId,aAAa;EAEL,sBAAsB;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,8CAA2C,EAAA;;AAE3C;EACA,qBAAqB;EACrB,UAAU;EAEF,sBAAsB,EAAA;;AAE9B;EACA,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAER,sBAAsB;EAC9B,gBAAgB;EAIhB,aAAa;EACb,gBAAgB;EAChB,0BAA0B,EAAA;;AAE1B;EACA,WAAW;EACX,cAAc;EACd,WAAW,EAAA;;AAEX;EAIQ,SAAO;EACf,UAAU;EACV,YAAY;EACZ,WAAW,EAAA;;AAEX;EACA,4BAA4B,EAAA;;AAE5B;EACA,yBAAyB,EAAA;;AAEzB;EACA,UAAU,EAAA;;AAEV;EACA,UAAU,EAAA;;AAEV;EACA,uBAAuB;EAEf,gBAAgB;EACxB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,kBAAkB;EAEV,sBAAsB;EAG9B,qBAAqB,EAAA;;AAErB;EACA,iBAAiB,EAAA;;AAEjB;;EAEA,gBAAgB,EAAA;;AAEhB;EACA,UAAU;EACV,SAAS,EAAA;;AAET;;EAEA,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EAGjB,iBAAiB;EAGjB,kBAAkB,EAAA;;AAE1B;EACA,UAAU;EACV,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB,EAAA;;AAEhB;;;;EAIA,mBAAmB,EAAA;;AAEnB;EACA,eAAe,EAAA;;AAcf;EACA;IACI,UAAU;IAEF,mCAAmC,EAAA;EAE/C;IACI,UAAU;IAEF,+BAA+B,EAAA,EAAA;;ACz0B/C;EAEQ,c1EuKU;E0EtKV,eAAe,EAAA;;AvCcvB;EuCXQ,iBAAiB,EAAA;EvCWzB;IuCTY,WAAW;IACX,qB1EgKM;I0E/JN,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,iCAAiC,EAAA;;AAK7C;EACI,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB,EAAA;EAJ3B;IAOQ,kC1E+uB2C;I0E9uB3C,gBAAgB,EAAA;EARxB;IAYQ,eAAe;IACf,c1EIc,EAAA;;AV6mxCtB;EoFxmxCY,qB1EgqD6B,EAAA;EV08tCvC;IoFvmxCU,oCAAoC;IACpC,eAAe;IACX,iBAAiB,EAAA;;AzCrDjC;E0CCE,mB3EosBgC;E2EnsBhC,4C3E4Ka,EAAA;;A2EzKf;EACE,eAAe;EACf,cAAc;EACd,cAAc,EAAA;;A1CgEhB;E0C5DE,eAAe;EACf,iBAAiB;EACjB,gB3EwxB+B,EAAA;;A2ErxBjC;EACE,c3EwJgB;E2EvJhB,mBAAmB,EAAA;;AAWnB;EALA,W3E2Ia;E2E1Ib,yB3ExBoB,EAAA;E2E4BpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3ENmB,EAAA;E2EUnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EkBsB,EAAA;E2EdtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EgJgB,EAAA;E2E5IhB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E8Ke,EAAA;E2E1Kf;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EyMqB,EAAA;E2ErMrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E6Ke,EAAA;E2EzKf;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E2Ke,EAAA;E2EvKf;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E0Ke,EAAA;E2EtKf;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E4IgB,EAAA;E2ExIhB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EkJgB,EAAA;E2E9IhB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EoByB,EAAA;E2EhBzB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EeqB,EAAA;E2EXrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EaqB,EAAA;E2ETrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EcqB,EAAA;E2EVrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EgBqB,EAAA;E2EZrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EpBqB,EAAA;E2EwBrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EvBqB,EAAA;E2E2BrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EbqB,EAAA;E2EiBrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3ElBqB,EAAA;E2EsBrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EhBqB,EAAA;E2EoBrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EXqB,EAAA;E2EerB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EVqB,EAAA;E2EcrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EPmB,EAAA;E2EWnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3ENmB,EAAA;E2EUnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3ELyB,EAAA;E2ESzB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EJmB,EAAA;E2EQnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EHmB,EAAA;E2EOnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EFmB,EAAA;E2EMnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EDmB,EAAA;E2EKnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EAmB,EAAA;E2EInB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3ECmB,EAAA;E2EGnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EEmB,EAAA;E2EEnB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EGoB,EAAA;E2ECpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EIoB,EAAA;E2EApB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EKqB,EAAA;E2EDrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EMqB,EAAA;E2EFrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EOqB,EAAA;E2EHrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EuBqB,EAAA;E2EnBrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EwBqB,EAAA;E2EpBrB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EyBoB,EAAA;E2ErBpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E0BoB,EAAA;E2EtBpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E2BsB,EAAA;E2EvBtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E4BoB,EAAA;E2ExBpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E6BoB,EAAA;E2EzBpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E8BoB,EAAA;E2E1BpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,2B3E+BsB,EAAA;E2E3BtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EsCuB,EAAA;E2ElCvB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EuCuB,EAAA;E2EnCvB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,2B3EwCyB,EAAA;E2EpCzB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3EyCoB,EAAA;E2ErCpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E0CoB,EAAA;E2EtCpB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,2B3E2CsB,EAAA;E2EvCtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E4CsB,EAAA;E2ExCtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E6CsB,EAAA;E2EzCtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,2B3E8CwB,EAAA;E2E1CxB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2EtIb;EALA,W3E2Ia;E2E1Ib,yB3E+CsB,EAAA;E2E3CtB;IAGI,0C3EmIS;I2ElIT,W3EkIS,EAAA;E2EtIb;IAOI,W3E+HS,EAAA;;A2E5Gb;EAbA,yB3EzCoB,EAAA;E2E2CpB;IACE,gC3E5CkB;I2E6ClB,uBAAuB,EAAA;EAEzB;IACE,6B3EhDkB;I2EiDlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EvBmB,EAAA;E2EyBnB;IACE,gC3E1BiB;I2E2BjB,uBAAuB,EAAA;EAEzB;IACE,6B3E9BiB;I2E+BjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ECsB,EAAA;E2ECtB;IACE,gC3EFoB;I2EGpB,uBAAuB,EAAA;EAEzB;IACE,6B3ENoB;I2EOpB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E+HgB,EAAA;E2E7HhB;IACE,gC3E4Hc;I2E3Hd,uBAAuB,EAAA;EAEzB;IACE,6B3EwHc;I2EvHd,uBAAuB,EAAA;;AAKzB;EAbA,yB3E6Je,EAAA;E2E3Jf;IACE,gC3E0Ja;I2EzJb,uBAAuB,EAAA;EAEzB;IACE,6B3EsJa;I2ErJb,uBAAuB,EAAA;;AAKzB;EAbA,yB3EwLqB,EAAA;E2EtLrB;IACE,gC3EqLmB;I2EpLnB,uBAAuB,EAAA;EAEzB;IACE,6B3EiLmB;I2EhLnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E4Je,EAAA;E2E1Jf;IACE,gC3EyJa;I2ExJb,uBAAuB,EAAA;EAEzB;IACE,6B3EqJa;I2EpJb,uBAAuB,EAAA;;AAKzB;EAbA,yB3E0Je,EAAA;E2ExJf;IACE,gC3EuJa;I2EtJb,uBAAuB,EAAA;EAEzB;IACE,6B3EmJa;I2ElJb,uBAAuB,EAAA;;AAKzB;EAbA,yB3EyJe,EAAA;E2EvJf;IACE,gC3EsJa;I2ErJb,uBAAuB,EAAA;EAEzB;IACE,6B3EkJa;I2EjJb,uBAAuB,EAAA;;AAKzB;EAbA,yB3E2HgB,EAAA;E2EzHhB;IACE,gC3EwHc;I2EvHd,uBAAuB,EAAA;EAEzB;IACE,6B3EoHc;I2EnHd,uBAAuB,EAAA;;AAKzB;EAbA,yB3EiIgB,EAAA;E2E/HhB;IACE,gC3E8Hc;I2E7Hd,uBAAuB,EAAA;EAEzB;IACE,6B3E0Hc;I2EzHd,uBAAuB,EAAA;;AAKzB;EAbA,yB3EGyB,EAAA;E2EDzB;IACE,gC3EAuB;I2ECvB,uBAAuB,EAAA;EAEzB;IACE,6B3EJuB;I2EKvB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EFqB,EAAA;E2EIrB;IACE,gC3ELmB;I2EMnB,uBAAuB,EAAA;EAEzB;IACE,6B3ETmB;I2EUnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EJqB,EAAA;E2EMrB;IACE,gC3EPmB;I2EQnB,uBAAuB,EAAA;EAEzB;IACE,6B3EXmB;I2EYnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EHqB,EAAA;E2EKrB;IACE,gC3ENmB;I2EOnB,uBAAuB,EAAA;EAEzB;IACE,6B3EVmB;I2EWnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EDqB,EAAA;E2EGrB;IACE,gC3EJmB;I2EKnB,uBAAuB,EAAA;EAEzB;IACE,6B3ERmB;I2ESnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ErCqB,EAAA;E2EuCrB;IACE,gC3ExCmB;I2EyCnB,uBAAuB,EAAA;EAEzB;IACE,6B3E5CmB;I2E6CnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ExCqB,EAAA;E2E0CrB;IACE,gC3E3CmB;I2E4CnB,uBAAuB,EAAA;EAEzB;IACE,6B3E/CmB;I2EgDnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E9BqB,EAAA;E2EgCrB;IACE,gC3EjCmB;I2EkCnB,uBAAuB,EAAA;EAEzB;IACE,6B3ErCmB;I2EsCnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EnCqB,EAAA;E2EqCrB;IACE,gC3EtCmB;I2EuCnB,uBAAuB,EAAA;EAEzB;IACE,6B3E1CmB;I2E2CnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EjCqB,EAAA;E2EmCrB;IACE,gC3EpCmB;I2EqCnB,uBAAuB,EAAA;EAEzB;IACE,6B3ExCmB;I2EyCnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E5BqB,EAAA;E2E8BrB;IACE,gC3E/BmB;I2EgCnB,uBAAuB,EAAA;EAEzB;IACE,6B3EnCmB;I2EoCnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E3BqB,EAAA;E2E6BrB;IACE,gC3E9BmB;I2E+BnB,uBAAuB,EAAA;EAEzB;IACE,6B3ElCmB;I2EmCnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ExBmB,EAAA;E2E0BnB;IACE,gC3E3BiB;I2E4BjB,uBAAuB,EAAA;EAEzB;IACE,6B3E/BiB;I2EgCjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EvBmB,EAAA;E2EyBnB;IACE,gC3E1BiB;I2E2BjB,uBAAuB,EAAA;EAEzB;IACE,6B3E9BiB;I2E+BjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EtByB,EAAA;E2EwBzB;IACE,gC3EzBuB;I2E0BvB,uBAAuB,EAAA;EAEzB;IACE,6B3E7BuB;I2E8BvB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ErBmB,EAAA;E2EuBnB;IACE,gC3ExBiB;I2EyBjB,uBAAuB,EAAA;EAEzB;IACE,6B3E5BiB;I2E6BjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EpBmB,EAAA;E2EsBnB;IACE,gC3EvBiB;I2EwBjB,uBAAuB,EAAA;EAEzB;IACE,6B3E3BiB;I2E4BjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EnBmB,EAAA;E2EqBnB;IACE,gC3EtBiB;I2EuBjB,uBAAuB,EAAA;EAEzB;IACE,6B3E1BiB;I2E2BjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ElBmB,EAAA;E2EoBnB;IACE,gC3ErBiB;I2EsBjB,uBAAuB,EAAA;EAEzB;IACE,6B3EzBiB;I2E0BjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EjBmB,EAAA;E2EmBnB;IACE,gC3EpBiB;I2EqBjB,uBAAuB,EAAA;EAEzB;IACE,6B3ExBiB;I2EyBjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EhBmB,EAAA;E2EkBnB;IACE,gC3EnBiB;I2EoBjB,uBAAuB,EAAA;EAEzB;IACE,6B3EvBiB;I2EwBjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EfmB,EAAA;E2EiBnB;IACE,gC3ElBiB;I2EmBjB,uBAAuB,EAAA;EAEzB;IACE,6B3EtBiB;I2EuBjB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EdoB,EAAA;E2EgBpB;IACE,gC3EjBkB;I2EkBlB,uBAAuB,EAAA;EAEzB;IACE,6B3ErBkB;I2EsBlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EboB,EAAA;E2EepB;IACE,gC3EhBkB;I2EiBlB,uBAAuB,EAAA;EAEzB;IACE,6B3EpBkB;I2EqBlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EZqB,EAAA;E2EcrB;IACE,gC3EfmB;I2EgBnB,uBAAuB,EAAA;EAEzB;IACE,6B3EnBmB;I2EoBnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EXqB,EAAA;E2EarB;IACE,gC3EdmB;I2EenB,uBAAuB,EAAA;EAEzB;IACE,6B3ElBmB;I2EmBnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EVqB,EAAA;E2EYrB;IACE,gC3EbmB;I2EcnB,uBAAuB,EAAA;EAEzB;IACE,6B3EjBmB;I2EkBnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EMqB,EAAA;E2EJrB;IACE,gC3EGmB;I2EFnB,uBAAuB,EAAA;EAEzB;IACE,6B3EDmB;I2EEnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EOqB,EAAA;E2ELrB;IACE,gC3EImB;I2EHnB,uBAAuB,EAAA;EAEzB;IACE,6B3EAmB;I2ECnB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EQoB,EAAA;E2ENpB;IACE,gC3EKkB;I2EJlB,uBAAuB,EAAA;EAEzB;IACE,6B3ECkB;I2EAlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3ESoB,EAAA;E2EPpB;IACE,gC3EMkB;I2ELlB,uBAAuB,EAAA;EAEzB;IACE,6B3EEkB;I2EDlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EUsB,EAAA;E2ERtB;IACE,gC3EOoB;I2ENpB,uBAAuB,EAAA;EAEzB;IACE,6B3EGoB;I2EFpB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EWoB,EAAA;E2ETpB;IACE,gC3EQkB;I2EPlB,uBAAuB,EAAA;EAEzB;IACE,6B3EIkB;I2EHlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EYoB,EAAA;E2EVpB;IACE,gC3ESkB;I2ERlB,uBAAuB,EAAA;EAEzB;IACE,6B3EKkB;I2EJlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EaoB,EAAA;E2EXpB;IACE,gC3EUkB;I2ETlB,uBAAuB,EAAA;EAEzB;IACE,6B3EMkB;I2ELlB,uBAAuB,EAAA;;AAKzB;EAbA,2B3EcsB,EAAA;E2EZtB;IACE,kC3EWoB;I2EVpB,uBAAuB,EAAA;EAEzB;IACE,+B3EOoB;I2ENpB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EqBuB,EAAA;E2EnBvB;IACE,gC3EkBqB;I2EjBrB,uBAAuB,EAAA;EAEzB;IACE,6B3EcqB;I2EbrB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EsBuB,EAAA;E2EpBvB;IACE,gC3EmBqB;I2ElBrB,uBAAuB,EAAA;EAEzB;IACE,6B3EeqB;I2EdrB,uBAAuB,EAAA;;AAKzB;EAbA,2B3EuByB,EAAA;E2ErBzB;IACE,kC3EoBuB;I2EnBvB,uBAAuB,EAAA;EAEzB;IACE,+B3EgBuB;I2EfvB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EwBoB,EAAA;E2EtBpB;IACE,gC3EqBkB;I2EpBlB,uBAAuB,EAAA;EAEzB;IACE,6B3EiBkB;I2EhBlB,uBAAuB,EAAA;;AAKzB;EAbA,yB3EyBoB,EAAA;E2EvBpB;IACE,gC3EsBkB;I2ErBlB,uBAAuB,EAAA;EAEzB;IACE,6B3EkBkB;I2EjBlB,uBAAuB,EAAA;;AAKzB;EAbA,2B3E0BsB,EAAA;E2ExBtB;IACE,kC3EuBoB;I2EtBpB,uBAAuB,EAAA;EAEzB;IACE,+B3EmBoB;I2ElBpB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E2BsB,EAAA;E2EzBtB;IACE,gC3EwBoB;I2EvBpB,uBAAuB,EAAA;EAEzB;IACE,6B3EoBoB;I2EnBpB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E4BsB,EAAA;E2E1BtB;IACE,gC3EyBoB;I2ExBpB,uBAAuB,EAAA;EAEzB;IACE,6B3EqBoB;I2EpBpB,uBAAuB,EAAA;;AAKzB;EAbA,2B3E6BwB,EAAA;E2E3BxB;IACE,kC3E0BsB;I2EzBtB,uBAAuB,EAAA;EAEzB;IACE,+B3EsBsB;I2ErBtB,uBAAuB,EAAA;;AAKzB;EAbA,yB3E8BsB,EAAA;E2E5BtB;IACE,gC3E2BoB;I2E1BpB,uBAAuB,EAAA;EAEzB;IACE,6B3EuBoB;I2EtBpB,uBAAuB,EAAA;;AAU3B;EAGM,yB3EzBiB,EAAA;;A2EsBvB;EAQI,sB3EoDY;E2EnDZ,yB3ElBkB;E2EmBlB,qCAAqC;EACrC,mBAAmB,EAAA;EAXvB;IAcM,2BAA2B,EAAA;EAdjC;IAkBM,gBAAgB,EAAA;IAlBtB;;MAuBQ,mBAAmB;MACnB,yBAAyB;MACzB,sBAAsB,EAAA;IAzB9B;MA6BQ,aAAa;MACb,aAAa;MACb,eAAe,EAAA;IA/BvB;MAmCQ,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,cAAc,EAAA;IAvCtB;MA2CQ,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,cAAc;MACd,0BAA0B,EAAA;IAhDlC;MAoDQ,cAAc,EAAA;IApDtB;MAwDQ,QAAQ,EAAA;;AAMhB;EACE,oBAAoB;EACpB,SAAS,EAAA;EAFX;IAKI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB,EAAA;IAEhB;;MAEE,WAAW;MACX,YAAY,EAAA;EAblB;IAkBI,eAAe,EAAA;EAGjB;IAEI,eAAe,EAAA;EAFnB;IAKI,WAAW;IACX,YAAY,EAAA;EA3BlB;IAgCI,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;EAlCrB;IAsCI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ,EAAA;IAzCZ;MA4CM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,iBAAiB;MACjB,c3ExJe;M2EyJf,gBAAgB;MAChB,yBAAyB,EAAA;IAlD/B;MAsDM,gBAAgB;MAChB,c3EtIkB,EAAA;E2E+ExB;IA4DI,cAAc;IACd,c3E3Ia,EAAA;;A2E+IjB;EAEI,yBAA8B,EAAA;;AC9LlC;EACE,WAAW,EAAA;;ApD+FgC;EoD3F3C,yC5EyKa;E4ExKb,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY,EAAA;E/CmMd;I+ChMI,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY,EAAA;EAdhB;IAmBI,4BAA4B;IAC5B,2BAA2B,EAAA;EApB/B;IAyBI,4BAA4B,EAAA;IAzBhC;MA4BM,4BAA4B,EAAA;;AAKlC;EACE,yB5EWqB;E4EVrB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc,EAAA;EAJhB;IAQI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe,EAAA;IAXnB;MAaM,eAAe,EAAA;IAbrB;MAgBM,yB5EtBiB,EAAA;;A4EkDvB;EACE;IACE,YAAY,EAAA;EAGd;IACE,YAAY,EAAA,EACb;;A/CuEH;E+CnEE,yB5E0EgB,EAAA;;A4ErElB;EACE,2BAA2B,EAAA;;AAG7B;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB,EAAA;;AAKxB;EACE,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA;EADd;IAGI,kBAAkB;IAClB,qCAAqC,EAAA;EAJzC;IAQI,c5EzGiB;I4E0GjB,gBAAgB,EAAA;IATpB;MAWM,aAAa,EAAA;IAXnB;MAcM,yB5EpGiB,EAAA;E4EsFvB;IAmBI,eAAe;IACf,c5EjImB,EAAA;;A4EqIvB;EAEI,mB5E9FmB;E4E+FnB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAA;EARlB;IAWM,UAAU,EAAA;;AAMhB;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EAEnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EAEf,c5E/JmB;E4EgKnB,kBAAkB;EAElB,sCAAsC,EAAA;;AAGxC;EACE,yB5E3JqB,EAAA;;A4E8JvB;EACE,yB5E/JqB,EAAA;;A4EkKvB;EACE,c5E9KmB,EAAA;;A4EiLrB;EACE,2DAA2D,EAAA;;ACtM7D;EAGU,c7EuKQ,EAAA;;A6ElKlB;EAEM,c7EgKY,EAAA;;A6EzJlB;EAEI,eAAe;EACf,kBAAkB,EAAA;EAHtB;IAMM,gBAAgB,EAAA;EANtB;IASM,iBAAiB,EAAA;EATvB;IAaM,yB7EyIY,EAAA;I6EtJlB;MAeQ,c7E9Bc,EAAA;M6EetB;QAiBU,mBAAmB,EAAA;IAjB7B;MAsBQ,WAAW;MACX,mB7EtCc;M6EuCd,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,OAAO;MACP,YAAY;MACZ,6BAA6B;MAC7B,mBAAmB,EAAA;;AAS3B;EAGU,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,EAAA;EAL5B;IAOc,eAAe,EAAA;;AC/D7B;EAEI,gB9EqyB6B,EAAA;;A8EvyBjC;EAMI,c9EqKc;E8EpKd,qB9E+Jc;E8E9Jd,yB7EHc,EAAA;;A6EOlB;EACE,yB9EyJgB,EAAA;;A8ElJlB;;EAGI,mBAAmB,EAAA;;AAIvB;EACE,aAAa,EAAA;;AAIf;;EAGI,iCAAiC,EAAA;;AAMrC;EAKU,uCAAuC,EAAA;;AALjD;EAQU,sCAAsC,EAAA;;AAMhD;;;EAII,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB,EAAA;;AAN3B;EASI,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAhB3B;EAmBI,WAAW;EACX,kBAAkB;EAClB,6BAA6B,EAAA;;AArBjC;EAyBI,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAEhB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;EAEjB,cAAc;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC,EAAA;;AA3CpC;EA+CI,gBAAgB,EAAA;;AA/CpB;EAqDQ,YAAY,EAAA;;AArDpB;EAwDQ,6BAA6B,EAAA;;AAxDrC;EA2DQ,4BAA4B,EAAA;;AA3DpC;EAwEM,gC9EpFgB;E8EqFhB,6BAA6B,EAAA;EAzEnC;IAmEQ,6B9E/Ec,EAAA;E8EYtB;IAsEQ,uBAAuB,EAAA;;AAtE/B;EA+EU,sBAAsB;EACtB,uBAAuB,EAAA;;AAhFjC;EAoFQ,a9E9He;E8E+Hf,c9E/He,EAAA;;A8E0CvB;EAwFQ,mBAAmB;EACnB,gBAAgB,EAAA;EAzFxB;IA4FU,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,mB9EqoB4B,EAAA;I8EpuBtC;MAiGY,c9EpIS;M8EqIT,aAAa;MACb,mBAAmB,EAAA;MAnG/B;QAqGc,aAAa,EAAA;;AArG3B;EA+GU,wCAAwC,EAAA;;AA/GlD;EAkHU,UAAU,EAAA;;AAlHpB;EAwIQ,kBAAkB,EAAA;EAxI1B;IA0Hc,sCAAsC,EAAA;EA1HpD;IA6Hc,wCAAwC,EAAA;EA7HtD;IAoIY,eAAe,EAAA;EApI3B;IA2IU,oCAA2C,EAAA;EA3IrD;IA+IU,sCAAsC,EAAA;EA/IhD;IAmJU,sCAAsC,EAAA;EAnJhD;IAuJU,oCAA2C,EAAA;EAvJrD;IA2JU,yB9EiBa,EAAA;E8E5KvB;IA8JU,2BAA2B,EAAA;EA9JrC;IAkKY,WAAW;IACX,YAAY;IACZ,MAAM;IACN,8B9ExMS;I8EyMT,OAAO;IACP,kBAAkB,EAAA;EAvK9B;IA4KY,WAAW;IACX,YAAY;IACZ,MAAM;IACN,8B9EtKa;I8EuKb,OAAO;IACP,kBAAkB,EAAA;EAjL9B;IAuLY,WAAW;IACX,YAAY;IACZ,MAAM;IACN,8B9E3KY;I8E4KZ,OAAO;IACP,kBAAkB,EAAA;EA5L9B;IAkMY,WAAW;IACX,YAAY;IACZ,MAAM;IACN,8B9EtOS;I8EuOT,OAAO;IACP,kBAAkB,EAAA;EAvM9B;IA6MY,WAAW;IACX,YAAY;IACZ,MAAM;IACN,8B9EjPS;I8EkPT,OAAO;IACP,kBAAkB,EAAA;EAlN9B;IAuNU,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,c9ErOiB;I8EsOjB,sBAAsB,EAAA;IA7NhC;MAgOY,qBAAqB;MACrB,YAAY;MACZ,cAAc,EAAA;IAlO1B;MAsOY,SAAS,EAAA;IAtOrB;MA0OY,gBAAgB,EAAA;IA1O5B;MA+Oc,yBAA8B;MAC9B,gBAAgB,EAAA;;AAhP9B;EAyPQ,yB9ElSe,EAAA;E8EyCvB;IA2PU,c9E9RW;I8E+RX,e9EyewB;I8ExexB,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY,EAAA;IA/PtB;MAkQY,gCAAgC,EAAA;IAlQ5C;MAqQY,+BAA+B,EAAA;;AArQ3C;EAgRY,wBAAwB,EAAA;;AAhRpC;EAuRI,8BAA8B,EAAA;;AAvRlC;;;EA6RI,8BAA8B,EAAA;;AA7RlC;EAiSI,uBAAuB;EACvB,2BAA2B,EAAA;EAlS/B;IAqSM,gBAAgB,EAAA;;AArStB;EA0SI,WAAW,EAAA;;AA1Sf;EA8SI,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAE1B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAEhB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAElB,aAAa;EACb,mBAAmB;EACnB,sBAAsB,EAAA;;AA5T1B;EA+TI,aAAa;EACb,mBAAmB;EAEnB,YAAY;EAEZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAElB,sBAAsB,EAAA;;AAzU1B;EA6UI,YAAY,EAAA;;AA7UhB;EAiVI,8BAA8B;EAC9B,sBAAsB,EAAA;;AAlV1B;EAsVI,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAI3B;;EAEE,sCAAsC,EAAA;;AAKxC;EAKU,6BAA6B,EAAA;;AALvC;EAQU,4BAA4B,EAAA;;AARtC;EAgBc,gCAAgC,EAAA;;AAhB9C;EAmBc,+BAA+B,EAAA;;AAS7C;EAKI,2BAA2B;EAC3B,qB9E5aiB;E8E6ajB,aAAa,EAAA;;AAIjB;EAEI,2BAA2B;EAC3B,kBAAkB;EAClB,yB9E9ZkB;E8E+ZlB,cAAc;EACd,yB9E1ZmB,EAAA;E8EoZvB;IASM,2BAA2B,EAAA;;AATjC;EAaI,UAAU,EAAA;EAbd;IAeM,c9Ehce;I8Eicf,eAAe;IACf,gBAAgB,EAAA;IAjBtB;MAmBQ,yB9Ezbe,EAAA;I8EsavB;MAsBQ,yB9Evca;M8Ewcb,qB9Exca;M8Eycb,YAAY,EAAA;;AAMpB;EACE,iBAAiB;EACjB,6BAA6B,EAAA;EAF/B;IAII,YAAY;IACZ,2BAA2B;IAC3B,qB9E9bkB;I8E+blB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe,EAAA;IAXnB;MAcM,qB9E/egB,EAAA;I8EietB;MAiBM,UAAU,EAAA;IAjBhB;MAqBM,UAAU;MACV,kC9EuR6C;M8EtR7C,gBAAgB;MAChB,eAAe;MACf,YAAY,EAAA;IAzBlB;MA6BM,WAAW,EAAA;MA7BjB;QAgCQ,UAAU;QACV,WAAW,EAAA;QAjCnB;UAoCU,WAAW,EAAA;EApCrB;IA2CI,yB9E3SmB;I8E4SnB,UAAU;IACV,+BAA+B;IAC/B,6BAA6B,EAAA;EA9CjC;;;;;;IAuDI,gBAAgB;IAChB,eAAe;IACf,YAAY,EAAA;EAzDhB;;IA8DI,yB9ElgBmB;I8EmgBnB,c9E9gBiB,EAAA;E8E+crB;;;IAqEI,yB9EzgBmB,EAAA;E8EocvB;IAyEI,6BAA6B;IAC7B,gC9E3iBkB;I8E4iBlB,c9E1hBiB;I8E2hBjB,gBAAgB,EAAA;EA5EpB;IAgFI,4BAA4B;IAC5B,mB9EyOkC;I8ExOlC,6BAA6B;IAC7B,c9E9fkB,EAAA;E8E2atB;;;IAwFI,6BAA6B,EAAA;EAxFjC;IA6FI,yBAA+B;IAC/B,qBAAqB,EAAA;EA9FzB;IA+GI,YAAY,EAAA;;AAIhB;EAGM,+BAA+B,EAAA;;AAKrC;EACE,sCAAsC,EAAA;;AAGxC;EACE,oCAAoC,EAAA;;AAGtC;EACE,oCAAoC,EAAA;;AAGtC;EACE,oCAAoC,EAAA;;AAGtC;EACE,oCAAoC,EAAA;;AAGtC;EACE,sCAAsC,EAAA;;AAGxC;EACE,sCAAsC,EAAA;;AAGxC;EACE,sCAAsC,EAAA;;AAGxC;EACE,oCAA2C,EAAA;;AC9nB7C;EAEQ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU,EAAA;;ACTlB;EACE,WAAW,EAAA;;AAIb;EACE,WAAW,EAAA;;AAIb;EACE,YAAY,EAAA;;AAId;EACE,YAAY,EAAA;;AAGd;EACE,kBAAkB,EAAA;EADpB;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B,EAAA;;AAKlC;EACE,kBAAkB;EAClB,iBAAiB,EAAA;EAFnB;IAII,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B,EAAA;EANlC;IAUI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAA;;AAMhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBhF+Ga;EgF9Gb,iBAAiB;EACjB,sBhF2qBkC,EAAA;EgFjrBpC;IAQI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBhF4Gc;IgF3Gd,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,aAAa,EAAA;;AAIjB;EACE;IACE,QAAQ,EAAA,EAAA;;AC3EZ;EACE,WAAW,EAAA;EADb;IAII,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B,EAAA;IAZ/B;MAcM,gBAAgB;MAChB,yBjFQe,EAAA;IiFvBrB;MAmBM,gBAAgB,EAAA;;ACnBtB;;;;;;C5F450CC;A6Fx50CD;EACI,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UnFoFmB;EmFnFnB,aAAa;EACb,yBnFciB;EmFbjB,4CnFuKW,EAAA;EmF9Kf;IAWY,kBAAkB;IAClB,yBnF+BU,EAAA;ImF3CtB;MAegB,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,kBAAkB;MAClB,kBnFuwBqB,EAAA;MmF1xBrC;QAqBoB,eAAe,EAAA;IArBnC;MA0BgB,aAAa;MACb,iBAAiB;MACjB,sBAAsB;MACtB,cnFVK;MmFWL,QAAQ,EAAA;IA9BxB;MAmCoB,gBAAgB;MAChB,kBnF0vBiB;MmFzvBjB,iBAAiB;MACjB,kBAAkB,EAAA;IAtCtC;MAyCoB,gBAAgB;MAChB,kBnFgvBiB,EAAA;ImF1xBrC;MA6CoB,gBAAgB;MAChB,kBnF4uBiB,EAAA;;AmFruBrC;EACI,aAAa;EAEb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YnFyCgB;EmFxChB,6BAA8C,EAAA;EAPlD;IAWY,yBAAwC,EAAA;;AAOpD;EACI,eAAe;EACf,YnFgE0B,EAAA;;AmF7D9B,WAAA;AAEA;EACI,aAAa;EACb,kBAAkB,EAAA;EAFtB;IASQ,6BAA6B;IAC7B,YnFgBe;ImFff,YAAY;IACZ,enFksB0B;ImFjsB1B,cnF2EU;ImF1EV,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBnFgBkB;ImFflB,gBAAgB;IAChB,mBAAmB,EAAA;IAnB3B;MAOY,8BAA8B,EAAA;IAP1C;MAsBY,cnF3FW,EAAA;EmFqEvB;IA0BQ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBnFmrB6B;ImFlrB7B,iBnFJe;ImFKf,QAAQ;IACR,eAAe;IACf,MAAM;IACN,cnFzGe;ImF0Gf,2BAA2B,EAAA;;AAInC;EArHA;IAwHQ,kBAAkB,EAAA;IADtB;MAKY,WAAW,EAAA;IALvB;MASgB,WAAW,EAAA;EAzD/B;IAgEQ,WAAW,EAAA;EAGf;IAEQ,aAAa,EAAA;EAFrB;IAMQ,qBAAqB,EAAA,EACxB;;AAIT;EACI,kBAAkB;EAClB,kBAAkB,EAAA;;AAGtB;EACI,0CAA4E,EAAA;;AAGhF;EACI,YnF3DgB;EmF4DhB,2BAA2B;EAC3B,cnFrD4B;EmFsD5B,SAAS;EACT,kBAAkB,EAAA;EALtB;IAQQ,yBnFpKc,EAAA;EmF4JtB;IAYQ,YnFlEe;ImFmEf,WnFnEe;ImFoEf,iBAAiB,EAAA;EAdzB;IAkBQ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B,EAAA;IArBnC;MAwBY,YnF9EW;MmF+EX,YAAY;MACZ,iBAAiB;MACjB,yBnFnBM;MmFoBN,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,uBAAuB,EAAA;MA/BnC;QAkCgB,YAAgC;QAChC,gBAAgB,EAAA;;AAMhC;EACI,6BAA6B,EAAA;EADjC;IAGQ,yBnFxMc,EAAA;;AmF4MtB;EACI,aAAa;EACb,mBAAmB,EAAA;EAFvB;IAKQ,YnF3Ge;ImF4Gf,WnF5Ge;ImF6Gf,yBnF9CU;ImF+CV,UAAU,EAAA;;AAIlB;EAEQ,gBAAgB,EAAA;EAFxB;IAIY,gBAAgB;IAChB,cnF7NU;ImF8NV,yBnFjNW,EAAA;;AmFsNvB;EAEQ,eAAe;EACf,cnFlImB,EAAA;;AmF+H3B;EAOQ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBnF5CS;EmF6CT,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW,EAAA;;AAInB;EAEQ,qBAAqB,EAAA;EAF7B;IAKY,yBnF3FM,EAAA;;AmFiGlB;EACI,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,cnFtGc,EAAA;EmF8FlB;IAWQ,YAAY,EAAA;EAXpB;IAeQ,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAlB3B;IAsBQ,qBnFxHU,EAAA;;AmF6HlB;EAGY,gBAAgB,EAAA;;AAK5B;EACI;IAEQ,gBAAgB,EAAA;IAFxB;MAKY,qBAAqB;MACrB,sBAAsB,EAAA,EACzB;;AAKb;EAjPA;IAmPQ,aAAa,EAAA,EAChB;;AAGL;EAEQ,gBAAgB,EAAA;;AAFxB;EAKQ,WAAW,EAAA;;AALnB;EAQQ,gBnFlOY;EmFmOZ,8DACmC,EAAA;;AAI3C;EAdA;IAiBY,gBAAgB,EAAA,EACnB;;ACpVT;EACI,kBAAkB;EAClB,aAAa;EACb,4BAA4B,EAAA;EAHhC;IAMQ,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,aAAa,EAAA;IAXrB;MAcY,WAAW;MACX,oCAAoC,EAAA;IAfhD;MAmBY,oCAAoC;MACpC,kBAAkB,EAAA;MApB9B;QAuBgB,oCAAoC,EAAA;IAvBpD;MA4BY,eAAe;MACf,aAAa;MACb,yBpFxBU;MoFyBV,6BAA6B;MAC7B,gBAAgB;MAChB,8BAA8B;MAC9B,iBAAiB;MACjB,aAAa;MACb,wBAAwB,EAAA;MApCpC;QAuCgB,WAAW;QACX,oCAAoC,EAAA;MAxCpD;QA4CgB,oCAAoC;QACpC,kBAAkB,EAAA;QA7ClC;UAgDoB,oCAAoC,EAAA;MAhDxD;QAqDgB,cAAc,EAAA;MArD9B;QAyDgB,iBAAiB,EAAA;MAzDjC;QA6DgB,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,YAAQ;QACR,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,cpFsGE;QoFrGF,YAAW;QACX,gBAAgB;QAChB,2BAA2B,EAAA;MAvE3C;QA2EgB,6BAA6B;QAC7B,gCAAgC,EAAA;MA5EhD;QAgFgB,6BAA6B;QAC7B,gCAAgC;QAChC,WAAW;QACX,wBAAwB,EAAA;QAnFxC;UAsFoB,6BAA6B;UAC7B,WAAW;UACX,wBAAwB,EAAA;QAxF5C;UA4FoB,6BAA6B;UAC7B,oBAAoB;UACpB,kBAAkB;UAClB,sBAAsB;UACtB,wBAAwB;UACxB,0BAA0B;UAC1B,wBAAwB;UACxB,4BAA4B;UAC5B,+BAA+B;UAC/B,0BAA0B;UAC1B,qBAAqB,EAAA;MAtGzC;;QA4GgB,oCAAyC;QACzC,uBAAuB,EAAA;QA7GvC;;UAgHoB,uBAAuB,EAAA;MAhH3C;QAqHgB,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,cpFjGK;QoFkGL,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,4BAA4B;QAC5B,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,YAAQ,EAAA;QAjIxB;;;UAsIoB,cpF/GC;UoFgHD,yBpF9FA,EAAA;QoFzCpB;UA2IoB,gBAAgB,EAAA;QA3IpC;UA+IoB,6BAA6B,EAAA;QA/IjD;UAkJoB,gBAAgB;UAChB,YAAY;UACZ,gBAAgB;UAChB,cpF9HC;UoF+HD,WAAW;UACX,aAAa;UACb,eAAe,EAAA;QAxJnC;UA4JoB,6BAA6B;UAC7B,sBAAsB;UACtB,wBAAwB,EAAA;UA9J5C;YAkK4B,yBpFzHR,EAAA;;AoFkIpB;EACI,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;EAC3B,oDAAiD;EACjD,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB,EAAA;EAbzB;IAgBQ,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,yBAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAoD,EAAA;IA7B5D;;;MAkCY,yBAA8B;MAC9B,oCAAwC,EAAA;IAnCpD;MAuCY,2BAA2B,EAAA;IAvCvC;MA2CY,wCAAwC,EAAA;IA3CpD;MA+CY,2BAA2B;MAC3B,uBAAuB;MACvB,2BAA2B;MAC3B,yBAA8B;MAC9B,sBAAsB;MACtB,wBAAwB;MACxB,0BAA0B,EAAA;IArDtC;MAyDY,6BAA6B;MAC7B,sBAAsB;MACtB,wBAAwB,EAAA;;AAKpC;EACI,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,oDAAiD;EACjD,qBAAqB;EACrB,yBAAyB,EAAA;EAV7B;IAaQ,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,yBAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;IAClC,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;IACvB,8BAA8B;IAC9B,uBAAoD,EAAA;IA5B5D;MA+BY,yBAA8B;MAC9B,oCAAwC,EAAA;IAhCpD;MAoCY,4BAA4B;MAC5B,uBAAuB;MACvB,2BAA2B;MAC3B,yBAA8B;MAC9B,sBAAsB;MACtB,wBAAwB;MACxB,8BAA8B;MAC9B,oBAAoB;MACpB,0BAA0B;MAC1B,gCAAgC;MAChC,0BAA0B;MAC1B,yBAAyB;MACzB,oBAAoB;MACpB,8BAA8B,EAAA;MAjD1C;QAoDgB,yBAA8B,EAAA;IApD9C;MAyDY,yBAA8B;MAC9B,0BAA0B;MAC1B,2BAA2B,EAAA;IA3DvC;MA+DY,yBAA8B;MAC9B,0BAA0B,EAAA;;ACvStC;EACI,2BAA4C;EAC5C,oBAAoB,EAAA;EAFxB;IAKQ,6BAA6B;IAC7B,UAAU,EAAA;EANlB;IAUQ,eAAe;IACf,gBAAgB,EAAA;;ACXxB;EACI,SAAS;EACT,4BAA6C;EAC7C,kBAAkB;EAClB,QAAQ;EACR,ctFqHkB;EsFpHlB,WtFgFiB;EsF/EjB,atFiHiB;EsFhHjB,4CtFsKW;EsFrKX,sBtFgHY,EAAA;;AsF7GhB;EAZA;IAcQ,OAAO,EAAA,EACV;;AAIL;EAEQ,UtFkEsB,EAAA;;AsF9D9B;EAEQ,kBAAkB,EAAA;;AC3B1B;EACI,sBvFmKW;EuFlKX,yEAAyE;EACzE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,YvF4HmB;EuF3HnB,aAAa;EACb,uBAAuB;EACvB,aAA+B;EAC/B,MAAM;EACN,SAAS,EAAA;EAXb;IAcQ,yBAAoC;IACpC,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,cvFoJU;IuFnJV,kBAAkB;IAClB,kBAAkB,EAAA;IApB1B;MAuBY,yBAAqC,EAAA;;AAMjD;EACI,wCvF8Ic;EuF7Id,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,aAAa;EACb,SAAS;EACT,aAAa;EACb,aAAa;EACb,4BAA4B,EAAA;;AAGhC;EAEQ,QAAQ,EAAA;;AAFhB;EAKQ,cAAc,EAAA;;A9EyBlB;E8ExEJ;IAqDQ,cAAc,EAAA;IADlB;MAGQ,uBAAuB,EAAA,EAC1B;;AAIT;EAGQ,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2BAA2B,EAAA;;AANnC;EAUQ,cAAc,EAAA;EAVtB;IAYY,UAAU;IACV,iBAAiB,EAAA;EAb7B;IAiBY,mBAAmB;IACnB,mBAAmB,EAAA;EAlB/B;IAsBY,gBAAgB;IAChB,mBAAmB,EAAA;EAvB/B;IA2BY,gBAAgB,EAAA;;AA3B5B;EAiCY,yBvF3FU;EuF4FV,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBvF0rB0B,EAAA;EuFjuBtC;IA0CgB,yBAA2D,EAAA;;AA1C3E;EAiDY,0BAA0B;EAC1B,cvFjEK,EAAA;;AuFejB;EAqDY,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAiC,EAAA;EA5D7C;IA+DgB,cAAkD,EAAA;;AC3HlE;EACI,SAAS,EAAA;EADb;IAIQ,cAAc;IACd,WAAW;IACX,cAAc,EAAA;EANtB;IAUQ,aAAa,EAAA;IAVrB;MAaY,aAAa,EAAA;IAbzB;MAiBY,cAAc,EAAA;EAjB1B;IAsBQ,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;IAC1B,uCAAuC,EAAA;;AAI/C;EACI,YxFsDiB;EwFrDjB,aAAa;EACb,mBxF8CgB;EwF7ChB,SAAS;EACT,aAAa;EACb,eAAe;EACf,MAAM;EACN,4CxFuIW,EAAA;EwF/If;IAWQ,YAAY;IACZ,yBxFjCe;IwFkCf,kBAAkB;IAClB,yBxFNe,EAAA;IwFRvB;MAgBY,yBxFRW;MwFSX,YAAY;MACZ,kCxF+tBuC;MwF9tBvC,gBAAgB;MAChB,eAAe;MACf,SAAS;MACT,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,kBxFsuByB;MwFruBzB,cxFtCS,EAAA;IwFYrB;MA6BY,gBAAgB;MAChB,yBxFvBW;MwFwBX,YAAY;MACZ,kBxF2tByB;MwF1tBzB,cxFjBkB;MwFkBlB,aAAa,EAAA;;AAKzB;EAGI,gBAAgB,EAAA;EAEhB;IACI,wBAAwB;IACxB,yBAAyB,EAAA;EAPjC;IAWQ,yBAAyB;IACzB,gBxFkBY,EAAA;EwF9BpB;IAiBY,yBAAyB,EAAA;EAjBrC;IAoBY,wCAAqE,EAAA;;AAKjF;EACI,aAAa;EACb,uBAAuB;EACvB,YxFEgB;EwFDhB,+BAA+B,EAAA;EAJnC;IAOQ,gCxF3Dc;IwF4Dd,aAAa,EAAA;;AAIrB;EACI,oBAAoB,EAAA;EADxB;IAMgB,0BAA0B,EAAA;EAN1C;IAWY,yBAAiD,EAAA;IAX7D;MAcgB,oCAA2C,EAAA;EAd3D;IAqBY,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,YAAY;IACZ,0BAA0B;IAC1B,eAAe,EAAA;EA1B3B;IAkCoB,cxFlGE;IwFmGF,axFnGE,EAAA;EwFgEtB;IAyCoB,oCAA2C;IAC3C,eAAe,EAAA;EA1CnC;IA8CgB,cAAc;IACd,UAAU;IACV,cxF1IM;IwF2IN,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oCxFPoC;IwFQpC,mBAAmB,EAAA;IAtDnC;MAyDoB,mBAAmB;MACnB,oBAAoB;MACpB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB,EAAA;MAhEtC;QAmEwB,WAAW;QACX,YAAY,EAAA;MApEpC;QAwEwB,eAAe;QACf,YAAY;QACZ,cAAc;QACd,cxFrKF;QwFsKE,oBAAoB,EAAA;EA5E5C;IAoFgB,eAAe,EAAA;EApF/B;IAwFgB,UAAU,EAAA;IAxF1B;MA4FwB,oCAAoC;MACpC,eAAe;MACf,cxFvHa,EAAA;IwFyBrC;MAkGwB,UAAU,EAAA;MAlGlC;QAsGgC,oCAAoC;QACpC,eAAe,EAAA;;AAU/C;EACI,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAA;;AAGpB;EAtMA;IAwMQ,aAAa,EAAA;EAjKrB;IAqKQ,yBAAyB,EAAA;EAG7B;IAEQ,cAAc,EAAA,EACjB;;AAKT;EAEQ,iBxFjKsB,EAAA;;AwF+J9B;EAMQ,sBAA0C;EAC1C,UAAU,EAAA;;AAPlB;EAYY,aAAa,EAAA;;AAZzB;EAgBY,cAAc,EAAA;;AAhB1B;EAsBQ,kBAAkB;EAClB,sBAA0C;EAC1C,UAAU,EAAA;EAxBlB;;IA4BY,4BAA4B,EAAA;EA5BxC;IAgCY,wBAAwB,EAAA;EAhCpC;IAoCY,oBAAoB,EAAA;EApChC;;IA4CgB,wBAAwB,EAAA;EA5CxC;IAgDgB,0BAA0B,EAAA;EAhD1C;IAqDoB,aAAa,EAAA;EArDjC;IA2DoB,kBAAkB;IAClB,mBAAmB,EAAA;IA5DvC;MA+DwB,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB,EAAA;MAjExC;QAsE4B,cxFxOW,EAAA;MwFkKvC;QA0E4B,eAAe;QACf,gBAAgB,EAAA;MA3E5C;QA+E4B,aAAa;QACb,kBAAkB,EAAA;IAhF9C;MAsF4B,kBAAkB;MAClB,wBAA+D;MAC/D,cxF5UN;MwF6UM,4BAAyC;MACzC,gBAAgB,EAAA;MA1F5C;QA6FgC,cxFjVV,EAAA;MwFoPtB;QAiGgC,eAAe,EAAA;IAjG/C;MAsG4B,cAAc;MACd,UxFtQE;MwFuQF,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;MACvB,mDAAmD,EAAA;MA3G/E;QA8GgC,mDAAmD,EAAA;MA9GnF;QAkHgC,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,UAAU;QACV,cxF3RK,EAAA;QwFoKrC;UA0HoC,cxF5RG,EAAA;EwFkKvC;IAkIoB,cAAc;IACd,aAAa;IACb,aAAa;IACb,yBxF3SA,EAAA;IwFsKpB;MA0IgC,cAAc;MACd,WAAW;MACX,uBAAuB;MACvB,iBAAiB;MACjB,kBAAkB;MAClB,YAAY,EAAA;IA/I5C;MAqJgC,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,yBAAyB,EAAA;IAxJzD;MA+J4B,cxFhPV,EAAA;;AwF0XlB;EAEQ,yBAAyB,EAAA;;AAMjC;EAEQ,WAAW;EACX,aAAa;EACb,mBAAmB,EAAA;EAEnB;IANR;MAOY,WAAW,EAAA,EAElB;;AATL;EAYQ,WxF3de;EwF4df,kBAAkB,EAAA;EAb1B;;IAiBY,wBAAwB,EAAA;;AAjBpC;EA0BQ,UxFzee,EAAA;EwF0ef;IA3BR;MA4BY,OAAO,EAAA,EAEd;;AA9BL;EAmEY,iBxFnhBkB,EAAA;;AwFgd9B;EAuEgB,gBAAgB,EAAA;EAvEhC;IA4EgC,qBAAqB,EAAA;;AA5ErD;EAoFY,UxFpiBkB,EAAA;;AyFvF9B;EACI,gBzF4Hc;EyF3Hd,yBAA0C;EAC1C,4CzF2KW;EyF1KX,gBzFgGgB;EyF/FhB,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY,EAAA;EARhB;IAWQ,SAAS;IACT,UAAU,EAAA;EAZlB;IAkBY,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,czFyGa;IyFxGb,oCzFmIwC,EAAA;IyFzJpD;MAyBgB,eAAe;MACf,sBAAsB;MACtB,qBAAqB,EAAA;IA3BrC;MA8BgB,czFiGgB;MyFhGhB,6BAA6B,EAAA;EA/B7C;IAoCY,czF0Fa,EAAA;IyF9HzB;MAsCgB,czFyFgB,EAAA;EyF/HhC;IA4CgB,czFmFgB,EAAA;EyF/HhC;IAmDoB,czF4EY;IyF3EZ,6BAA6B,EAAA;;AhFO7C;EgFEA;;IAGQ,cAAc,EAAA,EACjB;;AhFNL;EgFWA;IAKoB,eAAe,EAAA;EALnC;IAYQ,qBAAqB;IACrB,gBAAgB,EAAA;EAbxB;IAoBgB,SAAS;IACT,WAAW,EAAA;EArB3B;IAyBY,aAAa;IACb,kCzFkoBoB,EAAA;IyF5pBhC;MA8BoB,WAAW;MACX,2CAA2C;MAC3C,kBAAkB,EAAA;IAhCtC;MAsCoB,kBAAkB;MAClB,iBAAiB;MACjB,UAAU;MACV,aACJ,EAAA;EA1ChB;IAgDgB,cAAc,EAAA;EAhD9B;IAsDQ,cACJ,EAAA;EAGJ;IACI,aAAa,EAAA,EAChB;;AAGL;EACI,qBAAqB,EAAA;EADzB;IAIQ,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,0CAA0C;IAC1C,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW,EAAA;;AhF7Ef;EgFmFA;IAMwB,WAAW;IACX,UAAU,EAAA,EACb;;AhF3FrB;EgFqGA;IAEQ,czFzCS,EAAA;IyFuCjB;MAIY,czF3CK,EAAA;EyFuCjB;IASQ,azFjDO,EAAA;EyFrInB;IA2LQ,iBAAiB;IACjB,gBAAgB;IAChB,UAAU,EAAA;IA7LlB;MAgMgB,uBAAuB,EAAA;IA1HnC;MAgIY,6BAA6B;MAC7B,YAAY;MACZ,gBAAgB;MAChB,kBAAkB,EAAA;MAf9B;QAiBgB,WAAW,EAAA;QAjB3B;UAoBoB,WAAW,EAAA;IApB/B;MA0BY,kBAAkB;MAClB,6BAA6B,EAAA;MA3BzC;QA+BgB,czFvNE,EAAA;IyFwLlB;MAsCY,WAAW;MACX,kBAAkB,EAAA,EACrB;;AhFvKT;EgF+KA;IAGY,czFvGK,EAAA;EyFoGjB;IAOY,azF5GG,EAAA;EyFqGf;IAYQ,yBzFpPU,EAAA;IyFwOlB;MAgBgB,+BzFtFL,EAAA;MyFsEX;QAmBoB,+BzFzFT,EAAA;IyFsEX;MA0BwB,0CAAmC,EAAA,EACtC;;ACrQzB;EAGQ,WAAW;EACX,qB1Fea;E0Fdb,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC,EAAA;;AAKzC;EACI,MAAK;EACL,OAAO;EACP,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW,EAAA;;AChCf;;;;;;uDrGq62CuD;AqG952CtD;EACG,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,wCAAwC,EAAA;;AAE1C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAI9B,qJAAqJ;EAIrJ,6BAA6B;EAI7B,uCAAuC;EAKvC,mCAAmC;EACnC,oBAAoB,EAAA;;AAEtB;EACE,oCAAoC;EAIpC,6KAA6K,EAAA;;AAE/K;EACE,8BAA8B,EAAA;;AAEhC;EACE,oCAAoC,EAAA;;AAEtC;EAIE,2BAA2B,EAAA;;AAE7B;;EAME,wBAAwB;EACxB,2EAA2E,EAAA;;AAE7E;;;;EAIE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU,EAAA;;AAEZ;EACE,qBAAqB;EACrB,oBAAoB,EAAA;;AAEtB;EACE,SAAS;EACT,qBAAqB,EAAA;;AAEvB;EACE,oBAAoB;EACpB,sBAAsB,EAAA;;AAExB;EACE,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB,EAAA;;AAEpB;EACE,wBAAwB;EAExB,iDAAiD;EAIjD,qBAAqB,EAAA;;AAEvB;EAEE,+CAA+C,EAAA;;AAEjD;EACE,cAAc,EAAA;;AAvFhB;EA4FM,0C3F6BO,EAAA;;A2FzBf;EAEQ,wC3F3Ic,EAAA;;A2F8ItB;EAEQ,wC3FsDS,EAAA;;A2FnDjB;EAEQ,0C3F4Ee,EAAA;;A2FzEvB;EAEQ,yC3F2CS,EAAA;;A2FxCjB;EAEQ,wC3FoCS,EAAA;;A4FrMjB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,yB5F9BoB;E4F+BpB,W5FmIa;E4FlIb,aAAa;EACb,gB5FmwB+B;E4FlwB/B,YAAY;EACZ,uBAAuB;EACvB,WAAW,EAAA;;AAKb;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe,EAAA;EAHjB;IAKI,kBAAkB;IAClB,sB5FmHW;I4FlHX,kBAAkB;IAClB,oBAAoB,EAAA;IARxB;MAUM,kBAAkB;MAClB,2BAA2B,EAAA;;AAKjC;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,eAAe,EAAA;IALnB;MASQ,cAAc,EAAA;IATtB;MAqBM,aAAa;MACb,2BAA2B;MAC3B,yBAAyB;MACzB,yB5F/BgB;M4FgChB,mBAAmB;MACnB,aAAa;MACb,YAAY;MACZ,MAAM;MACN,WAAW;MACX,kBAAkB,EAAA;MA9BxB;QAeQ,WAAW,EAAA;MAfnB;QAkBQ,UAAU,EAAA;;AC5ElB;EAGY,kBAAkB,EAAA;;AAH9B;EAWoB,iBAAiB,EAAA;;AAXrC;EAkBQ,kBAAkB,EAAA;;AAI1B;EAEQ,yB7F6IU;E6F5IV,gBAAgB,EAAA;;AAHxB;EAMQ,kBAAkB;EAClB,kBAAkB,EAAA;EAP1B;IAUY,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,e7FsvBsB;I6FrvBtB,yB7FrCU;I6FsCV,W7F4HG;I6F3HH,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B,EAAA;;AAtBvC;EA8BoB,iBAAiB,EAAA;;AAOrC;EAEQ,YAAY,EAAA;EAFpB;IAIY,YAAY;IACZ,yB7FkKW;I6FjKX,2BAA2B;IAC3B,gC7FgKW,EAAA;I6FvKvB;MAUgB,4BAA4B,EAAA;IAV5C;MAagB,4BAA4B,EAAA;IAb5C;MAgBgB,yB7FhEO;M6FiEP,4B7FjEO,EAAA;I6FgDvB;MAqBgB,qB7F/EM;M6FgFN,4B7FhFM,EAAA;I6F0DtB;;MA0BgB,c7FnEK;M6FoEL,6BAA6B,EAAA;IA3B7C;MA+BgB,SAAS;MACT,YAAY;MACZ,c7FjDQ;M6FkDR,gBAAgB;MAChB,e7F6rBkB;M6F5rBlB,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,uBAAuB,EAAA;;AAMvC;EAEQ,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB,EAAA;;AALxB;EAQQ,gC7F9Dc;E6F+Dd,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAA;;AAX3B;EAcQ,UAAU,EAAA;;AAdlB;EAiBQ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,e7F4pB0B;E6F3pB1B,gBAAgB;EAChB,c7FtFgB,EAAA;;A6F8DxB;EA2BQ,aAAa,EAAA;;ACpIrB;EACI,oC9FuJgD,EAAA;;A8FpJpD;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAAmC,EAAA;;AAGvC;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,6BAAoC,EAAA;;AAGxC;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAI9B;EACI,0BAA0B,EAAA;;AAI9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EACI,0BAA0B,EAAA;;AAG9B;EAAc,2BAA2B,EAAA;;AACzC;EAAc,2BAA2B,EAAA;;AACzC;EAAc,2BAA2B,EAAA;;AACzC;EAAc,2BAA2B,EAAA;;AACzC;EAAc,2BAA2B,EAAA;;AACzC;EAAe,4BAA4B,EAAA;;AAE3C;EACI,eAAe,EAAA;;AAGnB;EACI,WAAW;EACX,YAAY;EACZ,yB9F9CkB;E8F+ClB,kBAAkB;EAClB,iBAAiB,EAAA;;AAKrB;EACI,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,yB9FoEc;E8FnEd,kBAAkB;EAClB,c9FkEc;E8FjEd,kBAAkB;EAClB,oBAAoB,EAAA;EATxB;IAYQ,c9F8DU;I8F7DV,yB9FyDU,EAAA;;A8FpDlB;EACI,eAAe,EAAA;;AAGnB;EACI,eAAe,EAAA;;AAGnB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAKpB;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,OAAO;EACP,MAAM;EACN,YAAY;EACZ,sB9F6BW,EAAA;;AuCvIf;EuDoHQ,eAAe;EACf,wB9Fg+CmC;E8F/9CnC,0FAA+F,EAAA;;AAKvG;EACI,kBAAkB,EAAA;EADtB;IAGQ,kBAAkB,EAAA;EAH1B;IAMQ,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,c9FLU,EAAA;;A8FUlB;EACI,aAAa,EAAA;EADjB;IAGQ,eAAe;IACf,gBAAgB;IAChB,kC9FulB2C;I8FtlB3C,c9F9IgB,EAAA;E8FwIxB;IASQ,c9FjJgB;I8FkJhB,gBAAgB;IAChB,e9F6lB0B,EAAA;E8FxmBlC;IAcQ,gBAAgB;IAChB,e9FylB0B;I8FxlB1B,2BAA2B,EAAA;;AAInC;EACI,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB,EAAA;;AAG7B;EACI,kBAAkB;EAClB,c9FtKkB;E8FuKlB,WAAW;EACX,aAAa,EAAA;;ACjNjB;EACE,sBAAsB;EACtB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB,EAAA;;AAOlB;EAEI,YAAY,EAAA;;AAFhB;EAMM,gCAAgC,EAAA;;AANtC;EAWI,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC,EAAA;;AAItC;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB,EAAA;;AAG3B;EACE,gCAAgC;EAChC,2BAA2B,EAAA;;AAG7B;EACE,cAAc;EACd,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;EAEE,yBAA+B,EAAA;;AAGjC;EACE,oCAA2C,EAAA;;AAG7C;EACE,oCAA2C,EAAA;;AAG7C;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,eAAe;EACf,oCAA2C,EAAA;;AAK7C;EACE,eAAe;EACf,qBAAqB;EACrB,oB/F4/BsE,EAAA;E+F//BxE;IAKI,YAAY;IACZ,cAAc;IACd,oBAA4C,EAAA;EAPhD;IAUI,cAAc,EAAA;;A1E3FlB;E0EgGE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB,EAAA;;AAGnB;;EAEE,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB,EAAA;;AAKnB;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB,EAAA;EAHnB;IAKI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB,EAAA;EARtB;IAYI,sBAAsB,EAAA;;AAI1B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB,EAAA;EAHnB;IAKI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;;AAKtB;EAKI,4BAA4B;EAC5B,yB/F9ImB;E+F+InB,gBAAgB,EAAA;EAPpB;IAGM,yB/F5IgB,EAAA;;A+FyItB;;EAWI,Y/F+6BwC;E+F96BxC,qB/F5GkB,EAAA;;A+FgGtB;EAgBI,gCAAiC;EACjC,2BAA2B,EAAA;;AAjB/B;EAqBI,gBAAgB;EAChB,yB/FtHkB;E+FuHlB,kBAAkB;EAClB,c/FvHoB;E+FwHpB,eAAe;EACf,kBAAkB;EAClB,eAAe,EAAA;;AA3BnB;EA8BI,c/F7HoB;E+F8HpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AAIrB;EAIE,4BAA4B,EAAA;EAJ9B;IAEI,oCAAqC,EAAA;;AAKzC;EACE,kBAAkB;EAClB,aAAa,EAAA;EAFf;IAKI,YAAY;IACZ,WAAW;IACX,c/FxIkB;I+FyIlB,sB/FmiBgC;I+FliBhC,qB/FrJkB;I+FsJlB,uBAAuB;IACvB,kC/F8kB+C;I+F7kB/C,gBAAgB,EAAA;IAZpB;MAeM,mC/F/LiB;M+FgMjB,qB/FhMiB,EAAA;I+FgLvB;MAmBM,yBAA+B,EAAA;EAnBrC;IAwBI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,c/F7MmB,EAAA;;A+FiNvB;EAME,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,oCAA0C;EAC1C,6BAA6B;EAC7B,kCAAkC,EAAA;EAdpC;IAEI,iCAAiC,EAAA;EAFrC;IAiBI,oCAA0C,EAAA;;AAI9C;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,oCAA0C;EAC1C,6BAA6B;EAC7B,kCAAkC,EAAA;EARpC;IAWI,oCAAyC;IACzC,gCAAqC,EAAA;EAZzC;IAeI,oCAA2C;IAC3C,gCAAuC,EAAA;;AAI3C;EAEI,oCAA2C;EAC3C,gCAAyC,EAAA;EAH7C;IAKM,yBAA+B,EAAA;;AALrC;EAUI,sBAAsB,EAAA;;AAV1B;EAcI,oCAA2C;EAC3C,gCAAsC;EACtC,mBAAmB,EAAA;EAhBvB;IAoBM,gCAAsC,EAAA;;AApB5C;;EA2BM,gCAAsC,EAAA;;AA3B5C;;EA8BM,gCAAyC,EAAA;;AA9B/C;;EAoCI,kC/F2e+C;E+F1e/C,Y/F+xBwC;E+F9xBxC,e/Fqf8B;E+Fpf9B,WAAW;EACX,sB/FybgC;E+FxbhC,aAAa;EACb,uBAAuB;EACvB,c/FrPkB;E+FsPlB,yB/FlQkB,EAAA;E+FsNtB;;;;IAiDM,gCAAsC,EAAA;EAjD5C;;IAqDM,eAAe;IACf,c/FhTiB;I+FiTjB,iBAAiB,EAAA;EAvDvB;;IA2DM,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,c/F3QgB,EAAA;I+F0MtB;;MAmEQ,c/F9Qc,EAAA;;A+FoRtB;EAEI,aAAa,EAAA;;AAFjB;EAMI,gCAAqC,EAAA;;AANzC;;EAWI,gCAAqC,EAAA;;AAXzC;EAeI,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB,EAAA;;AAjBtB;EA8BI,uBAAuB;EACvB,WAAW;EACX,Y/F2tBwC;E+F1tBxC,yB/FhUkB;E+FiUlB,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe,EAAA;EAvCnB;IAsBM,iBAAiB;IACjB,c/F7Ue,EAAA;E+FsTrB;IA2BM,gCAAqC,EAAA;;AAgB3C;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yB/FxUoB;E+FyUpB,uBAAuB;EACvB,4BAA4B,EAAA;EAX9B;IAaI,mC/F5WiB,EAAA;E+F+VrB;IAiBI,mC/F/WiB,EAAA;E+F8VrB;;;IAwBM,cAAc,EAAA;EAxBpB;IA8BM,2BAA2B,EAAA;EA9BjC;IAmCI,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,8B/F3WkB,EAAA;I+FiUtB;MA4CM,yBAA8B,EAAA;;AAKpC;EACE,kC/FyWiD;E+FxWjD,aAAa;EACb,8BAA8B,EAAA;EAHhC;IAMI,YAAY;IACZ,c/FtXkB;I+FuXlB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,e/F2W8B;I+F1W9B,qBAAqB,EAAA;IAZzB;MAeM,c/F9XgB,EAAA;I+F+WtB;MAmBM,c/FlYgB;M+FmYhB,kBAAkB,EAAA;IApBxB;MAwBM,4BAA4B,EAAA;EAxBlC;IA6BI,aAAa;IACb,cAAc,EAAA;EA9BlB;;IAmCI,YAAY,EAAA;;AAIhB;EACE,gBAAgB;EAChB,wBAAwB;EAExB,WAAW;EACX,YAAY;EACZ,eAAe;EAEf,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EAEtB,kBAAkB,EAAA;;AAZpB;EAgBE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAEhC,WAAW;EACX,YAAY;EACZ,eAAe;EAEf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,qBAAqB,EAAA;;AAGvB;EACE,YAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,4CAA4C,EAAA;;AAG9C;EACE,aAAa,EAAA;;AAGf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EAEnB,YAAY,EAAA;;AAGd;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,c/FpgBmB;E+FqgBnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB,EAAA;;AAG3B;EACE,uBAAuB,EAAA;;AAGzB;EACE,mBAAmB,EAAA;EADrB;IAII,wBAAwB,EAAA;EAJ5B;IAQI,0BAA0B;IAC1B,2BAA2B,EAAA;;AAI/B;EACE,aAAa;EACb,gBAAgB;EAEhB,qBAAqB;EACrB,oCAAoC,EAAA;;AAGtC;EACE,UAAU,EAAA;;AAGZ;EACE,uBAAuB,EAAA;;AAGzB;EACE,mBAAmB;EACnB,oBAAoB,EAAA;;AAGtB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AAGf;EAEI,8BAA8B,EAAA;;AAIlC;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,YAAY;IACZ,eAAe;IAEf,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C,EAAA;EAf9C;IAmBI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAEhB,qBAAqB;IACrB,wBAAwB,EAAA;IAxB5B;MA2BM,aAAa,EAAA;IA3BnB;MA+BM,mBAAmB;MACnB,kBAAkB,EAAA;IAhCxB;MAoCM,uBAAuB,EAAA;EApC7B;IAyCI,+BAA+B,EAAA;EAzCnC;IA6CI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,yDAEkB,EAAA;IApDtB;MAuDM,mBAAmB,EAAA;IAvDzB;MA2DM,mBAAmB;MACnB,cAAc,EAAA;;AAKpB;EACE,8BAA8B,EAAA;;ACnpBhC;EACE,iBAAiB,EAAA;;AAKnB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc,EAAA;;AAIhB;EACE,chGoJgB,EAAA;EgGrJlB;IAII,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,chG6Ic;IgG5Id,yBhGyIc;IgGxId,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB,EAAA;EAf1B;IAmBI,gBAAgB,EAAA;IAnBpB;MAuBQ,WhGyHO;MgGxHP,yBhG1Cc;MgG2Cd,qBhG3Cc,EAAA;;AgGiDtB;EACE,chGqHgB,EAAA;EgGtHlB;IAII,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,chG8Gc;IgG7Gd,yBhG0Gc;IgGzGd,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB,EAAA;EAf1B;IAmBI,gBAAgB,EAAA;IAnBpB;MAuBQ,WhG0FO;MgGzFP,yBhGzEc;MgG0Ed,qBhG1Ec,EAAA;;AgGkFtB;EAEI,yBhG+Ec;EgG9Ed,gBAAgB;EAChB,iBAAiB;EACjB,gBhG6sB6B;EgG5sB7B,kBAAkB,EAAA;;AAMtB;EACE,sBhGmEa;EgGlEb,yBhGqEgB;EgGpEhB,sBhG+nBkC;EgG9nBlC,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;EAPrB;IAUI,eAAe,EAAA;;AAInB;EACE,cAAc,EAAA;;AAGhB;EACE,aAAa,EAAA;EADf;IAGI,gCAAiC,EAAA;;AAIrC;EAEI,gBAAgB,EAAA;EAFpB;IAIM,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,oDAAiD;IACjD,yBAA0B;IAC1B,0BAA0B,EAAA;;ACnIhC;EACI;;;;;IAKI,wBAAwB,EAAA;EAE5B;;;;;IAKI,UAAU;IACV,SAAS,EAAA;EhEfjB;IgEmBQ,SAAS,EAAA,EACZ;;ACxBL;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe,EAAA;;AAEjB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B,EAAA;;AAE9B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,8BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,4BAA4B,EAAA;;AAE9B;EACE,WAAW,EAAA;;AAEb;EACE,UAAU,EAAA;;AAEZ;EACE,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB;EACE,2BAA2B;EAC3B,sBAAsB,EAAA;;AAGxB;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,EAAA;;AAGnB;EACI,kBAAkB;EAClB,mBAAmB,EAAA;;AAGvB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAA;;AA5BlB;EAgCE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;;AAIrB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,2BAA2B;EAC3B,yBAAyB,EAAA;;AAG3B;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB,EAAA;;AAKzB;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;ACvGvB;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB,EAAA;;AAGxB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,gBAAgB,EAAA;;AAGlB;EAEI,aAAa,EAAA;;AAFjB;EAMI,mBAAmB,EAAA;EANvB;IAQM,uBAAuB;IACvB,YAAY;IACZ,eAAe,EAAA;;AAKrB;EAEI,aAAa,EAAA;;AAFjB;EAMI,YAAY,EAAA;EANhB;IAQM,uBAAuB;IACvB,YAAY;IACZ,eAAe,EAAA;;AAMrB;EAEI,aAAa,EAAA;;AAFjB;EAMI,YAAY,EAAA;EANhB;IAQM,uBAAuB;IACvB,yBnGnBiB;ImGoBjB,cnG1Ce;ImG2Cf,eAAe,EAAA;;AC9DrB;EAEI,gBAAgB,EAAA;EAFpB;IAMI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY,EAAA;IAdhB;MAiBM,WpGmJS;MoGlJT,eAAe,EAAA;EAlBrB;IAuBM,kCpGyvB6C;IoGxvB7C,cpGsBqB;IoGrBrB,gBAAgB,EAAA;;AC7BtB;EACE,cAAc;EACd,eAAe,EAAA;EAFjB;IAKI,kBAAkB;IAClB,qBrGyCkB,EAAA;EqG/CtB;IAUI,kBAAkB,EAAA;EAVtB;IAeM,oCAAoC;IACpC,mBAAmB,EAAA;EAhBzB;IAmBM,mBAAmB;IACnB,YAAY,EAAA;;AAKlB;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY,EAAA;EALd;IAQI,aAAa;IACb,qBrGakB,EAAA;EqGtBtB;IAaI,4BAA4B;IAC5B,0BAA0B,EAAA;EAd9B;IAkBI,aAAa;IACb,yBAAyB,EAAA;IAnB7B;MAsBM,oCAAoC,EAAA;EAtB1C;IA2BI,yBrGCmB;IqGAnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,yBAAyB,EAAA;IAjC7B;;MAqCM,crGFgB;MqGGhB,gBAAgB;MAChB,eAAe;MACf,SAAS,EAAA;EAxCf;IA8CM,aAAa;IACb,sBAAsB,EAAA;IA/C5B;MAkDQ,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAA;IAtDzB;MA0DQ,YAAY,EAAA;IA1DpB;MA8DQ,cAAc;MACd,YAAY;MACZ,aAAa;MACb,8BAA8B;MAC9B,oBAAoB;MACpB,iBAAiB,EAAA;MAnEzB;QAsEU,aAAa;QACb,mBAAmB,EAAA;QAvE7B;UAyEY,crGvES;UqGwET,iBAAiB;UACjB,WAAW,EAAA;QA3EvB;UA8EY,uBAAuB;UACvB,SAAS;UACT,YAAY;UACZ,eAAe;UACf,crGhFS;UqGiFT,gBAAgB,EAAA;EAnF5B;IA2FI,uBAAuB;IACvB,gBAAgB,EAAA;IA5FpB;MA+FM,qCAAqC;MACrC,yCAAyC;MACzC,gBAAgB;MAChB,qBAAqB;MACrB,wBAAwB,EAAA;MAnG9B;QAsGQ,aAAa,EAAA;IAtGrB;MA2GM,mBAAmB;MACnB,gCAAgC;MAChC,aAAa;MACb,0BAA0B,EAAA;IA9GhC;MAkHM,aAAa;MACb,mBAAmB,EAAA;IAnHzB;MAuHM,mBAAmB;MACnB,kBAAkB;MAClB,yCAAyC,EAAA;MAzH/C;QA4HQ,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB,EAAA;MA9HxB;QAkIQ,gBAAgB,EAAA;MAlIxB;QAsIQ,mBAAmB,EAAA;MAtI3B;QA0IQ,kBAAkB,EAAA;MA1I1B;QA8IQ,WAAW;QACX,YAAY,EAAA;MA/IpB;QAmJQ,WAAW;QACX,YAAY,EAAA;;AAMpB;EACE,qBAAqB,EAAA;;AAGvB,oBAAA;AACA;EACE,mBAAmB;EACnB,0CAA0C,EAAA;;AAG5C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAA;;AAGX;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAEvB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,WAAW;EAEX,aAAa;EACb,mBAAmB;EACnB,SAAS;EAET,kBAAkB;EAElB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAA;EAXpB;IAcI,cAAc;IACd,eAAe,EAAA;EAfnB;IAmBI,cAAc;IACd,eAAe;IACf,gBAAgB,EAAA;EArBpB;IAyBI,cAAc;IACd,eAAe;IACf,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EAEnB,mBAAmB;EACnB,kBAAkB;EAElB,kBAAkB;EAElB,cAAc;EAEd,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,cAAc;EAEd,eAAe;EAEf,cAAc,EAAA;;AAGhB;EACE,cAAc;EAEd,gBAAgB;EAEhB,iBAAiB,EAAA;;AAGnB;EACE,cAAc;EAEd,eAAe;EAEf,iBAAiB,EAAA;;AAMnB;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAA;EAL3B;IAQI,qBAAqB;IACrB,iDAAiD,EAAA;EATrD;IAaI,SAAO;IACP,aAAa;IACb,mBAAmB,EAAA;EAfvB;IAmBI,YAAY;IACZ,0BAA0B;IAC1B,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,WAAW,EAAA;IAxBf;MA2BM,gBAAgB;MAChB,YAAY;MACZ,aAAa,EAAA;IA7BnB;MAiCM,cAAc,EAAA;IAjCpB;MAqCM,yBAAyB;MACzB,UAAU;MACV,mBAAmB,EAAA;EAvCzB;IA4CI,sBAAsB;IACtB,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe,EAAA;;AAOnB;EACE,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EAEI,mBAAmB,EAAA;;AAIvB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,aAAa,EAAA;;AAGf;EACE,8BAA8B;EAC9B,gBAAgB,EAAA;;AAGlB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAGlB;EACE,8BAA8B;EAC9B,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;EAHd;IAOI,kBAAkB,EAAA;EAPtB;;IAaI,gBAAgB,EAAA;IAbpB;;MAiBM,aAAa;MACb,SAAS;MACT,UAAU;MACV,SAAS,EAAA;EApBf;IA0BI,gBAAgB,EAAA;EA1BpB;;IA+BI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB,EAAA;;AAMlB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EANX;IASI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW,EAAA;EAbf;IAiBI,cAAc;IACd,WAAW;IACX,aAAa;IACb,uBAAuB,EAAA;IApB3B;MAuBM,WAAW,EAAA;;AAKjB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B,EAAA;EAR7B;IAWI,mBAAmB,EAAA;;AAIvB;EACE,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc,EAAA;EAPhB;IAUI,cAAc,EAAA;;AAKlB;EACE,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,eAAe,EAAA;;AAMjB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;;ACnnBhB;EACE,aAAa;EACb,SAAS;EACT,mBtG8CqB;EsG7CrB,mBAAmB;EACnB,kBAAkB,EAAA;EALpB;IAQI,SAAO;IACP,YAAY,EAAA;IAThB;MAYM,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;MACf,ctGGe;MsGFf,mBAAmB,EAAA;MAlBzB;QAqBQ,uBAAuB;QACvB,SAAS;QACT,gBAAgB;QAChB,ctGJa;QsGKb,eAAe,EAAA;QAzBvB;UA4BU,aAAa,EAAA;IA5BvB;MAkCM,aAAa;MACb,qCAAqC;MACrC,kBAAkB;MAClB,ctGlCiB;MsGmCjB,eAAe;MACf,gBAAgB;MAChB,kBAAkB,EAAA;MAxCxB;QA4CM,kBAAA;QACE,UAAU;QACV,SAAS;QACT,aAAa;QACb,mBAAmB;QACnB,uBAAuB,EAAA;IAjD/B;MAsDM,aAAa;MACb,qCAAqC;MACrC,QAAQ,EAAA;IAxDd;MA4DM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe;MACf,YAAY;MACZ,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,ctGpEgB;MsGqEhB,eAAe;MACf,yBAAiB;cAAjB,iBAAiB;MACjB,+CAA+C,EAAA;MAzErD;QA4EQ,yBtGxEe;QsGyEf,ctG3Ec,EAAA;MsGFtB;QAiFQ,yBtG/Ec;QsGgFd,WAAW;QACX,gBAAgB,EAAA;MAnFxB;QAuFQ,yBtGnCc;QsGoCd,ctG3CS;QsG4CT,eAAe,EAAA;MAzFvB;QA6FQ,ctGxCgB;QsGyChB,eAAe,EAAA;MA9FvB;QAkGQ,ctG9Cc;QsG+Cd,eAAe,EAAA;;ACvGvB;EAEI,yBAA8B,EAAA;;ACIlC;EAIQ,0BAA0B;EAC1B,6BAA6B,EAAA;;AALrC;EAaU,yBAAyB;EACzB,4BAA4B,EAAA;;AChBtC;EAEM,ezG0xB4B;EyGzxB5B,iBAAiB;EACjB,yBAAyB,EAAA;;AAI/B;EAEM,mBzG4JY;EyG3JZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBzGkIoB,EAAA;;AyG9H1B;;;;;;;;;;EAWM,qBzGwIY,EAAA;;AyGnJlB;EAcM,mBAAkC,EAAA;;AAIxC;EACE,gBzG8Ha;EyG7Hb,qBzG+HgB;EyG9HhB,czGmIgB;EyGlIhB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB,EAAA;;AAGzB;;;EAGE,yBzGhDoB;EyGiDpB,WzGiHa;EyGhHb,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,2BAA0B;EAC1B,iBAAiB,EAAA;;AAGnB;EACE,yBzGrEoB,EAAA;;AyGwEtB;EACE,WzGyFa,EAAA;;AyGtFf;EAGM,qBzGqFY,EAAA;;AyGhFd;EARJ;IASM,cAAc,EAAA,EAkCjB;;AA3CH;EAaU,ezGisBwB;EyGhsBxB,iBAAiB;EACjB,yBAAyB,EAAA;;AAG7B;EAlBN;;;IAuBc,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,cAAc,EAAA;EA3B5B;IA+Bc,WAAW,EAAA;EA/BzB;IAmCc,aAAa,EAAA,EAChB;;AApCX;EAwCU,0BAA0B,EAAA;;AAKpC;EACE,yBzG2CgB,EAAA;;AyGxClB;EACE,iCAAmC,EAAA;;AnHio6CrC;EmH5n6CE,yBAAyB,EAAA;;AnH+n6C3B;EmH3n6CE,kBAAkB,EAAA;;ACzIpB;EACI,sB1GmKW,EAAA;E0GpKf;IAGQ,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,c1GqKU,EAAA;I0G5KlB;MAUY,yB1G4JM,EAAA;I0GtKlB;MAcY,yB1G0LK;M0GzLL,gBAAgB;MAChB,eAAe,EAAA;;AAK3B;EACI,+B1GgJc,EAAA;;A0G7IlB;EACI,sB1G0IW;E0GzIX,gCAA4C;EAC5C,c1G+Ic,EAAA;E0GlJlB;IAKQ,aAAa,EAAA;;AAGrB;EAEQ,oCAAgE,EAAA;;AAIxE;EAEQ,qCAAqC;EACrC,wCAAwC;EACxC,sCAAsC;EACtC,yCAAyC,EAAA;;AAIjD;EACI,yB1GuHc;E0GtHd,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,gC1G6qBgC;E0G5qBhC,mC1G4qBgC,EAAA;;AV+k5CpC;EqHpz6CE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B,EAAA;;AAGjC;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU,EAAA;;AAGZ;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,iCAAiC,EAAA;;AAGnC;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EAAE,mGAAA;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EAAE,mFAAA;EAChB,eAAe;EAAE,kDAAA;EACjB,gBAAgB;EAAE,0CAAA;EAClB,qBAAqB;EACrB,uBAAuB,EAAA;;AAGzB;;EAEE,aAAa,EAAA;;AAGf;;EAEE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB,EAAA;;ArHiz6ClB;EqH7y6CE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB,EAAA;;ArHgz6C3B;EqH5y6CE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,+BAA+B,EAAA;;AAGjC;EACE,0DAAA;EACA,YAAY;EACZ,6BAA6B,EAAA;;AAG/B;EACE,MAAM;EACN,WAAW,EAAA;;AAGb;EACE,QAAQ;EACR,WAAW,EAAA;;AAGb;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb,gBAAA;ArHqy6CA;EqHny6CE,WAAW;EACX,OAAO,EAAA;;AAGT;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,YAAY,EAAA;;AClNd;EAEI,UAAU,EAAA;;AAId;EAEI,iBAAiB,EAAA;EAEjB;IAJJ;MAKM,kBAAkB,EAAA,EAQrB;EAbH;IAUM,kBAAkB;IAClB,eAAe,EAAA;;AAKrB;EAGM,aAAa,EAAA;;AAKnB;EAEI,eAAe,EAAA;;AAFnB;EAMI,gBAAgB,EAAA;;AAKpB;EACE,oCAAoC;EACpC,8BAA8B,EAAA;EAFhC;;;;;IAaQ,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,QAAQ,EAAA;EAlBhB;;;;;IAwBQ,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,oCAAoC;IACpC,SAAS;IACT,eAAe,EAAA;EA7BvB;;;;IAyCU,kBAAkB;IAClB,mBAAmB,EAAA;EA1C7B;IAoDQ,wC5G3Fc,EAAA;I4GuCtB;MAuDY,oC5G9FU;M4G+FV,c5G/FU,EAAA;E4GuCtB;IA6DY,wBAAwB,EAAA;EA7DpC;IAkEQ,qCAAsC;IACtC,oBAAoB;IACpB,yC5G3Gc,EAAA;;A4GgHtB;EACE,gB5G8BwB,EAAA;;A4GzB1B;;EAQY,yC5G8CG;E4G7CH,yB5GuEK;E4GtEL,YAAY,EAAA;;AAVxB;;EAsBY,yB5GuDK,EAAA;;A4G7CjB;EACE,yB5GvJoB;E4GwJpB,YAAY;EACZ,W5GSa;E4GRb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAA;EAPb;IAUI,mBAAmB;IACnB,0C5GCW;I4GAX,W5GAW,EAAA;;AS5FX;EmGkGF;;IAEE,qBAAqB;IACrB,iBAAiB,EAAA;EAGnB;IACE,aAAa,EAAA;EAGf;IAEI,kBAAkB;IAClB,cAAc;IACd,2BAA8B,EAAA;EAIlC;IACE,qBAAqB;IACrB,mB5GqYS,EAAA;E4GlYX;IACE,eAAe,EAAA,EAChB;;AAIH;EAEI,yB5GpCc,EAAA;;A8EzJlB;E8ByME,yB5G/CgB,EAAA;;A4GoDlB;;EAIM,kBAAkB,EAAA;EAJxB;;IAOQ,kBAAkB,EAAA;IAP1B;;MAUU,QAAQ;MACR,SAAS;MACT,YAAY;MACZ,WAAW;MACX,iBAAiB;MACjB,cAAc;MACd,kBAAkB;MAClB,W5GvEK;M4GwEL,sB5GxEK;M4GyEL,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,yBAAyB;MACzB,iBAAiB;MACjB,YAAY;MACZ,yB5GjPY,EAAA;;A6GDtB;EACE,yB7GmKgB;E6GlKhB,YAAY;EACZ,uBAAuB,EAAA;EAHzB;IAOQ,gBAAgB,EAAA;EAPxB;IAaU,oCAAqC;IACrC,sBAAsB;IACtB,gBAAgB;IAChB,sBAAwB,EAAA;EAhBlC;;;IAuBY,mB7G8IM,EAAA;E6GrKlB;;;IA8BY,c7G0IM;I6GzIN,YAAY,EAAA;EA/BxB;IAmCY,yB7GmIM,EAAA;;A6G5HlB;EAEI,YAAY,EAAA;;ACjDhB,eAAA;AACA;EACE,aAAa,EAAA;;AAGf;EACE,iBAAiB;EACjB,iCAAyC;EACzC,YAAY;EACZ,yBAA2B;EAC3B,4C9GwKa;E8GvKb,kBAAkB,EAAA;;AAGpB;EACE,c9G8JgB,EAAA;;A8G3JlB;EAEI,wCAAwC,EAAA;;AChB5C;EACI,8CAA8C;EAC9C,6CAA6C;EAC7C,sC/GixBoF,EAAA;E+GpxBxF;IAMQ,qB/GkKU,EAAA;;A+G9JlB;EACI,yB/G6Jc;E+G5Jd,sB/GstBgC,EAAA;;A+GntBpC;EACI,0CAA0C;EAC1C,2CAA2C;EAC3C,iDAAyC,EAAA;EAH7C;IAKQ,wBAAwB;IACxB,c/GsJU,EAAA;I+G5JlB;MASY,yBAA0B,EAAA;EATtC;IAcQ,qB/G2IU,EAAA;I+GzJlB;MAkBgB,yBAAyB,EAAA;;AAMzC;EACI,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB,EAAA;;AAIzB;EACI,sB/GqHW;E+GpHX,c/G6Hc;E+G5Hd,8C/G6HW;E+G5HX,mC/G4HW,EAAA;E+GhIf;IAOQ,gB/G+GO;I+G9GP,c/GqHU;I+GpHV,gCAAkD,EAAA;;AAG1D;;;EAIQ,e/G6GU,EAAA;;A+GjHlB;EAOQ,a/G0GU,EAAA;;A+GtGlB;EAEQ,sB/G6FO;E+G5FP,4CAA+C,EAAA;;ACxEvD,aAAA;AACA;EACE,iBAAiB;EACjB,0BhHqKgB;EgHpKhB,gBhHgKa;EgH/Jb,kBAAkB,EAAA;EAJpB;IAOI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa,EAAA;IAVjB;MAYM,aAAa,EAAA;;ACXnB;EAGQ,kBAAkB,EAAA;EAH1B;IAMY,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBjH4JM;IiH3JN,kBAAkB;IAClB,OAAO;IACP,SAAS,EAAA;EAZrB;IAgBY,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBjHpBU;IiHqBV,cjHrBU;IiHsBV,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBjHyIG,EAAA;IiHvIH;MA3BZ;QA4BgB,cAAc;QACd,6BAA6B,EAAA,EAEpC;EA/BT;IAmCgB,cAAc;IACd,eAAe;IACf,gBjHgwBiB,EAAA;IiH9vBjB;MAvChB;QAwCoB,aAAa,EAAA,EAEpB;EA1Cb;IA6CgB,6BAA6B;IAC7B,cjH2HE,EAAA;IiHzKlB;MAiDoB,yBjHjDE;MiHkDF,WjHgHL,EAAA;;AiHlKf;EAyDQ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EA5DxB;IA+DY,qBAAqB,EAAA;IA/DjC;MAkEgB,qBAAqB;MACrB,sBAAsB;MACtB,yBjHpEM;MiHqEN,WjH6FD;MiH5FC,qBAAqB,EAAA;IAtErC;MA2EoB,mBAAmB;MACnB,yBAAuC,EAAA;IA5E3D;MAiFgB,YAAY,EAAA;;AAM5B;EACI,iBAAiB;EACjB,iBAAiB,EAAA;;AC1FrB;EACE,aAAa;EACb,mBlHkKgB;EkHjKhB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,kBAAkB;EAClB,WlH0Ja;EkHzJb,elHixBgC;EkHhxBhC,iBAAiB;EACjB,mBlHXoB;EkHYpB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB,EAAA;EALpB;IAOI,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,8BlH1BkB,EAAA;EkHgBtB;IAaI,UAAU;IACV,mCAAmC;IACnC,oCAAoC;IACpC,iClHhCkB,EAAA;;AmHDtB;EACE,cnHmMe,EAAA;;AmHhMjB;EACE,qBnH+Le,EAAA;;AmH5LjB;EACE,aAAa;EACb,SAAS;EACT,UAAU,EAAA;EAHZ;IAKI,cAAc,EAAA;EALlB;IAQI,eAAe;IACf,gBAAgB;IAChB,cnHkLa;ImHjLb,eAAe,EAAA;;ACpBnB;EAEQ,eAAe,EAAA;;AAIvB;;;;EAKQ,8BAA+B;EAC/B,eAAe,EAAA;;AANvB;;;EAYQ,QAAQ,EAAA;EAZhB;;;IAcY,aAAa,EAAA;;AAdzB;EAmBQ,mBpH8IU;EoH7IV,qBpH6IU;EoH5IV,eAAe,EAAA;;AArBvB;EAwBQ,eAAe;EACf,cpHyIU,EAAA;;AoHlKlB;;EA6BQ,cpHsIU;EoHrIV,mBpHmIU;EoHlIV,eAAe,EAAA;;AA/BvB;EAmCQ,yBpHvCc;EoHwCd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iCAAqC;EACrC,eAAe,EAAA;EAxCvB;IA0CY,eAAe,EAAA;;AC/C3B;EACE,kBrHkKa,EAAA;;AqH/Jf;EACE,eAAe,EAAA;;AAGjB;EACE,QAAQ,EAAA;;AAGV;EAEI,qBAAqB;EACrB,sBAAsB,EAAA;EAH1B;IAMM,gBAAgB,EAAA;;AClBtB;EAEI,cAAc,EAAA;;AAFlB;EAKI,uBAAuB,EAAA;;AAL3B;EASM,yBtH4JY;EsH3JZ,ctHiKY;EsHhKZ,yBAAoC,EAAA;EAX1C;IAaU,yBtHZY;IsHaZ,qBtHbY;IsHcZ,WtHoJK,EAAA;;AsHnKf;EAmBM,YAAY,EAAA;EAnBlB;IAqBQ,QAAQ;IACR,0BAA0B;IAC1B,oBAAoB,EAAA;;AAvB5B;EA6BM,eAAe;EACf,mBAAmB,EAAA;;AA9BzB;EAmCI,kBAAkB;EAClB,yBAAiC,EAAA;EApCrC;IAuCM,oCAAmD,EAAA;EAvCzD;IA2CM,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB,EAAA;IA7CxB;MA+CQ,+BAA+B;MAC/B,oCAAoC;MACpC,sBtHkHO;MsHjHP,kBAAkB;MAClB,yBtHmHU;MsHlHV,WAAW;MACX,qBAAqB;MACrB,YAAY;MACZ,OAAO;MACP,kBAAkB;MAClB,kBAAkB;MAClB,4BAA4B;MAC5B,WAAW;MACX,wBAAwB,EAAA;IA5DhC;MA+DQ,ctHsGU;MsHrGV,qBAAqB;MACrB,eAAe;MACf,YAAY;MACZ,OAAO;MACP,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;MAClB,SAAS;MACT,WAAW,EAAA;EAzEnB;IA6EM,eAAe;IACf,UAAU;IACV,UAAU;IACV,wBAAwB,EAAA;IAhF9B;MAmFQ,aAAa,EAAA;EAnFrB;IAwFQ,oBAAoB;IACpB,aAAa,EAAA;EAzFrB;IA8FQ,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB,EAAA;EAhGxB;IAqGQ,yBtH+DU;IsH9DV,mBAAmB,EAAA;EAtG3B;IA2GQ,yBtH1Gc;IsH2Gd,qBtH3Gc,EAAA;EsHDtB;IA+GQ,WtHoDO,EAAA;;AsHnKf;EAsHM,oBAA8B;EAC9B,yBtHtHgB,EAAA;EsHDtB;IAyHQ,WtH0CO,EAAA;;AsHnCb;EADF;IAIQ,qBAAqC,EAAA,EACtC;;ACrIP;EACI,cAAc,EAAA;EADlB;IAGQ,sBvHiKO;IuHhKP,yBvHoKU;IuHnKV,YAAY,EAAA;IALpB;MAOY,aAAa,EAAA;IAPzB;MAWY,iBAAiB;MACjB,kBAAkB;MAClB,cvH8JM,EAAA;IuH3KlB;MAiBY,YAAY;MACZ,WAAW;MACX,UAAU,EAAA;MAnBtB;QAsBgB,yDAA2D;QAC3D,2BAA2B,EAAA;IAvB3C;MA4BY,cvH+IM,EAAA;;AVk27ClB;EiI1+7CQ,eAAe,EAAA;;AAIvB;EAIgB,oEAAsE;EACtE,sCAAsC,EAAA;;AAMtD;EAEQ,aAAa;EACb,sBvH+GO,EAAA;EuHlHf;IAKY,yBvHiHM;IuHhHN,sBvH4GG;IuH3GH,cvHiHM;IuHhHN,aAAa,EAAA;;AARzB;EAYQ,yBvH5Dc,EAAA;;AuHgDtB;EAeQ,yBvHoGU;EuHnGV,cvHsyCiD,EAAA;EuHtzCzD;IAkBY,yBvHlEU;IuHmEV,WvH+FG,EAAA;;AuH1Ff;EACI,iBAAiB,EAAA;;AAGrB;EACI,qCvH+FW;EuH9FX,sBvHoFW;EuHnFX,4CvH6FW,EAAA;;AuH1Ff;EAEQ,yBvHiFU,EAAA;;AuH7ElB;EAEQ,gBAAgB;EAChB,sBvHuEO;EuHtEP,oCAAgD,EAAA;EAJxD;IAOY,iBAAiB,EAAA;EAP7B;IAUY,SAAS;IACT,cvHsEM,EAAA;IuHjFlB;MAagB,cvHoEE,EAAA;EuHjFlB;IAiBY,yBvH2DM;IuH1DN,yBvH2DM;IuH1DN,kBAAkB;IAClB,cAAc,EAAA;;AAK1B;EAGY,qBvHkDM,EAAA;;AuHrDlB;EAQQ,gBvHsBkB,EAAA;;AuHhB1B;EACI,WAAW;EACX,WAAW;EACX,kBAAkB,EAAA;EAHtB;IAKQ,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAA;;AAI1B;EACI,eAAe,EAAA;;AAGnB;;;EAGI,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cvHmBc,EAAA;EuHzBlB;;;IASQ,iBAAiB,EAAA;IATzB;;;MAagB,gBAAgB;MAChB,kCAAkC,EAAA;;AAMlD;;;EAIQ,+BvHJO,EAAA;;AuHQf;EACI,gBAAgB,EAAA;;AAKpB;EACI,iBAAiB;EACjB,YAAY;EACZ,WAAW,EAAA;;ACrLf;EAEQ,aAAa,EAAA;;AAFrB;EAMQ,cxH+LS;EwH9LT,gBxH+xByB,EAAA;;AwHtyBjC;EAWQ,sBxHyJO;EwHxJP,cxHyLS;EwHxLT,gBAAgB,EAAA;;ACbxB;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAsC;EACtC,yCzHyKa;EyHxKb,4BAA4B;EAC5B,kBAAkB;EAClB,gCAAkC,EAAA;;AAGpC;EACE,yBAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,iDAAyC;EACzC,2BAA2C,EAAA;;ACf7C;EAEI,eAAe;EACf,gB1HkyB6B,EAAA;;A0H9xBjC;EACE,e1HmxBgC,EAAA;;A0HhxBlC;EAEI,qB1HqNmB;E0HpNnB,c1HoNmB,EAAA;;A0HvNvB;EAOM,yB1HqLW,EAAA;;A0H5LjB;EAWM,oC1HiLW,EAAA;;A0H5LjB;EAeI,qB1H4Ka;E0H3Kb,c1H2Ka,EAAA;;A0HvKjB;EAEI,gBAAgB,EAAA;;AAIpB;EAEI,mB1HtCkB,EAAA;E0HoCtB;IAIM,mB1HxCgB,EAAA;I0HoCtB;MAMQ,kC1H1Cc,EAAA;;A0HoCtB;EAYI,mB1HhDkB,EAAA;;A0HoDtB;EACE,qDAAuD,EAAA;;ACvDzD,eAAA;AACA;EACE,aAAa,EAAA;EADf;IAGI,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yB3HgKc;I2H/Jd,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gB3HsxB6B;I2HrxB7B,gCAAgC,EAAA;IAhBpC;MAkBM,c3HyJY;M2HxJZ,6BAA6B;MAC7B,cAAc;MACd,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,SAAS;MACT,kBAAkB;MAClB,qBAAqB;MACrB,gBAAgB;MAChB,gCAAgC,EAAA;IAhCtC;MAoCM,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,yB3H8HY;M2H7HZ,gBAAgB;MAChB,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,QAAQ;MACR,gCAAgC,EAAA;EA7CtC;IAkDI,yB3HjDkB,EAAA;;A2HDtB;EAuDE,yB3HtDoB,EAAA;E2HqDtB;IAGI,W3H0GW;I2HzGX,4BAA4B;IAC5B,WAAW;IACX,SAAS,EAAA;EANb;IAUI,UAAU;IACV,yB3HoGc,EAAA;;A2HhGlB;EACE,yB3H8He,EAAA;;A2H5HjB;;EAEE,W3HyFa,EAAA;;A2HtFf;EACE,yB3HyHe,EAAA;;A2HtHjB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yB3HrFoB,EAAA;;A2HwFtB;EACE,yB3H6Ge,EAAA;;A2H1GjB;EACE,yB3HoIqB,EAAA;;A2HjIvB;EACE,yB3HoGe,EAAA;;A2HjGjB;EACE,yB3H8Fe,EAAA;;A2H3FjB;EACE,yB3HiEgB,EAAA;;A2H9DlB;EACE,iBAAiB,EAAA;EADnB;IAGI,kBAAkB,EAAA;;AChHtB;EAEI,kC7GmO4D;E6GlO5D,uB5Hs8B+B;E4Hr8B/B,yB5HmKc;E4HlKd,sB5H8JW;E4H7JX,c5HoKc;E4HnKd,sB5H0tBgC,EAAA;E4HjuBpC;IASM,aAAa;IACb,qB5H4iCkE,EAAA;;A6HvjCxE;EACI,yB7H2Kc;E6H1Kd,c7HoKc;E6HnKd,mB7HwxBkC;E6HvxBlC,sBAAsB,EAAA;;AAG1B;EACI,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGrB;EACI,SAAS,EAAA;;ACdb;EAEM,qBAAqB,EAAA;;AAIzB;EACE,gBAAgB,EAAA;EADlB;IAGI,gBAAgB,EAAA;;ACPtB;EACI,kCAAkC,EAAA;;AAGtC;EACI,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAA;EAEd;IARJ;MASQ,eAAe,EAAA,EAEtB;;AAED;EAbA;IAeQ,0BAA0B;IAC1B,4BAA4B,EAAA;EAGhC;IACI,0BAA0B,EAAA,EAC7B;;AAIL;EACI,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,UAAU,EAAA;;AAGd;EACI,gBAAgB;EAChB,uBACJ,EAAA;;AAEA;EAEQ,wBAAiC,EAAA;;AAKzC;EACE,gBAAgB;EAChB,gBAAiB;EACjB,cAAe,EAAA;;AAGjB;EACI,YAAY;EACZ,YAAY,EAAA;;AAIhB;EACI,WAAW;EACX,YAAY,EAAA;;AAIhB;EACI,aAAa;EACb,mBAAmB,EAAA;;AAGvB;EACI,YAAY;EACZ,aAAa;EACb,iBAAiB,EAAA;;AAIrB;EACI,aAAa,EAAA;;A9E8DjB;E8E1DI,wBAAwB,EAAA;;A9E0D5B;E8EtDI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAAE,4BAAA;EACpB,yBAAyB;EACzB,UAAU;EACV,aAAa,EAAA;;AAGjB;;EAEI,aAAa,EAAA;;A9EsBjB;;E8ElBI,WAAW;EACX,YAAY,EAAA;;A9EuChB;E8EnCI,uBAAuB,EAAA;;AAG3B;EACI,iBAAgB,EAAA;;AAGpB;EACI,gBAAe,EAAA;;AAGnB;EACI,oBAAoB;EACpB,cAAc,EAAA;;AAGlB;EACI,iBAAiB,EAAA;;AAIrB;EACI,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY,EAAA;;AAIhB;EACI,cAAc,EAAA;;AAElB;EACI,gBAAgB;EAChB,+B/HilBgC;E+HhlBhC,kC/HglBgC,EAAA;;A+H5kBpC;EACI,gBAAgB;EAChB,0BAAmC;EACnC,2CAAkD;EAClD,8CAAqD;EACrD,YAAY,EAAA;;AAGhB;EACI,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa,EAAA;;AAGjB;EACI,YAAY;EACZ,iCAAuC;EACvC,0BAAmC;EACnC,oCAAyC,EAAA;;AAhJzC;EAoJA,eAAe,EAAA;EAEf;IAtJA;MAuJI,eAAe,EAAA,EAEtB;;AAED;EACQ,iBAAiB,EAAA;;ACzLzB;;EAGQ,aAAa;EACb,wBAAwB,EAAA;;AAJhC;EASY,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,sBAAsB,EAAA;EAZlC;IA4BgB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kChIovBmC;IgInvBnC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,yBhIfK;IgIgBL,kBAAkB,EAAA;IAvClC;MAeoB,yBhIQC;MgIPD,qBhIOC;MgIND,YAAY,EAAA;IAjBhC;MAoBoB,mBAAmB;MACnB,chIoCI;MgInCJ,qBhImCI,EAAA;MgIzDxB;QAwBwB,uBAAuB;QACvB,oCAA4C,EAAA;IAzBpE;MA0CoB,kBAAkB;MAClB,WAAW;MACX,SAAS;MACT,UAAU;MACV,YAAY;MACZ,kBAAkB;MAClB,yBhIrBC;MgIsBD,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,SAAS,EAAA;EApD7B;IA2DwB,6BAA6B;IAC7B,kChIwtB2B;IgIvtB3B,gBAAgB;IAChB,eAAe;IACf,chIvCH;IgIwCG,WAAW;IACX,kBAAkB;IAClB,kBAAkB,EAAA;IAlE1C;MAqE4B,mBAAmB;MACnB,chIbJ,EAAA;IgIzDxB;MA0E4B,chIpEN,EAAA;IgINtB;MA8E4B,aAAa,EAAA;EA9EzC;IAmFwB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,MAAM;IACN,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,qCAAqC;IACrC,WAAW,EAAA;IA9FnC;MAiG4B,kBAAkB;MAClB,oBAAoB;MACpB,gChIrDL,EAAA;MgI9CvB;QAsGgC,kChI8qBmB;QgI7qBnB,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,kBAAkB;QAClB,chInFX,EAAA;MgIxBrB;QAmHgC,gBAAgB;QAChB,YAAY;QACZ,chI7FX;QgI8FW,kChI8pBmB;QgI7pBnB,gBAAgB;QAChB,YAAY;QACZ,eAAe,EAAA;QAzH/C;UAgHoC,6BAA6B;UAC7B,0BAA0B,EAAA;IAjH9D;MA+H4B,oBAAoB,EAAA;MA/HhD;QAkIgC,kChIkpBmB;QgIjpBnB,gBAAgB;QAChB,eAAe;QACf,chIrFR,EAAA;MgIhDxB;QAyIgC,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,8BAA8B;QAC9B,yBhI/FV;QgIgGU,aAAa;QACb,mBAAmB;QACnB,eAAe,EAAA;QAjJ/C;UAmJoC,gCAAsC,EAAA;QAnJ1E;UAuJoC,YAAY;UACZ,6BAA6B;UAC7B,gBAAgB;UAChB,eAAe;UACf,chI5Gd,EAAA;UgI/CtB;YA6JwC,chI9GlB,EAAA;QgI/CtB;UAkKoC,WAAW;UACX,YAAY;UACZ,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,8BhIxHd,EAAA;UgI/CtB;YA0KwC,eAAe;YACf,chInJnB,EAAA;MgIxBrB;QAmLoC,YAAY;QACZ,mBAAmB;QACnB,2BAA2B;QAC3B,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf,kChI2lBe,EAAA;QgIpxBnD;UA2LwC,yBAA+B;UAC/B,wCAAwC,EAAA;QA5LhF;UAgMwC,YAAY;UACZ,yBhI1KnB,EAAA;;AgIvBrB;EA4MY,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,kBAAkB;EAClB,cAAc,EAAA;;AAlN1B;EAsNY,iBAAiB,EAAA;EAtN7B;IAwNgB,chI1KO,EAAA;EgI9CvB;IA4NgB,mBAAmB,EAAA;IA5NnC;MA+NoB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;MACnB,qBAAqB;MACrB,YAAY;MACZ,yBhI7MC,EAAA;EgI3BrB;IA6OgB,kChIuiBmC;IgItiBnC,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,chI3OO;IgI4OP,YAAY;IACZ,aAAa;IACb,0BAA0B,EAAA;EArP1C;IAmUgB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,8BhIrTM;IgIsTN,2BAA2B,EAAA;IA3U3C;MA4PwB,eAAe;MACf,chI9MF;MgI+ME,eAAe,EAAA;IA9PvC;MAmQwB,eAAe;MACf,chI5OH;MgI6OG,eAAe,EAAA;IArQvC;MA2QwB,SAAS;MACT,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,YAAY;MACZ,mBAAmB;MACnB,yBhI1CD;MgI2CC,kChIkgB2B;MgIjgB3B,gBAAgB;MAChB,eAAe;MACf,chInOG,EAAA;MgIlD3B;QAwRwB,eAAe;QACf,chIjQH,EAAA;IgIxBrB;MA8R4B,YAAY;MACZ,mBAAmB;MACnB,iBAAiB;MACjB,YAAY;MACZ,yBhI5RN;MgI6RM,kChIifuB;MgIhfvB,gBAAgB;MAChB,eAAe,EAAA;IArS3C;MAwS4B,chIjSL;MgIkSK,0BAA0B,EAAA;IAzStD;MA+SoB,eAAe,EAAA;MA/SnC;QAiTwB,eAAe;QACf,chIlQA,EAAA;MgIhDxB;QAqTwB,0BAA0B;QAC1B,iBAAiB;QACjB,kChI6d2B,EAAA;MgIpxBnD;QA0TwB,gBAAgB,EAAA;MA1TxC;QA6TwB,yBAA8B;QAC9B,gBAAgB,EAAA;IA9TxC;MA8UoB,chI5RO,EAAA;IgIlD3B;MAkVoB,kChIkc+B;MgIjc/B,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAtVrC;MA0VoB,yCAAyC,EAAA;IA1V7D;MA6VoB,WAAW,EAAA;IA7V/B;MAiWoB,kChImb+B;MgIlb/B,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IApWrC;MAyWwB,YAAY;MACZ,kChI0a2B,EAAA;IgIpxBnD;MA8WwB,gBAAgB;MAChB,yBAAoC;MACpC,0BAA0B,EAAA;IAhXlD;MAoXwB,eAAe;MACf,chI7VH,EAAA;IgIxBrB;MAyXwB,eAAe;MACf,gBAAgB,EAAA;IA1XxC;MA6XwB,gBAAgB;MAChB,eAAe;MACf,chIxWH,EAAA;IgIvBrB;MAmYwB,eAAe;MACf,yBAA+B,EAAA;IApYvD;MAwYwB,kChI4Y2B;MgI3Y3B,gBAAgB;MAChB,eAAe;MACf,chI5VF,EAAA;MgI/CtB;QA6Y4B,chI9VN;QgI+VM,eAAe,EAAA;;AA9Y3C;EAuZgB,kChI6XmC;EgI5XnC,gBAAgB;EAChB,kBhIqYqB;EgIpYrB,YAAY,EAAA;;AA1Z5B;EA8ZgB,yBhIhZO;EgIiZP,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,kChIgXmC;EgI/WnC,gBAAgB;EAChB,kBhIwXqB;EgIvXrB,2BAA2B;EAC3B,chIhZK;EgIiZL,eAAe,EAAA;EAza/B;IA4aoB,yBhItaE;IgIuaF,YAAY,EAAA;IA7ahC;MA+awB,YAAY,EAAA;EA/apC;IAoboB,chI5ZC;IgI6ZD,kBhIyWiB;IgIxWjB,eAAe,EAAA;;AAtbnC;EA4bY,gBAAgB,EAAA;EA5b5B;IA+bgB,kChIqVmC;IgIpVnC,gBAAgB;IAChB,kBhIiWqB;IgIhWrB,iBAAiB;IACjB,chI5aK;IgI6aL,oBAAoB,EAAA;EApcpC;IAwcgB,kChI4UmC;IgI3UnC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB,EAAA;;AC5chC,wCAAA;AAaA;EACE,yBAXoB;EAYpB,wCAX+B,EAAA;;AAcjC;EACE,yBAAyB;EACzB,yCAfiC,EAAA;EAanC;IAKI,2BAA2B;IAC3B,yCAlB4B,EAAA;;AAsBhC;EACE,YAAY,EAAA;;AAId;EACE,kBAAkB,EAAA;;AAGpB;EACE,yBAnCoB;EAoCpB,kBAAkB;EAClB,gBAAgB;EAChB,+BAlCuB,EAAA;EA8BzB;IAOI,yCAvC+B,EAAA;;AA2CnC;EACE,yBAzCwB;EA0CxB,6BA/CoB,EAAA;;AAkDtB;EACE,kBAAkB;EAClB,gCApDoB,EAAA;EAkDtB;IAKI,mBAAmB,EAAA;;AAIvB;EACE,eAAe,EAAA;;AAGjB;EACE,wCA7D8B;EA8D9B,yBA1Da,EAAA;;AA6Df;EACE,YAAY,EAAA;;AAGd;EAEI,cApEgB;EAqEhB,gBAAgB,EAAA;;AAKpB;EACE,yBAAyB,EAAA;EAD3B;IAII,qBAAqB,EAAA;;AAKzB;EACE,6DAA6E;EAC7E,kBAAkB;EAClB,aAAa,EAAA;;AAIf;EACE;IACE,eAAe;IACf,uBAAuB,EAAA;EApF3B;IAwFI,WAAW,EAAA;EA9Ef;IAkFI,aAAa,EAAA;EAlBjB;IAsBI,kBAAkB,EAAA;EA7DtB;IAiEI,kBAAkB,EAAA,EACnB;;AAIH;EACE,yBAAyB,EAAA;;AAI3B;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,qBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,qBAAsB,EAAA,EAAA;;AAI1B;EACE;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,qBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,sBAAsB,EAAA;EAExB;IACE,mBAAmB,EAAA,EAAA;;ACjPvB;;oB5Ii79CoB;A4I769CpB;EAEI,cAAc;EACd,clIuKc;EkItKd,iBAAiB;EACjB,gBAAgB,EAAA;EALpB;IAOM,clI8LW;IkI7LX,gBAAgB,EAAA;EARtB;IAYM,eAAe,EAAA;;AAKrB;EAEI,clIyJc;EkIxJd,gBAAgB,EAAA;;AAHpB;EAMI,eAAe,EAAA;;AAInB;EACE,cAAc;EACd,eAAe,EAAA;EAFjB;IAKI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,wBAAwB,EAAA;IAV5B;MAaM,clIkIY,EAAA;IkI/IlB;MAiBM,mBlI2HY;MkI1HZ,yBAAyB,EAAA;IAlB/B;MAsBM,WAAW;MACX,kBAAkB,EAAA;IAvBxB;MA2BM,YAAY,EAAA;MA3BlB;;;QAgCQ,cAAc;QACd,WAAW,EAAA;MAjCnB;QAqCQ,6BAA6B;QAC7B,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;QACT,QAAQ;QACR,cAAc;QACd,YAAY,EAAA;MA3CpB;QA+CQ,wBAAwB,EAAA;MA/ChC;QAmDQ,gBAAgB;QAChB,gBAAgB,EAAA;MApDxB;QAwDQ,kBAAkB;QAClB,MAAM;QACN,WAAW;QACX,QAAQ;QACR,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB,EAAA;IA/DxB;MAoEM,kBAAkB;MAClB,MAAM;MACN,WAAW;MACX,QAAQ;MACR,SAAS,EAAA;MAxEf;;QA4EQ,kBAAkB;QAClB,MAAM,EAAA;MA7Ed;QAiFQ,OAAO;QACP,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB,EAAA;MArF3B;QAyFQ,QAAQ;QACR,YAAY;QACZ,kBAAkB,EAAA;IA3F1B;MAiGM,iClI1HgB,EAAA;IkIyBtB;MAsGI,yBlIsCc;MkIrCd,gBAAgB;MAChB,cAAuB,EAAA;MAxG3B;QA0GQ,cAAuB;QACvB,gBAAgB,EAAA;EA3GxB;IAkHI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,mClIsBc;IkIrBd,kBAAkB,EAAA;IAxHtB;MA2HM,UAAU;MACV,eAAe,EAAA;IA5HrB;MA+HM,UAAU,EAAA;IA/HhB;MAmIM,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,OAAO;MACP,eAAe;MACf,UAAU;MACV,gBAAgB;MAChB,yBAAyB;MACzB,MAAM,EAAA;MA3IZ;QA6IQ,iBAAiB;QACjB,oCAAoC;QACpC,MAAM;QACN,YAAY;QACZ,cAAuB;QACvB,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,SAAS;QACT,eAAe,EAAA;;AAMvB;EA5JA;IA8JM,YAAY,EAAA,EACf;;AC1LH;EACI,eAAe;EACf,gBnIoyB6B;EmInyB7B,kBAAkB,EAAA;EAHtB;IAKQ,enIuxB0B;ImItxB1B,gBnI+xByB;ImI9xBzB,cAAc;IACd,gBAAgB,EAAA;;AAIxB;EACI,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,0BAAwE;EACxE,sBnImJW;EmIlJX,qBpHqOyB;EoHpOzB,4CnI2JW,EAAA;;AmIxJf;EAVA;IAYQ,UAAU,EAAA,EACb;;AC1BL,gDAAA;AAEA,kDAAA;AAEA;EACI,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;EALtB;IAOQ,aAAa,EAAA;;AAIrB;EAEQ,cpI4JU,EAAA;;AoIxJlB;EACI,UAAU,EAAA;;AAId;EAEQ,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB,EAAA;;AAJ1B;EAUY,YAAY,EAAA;;AAVxB;EAcY,UAAU;EACV,wCpItCU,EAAA;EoIuBtB;IAiBgB,cpIxCM,EAAA;;AoIuBtB;EAsBY,kBAAkB,EAAA;;AAtB9B;EA6BY,UAAU,EAAA;;AAOtB,gDAAA;AAEA;EACI,8BpIuGc;EoItGd,aAAa,EAAA;EAFjB;IAKQ,kBAAkB;IAClB,0BAA0B,EAAA;IANlC;MASY,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,UAAU;MACV,QAAQ;MACR,8BpIyFM;MoIxFN,8BpIwFM;MoIvFN,4BAA4B,EAAA;IAjBxC;MAqBY,kBAAkB;MAClB,yBHtFU;MGuFV,kBAAkB,EAAA;IAvB9B;MA4BgB,cpIzFM,EAAA;IoI6DtB;MAiCY,mBAAmB,EAAA;;AC/F/B;;sB/I0o+CsB;A+Ito+CtB;EAGY,kBAAkB;EAClB,gBAAgB,EAAA;;AAJ5B;EAQY,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,mBrIhBU;EqIiBV,UAAU;EACV,oBAAoB,EAAA;;AAfhC;EAmBY,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBrIwIG;EqIvIH,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB,EAAA;;AA3B9B;EA+BY,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB,EAAA;EApChC;IAuCgB,eAAe,EAAA;;AAvC/B;EA6CgB,YAAY,EAAA;;AA7C5B;EAiDgB,kBAAkB;EAClB,YAAY,EAAA;;AAM5B,sCAAA;AACA;EACI,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B,EAAA;;AAG/B;;EAEI,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B,EAAA;;AAG/B;EACI,2CrI1EkB,EAAA;;AsINtB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBtIyHc,EAAA;;AsItHhB;EACE,yBtIFoB;EsIGpB,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,WtI6Gc;EsI5Gd,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,2BAA2B,EAAA;;AAG7B;EACE,yBAAyB,EAAA;;AAG3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB,EAAA;EAZnB;IAeI,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB,EAAA;EAHrB;IAMI,yBtIzDkB;IsI0DlB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB,EAAA;EAnBpB;IAuBI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,kCAAkC,EAAA;IA7BtC;MA+BM,mBAAmB,EAAA;EA/BzB;IAoCI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB,EAAA;EAzCpB;IA4CI,yBAAyB,EAAA;EA5C7B;IAgDI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAA;IA1Df;MA6DM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,YAAY;MACZ,eAAe;MACf,2DAA2D,EAAA;MAnEjE;QAsEQ,yBAAyB;QACzB,sBAAsB,EAAA;MAvE9B;QA2EQ,yBAAyB,EAAA;QA3EjC;UA6EU,yBAAyB;UACzB,mBAAmB,EAAA;MA9E7B;QAkFQ,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;QACvB,kCAAkC,EAAA;;AAM1C;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY,EAAA;EAJd;;IAQI,mBAAmB,EAAA;EARvB;IAYI,kBAAkB,EAAA;EAZtB;IAgBI,eAAe;IACf,iBAAiB;IACjB,ctIjJiB;IsIkJjB,mBAAmB,EAAA;EAnBvB;IAuBI,eAAe;IACf,iBAAiB;IACjB,ctIxJiB;IsIyJjB,gBAAgB;IAChB,mBAAmB,EAAA;EA3BvB;IA+BI,eAAe;IACf,iBAAiB;IACjB,ctIhKiB,EAAA;;AsIoKrB;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kCAAkC,EAAA;;AAIpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ,EAAA;EAJV;IAOI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAElB,cAAc;IACd,qBAAqB,EAAA;EAdzB;IAkBI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAElB,cAAc,EAAA;;AAIlB;EACE,gBAAgB,EAAA;;AnEhKV;EmEoKN,cAAc,EAAA;;ACtOhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EAEE,yBAAyB,EAAA;EAF3B;IAKI,yBAAyB,EAAA;;AAI7B;EAEE,yBAAyB,EAAA;EAF3B;IAKI,yBAAyB,EAAA;;AAI7B;EACE,sBAAsB;EACtB,yBAAyB,EAAA;EAF3B;IAKI,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB,EAAA;;AlE7BzB;E/EkBE,kCAAkC,EAAA;;AAGpC;EAEI,aAAa;EACb,kCUwvB+C,EAAA;;AVpvBnD;EAEI,wBAAwB,EAAA;;AAI5B;EACE,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,0FACgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,UAAU,EAAA;EAbZ;IAeI,aAAa,EAAA;;AsD2DjB;EtDtDI,WAAW;EACX,YAAY,EAAA;;AsDmChB;EtD/BI,kBAAkB,EAAA;;AAGtB;EACE,cUjByB,EAAA;;A0BiFzB;EpC3DE,mBUiIa,EAAA;;AV7HjB;EACE,yBU4He;EV3Hf,yBU2He;EV1Hf,kCUqsBiD,EAAA;;AVlsBnD;EACE,kCUisBiD;EVhsBjD,yBU5DmB;EV6DnB,yBU7DmB,EAAA;;AViErB;EACE,cUlEmB;EVmEnB,gBUgtB+B,EAAA;;AV7sBjC;EACE,yBAAsB;EACtB,qBAAqB,EAAA;;AAGvB;EACE,yBAA2B,EAAA;;AAG7B;EACE,8BAA8B,EAAA;;AAEhC;EACE,mBAAmB,EAAA;EADrB;IAGI,2BAA2B;IAC3B,YAAY,EAAA;;ASgRhB;ET3QI,gBAAgB,EAAA;;AAGpB;EACI,wCAAwC;EACxC,mBAAmB,EAAA;;AAGvB;EACE,cUrHqB,EAAA;;AVwHvB;EACI,yBUzHmB;EV0HnB,uBAAuB;EACvB,mBAAmB;EACnB,kBU2pBiC;EV1pBjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB,EAAA;;AAGrB;EACE;IACE,wBAAwB,EAAA,EACzB","sourcesContent":["@import \"./icons.scss\";\n\n// Dark Theme\n// @import \"./bootstrap-dark.scss\";\n// @import \"./app-dark.scss\";\n\n// Light Theme\n@import \"./bootstrap.scss\";\n@import \"./app.scss\";\n\n// rtl Direction\n// @import \"./custom/rtl/general-rtl\";\n// @import \"./custom/rtl/bootstrap-rtl\";\n// @import \"./custom/rtl/spacing-rtl\";\n// @import \"./custom/rtl/float-rtl\";\n// @import \"./custom/rtl/text-rtl\";\n// @import \"./custom/rtl/structure-rtl\";\n// @import \"./custom/rtl/plugins-rtl\";\n// @import \"./custom/rtl/components-rtl\";\n// @import \"./custom/rtl/pages-rtl\";\n\nhtml {\n  background-color: white !important;\n}\n\nbody {\n  * {\n    outline: none;\n    font-family: $font-family-sans-serif;\n  }\n}\n\n.ReactModalPortal{\n  & > div{\n    z-index: 1056 !important;\n  }\n}\n\n.close {\n  background: transparent;\n  border: 0;\n  font-size: 10px;\n  padding: 1.35rem 1.25rem;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width\n    auto no-repeat;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  width: 1em;\n  height: 1em;\n  z-index: 2;\n  span {\n    display: none;\n  }\n}\n\n.modal-backdrop {    \n    width: 100%;\n    height: 100%;\n}\n\n.modal-content {\n    border-radius: 1em;\n}\n\n.modal-content p, .modal-content span, .modal-content strong {\n  color: $dark_gray_primary\n}\n\n\n.btn-danger {    \n    background: $red;\n}\n\n\nbutton.mx-2.btn.btn-danger-dark {\n  border: 1px solid $red;\n  background-color: $red;\n  font-family: $font-family-sans-serif;\n}\n\nbutton.mx-2.btn.btn-primary-dark {\n  font-family: $font-family-sans-serif;\n  border: 1px solid $primary-dark;\n  background-color: $primary-dark;\n}\n\n\nbutton.waves-effect.mx-2.btn.btn-link.primary-dark {  \n  color: $primary-dark;\n  font-weight: $font-weight-bold;\n}\n\n.hover-red:hover {\n  color: $red !important;\n  text-decoration: none;\n}\n\n.gray-700-text{\n  color: $gray-700 !important;\n}\n\n.bg-yellow{\n  background: $yellow !important;\n}\n.dados-pessoais {\n  height: fit-content;\n  & .card {\n    box-shadow: none !important;\n    padding: 8px;\n  }\n}\n\nlabel {\n    font-weight: 400;\n}\n\n.shadow-card {\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n    border-radius: 12px;\n}\n\n.link-primary-01 {\n  color: $light_blue_01;\n}\n\n.notify-circle{\n    background-color: $light_blue_01;\n    color: white !important;\n    border-radius: 50px;\n    font-size: $font-size-sm;\n    width: 33px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px;    \n    margin-left: 10px;\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n}","/*\nTemplate Name: Upzet -  Admin & Dashboard Template\nAuthor: Themesdesign\nVersion: 1.1.0\nContact: themesdesign.in@gmail.com\nFile: Icons Css File\n*/\n\n// Plugins\n@import \"custom/plugins/icons\";\n","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=5.9.55\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=5.9.55\") format(\"embedded-opentype\"), url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=5.9.55\") format(\"woff2\"), url(\"../../../../fonts/materialdesignicons-webfont.woff?v=5.9.55\") format(\"woff\"), url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=5.9.55\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\F16E0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-adobe::before {\n  content: \"\\F0936\";\n}\n\n.mdi-adobe-acrobat::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\F171E\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\F171F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-amazon::before {\n  content: \"\\F002D\";\n}\n\n.mdi-amazon-alexa::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-auto::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-android-debug-bridge::before {\n  content: \"\\F0033\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-airplay::before {\n  content: \"\\F001F\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F1555\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bandcamp::before {\n  content: \"\\F0675\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-battlenet::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blogger::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolnisi-cross::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\F1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\F1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buddhism::before {\n  content: \"\\F094B\";\n}\n\n.mdi-buffer::before {\n  content: \"\\F0619\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\F16E1\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cash-usd::before {\n  content: \"\\F1176\";\n}\n\n.mdi-cash-usd-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-android::before {\n  content: \"\\F011D\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-erase::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-iphone::before {\n  content: \"\\F0120\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-celtic-cross::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\F1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\F1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-box-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-check-box-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\F1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-christianity::before {\n  content: \"\\F0953\";\n}\n\n.mdi-christianity-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\F16E2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\F16E3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-concourse-ci::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\F16E4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\F16E5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\F16E6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\F16E7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\F16E8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\F16E9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\F16EA\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\F16EB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\F16EC\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\F16ED\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-circle::before {\n  content: \"\\F116B\";\n}\n\n.mdi-currency-usd-circle-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-do-not-disturb::before {\n  content: \"\\F0698\";\n}\n\n.mdi-do-not-disturb-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\F16EE\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-douban::before {\n  content: \"\\F069A\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-profile-woman::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\F171D\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-pdf-box-outline::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-file-pdf-outline::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\F1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\F1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\F171C\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gif::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\F16EF\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\F16F0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\F16F1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\F16F2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-photos::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-hinduism::before {\n  content: \"\\F0973\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-currency-usd::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-iframe::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-iframe-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-iframe-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-iframe-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-iframe-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-iframe-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-iframe-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-iframe-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-iframe-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-iframe-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-islam::before {\n  content: \"\\F0979\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-judaism::before {\n  content: \"\\F097A\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\F173C\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-koala::before {\n  content: \"\\F173F\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-chromebook::before {\n  content: \"\\F0323\";\n}\n\n.mdi-laptop-mac::before {\n  content: \"\\F0324\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laptop-windows::before {\n  content: \"\\F0325\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\F173A\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\F173B\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\F173D\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\F173E\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-edge-legacy::before {\n  content: \"\\F1250\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microsoft-yammer::before {\n  content: \"\\F0789\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-clean::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\F16F3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\F16F4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\F16F5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\F16F6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\F16F7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\F16F8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\F16F9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\F16FA\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\F16FB\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\F16FC\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\F16FD\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\F16FE\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\F16FF\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\F1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\F1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\F1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\F1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\F1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\F1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\F1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\F1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\F1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\F1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\F170A\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\F170B\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\F170C\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\F170D\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\F170E\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\F170F\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\F1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\F1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\F1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\F1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\F1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\F1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\F1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\F1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\F1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-pdf-box::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-pharmacy::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-one::before {\n  content: \"\\F041B\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-poll-box::before {\n  content: \"\\F0420\";\n}\n\n.mdi-poll-box-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\F1724\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\F1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\F171A\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\F1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\F1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\F1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\F1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-sparkles::before {\n  content: \"\\F1545\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\F1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\F1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\F1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\F172A\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\F1743\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-tablet-ipad::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\F172B\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\F172C\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\F172D\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\F172E\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\F172F\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\F1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\F1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\F1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teach::before {\n  content: \"\\F0890\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-telegram::before {\n  content: \"\\F0501\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-clean::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-subject::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\F1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\F1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\F1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\F1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-turkey::before {\n  content: \"\\F171B\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-twitter-retweet::before {\n  content: \"\\F0547\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-untappd::before {\n  content: \"\\F0551\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vk::before {\n  content: \"\\F0579\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\F1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xamarin-outline::before {\n  content: \"\\F0846\";\n}\n\n.mdi-xing::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-y-combinator::before {\n  content: \"\\F0624\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","@charset \"UTF-8\";\n\n@font-face {\n  font-family: \"dripicons-v2\";\n  src:url(\"../../../../fonts/dripicons-v2.eot\");\n  src:url(\"../../../../fonts/dripicons-v2.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"),\n    url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"),\n    url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n\n}\n\n[data-icon]:before {\n  font-family: \"dripicons-v2\" !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"dripicons-\"]:before,\n[class*=\" dripicons-\"]:before {\n  font-family: \"dripicons-v2\" !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.dripicons-alarm:before {\n  content: \"\\61\";\n}\n.dripicons-align-center:before {\n  content: \"\\62\";\n}\n.dripicons-align-justify:before {\n  content: \"\\63\";\n}\n.dripicons-align-left:before {\n  content: \"\\64\";\n}\n.dripicons-align-right:before {\n  content: \"\\65\";\n}\n.dripicons-anchor:before {\n  content: \"\\66\";\n}\n.dripicons-archive:before {\n  content: \"\\67\";\n}\n.dripicons-arrow-down:before {\n  content: \"\\68\";\n}\n.dripicons-arrow-left:before {\n  content: \"\\69\";\n}\n.dripicons-arrow-right:before {\n  content: \"\\6a\";\n}\n.dripicons-arrow-thin-down:before {\n  content: \"\\6b\";\n}\n.dripicons-arrow-thin-left:before {\n  content: \"\\6c\";\n}\n.dripicons-arrow-thin-right:before {\n  content: \"\\6d\";\n}\n.dripicons-arrow-thin-up:before {\n  content: \"\\6e\";\n}\n.dripicons-arrow-up:before {\n  content: \"\\6f\";\n}\n.dripicons-article:before {\n  content: \"\\70\";\n}\n.dripicons-backspace:before {\n  content: \"\\71\";\n}\n.dripicons-basket:before {\n  content: \"\\72\";\n}\n.dripicons-basketball:before {\n  content: \"\\73\";\n}\n.dripicons-battery-empty:before {\n  content: \"\\74\";\n}\n.dripicons-battery-full:before {\n  content: \"\\75\";\n}\n.dripicons-battery-low:before {\n  content: \"\\76\";\n}\n.dripicons-battery-medium:before {\n  content: \"\\77\";\n}\n.dripicons-bell:before {\n  content: \"\\78\";\n}\n.dripicons-blog:before {\n  content: \"\\79\";\n}\n.dripicons-bluetooth:before {\n  content: \"\\7a\";\n}\n.dripicons-bold:before {\n  content: \"\\41\";\n}\n.dripicons-bookmark:before {\n  content: \"\\42\";\n}\n.dripicons-bookmarks:before {\n  content: \"\\43\";\n}\n.dripicons-box:before {\n  content: \"\\44\";\n}\n.dripicons-briefcase:before {\n  content: \"\\45\";\n}\n.dripicons-brightness-low:before {\n  content: \"\\46\";\n}\n.dripicons-brightness-max:before {\n  content: \"\\47\";\n}\n.dripicons-brightness-medium:before {\n  content: \"\\48\";\n}\n.dripicons-broadcast:before {\n  content: \"\\49\";\n}\n.dripicons-browser:before {\n  content: \"\\4a\";\n}\n.dripicons-browser-upload:before {\n  content: \"\\4b\";\n}\n.dripicons-brush:before {\n  content: \"\\4c\";\n}\n.dripicons-calendar:before {\n  content: \"\\4d\";\n}\n.dripicons-camcorder:before {\n  content: \"\\4e\";\n}\n.dripicons-camera:before {\n  content: \"\\4f\";\n}\n.dripicons-card:before {\n  content: \"\\50\";\n}\n.dripicons-cart:before {\n  content: \"\\51\";\n}\n.dripicons-checklist:before {\n  content: \"\\52\";\n}\n.dripicons-checkmark:before {\n  content: \"\\53\";\n}\n.dripicons-chevron-down:before {\n  content: \"\\54\";\n}\n.dripicons-chevron-left:before {\n  content: \"\\55\";\n}\n.dripicons-chevron-right:before {\n  content: \"\\56\";\n}\n.dripicons-chevron-up:before {\n  content: \"\\57\";\n}\n.dripicons-clipboard:before {\n  content: \"\\58\";\n}\n.dripicons-clock:before {\n  content: \"\\59\";\n}\n.dripicons-clockwise:before {\n  content: \"\\5a\";\n}\n.dripicons-cloud:before {\n  content: \"\\30\";\n}\n.dripicons-cloud-download:before {\n  content: \"\\31\";\n}\n.dripicons-cloud-upload:before {\n  content: \"\\32\";\n}\n.dripicons-code:before {\n  content: \"\\33\";\n}\n.dripicons-contract:before {\n  content: \"\\34\";\n}\n.dripicons-contract-2:before {\n  content: \"\\35\";\n}\n.dripicons-conversation:before {\n  content: \"\\36\";\n}\n.dripicons-copy:before {\n  content: \"\\37\";\n}\n.dripicons-crop:before {\n  content: \"\\38\";\n}\n.dripicons-cross:before {\n  content: \"\\39\";\n}\n.dripicons-crosshair:before {\n  content: \"\\21\";\n}\n.dripicons-cutlery:before {\n  content: \"\\22\";\n}\n.dripicons-device-desktop:before {\n  content: \"\\23\";\n}\n.dripicons-device-mobile:before {\n  content: \"\\24\";\n}\n.dripicons-device-tablet:before {\n  content: \"\\25\";\n}\n.dripicons-direction:before {\n  content: \"\\26\";\n}\n.dripicons-disc:before {\n  content: \"\\27\";\n}\n.dripicons-document:before {\n  content: \"\\28\";\n}\n.dripicons-document-delete:before {\n  content: \"\\29\";\n}\n.dripicons-document-edit:before {\n  content: \"\\2a\";\n}\n.dripicons-document-new:before {\n  content: \"\\2b\";\n}\n.dripicons-document-remove:before {\n  content: \"\\2c\";\n}\n.dripicons-dot:before {\n  content: \"\\2d\";\n}\n.dripicons-dots-2:before {\n  content: \"\\2e\";\n}\n.dripicons-dots-3:before {\n  content: \"\\2f\";\n}\n.dripicons-download:before {\n  content: \"\\3a\";\n}\n.dripicons-duplicate:before {\n  content: \"\\3b\";\n}\n.dripicons-enter:before {\n  content: \"\\3c\";\n}\n.dripicons-exit:before {\n  content: \"\\3d\";\n}\n.dripicons-expand:before {\n  content: \"\\3e\";\n}\n.dripicons-expand-2:before {\n  content: \"\\3f\";\n}\n.dripicons-experiment:before {\n  content: \"\\40\";\n}\n.dripicons-export:before {\n  content: \"\\5b\";\n}\n.dripicons-feed:before {\n  content: \"\\5d\";\n}\n.dripicons-flag:before {\n  content: \"\\5e\";\n}\n.dripicons-flashlight:before {\n  content: \"\\5f\";\n}\n.dripicons-folder:before {\n  content: \"\\60\";\n}\n.dripicons-folder-open:before {\n  content: \"\\7b\";\n}\n.dripicons-forward:before {\n  content: \"\\7c\";\n}\n.dripicons-gaming:before {\n  content: \"\\7d\";\n}\n.dripicons-gear:before {\n  content: \"\\7e\";\n}\n.dripicons-graduation:before {\n  content: \"\\5c\";\n}\n.dripicons-graph-bar:before {\n  content: \"\\e000\";\n}\n.dripicons-graph-line:before {\n  content: \"\\e001\";\n}\n.dripicons-graph-pie:before {\n  content: \"\\e002\";\n}\n.dripicons-headset:before {\n  content: \"\\e003\";\n}\n.dripicons-heart:before {\n  content: \"\\e004\";\n}\n.dripicons-help:before {\n  content: \"\\e005\";\n}\n.dripicons-home:before {\n  content: \"\\e006\";\n}\n.dripicons-hourglass:before {\n  content: \"\\e007\";\n}\n.dripicons-inbox:before {\n  content: \"\\e008\";\n}\n.dripicons-information:before {\n  content: \"\\e009\";\n}\n.dripicons-italic:before {\n  content: \"\\e00a\";\n}\n.dripicons-jewel:before {\n  content: \"\\e00b\";\n}\n.dripicons-lifting:before {\n  content: \"\\e00c\";\n}\n.dripicons-lightbulb:before {\n  content: \"\\e00d\";\n}\n.dripicons-link:before {\n  content: \"\\e00e\";\n}\n.dripicons-link-broken:before {\n  content: \"\\e00f\";\n}\n.dripicons-list:before {\n  content: \"\\e010\";\n}\n.dripicons-loading:before {\n  content: \"\\e011\";\n}\n.dripicons-location:before {\n  content: \"\\e012\";\n}\n.dripicons-lock:before {\n  content: \"\\e013\";\n}\n.dripicons-lock-open:before {\n  content: \"\\e014\";\n}\n.dripicons-mail:before {\n  content: \"\\e015\";\n}\n.dripicons-map:before {\n  content: \"\\e016\";\n}\n.dripicons-media-loop:before {\n  content: \"\\e017\";\n}\n.dripicons-media-next:before {\n  content: \"\\e018\";\n}\n.dripicons-media-pause:before {\n  content: \"\\e019\";\n}\n.dripicons-media-play:before {\n  content: \"\\e01a\";\n}\n.dripicons-media-previous:before {\n  content: \"\\e01b\";\n}\n.dripicons-media-record:before {\n  content: \"\\e01c\";\n}\n.dripicons-media-shuffle:before {\n  content: \"\\e01d\";\n}\n.dripicons-media-stop:before {\n  content: \"\\e01e\";\n}\n.dripicons-medical:before {\n  content: \"\\e01f\";\n}\n.dripicons-menu:before {\n  content: \"\\e020\";\n}\n.dripicons-message:before {\n  content: \"\\e021\";\n}\n.dripicons-meter:before {\n  content: \"\\e022\";\n}\n.dripicons-microphone:before {\n  content: \"\\e023\";\n}\n.dripicons-minus:before {\n  content: \"\\e024\";\n}\n.dripicons-monitor:before {\n  content: \"\\e025\";\n}\n.dripicons-move:before {\n  content: \"\\e026\";\n}\n.dripicons-music:before {\n  content: \"\\e027\";\n}\n.dripicons-network-1:before {\n  content: \"\\e028\";\n}\n.dripicons-network-2:before {\n  content: \"\\e029\";\n}\n.dripicons-network-3:before {\n  content: \"\\e02a\";\n}\n.dripicons-network-4:before {\n  content: \"\\e02b\";\n}\n.dripicons-network-5:before {\n  content: \"\\e02c\";\n}\n.dripicons-pamphlet:before {\n  content: \"\\e02d\";\n}\n.dripicons-paperclip:before {\n  content: \"\\e02e\";\n}\n.dripicons-pencil:before {\n  content: \"\\e02f\";\n}\n.dripicons-phone:before {\n  content: \"\\e030\";\n}\n.dripicons-photo:before {\n  content: \"\\e031\";\n}\n.dripicons-photo-group:before {\n  content: \"\\e032\";\n}\n.dripicons-pill:before {\n  content: \"\\e033\";\n}\n.dripicons-pin:before {\n  content: \"\\e034\";\n}\n.dripicons-plus:before {\n  content: \"\\e035\";\n}\n.dripicons-power:before {\n  content: \"\\e036\";\n}\n.dripicons-preview:before {\n  content: \"\\e037\";\n}\n.dripicons-print:before {\n  content: \"\\e038\";\n}\n.dripicons-pulse:before {\n  content: \"\\e039\";\n}\n.dripicons-question:before {\n  content: \"\\e03a\";\n}\n.dripicons-reply:before {\n  content: \"\\e03b\";\n}\n.dripicons-reply-all:before {\n  content: \"\\e03c\";\n}\n.dripicons-return:before {\n  content: \"\\e03d\";\n}\n.dripicons-retweet:before {\n  content: \"\\e03e\";\n}\n.dripicons-rocket:before {\n  content: \"\\e03f\";\n}\n.dripicons-scale:before {\n  content: \"\\e040\";\n}\n.dripicons-search:before {\n  content: \"\\e041\";\n}\n.dripicons-shopping-bag:before {\n  content: \"\\e042\";\n}\n.dripicons-skip:before {\n  content: \"\\e043\";\n}\n.dripicons-stack:before {\n  content: \"\\e044\";\n}\n.dripicons-star:before {\n  content: \"\\e045\";\n}\n.dripicons-stopwatch:before {\n  content: \"\\e046\";\n}\n.dripicons-store:before {\n  content: \"\\e047\";\n}\n.dripicons-suitcase:before {\n  content: \"\\e048\";\n}\n.dripicons-swap:before {\n  content: \"\\e049\";\n}\n.dripicons-tag:before {\n  content: \"\\e04a\";\n}\n.dripicons-tag-delete:before {\n  content: \"\\e04b\";\n}\n.dripicons-tags:before {\n  content: \"\\e04c\";\n}\n.dripicons-thumbs-down:before {\n  content: \"\\e04d\";\n}\n.dripicons-thumbs-up:before {\n  content: \"\\e04e\";\n}\n.dripicons-ticket:before {\n  content: \"\\e04f\";\n}\n.dripicons-time-reverse:before {\n  content: \"\\e050\";\n}\n.dripicons-to-do:before {\n  content: \"\\e051\";\n}\n.dripicons-toggles:before {\n  content: \"\\e052\";\n}\n.dripicons-trash:before {\n  content: \"\\e053\";\n}\n.dripicons-trophy:before {\n  content: \"\\e054\";\n}\n.dripicons-upload:before {\n  content: \"\\e055\";\n}\n.dripicons-user:before {\n  content: \"\\e056\";\n}\n.dripicons-user-group:before {\n  content: \"\\e057\";\n}\n.dripicons-user-id:before {\n  content: \"\\e058\";\n}\n.dripicons-vibrate:before {\n  content: \"\\e059\";\n}\n.dripicons-view-apps:before {\n  content: \"\\e05a\";\n}\n.dripicons-view-list:before {\n  content: \"\\e05b\";\n}\n.dripicons-view-list-large:before {\n  content: \"\\e05c\";\n}\n.dripicons-view-thumb:before {\n  content: \"\\e05d\";\n}\n.dripicons-volume-full:before {\n  content: \"\\e05e\";\n}\n.dripicons-volume-low:before {\n  content: \"\\e05f\";\n}\n.dripicons-volume-medium:before {\n  content: \"\\e060\";\n}\n.dripicons-volume-off:before {\n  content: \"\\e061\";\n}\n.dripicons-wallet:before {\n  content: \"\\e062\";\n}\n.dripicons-warning:before {\n  content: \"\\e063\";\n}\n.dripicons-web:before {\n  content: \"\\e064\";\n}\n.dripicons-weight:before {\n  content: \"\\e065\";\n}\n.dripicons-wifi:before {\n  content: \"\\e066\";\n}\n.dripicons-wrong:before {\n  content: \"\\e067\";\n}\n.dripicons-zoom-in:before {\n  content: \"\\e068\";\n}\n.dripicons-zoom-out:before {\n  content: \"\\e069\";\n}\n","/*\n* Remix Icon v2.4.0\n* https://remixicon.com\n* https://github.com/Remix-Design/RemixIcon\n*\n* Copyright RemixIcon.com\n* Released under the Apache License Version 2.0\n*\n* Date: 2020-04-20\n*/\n@font-face {\n  font-family: \"remixicon\";\n  src: url('../../../../fonts/remixicon.eot?t=1587359857360'); /* IE9*/\n  src: url('../../../../fonts/remixicon.eot?t=1587359857360#iefix') format('embedded-opentype'), /* IE6-IE8 */\n  url(\"../../../../fonts/remixicon.woff2?t=1587359857360\") format(\"woff2\"),\n  url(\"../../../../fonts/remixicon.woff?t=1587359857360\") format(\"woff\"),\n  url('../../../../fonts/remixicon.ttf?t=1587359857360') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n  url('../../../../fonts/remixicon.svg?t=1587359857360#remixicon') format('svg'); /* iOS 4.1- */\n  font-display: swap;\n}\n\n[class^=\"ri-\"], [class*=\" ri-\"] {\n  font-family: 'remixicon' !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\n.ri-xxs { font-size: .5em; }\n.ri-xs { font-size: .75em; }\n.ri-sm { font-size: .875em }\n.ri-1x { font-size: 1em; }\n.ri-2x { font-size: 2em; }\n.ri-3x { font-size: 3em; }\n.ri-4x { font-size: 4em; }\n.ri-5x { font-size: 5em; }\n.ri-6x { font-size: 6em; }\n.ri-7x { font-size: 7em; }\n.ri-8x { font-size: 8em; }\n.ri-9x { font-size: 9em; }\n.ri-10x { font-size: 10em; }\n.ri-fw { text-align: center; width: 1.25em; }\n\n.ri-4k-fill:before { content: \"\\ea01\"; }\n.ri-4k-line:before { content: \"\\ea02\"; }\n.ri-a-b:before { content: \"\\ea03\"; }\n.ri-account-box-fill:before { content: \"\\ea04\"; }\n.ri-account-box-line:before { content: \"\\ea05\"; }\n.ri-account-circle-fill:before { content: \"\\ea06\"; }\n.ri-account-circle-line:before { content: \"\\ea07\"; }\n.ri-account-pin-box-fill:before { content: \"\\ea08\"; }\n.ri-account-pin-box-line:before { content: \"\\ea09\"; }\n.ri-account-pin-circle-fill:before { content: \"\\ea0a\"; }\n.ri-account-pin-circle-line:before { content: \"\\ea0b\"; }\n.ri-add-box-fill:before { content: \"\\ea0c\"; }\n.ri-add-box-line:before { content: \"\\ea0d\"; }\n.ri-add-circle-fill:before { content: \"\\ea0e\"; }\n.ri-add-circle-line:before { content: \"\\ea0f\"; }\n.ri-add-fill:before { content: \"\\ea10\"; }\n.ri-add-line:before { content: \"\\ea11\"; }\n.ri-admin-fill:before { content: \"\\ea12\"; }\n.ri-admin-line:before { content: \"\\ea13\"; }\n.ri-advertisement-fill:before { content: \"\\ea14\"; }\n.ri-advertisement-line:before { content: \"\\ea15\"; }\n.ri-airplay-fill:before { content: \"\\ea16\"; }\n.ri-airplay-line:before { content: \"\\ea17\"; }\n.ri-alarm-fill:before { content: \"\\ea18\"; }\n.ri-alarm-line:before { content: \"\\ea19\"; }\n.ri-alarm-warning-fill:before { content: \"\\ea1a\"; }\n.ri-alarm-warning-line:before { content: \"\\ea1b\"; }\n.ri-album-fill:before { content: \"\\ea1c\"; }\n.ri-album-line:before { content: \"\\ea1d\"; }\n.ri-alert-fill:before { content: \"\\ea1e\"; }\n.ri-alert-line:before { content: \"\\ea1f\"; }\n.ri-aliens-fill:before { content: \"\\ea20\"; }\n.ri-aliens-line:before { content: \"\\ea21\"; }\n.ri-align-bottom:before { content: \"\\ea22\"; }\n.ri-align-center:before { content: \"\\ea23\"; }\n.ri-align-justify:before { content: \"\\ea24\"; }\n.ri-align-left:before { content: \"\\ea25\"; }\n.ri-align-right:before { content: \"\\ea26\"; }\n.ri-align-top:before { content: \"\\ea27\"; }\n.ri-align-vertically:before { content: \"\\ea28\"; }\n.ri-alipay-fill:before { content: \"\\ea29\"; }\n.ri-alipay-line:before { content: \"\\ea2a\"; }\n.ri-amazon-fill:before { content: \"\\ea2b\"; }\n.ri-amazon-line:before { content: \"\\ea2c\"; }\n.ri-anchor-fill:before { content: \"\\ea2d\"; }\n.ri-anchor-line:before { content: \"\\ea2e\"; }\n.ri-ancient-gate-fill:before { content: \"\\ea2f\"; }\n.ri-ancient-gate-line:before { content: \"\\ea30\"; }\n.ri-ancient-pavilion-fill:before { content: \"\\ea31\"; }\n.ri-ancient-pavilion-line:before { content: \"\\ea32\"; }\n.ri-android-fill:before { content: \"\\ea33\"; }\n.ri-android-line:before { content: \"\\ea34\"; }\n.ri-angularjs-fill:before { content: \"\\ea35\"; }\n.ri-angularjs-line:before { content: \"\\ea36\"; }\n.ri-anticlockwise-2-fill:before { content: \"\\ea37\"; }\n.ri-anticlockwise-2-line:before { content: \"\\ea38\"; }\n.ri-anticlockwise-fill:before { content: \"\\ea39\"; }\n.ri-anticlockwise-line:before { content: \"\\ea3a\"; }\n.ri-app-store-fill:before { content: \"\\ea3b\"; }\n.ri-app-store-line:before { content: \"\\ea3c\"; }\n.ri-apple-fill:before { content: \"\\ea3d\"; }\n.ri-apple-line:before { content: \"\\ea3e\"; }\n.ri-apps-2-fill:before { content: \"\\ea3f\"; }\n.ri-apps-2-line:before { content: \"\\ea40\"; }\n.ri-apps-fill:before { content: \"\\ea41\"; }\n.ri-apps-line:before { content: \"\\ea42\"; }\n.ri-archive-drawer-fill:before { content: \"\\ea43\"; }\n.ri-archive-drawer-line:before { content: \"\\ea44\"; }\n.ri-archive-fill:before { content: \"\\ea45\"; }\n.ri-archive-line:before { content: \"\\ea46\"; }\n.ri-arrow-down-circle-fill:before { content: \"\\ea47\"; }\n.ri-arrow-down-circle-line:before { content: \"\\ea48\"; }\n.ri-arrow-down-fill:before { content: \"\\ea49\"; }\n.ri-arrow-down-line:before { content: \"\\ea4a\"; }\n.ri-arrow-down-s-fill:before { content: \"\\ea4b\"; }\n.ri-arrow-down-s-line:before { content: \"\\ea4c\"; }\n.ri-arrow-drop-down-fill:before { content: \"\\ea4d\"; }\n.ri-arrow-drop-down-line:before { content: \"\\ea4e\"; }\n.ri-arrow-drop-left-fill:before { content: \"\\ea4f\"; }\n.ri-arrow-drop-left-line:before { content: \"\\ea50\"; }\n.ri-arrow-drop-right-fill:before { content: \"\\ea51\"; }\n.ri-arrow-drop-right-line:before { content: \"\\ea52\"; }\n.ri-arrow-drop-up-fill:before { content: \"\\ea53\"; }\n.ri-arrow-drop-up-line:before { content: \"\\ea54\"; }\n.ri-arrow-go-back-fill:before { content: \"\\ea55\"; }\n.ri-arrow-go-back-line:before { content: \"\\ea56\"; }\n.ri-arrow-go-forward-fill:before { content: \"\\ea57\"; }\n.ri-arrow-go-forward-line:before { content: \"\\ea58\"; }\n.ri-arrow-left-circle-fill:before { content: \"\\ea59\"; }\n.ri-arrow-left-circle-line:before { content: \"\\ea5a\"; }\n.ri-arrow-left-down-fill:before { content: \"\\ea5b\"; }\n.ri-arrow-left-down-line:before { content: \"\\ea5c\"; }\n.ri-arrow-left-fill:before { content: \"\\ea5d\"; }\n.ri-arrow-left-line:before { content: \"\\ea5e\"; }\n.ri-arrow-left-right-fill:before { content: \"\\ea5f\"; }\n.ri-arrow-left-right-line:before { content: \"\\ea60\"; }\n.ri-arrow-left-s-fill:before { content: \"\\ea61\"; }\n.ri-arrow-left-s-line:before { content: \"\\ea62\"; }\n.ri-arrow-left-up-fill:before { content: \"\\ea63\"; }\n.ri-arrow-left-up-line:before { content: \"\\ea64\"; }\n.ri-arrow-right-circle-fill:before { content: \"\\ea65\"; }\n.ri-arrow-right-circle-line:before { content: \"\\ea66\"; }\n.ri-arrow-right-down-fill:before { content: \"\\ea67\"; }\n.ri-arrow-right-down-line:before { content: \"\\ea68\"; }\n.ri-arrow-right-fill:before { content: \"\\ea69\"; }\n.ri-arrow-right-line:before { content: \"\\ea6a\"; }\n.ri-arrow-right-s-fill:before { content: \"\\ea6b\"; }\n.ri-arrow-right-s-line:before { content: \"\\ea6c\"; }\n.ri-arrow-right-up-fill:before { content: \"\\ea6d\"; }\n.ri-arrow-right-up-line:before { content: \"\\ea6e\"; }\n.ri-arrow-up-circle-fill:before { content: \"\\ea6f\"; }\n.ri-arrow-up-circle-line:before { content: \"\\ea70\"; }\n.ri-arrow-up-down-fill:before { content: \"\\ea71\"; }\n.ri-arrow-up-down-line:before { content: \"\\ea72\"; }\n.ri-arrow-up-fill:before { content: \"\\ea73\"; }\n.ri-arrow-up-line:before { content: \"\\ea74\"; }\n.ri-arrow-up-s-fill:before { content: \"\\ea75\"; }\n.ri-arrow-up-s-line:before { content: \"\\ea76\"; }\n.ri-artboard-2-fill:before { content: \"\\ea77\"; }\n.ri-artboard-2-line:before { content: \"\\ea78\"; }\n.ri-artboard-fill:before { content: \"\\ea79\"; }\n.ri-artboard-line:before { content: \"\\ea7a\"; }\n.ri-article-fill:before { content: \"\\ea7b\"; }\n.ri-article-line:before { content: \"\\ea7c\"; }\n.ri-aspect-ratio-fill:before { content: \"\\ea7d\"; }\n.ri-aspect-ratio-line:before { content: \"\\ea7e\"; }\n.ri-asterisk:before { content: \"\\ea7f\"; }\n.ri-at-fill:before { content: \"\\ea80\"; }\n.ri-at-line:before { content: \"\\ea81\"; }\n.ri-attachment-2:before { content: \"\\ea82\"; }\n.ri-attachment-fill:before { content: \"\\ea83\"; }\n.ri-attachment-line:before { content: \"\\ea84\"; }\n.ri-auction-fill:before { content: \"\\ea85\"; }\n.ri-auction-line:before { content: \"\\ea86\"; }\n.ri-award-fill:before { content: \"\\ea87\"; }\n.ri-award-line:before { content: \"\\ea88\"; }\n.ri-baidu-fill:before { content: \"\\ea89\"; }\n.ri-baidu-line:before { content: \"\\ea8a\"; }\n.ri-ball-pen-fill:before { content: \"\\ea8b\"; }\n.ri-ball-pen-line:before { content: \"\\ea8c\"; }\n.ri-bank-card-2-fill:before { content: \"\\ea8d\"; }\n.ri-bank-card-2-line:before { content: \"\\ea8e\"; }\n.ri-bank-card-fill:before { content: \"\\ea8f\"; }\n.ri-bank-card-line:before { content: \"\\ea90\"; }\n.ri-bank-fill:before { content: \"\\ea91\"; }\n.ri-bank-line:before { content: \"\\ea92\"; }\n.ri-bar-chart-2-fill:before { content: \"\\ea93\"; }\n.ri-bar-chart-2-line:before { content: \"\\ea94\"; }\n.ri-bar-chart-box-fill:before { content: \"\\ea95\"; }\n.ri-bar-chart-box-line:before { content: \"\\ea96\"; }\n.ri-bar-chart-fill:before { content: \"\\ea97\"; }\n.ri-bar-chart-grouped-fill:before { content: \"\\ea98\"; }\n.ri-bar-chart-grouped-line:before { content: \"\\ea99\"; }\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9a\"; }\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9b\"; }\n.ri-bar-chart-line:before { content: \"\\ea9c\"; }\n.ri-barcode-box-fill:before { content: \"\\ea9d\"; }\n.ri-barcode-box-line:before { content: \"\\ea9e\"; }\n.ri-barcode-fill:before { content: \"\\ea9f\"; }\n.ri-barcode-line:before { content: \"\\eaa0\"; }\n.ri-barricade-fill:before { content: \"\\eaa1\"; }\n.ri-barricade-line:before { content: \"\\eaa2\"; }\n.ri-base-station-fill:before { content: \"\\eaa3\"; }\n.ri-base-station-line:before { content: \"\\eaa4\"; }\n.ri-basketball-fill:before { content: \"\\eaa5\"; }\n.ri-basketball-line:before { content: \"\\eaa6\"; }\n.ri-battery-2-charge-fill:before { content: \"\\eaa7\"; }\n.ri-battery-2-charge-line:before { content: \"\\eaa8\"; }\n.ri-battery-2-fill:before { content: \"\\eaa9\"; }\n.ri-battery-2-line:before { content: \"\\eaaa\"; }\n.ri-battery-charge-fill:before { content: \"\\eaab\"; }\n.ri-battery-charge-line:before { content: \"\\eaac\"; }\n.ri-battery-fill:before { content: \"\\eaad\"; }\n.ri-battery-line:before { content: \"\\eaae\"; }\n.ri-battery-low-fill:before { content: \"\\eaaf\"; }\n.ri-battery-low-line:before { content: \"\\eab0\"; }\n.ri-battery-saver-fill:before { content: \"\\eab1\"; }\n.ri-battery-saver-line:before { content: \"\\eab2\"; }\n.ri-battery-share-fill:before { content: \"\\eab3\"; }\n.ri-battery-share-line:before { content: \"\\eab4\"; }\n.ri-bear-smile-fill:before { content: \"\\eab5\"; }\n.ri-bear-smile-line:before { content: \"\\eab6\"; }\n.ri-behance-fill:before { content: \"\\eab7\"; }\n.ri-behance-line:before { content: \"\\eab8\"; }\n.ri-bell-fill:before { content: \"\\eab9\"; }\n.ri-bell-line:before { content: \"\\eaba\"; }\n.ri-bike-fill:before { content: \"\\eabb\"; }\n.ri-bike-line:before { content: \"\\eabc\"; }\n.ri-bilibili-fill:before { content: \"\\eabd\"; }\n.ri-bilibili-line:before { content: \"\\eabe\"; }\n.ri-bill-fill:before { content: \"\\eabf\"; }\n.ri-bill-line:before { content: \"\\eac0\"; }\n.ri-billiards-fill:before { content: \"\\eac1\"; }\n.ri-billiards-line:before { content: \"\\eac2\"; }\n.ri-bit-coin-fill:before { content: \"\\eac3\"; }\n.ri-bit-coin-line:before { content: \"\\eac4\"; }\n.ri-blaze-fill:before { content: \"\\eac5\"; }\n.ri-blaze-line:before { content: \"\\eac6\"; }\n.ri-bluetooth-connect-fill:before { content: \"\\eac7\"; }\n.ri-bluetooth-connect-line:before { content: \"\\eac8\"; }\n.ri-bluetooth-fill:before { content: \"\\eac9\"; }\n.ri-bluetooth-line:before { content: \"\\eaca\"; }\n.ri-blur-off-fill:before { content: \"\\eacb\"; }\n.ri-blur-off-line:before { content: \"\\eacc\"; }\n.ri-body-scan-fill:before { content: \"\\eacd\"; }\n.ri-body-scan-line:before { content: \"\\eace\"; }\n.ri-bold:before { content: \"\\eacf\"; }\n.ri-book-2-fill:before { content: \"\\ead0\"; }\n.ri-book-2-line:before { content: \"\\ead1\"; }\n.ri-book-3-fill:before { content: \"\\ead2\"; }\n.ri-book-3-line:before { content: \"\\ead3\"; }\n.ri-book-fill:before { content: \"\\ead4\"; }\n.ri-book-line:before { content: \"\\ead5\"; }\n.ri-book-mark-fill:before { content: \"\\ead6\"; }\n.ri-book-mark-line:before { content: \"\\ead7\"; }\n.ri-book-open-fill:before { content: \"\\ead8\"; }\n.ri-book-open-line:before { content: \"\\ead9\"; }\n.ri-book-read-fill:before { content: \"\\eada\"; }\n.ri-book-read-line:before { content: \"\\eadb\"; }\n.ri-booklet-fill:before { content: \"\\eadc\"; }\n.ri-booklet-line:before { content: \"\\eadd\"; }\n.ri-bookmark-2-fill:before { content: \"\\eade\"; }\n.ri-bookmark-2-line:before { content: \"\\eadf\"; }\n.ri-bookmark-3-fill:before { content: \"\\eae0\"; }\n.ri-bookmark-3-line:before { content: \"\\eae1\"; }\n.ri-bookmark-fill:before { content: \"\\eae2\"; }\n.ri-bookmark-line:before { content: \"\\eae3\"; }\n.ri-boxing-fill:before { content: \"\\eae4\"; }\n.ri-boxing-line:before { content: \"\\eae5\"; }\n.ri-braces-fill:before { content: \"\\eae6\"; }\n.ri-braces-line:before { content: \"\\eae7\"; }\n.ri-brackets-fill:before { content: \"\\eae8\"; }\n.ri-brackets-line:before { content: \"\\eae9\"; }\n.ri-briefcase-2-fill:before { content: \"\\eaea\"; }\n.ri-briefcase-2-line:before { content: \"\\eaeb\"; }\n.ri-briefcase-3-fill:before { content: \"\\eaec\"; }\n.ri-briefcase-3-line:before { content: \"\\eaed\"; }\n.ri-briefcase-4-fill:before { content: \"\\eaee\"; }\n.ri-briefcase-4-line:before { content: \"\\eaef\"; }\n.ri-briefcase-5-fill:before { content: \"\\eaf0\"; }\n.ri-briefcase-5-line:before { content: \"\\eaf1\"; }\n.ri-briefcase-fill:before { content: \"\\eaf2\"; }\n.ri-briefcase-line:before { content: \"\\eaf3\"; }\n.ri-bring-forward:before { content: \"\\eaf4\"; }\n.ri-bring-to-front:before { content: \"\\eaf5\"; }\n.ri-broadcast-fill:before { content: \"\\eaf6\"; }\n.ri-broadcast-line:before { content: \"\\eaf7\"; }\n.ri-brush-2-fill:before { content: \"\\eaf8\"; }\n.ri-brush-2-line:before { content: \"\\eaf9\"; }\n.ri-brush-3-fill:before { content: \"\\eafa\"; }\n.ri-brush-3-line:before { content: \"\\eafb\"; }\n.ri-brush-4-fill:before { content: \"\\eafc\"; }\n.ri-brush-4-line:before { content: \"\\eafd\"; }\n.ri-brush-fill:before { content: \"\\eafe\"; }\n.ri-brush-line:before { content: \"\\eaff\"; }\n.ri-bubble-chart-fill:before { content: \"\\eb00\"; }\n.ri-bubble-chart-line:before { content: \"\\eb01\"; }\n.ri-bug-2-fill:before { content: \"\\eb02\"; }\n.ri-bug-2-line:before { content: \"\\eb03\"; }\n.ri-bug-fill:before { content: \"\\eb04\"; }\n.ri-bug-line:before { content: \"\\eb05\"; }\n.ri-building-2-fill:before { content: \"\\eb06\"; }\n.ri-building-2-line:before { content: \"\\eb07\"; }\n.ri-building-3-fill:before { content: \"\\eb08\"; }\n.ri-building-3-line:before { content: \"\\eb09\"; }\n.ri-building-4-fill:before { content: \"\\eb0a\"; }\n.ri-building-4-line:before { content: \"\\eb0b\"; }\n.ri-building-fill:before { content: \"\\eb0c\"; }\n.ri-building-line:before { content: \"\\eb0d\"; }\n.ri-bus-2-fill:before { content: \"\\eb0e\"; }\n.ri-bus-2-line:before { content: \"\\eb0f\"; }\n.ri-bus-fill:before { content: \"\\eb10\"; }\n.ri-bus-line:before { content: \"\\eb11\"; }\n.ri-bus-wifi-fill:before { content: \"\\eb12\"; }\n.ri-bus-wifi-line:before { content: \"\\eb13\"; }\n.ri-cake-2-fill:before { content: \"\\eb14\"; }\n.ri-cake-2-line:before { content: \"\\eb15\"; }\n.ri-cake-3-fill:before { content: \"\\eb16\"; }\n.ri-cake-3-line:before { content: \"\\eb17\"; }\n.ri-cake-fill:before { content: \"\\eb18\"; }\n.ri-cake-line:before { content: \"\\eb19\"; }\n.ri-calculator-fill:before { content: \"\\eb1a\"; }\n.ri-calculator-line:before { content: \"\\eb1b\"; }\n.ri-calendar-2-fill:before { content: \"\\eb1c\"; }\n.ri-calendar-2-line:before { content: \"\\eb1d\"; }\n.ri-calendar-check-fill:before { content: \"\\eb1e\"; }\n.ri-calendar-check-line:before { content: \"\\eb1f\"; }\n.ri-calendar-event-fill:before { content: \"\\eb20\"; }\n.ri-calendar-event-line:before { content: \"\\eb21\"; }\n.ri-calendar-fill:before { content: \"\\eb22\"; }\n.ri-calendar-line:before { content: \"\\eb23\"; }\n.ri-calendar-todo-fill:before { content: \"\\eb24\"; }\n.ri-calendar-todo-line:before { content: \"\\eb25\"; }\n.ri-camera-2-fill:before { content: \"\\eb26\"; }\n.ri-camera-2-line:before { content: \"\\eb27\"; }\n.ri-camera-3-fill:before { content: \"\\eb28\"; }\n.ri-camera-3-line:before { content: \"\\eb29\"; }\n.ri-camera-fill:before { content: \"\\eb2a\"; }\n.ri-camera-lens-fill:before { content: \"\\eb2b\"; }\n.ri-camera-lens-line:before { content: \"\\eb2c\"; }\n.ri-camera-line:before { content: \"\\eb2d\"; }\n.ri-camera-off-fill:before { content: \"\\eb2e\"; }\n.ri-camera-off-line:before { content: \"\\eb2f\"; }\n.ri-camera-switch-fill:before { content: \"\\eb30\"; }\n.ri-camera-switch-line:before { content: \"\\eb31\"; }\n.ri-car-fill:before { content: \"\\eb32\"; }\n.ri-car-line:before { content: \"\\eb33\"; }\n.ri-car-washing-fill:before { content: \"\\eb34\"; }\n.ri-car-washing-line:before { content: \"\\eb35\"; }\n.ri-caravan-fill:before { content: \"\\eb36\"; }\n.ri-caravan-line:before { content: \"\\eb37\"; }\n.ri-cast-fill:before { content: \"\\eb38\"; }\n.ri-cast-line:before { content: \"\\eb39\"; }\n.ri-cellphone-fill:before { content: \"\\eb3a\"; }\n.ri-cellphone-line:before { content: \"\\eb3b\"; }\n.ri-celsius-fill:before { content: \"\\eb3c\"; }\n.ri-celsius-line:before { content: \"\\eb3d\"; }\n.ri-centos-fill:before { content: \"\\eb3e\"; }\n.ri-centos-line:before { content: \"\\eb3f\"; }\n.ri-character-recognition-fill:before { content: \"\\eb40\"; }\n.ri-character-recognition-line:before { content: \"\\eb41\"; }\n.ri-charging-pile-2-fill:before { content: \"\\eb42\"; }\n.ri-charging-pile-2-line:before { content: \"\\eb43\"; }\n.ri-charging-pile-fill:before { content: \"\\eb44\"; }\n.ri-charging-pile-line:before { content: \"\\eb45\"; }\n.ri-chat-1-fill:before { content: \"\\eb46\"; }\n.ri-chat-1-line:before { content: \"\\eb47\"; }\n.ri-chat-2-fill:before { content: \"\\eb48\"; }\n.ri-chat-2-line:before { content: \"\\eb49\"; }\n.ri-chat-3-fill:before { content: \"\\eb4a\"; }\n.ri-chat-3-line:before { content: \"\\eb4b\"; }\n.ri-chat-4-fill:before { content: \"\\eb4c\"; }\n.ri-chat-4-line:before { content: \"\\eb4d\"; }\n.ri-chat-check-fill:before { content: \"\\eb4e\"; }\n.ri-chat-check-line:before { content: \"\\eb4f\"; }\n.ri-chat-delete-fill:before { content: \"\\eb50\"; }\n.ri-chat-delete-line:before { content: \"\\eb51\"; }\n.ri-chat-download-fill:before { content: \"\\eb52\"; }\n.ri-chat-download-line:before { content: \"\\eb53\"; }\n.ri-chat-follow-up-fill:before { content: \"\\eb54\"; }\n.ri-chat-follow-up-line:before { content: \"\\eb55\"; }\n.ri-chat-forward-fill:before { content: \"\\eb56\"; }\n.ri-chat-forward-line:before { content: \"\\eb57\"; }\n.ri-chat-heart-fill:before { content: \"\\eb58\"; }\n.ri-chat-heart-line:before { content: \"\\eb59\"; }\n.ri-chat-history-fill:before { content: \"\\eb5a\"; }\n.ri-chat-history-line:before { content: \"\\eb5b\"; }\n.ri-chat-new-fill:before { content: \"\\eb5c\"; }\n.ri-chat-new-line:before { content: \"\\eb5d\"; }\n.ri-chat-off-fill:before { content: \"\\eb5e\"; }\n.ri-chat-off-line:before { content: \"\\eb5f\"; }\n.ri-chat-poll-fill:before { content: \"\\eb60\"; }\n.ri-chat-poll-line:before { content: \"\\eb61\"; }\n.ri-chat-private-fill:before { content: \"\\eb62\"; }\n.ri-chat-private-line:before { content: \"\\eb63\"; }\n.ri-chat-quote-fill:before { content: \"\\eb64\"; }\n.ri-chat-quote-line:before { content: \"\\eb65\"; }\n.ri-chat-settings-fill:before { content: \"\\eb66\"; }\n.ri-chat-settings-line:before { content: \"\\eb67\"; }\n.ri-chat-smile-2-fill:before { content: \"\\eb68\"; }\n.ri-chat-smile-2-line:before { content: \"\\eb69\"; }\n.ri-chat-smile-3-fill:before { content: \"\\eb6a\"; }\n.ri-chat-smile-3-line:before { content: \"\\eb6b\"; }\n.ri-chat-smile-fill:before { content: \"\\eb6c\"; }\n.ri-chat-smile-line:before { content: \"\\eb6d\"; }\n.ri-chat-upload-fill:before { content: \"\\eb6e\"; }\n.ri-chat-upload-line:before { content: \"\\eb6f\"; }\n.ri-chat-voice-fill:before { content: \"\\eb70\"; }\n.ri-chat-voice-line:before { content: \"\\eb71\"; }\n.ri-check-double-fill:before { content: \"\\eb72\"; }\n.ri-check-double-line:before { content: \"\\eb73\"; }\n.ri-check-fill:before { content: \"\\eb74\"; }\n.ri-check-line:before { content: \"\\eb75\"; }\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb76\"; }\n.ri-checkbox-blank-circle-line:before { content: \"\\eb77\"; }\n.ri-checkbox-blank-fill:before { content: \"\\eb78\"; }\n.ri-checkbox-blank-line:before { content: \"\\eb79\"; }\n.ri-checkbox-circle-fill:before { content: \"\\eb7a\"; }\n.ri-checkbox-circle-line:before { content: \"\\eb7b\"; }\n.ri-checkbox-fill:before { content: \"\\eb7c\"; }\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb7d\"; }\n.ri-checkbox-indeterminate-line:before { content: \"\\eb7e\"; }\n.ri-checkbox-line:before { content: \"\\eb7f\"; }\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb80\"; }\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb81\"; }\n.ri-checkbox-multiple-fill:before { content: \"\\eb82\"; }\n.ri-checkbox-multiple-line:before { content: \"\\eb83\"; }\n.ri-china-railway-fill:before { content: \"\\eb84\"; }\n.ri-china-railway-line:before { content: \"\\eb85\"; }\n.ri-chrome-fill:before { content: \"\\eb86\"; }\n.ri-chrome-line:before { content: \"\\eb87\"; }\n.ri-clapperboard-fill:before { content: \"\\eb88\"; }\n.ri-clapperboard-line:before { content: \"\\eb89\"; }\n.ri-clipboard-fill:before { content: \"\\eb8a\"; }\n.ri-clipboard-line:before { content: \"\\eb8b\"; }\n.ri-clockwise-2-fill:before { content: \"\\eb8c\"; }\n.ri-clockwise-2-line:before { content: \"\\eb8d\"; }\n.ri-clockwise-fill:before { content: \"\\eb8e\"; }\n.ri-clockwise-line:before { content: \"\\eb8f\"; }\n.ri-close-circle-fill:before { content: \"\\eb90\"; }\n.ri-close-circle-line:before { content: \"\\eb91\"; }\n.ri-close-fill:before { content: \"\\eb92\"; }\n.ri-close-line:before { content: \"\\eb93\"; }\n.ri-cloud-fill:before { content: \"\\eb94\"; }\n.ri-cloud-line:before { content: \"\\eb95\"; }\n.ri-cloud-off-fill:before { content: \"\\eb96\"; }\n.ri-cloud-off-line:before { content: \"\\eb97\"; }\n.ri-cloud-windy-fill:before { content: \"\\eb98\"; }\n.ri-cloud-windy-line:before { content: \"\\eb99\"; }\n.ri-cloudy-2-fill:before { content: \"\\eb9a\"; }\n.ri-cloudy-2-line:before { content: \"\\eb9b\"; }\n.ri-cloudy-fill:before { content: \"\\eb9c\"; }\n.ri-cloudy-line:before { content: \"\\eb9d\"; }\n.ri-code-box-fill:before { content: \"\\eb9e\"; }\n.ri-code-box-line:before { content: \"\\eb9f\"; }\n.ri-code-fill:before { content: \"\\eba0\"; }\n.ri-code-line:before { content: \"\\eba1\"; }\n.ri-code-s-fill:before { content: \"\\eba2\"; }\n.ri-code-s-line:before { content: \"\\eba3\"; }\n.ri-code-s-slash-fill:before { content: \"\\eba4\"; }\n.ri-code-s-slash-line:before { content: \"\\eba5\"; }\n.ri-code-view:before { content: \"\\eba6\"; }\n.ri-codepen-fill:before { content: \"\\eba7\"; }\n.ri-codepen-line:before { content: \"\\eba8\"; }\n.ri-coin-fill:before { content: \"\\eba9\"; }\n.ri-coin-line:before { content: \"\\ebaa\"; }\n.ri-coins-fill:before { content: \"\\ebab\"; }\n.ri-coins-line:before { content: \"\\ebac\"; }\n.ri-command-fill:before { content: \"\\ebad\"; }\n.ri-command-line:before { content: \"\\ebae\"; }\n.ri-community-fill:before { content: \"\\ebaf\"; }\n.ri-community-line:before { content: \"\\ebb0\"; }\n.ri-compass-2-fill:before { content: \"\\ebb1\"; }\n.ri-compass-2-line:before { content: \"\\ebb2\"; }\n.ri-compass-3-fill:before { content: \"\\ebb3\"; }\n.ri-compass-3-line:before { content: \"\\ebb4\"; }\n.ri-compass-4-fill:before { content: \"\\ebb5\"; }\n.ri-compass-4-line:before { content: \"\\ebb6\"; }\n.ri-compass-discover-fill:before { content: \"\\ebb7\"; }\n.ri-compass-discover-line:before { content: \"\\ebb8\"; }\n.ri-compass-fill:before { content: \"\\ebb9\"; }\n.ri-compass-line:before { content: \"\\ebba\"; }\n.ri-compasses-2-fill:before { content: \"\\ebbb\"; }\n.ri-compasses-2-line:before { content: \"\\ebbc\"; }\n.ri-compasses-fill:before { content: \"\\ebbd\"; }\n.ri-compasses-line:before { content: \"\\ebbe\"; }\n.ri-computer-fill:before { content: \"\\ebbf\"; }\n.ri-computer-line:before { content: \"\\ebc0\"; }\n.ri-contacts-book-2-fill:before { content: \"\\ebc1\"; }\n.ri-contacts-book-2-line:before { content: \"\\ebc2\"; }\n.ri-contacts-book-fill:before { content: \"\\ebc3\"; }\n.ri-contacts-book-line:before { content: \"\\ebc4\"; }\n.ri-contacts-book-upload-fill:before { content: \"\\ebc5\"; }\n.ri-contacts-book-upload-line:before { content: \"\\ebc6\"; }\n.ri-contacts-fill:before { content: \"\\ebc7\"; }\n.ri-contacts-line:before { content: \"\\ebc8\"; }\n.ri-contrast-2-fill:before { content: \"\\ebc9\"; }\n.ri-contrast-2-line:before { content: \"\\ebca\"; }\n.ri-contrast-drop-2-fill:before { content: \"\\ebcb\"; }\n.ri-contrast-drop-2-line:before { content: \"\\ebcc\"; }\n.ri-contrast-drop-fill:before { content: \"\\ebcd\"; }\n.ri-contrast-drop-line:before { content: \"\\ebce\"; }\n.ri-contrast-fill:before { content: \"\\ebcf\"; }\n.ri-contrast-line:before { content: \"\\ebd0\"; }\n.ri-copper-coin-fill:before { content: \"\\ebd1\"; }\n.ri-copper-coin-line:before { content: \"\\ebd2\"; }\n.ri-copper-diamond-fill:before { content: \"\\ebd3\"; }\n.ri-copper-diamond-line:before { content: \"\\ebd4\"; }\n.ri-copyright-fill:before { content: \"\\ebd5\"; }\n.ri-copyright-line:before { content: \"\\ebd6\"; }\n.ri-coreos-fill:before { content: \"\\ebd7\"; }\n.ri-coreos-line:before { content: \"\\ebd8\"; }\n.ri-coupon-2-fill:before { content: \"\\ebd9\"; }\n.ri-coupon-2-line:before { content: \"\\ebda\"; }\n.ri-coupon-3-fill:before { content: \"\\ebdb\"; }\n.ri-coupon-3-line:before { content: \"\\ebdc\"; }\n.ri-coupon-4-fill:before { content: \"\\ebdd\"; }\n.ri-coupon-4-line:before { content: \"\\ebde\"; }\n.ri-coupon-5-fill:before { content: \"\\ebdf\"; }\n.ri-coupon-5-line:before { content: \"\\ebe0\"; }\n.ri-coupon-fill:before { content: \"\\ebe1\"; }\n.ri-coupon-line:before { content: \"\\ebe2\"; }\n.ri-cpu-fill:before { content: \"\\ebe3\"; }\n.ri-cpu-line:before { content: \"\\ebe4\"; }\n.ri-creative-commons-by-fill:before { content: \"\\ebe5\"; }\n.ri-creative-commons-by-line:before { content: \"\\ebe6\"; }\n.ri-creative-commons-fill:before { content: \"\\ebe7\"; }\n.ri-creative-commons-line:before { content: \"\\ebe8\"; }\n.ri-creative-commons-nc-fill:before { content: \"\\ebe9\"; }\n.ri-creative-commons-nc-line:before { content: \"\\ebea\"; }\n.ri-creative-commons-nd-fill:before { content: \"\\ebeb\"; }\n.ri-creative-commons-nd-line:before { content: \"\\ebec\"; }\n.ri-creative-commons-sa-fill:before { content: \"\\ebed\"; }\n.ri-creative-commons-sa-line:before { content: \"\\ebee\"; }\n.ri-creative-commons-zero-fill:before { content: \"\\ebef\"; }\n.ri-creative-commons-zero-line:before { content: \"\\ebf0\"; }\n.ri-criminal-fill:before { content: \"\\ebf1\"; }\n.ri-criminal-line:before { content: \"\\ebf2\"; }\n.ri-crop-2-fill:before { content: \"\\ebf3\"; }\n.ri-crop-2-line:before { content: \"\\ebf4\"; }\n.ri-crop-fill:before { content: \"\\ebf5\"; }\n.ri-crop-line:before { content: \"\\ebf6\"; }\n.ri-css3-fill:before { content: \"\\ebf7\"; }\n.ri-css3-line:before { content: \"\\ebf8\"; }\n.ri-cup-fill:before { content: \"\\ebf9\"; }\n.ri-cup-line:before { content: \"\\ebfa\"; }\n.ri-currency-fill:before { content: \"\\ebfb\"; }\n.ri-currency-line:before { content: \"\\ebfc\"; }\n.ri-cursor-fill:before { content: \"\\ebfd\"; }\n.ri-cursor-line:before { content: \"\\ebfe\"; }\n.ri-customer-service-2-fill:before { content: \"\\ebff\"; }\n.ri-customer-service-2-line:before { content: \"\\ec00\"; }\n.ri-customer-service-fill:before { content: \"\\ec01\"; }\n.ri-customer-service-line:before { content: \"\\ec02\"; }\n.ri-dashboard-fill:before { content: \"\\ec03\"; }\n.ri-dashboard-line:before { content: \"\\ec04\"; }\n.ri-database-2-fill:before { content: \"\\ec05\"; }\n.ri-database-2-line:before { content: \"\\ec06\"; }\n.ri-database-fill:before { content: \"\\ec07\"; }\n.ri-database-line:before { content: \"\\ec08\"; }\n.ri-delete-back-2-fill:before { content: \"\\ec09\"; }\n.ri-delete-back-2-line:before { content: \"\\ec0a\"; }\n.ri-delete-back-fill:before { content: \"\\ec0b\"; }\n.ri-delete-back-line:before { content: \"\\ec0c\"; }\n.ri-delete-bin-2-fill:before { content: \"\\ec0d\"; }\n.ri-delete-bin-2-line:before { content: \"\\ec0e\"; }\n.ri-delete-bin-3-fill:before { content: \"\\ec0f\"; }\n.ri-delete-bin-3-line:before { content: \"\\ec10\"; }\n.ri-delete-bin-4-fill:before { content: \"\\ec11\"; }\n.ri-delete-bin-4-line:before { content: \"\\ec12\"; }\n.ri-delete-bin-5-fill:before { content: \"\\ec13\"; }\n.ri-delete-bin-5-line:before { content: \"\\ec14\"; }\n.ri-delete-bin-6-fill:before { content: \"\\ec15\"; }\n.ri-delete-bin-6-line:before { content: \"\\ec16\"; }\n.ri-delete-bin-7-fill:before { content: \"\\ec17\"; }\n.ri-delete-bin-7-line:before { content: \"\\ec18\"; }\n.ri-delete-bin-fill:before { content: \"\\ec19\"; }\n.ri-delete-bin-line:before { content: \"\\ec1a\"; }\n.ri-device-fill:before { content: \"\\ec1b\"; }\n.ri-device-line:before { content: \"\\ec1c\"; }\n.ri-device-recover-fill:before { content: \"\\ec1d\"; }\n.ri-device-recover-line:before { content: \"\\ec1e\"; }\n.ri-dingding-fill:before { content: \"\\ec1f\"; }\n.ri-dingding-line:before { content: \"\\ec20\"; }\n.ri-direction-fill:before { content: \"\\ec21\"; }\n.ri-direction-line:before { content: \"\\ec22\"; }\n.ri-disc-fill:before { content: \"\\ec23\"; }\n.ri-disc-line:before { content: \"\\ec24\"; }\n.ri-discord-fill:before { content: \"\\ec25\"; }\n.ri-discord-line:before { content: \"\\ec26\"; }\n.ri-discuss-fill:before { content: \"\\ec27\"; }\n.ri-discuss-line:before { content: \"\\ec28\"; }\n.ri-disqus-fill:before { content: \"\\ec29\"; }\n.ri-disqus-line:before { content: \"\\ec2a\"; }\n.ri-divide-fill:before { content: \"\\ec2b\"; }\n.ri-divide-line:before { content: \"\\ec2c\"; }\n.ri-donut-chart-fill:before { content: \"\\ec2d\"; }\n.ri-donut-chart-line:before { content: \"\\ec2e\"; }\n.ri-door-lock-box-fill:before { content: \"\\ec2f\"; }\n.ri-door-lock-box-line:before { content: \"\\ec30\"; }\n.ri-door-lock-fill:before { content: \"\\ec31\"; }\n.ri-door-lock-line:before { content: \"\\ec32\"; }\n.ri-douban-fill:before { content: \"\\ec33\"; }\n.ri-douban-line:before { content: \"\\ec34\"; }\n.ri-double-quotes-l:before { content: \"\\ec35\"; }\n.ri-double-quotes-r:before { content: \"\\ec36\"; }\n.ri-download-2-fill:before { content: \"\\ec37\"; }\n.ri-download-2-line:before { content: \"\\ec38\"; }\n.ri-download-cloud-2-fill:before { content: \"\\ec39\"; }\n.ri-download-cloud-2-line:before { content: \"\\ec3a\"; }\n.ri-download-cloud-fill:before { content: \"\\ec3b\"; }\n.ri-download-cloud-line:before { content: \"\\ec3c\"; }\n.ri-download-fill:before { content: \"\\ec3d\"; }\n.ri-download-line:before { content: \"\\ec3e\"; }\n.ri-drag-drop-fill:before { content: \"\\ec3f\"; }\n.ri-drag-drop-line:before { content: \"\\ec40\"; }\n.ri-drag-move-2-fill:before { content: \"\\ec41\"; }\n.ri-drag-move-2-line:before { content: \"\\ec42\"; }\n.ri-drag-move-fill:before { content: \"\\ec43\"; }\n.ri-drag-move-line:before { content: \"\\ec44\"; }\n.ri-dribbble-fill:before { content: \"\\ec45\"; }\n.ri-dribbble-line:before { content: \"\\ec46\"; }\n.ri-drive-fill:before { content: \"\\ec47\"; }\n.ri-drive-line:before { content: \"\\ec48\"; }\n.ri-drizzle-fill:before { content: \"\\ec49\"; }\n.ri-drizzle-line:before { content: \"\\ec4a\"; }\n.ri-drop-fill:before { content: \"\\ec4b\"; }\n.ri-drop-line:before { content: \"\\ec4c\"; }\n.ri-dropbox-fill:before { content: \"\\ec4d\"; }\n.ri-dropbox-line:before { content: \"\\ec4e\"; }\n.ri-dual-sim-1-fill:before { content: \"\\ec4f\"; }\n.ri-dual-sim-1-line:before { content: \"\\ec50\"; }\n.ri-dual-sim-2-fill:before { content: \"\\ec51\"; }\n.ri-dual-sim-2-line:before { content: \"\\ec52\"; }\n.ri-dv-fill:before { content: \"\\ec53\"; }\n.ri-dv-line:before { content: \"\\ec54\"; }\n.ri-dvd-fill:before { content: \"\\ec55\"; }\n.ri-dvd-line:before { content: \"\\ec56\"; }\n.ri-e-bike-2-fill:before { content: \"\\ec57\"; }\n.ri-e-bike-2-line:before { content: \"\\ec58\"; }\n.ri-e-bike-fill:before { content: \"\\ec59\"; }\n.ri-e-bike-line:before { content: \"\\ec5a\"; }\n.ri-earth-fill:before { content: \"\\ec5b\"; }\n.ri-earth-line:before { content: \"\\ec5c\"; }\n.ri-earthquake-fill:before { content: \"\\ec5d\"; }\n.ri-earthquake-line:before { content: \"\\ec5e\"; }\n.ri-edge-fill:before { content: \"\\ec5f\"; }\n.ri-edge-line:before { content: \"\\ec60\"; }\n.ri-edit-2-fill:before { content: \"\\ec61\"; }\n.ri-edit-2-line:before { content: \"\\ec62\"; }\n.ri-edit-box-fill:before { content: \"\\ec63\"; }\n.ri-edit-box-line:before { content: \"\\ec64\"; }\n.ri-edit-circle-fill:before { content: \"\\ec65\"; }\n.ri-edit-circle-line:before { content: \"\\ec66\"; }\n.ri-edit-fill:before { content: \"\\ec67\"; }\n.ri-edit-line:before { content: \"\\ec68\"; }\n.ri-eject-fill:before { content: \"\\ec69\"; }\n.ri-eject-line:before { content: \"\\ec6a\"; }\n.ri-emotion-2-fill:before { content: \"\\ec6b\"; }\n.ri-emotion-2-line:before { content: \"\\ec6c\"; }\n.ri-emotion-fill:before { content: \"\\ec6d\"; }\n.ri-emotion-happy-fill:before { content: \"\\ec6e\"; }\n.ri-emotion-happy-line:before { content: \"\\ec6f\"; }\n.ri-emotion-laugh-fill:before { content: \"\\ec70\"; }\n.ri-emotion-laugh-line:before { content: \"\\ec71\"; }\n.ri-emotion-line:before { content: \"\\ec72\"; }\n.ri-emotion-normal-fill:before { content: \"\\ec73\"; }\n.ri-emotion-normal-line:before { content: \"\\ec74\"; }\n.ri-emotion-sad-fill:before { content: \"\\ec75\"; }\n.ri-emotion-sad-line:before { content: \"\\ec76\"; }\n.ri-emotion-unhappy-fill:before { content: \"\\ec77\"; }\n.ri-emotion-unhappy-line:before { content: \"\\ec78\"; }\n.ri-emphasis-cn:before { content: \"\\ec79\"; }\n.ri-emphasis:before { content: \"\\ec7a\"; }\n.ri-english-input:before { content: \"\\ec7b\"; }\n.ri-equalizer-fill:before { content: \"\\ec7c\"; }\n.ri-equalizer-line:before { content: \"\\ec7d\"; }\n.ri-eraser-fill:before { content: \"\\ec7e\"; }\n.ri-eraser-line:before { content: \"\\ec7f\"; }\n.ri-error-warning-fill:before { content: \"\\ec80\"; }\n.ri-error-warning-line:before { content: \"\\ec81\"; }\n.ri-evernote-fill:before { content: \"\\ec82\"; }\n.ri-evernote-line:before { content: \"\\ec83\"; }\n.ri-exchange-box-fill:before { content: \"\\ec84\"; }\n.ri-exchange-box-line:before { content: \"\\ec85\"; }\n.ri-exchange-cny-fill:before { content: \"\\ec86\"; }\n.ri-exchange-cny-line:before { content: \"\\ec87\"; }\n.ri-exchange-dollar-fill:before { content: \"\\ec88\"; }\n.ri-exchange-dollar-line:before { content: \"\\ec89\"; }\n.ri-exchange-fill:before { content: \"\\ec8a\"; }\n.ri-exchange-funds-fill:before { content: \"\\ec8b\"; }\n.ri-exchange-funds-line:before { content: \"\\ec8c\"; }\n.ri-exchange-line:before { content: \"\\ec8d\"; }\n.ri-external-link-fill:before { content: \"\\ec8e\"; }\n.ri-external-link-line:before { content: \"\\ec8f\"; }\n.ri-eye-2-fill:before { content: \"\\ec90\"; }\n.ri-eye-2-line:before { content: \"\\ec91\"; }\n.ri-eye-close-fill:before { content: \"\\ec92\"; }\n.ri-eye-close-line:before { content: \"\\ec93\"; }\n.ri-eye-fill:before { content: \"\\ec94\"; }\n.ri-eye-line:before { content: \"\\ec95\"; }\n.ri-eye-off-fill:before { content: \"\\ec96\"; }\n.ri-eye-off-line:before { content: \"\\ec97\"; }\n.ri-facebook-box-fill:before { content: \"\\ec98\"; }\n.ri-facebook-box-line:before { content: \"\\ec99\"; }\n.ri-facebook-circle-fill:before { content: \"\\ec9a\"; }\n.ri-facebook-circle-line:before { content: \"\\ec9b\"; }\n.ri-facebook-fill:before { content: \"\\ec9c\"; }\n.ri-facebook-line:before { content: \"\\ec9d\"; }\n.ri-fahrenheit-fill:before { content: \"\\ec9e\"; }\n.ri-fahrenheit-line:before { content: \"\\ec9f\"; }\n.ri-feedback-fill:before { content: \"\\eca0\"; }\n.ri-feedback-line:before { content: \"\\eca1\"; }\n.ri-file-2-fill:before { content: \"\\eca2\"; }\n.ri-file-2-line:before { content: \"\\eca3\"; }\n.ri-file-3-fill:before { content: \"\\eca4\"; }\n.ri-file-3-line:before { content: \"\\eca5\"; }\n.ri-file-4-fill:before { content: \"\\eca6\"; }\n.ri-file-4-line:before { content: \"\\eca7\"; }\n.ri-file-add-fill:before { content: \"\\eca8\"; }\n.ri-file-add-line:before { content: \"\\eca9\"; }\n.ri-file-chart-2-fill:before { content: \"\\ecaa\"; }\n.ri-file-chart-2-line:before { content: \"\\ecab\"; }\n.ri-file-chart-fill:before { content: \"\\ecac\"; }\n.ri-file-chart-line:before { content: \"\\ecad\"; }\n.ri-file-cloud-fill:before { content: \"\\ecae\"; }\n.ri-file-cloud-line:before { content: \"\\ecaf\"; }\n.ri-file-code-fill:before { content: \"\\ecb0\"; }\n.ri-file-code-line:before { content: \"\\ecb1\"; }\n.ri-file-copy-2-fill:before { content: \"\\ecb2\"; }\n.ri-file-copy-2-line:before { content: \"\\ecb3\"; }\n.ri-file-copy-fill:before { content: \"\\ecb4\"; }\n.ri-file-copy-line:before { content: \"\\ecb5\"; }\n.ri-file-damage-fill:before { content: \"\\ecb6\"; }\n.ri-file-damage-line:before { content: \"\\ecb7\"; }\n.ri-file-download-fill:before { content: \"\\ecb8\"; }\n.ri-file-download-line:before { content: \"\\ecb9\"; }\n.ri-file-edit-fill:before { content: \"\\ecba\"; }\n.ri-file-edit-line:before { content: \"\\ecbb\"; }\n.ri-file-excel-2-fill:before { content: \"\\ecbc\"; }\n.ri-file-excel-2-line:before { content: \"\\ecbd\"; }\n.ri-file-excel-fill:before { content: \"\\ecbe\"; }\n.ri-file-excel-line:before { content: \"\\ecbf\"; }\n.ri-file-fill:before { content: \"\\ecc0\"; }\n.ri-file-forbid-fill:before { content: \"\\ecc1\"; }\n.ri-file-forbid-line:before { content: \"\\ecc2\"; }\n.ri-file-gif-fill:before { content: \"\\ecc3\"; }\n.ri-file-gif-line:before { content: \"\\ecc4\"; }\n.ri-file-history-fill:before { content: \"\\ecc5\"; }\n.ri-file-history-line:before { content: \"\\ecc6\"; }\n.ri-file-hwp-fill:before { content: \"\\ecc7\"; }\n.ri-file-hwp-line:before { content: \"\\ecc8\"; }\n.ri-file-info-fill:before { content: \"\\ecc9\"; }\n.ri-file-info-line:before { content: \"\\ecca\"; }\n.ri-file-line:before { content: \"\\eccb\"; }\n.ri-file-list-2-fill:before { content: \"\\eccc\"; }\n.ri-file-list-2-line:before { content: \"\\eccd\"; }\n.ri-file-list-3-fill:before { content: \"\\ecce\"; }\n.ri-file-list-3-line:before { content: \"\\eccf\"; }\n.ri-file-list-fill:before { content: \"\\ecd0\"; }\n.ri-file-list-line:before { content: \"\\ecd1\"; }\n.ri-file-lock-fill:before { content: \"\\ecd2\"; }\n.ri-file-lock-line:before { content: \"\\ecd3\"; }\n.ri-file-mark-fill:before { content: \"\\ecd4\"; }\n.ri-file-mark-line:before { content: \"\\ecd5\"; }\n.ri-file-music-fill:before { content: \"\\ecd6\"; }\n.ri-file-music-line:before { content: \"\\ecd7\"; }\n.ri-file-paper-2-fill:before { content: \"\\ecd8\"; }\n.ri-file-paper-2-line:before { content: \"\\ecd9\"; }\n.ri-file-paper-fill:before { content: \"\\ecda\"; }\n.ri-file-paper-line:before { content: \"\\ecdb\"; }\n.ri-file-pdf-fill:before { content: \"\\ecdc\"; }\n.ri-file-pdf-line:before { content: \"\\ecdd\"; }\n.ri-file-ppt-2-fill:before { content: \"\\ecde\"; }\n.ri-file-ppt-2-line:before { content: \"\\ecdf\"; }\n.ri-file-ppt-fill:before { content: \"\\ece0\"; }\n.ri-file-ppt-line:before { content: \"\\ece1\"; }\n.ri-file-reduce-fill:before { content: \"\\ece2\"; }\n.ri-file-reduce-line:before { content: \"\\ece3\"; }\n.ri-file-search-fill:before { content: \"\\ece4\"; }\n.ri-file-search-line:before { content: \"\\ece5\"; }\n.ri-file-settings-fill:before { content: \"\\ece6\"; }\n.ri-file-settings-line:before { content: \"\\ece7\"; }\n.ri-file-shield-2-fill:before { content: \"\\ece8\"; }\n.ri-file-shield-2-line:before { content: \"\\ece9\"; }\n.ri-file-shield-fill:before { content: \"\\ecea\"; }\n.ri-file-shield-line:before { content: \"\\eceb\"; }\n.ri-file-shred-fill:before { content: \"\\ecec\"; }\n.ri-file-shred-line:before { content: \"\\eced\"; }\n.ri-file-text-fill:before { content: \"\\ecee\"; }\n.ri-file-text-line:before { content: \"\\ecef\"; }\n.ri-file-transfer-fill:before { content: \"\\ecf0\"; }\n.ri-file-transfer-line:before { content: \"\\ecf1\"; }\n.ri-file-unknow-fill:before { content: \"\\ecf2\"; }\n.ri-file-unknow-line:before { content: \"\\ecf3\"; }\n.ri-file-upload-fill:before { content: \"\\ecf4\"; }\n.ri-file-upload-line:before { content: \"\\ecf5\"; }\n.ri-file-user-fill:before { content: \"\\ecf6\"; }\n.ri-file-user-line:before { content: \"\\ecf7\"; }\n.ri-file-warning-fill:before { content: \"\\ecf8\"; }\n.ri-file-warning-line:before { content: \"\\ecf9\"; }\n.ri-file-word-2-fill:before { content: \"\\ecfa\"; }\n.ri-file-word-2-line:before { content: \"\\ecfb\"; }\n.ri-file-word-fill:before { content: \"\\ecfc\"; }\n.ri-file-word-line:before { content: \"\\ecfd\"; }\n.ri-file-zip-fill:before { content: \"\\ecfe\"; }\n.ri-file-zip-line:before { content: \"\\ecff\"; }\n.ri-film-fill:before { content: \"\\ed00\"; }\n.ri-film-line:before { content: \"\\ed01\"; }\n.ri-filter-2-fill:before { content: \"\\ed02\"; }\n.ri-filter-2-line:before { content: \"\\ed03\"; }\n.ri-filter-3-fill:before { content: \"\\ed04\"; }\n.ri-filter-3-line:before { content: \"\\ed05\"; }\n.ri-filter-fill:before { content: \"\\ed06\"; }\n.ri-filter-line:before { content: \"\\ed07\"; }\n.ri-find-replace-fill:before { content: \"\\ed08\"; }\n.ri-find-replace-line:before { content: \"\\ed09\"; }\n.ri-fingerprint-2-fill:before { content: \"\\ed0a\"; }\n.ri-fingerprint-2-line:before { content: \"\\ed0b\"; }\n.ri-fingerprint-fill:before { content: \"\\ed0c\"; }\n.ri-fingerprint-line:before { content: \"\\ed0d\"; }\n.ri-fire-fill:before { content: \"\\ed0e\"; }\n.ri-fire-line:before { content: \"\\ed0f\"; }\n.ri-firefox-fill:before { content: \"\\ed10\"; }\n.ri-firefox-line:before { content: \"\\ed11\"; }\n.ri-flag-2-fill:before { content: \"\\ed12\"; }\n.ri-flag-2-line:before { content: \"\\ed13\"; }\n.ri-flag-fill:before { content: \"\\ed14\"; }\n.ri-flag-line:before { content: \"\\ed15\"; }\n.ri-flashlight-fill:before { content: \"\\ed16\"; }\n.ri-flashlight-line:before { content: \"\\ed17\"; }\n.ri-flask-fill:before { content: \"\\ed18\"; }\n.ri-flask-line:before { content: \"\\ed19\"; }\n.ri-flight-land-fill:before { content: \"\\ed1a\"; }\n.ri-flight-land-line:before { content: \"\\ed1b\"; }\n.ri-flight-takeoff-fill:before { content: \"\\ed1c\"; }\n.ri-flight-takeoff-line:before { content: \"\\ed1d\"; }\n.ri-flood-fill:before { content: \"\\ed1e\"; }\n.ri-flood-line:before { content: \"\\ed1f\"; }\n.ri-flutter-fill:before { content: \"\\ed20\"; }\n.ri-flutter-line:before { content: \"\\ed21\"; }\n.ri-focus-2-fill:before { content: \"\\ed22\"; }\n.ri-focus-2-line:before { content: \"\\ed23\"; }\n.ri-focus-3-fill:before { content: \"\\ed24\"; }\n.ri-focus-3-line:before { content: \"\\ed25\"; }\n.ri-focus-fill:before { content: \"\\ed26\"; }\n.ri-focus-line:before { content: \"\\ed27\"; }\n.ri-foggy-fill:before { content: \"\\ed28\"; }\n.ri-foggy-line:before { content: \"\\ed29\"; }\n.ri-folder-2-fill:before { content: \"\\ed2a\"; }\n.ri-folder-2-line:before { content: \"\\ed2b\"; }\n.ri-folder-3-fill:before { content: \"\\ed2c\"; }\n.ri-folder-3-line:before { content: \"\\ed2d\"; }\n.ri-folder-4-fill:before { content: \"\\ed2e\"; }\n.ri-folder-4-line:before { content: \"\\ed2f\"; }\n.ri-folder-5-fill:before { content: \"\\ed30\"; }\n.ri-folder-5-line:before { content: \"\\ed31\"; }\n.ri-folder-add-fill:before { content: \"\\ed32\"; }\n.ri-folder-add-line:before { content: \"\\ed33\"; }\n.ri-folder-chart-2-fill:before { content: \"\\ed34\"; }\n.ri-folder-chart-2-line:before { content: \"\\ed35\"; }\n.ri-folder-chart-fill:before { content: \"\\ed36\"; }\n.ri-folder-chart-line:before { content: \"\\ed37\"; }\n.ri-folder-download-fill:before { content: \"\\ed38\"; }\n.ri-folder-download-line:before { content: \"\\ed39\"; }\n.ri-folder-fill:before { content: \"\\ed3a\"; }\n.ri-folder-forbid-fill:before { content: \"\\ed3b\"; }\n.ri-folder-forbid-line:before { content: \"\\ed3c\"; }\n.ri-folder-history-fill:before { content: \"\\ed3d\"; }\n.ri-folder-history-line:before { content: \"\\ed3e\"; }\n.ri-folder-info-fill:before { content: \"\\ed3f\"; }\n.ri-folder-info-line:before { content: \"\\ed40\"; }\n.ri-folder-keyhole-fill:before { content: \"\\ed41\"; }\n.ri-folder-keyhole-line:before { content: \"\\ed42\"; }\n.ri-folder-line:before { content: \"\\ed43\"; }\n.ri-folder-lock-fill:before { content: \"\\ed44\"; }\n.ri-folder-lock-line:before { content: \"\\ed45\"; }\n.ri-folder-music-fill:before { content: \"\\ed46\"; }\n.ri-folder-music-line:before { content: \"\\ed47\"; }\n.ri-folder-open-fill:before { content: \"\\ed48\"; }\n.ri-folder-open-line:before { content: \"\\ed49\"; }\n.ri-folder-received-fill:before { content: \"\\ed4a\"; }\n.ri-folder-received-line:before { content: \"\\ed4b\"; }\n.ri-folder-reduce-fill:before { content: \"\\ed4c\"; }\n.ri-folder-reduce-line:before { content: \"\\ed4d\"; }\n.ri-folder-settings-fill:before { content: \"\\ed4e\"; }\n.ri-folder-settings-line:before { content: \"\\ed4f\"; }\n.ri-folder-shared-fill:before { content: \"\\ed50\"; }\n.ri-folder-shared-line:before { content: \"\\ed51\"; }\n.ri-folder-shield-2-fill:before { content: \"\\ed52\"; }\n.ri-folder-shield-2-line:before { content: \"\\ed53\"; }\n.ri-folder-shield-fill:before { content: \"\\ed54\"; }\n.ri-folder-shield-line:before { content: \"\\ed55\"; }\n.ri-folder-transfer-fill:before { content: \"\\ed56\"; }\n.ri-folder-transfer-line:before { content: \"\\ed57\"; }\n.ri-folder-unknow-fill:before { content: \"\\ed58\"; }\n.ri-folder-unknow-line:before { content: \"\\ed59\"; }\n.ri-folder-upload-fill:before { content: \"\\ed5a\"; }\n.ri-folder-upload-line:before { content: \"\\ed5b\"; }\n.ri-folder-user-fill:before { content: \"\\ed5c\"; }\n.ri-folder-user-line:before { content: \"\\ed5d\"; }\n.ri-folder-warning-fill:before { content: \"\\ed5e\"; }\n.ri-folder-warning-line:before { content: \"\\ed5f\"; }\n.ri-folder-zip-fill:before { content: \"\\ed60\"; }\n.ri-folder-zip-line:before { content: \"\\ed61\"; }\n.ri-folders-fill:before { content: \"\\ed62\"; }\n.ri-folders-line:before { content: \"\\ed63\"; }\n.ri-font-color:before { content: \"\\ed64\"; }\n.ri-font-size-2:before { content: \"\\ed65\"; }\n.ri-font-size:before { content: \"\\ed66\"; }\n.ri-football-fill:before { content: \"\\ed67\"; }\n.ri-football-line:before { content: \"\\ed68\"; }\n.ri-footprint-fill:before { content: \"\\ed69\"; }\n.ri-footprint-line:before { content: \"\\ed6a\"; }\n.ri-forbid-2-fill:before { content: \"\\ed6b\"; }\n.ri-forbid-2-line:before { content: \"\\ed6c\"; }\n.ri-forbid-fill:before { content: \"\\ed6d\"; }\n.ri-forbid-line:before { content: \"\\ed6e\"; }\n.ri-format-clear:before { content: \"\\ed6f\"; }\n.ri-fridge-fill:before { content: \"\\ed70\"; }\n.ri-fridge-line:before { content: \"\\ed71\"; }\n.ri-fullscreen-exit-fill:before { content: \"\\ed72\"; }\n.ri-fullscreen-exit-line:before { content: \"\\ed73\"; }\n.ri-fullscreen-fill:before { content: \"\\ed74\"; }\n.ri-fullscreen-line:before { content: \"\\ed75\"; }\n.ri-function-fill:before { content: \"\\ed76\"; }\n.ri-function-line:before { content: \"\\ed77\"; }\n.ri-functions:before { content: \"\\ed78\"; }\n.ri-funds-box-fill:before { content: \"\\ed79\"; }\n.ri-funds-box-line:before { content: \"\\ed7a\"; }\n.ri-funds-fill:before { content: \"\\ed7b\"; }\n.ri-funds-line:before { content: \"\\ed7c\"; }\n.ri-gallery-fill:before { content: \"\\ed7d\"; }\n.ri-gallery-line:before { content: \"\\ed7e\"; }\n.ri-gallery-upload-fill:before { content: \"\\ed7f\"; }\n.ri-gallery-upload-line:before { content: \"\\ed80\"; }\n.ri-game-fill:before { content: \"\\ed81\"; }\n.ri-game-line:before { content: \"\\ed82\"; }\n.ri-gamepad-fill:before { content: \"\\ed83\"; }\n.ri-gamepad-line:before { content: \"\\ed84\"; }\n.ri-gas-station-fill:before { content: \"\\ed85\"; }\n.ri-gas-station-line:before { content: \"\\ed86\"; }\n.ri-gatsby-fill:before { content: \"\\ed87\"; }\n.ri-gatsby-line:before { content: \"\\ed88\"; }\n.ri-genderless-fill:before { content: \"\\ed89\"; }\n.ri-genderless-line:before { content: \"\\ed8a\"; }\n.ri-ghost-2-fill:before { content: \"\\ed8b\"; }\n.ri-ghost-2-line:before { content: \"\\ed8c\"; }\n.ri-ghost-fill:before { content: \"\\ed8d\"; }\n.ri-ghost-line:before { content: \"\\ed8e\"; }\n.ri-ghost-smile-fill:before { content: \"\\ed8f\"; }\n.ri-ghost-smile-line:before { content: \"\\ed90\"; }\n.ri-gift-2-fill:before { content: \"\\ed91\"; }\n.ri-gift-2-line:before { content: \"\\ed92\"; }\n.ri-gift-fill:before { content: \"\\ed93\"; }\n.ri-gift-line:before { content: \"\\ed94\"; }\n.ri-git-branch-fill:before { content: \"\\ed95\"; }\n.ri-git-branch-line:before { content: \"\\ed96\"; }\n.ri-git-commit-fill:before { content: \"\\ed97\"; }\n.ri-git-commit-line:before { content: \"\\ed98\"; }\n.ri-git-merge-fill:before { content: \"\\ed99\"; }\n.ri-git-merge-line:before { content: \"\\ed9a\"; }\n.ri-git-pull-request-fill:before { content: \"\\ed9b\"; }\n.ri-git-pull-request-line:before { content: \"\\ed9c\"; }\n.ri-git-repository-commits-fill:before { content: \"\\ed9d\"; }\n.ri-git-repository-commits-line:before { content: \"\\ed9e\"; }\n.ri-git-repository-fill:before { content: \"\\ed9f\"; }\n.ri-git-repository-line:before { content: \"\\eda0\"; }\n.ri-git-repository-private-fill:before { content: \"\\eda1\"; }\n.ri-git-repository-private-line:before { content: \"\\eda2\"; }\n.ri-github-fill:before { content: \"\\eda3\"; }\n.ri-github-line:before { content: \"\\eda4\"; }\n.ri-gitlab-fill:before { content: \"\\eda5\"; }\n.ri-gitlab-line:before { content: \"\\eda6\"; }\n.ri-global-fill:before { content: \"\\eda7\"; }\n.ri-global-line:before { content: \"\\eda8\"; }\n.ri-globe-fill:before { content: \"\\eda9\"; }\n.ri-globe-line:before { content: \"\\edaa\"; }\n.ri-goblet-fill:before { content: \"\\edab\"; }\n.ri-goblet-line:before { content: \"\\edac\"; }\n.ri-google-fill:before { content: \"\\edad\"; }\n.ri-google-line:before { content: \"\\edae\"; }\n.ri-google-play-fill:before { content: \"\\edaf\"; }\n.ri-google-play-line:before { content: \"\\edb0\"; }\n.ri-government-fill:before { content: \"\\edb1\"; }\n.ri-government-line:before { content: \"\\edb2\"; }\n.ri-gps-fill:before { content: \"\\edb3\"; }\n.ri-gps-line:before { content: \"\\edb4\"; }\n.ri-gradienter-fill:before { content: \"\\edb5\"; }\n.ri-gradienter-line:before { content: \"\\edb6\"; }\n.ri-grid-fill:before { content: \"\\edb7\"; }\n.ri-grid-line:before { content: \"\\edb8\"; }\n.ri-group-2-fill:before { content: \"\\edb9\"; }\n.ri-group-2-line:before { content: \"\\edba\"; }\n.ri-group-fill:before { content: \"\\edbb\"; }\n.ri-group-line:before { content: \"\\edbc\"; }\n.ri-guide-fill:before { content: \"\\edbd\"; }\n.ri-guide-line:before { content: \"\\edbe\"; }\n.ri-hail-fill:before { content: \"\\edbf\"; }\n.ri-hail-line:before { content: \"\\edc0\"; }\n.ri-hammer-fill:before { content: \"\\edc1\"; }\n.ri-hammer-line:before { content: \"\\edc2\"; }\n.ri-hand-coin-fill:before { content: \"\\edc3\"; }\n.ri-hand-coin-line:before { content: \"\\edc4\"; }\n.ri-hand-heart-fill:before { content: \"\\edc5\"; }\n.ri-hand-heart-line:before { content: \"\\edc6\"; }\n.ri-handbag-fill:before { content: \"\\edc7\"; }\n.ri-handbag-line:before { content: \"\\edc8\"; }\n.ri-hard-drive-2-fill:before { content: \"\\edc9\"; }\n.ri-hard-drive-2-line:before { content: \"\\edca\"; }\n.ri-hard-drive-fill:before { content: \"\\edcb\"; }\n.ri-hard-drive-line:before { content: \"\\edcc\"; }\n.ri-hashtag:before { content: \"\\edcd\"; }\n.ri-haze-2-fill:before { content: \"\\edce\"; }\n.ri-haze-2-line:before { content: \"\\edcf\"; }\n.ri-haze-fill:before { content: \"\\edd0\"; }\n.ri-haze-line:before { content: \"\\edd1\"; }\n.ri-hd-fill:before { content: \"\\edd2\"; }\n.ri-hd-line:before { content: \"\\edd3\"; }\n.ri-heading:before { content: \"\\edd4\"; }\n.ri-headphone-fill:before { content: \"\\edd5\"; }\n.ri-headphone-line:before { content: \"\\edd6\"; }\n.ri-heart-2-fill:before { content: \"\\edd7\"; }\n.ri-heart-2-line:before { content: \"\\edd8\"; }\n.ri-heart-add-fill:before { content: \"\\edd9\"; }\n.ri-heart-add-line:before { content: \"\\edda\"; }\n.ri-heart-fill:before { content: \"\\eddb\"; }\n.ri-heart-line:before { content: \"\\eddc\"; }\n.ri-hearts-fill:before { content: \"\\eddd\"; }\n.ri-hearts-line:before { content: \"\\edde\"; }\n.ri-heavy-showers-fill:before { content: \"\\eddf\"; }\n.ri-heavy-showers-line:before { content: \"\\ede0\"; }\n.ri-history-fill:before { content: \"\\ede1\"; }\n.ri-history-line:before { content: \"\\ede2\"; }\n.ri-home-2-fill:before { content: \"\\ede3\"; }\n.ri-home-2-line:before { content: \"\\ede4\"; }\n.ri-home-3-fill:before { content: \"\\ede5\"; }\n.ri-home-3-line:before { content: \"\\ede6\"; }\n.ri-home-4-fill:before { content: \"\\ede7\"; }\n.ri-home-4-line:before { content: \"\\ede8\"; }\n.ri-home-5-fill:before { content: \"\\ede9\"; }\n.ri-home-5-line:before { content: \"\\edea\"; }\n.ri-home-6-fill:before { content: \"\\edeb\"; }\n.ri-home-6-line:before { content: \"\\edec\"; }\n.ri-home-7-fill:before { content: \"\\eded\"; }\n.ri-home-7-line:before { content: \"\\edee\"; }\n.ri-home-8-fill:before { content: \"\\edef\"; }\n.ri-home-8-line:before { content: \"\\edf0\"; }\n.ri-home-fill:before { content: \"\\edf1\"; }\n.ri-home-gear-fill:before { content: \"\\edf2\"; }\n.ri-home-gear-line:before { content: \"\\edf3\"; }\n.ri-home-heart-fill:before { content: \"\\edf4\"; }\n.ri-home-heart-line:before { content: \"\\edf5\"; }\n.ri-home-line:before { content: \"\\edf6\"; }\n.ri-home-smile-2-fill:before { content: \"\\edf7\"; }\n.ri-home-smile-2-line:before { content: \"\\edf8\"; }\n.ri-home-smile-fill:before { content: \"\\edf9\"; }\n.ri-home-smile-line:before { content: \"\\edfa\"; }\n.ri-home-wifi-fill:before { content: \"\\edfb\"; }\n.ri-home-wifi-line:before { content: \"\\edfc\"; }\n.ri-honor-of-kings-fill:before { content: \"\\edfd\"; }\n.ri-honor-of-kings-line:before { content: \"\\edfe\"; }\n.ri-honour-fill:before { content: \"\\edff\"; }\n.ri-honour-line:before { content: \"\\ee00\"; }\n.ri-hospital-fill:before { content: \"\\ee01\"; }\n.ri-hospital-line:before { content: \"\\ee02\"; }\n.ri-hotel-bed-fill:before { content: \"\\ee03\"; }\n.ri-hotel-bed-line:before { content: \"\\ee04\"; }\n.ri-hotel-fill:before { content: \"\\ee05\"; }\n.ri-hotel-line:before { content: \"\\ee06\"; }\n.ri-hotspot-fill:before { content: \"\\ee07\"; }\n.ri-hotspot-line:before { content: \"\\ee08\"; }\n.ri-hq-fill:before { content: \"\\ee09\"; }\n.ri-hq-line:before { content: \"\\ee0a\"; }\n.ri-html5-fill:before { content: \"\\ee0b\"; }\n.ri-html5-line:before { content: \"\\ee0c\"; }\n.ri-ie-fill:before { content: \"\\ee0d\"; }\n.ri-ie-line:before { content: \"\\ee0e\"; }\n.ri-image-2-fill:before { content: \"\\ee0f\"; }\n.ri-image-2-line:before { content: \"\\ee10\"; }\n.ri-image-add-fill:before { content: \"\\ee11\"; }\n.ri-image-add-line:before { content: \"\\ee12\"; }\n.ri-image-fill:before { content: \"\\ee13\"; }\n.ri-image-line:before { content: \"\\ee14\"; }\n.ri-inbox-archive-fill:before { content: \"\\ee15\"; }\n.ri-inbox-archive-line:before { content: \"\\ee16\"; }\n.ri-inbox-fill:before { content: \"\\ee17\"; }\n.ri-inbox-line:before { content: \"\\ee18\"; }\n.ri-inbox-unarchive-fill:before { content: \"\\ee19\"; }\n.ri-inbox-unarchive-line:before { content: \"\\ee1a\"; }\n.ri-increase-decrease-fill:before { content: \"\\ee1b\"; }\n.ri-increase-decrease-line:before { content: \"\\ee1c\"; }\n.ri-indent-decrease:before { content: \"\\ee1d\"; }\n.ri-indent-increase:before { content: \"\\ee1e\"; }\n.ri-indeterminate-circle-fill:before { content: \"\\ee1f\"; }\n.ri-indeterminate-circle-line:before { content: \"\\ee20\"; }\n.ri-information-fill:before { content: \"\\ee21\"; }\n.ri-information-line:before { content: \"\\ee22\"; }\n.ri-input-cursor-move:before { content: \"\\ee23\"; }\n.ri-input-method-fill:before { content: \"\\ee24\"; }\n.ri-input-method-line:before { content: \"\\ee25\"; }\n.ri-instagram-fill:before { content: \"\\ee26\"; }\n.ri-instagram-line:before { content: \"\\ee27\"; }\n.ri-install-fill:before { content: \"\\ee28\"; }\n.ri-install-line:before { content: \"\\ee29\"; }\n.ri-invision-fill:before { content: \"\\ee2a\"; }\n.ri-invision-line:before { content: \"\\ee2b\"; }\n.ri-italic:before { content: \"\\ee2c\"; }\n.ri-kakao-talk-fill:before { content: \"\\ee2d\"; }\n.ri-kakao-talk-line:before { content: \"\\ee2e\"; }\n.ri-key-2-fill:before { content: \"\\ee2f\"; }\n.ri-key-2-line:before { content: \"\\ee30\"; }\n.ri-key-fill:before { content: \"\\ee31\"; }\n.ri-key-line:before { content: \"\\ee32\"; }\n.ri-keyboard-box-fill:before { content: \"\\ee33\"; }\n.ri-keyboard-box-line:before { content: \"\\ee34\"; }\n.ri-keyboard-fill:before { content: \"\\ee35\"; }\n.ri-keyboard-line:before { content: \"\\ee36\"; }\n.ri-keynote-fill:before { content: \"\\ee37\"; }\n.ri-keynote-line:before { content: \"\\ee38\"; }\n.ri-knife-blood-fill:before { content: \"\\ee39\"; }\n.ri-knife-blood-line:before { content: \"\\ee3a\"; }\n.ri-knife-fill:before { content: \"\\ee3b\"; }\n.ri-knife-line:before { content: \"\\ee3c\"; }\n.ri-landscape-fill:before { content: \"\\ee3d\"; }\n.ri-landscape-line:before { content: \"\\ee3e\"; }\n.ri-layout-2-fill:before { content: \"\\ee3f\"; }\n.ri-layout-2-line:before { content: \"\\ee40\"; }\n.ri-layout-3-fill:before { content: \"\\ee41\"; }\n.ri-layout-3-line:before { content: \"\\ee42\"; }\n.ri-layout-4-fill:before { content: \"\\ee43\"; }\n.ri-layout-4-line:before { content: \"\\ee44\"; }\n.ri-layout-5-fill:before { content: \"\\ee45\"; }\n.ri-layout-5-line:before { content: \"\\ee46\"; }\n.ri-layout-6-fill:before { content: \"\\ee47\"; }\n.ri-layout-6-line:before { content: \"\\ee48\"; }\n.ri-layout-bottom-2-fill:before { content: \"\\ee49\"; }\n.ri-layout-bottom-2-line:before { content: \"\\ee4a\"; }\n.ri-layout-bottom-fill:before { content: \"\\ee4b\"; }\n.ri-layout-bottom-line:before { content: \"\\ee4c\"; }\n.ri-layout-column-fill:before { content: \"\\ee4d\"; }\n.ri-layout-column-line:before { content: \"\\ee4e\"; }\n.ri-layout-fill:before { content: \"\\ee4f\"; }\n.ri-layout-grid-fill:before { content: \"\\ee50\"; }\n.ri-layout-grid-line:before { content: \"\\ee51\"; }\n.ri-layout-left-2-fill:before { content: \"\\ee52\"; }\n.ri-layout-left-2-line:before { content: \"\\ee53\"; }\n.ri-layout-left-fill:before { content: \"\\ee54\"; }\n.ri-layout-left-line:before { content: \"\\ee55\"; }\n.ri-layout-line:before { content: \"\\ee56\"; }\n.ri-layout-masonry-fill:before { content: \"\\ee57\"; }\n.ri-layout-masonry-line:before { content: \"\\ee58\"; }\n.ri-layout-right-2-fill:before { content: \"\\ee59\"; }\n.ri-layout-right-2-line:before { content: \"\\ee5a\"; }\n.ri-layout-right-fill:before { content: \"\\ee5b\"; }\n.ri-layout-right-line:before { content: \"\\ee5c\"; }\n.ri-layout-row-fill:before { content: \"\\ee5d\"; }\n.ri-layout-row-line:before { content: \"\\ee5e\"; }\n.ri-layout-top-2-fill:before { content: \"\\ee5f\"; }\n.ri-layout-top-2-line:before { content: \"\\ee60\"; }\n.ri-layout-top-fill:before { content: \"\\ee61\"; }\n.ri-layout-top-line:before { content: \"\\ee62\"; }\n.ri-leaf-fill:before { content: \"\\ee63\"; }\n.ri-leaf-line:before { content: \"\\ee64\"; }\n.ri-lifebuoy-fill:before { content: \"\\ee65\"; }\n.ri-lifebuoy-line:before { content: \"\\ee66\"; }\n.ri-lightbulb-fill:before { content: \"\\ee67\"; }\n.ri-lightbulb-flash-fill:before { content: \"\\ee68\"; }\n.ri-lightbulb-flash-line:before { content: \"\\ee69\"; }\n.ri-lightbulb-line:before { content: \"\\ee6a\"; }\n.ri-line-chart-fill:before { content: \"\\ee6b\"; }\n.ri-line-chart-line:before { content: \"\\ee6c\"; }\n.ri-line-fill:before { content: \"\\ee6d\"; }\n.ri-line-height:before { content: \"\\ee6e\"; }\n.ri-line-line:before { content: \"\\ee6f\"; }\n.ri-link-m:before { content: \"\\ee70\"; }\n.ri-link-unlink-m:before { content: \"\\ee71\"; }\n.ri-link-unlink:before { content: \"\\ee72\"; }\n.ri-link:before { content: \"\\ee73\"; }\n.ri-linkedin-box-fill:before { content: \"\\ee74\"; }\n.ri-linkedin-box-line:before { content: \"\\ee75\"; }\n.ri-linkedin-fill:before { content: \"\\ee76\"; }\n.ri-linkedin-line:before { content: \"\\ee77\"; }\n.ri-links-fill:before { content: \"\\ee78\"; }\n.ri-links-line:before { content: \"\\ee79\"; }\n.ri-list-check-2:before { content: \"\\ee7a\"; }\n.ri-list-check:before { content: \"\\ee7b\"; }\n.ri-list-ordered:before { content: \"\\ee7c\"; }\n.ri-list-settings-fill:before { content: \"\\ee7d\"; }\n.ri-list-settings-line:before { content: \"\\ee7e\"; }\n.ri-list-unordered:before { content: \"\\ee7f\"; }\n.ri-live-fill:before { content: \"\\ee80\"; }\n.ri-live-line:before { content: \"\\ee81\"; }\n.ri-loader-2-fill:before { content: \"\\ee82\"; }\n.ri-loader-2-line:before { content: \"\\ee83\"; }\n.ri-loader-3-fill:before { content: \"\\ee84\"; }\n.ri-loader-3-line:before { content: \"\\ee85\"; }\n.ri-loader-4-fill:before { content: \"\\ee86\"; }\n.ri-loader-4-line:before { content: \"\\ee87\"; }\n.ri-loader-5-fill:before { content: \"\\ee88\"; }\n.ri-loader-5-line:before { content: \"\\ee89\"; }\n.ri-loader-fill:before { content: \"\\ee8a\"; }\n.ri-loader-line:before { content: \"\\ee8b\"; }\n.ri-lock-2-fill:before { content: \"\\ee8c\"; }\n.ri-lock-2-line:before { content: \"\\ee8d\"; }\n.ri-lock-fill:before { content: \"\\ee8e\"; }\n.ri-lock-line:before { content: \"\\ee8f\"; }\n.ri-lock-password-fill:before { content: \"\\ee90\"; }\n.ri-lock-password-line:before { content: \"\\ee91\"; }\n.ri-lock-unlock-fill:before { content: \"\\ee92\"; }\n.ri-lock-unlock-line:before { content: \"\\ee93\"; }\n.ri-login-box-fill:before { content: \"\\ee94\"; }\n.ri-login-box-line:before { content: \"\\ee95\"; }\n.ri-login-circle-fill:before { content: \"\\ee96\"; }\n.ri-login-circle-line:before { content: \"\\ee97\"; }\n.ri-logout-box-fill:before { content: \"\\ee98\"; }\n.ri-logout-box-line:before { content: \"\\ee99\"; }\n.ri-logout-box-r-fill:before { content: \"\\ee9a\"; }\n.ri-logout-box-r-line:before { content: \"\\ee9b\"; }\n.ri-logout-circle-fill:before { content: \"\\ee9c\"; }\n.ri-logout-circle-line:before { content: \"\\ee9d\"; }\n.ri-logout-circle-r-fill:before { content: \"\\ee9e\"; }\n.ri-logout-circle-r-line:before { content: \"\\ee9f\"; }\n.ri-luggage-cart-fill:before { content: \"\\eea0\"; }\n.ri-luggage-cart-line:before { content: \"\\eea1\"; }\n.ri-luggage-deposit-fill:before { content: \"\\eea2\"; }\n.ri-luggage-deposit-line:before { content: \"\\eea3\"; }\n.ri-mac-fill:before { content: \"\\eea4\"; }\n.ri-mac-line:before { content: \"\\eea5\"; }\n.ri-macbook-fill:before { content: \"\\eea6\"; }\n.ri-macbook-line:before { content: \"\\eea7\"; }\n.ri-magic-fill:before { content: \"\\eea8\"; }\n.ri-magic-line:before { content: \"\\eea9\"; }\n.ri-mail-add-fill:before { content: \"\\eeaa\"; }\n.ri-mail-add-line:before { content: \"\\eeab\"; }\n.ri-mail-check-fill:before { content: \"\\eeac\"; }\n.ri-mail-check-line:before { content: \"\\eead\"; }\n.ri-mail-close-fill:before { content: \"\\eeae\"; }\n.ri-mail-close-line:before { content: \"\\eeaf\"; }\n.ri-mail-download-fill:before { content: \"\\eeb0\"; }\n.ri-mail-download-line:before { content: \"\\eeb1\"; }\n.ri-mail-fill:before { content: \"\\eeb2\"; }\n.ri-mail-forbid-fill:before { content: \"\\eeb3\"; }\n.ri-mail-forbid-line:before { content: \"\\eeb4\"; }\n.ri-mail-line:before { content: \"\\eeb5\"; }\n.ri-mail-lock-fill:before { content: \"\\eeb6\"; }\n.ri-mail-lock-line:before { content: \"\\eeb7\"; }\n.ri-mail-open-fill:before { content: \"\\eeb8\"; }\n.ri-mail-open-line:before { content: \"\\eeb9\"; }\n.ri-mail-send-fill:before { content: \"\\eeba\"; }\n.ri-mail-send-line:before { content: \"\\eebb\"; }\n.ri-mail-settings-fill:before { content: \"\\eebc\"; }\n.ri-mail-settings-line:before { content: \"\\eebd\"; }\n.ri-mail-star-fill:before { content: \"\\eebe\"; }\n.ri-mail-star-line:before { content: \"\\eebf\"; }\n.ri-mail-unread-fill:before { content: \"\\eec0\"; }\n.ri-mail-unread-line:before { content: \"\\eec1\"; }\n.ri-mail-volume-fill:before { content: \"\\eec2\"; }\n.ri-mail-volume-line:before { content: \"\\eec3\"; }\n.ri-map-2-fill:before { content: \"\\eec4\"; }\n.ri-map-2-line:before { content: \"\\eec5\"; }\n.ri-map-fill:before { content: \"\\eec6\"; }\n.ri-map-line:before { content: \"\\eec7\"; }\n.ri-map-pin-2-fill:before { content: \"\\eec8\"; }\n.ri-map-pin-2-line:before { content: \"\\eec9\"; }\n.ri-map-pin-3-fill:before { content: \"\\eeca\"; }\n.ri-map-pin-3-line:before { content: \"\\eecb\"; }\n.ri-map-pin-4-fill:before { content: \"\\eecc\"; }\n.ri-map-pin-4-line:before { content: \"\\eecd\"; }\n.ri-map-pin-5-fill:before { content: \"\\eece\"; }\n.ri-map-pin-5-line:before { content: \"\\eecf\"; }\n.ri-map-pin-add-fill:before { content: \"\\eed0\"; }\n.ri-map-pin-add-line:before { content: \"\\eed1\"; }\n.ri-map-pin-fill:before { content: \"\\eed2\"; }\n.ri-map-pin-line:before { content: \"\\eed3\"; }\n.ri-map-pin-range-fill:before { content: \"\\eed4\"; }\n.ri-map-pin-range-line:before { content: \"\\eed5\"; }\n.ri-map-pin-time-fill:before { content: \"\\eed6\"; }\n.ri-map-pin-time-line:before { content: \"\\eed7\"; }\n.ri-map-pin-user-fill:before { content: \"\\eed8\"; }\n.ri-map-pin-user-line:before { content: \"\\eed9\"; }\n.ri-mark-pen-fill:before { content: \"\\eeda\"; }\n.ri-mark-pen-line:before { content: \"\\eedb\"; }\n.ri-markdown-fill:before { content: \"\\eedc\"; }\n.ri-markdown-line:before { content: \"\\eedd\"; }\n.ri-markup-fill:before { content: \"\\eede\"; }\n.ri-markup-line:before { content: \"\\eedf\"; }\n.ri-mastercard-fill:before { content: \"\\eee0\"; }\n.ri-mastercard-line:before { content: \"\\eee1\"; }\n.ri-mastodon-fill:before { content: \"\\eee2\"; }\n.ri-mastodon-line:before { content: \"\\eee3\"; }\n.ri-medal-2-fill:before { content: \"\\eee4\"; }\n.ri-medal-2-line:before { content: \"\\eee5\"; }\n.ri-medal-fill:before { content: \"\\eee6\"; }\n.ri-medal-line:before { content: \"\\eee7\"; }\n.ri-medium-fill:before { content: \"\\eee8\"; }\n.ri-medium-line:before { content: \"\\eee9\"; }\n.ri-men-fill:before { content: \"\\eeea\"; }\n.ri-men-line:before { content: \"\\eeeb\"; }\n.ri-menu-2-fill:before { content: \"\\eeec\"; }\n.ri-menu-2-line:before { content: \"\\eeed\"; }\n.ri-menu-3-fill:before { content: \"\\eeee\"; }\n.ri-menu-3-line:before { content: \"\\eeef\"; }\n.ri-menu-4-fill:before { content: \"\\eef0\"; }\n.ri-menu-4-line:before { content: \"\\eef1\"; }\n.ri-menu-5-fill:before { content: \"\\eef2\"; }\n.ri-menu-5-line:before { content: \"\\eef3\"; }\n.ri-menu-add-fill:before { content: \"\\eef4\"; }\n.ri-menu-add-line:before { content: \"\\eef5\"; }\n.ri-menu-fill:before { content: \"\\eef6\"; }\n.ri-menu-line:before { content: \"\\eef7\"; }\n.ri-message-2-fill:before { content: \"\\eef8\"; }\n.ri-message-2-line:before { content: \"\\eef9\"; }\n.ri-message-3-fill:before { content: \"\\eefa\"; }\n.ri-message-3-line:before { content: \"\\eefb\"; }\n.ri-message-fill:before { content: \"\\eefc\"; }\n.ri-message-line:before { content: \"\\eefd\"; }\n.ri-messenger-fill:before { content: \"\\eefe\"; }\n.ri-messenger-line:before { content: \"\\eeff\"; }\n.ri-meteor-fill:before { content: \"\\ef00\"; }\n.ri-meteor-line:before { content: \"\\ef01\"; }\n.ri-mic-2-fill:before { content: \"\\ef02\"; }\n.ri-mic-2-line:before { content: \"\\ef03\"; }\n.ri-mic-fill:before { content: \"\\ef04\"; }\n.ri-mic-line:before { content: \"\\ef05\"; }\n.ri-mic-off-fill:before { content: \"\\ef06\"; }\n.ri-mic-off-line:before { content: \"\\ef07\"; }\n.ri-mickey-fill:before { content: \"\\ef08\"; }\n.ri-mickey-line:before { content: \"\\ef09\"; }\n.ri-mini-program-fill:before { content: \"\\ef0a\"; }\n.ri-mini-program-line:before { content: \"\\ef0b\"; }\n.ri-mist-fill:before { content: \"\\ef0c\"; }\n.ri-mist-line:before { content: \"\\ef0d\"; }\n.ri-money-cny-box-fill:before { content: \"\\ef0e\"; }\n.ri-money-cny-box-line:before { content: \"\\ef0f\"; }\n.ri-money-cny-circle-fill:before { content: \"\\ef10\"; }\n.ri-money-cny-circle-line:before { content: \"\\ef11\"; }\n.ri-money-dollar-box-fill:before { content: \"\\ef12\"; }\n.ri-money-dollar-box-line:before { content: \"\\ef13\"; }\n.ri-money-dollar-circle-fill:before { content: \"\\ef14\"; }\n.ri-money-dollar-circle-line:before { content: \"\\ef15\"; }\n.ri-money-euro-box-fill:before { content: \"\\ef16\"; }\n.ri-money-euro-box-line:before { content: \"\\ef17\"; }\n.ri-money-euro-circle-fill:before { content: \"\\ef18\"; }\n.ri-money-euro-circle-line:before { content: \"\\ef19\"; }\n.ri-money-pound-box-fill:before { content: \"\\ef1a\"; }\n.ri-money-pound-box-line:before { content: \"\\ef1b\"; }\n.ri-money-pound-circle-fill:before { content: \"\\ef1c\"; }\n.ri-money-pound-circle-line:before { content: \"\\ef1d\"; }\n.ri-moon-clear-fill:before { content: \"\\ef1e\"; }\n.ri-moon-clear-line:before { content: \"\\ef1f\"; }\n.ri-moon-cloudy-fill:before { content: \"\\ef20\"; }\n.ri-moon-cloudy-line:before { content: \"\\ef21\"; }\n.ri-moon-fill:before { content: \"\\ef22\"; }\n.ri-moon-foggy-fill:before { content: \"\\ef23\"; }\n.ri-moon-foggy-line:before { content: \"\\ef24\"; }\n.ri-moon-line:before { content: \"\\ef25\"; }\n.ri-more-2-fill:before { content: \"\\ef26\"; }\n.ri-more-2-line:before { content: \"\\ef27\"; }\n.ri-more-fill:before { content: \"\\ef28\"; }\n.ri-more-line:before { content: \"\\ef29\"; }\n.ri-motorbike-fill:before { content: \"\\ef2a\"; }\n.ri-motorbike-line:before { content: \"\\ef2b\"; }\n.ri-mouse-fill:before { content: \"\\ef2c\"; }\n.ri-mouse-line:before { content: \"\\ef2d\"; }\n.ri-movie-2-fill:before { content: \"\\ef2e\"; }\n.ri-movie-2-line:before { content: \"\\ef2f\"; }\n.ri-movie-fill:before { content: \"\\ef30\"; }\n.ri-movie-line:before { content: \"\\ef31\"; }\n.ri-music-2-fill:before { content: \"\\ef32\"; }\n.ri-music-2-line:before { content: \"\\ef33\"; }\n.ri-music-fill:before { content: \"\\ef34\"; }\n.ri-music-line:before { content: \"\\ef35\"; }\n.ri-mv-fill:before { content: \"\\ef36\"; }\n.ri-mv-line:before { content: \"\\ef37\"; }\n.ri-navigation-fill:before { content: \"\\ef38\"; }\n.ri-navigation-line:before { content: \"\\ef39\"; }\n.ri-netease-cloud-music-fill:before { content: \"\\ef3a\"; }\n.ri-netease-cloud-music-line:before { content: \"\\ef3b\"; }\n.ri-netflix-fill:before { content: \"\\ef3c\"; }\n.ri-netflix-line:before { content: \"\\ef3d\"; }\n.ri-newspaper-fill:before { content: \"\\ef3e\"; }\n.ri-newspaper-line:before { content: \"\\ef3f\"; }\n.ri-notification-2-fill:before { content: \"\\ef40\"; }\n.ri-notification-2-line:before { content: \"\\ef41\"; }\n.ri-notification-3-fill:before { content: \"\\ef42\"; }\n.ri-notification-3-line:before { content: \"\\ef43\"; }\n.ri-notification-4-fill:before { content: \"\\ef44\"; }\n.ri-notification-4-line:before { content: \"\\ef45\"; }\n.ri-notification-badge-fill:before { content: \"\\ef46\"; }\n.ri-notification-badge-line:before { content: \"\\ef47\"; }\n.ri-notification-fill:before { content: \"\\ef48\"; }\n.ri-notification-line:before { content: \"\\ef49\"; }\n.ri-notification-off-fill:before { content: \"\\ef4a\"; }\n.ri-notification-off-line:before { content: \"\\ef4b\"; }\n.ri-npmjs-fill:before { content: \"\\ef4c\"; }\n.ri-npmjs-line:before { content: \"\\ef4d\"; }\n.ri-number-0:before { content: \"\\ef4e\"; }\n.ri-number-1:before { content: \"\\ef4f\"; }\n.ri-number-2:before { content: \"\\ef50\"; }\n.ri-number-3:before { content: \"\\ef51\"; }\n.ri-number-4:before { content: \"\\ef52\"; }\n.ri-number-5:before { content: \"\\ef53\"; }\n.ri-number-6:before { content: \"\\ef54\"; }\n.ri-number-7:before { content: \"\\ef55\"; }\n.ri-number-8:before { content: \"\\ef56\"; }\n.ri-number-9:before { content: \"\\ef57\"; }\n.ri-numbers-fill:before { content: \"\\ef58\"; }\n.ri-numbers-line:before { content: \"\\ef59\"; }\n.ri-oil-fill:before { content: \"\\ef5a\"; }\n.ri-oil-line:before { content: \"\\ef5b\"; }\n.ri-omega:before { content: \"\\ef5c\"; }\n.ri-open-arm-fill:before { content: \"\\ef5d\"; }\n.ri-open-arm-line:before { content: \"\\ef5e\"; }\n.ri-open-source-fill:before { content: \"\\ef5f\"; }\n.ri-open-source-line:before { content: \"\\ef60\"; }\n.ri-opera-fill:before { content: \"\\ef61\"; }\n.ri-opera-line:before { content: \"\\ef62\"; }\n.ri-order-play-fill:before { content: \"\\ef63\"; }\n.ri-order-play-line:before { content: \"\\ef64\"; }\n.ri-outlet-2-fill:before { content: \"\\ef65\"; }\n.ri-outlet-2-line:before { content: \"\\ef66\"; }\n.ri-outlet-fill:before { content: \"\\ef67\"; }\n.ri-outlet-line:before { content: \"\\ef68\"; }\n.ri-page-separator:before { content: \"\\ef69\"; }\n.ri-pages-fill:before { content: \"\\ef6a\"; }\n.ri-pages-line:before { content: \"\\ef6b\"; }\n.ri-paint-brush-fill:before { content: \"\\ef6c\"; }\n.ri-paint-brush-line:before { content: \"\\ef6d\"; }\n.ri-paint-fill:before { content: \"\\ef6e\"; }\n.ri-paint-line:before { content: \"\\ef6f\"; }\n.ri-palette-fill:before { content: \"\\ef70\"; }\n.ri-palette-line:before { content: \"\\ef71\"; }\n.ri-pantone-fill:before { content: \"\\ef72\"; }\n.ri-pantone-line:before { content: \"\\ef73\"; }\n.ri-paragraph:before { content: \"\\ef74\"; }\n.ri-parent-fill:before { content: \"\\ef75\"; }\n.ri-parent-line:before { content: \"\\ef76\"; }\n.ri-parentheses-fill:before { content: \"\\ef77\"; }\n.ri-parentheses-line:before { content: \"\\ef78\"; }\n.ri-parking-box-fill:before { content: \"\\ef79\"; }\n.ri-parking-box-line:before { content: \"\\ef7a\"; }\n.ri-parking-fill:before { content: \"\\ef7b\"; }\n.ri-parking-line:before { content: \"\\ef7c\"; }\n.ri-passport-fill:before { content: \"\\ef7d\"; }\n.ri-passport-line:before { content: \"\\ef7e\"; }\n.ri-patreon-fill:before { content: \"\\ef7f\"; }\n.ri-patreon-line:before { content: \"\\ef80\"; }\n.ri-pause-circle-fill:before { content: \"\\ef81\"; }\n.ri-pause-circle-line:before { content: \"\\ef82\"; }\n.ri-pause-fill:before { content: \"\\ef83\"; }\n.ri-pause-line:before { content: \"\\ef84\"; }\n.ri-pause-mini-fill:before { content: \"\\ef85\"; }\n.ri-pause-mini-line:before { content: \"\\ef86\"; }\n.ri-paypal-fill:before { content: \"\\ef87\"; }\n.ri-paypal-line:before { content: \"\\ef88\"; }\n.ri-pen-nib-fill:before { content: \"\\ef89\"; }\n.ri-pen-nib-line:before { content: \"\\ef8a\"; }\n.ri-pencil-fill:before { content: \"\\ef8b\"; }\n.ri-pencil-line:before { content: \"\\ef8c\"; }\n.ri-pencil-ruler-2-fill:before { content: \"\\ef8d\"; }\n.ri-pencil-ruler-2-line:before { content: \"\\ef8e\"; }\n.ri-pencil-ruler-fill:before { content: \"\\ef8f\"; }\n.ri-pencil-ruler-line:before { content: \"\\ef90\"; }\n.ri-percent-fill:before { content: \"\\ef91\"; }\n.ri-percent-line:before { content: \"\\ef92\"; }\n.ri-phone-camera-fill:before { content: \"\\ef93\"; }\n.ri-phone-camera-line:before { content: \"\\ef94\"; }\n.ri-phone-fill:before { content: \"\\ef95\"; }\n.ri-phone-find-fill:before { content: \"\\ef96\"; }\n.ri-phone-find-line:before { content: \"\\ef97\"; }\n.ri-phone-line:before { content: \"\\ef98\"; }\n.ri-phone-lock-fill:before { content: \"\\ef99\"; }\n.ri-phone-lock-line:before { content: \"\\ef9a\"; }\n.ri-picture-in-picture-2-fill:before { content: \"\\ef9b\"; }\n.ri-picture-in-picture-2-line:before { content: \"\\ef9c\"; }\n.ri-picture-in-picture-exit-fill:before { content: \"\\ef9d\"; }\n.ri-picture-in-picture-exit-line:before { content: \"\\ef9e\"; }\n.ri-picture-in-picture-fill:before { content: \"\\ef9f\"; }\n.ri-picture-in-picture-line:before { content: \"\\efa0\"; }\n.ri-pie-chart-2-fill:before { content: \"\\efa1\"; }\n.ri-pie-chart-2-line:before { content: \"\\efa2\"; }\n.ri-pie-chart-box-fill:before { content: \"\\efa3\"; }\n.ri-pie-chart-box-line:before { content: \"\\efa4\"; }\n.ri-pie-chart-fill:before { content: \"\\efa5\"; }\n.ri-pie-chart-line:before { content: \"\\efa6\"; }\n.ri-pin-distance-fill:before { content: \"\\efa7\"; }\n.ri-pin-distance-line:before { content: \"\\efa8\"; }\n.ri-ping-pong-fill:before { content: \"\\efa9\"; }\n.ri-ping-pong-line:before { content: \"\\efaa\"; }\n.ri-pinterest-fill:before { content: \"\\efab\"; }\n.ri-pinterest-line:before { content: \"\\efac\"; }\n.ri-pinyin-input:before { content: \"\\efad\"; }\n.ri-pixelfed-fill:before { content: \"\\efae\"; }\n.ri-pixelfed-line:before { content: \"\\efaf\"; }\n.ri-plane-fill:before { content: \"\\efb0\"; }\n.ri-plane-line:before { content: \"\\efb1\"; }\n.ri-plant-fill:before { content: \"\\efb2\"; }\n.ri-plant-line:before { content: \"\\efb3\"; }\n.ri-play-circle-fill:before { content: \"\\efb4\"; }\n.ri-play-circle-line:before { content: \"\\efb5\"; }\n.ri-play-fill:before { content: \"\\efb6\"; }\n.ri-play-line:before { content: \"\\efb7\"; }\n.ri-play-list-add-fill:before { content: \"\\efb8\"; }\n.ri-play-list-add-line:before { content: \"\\efb9\"; }\n.ri-play-list-fill:before { content: \"\\efba\"; }\n.ri-play-list-line:before { content: \"\\efbb\"; }\n.ri-play-mini-fill:before { content: \"\\efbc\"; }\n.ri-play-mini-line:before { content: \"\\efbd\"; }\n.ri-playstation-fill:before { content: \"\\efbe\"; }\n.ri-playstation-line:before { content: \"\\efbf\"; }\n.ri-plug-2-fill:before { content: \"\\efc0\"; }\n.ri-plug-2-line:before { content: \"\\efc1\"; }\n.ri-plug-fill:before { content: \"\\efc2\"; }\n.ri-plug-line:before { content: \"\\efc3\"; }\n.ri-polaroid-2-fill:before { content: \"\\efc4\"; }\n.ri-polaroid-2-line:before { content: \"\\efc5\"; }\n.ri-polaroid-fill:before { content: \"\\efc6\"; }\n.ri-polaroid-line:before { content: \"\\efc7\"; }\n.ri-police-car-fill:before { content: \"\\efc8\"; }\n.ri-police-car-line:before { content: \"\\efc9\"; }\n.ri-price-tag-2-fill:before { content: \"\\efca\"; }\n.ri-price-tag-2-line:before { content: \"\\efcb\"; }\n.ri-price-tag-3-fill:before { content: \"\\efcc\"; }\n.ri-price-tag-3-line:before { content: \"\\efcd\"; }\n.ri-price-tag-fill:before { content: \"\\efce\"; }\n.ri-price-tag-line:before { content: \"\\efcf\"; }\n.ri-printer-cloud-fill:before { content: \"\\efd0\"; }\n.ri-printer-cloud-line:before { content: \"\\efd1\"; }\n.ri-printer-fill:before { content: \"\\efd2\"; }\n.ri-printer-line:before { content: \"\\efd3\"; }\n.ri-product-hunt-fill:before { content: \"\\efd4\"; }\n.ri-product-hunt-line:before { content: \"\\efd5\"; }\n.ri-profile-fill:before { content: \"\\efd6\"; }\n.ri-profile-line:before { content: \"\\efd7\"; }\n.ri-projector-2-fill:before { content: \"\\efd8\"; }\n.ri-projector-2-line:before { content: \"\\efd9\"; }\n.ri-projector-fill:before { content: \"\\efda\"; }\n.ri-projector-line:before { content: \"\\efdb\"; }\n.ri-pushpin-2-fill:before { content: \"\\efdc\"; }\n.ri-pushpin-2-line:before { content: \"\\efdd\"; }\n.ri-pushpin-fill:before { content: \"\\efde\"; }\n.ri-pushpin-line:before { content: \"\\efdf\"; }\n.ri-qq-fill:before { content: \"\\efe0\"; }\n.ri-qq-line:before { content: \"\\efe1\"; }\n.ri-qr-code-fill:before { content: \"\\efe2\"; }\n.ri-qr-code-line:before { content: \"\\efe3\"; }\n.ri-qr-scan-2-fill:before { content: \"\\efe4\"; }\n.ri-qr-scan-2-line:before { content: \"\\efe5\"; }\n.ri-qr-scan-fill:before { content: \"\\efe6\"; }\n.ri-qr-scan-line:before { content: \"\\efe7\"; }\n.ri-question-answer-fill:before { content: \"\\efe8\"; }\n.ri-question-answer-line:before { content: \"\\efe9\"; }\n.ri-question-fill:before { content: \"\\efea\"; }\n.ri-question-line:before { content: \"\\efeb\"; }\n.ri-questionnaire-fill:before { content: \"\\efec\"; }\n.ri-questionnaire-line:before { content: \"\\efed\"; }\n.ri-quill-pen-fill:before { content: \"\\efee\"; }\n.ri-quill-pen-line:before { content: \"\\efef\"; }\n.ri-radar-fill:before { content: \"\\eff0\"; }\n.ri-radar-line:before { content: \"\\eff1\"; }\n.ri-radio-2-fill:before { content: \"\\eff2\"; }\n.ri-radio-2-line:before { content: \"\\eff3\"; }\n.ri-radio-button-fill:before { content: \"\\eff4\"; }\n.ri-radio-button-line:before { content: \"\\eff5\"; }\n.ri-radio-fill:before { content: \"\\eff6\"; }\n.ri-radio-line:before { content: \"\\eff7\"; }\n.ri-rainbow-fill:before { content: \"\\eff8\"; }\n.ri-rainbow-line:before { content: \"\\eff9\"; }\n.ri-rainy-fill:before { content: \"\\effa\"; }\n.ri-rainy-line:before { content: \"\\effb\"; }\n.ri-reactjs-fill:before { content: \"\\effc\"; }\n.ri-reactjs-line:before { content: \"\\effd\"; }\n.ri-record-circle-fill:before { content: \"\\effe\"; }\n.ri-record-circle-line:before { content: \"\\efff\"; }\n.ri-record-mail-fill:before { content: \"\\f000\"; }\n.ri-record-mail-line:before { content: \"\\f001\"; }\n.ri-recycle-fill:before { content: \"\\f002\"; }\n.ri-recycle-line:before { content: \"\\f003\"; }\n.ri-red-packet-fill:before { content: \"\\f004\"; }\n.ri-red-packet-line:before { content: \"\\f005\"; }\n.ri-reddit-fill:before { content: \"\\f006\"; }\n.ri-reddit-line:before { content: \"\\f007\"; }\n.ri-refresh-fill:before { content: \"\\f008\"; }\n.ri-refresh-line:before { content: \"\\f009\"; }\n.ri-refund-2-fill:before { content: \"\\f00a\"; }\n.ri-refund-2-line:before { content: \"\\f00b\"; }\n.ri-refund-fill:before { content: \"\\f00c\"; }\n.ri-refund-line:before { content: \"\\f00d\"; }\n.ri-registered-fill:before { content: \"\\f00e\"; }\n.ri-registered-line:before { content: \"\\f00f\"; }\n.ri-remixicon-fill:before { content: \"\\f010\"; }\n.ri-remixicon-line:before { content: \"\\f011\"; }\n.ri-remote-control-2-fill:before { content: \"\\f012\"; }\n.ri-remote-control-2-line:before { content: \"\\f013\"; }\n.ri-remote-control-fill:before { content: \"\\f014\"; }\n.ri-remote-control-line:before { content: \"\\f015\"; }\n.ri-repeat-2-fill:before { content: \"\\f016\"; }\n.ri-repeat-2-line:before { content: \"\\f017\"; }\n.ri-repeat-fill:before { content: \"\\f018\"; }\n.ri-repeat-line:before { content: \"\\f019\"; }\n.ri-repeat-one-fill:before { content: \"\\f01a\"; }\n.ri-repeat-one-line:before { content: \"\\f01b\"; }\n.ri-reply-fill:before { content: \"\\f01c\"; }\n.ri-reply-line:before { content: \"\\f01d\"; }\n.ri-reserved-fill:before { content: \"\\f01e\"; }\n.ri-reserved-line:before { content: \"\\f01f\"; }\n.ri-restart-fill:before { content: \"\\f020\"; }\n.ri-restart-line:before { content: \"\\f021\"; }\n.ri-restaurant-2-fill:before { content: \"\\f022\"; }\n.ri-restaurant-2-line:before { content: \"\\f023\"; }\n.ri-restaurant-fill:before { content: \"\\f024\"; }\n.ri-restaurant-line:before { content: \"\\f025\"; }\n.ri-rewind-fill:before { content: \"\\f026\"; }\n.ri-rewind-line:before { content: \"\\f027\"; }\n.ri-rewind-mini-fill:before { content: \"\\f028\"; }\n.ri-rewind-mini-line:before { content: \"\\f029\"; }\n.ri-rhythm-fill:before { content: \"\\f02a\"; }\n.ri-rhythm-line:before { content: \"\\f02b\"; }\n.ri-riding-fill:before { content: \"\\f02c\"; }\n.ri-riding-line:before { content: \"\\f02d\"; }\n.ri-road-map-fill:before { content: \"\\f02e\"; }\n.ri-road-map-line:before { content: \"\\f02f\"; }\n.ri-roadster-fill:before { content: \"\\f030\"; }\n.ri-roadster-line:before { content: \"\\f031\"; }\n.ri-robot-fill:before { content: \"\\f032\"; }\n.ri-robot-line:before { content: \"\\f033\"; }\n.ri-rocket-2-fill:before { content: \"\\f034\"; }\n.ri-rocket-2-line:before { content: \"\\f035\"; }\n.ri-rocket-fill:before { content: \"\\f036\"; }\n.ri-rocket-line:before { content: \"\\f037\"; }\n.ri-rotate-lock-fill:before { content: \"\\f038\"; }\n.ri-rotate-lock-line:before { content: \"\\f039\"; }\n.ri-route-fill:before { content: \"\\f03a\"; }\n.ri-route-line:before { content: \"\\f03b\"; }\n.ri-router-fill:before { content: \"\\f03c\"; }\n.ri-router-line:before { content: \"\\f03d\"; }\n.ri-rss-fill:before { content: \"\\f03e\"; }\n.ri-rss-line:before { content: \"\\f03f\"; }\n.ri-ruler-2-fill:before { content: \"\\f040\"; }\n.ri-ruler-2-line:before { content: \"\\f041\"; }\n.ri-ruler-fill:before { content: \"\\f042\"; }\n.ri-ruler-line:before { content: \"\\f043\"; }\n.ri-run-fill:before { content: \"\\f044\"; }\n.ri-run-line:before { content: \"\\f045\"; }\n.ri-safari-fill:before { content: \"\\f046\"; }\n.ri-safari-line:before { content: \"\\f047\"; }\n.ri-safe-2-fill:before { content: \"\\f048\"; }\n.ri-safe-2-line:before { content: \"\\f049\"; }\n.ri-safe-fill:before { content: \"\\f04a\"; }\n.ri-safe-line:before { content: \"\\f04b\"; }\n.ri-sailboat-fill:before { content: \"\\f04c\"; }\n.ri-sailboat-line:before { content: \"\\f04d\"; }\n.ri-save-2-fill:before { content: \"\\f04e\"; }\n.ri-save-2-line:before { content: \"\\f04f\"; }\n.ri-save-3-fill:before { content: \"\\f050\"; }\n.ri-save-3-line:before { content: \"\\f051\"; }\n.ri-save-fill:before { content: \"\\f052\"; }\n.ri-save-line:before { content: \"\\f053\"; }\n.ri-scales-2-fill:before { content: \"\\f054\"; }\n.ri-scales-2-line:before { content: \"\\f055\"; }\n.ri-scales-fill:before { content: \"\\f056\"; }\n.ri-scales-line:before { content: \"\\f057\"; }\n.ri-scan-2-fill:before { content: \"\\f058\"; }\n.ri-scan-2-line:before { content: \"\\f059\"; }\n.ri-scan-fill:before { content: \"\\f05a\"; }\n.ri-scan-line:before { content: \"\\f05b\"; }\n.ri-scissors-2-fill:before { content: \"\\f05c\"; }\n.ri-scissors-2-line:before { content: \"\\f05d\"; }\n.ri-scissors-cut-fill:before { content: \"\\f05e\"; }\n.ri-scissors-cut-line:before { content: \"\\f05f\"; }\n.ri-scissors-fill:before { content: \"\\f060\"; }\n.ri-scissors-line:before { content: \"\\f061\"; }\n.ri-screenshot-2-fill:before { content: \"\\f062\"; }\n.ri-screenshot-2-line:before { content: \"\\f063\"; }\n.ri-screenshot-fill:before { content: \"\\f064\"; }\n.ri-screenshot-line:before { content: \"\\f065\"; }\n.ri-sd-card-fill:before { content: \"\\f066\"; }\n.ri-sd-card-line:before { content: \"\\f067\"; }\n.ri-sd-card-mini-fill:before { content: \"\\f068\"; }\n.ri-sd-card-mini-line:before { content: \"\\f069\"; }\n.ri-search-2-fill:before { content: \"\\f06a\"; }\n.ri-search-2-line:before { content: \"\\f06b\"; }\n.ri-search-eye-fill:before { content: \"\\f06c\"; }\n.ri-search-eye-line:before { content: \"\\f06d\"; }\n.ri-search-fill:before { content: \"\\f06e\"; }\n.ri-search-line:before { content: \"\\f06f\"; }\n.ri-secure-payment-fill:before { content: \"\\f070\"; }\n.ri-secure-payment-line:before { content: \"\\f071\"; }\n.ri-send-backward:before { content: \"\\f072\"; }\n.ri-send-plane-2-fill:before { content: \"\\f073\"; }\n.ri-send-plane-2-line:before { content: \"\\f074\"; }\n.ri-send-plane-fill:before { content: \"\\f075\"; }\n.ri-send-plane-line:before { content: \"\\f076\"; }\n.ri-send-to-back:before { content: \"\\f077\"; }\n.ri-sensor-fill:before { content: \"\\f078\"; }\n.ri-sensor-line:before { content: \"\\f079\"; }\n.ri-separator:before { content: \"\\f07a\"; }\n.ri-server-fill:before { content: \"\\f07b\"; }\n.ri-server-line:before { content: \"\\f07c\"; }\n.ri-service-fill:before { content: \"\\f07d\"; }\n.ri-service-line:before { content: \"\\f07e\"; }\n.ri-settings-2-fill:before { content: \"\\f07f\"; }\n.ri-settings-2-line:before { content: \"\\f080\"; }\n.ri-settings-3-fill:before { content: \"\\f081\"; }\n.ri-settings-3-line:before { content: \"\\f082\"; }\n.ri-settings-4-fill:before { content: \"\\f083\"; }\n.ri-settings-4-line:before { content: \"\\f084\"; }\n.ri-settings-5-fill:before { content: \"\\f085\"; }\n.ri-settings-5-line:before { content: \"\\f086\"; }\n.ri-settings-6-fill:before { content: \"\\f087\"; }\n.ri-settings-6-line:before { content: \"\\f088\"; }\n.ri-settings-fill:before { content: \"\\f089\"; }\n.ri-settings-line:before { content: \"\\f08a\"; }\n.ri-shape-2-fill:before { content: \"\\f08b\"; }\n.ri-shape-2-line:before { content: \"\\f08c\"; }\n.ri-shape-fill:before { content: \"\\f08d\"; }\n.ri-shape-line:before { content: \"\\f08e\"; }\n.ri-share-box-fill:before { content: \"\\f08f\"; }\n.ri-share-box-line:before { content: \"\\f090\"; }\n.ri-share-circle-fill:before { content: \"\\f091\"; }\n.ri-share-circle-line:before { content: \"\\f092\"; }\n.ri-share-fill:before { content: \"\\f093\"; }\n.ri-share-forward-2-fill:before { content: \"\\f094\"; }\n.ri-share-forward-2-line:before { content: \"\\f095\"; }\n.ri-share-forward-box-fill:before { content: \"\\f096\"; }\n.ri-share-forward-box-line:before { content: \"\\f097\"; }\n.ri-share-forward-fill:before { content: \"\\f098\"; }\n.ri-share-forward-line:before { content: \"\\f099\"; }\n.ri-share-line:before { content: \"\\f09a\"; }\n.ri-shield-cross-fill:before { content: \"\\f09b\"; }\n.ri-shield-cross-line:before { content: \"\\f09c\"; }\n.ri-shield-fill:before { content: \"\\f09d\"; }\n.ri-shield-flash-fill:before { content: \"\\f09e\"; }\n.ri-shield-flash-line:before { content: \"\\f09f\"; }\n.ri-shield-keyhole-fill:before { content: \"\\f0a0\"; }\n.ri-shield-keyhole-line:before { content: \"\\f0a1\"; }\n.ri-shield-line:before { content: \"\\f0a2\"; }\n.ri-shield-star-fill:before { content: \"\\f0a3\"; }\n.ri-shield-star-line:before { content: \"\\f0a4\"; }\n.ri-shield-user-fill:before { content: \"\\f0a5\"; }\n.ri-shield-user-line:before { content: \"\\f0a6\"; }\n.ri-ship-2-fill:before { content: \"\\f0a7\"; }\n.ri-ship-2-line:before { content: \"\\f0a8\"; }\n.ri-ship-fill:before { content: \"\\f0a9\"; }\n.ri-ship-line:before { content: \"\\f0aa\"; }\n.ri-shirt-fill:before { content: \"\\f0ab\"; }\n.ri-shirt-line:before { content: \"\\f0ac\"; }\n.ri-shopping-bag-2-fill:before { content: \"\\f0ad\"; }\n.ri-shopping-bag-2-line:before { content: \"\\f0ae\"; }\n.ri-shopping-bag-3-fill:before { content: \"\\f0af\"; }\n.ri-shopping-bag-3-line:before { content: \"\\f0b0\"; }\n.ri-shopping-bag-fill:before { content: \"\\f0b1\"; }\n.ri-shopping-bag-line:before { content: \"\\f0b2\"; }\n.ri-shopping-basket-2-fill:before { content: \"\\f0b3\"; }\n.ri-shopping-basket-2-line:before { content: \"\\f0b4\"; }\n.ri-shopping-basket-fill:before { content: \"\\f0b5\"; }\n.ri-shopping-basket-line:before { content: \"\\f0b6\"; }\n.ri-shopping-cart-2-fill:before { content: \"\\f0b7\"; }\n.ri-shopping-cart-2-line:before { content: \"\\f0b8\"; }\n.ri-shopping-cart-fill:before { content: \"\\f0b9\"; }\n.ri-shopping-cart-line:before { content: \"\\f0ba\"; }\n.ri-showers-fill:before { content: \"\\f0bb\"; }\n.ri-showers-line:before { content: \"\\f0bc\"; }\n.ri-shuffle-fill:before { content: \"\\f0bd\"; }\n.ri-shuffle-line:before { content: \"\\f0be\"; }\n.ri-shut-down-fill:before { content: \"\\f0bf\"; }\n.ri-shut-down-line:before { content: \"\\f0c0\"; }\n.ri-side-bar-fill:before { content: \"\\f0c1\"; }\n.ri-side-bar-line:before { content: \"\\f0c2\"; }\n.ri-signal-tower-fill:before { content: \"\\f0c3\"; }\n.ri-signal-tower-line:before { content: \"\\f0c4\"; }\n.ri-signal-wifi-1-fill:before { content: \"\\f0c5\"; }\n.ri-signal-wifi-1-line:before { content: \"\\f0c6\"; }\n.ri-signal-wifi-2-fill:before { content: \"\\f0c7\"; }\n.ri-signal-wifi-2-line:before { content: \"\\f0c8\"; }\n.ri-signal-wifi-3-fill:before { content: \"\\f0c9\"; }\n.ri-signal-wifi-3-line:before { content: \"\\f0ca\"; }\n.ri-signal-wifi-error-fill:before { content: \"\\f0cb\"; }\n.ri-signal-wifi-error-line:before { content: \"\\f0cc\"; }\n.ri-signal-wifi-fill:before { content: \"\\f0cd\"; }\n.ri-signal-wifi-line:before { content: \"\\f0ce\"; }\n.ri-signal-wifi-off-fill:before { content: \"\\f0cf\"; }\n.ri-signal-wifi-off-line:before { content: \"\\f0d0\"; }\n.ri-sim-card-2-fill:before { content: \"\\f0d1\"; }\n.ri-sim-card-2-line:before { content: \"\\f0d2\"; }\n.ri-sim-card-fill:before { content: \"\\f0d3\"; }\n.ri-sim-card-line:before { content: \"\\f0d4\"; }\n.ri-single-quotes-l:before { content: \"\\f0d5\"; }\n.ri-single-quotes-r:before { content: \"\\f0d6\"; }\n.ri-sip-fill:before { content: \"\\f0d7\"; }\n.ri-sip-line:before { content: \"\\f0d8\"; }\n.ri-skip-back-fill:before { content: \"\\f0d9\"; }\n.ri-skip-back-line:before { content: \"\\f0da\"; }\n.ri-skip-back-mini-fill:before { content: \"\\f0db\"; }\n.ri-skip-back-mini-line:before { content: \"\\f0dc\"; }\n.ri-skip-forward-fill:before { content: \"\\f0dd\"; }\n.ri-skip-forward-line:before { content: \"\\f0de\"; }\n.ri-skip-forward-mini-fill:before { content: \"\\f0df\"; }\n.ri-skip-forward-mini-line:before { content: \"\\f0e0\"; }\n.ri-skull-2-fill:before { content: \"\\f0e1\"; }\n.ri-skull-2-line:before { content: \"\\f0e2\"; }\n.ri-skull-fill:before { content: \"\\f0e3\"; }\n.ri-skull-line:before { content: \"\\f0e4\"; }\n.ri-skype-fill:before { content: \"\\f0e5\"; }\n.ri-skype-line:before { content: \"\\f0e6\"; }\n.ri-slack-fill:before { content: \"\\f0e7\"; }\n.ri-slack-line:before { content: \"\\f0e8\"; }\n.ri-slice-fill:before { content: \"\\f0e9\"; }\n.ri-slice-line:before { content: \"\\f0ea\"; }\n.ri-slideshow-2-fill:before { content: \"\\f0eb\"; }\n.ri-slideshow-2-line:before { content: \"\\f0ec\"; }\n.ri-slideshow-3-fill:before { content: \"\\f0ed\"; }\n.ri-slideshow-3-line:before { content: \"\\f0ee\"; }\n.ri-slideshow-4-fill:before { content: \"\\f0ef\"; }\n.ri-slideshow-4-line:before { content: \"\\f0f0\"; }\n.ri-slideshow-fill:before { content: \"\\f0f1\"; }\n.ri-slideshow-line:before { content: \"\\f0f2\"; }\n.ri-smartphone-fill:before { content: \"\\f0f3\"; }\n.ri-smartphone-line:before { content: \"\\f0f4\"; }\n.ri-snapchat-fill:before { content: \"\\f0f5\"; }\n.ri-snapchat-line:before { content: \"\\f0f6\"; }\n.ri-snowy-fill:before { content: \"\\f0f7\"; }\n.ri-snowy-line:before { content: \"\\f0f8\"; }\n.ri-sort-asc:before { content: \"\\f0f9\"; }\n.ri-sort-desc:before { content: \"\\f0fa\"; }\n.ri-sound-module-fill:before { content: \"\\f0fb\"; }\n.ri-sound-module-line:before { content: \"\\f0fc\"; }\n.ri-soundcloud-fill:before { content: \"\\f0fd\"; }\n.ri-soundcloud-line:before { content: \"\\f0fe\"; }\n.ri-space-ship-fill:before { content: \"\\f0ff\"; }\n.ri-space-ship-line:before { content: \"\\f100\"; }\n.ri-space:before { content: \"\\f101\"; }\n.ri-spam-2-fill:before { content: \"\\f102\"; }\n.ri-spam-2-line:before { content: \"\\f103\"; }\n.ri-spam-3-fill:before { content: \"\\f104\"; }\n.ri-spam-3-line:before { content: \"\\f105\"; }\n.ri-spam-fill:before { content: \"\\f106\"; }\n.ri-spam-line:before { content: \"\\f107\"; }\n.ri-speaker-2-fill:before { content: \"\\f108\"; }\n.ri-speaker-2-line:before { content: \"\\f109\"; }\n.ri-speaker-3-fill:before { content: \"\\f10a\"; }\n.ri-speaker-3-line:before { content: \"\\f10b\"; }\n.ri-speaker-fill:before { content: \"\\f10c\"; }\n.ri-speaker-line:before { content: \"\\f10d\"; }\n.ri-spectrum-fill:before { content: \"\\f10e\"; }\n.ri-spectrum-line:before { content: \"\\f10f\"; }\n.ri-speed-fill:before { content: \"\\f110\"; }\n.ri-speed-line:before { content: \"\\f111\"; }\n.ri-speed-mini-fill:before { content: \"\\f112\"; }\n.ri-speed-mini-line:before { content: \"\\f113\"; }\n.ri-spotify-fill:before { content: \"\\f114\"; }\n.ri-spotify-line:before { content: \"\\f115\"; }\n.ri-spy-fill:before { content: \"\\f116\"; }\n.ri-spy-line:before { content: \"\\f117\"; }\n.ri-stack-fill:before { content: \"\\f118\"; }\n.ri-stack-line:before { content: \"\\f119\"; }\n.ri-stack-overflow-fill:before { content: \"\\f11a\"; }\n.ri-stack-overflow-line:before { content: \"\\f11b\"; }\n.ri-stackshare-fill:before { content: \"\\f11c\"; }\n.ri-stackshare-line:before { content: \"\\f11d\"; }\n.ri-star-fill:before { content: \"\\f11e\"; }\n.ri-star-half-fill:before { content: \"\\f11f\"; }\n.ri-star-half-line:before { content: \"\\f120\"; }\n.ri-star-half-s-fill:before { content: \"\\f121\"; }\n.ri-star-half-s-line:before { content: \"\\f122\"; }\n.ri-star-line:before { content: \"\\f123\"; }\n.ri-star-s-fill:before { content: \"\\f124\"; }\n.ri-star-s-line:before { content: \"\\f125\"; }\n.ri-star-smile-fill:before { content: \"\\f126\"; }\n.ri-star-smile-line:before { content: \"\\f127\"; }\n.ri-steam-fill:before { content: \"\\f128\"; }\n.ri-steam-line:before { content: \"\\f129\"; }\n.ri-steering-2-fill:before { content: \"\\f12a\"; }\n.ri-steering-2-line:before { content: \"\\f12b\"; }\n.ri-steering-fill:before { content: \"\\f12c\"; }\n.ri-steering-line:before { content: \"\\f12d\"; }\n.ri-sticky-note-2-fill:before { content: \"\\f12e\"; }\n.ri-sticky-note-2-line:before { content: \"\\f12f\"; }\n.ri-sticky-note-fill:before { content: \"\\f130\"; }\n.ri-sticky-note-line:before { content: \"\\f131\"; }\n.ri-stock-fill:before { content: \"\\f132\"; }\n.ri-stock-line:before { content: \"\\f133\"; }\n.ri-stop-circle-fill:before { content: \"\\f134\"; }\n.ri-stop-circle-line:before { content: \"\\f135\"; }\n.ri-stop-fill:before { content: \"\\f136\"; }\n.ri-stop-line:before { content: \"\\f137\"; }\n.ri-stop-mini-fill:before { content: \"\\f138\"; }\n.ri-stop-mini-line:before { content: \"\\f139\"; }\n.ri-store-2-fill:before { content: \"\\f13a\"; }\n.ri-store-2-line:before { content: \"\\f13b\"; }\n.ri-store-3-fill:before { content: \"\\f13c\"; }\n.ri-store-3-line:before { content: \"\\f13d\"; }\n.ri-store-fill:before { content: \"\\f13e\"; }\n.ri-store-line:before { content: \"\\f13f\"; }\n.ri-strikethrough-2:before { content: \"\\f140\"; }\n.ri-strikethrough:before { content: \"\\f141\"; }\n.ri-subscript-2:before { content: \"\\f142\"; }\n.ri-subscript:before { content: \"\\f143\"; }\n.ri-subtract-fill:before { content: \"\\f144\"; }\n.ri-subtract-line:before { content: \"\\f145\"; }\n.ri-subway-fill:before { content: \"\\f146\"; }\n.ri-subway-line:before { content: \"\\f147\"; }\n.ri-subway-wifi-fill:before { content: \"\\f148\"; }\n.ri-subway-wifi-line:before { content: \"\\f149\"; }\n.ri-suitcase-2-fill:before { content: \"\\f14a\"; }\n.ri-suitcase-2-line:before { content: \"\\f14b\"; }\n.ri-suitcase-3-fill:before { content: \"\\f14c\"; }\n.ri-suitcase-3-line:before { content: \"\\f14d\"; }\n.ri-suitcase-fill:before { content: \"\\f14e\"; }\n.ri-suitcase-line:before { content: \"\\f14f\"; }\n.ri-sun-cloudy-fill:before { content: \"\\f150\"; }\n.ri-sun-cloudy-line:before { content: \"\\f151\"; }\n.ri-sun-fill:before { content: \"\\f152\"; }\n.ri-sun-foggy-fill:before { content: \"\\f153\"; }\n.ri-sun-foggy-line:before { content: \"\\f154\"; }\n.ri-sun-line:before { content: \"\\f155\"; }\n.ri-superscript-2:before { content: \"\\f156\"; }\n.ri-superscript:before { content: \"\\f157\"; }\n.ri-surround-sound-fill:before { content: \"\\f158\"; }\n.ri-surround-sound-line:before { content: \"\\f159\"; }\n.ri-survey-fill:before { content: \"\\f15a\"; }\n.ri-survey-line:before { content: \"\\f15b\"; }\n.ri-swap-box-fill:before { content: \"\\f15c\"; }\n.ri-swap-box-line:before { content: \"\\f15d\"; }\n.ri-swap-fill:before { content: \"\\f15e\"; }\n.ri-swap-line:before { content: \"\\f15f\"; }\n.ri-switch-fill:before { content: \"\\f160\"; }\n.ri-switch-line:before { content: \"\\f161\"; }\n.ri-sword-fill:before { content: \"\\f162\"; }\n.ri-sword-line:before { content: \"\\f163\"; }\n.ri-t-box-fill:before { content: \"\\f164\"; }\n.ri-t-box-line:before { content: \"\\f165\"; }\n.ri-t-shirt-2-fill:before { content: \"\\f166\"; }\n.ri-t-shirt-2-line:before { content: \"\\f167\"; }\n.ri-t-shirt-air-fill:before { content: \"\\f168\"; }\n.ri-t-shirt-air-line:before { content: \"\\f169\"; }\n.ri-t-shirt-fill:before { content: \"\\f16a\"; }\n.ri-t-shirt-line:before { content: \"\\f16b\"; }\n.ri-table-2:before { content: \"\\f16c\"; }\n.ri-table-alt-fill:before { content: \"\\f16d\"; }\n.ri-table-alt-line:before { content: \"\\f16e\"; }\n.ri-table-fill:before { content: \"\\f16f\"; }\n.ri-table-line:before { content: \"\\f170\"; }\n.ri-tablet-fill:before { content: \"\\f171\"; }\n.ri-tablet-line:before { content: \"\\f172\"; }\n.ri-takeaway-fill:before { content: \"\\f173\"; }\n.ri-takeaway-line:before { content: \"\\f174\"; }\n.ri-taobao-fill:before { content: \"\\f175\"; }\n.ri-taobao-line:before { content: \"\\f176\"; }\n.ri-tape-fill:before { content: \"\\f177\"; }\n.ri-tape-line:before { content: \"\\f178\"; }\n.ri-task-fill:before { content: \"\\f179\"; }\n.ri-task-line:before { content: \"\\f17a\"; }\n.ri-taxi-fill:before { content: \"\\f17b\"; }\n.ri-taxi-line:before { content: \"\\f17c\"; }\n.ri-taxi-wifi-fill:before { content: \"\\f17d\"; }\n.ri-taxi-wifi-line:before { content: \"\\f17e\"; }\n.ri-team-fill:before { content: \"\\f17f\"; }\n.ri-team-line:before { content: \"\\f180\"; }\n.ri-telegram-fill:before { content: \"\\f181\"; }\n.ri-telegram-line:before { content: \"\\f182\"; }\n.ri-temp-cold-fill:before { content: \"\\f183\"; }\n.ri-temp-cold-line:before { content: \"\\f184\"; }\n.ri-temp-hot-fill:before { content: \"\\f185\"; }\n.ri-temp-hot-line:before { content: \"\\f186\"; }\n.ri-terminal-box-fill:before { content: \"\\f187\"; }\n.ri-terminal-box-line:before { content: \"\\f188\"; }\n.ri-terminal-fill:before { content: \"\\f189\"; }\n.ri-terminal-line:before { content: \"\\f18a\"; }\n.ri-terminal-window-fill:before { content: \"\\f18b\"; }\n.ri-terminal-window-line:before { content: \"\\f18c\"; }\n.ri-text-direction-l:before { content: \"\\f18d\"; }\n.ri-text-direction-r:before { content: \"\\f18e\"; }\n.ri-text-spacing:before { content: \"\\f18f\"; }\n.ri-text-wrap:before { content: \"\\f190\"; }\n.ri-text:before { content: \"\\f191\"; }\n.ri-thumb-down-fill:before { content: \"\\f192\"; }\n.ri-thumb-down-line:before { content: \"\\f193\"; }\n.ri-thumb-up-fill:before { content: \"\\f194\"; }\n.ri-thumb-up-line:before { content: \"\\f195\"; }\n.ri-thunderstorms-fill:before { content: \"\\f196\"; }\n.ri-thunderstorms-line:before { content: \"\\f197\"; }\n.ri-ticket-2-fill:before { content: \"\\f198\"; }\n.ri-ticket-2-line:before { content: \"\\f199\"; }\n.ri-ticket-fill:before { content: \"\\f19a\"; }\n.ri-ticket-line:before { content: \"\\f19b\"; }\n.ri-time-fill:before { content: \"\\f19c\"; }\n.ri-time-line:before { content: \"\\f19d\"; }\n.ri-timer-2-fill:before { content: \"\\f19e\"; }\n.ri-timer-2-line:before { content: \"\\f19f\"; }\n.ri-timer-fill:before { content: \"\\f1a0\"; }\n.ri-timer-flash-fill:before { content: \"\\f1a1\"; }\n.ri-timer-flash-line:before { content: \"\\f1a2\"; }\n.ri-timer-line:before { content: \"\\f1a3\"; }\n.ri-todo-fill:before { content: \"\\f1a4\"; }\n.ri-todo-line:before { content: \"\\f1a5\"; }\n.ri-toggle-fill:before { content: \"\\f1a6\"; }\n.ri-toggle-line:before { content: \"\\f1a7\"; }\n.ri-tools-fill:before { content: \"\\f1a8\"; }\n.ri-tools-line:before { content: \"\\f1a9\"; }\n.ri-tornado-fill:before { content: \"\\f1aa\"; }\n.ri-tornado-line:before { content: \"\\f1ab\"; }\n.ri-trademark-fill:before { content: \"\\f1ac\"; }\n.ri-trademark-line:before { content: \"\\f1ad\"; }\n.ri-traffic-light-fill:before { content: \"\\f1ae\"; }\n.ri-traffic-light-line:before { content: \"\\f1af\"; }\n.ri-train-fill:before { content: \"\\f1b0\"; }\n.ri-train-line:before { content: \"\\f1b1\"; }\n.ri-train-wifi-fill:before { content: \"\\f1b2\"; }\n.ri-train-wifi-line:before { content: \"\\f1b3\"; }\n.ri-translate-2:before { content: \"\\f1b4\"; }\n.ri-translate:before { content: \"\\f1b5\"; }\n.ri-travesti-fill:before { content: \"\\f1b6\"; }\n.ri-travesti-line:before { content: \"\\f1b7\"; }\n.ri-treasure-map-fill:before { content: \"\\f1b8\"; }\n.ri-treasure-map-line:before { content: \"\\f1b9\"; }\n.ri-trello-fill:before { content: \"\\f1ba\"; }\n.ri-trello-line:before { content: \"\\f1bb\"; }\n.ri-trophy-fill:before { content: \"\\f1bc\"; }\n.ri-trophy-line:before { content: \"\\f1bd\"; }\n.ri-truck-fill:before { content: \"\\f1be\"; }\n.ri-truck-line:before { content: \"\\f1bf\"; }\n.ri-tumblr-fill:before { content: \"\\f1c0\"; }\n.ri-tumblr-line:before { content: \"\\f1c1\"; }\n.ri-tv-2-fill:before { content: \"\\f1c2\"; }\n.ri-tv-2-line:before { content: \"\\f1c3\"; }\n.ri-tv-fill:before { content: \"\\f1c4\"; }\n.ri-tv-line:before { content: \"\\f1c5\"; }\n.ri-twitch-fill:before { content: \"\\f1c6\"; }\n.ri-twitch-line:before { content: \"\\f1c7\"; }\n.ri-twitter-fill:before { content: \"\\f1c8\"; }\n.ri-twitter-line:before { content: \"\\f1c9\"; }\n.ri-typhoon-fill:before { content: \"\\f1ca\"; }\n.ri-typhoon-line:before { content: \"\\f1cb\"; }\n.ri-u-disk-fill:before { content: \"\\f1cc\"; }\n.ri-u-disk-line:before { content: \"\\f1cd\"; }\n.ri-ubuntu-fill:before { content: \"\\f1ce\"; }\n.ri-ubuntu-line:before { content: \"\\f1cf\"; }\n.ri-umbrella-fill:before { content: \"\\f1d0\"; }\n.ri-umbrella-line:before { content: \"\\f1d1\"; }\n.ri-underline:before { content: \"\\f1d2\"; }\n.ri-uninstall-fill:before { content: \"\\f1d3\"; }\n.ri-uninstall-line:before { content: \"\\f1d4\"; }\n.ri-unsplash-fill:before { content: \"\\f1d5\"; }\n.ri-unsplash-line:before { content: \"\\f1d6\"; }\n.ri-upload-2-fill:before { content: \"\\f1d7\"; }\n.ri-upload-2-line:before { content: \"\\f1d8\"; }\n.ri-upload-cloud-2-fill:before { content: \"\\f1d9\"; }\n.ri-upload-cloud-2-line:before { content: \"\\f1da\"; }\n.ri-upload-cloud-fill:before { content: \"\\f1db\"; }\n.ri-upload-cloud-line:before { content: \"\\f1dc\"; }\n.ri-upload-fill:before { content: \"\\f1dd\"; }\n.ri-upload-line:before { content: \"\\f1de\"; }\n.ri-user-2-fill:before { content: \"\\f1df\"; }\n.ri-user-2-line:before { content: \"\\f1e0\"; }\n.ri-user-3-fill:before { content: \"\\f1e1\"; }\n.ri-user-3-line:before { content: \"\\f1e2\"; }\n.ri-user-4-fill:before { content: \"\\f1e3\"; }\n.ri-user-4-line:before { content: \"\\f1e4\"; }\n.ri-user-5-fill:before { content: \"\\f1e5\"; }\n.ri-user-5-line:before { content: \"\\f1e6\"; }\n.ri-user-6-fill:before { content: \"\\f1e7\"; }\n.ri-user-6-line:before { content: \"\\f1e8\"; }\n.ri-user-add-fill:before { content: \"\\f1e9\"; }\n.ri-user-add-line:before { content: \"\\f1ea\"; }\n.ri-user-fill:before { content: \"\\f1eb\"; }\n.ri-user-follow-fill:before { content: \"\\f1ec\"; }\n.ri-user-follow-line:before { content: \"\\f1ed\"; }\n.ri-user-heart-fill:before { content: \"\\f1ee\"; }\n.ri-user-heart-line:before { content: \"\\f1ef\"; }\n.ri-user-line:before { content: \"\\f1f0\"; }\n.ri-user-location-fill:before { content: \"\\f1f1\"; }\n.ri-user-location-line:before { content: \"\\f1f2\"; }\n.ri-user-received-2-fill:before { content: \"\\f1f3\"; }\n.ri-user-received-2-line:before { content: \"\\f1f4\"; }\n.ri-user-received-fill:before { content: \"\\f1f5\"; }\n.ri-user-received-line:before { content: \"\\f1f6\"; }\n.ri-user-search-fill:before { content: \"\\f1f7\"; }\n.ri-user-search-line:before { content: \"\\f1f8\"; }\n.ri-user-settings-fill:before { content: \"\\f1f9\"; }\n.ri-user-settings-line:before { content: \"\\f1fa\"; }\n.ri-user-shared-2-fill:before { content: \"\\f1fb\"; }\n.ri-user-shared-2-line:before { content: \"\\f1fc\"; }\n.ri-user-shared-fill:before { content: \"\\f1fd\"; }\n.ri-user-shared-line:before { content: \"\\f1fe\"; }\n.ri-user-smile-fill:before { content: \"\\f1ff\"; }\n.ri-user-smile-line:before { content: \"\\f200\"; }\n.ri-user-star-fill:before { content: \"\\f201\"; }\n.ri-user-star-line:before { content: \"\\f202\"; }\n.ri-user-unfollow-fill:before { content: \"\\f203\"; }\n.ri-user-unfollow-line:before { content: \"\\f204\"; }\n.ri-user-voice-fill:before { content: \"\\f205\"; }\n.ri-user-voice-line:before { content: \"\\f206\"; }\n.ri-video-add-fill:before { content: \"\\f207\"; }\n.ri-video-add-line:before { content: \"\\f208\"; }\n.ri-video-chat-fill:before { content: \"\\f209\"; }\n.ri-video-chat-line:before { content: \"\\f20a\"; }\n.ri-video-download-fill:before { content: \"\\f20b\"; }\n.ri-video-download-line:before { content: \"\\f20c\"; }\n.ri-video-fill:before { content: \"\\f20d\"; }\n.ri-video-line:before { content: \"\\f20e\"; }\n.ri-video-upload-fill:before { content: \"\\f20f\"; }\n.ri-video-upload-line:before { content: \"\\f210\"; }\n.ri-vidicon-2-fill:before { content: \"\\f211\"; }\n.ri-vidicon-2-line:before { content: \"\\f212\"; }\n.ri-vidicon-fill:before { content: \"\\f213\"; }\n.ri-vidicon-line:before { content: \"\\f214\"; }\n.ri-vip-crown-2-fill:before { content: \"\\f215\"; }\n.ri-vip-crown-2-line:before { content: \"\\f216\"; }\n.ri-vip-crown-fill:before { content: \"\\f217\"; }\n.ri-vip-crown-line:before { content: \"\\f218\"; }\n.ri-vip-diamond-fill:before { content: \"\\f219\"; }\n.ri-vip-diamond-line:before { content: \"\\f21a\"; }\n.ri-vip-fill:before { content: \"\\f21b\"; }\n.ri-vip-line:before { content: \"\\f21c\"; }\n.ri-visa-fill:before { content: \"\\f21d\"; }\n.ri-visa-line:before { content: \"\\f21e\"; }\n.ri-voice-recognition-fill:before { content: \"\\f21f\"; }\n.ri-voice-recognition-line:before { content: \"\\f220\"; }\n.ri-voiceprint-fill:before { content: \"\\f221\"; }\n.ri-voiceprint-line:before { content: \"\\f222\"; }\n.ri-volume-down-fill:before { content: \"\\f223\"; }\n.ri-volume-down-line:before { content: \"\\f224\"; }\n.ri-volume-mute-fill:before { content: \"\\f225\"; }\n.ri-volume-mute-line:before { content: \"\\f226\"; }\n.ri-volume-off-vibrate-fill:before { content: \"\\f227\"; }\n.ri-volume-off-vibrate-line:before { content: \"\\f228\"; }\n.ri-volume-up-fill:before { content: \"\\f229\"; }\n.ri-volume-up-line:before { content: \"\\f22a\"; }\n.ri-volume-vibrate-fill:before { content: \"\\f22b\"; }\n.ri-volume-vibrate-line:before { content: \"\\f22c\"; }\n.ri-vuejs-fill:before { content: \"\\f22d\"; }\n.ri-vuejs-line:before { content: \"\\f22e\"; }\n.ri-walk-fill:before { content: \"\\f22f\"; }\n.ri-walk-line:before { content: \"\\f230\"; }\n.ri-wallet-2-fill:before { content: \"\\f231\"; }\n.ri-wallet-2-line:before { content: \"\\f232\"; }\n.ri-wallet-3-fill:before { content: \"\\f233\"; }\n.ri-wallet-3-line:before { content: \"\\f234\"; }\n.ri-wallet-fill:before { content: \"\\f235\"; }\n.ri-wallet-line:before { content: \"\\f236\"; }\n.ri-water-flash-fill:before { content: \"\\f237\"; }\n.ri-water-flash-line:before { content: \"\\f238\"; }\n.ri-webcam-fill:before { content: \"\\f239\"; }\n.ri-webcam-line:before { content: \"\\f23a\"; }\n.ri-wechat-2-fill:before { content: \"\\f23b\"; }\n.ri-wechat-2-line:before { content: \"\\f23c\"; }\n.ri-wechat-fill:before { content: \"\\f23d\"; }\n.ri-wechat-line:before { content: \"\\f23e\"; }\n.ri-wechat-pay-fill:before { content: \"\\f23f\"; }\n.ri-wechat-pay-line:before { content: \"\\f240\"; }\n.ri-weibo-fill:before { content: \"\\f241\"; }\n.ri-weibo-line:before { content: \"\\f242\"; }\n.ri-whatsapp-fill:before { content: \"\\f243\"; }\n.ri-whatsapp-line:before { content: \"\\f244\"; }\n.ri-wheelchair-fill:before { content: \"\\f245\"; }\n.ri-wheelchair-line:before { content: \"\\f246\"; }\n.ri-wifi-fill:before { content: \"\\f247\"; }\n.ri-wifi-line:before { content: \"\\f248\"; }\n.ri-wifi-off-fill:before { content: \"\\f249\"; }\n.ri-wifi-off-line:before { content: \"\\f24a\"; }\n.ri-window-2-fill:before { content: \"\\f24b\"; }\n.ri-window-2-line:before { content: \"\\f24c\"; }\n.ri-window-fill:before { content: \"\\f24d\"; }\n.ri-window-line:before { content: \"\\f24e\"; }\n.ri-windows-fill:before { content: \"\\f24f\"; }\n.ri-windows-line:before { content: \"\\f250\"; }\n.ri-windy-fill:before { content: \"\\f251\"; }\n.ri-windy-line:before { content: \"\\f252\"; }\n.ri-wireless-charging-fill:before { content: \"\\f253\"; }\n.ri-wireless-charging-line:before { content: \"\\f254\"; }\n.ri-women-fill:before { content: \"\\f255\"; }\n.ri-women-line:before { content: \"\\f256\"; }\n.ri-wubi-input:before { content: \"\\f257\"; }\n.ri-xbox-fill:before { content: \"\\f258\"; }\n.ri-xbox-line:before { content: \"\\f259\"; }\n.ri-xing-fill:before { content: \"\\f25a\"; }\n.ri-xing-line:before { content: \"\\f25b\"; }\n.ri-youtube-fill:before { content: \"\\f25c\"; }\n.ri-youtube-line:before { content: \"\\f25d\"; }\n.ri-zcool-fill:before { content: \"\\f25e\"; }\n.ri-zcool-line:before { content: \"\\f25f\"; }\n.ri-zhihu-fill:before { content: \"\\f260\"; }\n.ri-zhihu-line:before { content: \"\\f261\"; }\n.ri-zoom-in-fill:before { content: \"\\f262\"; }\n.ri-zoom-in-line:before { content: \"\\f263\"; }\n.ri-zoom-out-fill:before { content: \"\\f264\"; }\n.ri-zoom-out-line:before { content: \"\\f265\"; }\n\n","/*\nTemplate Name: Upzet -  Admin & Dashboard Template\nAuthor: Themesdesign\nVersion: 1.1.0\nContact: themesdesign.in@gmail.com\nFile: Custom Bootstrap Css File\n*/\n\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";\n\n@import \"custom/components/reboot\";\n@import \"custom/components/backgrounds\";\n@import \"custom/components/badge\";\n@import \"custom/components/buttons\";\n@import \"custom/components/calendaryFlatpickr\";\n@import \"custom/components/breadcrumb\";\n@import \"custom/components/card\";\n@import \"custom/components/dropdown\";\n@import \"custom/components/nav\";\n@import \"custom/components/table\";\n@import \"custom/components/pagination\";\n@import \"custom/components/progress\";\n@import \"custom/components/dragdrop\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n// ** Pallet color **\n\n// -- BLUE\n$color-azul2: #263874;\n$blue_primary: #244EA2;\n$light_blue_01: #498EF2;\n$light_blue_02: #82C0F9;\n$light_blue_03: #005366;\n$light_blue_04: #0075A2;\n$light_blue_05: #7DC3DC;\n$light_blue_06: #1FA3CC;\n$light_blue_07: #9DE6E6;\n$light_blue_08: #D6D9E2;\n$light_blue_09: #B4D8FB;\n$light_blue_10: #C2CADF;\n$light_blue_11: #596CA3;\n$light_blue_12: #D8F5F5;\n$light_blue_13: #e5e7ee;\n$light_blue_14: #98A1BB;\n$dark_blue_10: #193576;\n\n$color-azul1: #0F1D42;\n$color-azul2: #263874;\n$color-azul2-hover: #364B8C;\n$color-azul3: #244EA2;\n$color-azul4: #498EF2;\n$color-azul5: #82C0F9;\n$color-azul6: #005366;\n$color-azul7: #0075A2;\n$color-azul8: #1FA3CC;\n$color-azul9: #7DC3DC;\n$color-azul10: #9DE6E6;\n$color-azul11: #D6D9E2;\n$color-azul410: #C1E0FF;\n$color-azul130: #6A799C;\n$color-azul405: #E5F3FF;\n\n\n// -- gray\n$light_gray: #F7F7F7;\n$light_gray_02: #EEEEEE;\n$light_gray_03: #E2E2E2;\n$light_gray_04: #E6E6E6;\n$light_gray_05: #D9D9D9;\n$light_gray_06: #CDCDCD;\n$gray_primary: #A8A8A8;\n$gray_secundary: #6C6C6C;\n$gray_03: #676A6C;\n$dark_gray_primary: #353535;\n$dark_gray_primary_02: #232323;\n\n$color-branco2: #F5F5F5;\n$color-branco3: #F0F0F0;\n$color-cinza1: #E2E2E2;\n$color-cinza2: #D9D9D9;\n$color-cinza2-5: #CDCDCD;\n$color-cinza3: #A8A8A8;\n$color-cinza4: #6C6C6C;\n$color-cinza5: #353535;\n$color-cinza6: #B4B4B412;\n\n$gray_disabled: #ebebeb;\n$border_disabled: #d7d7d7;\n\n$green_icon: #55af53;\n\n$color-vermelho1: #ec221f;\n$color-vermelho2: #BA0501;\n$color-vermelho3: #ec221f25;\n$color-verde1: #4bb543;\n$color-verde2: #0a7702;\n$color-verde3: #4bb54325;\n$color-amarelo1: #fece22;\n$color-amarelo2: #7f6d31;\n$color-amarelo3: #fece2225;\n$color-laranja1: #ff6241;\n\n// -----------------\n// custom-variables\n// -----------------\n\n// Vertical Sidebar - Default Light\n$sidebar-bg: #ffffff;\n$sidebar-menu-item-color: #74788d;\n$sidebar-menu-sub-item-color: #7c8a96;\n$sidebar-menu-item-icon-color: $dark_gray_primary;\n$sidebar-menu-item-hover-color: #383c40;\n$sidebar-menu-item-active-color: $color-azul2;\n$sidebar-width: 250px;\n$sidebar-collapsed-width: 70px;\n$sidebar-width-sm: 80px;\n\n// Vertical Sidebar - Dark\n$sidebar-dark-bg: $blue_primary;\n$sidebar-light-bg: #f1f5f7;\n$sidebar-dark-menu-item-color: #8590a5;\n// $sidebar-dark-menu-sub-item-color: #8590a5;\n$sidebar-dark-menu-item-icon-color: #8590a5;\n// $sidebar-dark-menu-item-hover-color: #d7e4ec;\n$sidebar-dark-menu-item-active-color: #d7e4ec;\n\n// Topbar - Deafult Light\n$header-height: 76px;\n$header-bg: #ffffff;\n$header-item-color: #636e75;\n$header-dropdown-bg-opacity: $blue_primary;\n$header-size-icon: 42px;\n\n// Topbar - Dark\n$header-dark-bg: $blue_primary;\n$header-dark-item-color: #e9ecef;\n\n// Topbar Search\n$topbar-search-bg: #182C59;\n$topbar-search-icon: $light_blue_05;\n\n// Topbar Inside\n$topbar-inside-bg: #E4EAF5;\n$topbar-inside-item-color: $dark_gray_primary;\n$topbar-inside-height-item: 36;\n\n// Footer\n$footer-height: 120px;\n$footer-bg: #fff;\n$footer-color: #74788d;\n\n// Horizontal nav\n$topnav-bg:   #fff;\n$menu-item-color: #74788d;\n$menu-item-active-color: #0bb197;\n\n// Right Sidebar\n$rightbar-width:  280px;\n\n// Display\n$display-none: none;\n$display-block: block;\n\n// Brand \n$navbar-brand-box-width: 160px;\n\n// Boxed layout width\n$boxed-layout-width:    1300px;\n$boxed-body-bg:       #dee7ec;\n\n// Font Weight\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n\n\n// table\n$table-head-bg:               $gray-100;\n$table-dark-border-color:     tint-color($gray-800, 7.5%);\n\n// Custom Font\n$font-family-secondary:      'Work Sans', sans-serif;\n\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff;\n$gray-100: #f8f9fa;\n$gray-200: #eff2f7;\n$gray-300: #f1f5f7;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #74788d;\n$gray-700: #505d69;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black:    #000;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n$blue:    $blue_primary;\n$indigo:  #564ab1;\n$purple:  #5664d2;\n$pink:    #e83e8c;\n$red:     #EC221F;\n$orange:  #f1734f;\n$yellow:  #fece22;\n$green:   #4bb543;\n$teal:    #050505;\n$cyan:    #4aa3ff;\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue;\n$primary_dark:  $color-azul2;\n$secondary:     $gray-600;\n$success:       $green;\n$info:          #F0F0F0;\n$warning:       $yellow;\n$danger:        $red;\n$light:         $gray-200;\n$dark:          $gray-800;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"primary-dark\":    $primary_dark,\n  \"gray-secundary\": $gray_secundary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"pink\":       $pink,\n  \"light\":      $light,\n  \"dark\":       $dark,\n  \"dark-gray-primary\": $dark_gray_primary,\n  \"light-gray-05\": $light_gray_05,\n  \"light-gray-03\": $light_gray_03,\n  \"light_gray_04\": $light_gray_04,\n  \"light-gray-06\": $light_gray_06,\n  \"light_blue_04\": $light_blue_04,\n  \"light-blue-01\": $light_blue_01,\n  \"light-blue-11\": $light_blue_11,\n  \"light-blue-06\": $light_blue_06,\n  \"light-blue-08\": $light_blue_08,\n  \"light-blue-13\": $light_blue_13,\n  \"light-blue-14\": $light_blue_14,\n  \"color-azul1\": $color-azul1,\n  \"color-azul2\": $color-azul2,\n  \"color-azul2-hover\": $color-azul2-hover,\n  \"color-azul3\": $color-azul3,\n  \"color-azul4\": $color-azul4,\n  \"color-azul5\": $color-azul5,\n  \"color-azul6\": $color-azul6,\n  \"color-azul7\": $color-azul7,\n  \"color-azul8\": $color-azul8,\n  \"color-azul9\": $color-azul9,\n  \"color-azul10\": $color-azul10,\n  \"color-azul11\": $color-azul11,\n  \"color-azul410\": $color-azul410,\n  \"color-azul130\": $color-azul130,\n  \"color-azul405\": $color-azul405,\n  \"color-branco2\": $color-branco2,\n  \"color-branco3\": $color-branco3,\n  \"color-cinza1\": $color-cinza1,\n  \"color-cinza2\": $color-cinza2,\n  \"color-cinza2-5\": $color-cinza2-5,\n  \"color-cinza3\": $color-cinza3,\n  \"color-cinza4\": $color-cinza4,\n  \"color-cinza5\": $color-cinza5,\n  \"color-cinza6\": $color-cinza6,\n  \"color-vermelho1\": $color-vermelho1,\n  \"color-vermelho2\": $color-vermelho2,\n  \"color-vermelho3\": $color-vermelho3,\n  \"color-verde1\": $color-verde1,\n  \"color-verde2\": $color-verde2,\n  \"color-verde3\": $color-verde3,\n  \"color-amarelo1\": $color-amarelo1,\n  \"color-amarelo2\": $color-amarelo2,\n  \"color-amarelo3\": $color-amarelo3,\n  \"color-laranja1\": $color-laranja1\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   1.7;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                false;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs-;\n\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n// scss-docs-end position-map\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   #f3f3f4;\n$body-color:                $gray-700;\n$body-text-align:           null;\n\n// Utilities maps\n//\n// Extends the default `$theme-colors` maps to help create our utilities.\n\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\n// scss-docs-start utilities-colors\n$utilities-colors: $theme-colors-rgb;\n// scss-docs-end utilities-colors\n\n// scss-docs-start utilities-text-colors\n$utilities-text: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-color)\n  )\n);\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\");\n// scss-docs-end utilities-text-colors\n\n// scss-docs-start utilities-bg-colors\n$utilities-bg: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-bg)\n  )\n);\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\");\n// scss-docs-end utilities-bg-colors\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary;\n$link-decoration:                         none;\n$link-shade-percentage:                   20%;\n$link-hover-color:                        darken($link-color, 15%);\n$link-hover-decoration:                   underline;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           48px;\n$grid-row-columns:            6;\n\n$gutters: $spacers;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-color:                $gray-200;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-lg:            .4rem;\n$border-radius-sm:            .2rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow-sm:               0 1px 1px rgba($black,.05);\n$box-shadow:                  2px 4px 12px rgba($black,.08);\n$box-shadow-lg:               0 5px 12px rgba($black, 0.1);\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white;\n$component-active-bg:         $primary;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      'Poppins', sans-serif;\n// $font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif);\n// $font-family-code:            var(--#{$variable-prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null;\n$font-size-sm:                0.75rem; // 12px\n$font-size-base:              0.875rem; // 14px\n$font-size-md:                1rem; // 16px\n$font-size-lg:                1.125rem; // 18px\n$font-size-xlg:               1.25rem; // 20px\n$font-size-xxlg:              1.375rem; // 22px\n$font-size-xxxlg:             1.5rem; // 24px\n\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-medium:          500;\n$font-weight-bold:            600;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n$line-height-base:            1.5;\n$line-height-sm:              1.25;\n$line-height-lg:              2;\n\n$h1-font-size:                $font-size-base * 2.5;\n$h2-font-size:                $font-size-base * 2;\n$h3-font-size:                $font-size-base * 1.75;\n$h4-font-size:                $font-size-base * 1.5;\n$h5-font-size:                $font-size-base * 1.25;\n$h6-font-size:                $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer / 2;\n$headings-font-family:        null;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.2;\n$headings-color:              null;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 6rem,\n  2: 5.5rem,\n  3: 4.5rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             80%;\n\n$sub-sup-font-size:           .75em;\n\n$text-muted:                  $gray-600;\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.25;\n$blockquote-footer-color:     $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer;\n$hr-color:                    rgba($black, .1);\n$hr-height:                   $border-width;\n$hr-opacity:                  .7;\n\n$legend-margin-bottom:        .5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-bold;\n\n$nested-kbd-font-weight:      $font-weight-bold;\n\n$list-inline-padding:         .5rem;\n\n$mark-bg:                     #fcf8e3;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .75rem;\n$table-cell-padding-x:        .75rem;\n$table-cell-padding-y-sm:     .3rem;\n$table-cell-padding-x-sm:     .3rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 $body-color;\n$table-bg:                    null;\n$table-accent-bg:             transparent;\n\n$table-th-font-weight:        null;\n\n\n$table-striped-color:         $table-color;\n$table-striped-bg-factor:     .05;\n$table-striped-bg:            $gray-100;\n\n$table-active-color:          $table-color;\n$table-active-bg-factor:      .1;\n$table-active-bg:             $gray-100;\n\n$table-hover-color:           $table-color;\n$table-hover-bg-factor:       .075;\n$table-hover-bg:              $gray-100;\n\n$table-border-factor:         .1;\n$table-border-width:          $border-width;\n$table-border-color:          $border-color;\n\n$table-striped-order:         odd;\n$table-group-separator-color: $border-color;\n\n$table-caption-color:         $text-muted;\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $gray-100,\n  \"dark\":       $dark,\n);\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .47rem;\n$input-btn-padding-x:         .75rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:       .15rem;\n$input-btn-focus-color-opacity: .25;\n$input-btn-focus-color:         rgba($component-active-bg, .25);\n$input-btn-focus-blur:          0;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .25rem;\n$input-btn-padding-x-sm:      .5rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .5rem;\n$input-btn-padding-x-lg:      1rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      $border-width;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\n\n$btn-link-color:              $link-color;\n$btn-link-hover-color:        $link-hover-color;\n$btn-link-disabled-color:     $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius;\n$btn-border-radius-sm:        $border-radius-sm;\n$btn-border-radius-lg:        $border-radius-lg;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       $text-muted;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              $white;\n$input-disabled-bg:                     $gray-200;\n$input-disabled-border-color:           null;\n\n$input-color:                           $gray-700;\n$input-border-color:                    $gray-400;\n$input-border-width:                    $input-btn-border-width;\n$input-box-shadow:                      $box-shadow-inset;\n\n$input-border-radius:                   $border-radius;\n$input-border-radius-lg:                $border-radius-lg;\n$input-border-radius-sm:                $border-radius-sm;\n\n$input-focus-bg:                        $input-bg;\n$input-focus-border-color:              darken($input-border-color, 10%);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                none;\n\n$input-placeholder-color:               $gray-600;\n$input-plaintext-color:                 $body-color;\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y / 2);\n\n$input-height:                          40px;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5em;\n$form-check-margin-bottom:                .125rem;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   background-color .15s ease-in-out, background-position .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     $card-bg;\n$form-check-input-border:                 1px solid rgba(0, 0, 0, .25);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\n\n$form-check-input-checked-color:          $component-active-color;\n$form-check-input-checked-bg-color:       $component-active-bg;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         $input-focus-border-color;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  $gray-200;\n$input-group-addon-border-color:        $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y;\n$form-select-padding-x:             $input-padding-x;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     1.75rem; // Extra padding to account for the presence of the background-image based indicator\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 $input-color;\n$form-select-disabled-color:        $gray-600;\n$form-select-bg:                    $input-bg;\n$form-select-disabled-bg:           $gray-200;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: add(1em * .75, (2 * $form-select-padding-y * .75) + $form-select-padding-x + $form-select-indicator-padding);\n$form-select-feedback-icon-position:    center right ($form-select-padding-x + $form-select-indicator-padding);\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       $border-radius;\n$form-select-box-shadow:          $box-shadow-inset;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             $gray-300;\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     $box-shadow-inset;\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg:             $gray-500;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color;\n$form-file-button-bg:             $input-group-addon-bg;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $form-text-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    null;\n$nav-link-hover-color:              null;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n$nav-link-disabled-color:           $gray-600;\n\n$nav-tabs-border-color:             $gray-400;\n$nav-tabs-border-width:             $border-width;\n$nav-tabs-border-radius:            $border-radius;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color;\n$nav-tabs-link-active-color:        $gray-700;\n$nav-tabs-link-active-bg:           $card-bg;\n$nav-tabs-link-active-border-color: $gray-400 $gray-400 $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius:           $border-radius;\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5;\n$navbar-padding-x:                  null;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n\n$navbar-light-color:                rgba($black, .55);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         rgba($black, .9);\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                0;\n$dropdown-padding-y:                .5rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    $body-color;\n$dropdown-bg:                       $white;\n$dropdown-border-color:             rgba($black, .15);\n$dropdown-border-radius:            $border-radius;\n$dropdown-border-width:             0;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width});\n$dropdown-divider-bg:               $gray-200;\n$dropdown-divider-margin-y:         $spacer / 2;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175);\n\n$dropdown-link-color:               $gray-900;\n$dropdown-link-hover-color:         darken($gray-900, 5%);\n$dropdown-link-hover-bg:            $gray-100;\n\n$dropdown-link-active-color:        darken($gray-900, 5%);\n$dropdown-link-active-bg:           $gray-100;\n\n$dropdown-link-disabled-color:      $gray-600;\n\n$dropdown-item-padding-y:           .35rem;\n$dropdown-item-padding-x:           1rem;\n\n$dropdown-header-color:             $gray-600;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300;\n$dropdown-dark-bg:                  $gray-800;\n$dropdown-dark-border-color:        $dropdown-border-color;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          $dropdown-dark-color;\n$dropdown-dark-link-hover-color:    $white;\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\n$dropdown-dark-link-active-color:   $dropdown-link-active-color;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color:        $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .5rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .75rem;\n$pagination-padding-x-lg:           1.5rem;\n\n$pagination-color:                  $gray-600;\n$pagination-bg:                     $white;\n$pagination-border-width:           $border-width;\n$pagination-border-radius:          $border-radius;\n$pagination-margin-start:           -$pagination-border-width;\n$pagination-border-color:           $gray-400;\n\n$pagination-focus-color:            $link-hover-color;\n$pagination-focus-bg:               $gray-200;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            $link-hover-color;\n$pagination-hover-bg:               $gray-200;\n$pagination-hover-border-color:     $gray-400;\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         $gray-400;\n$pagination-disabled-bg:            $white;\n$pagination-disabled-border-color:  $gray-400;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       $border-radius-sm;\n$pagination-border-radius-lg:       $border-radius-lg;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     1.25rem;\n$card-spacer-x:                     1.25rem;\n$card-title-spacer-y:               $spacer / 2;\n$card-border-width:                 0;\n$card-box-shadow:                   null;\n$card-border-radius:                $border-radius-lg;\n$card-border-color:                 $gray-300;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                $card-spacer-y / 2;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       $gray-300;\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           $white;\n\n$card-title-desc:                   $gray-600;\n\n$card-img-overlay-padding:          $spacer;\n\n$card-group-margin:                 $grid-gutter-width / 2;\n// scss-docs-end card-variables\n\n// Accordion\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         $body-color;\n$accordion-bg:                            transparent;\n$accordion-border-width:                  $border-width;\n$accordion-border-color:                  rgba($black, .125);\n$accordion-border-radius:                 $border-radius;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  $accordion-color;\n$accordion-button-bg:                     $accordion-bg;\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%);\n$accordion-button-active-color:           shade-color($primary, 10%);\n\n$accordion-button-focus-border-color:     $input-focus-border-color;\n$accordion-button-focus-box-shadow:       none;\n\n$accordion-icon-width:                    16px;\n$accordion-icon-color:                    $accordion-color;\n$accordion-icon-active-color:             $accordion-button-active-color;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(180deg);\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     $white;\n$tooltip-bg:                        $black;\n$tooltip-border-radius:             $border-radius;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 .4rem;\n$tooltip-padding-x:                 .7rem;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   $line-height-base;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm;\n$popover-bg:                        $white;\n$popover-max-width:                 276px;\n$popover-border-width:              $border-width;\n$popover-border-color:              $gray-200;\n$popover-border-radius:             $border-radius-lg;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2);\n\n$popover-header-bg:                 darken($popover-bg, 3%);\n$popover-header-color:              $headings-color;\n$popover-header-padding-y:          .5rem;\n$popover-header-padding-x:          .75rem;\n\n$popover-body-color:                $body-color;\n$popover-body-padding-y:            $popover-header-padding-y;\n$popover-body-padding-x:            $popover-header-padding-x;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               $popover-bg;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05);\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .25rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       null;\n$toast-background-color:            rgba($white, .85);\n$toast-border-width:                1px;\n$toast-border-color:                rgba(0, 0, 0, .1);\n$toast-border-radius:               .25rem;\n$toast-box-shadow:                  $box-shadow;\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                $gray-600;\n$toast-header-background-color:     rgba($white, .85);\n$toast-header-border-color:         rgba(0, 0, 0, .05);\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   75%;\n$badge-font-weight:                 $font-weight-medium;\n$badge-color:                       $white;\n$badge-padding-y:                   .25em;\n$badge-padding-x:                   .4em;\n$badge-border-radius:               $border-radius;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               1rem;\n\n$modal-footer-margin-between:       .5rem;\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  $white;\n$modal-content-border-color:        $gray-300;\n$modal-content-border-width:        $border-width;\n$modal-content-border-radius:       $border-radius-lg;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       $box-shadow-sm;\n$modal-content-box-shadow-sm-up:    $box-shadow;\n\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n$modal-header-border-color:         $border-color;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-header-border-width:         $modal-content-border-width;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:                   .75rem;\n$alert-padding-x:                   1.25rem;\n$alert-margin-bottom:               1rem;\n$alert-border-radius:               $border-radius;\n$alert-link-font-weight:            $font-weight-bold;\n$alert-border-width:                $border-width;\n\n$alert-bg-scale:                    -80%;\n$alert-border-scale:                -70%;\n$alert-color-scale:                 40%;\n\n$alert-dismissible-padding-r:       $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   .625rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       $gray-300;\n$progress-border-radius:            $border-radius;\n$progress-box-shadow:               $box-shadow-inset;\n$progress-bar-color:                $white;\n$progress-bar-bg:                   $primary;\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  null;\n$list-group-bg:                     $white;\n$list-group-border-color:           $border-color;\n$list-group-border-width:           $border-width;\n$list-group-border-radius:          $border-radius;\n\n$list-group-item-padding-y:         .75rem;\n$list-group-item-padding-x:         1.25rem;\n$list-group-item-bg-scale:          -80%;\n$list-group-item-color-scale:       40%;\n\n$list-group-hover-bg:               $gray-100;\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         $gray-600;\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           $gray-700;\n$list-group-action-hover-color:     $list-group-action-color;\n\n$list-group-action-active-color:    $body-color;\n$list-group-action-active-bg:       $gray-200;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      $body-bg;\n$thumbnail-border-width:            $border-width;\n$thumbnail-border-color:            $gray-300;\n$thumbnail-border-radius:           $border-radius;\n$thumbnail-box-shadow:              $box-shadow-sm;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              $gray-600;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              .75rem;\n$breadcrumb-padding-x:              1rem;\n$breadcrumb-item-padding-x:         .5rem;\n\n$breadcrumb-margin-bottom:          1rem;\n\n$breadcrumb-bg:                     null;\n$breadcrumb-divider-color:          $gray-600;\n$breadcrumb-active-color:           $gray-600;\n$breadcrumb-divider:                quote(\"\\F0142\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          null;\n// scss-docs-end breadcrumb-variables\n\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        2rem;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black;\n$carousel-dark-caption-color:        $black;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            $black;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-bg-dark:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$black}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow:     none;\n$btn-close-opacity:          .5;\n$btn-close-hover-opacity:    .75;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                $modal-content-bg;\n$offcanvas-color:                   $modal-content-color;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    87.5%;\n$code-color:                        $pink;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         $white;\n$kbd-bg:                            $gray-900;\n\n$pre-color:                         $gray-900;","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-bg-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-color-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$prefix}#{$identifier}-rgb), var(--#{$prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Kitty Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio >= $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.2 relative luminance\n// See https://www.w3.org/TR/WCAG/#dfn-relative-luminance\n// See https://www.w3.org/TR/WCAG/#dfn-contrast-ratio\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .04045, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100%);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/* =============\n   General\n============= */\n\nhtml {\n    position: relative;\n    min-height: 100%;\n    background-color: white;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    color: $gray-800;\n    font-family: $font-family-secondary;\n}\n\na {\n    text-decoration: none !important;\n}\n\nlabel {\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n// blockquote\n\n.blockquote {\n    padding: 10px 20px;\n    border-left: 4px solid $gray-300;\n}\n\n.blockquote-reverse {\n    border-left: 0;\n    border-right: 4px solid $gray-300;\n    text-align: right;\n}\n\n// row\n\n.row{\n    > * {\n        position: relative;\n    }\n  }\n  ","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.25) !important;\n    }\n}\n","// \n// _badge.scss\n// \n\n\n.badge {\n  &[href] {\n    &:hover,\n    &:focus {\n      color: $white;\n    }\n  }\n}\n\n// Soft badge\n@mixin badge-variant-soft($bg) {\n  color: $bg;\n  background-color: rgba($bg, 0.18);\n\n  &[href] {\n    &:hover,\n    &:focus {\n      color: $bg;\n      text-decoration: none;\n      background-color: rgba($bg, 0.4);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .badge {\n  &.bg-#{$color} {\n    &[href] {\n      &:hover,\n      &:focus {\n        background-color: darken($value, 4%) !important;\n      }\n    }\n  }\n}\n\n.badge{\n  &.bg-light{\n    color: $body-color;\n\n    &[href] {\n      &:hover,\n      &:focus {\n        color: $body-color;\n      }\n    }\n  }\n}\n\n  .badge-soft-#{$color} {\n      @include badge-variant-soft($value);\n  }\n  \n}\n\n.badge-h-30{\n  height: 30px;\n}\n\n.rounded-pill{\n   padding-right: .6em;\n    padding-left: .6em;\n}\n\n// Dark badge\n\n.badge.bg-dark{\n  color: $light;\n}\n\n.badge-filter-applied-dynamic{\n  &:hover{\n    color: white !important;\n    background-color: $color-azul3 !important;\n    & i{\n      color: white !important;\n    }\n  }\n}","//\n// _buttons.scss\n//\n\nbutton,\na {\n  outline: none !important;\n}\n\n.btn-light {\n  border: 1px solid darken($light, 2%);\n}\n\n// Rounded Buttons\n.btn-rounded {\n  border-radius: 30px;\n}\n\n.btn-dark,\n.btn-secondary {\n  color: $gray-200 !important;\n}\n\n.btn-outline-light {\n  color: $gray-900;\n}\n\n//\n// Soft Buttons\n//\n\n@mixin button-variant-soft($bg) {\n  color: $bg;\n  background-color: rgba($bg, 0.1);\n  border-color: transparent;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: $white;\n    background-color: $bg;\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-soft-#{$color} {\n    @include button-variant-soft($value);\n  }\n}\n\n.btn-group-vertical {\n  label {\n    margin-bottom: 0;\n  }\n}\n\n.btn-fechar {\n  background: transparent;\n  border: none;\n  color: #6c757d;\n  height: 32px;\n  padding: 0 12px;\n\n  &:hover {\n    background-color: #f1f3f5;\n    color: #498ef2;\n  }\n\n  &:focus,\n  &:active {\n    box-shadow: none;\n    outline: none;\n  }\n}\n\n.btn-comparar {\n  background-color: #263874;\n  border-color: #263874;\n  color: #fff;\n\n  &:hover {\n    background-color: #364b8c;\n    border-color: #364b8c;\n    color: #fff;\n  }\n\n  &:focus,\n  &:active {\n    background-color: #364b8c;\n    border-color: #364b8c;\n    box-shadow: none;\n  }\n\n  &:disabled {\n    background-color: #e0e0e0;\n    border-color: #e0e0e0;\n    color: #8c8c8c;\n    cursor: not-allowed;\n  }\n}\n\n.btn-primary-dark,\n.btn-color-azul2 {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  transition: 0.2s ease-in-out;\n  justify-content: center;\n  &:hover {\n    background-color: $color-azul2-hover !important;\n  }\n}\n\n.bg-primary-dark-inverse {\n  border: 1px solid $color-cinza3;\n  background-color: transparent;\n  color: $primary_dark;\n  &:hover,\n  &:active {\n    background-color: $primary_dark;\n    color: #fff;\n  }\n\n  &.hover-cancel {\n    &:hover,\n    &:active {\n      background-color: transparent !important;\n      color: $color-vermelho1 !important;\n    }\n  }\n}\n\n.btn-confirmar-co0005 {\n  background-color: $color-azul2;\n  border-color: $color-azul2;\n  color: #fff;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  transition: 0.2s ease-in-out;\n  &:hover {\n    background-color: $light_blue_11 !important;\n    border-color: $light_blue_11 !important;\n    color: #fff;\n  }\n}\n\n.btn-cancelar-co0005 {\n  background-color: transparent;\n  border: none;\n  color: $color-azul1;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  transition: 0.2s ease-in-out;\n  &:hover {\n    background-color: transparent;\n    border: none;\n    color: $color-vermelho1;\n  }\n}\n\n.df-co0010-btn-transition {\n  transition: 0.2s ease-in-out;\n}\n\n.btn-cancelar-split {\n  @extend .df-co0010-btn-transition;\n\n  background: transparent;\n  color: #0f1d42;\n\n  &:hover {\n    color: #ec221f !important;\n  }\n}\n\n.btn-salvar-split {\n  @extend .df-co0010-btn-transition;\n\n  background: #263874;\n  color: #ffffff;\n\n  &:hover {\n    background: #364b8c !important;\n    color: #ffffff;\n  }\n\n  &:disabled {\n    opacity: 0.7;\n  }\n}\n","// CUSTOM CALENDAR FLATPICKR\n\n.calendary-picker-bizin {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n\n.flatpickr-icon-bizin{\n        position: absolute;\n        right: 1rem;\n        cursor: pointer;\n        font-size: 1.2rem;\n        color: #555;\n        color: $color-azul2;\n}\n\n.flatpickr-bizin {\n        border: 1px solid #a8a8a8;\n        border-radius: 0.375rem;   \n        overflow: hidden;\n        display: flex !important;             \n        flex-wrap: nowrap !important; \n        border-radius: 12px;\n        width: 0% !important;\n        display: none;\n        border-left: 0px !important;\n        border-radius: 0px 10px 10px 0px !important;\n        padding: 22px !important;\n\n}\n\n.flatpickr-input-bizin {\n        padding-right: 2.5rem; \n        height: 2.5rem;\n        font-size: 1rem;\n        border-radius: 10px 0px 0px 10px !important;\n\n}\n\n\n// Flatpickr styles\n\n.flatpickr-calendar {\n    background: transparent;\n    opacity: 0;\n    display: none;\n    text-align: center;\n    visibility: hidden;\n    padding: 0;\n    -webkit-animation: none;\n            animation: none;\n    direction: ltr;\n    border: 0;\n    font-size: 14px;\n    line-height: 24px;\n    border-radius: 5px;\n    position: absolute;\n    width: 307.875px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -ms-touch-action: manipulation;\n        touch-action: manipulation;\n    -webkit-box-shadow: 0 3px 13px rgba(0,0,0,0.08);\n            box-shadow: 0 3px 13px rgba(0,0,0,0.08);\n    }\n    .flatpickr-calendar.open,\n    .flatpickr-calendar.inline {\n    opacity: 1;\n    max-height: 640px;\n    visibility: visible;\n    }\n    .flatpickr-calendar.open {\n    display: inline-block;\n    z-index: 99999;\n    }\n    .flatpickr-calendar.animate.open {\n    -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n            animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n    }\n    .flatpickr-calendar.inline {\n    display: block;\n    position: relative;\n    top: 2px;\n    }\n    .flatpickr-calendar.static {\n    position: absolute;\n    top: calc(100% + 2px);\n    }\n    .flatpickr-calendar.static.open {\n    z-index: 999;\n    display: block;\n    }\n    .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n    -webkit-box-shadow: none !important;\n            box-shadow: none !important;\n    }\n    .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n    -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n            box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n    }\n    .flatpickr-calendar .hasWeeks .dayContainer,\n    .flatpickr-calendar .hasTime .dayContainer {\n    border-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    }\n    .flatpickr-calendar .hasWeeks .dayContainer {\n    border-left: 0;\n    }\n    .flatpickr-calendar.hasTime .flatpickr-time {\n    height: 40px;\n    border-top: 1px solid rgba(72,72,72,0.2);\n    }\n    .flatpickr-calendar.hasTime .flatpickr-innerContainer {\n    border-bottom: 0;\n    }\n    .flatpickr-calendar.hasTime .flatpickr-time {\n    border: 1px solid rgba(72,72,72,0.2);\n    }\n    .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n    height: auto;\n    }\n    .flatpickr-calendar:before,\n    .flatpickr-calendar:after {\n    position: absolute;\n    display: block;\n    pointer-events: none;\n    border: solid transparent;\n    content: '';\n    height: 0;\n    width: 0;\n    left: 22px;\n    }\n    .flatpickr-calendar.rightMost:before,\n    .flatpickr-calendar.arrowRight:before,\n    .flatpickr-calendar.rightMost:after,\n    .flatpickr-calendar.arrowRight:after {\n    left: auto;\n    right: 22px;\n    }\n    .flatpickr-calendar.arrowCenter:before,\n    .flatpickr-calendar.arrowCenter:after {\n    left: 50%;\n    right: 50%;\n    }\n    .flatpickr-calendar:before {\n    border-width: 5px;\n    margin: 0 -5px;\n    }\n    .flatpickr-calendar:after {\n    border-width: 4px;\n    margin: 0 -4px;\n    }\n    .flatpickr-calendar.arrowTop:before,\n    .flatpickr-calendar.arrowTop:after {\n    bottom: 100%;\n    }\n    .flatpickr-calendar.arrowTop:before {\n    border-bottom-color: rgba(72,72,72,0.2);\n    }\n    .flatpickr-calendar.arrowTop:after {\n    border-bottom-color: $color-azul2;\n    }\n    .flatpickr-calendar.arrowBottom:before,\n    .flatpickr-calendar.arrowBottom:after {\n    top: 100%;\n    }\n    .flatpickr-calendar.arrowBottom:before {\n    border-top-color: rgba(72,72,72,0.2);\n    }\n    .flatpickr-calendar.arrowBottom:after {\n    border-top-color: $color-azul2;\n    }\n    .flatpickr-calendar:focus {\n    outline: 0;\n    }\n    .flatpickr-wrapper {\n    position: relative;\n    display: inline-block;\n    }\n    .flatpickr-months {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    }\n    .flatpickr-months .flatpickr-month {\n    border-radius: 5px 5px 0 0;\n    background: $color-azul2;\n    color: #fff;\n    fill: #fff;\n    height: 34px;\n    line-height: 1;\n    text-align: center;\n    position: relative;\n    -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    overflow: hidden;\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    }\n    .flatpickr-months .flatpickr-prev-month,\n    .flatpickr-months .flatpickr-next-month {\n    -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    text-decoration: none;\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    height: 34px;\n    padding: 10px;\n    z-index: 3;\n    color: #fff;\n    fill: #fff;\n    }\n    .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,\n    .flatpickr-months .flatpickr-next-month.flatpickr-disabled {\n    display: none;\n    }\n    .flatpickr-months .flatpickr-prev-month i,\n    .flatpickr-months .flatpickr-next-month i {\n    position: relative;\n    }\n    .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n    .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n    /*\n        /*rtl:begin:ignore*/\n    /*\n        */\n    left: 0;\n    /*\n        /*rtl:end:ignore*/\n    /*\n        */\n    }\n    /*\n        /*rtl:begin:ignore*/\n    /*\n        /*rtl:end:ignore*/\n    .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n    .flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n    /*\n        /*rtl:begin:ignore*/\n    /*\n        */\n    right: 0;\n    /*\n        /*rtl:end:ignore*/\n    /*\n        */\n    }\n    /*\n        /*rtl:begin:ignore*/\n    /*\n        /*rtl:end:ignore*/\n    .flatpickr-months .flatpickr-prev-month:hover,\n    .flatpickr-months .flatpickr-next-month:hover {\n    color: #bbb;\n    }\n    .flatpickr-months .flatpickr-prev-month:hover svg,\n    .flatpickr-months .flatpickr-next-month:hover svg {\n    fill: #f64747;\n    }\n    .flatpickr-months .flatpickr-prev-month svg,\n    .flatpickr-months .flatpickr-next-month svg {\n    width: 14px;\n    height: 14px;\n    }\n    .flatpickr-months .flatpickr-prev-month svg path,\n    .flatpickr-months .flatpickr-next-month svg path {\n    -webkit-transition: fill 0.1s;\n    transition: fill 0.1s;\n    fill: inherit;\n    }\n    .numInputWrapper {\n    position: relative;\n    height: auto;\n    }\n    .numInputWrapper input,\n    .numInputWrapper span {\n    display: inline-block;\n    }\n    .numInputWrapper input {\n    width: 100%;\n    }\n    .numInputWrapper input::-ms-clear {\n    display: none;\n    }\n    .numInputWrapper input::-webkit-outer-spin-button,\n    .numInputWrapper input::-webkit-inner-spin-button {\n    margin: 0;\n    -webkit-appearance: none;\n    }\n    .numInputWrapper span {\n    position: absolute;\n    right: 0;\n    width: 14px;\n    padding: 0 4px 0 2px;\n    height: 50%;\n    line-height: 50%;\n    opacity: 0;\n    cursor: pointer;\n    border: 1px solid rgba(72,72,72,0.15);\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    }\n    .numInputWrapper span:hover {\n    background: rgba(0,0,0,0.1);\n    }\n    .numInputWrapper span:active {\n    background: rgba(0,0,0,0.2);\n    }\n    .numInputWrapper span:after {\n    display: block;\n    content: \"\";\n    position: absolute;\n    }\n    .numInputWrapper span.arrowUp {\n    top: 0;\n    border-bottom: 0;\n    }\n    .numInputWrapper span.arrowUp:after {\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-bottom: 4px solid rgba(72,72,72,0.6);\n    top: 26%;\n    }\n    .numInputWrapper span.arrowDown {\n    top: 50%;\n    }\n    .numInputWrapper span.arrowDown:after {\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 4px solid rgba(72,72,72,0.6);\n    top: 40%;\n    }\n    .numInputWrapper span svg {\n    width: inherit;\n    height: auto;\n    }\n    .numInputWrapper span svg path {\n    fill: rgba(255,255,255,0.5);\n    }\n    .numInputWrapper:hover {\n    background: rgba(0,0,0,0.05);\n    }\n    .numInputWrapper:hover span {\n    opacity: 1;\n    }\n    .flatpickr-current-month {\n    font-size: 135%;\n    line-height: inherit;\n    font-weight: 300;\n    color: inherit;\n    position: absolute;\n    width: 75%;\n    left: 12.5%;\n    padding: 7.48px 0 0 0;\n    line-height: 1;\n    height: 34px;\n    display: inline-block;\n    text-align: center;\n    -webkit-transform: translate3d(0px, 0px, 0px);\n            transform: translate3d(0px, 0px, 0px);\n    }\n    .flatpickr-current-month span.cur-month {\n    font-family: inherit;\n    font-weight: 700;\n    color: inherit;\n    display: inline-block;\n    margin-left: 0.5ch;\n    padding: 0;\n    }\n    .flatpickr-current-month span.cur-month:hover {\n    background: rgba(0,0,0,0.05);\n    }\n    .flatpickr-current-month .numInputWrapper {\n    width: 6ch;\n    width: 7ch\\0;\n    display: inline-block;\n    }\n    .flatpickr-current-month .numInputWrapper span.arrowUp:after {\n    border-bottom-color: #fff;\n    }\n    .flatpickr-current-month .numInputWrapper span.arrowDown:after {\n    border-top-color: #fff;\n    }\n    .flatpickr-current-month input.cur-year {\n    background: transparent;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    color: inherit;\n    cursor: text;\n    padding: 0 0 0 0.5ch;\n    margin: 0;\n    display: inline-block;\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: 300;\n    line-height: inherit;\n    height: auto;\n    border: 0;\n    border-radius: 0;\n    vertical-align: initial;\n    -webkit-appearance: textfield;\n    -moz-appearance: textfield;\n    appearance: textfield;\n    }\n    .flatpickr-current-month input.cur-year:focus {\n    outline: 0;\n    }\n    .flatpickr-current-month input.cur-year[disabled],\n    .flatpickr-current-month input.cur-year[disabled]:hover {\n    font-size: 100%;\n    color: rgba(255,255,255,0.5);\n    background: transparent;\n    pointer-events: none;\n    }\n    .flatpickr-current-month .flatpickr-monthDropdown-months {\n    appearance: menulist;\n    background: $color-azul2;\n    border: none;\n    border-radius: 0;\n    box-sizing: border-box;\n    color: inherit;\n    cursor: pointer;\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: 300;\n    height: auto;\n    line-height: inherit;\n    margin: -1px 0 0 0;\n    outline: none;\n    padding: 0 0 0 0.5ch;\n    position: relative;\n    vertical-align: initial;\n    -webkit-box-sizing: border-box;\n    -webkit-appearance: menulist;\n    -moz-appearance: menulist;\n    width: auto;\n    }\n    .flatpickr-current-month .flatpickr-monthDropdown-months:focus,\n    .flatpickr-current-month .flatpickr-monthDropdown-months:active {\n    outline: none;\n    }\n    .flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n    background: rgba(0,0,0,0.05);\n    }\n    .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n    background-color: $color-azul2;\n    outline: none;\n    padding: 0;\n    }\n    .flatpickr-weekdays {\n    background: $color-azul2;\n    text-align: center;\n    overflow: hidden;\n    width: 100%;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: 28px;\n    }\n    .flatpickr-weekdays .flatpickr-weekdaycontainer {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    }\n    span.flatpickr-weekday {\n    cursor: default;\n    font-size: 90%;\n    background: $color-azul2;\n    color: white;\n    line-height: 1;\n    margin: 0;\n    text-align: center;\n    display: block;\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    font-weight: bolder;\n    }\n    .dayContainer,\n    .flatpickr-weeks {\n    padding: 1px 0 0 0;\n    }\n    .flatpickr-days {\n    position: relative;\n    overflow: hidden;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    width: 307.875px;\n    border-left: 1px solid rgba(72,72,72,0.2);\n    border-right: 1px solid rgba(72,72,72,0.2);\n    }\n    .flatpickr-days:focus {\n    outline: 0;\n    }\n    .dayContainer {\n    padding: 0;\n    outline: 0;\n    text-align: left;\n    width: 307.875px;\n    min-width: 307.875px;\n    max-width: 307.875px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    display: inline-block;\n    display: -ms-flexbox;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-flex-wrap: wrap;\n            flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    -ms-flex-pack: justify;\n    -webkit-justify-content: space-around;\n            justify-content: space-around;\n    -webkit-transform: translate3d(0px, 0px, 0px);\n            transform: translate3d(0px, 0px, 0px);\n    opacity: 1;\n    }\n    .dayContainer + .dayContainer {\n    -webkit-box-shadow: -1px 0 0 rgba(72,72,72,0.2);\n            box-shadow: -1px 0 0 rgba(72,72,72,0.2);\n    }\n    .flatpickr-day {\n    background: none;\n    border: 1px solid transparent;\n    border-radius: 150px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    color: #484848;\n    cursor: pointer;\n    font-weight: 400;\n    width: 14.2857143%;\n    -webkit-flex-basis: 14.2857143%;\n        -ms-flex-preferred-size: 14.2857143%;\n            flex-basis: 14.2857143%;\n    max-width: 39px;\n    height: 39px;\n    line-height: 39px;\n    margin: 0;\n    display: inline-block;\n    position: relative;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    text-align: center;\n    }\n    .flatpickr-day.inRange,\n    .flatpickr-day.prevMonthDay.inRange,\n    .flatpickr-day.nextMonthDay.inRange,\n    .flatpickr-day.today.inRange,\n    .flatpickr-day.prevMonthDay.today.inRange,\n    .flatpickr-day.nextMonthDay.today.inRange,\n    .flatpickr-day:hover,\n    .flatpickr-day.prevMonthDay:hover,\n    .flatpickr-day.nextMonthDay:hover,\n    .flatpickr-day:focus,\n    .flatpickr-day.prevMonthDay:focus,\n    .flatpickr-day.nextMonthDay:focus {\n    cursor: pointer;\n    outline: 0;\n    background: #e2e2e2;\n    border-color: #e2e2e2;\n    }\n    .flatpickr-day.today {\n    border-color: #bbb;\n    }\n    .flatpickr-day.today:hover,\n    .flatpickr-day.today:focus {\n    border-color: #bbb;\n    background: #bbb;\n    color: #fff;\n    }\n    .flatpickr-day.selected,\n    .flatpickr-day.startRange,\n    .flatpickr-day.endRange,\n    .flatpickr-day.selected.inRange,\n    .flatpickr-day.startRange.inRange,\n    .flatpickr-day.endRange.inRange,\n    .flatpickr-day.selected:focus,\n    .flatpickr-day.startRange:focus,\n    .flatpickr-day.endRange:focus,\n    .flatpickr-day.selected:hover,\n    .flatpickr-day.startRange:hover,\n    .flatpickr-day.endRange:hover,\n    .flatpickr-day.selected.prevMonthDay,\n    .flatpickr-day.startRange.prevMonthDay,\n    .flatpickr-day.endRange.prevMonthDay,\n    .flatpickr-day.selected.nextMonthDay,\n    .flatpickr-day.startRange.nextMonthDay,\n    .flatpickr-day.endRange.nextMonthDay {\n    background: $blue_primary;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    color: #fff;\n    border-color: $blue_primary;\n    }\n    .flatpickr-day.selected.startRange,\n    .flatpickr-day.startRange.startRange,\n    .flatpickr-day.endRange.startRange {\n    border-radius: 50px 0 0 50px;\n    }\n    .flatpickr-day.selected.endRange,\n    .flatpickr-day.startRange.endRange,\n    .flatpickr-day.endRange.endRange {\n    border-radius: 0 50px 50px 0;\n    }\n    .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),\n    .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),\n    .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n    -webkit-box-shadow: -10px 0 0 $color-azul2;\n            box-shadow: -10px 0 0 $color-azul2;\n    }\n    .flatpickr-day.selected.startRange.endRange,\n    .flatpickr-day.startRange.startRange.endRange,\n    .flatpickr-day.endRange.startRange.endRange {\n    border-radius: 50px;\n    }\n    .flatpickr-day.inRange {\n    border-radius: 0;\n    -webkit-box-shadow: -5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2;\n            box-shadow: -5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2;\n    }\n    .flatpickr-day.flatpickr-disabled,\n    .flatpickr-day.flatpickr-disabled:hover,\n    .flatpickr-day.prevMonthDay,\n    .flatpickr-day.nextMonthDay,\n    .flatpickr-day.notAllowed,\n    .flatpickr-day.notAllowed.prevMonthDay,\n    .flatpickr-day.notAllowed.nextMonthDay {\n    color: rgba(72,72,72,0.3);\n    background: transparent;\n    border-color: transparent;\n    cursor: default;\n    }\n    .flatpickr-day.flatpickr-disabled,\n    .flatpickr-day.flatpickr-disabled:hover {\n    cursor: not-allowed;\n    color: rgba(72,72,72,0.1);\n    }\n    .flatpickr-day.week.selected {\n    border-radius: 0;\n    -webkit-box-shadow: -5px 0 0 $color-azul2, 5px 0 0 $color-azul2;\n            box-shadow: -5px 0 0 $color-azul2, 5px 0 0 $color-azul2;\n    }\n    .flatpickr-day.hidden {\n    visibility: hidden;\n    }\n    .rangeMode .flatpickr-day {\n    margin-top: 1px;\n    }\n    .flatpickr-weekwrapper {\n    float: left;\n    }\n    .flatpickr-weekwrapper .flatpickr-weeks {\n    padding: 0 12px;\n    border-left: 1px solid rgba(72,72,72,0.2);\n    }\n    .flatpickr-weekwrapper .flatpickr-weekday {\n    float: none;\n    width: 100%;\n    line-height: 28px;\n    }\n    .flatpickr-weekwrapper span.flatpickr-day,\n    .flatpickr-weekwrapper span.flatpickr-day:hover {\n    display: block;\n    width: 100%;\n    max-width: none;\n    color: rgba(72,72,72,0.3);\n    background: transparent;\n    cursor: default;\n    border: none;\n    }\n    .flatpickr-innerContainer {\n    display: block;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    overflow: hidden;\n    background: #fff;\n    border-bottom: 1px solid rgba(72,72,72,0.2);\n    }\n    .flatpickr-rContainer {\n    display: inline-block;\n    padding: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    }\n    .flatpickr-time {\n    text-align: center;\n    outline: 0;\n    display: block;\n    height: 0;\n    line-height: 40px;\n    max-height: 40px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    overflow: hidden;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    background: #fff;\n    border-radius: 0 0 5px 5px;\n    }\n    .flatpickr-time:after {\n    content: \"\";\n    display: table;\n    clear: both;\n    }\n    .flatpickr-time .numInputWrapper {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    width: 40%;\n    height: 40px;\n    float: left;\n    }\n    .flatpickr-time .numInputWrapper span.arrowUp:after {\n    border-bottom-color: #484848;\n    }\n    .flatpickr-time .numInputWrapper span.arrowDown:after {\n    border-top-color: #484848;\n    }\n    .flatpickr-time.hasSeconds .numInputWrapper {\n    width: 26%;\n    }\n    .flatpickr-time.time24hr .numInputWrapper {\n    width: 49%;\n    }\n    .flatpickr-time input {\n    background: transparent;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    border: 0;\n    border-radius: 0;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n    height: inherit;\n    line-height: inherit;\n    color: #484848;\n    font-size: 14px;\n    position: relative;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-appearance: textfield;\n    -moz-appearance: textfield;\n    appearance: textfield;\n    }\n    .flatpickr-time input.flatpickr-hour {\n    font-weight: bold;\n    }\n    .flatpickr-time input.flatpickr-minute,\n    .flatpickr-time input.flatpickr-second {\n    font-weight: 400;\n    }\n    .flatpickr-time input:focus {\n    outline: 0;\n    border: 0;\n    }\n    .flatpickr-time .flatpickr-time-separator,\n    .flatpickr-time .flatpickr-am-pm {\n    height: inherit;\n    float: left;\n    line-height: inherit;\n    color: #484848;\n    font-weight: bold;\n    width: 2%;\n    -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    -webkit-align-self: center;\n        -ms-flex-item-align: center;\n            align-self: center;\n    }\n    .flatpickr-time .flatpickr-am-pm {\n    outline: 0;\n    width: 18%;\n    cursor: pointer;\n    text-align: center;\n    font-weight: 400;\n    }\n    .flatpickr-time input:hover,\n    .flatpickr-time .flatpickr-am-pm:hover,\n    .flatpickr-time input:focus,\n    .flatpickr-time .flatpickr-am-pm:focus {\n    background: #eaeaea;\n    }\n    .flatpickr-input[readonly] {\n    cursor: pointer;\n    }\n    @-webkit-keyframes fpFadeInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -20px, 0);\n                transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 0, 0);\n                transform: translate3d(0, 0, 0);\n    }\n    }\n    @keyframes fpFadeInDown {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -20px, 0);\n                transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 0, 0);\n                transform: translate3d(0, 0, 0);\n    }\n    }","\n// \n// breadcrumb.scss\n//\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: $gray-700;\n        font-size: 14px;\n    }\n    +.breadcrumb-item {\n        padding-left: 8px;\n        &::before {\n            content: \"\";\n            border: solid $gray-700;\n            border-width: 0 1px 1px 0;\n            background-color: transparent;\n            display: inline-block;\n            padding: 0;\n            margin-top: 8px;\n            margin-right: 10px;\n            height: 8px;\n            width: 8px;\n            transform: rotate(-45deg);\n            -webkit-transform: rotate(-45deg);\n        }\n    }\n}\n\n.describe-transation{\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n\n    & span {\n        font-family: $font-family-sans-serif;\n        font-weight: 300;\n    }\n\n    & span, & i{\n        font-size: 14px;\n        color: $gray_primary;\n    }\n}\n\n// RTL\n\n[dir=\"rtl\"] {\n    .breadcrumb-item {\n        +.breadcrumb-item {\n            padding-right: $breadcrumb-item-padding-x;\n\n            &::before {\n            font-family: \"Material Design Icons\";\n            padding-left: 0;\n                content: \"\\F0141\";\n            }\n        }\n    }\n}","//\n// _card.scss\n//\n\n.card {\n  margin-bottom: $grid-gutter-width;\n  box-shadow: $box-shadow;\n}\n\n.card-drop {\n  font-size: 20px;\n  line-height: 0;\n  color: inherit;\n}\n\n.card-title {\n  font-size: 15px;\n  margin: 0 0 7px 0;\n  font-weight: $font-weight-medium;\n}\n\n.card-title-desc {\n  color: $card-title-desc;\n  margin-bottom: 24px;\n}\n\n// card color variant\n\n@mixin card-variant($bg) {\n  color: $white;\n  background-color: $bg;\n}\n\n@each $color, $value in $theme-colors {\n  .card-#{$color} {\n    @include card-variant($value);\n    .card-header {\n      background-color: rgba($white, 0.1);\n      color: $white;\n    }\n    .card-title {\n      color: $white;\n    }\n  }\n}\n\n@mixin card-border-variant($bg) {\n  border: 1px solid $bg;\n\n  .card-header {\n    border-bottom: 1px solid $bg;\n    background: transparent;\n  }\n  .card-footer {\n    border-top: 1px solid $bg;\n    background: transparent;\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .card-border-#{$color} {\n    @include card-border-variant($value);\n  }\n}\n\n.card-context-dynamic-wrapper {\n  &.cb-variant-bordered {\n    .card-context-dynamic {\n      border: 1px solid $light_gray_03;\n    }\n  }\n\n  .card-context-dynamic {\n    background-color: $footer-bg;\n    border: 1px solid $color-cinza2;\n    box-shadow: 0px 1px 2px 0px #0000004d;\n    border-radius: 12px;\n\n    &.pdf-preview{\n      box-shadow: none !important;\n    }\n\n    .card-context-dynamic-item {\n      min-width: 120px;\n      //flex: 1;\n\n      .card-context-text,\n      .card-context-text * {\n        white-space: normal;\n        overflow-wrap: break-word;\n        word-break: break-word;\n      }\n\n      .flex-gap-xs {\n        gap: 0.125rem;\n        display: flex;\n        flex-wrap: wrap;\n      }\n\n      .img-card {\n        width: 32px;\n        height: 32px;\n        object-fit: cover;\n        border-radius: 50%;\n        flex-shrink: 0;\n      }\n\n      .img-context-user {\n        width: 48px;\n        height: 48px;\n        object-fit: cover;\n        border-radius: 12px;\n        flex-shrink: 0;\n        font-size: 48px !important;\n      }\n\n      .far.fa-user-circle {\n        line-height: 1;\n      }\n\n      .gap-8 {\n        gap: 8px;\n      }\n    }\n  }\n}\n\n.card-flow-dynamic-container {\n  display: inline-flex;\n  gap: 10px;\n\n  & .card-flow-logo-wrapper {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    overflow: hidden;\n\n    .is-modal-page &,\n    .modal-dinamic-table-simple & {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  & .user-photo-label {\n    font-size: 48px;\n  }\n\n  .is-modal-page & {\n    & .user-photo-label {\n      font-size: 32px;\n    }\n    & .card-flow-logo-wrapper {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .card-flow-logo {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .flow-item {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1px;\n\n    .card-flow-name {\n      font-weight: 600;\n      font-size: 20px;\n      line-height: 100%;\n      letter-spacing: 0;\n      color: $color-azul1;\n      max-width: 200px;\n      overflow-wrap: break-word;\n    }\n\n    .card-flow-size {\n      font-size: 0.9em;\n      color: $gray_secundary;\n    }\n  }\n\n  .card-flow-arrow {\n    font-size: 2em;\n    color: $gray_03;\n  }\n}\n\n.title-log-cancelamento {\n  .accordion-button {\n    color: $color-azul1 !important;\n  }\n}\n","//\n// _dropdown.scss\n//\n\n.dropdown {\n  width: 100%;\n}\n\n.dropdown-menu {\n  box-shadow: $box-shadow-lg;\n  animation-name: DropDownSlide;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  margin: 0;\n  position: absolute;\n  z-index: 1000;\n  border-radius: 0;\n  padding: 0px;\n\n  &.show {\n    overflow: visible; // Changed from auto to visible to allow submenus\n    max-height: calc(100vh - 150px);\n    height: auto;\n  }\n\n  // Garantir que submenus dentro de dropdown-items sejam visíveis\n  .dropdown-item .dropdown-menu {\n    overflow: visible !important;\n    max-height: none !important;\n  }\n\n  // Garantir que submenus customizados sejam visíveis\n  .dropdown-item .submenu-custom-wrapper {\n    overflow: visible !important;\n\n    .submenu-custom {\n      overflow: visible !important;\n    }\n  }\n}\n\n.dropdown-kebab-custom-table {\n  background-color: $color-branco2;\n  border-radius: 4px;\n  box-shadow: 0px 1px 2px 0px #0000004d;\n  padding: 8px 0;\n  // right: -25px;\n\n  & .dropdown-item {\n    height: 32px;\n    padding: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    & i {\n      font-size: 18px;\n    }\n    &:hover {\n      background-color: $color-azul410;\n    }\n  }\n}\n\n// .dropdown-menu-end[style] {\n//   left: auto !important;\n//   right: 0 !important;\n// }\n\n// .dropdown-menu[data-popper-placement^=\"right\"],\n// .dropdown-menu[data-popper-placement^=\"top\"],\n// .dropdown-menu[data-popper-placement^=\"left\"] {\n//   top: auto !important;\n//   animation: none !important;\n//   inset: none !important;\n//   position: absolute !important;\n// }\n\n// @keyframes DropDownSlide {\n//   100% {\n//     transform: translateY(0);\n//   }\n//   0% {\n//     transform: translateY(10px);\n//   }\n// }\n\n@media (min-width: 600px) {\n  .dropdown-menu-lg {\n    width: 320px;\n  }\n\n  .dropdown-menu-md {\n    width: 240px;\n  }\n}\n\n.dropdown-divider {\n  border-top-color: $border-color;\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n  position: static !important;\n}\n\n.dropdown-megamenu[style] {\n  padding: 20px;\n  left: 20px !important;\n  right: 20px !important;\n}\n\n// Dropdown size\n\n.dropdown-mega-menu-xl {\n  width: 40rem;\n}\n\n.dropdown-mega-menu-lg {\n  width: 26rem;\n}\n\n.dropdown-export-dynamic {\n  width: 110px;\n  & .dropdown-menu.show {\n    border-radius: 4px;\n    box-shadow: 0px 1px 2px 0px #0000004d;\n  }\n\n  & button {\n    color: $color-azul2;\n    font-weight: 400;\n    &::after {\n      display: none;\n    }\n    &:hover {\n      background-color: $color-azul410;\n    }\n  }\n\n  & i {\n    font-size: 24px;\n    color: $light_blue_06;\n  }\n}\n\n.dropdown-preset-table{\n  & .dropdown-menu.show{\n    background: $color-branco2;\n    border-radius: 4px;\n    padding: 16px;\n    box-shadow: 0px 1px 2px 0px #0000004d;\n    margin-top: 20px;\n    margin-left: -240px;\n    overflow: auto;\n  \n    &::-webkit-scrollbar {\n      width: 2px;\n    }\n  }\n\n}\n\n.reasons-dropdown {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n  max-height: 250px;\n  overflow-y: auto;\n  border-radius: 6px;\n  box-sizing: border-box;\n  background-color: #F5F5F5;\n}\n\n.reason-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  padding: 8px 14px;\n  margin: 4px 8px;\n  cursor: pointer;\n\n  color: $color-azul2;\n  border-radius: 4px;\n\n  transition: background-color 0.2s ease;\n}\n\n.reason-item:hover {\n  background-color: $color-azul410;\n}\n\n.reason-item.active {\n  background-color: $color-azul410;\n}\n\n.reason-item i {\n  color: $color-azul2;\n}\n\n.shadow.mt-1 {\n  box-shadow: -1px 3px 0px 0px rgba(0, 0, 0, 0.23) !important;\n}\n","// \n// _nav.scss\n// \n\n.nav-tabs,.nav-pills {\n  > li {\n      > a {\n          color: $gray-600;\n      }\n  }\n}\n\n.nav-pills {\n  > a {\n      color: $gray-600;  \n  }\n}\n\n\n// Nav tab custom\n\n.nav-tabs-custom{\n  .nav-item{\n    margin: 0px 7px;\n    position: relative;\n\n    &:first-child{\n      margin-left: 0px;\n    }\n    &:last-child{\n      margin-right: 0px;\n    }\n\n    .nav-link{\n      background-color: $gray-300;\n      &.active{\n        color: $primary;\n        &:after{\n          transform: scale(1);\n        }\n      }\n\n      &:after {\n        content: \"\";\n        background: $primary;\n        height: 2px;\n        position: absolute;\n        width: 100%;\n        left: 0;\n        bottom: -1px;\n        transition: all 250ms ease 0s;\n        transform: scale(0);\n      }\n    }\n  }\n}\n\n\n// vertical nav\n\n.vertical-nav{\n  .nav{\n      .nav-link{\n          padding: 24px 16px;\n          text-align: center;\n          margin-bottom: 8px;\n          .nav-icon{\n              font-size: 24px;\n          }\n      }\n  }\n}","//\n// _table.scss\n//\n\n.table {\n  th {\n    font-weight: $font-weight-bold;\n  }\n\n  .table-light {\n    color: $body-color;\n    border-color: $table-border-color;\n    background-color: $table-head-bg;\n  }\n}\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n}\n\n// .table-dark > :not(:last-child) > :last-child > * {\n//     border-bottom-color: $table-dark-border-color;\n// }\n\n.table-nowrap {\n  th,\n  td {\n    white-space: nowrap;\n  }\n}\n\n.table > :not(:first-child) {\n  border-top: 0;\n}\n\n//Table centered\n.table-centered {\n  td,\n  th {\n    vertical-align: middle !important;\n  }\n}\n\n// Table - dataTable-custom-primary\n\n.dataTable-custom-primary:has(.p-datatable-row-expansion) {\n  & .p-datatable-table {\n    & table {\n      & thead tr {\n        & th:last-child {\n          border-top-right-radius: 0px !important;\n        }\n        & th:first-child {\n          border-top-left-radius: 0px !important;\n        }\n      }\n    }\n  }\n}\n.dataTable-custom-primary {\n  button.p-row-toggler.p-link:hover,\n  button.p-row-toggler.p-link:focus,\n  button.p-row-toggler.p-link:active {\n    background-color: transparent !important;\n    box-shadow: none !important;\n    border: none !important;\n  }\n  .header-expander-icon {\n    color: #6c6c6c;\n    font-size: 24px;\n    width: 16px;\n    height: 24px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  button.p-row-toggler {\n    width: auto;\n    position: relative;\n    color: transparent !important;\n  }\n\n  button.p-row-toggler::after {\n    content: \"\\f0da\";\n    font-family: \"Font Awesome 7 Pro\";\n    font-weight: 900;\n\n    font-size: 14px;\n    width: 9px;\n    height: 14px;\n    line-height: 14px;\n\n    color: #6c6c6c;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  button.p-row-toggler[aria-expanded=\"true\"]::after {\n    content: \"\\f0d7\";\n  }\n\n  & table {\n    & thead tr {\n      & th {\n        border: none;\n      }\n      & th:last-child {\n        border-top-right-radius: 12px;\n      }\n      & th:first-child {\n        border-top-left-radius: 12px;\n      }\n    }\n  }\n\n  & table {\n    & tr {\n      &:first-child {\n        border-top: 1px solid $gray_primary;\n      }\n      &:last-child {\n        border: none !important;\n      }\n      border-bottom: 1px solid $gray_primary;\n      background-color: transparent;\n    }\n\n    & thead {\n      & .p-checkbox-box{\n        & svg{\n          fill: white !important;\n          color: white !important;\n        }\n      }\n      & svg {\n        fill: $light_blue_11;\n        color: $light_blue_11;\n      }\n      & tr {\n        border-color: white;\n        border-left: 1px;\n\n        & th {\n          align-content: center;\n          height: 56px;\n          padding: 0 10px;\n          font-size: $font-size-base;\n          & div {\n            color: $color-azul2;\n            display: flex;\n            align-items: center;\n            & span[data-pc-section=\"sort\"] {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n\n    & tbody {\n      & .p-datatable-row-expansion {\n        &:hover {\n          background-color: transparent !important;\n        }\n        & td {\n          padding: 0;\n        }\n      }\n\n      & tr {\n        &:nth-last-child(1) {\n          & td {\n            &:last-child {\n              border-end-end-radius: 12px !important;\n            }\n            &:first-child {\n              border-end-start-radius: 12px !important;\n            }\n          }\n        }\n\n        &.p-datatable-emptymessage {\n          & td {\n            padding: 0 10px;\n          }\n        }\n\n        position: relative;\n\n        &:hover {\n          background-color: $light_blue_13 !important;\n        }\n\n        &:has(.flag-error):hover {\n          background-color: #ec221f20 !important;\n        }\n\n        &:has(.flag-alert):hover {\n          background-color: #fece2220 !important;\n        }\n\n        &:has(.flag-success):hover {\n          background-color: $color-azul410 !important;\n        }\n\n        &:nth-of-type(even) {\n          background-color: $info;\n        }\n        &:nth-of-type(odd) {\n          background-color: #b4b4b41f;\n        }\n        &:has(.no-visited) {\n          &::after {\n            content: \"\";\n            height: 100%;\n            top: 0;\n            border-left: 4px solid $color-azul2;\n            left: 0;\n            position: absolute;\n          }\n        }\n        &:has(.flag-error) {\n          &::after {\n            content: \"\";\n            height: 100%;\n            top: 0;\n            border-left: 4px solid $color-vermelho1;\n            left: 0;\n            position: absolute;\n          }\n        }\n\n        &:has(.flag-alert) {\n          &::after {\n            content: \"\";\n            height: 100%;\n            top: 0;\n            border-left: 4px solid $color-amarelo1;\n            left: 0;\n            position: absolute;\n          }\n        }\n\n        &:has(.flag-success) {\n          &::after {\n            content: \"\";\n            height: 100%;\n            top: 0;\n            border-left: 4px solid $color-azul3;\n            left: 0;\n            position: absolute;\n          }\n        }\n\n        &:has(.flag-info) {\n          &::after {\n            content: \"\";\n            height: 100%;\n            top: 0;\n            border-left: 4px solid $color-azul3;\n            left: 0;\n            position: absolute;\n          }\n        }\n\n        & td {\n          font-size: 13px;\n          background-color: transparent;\n          align-content: center;\n          height: 52px;\n          border: none;\n          color: $dark_gray_primary;\n          letter-spacing: -0.3px;\n\n          & > div {\n            align-content: center;\n            height: 100%;\n            display: block;\n          }\n\n          & p {\n            margin: 0;\n          }\n\n          & img {\n            max-height: 40px;\n          }\n\n          & .no-visited {\n            & span {\n              color: $color-azul2 !important;\n              font-weight: 700;\n            }\n          }\n        }\n      }\n    }\n\n    & tfoot {\n      & tr {\n        background-color: $light_blue_12;\n        & td {\n          color: $color-azul2;\n          font-size: $font-size-md;\n          background-color: transparent;\n          align-content: center;\n          height: 56px;\n\n          &:last-child {\n            border-bottom-right-radius: 10px;\n          }\n          &:first-child {\n            border-bottom-left-radius: 10px;\n          }\n        }\n      }\n    }\n  }\n  &.no-header-checkbox {\n    & table {\n      & thead {\n        & .p-column-header-content {\n          & .p-checkbox {\n            display: none !important;\n          }\n        }\n      }\n    }\n  }\n  thead th {\n    border-bottom: none !important;\n  }\n\n  thead th:hover,\n  thead th:focus,\n  thead th:active {\n    border-bottom: none !important;\n  }\n\n  .p-column-header-content {\n    border: none !important;\n    box-shadow: none !important;\n\n    & .p-column-title {\n      font-weight: 800;\n    }\n  }\n\n  .p-cell-editor {\n    width: 100%;\n  }\n\n  .p-cell-editor input {\n    width: 100% !important;\n    min-width: 100% !important;\n    max-width: 100% !important;\n\n    height: 34px;\n    min-height: 34px;\n    max-height: 34px;\n\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    padding: 0 0.75rem;\n\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n  }\n  .p-cell-editor-key-helper {\n    display: flex;\n    align-items: center;\n    // min-width: 120px;\n    height: 34px;\n\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    background: #fff;\n    padding: 0 0.75rem;\n\n    box-sizing: border-box;\n  }\n\n  .p-cell-editor-key-helper {\n    cursor: text;\n  }\n\n  tbody td {\n    white-space: normal !important;\n    word-break: break-word;\n  }\n\n  .header-icon-status {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.row-error-validacao,\n.row-error-validacao > td {\n  background-color: #EC221F26 !important;\n}\n\n// Table Inside modal - dataTable-custom-primary\n\n.modal-dinamic-table-simple {\n  .dataTable-custom-primary {\n    & table {\n      & thead tr {\n        & th:last-child {\n          border-top-right-radius: 10px;\n        }\n        & th:first-child {\n          border-top-left-radius: 10px;\n        }        \n      }\n\n      & tbody {\n        & tr {\n          & td {\n            &:last-child {\n              border-bottom-right-radius: 10px;\n            }\n            &:first-child {\n              border-bottom-left-radius: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.p-dropdown:not(.p-disabled) {\n  &:hover,\n  &:focus-within,\n  &:focus,\n  &:active {\n    box-shadow: none !important;\n    border-color: $color-azul2;\n    outline: none;\n  }\n}\n\n.p-dropdown-panel {\n  & .p-dropdown-items-wrapper {\n    max-height: none !important;\n    border-radius: 4px;\n    border: 1px solid $gray_primary;\n    padding: 8px 0;\n    background-color: $color-branco2;\n\n    & .p-dropdown-items {\n      margin-bottom: 0 !important;\n    }\n  }\n  & .p-dropdown-items {\n    padding: 0;\n    & .p-dropdown-item {\n      color: $color-azul2;\n      font-size: 12px;\n      font-weight: 400;\n      &:hover {\n        background-color: $color-azul410;\n      }\n      &.p-highlight {\n        background-color: $color-azul2;\n        border-color: $color-azul2;\n        color: white;\n      }\n    }\n  }\n}\n\n.paginator-table-custom {\n  flex-wrap: nowrap;\n  background-color: transparent;\n  & .p-dropdown {\n    height: 36px;\n    box-shadow: none !important;\n    border-color: $gray_primary;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 0 10px;\n\n    &.p-inputwrapper-focus {\n      border-color: $blue_primary;\n    }\n    & .p-dropdown-items {\n      padding: 0;\n    }\n\n    & .p-dropdown-label {\n      padding: 0;\n      font-family: $font-family-sans-serif;\n      font-weight: 400;\n      font-size: 16px;\n      color: black;\n    }\n\n    & .p-dropdown-trigger {\n      width: auto;\n\n      & svg {\n        width: 8px;\n        height: 8px;\n\n        & path {\n          fill: black;\n        }\n      }\n    }\n  }\n\n  & .p-paginator-left-content {\n    background-color: $info;\n    flex: auto;\n    border-start-start-radius: 1rem;\n    border-end-start-radius: 1rem;\n  }\n\n  & .p-paginator-pages .p-link,\n  & .p-paginator-pages .p-link.no-hover,\n  & .p-paginator-first,\n  & .p-paginator-last,\n  & .p-paginator-prev,\n  & .p-paginator-next {\n    min-height: 32px;\n    min-width: 32px;\n    height: 32px;\n  }\n\n  & .p-paginator-prev:hover,\n  & .p-paginator-next:hover {\n    background-color: $color-azul410;\n    color: $color-azul2;\n  }\n\n  & .p-paginator-pages .p-link:not(.no-hover):hover,\n  & .p-paginator-first:hover,\n  & .p-paginator-last:hover {\n    background-color: $color-azul410;\n  }\n\n  & .p-paginator-pages .p-link.p-highlight {\n    background-color: transparent;\n    border-bottom: 4px solid $blue_primary;\n    color: $color-azul2;\n    font-weight: 600;\n  }\n\n  & .p-link {\n    transition: 0.2s ease-in-out;\n    font-size: $font-size-lg;\n    border: 4px solid transparent;\n    color: $color-cinza5;\n  }\n  & .p-paginator-pages,\n  & .p-paginator-first,\n  & .p-paginator-last {\n    background-color: transparent;\n  }\n\n  & .p-disabled {\n    // background-color: #A8A8A826 !important;\n    color: $color-cinza3 !important;\n    opacity: 1 !important;\n  }\n\n  // & .p-paginator-prev, & .p-paginator-next{\n  //     border: 1px solid $gray_primary;\n  //     color: $blue_primary;\n  //     transition: .2s ease-in-out;\n  //     background-color: white;\n  // }\n  // & .p-paginator-prev{\n  //     border-radius: 8px 0 0 8px;\n  // }\n  // & .p-paginator-next{\n  //     border-radius: 0 8px 8px 0;\n  // }\n\n  &.p-paginator-bottom {\n    border: none;\n  }\n}\n\n.table-simple-container {\n  &.active-min-height {\n    & .p-datatable-wrapper {\n      min-height: calc(100vh - 335px);\n    }\n  }\n}\n\n.validation-row {\n  transition: background-color 0.2s ease;\n}\n\n.validation-row.success {\n  background-color: #eef8ee !important;\n}\n\n.validation-row.error {\n  background-color: #fdecec !important;\n}\n\n.validation-row.warning {\n  background-color: #fff9e5 !important;\n}\n\n.validation-row.info {\n  background-color: #eef5ff !important;\n}\n\n.validation-row.error:hover {\n  background-color: #ec221f40 !important;\n}\n\n.validation-row.warning:hover {\n  background-color: #fece2240 !important;\n}\n\n.validation-row.success:hover {\n  background-color: #4caf5040 !important;\n}\n\n.validation-row.info:hover {\n  background-color: $color-azul410 !important;\n}\n","// \n// _pagination.scss\n// \n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        min-width: 30px;\n        height: 30px;\n        line-height: 30px;\n        border-radius: 30px !important;\n        margin: 0 3px;\n        border: none;\n        text-align: center;\n        padding: 0;\n    }\n  }","//\n// _progress.scss\n//\n\n// Progress height small\n.progress-sm {\n  height: 5px;\n}\n\n// Progress height medium\n.progress-md {\n  height: 8px;\n}\n\n// Progress height large\n.progress-lg {\n  height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n  height: 16px;\n}\n\n.animated-progess {\n  position: relative;\n  .progress-bar {\n    position: relative;\n    border-radius: 6px;\n    animation: animate-positive 2s;\n  }\n}\n\n\n.progress-animate {\n  position: relative;\n  overflow: visible;\n  .progress-bar {\n    position: relative;\n    border-radius: 6px;\n    animation: animate-positive 2s;\n  }\n\n  .progress-value {\n    display: block;\n    position: absolute;\n    top: -26px;\n    right: -14px;\n  }\n\n\n}\n\n.progress-label {\n  display: inline-block;\n  position: relative;\n  padding: 1px 8px;\n  background-color: $card-bg;\n  border: 1px solid;\n  border-radius: $border-radius;\n  &::after {\n    content: \"\";\n    position: absolute;\n    height: 10px;\n    width: 3px;\n    background: $gray-500;\n    left: 0;\n    right: 0;\n    margin: 0px auto;\n    bottom: -11px;\n  }\n}\n\n@keyframes animate-positive {\n  0% {\n    width: 0;\n  }\n}\n",".sortable-list-custom {\n  width: auto;\n  \n  & .sortable-item {\n    padding: 8px 10px;\n    height: 42px;\n    margin-bottom: 8px;\n    background: #fff;\n    border-radius: 4px;\n    border: 1px solid #fff;\n    cursor: move;\n    user-select: none;\n    transition: .2s ease-in-out;\n    &:hover {\n      background: #fff;\n      border: 1px solid $color-azul1;\n    }\n    \n    &:active {\n      cursor: grabbing;\n    }\n  }\n  \n}\n","/*\nTemplate Name: Upzet -  Admin & Dashboard Template\nAuthor: Themesdesign\nVersion: 1.1.0\nContact: themesdesign.in@gmail.com\nFile: Main Css File\n*/\n\n//Fonts\n@import \"custom/fonts/fonts\";\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/mixins.scss\";\n\n// Structure\n@import \"custom/structure/topbar\";\n@import \"custom/structure/topbar-inside\";\n@import \"custom/structure/page-head\";\n@import \"custom/structure/footer\";\n@import \"custom/structure/right-sidebar\";\n@import \"custom/structure/vertical\";\n@import \"custom/structure/horizontal-nav\";\n@import \"custom/structure/general\";\n\n// Components\n@import \"custom/components/waves\";\n@import \"custom/components/avatar\";\n@import \"custom/components/accordion\";\n@import \"custom/components/helper\";\n@import \"custom/components/forms\";\n@import \"custom/components/demos\";\n@import \"custom/components/print\";\n@import \"custom/components/avatarUpload\";\n@import \"custom/components/tooltip\";\n@import \"custom/components/notificationModal\";\n@import \"custom/components/modals\";\n@import \"custom/components/calendar\";\n@import \"custom/components/houvers\";\n\n// Plugins\n@import \"custom/plugins/bootstrap-touchspin\";\n@import \"custom/plugins/calendar\";\n@import \"custom/plugins/color-picker\";\n@import \"custom/plugins/custom-scrollbar\";\n@import \"custom/plugins/datatable\";\n@import \"custom/plugins/datepicker\";\n@import \"custom/plugins/flot\";\n@import \"custom/plugins/form-editors\";\n@import \"custom/plugins/form-upload\";\n@import \"custom/plugins/form-wizard\";\n@import \"custom/plugins/google-map\";\n@import \"custom/plugins/parsley\";\n@import \"custom/plugins/range-slider\";\n@import \"custom/plugins/rating\";\n@import \"custom/plugins/responsive-table\";\n@import \"custom/plugins/select2\";\n@import \"custom/plugins/session-timeout\";\n@import \"custom/plugins/sparkline-chart\";\n@import \"custom/plugins/sweatalert2\";\n@import \"custom/plugins/switch\";\n@import \"custom/plugins/table-editable\";\n@import \"custom/plugins/vector-maps\";\n@import \"custom/plugins/x-editable\";\n@import \"primereact/resources/themes/lara-light-cyan/theme.css\";\n\n// Pages\n@import \"custom/pages/authentication\";\n@import \"custom/pages/search\";\n\n@import \"custom/pages/BI_AUT003\";\n\n@import \"custom/pages/email\";\n@import \"custom/pages/coming-soon\";\n@import \"custom/pages/timeline\";\n@import \"custom/pages/extras-pages\";\n@import \"custom/pages/LegalContentPage\";\n@import \"custom/pages/df-lo0020\";\n","//\n// _header.scss\n//\n\n#page-topbar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: $sidebar-width-sm;\n    z-index: 1002;\n    background-color: $color-azul2;\n    box-shadow: $box-shadow;\n\n    & .dropdown{\n        & .dropdown-menu-end{\n            border-radius: 5px;\n            border: 1px solid $gray_primary;\n\n            & .dropdown-item{\n                display: flex;\n                align-items: center;\n                gap: 12px;\n                padding: 10px 16px;\n                font-size: $font-size-sm;\n                & i{\n                    font-size: 20px;\n                }\n            }\n\n            & .container-infos{\n                display: flex;\n                padding: 6px 15px;\n                flex-direction: column;\n                color: $color-azul1;\n                gap: 4px;\n            }\n\n            & .info-business, & .info-profile{\n                & .business-name{\n                    font-weight: 600;\n                    font-size: $font-size-xlg;\n                    line-height: 100%;\n                    padding: 5px 0 0 0;\n                }\n                & .business-cnpj{\n                    font-weight: 500;\n                    font-size: $font-size-sm;\n                }\n                & .business-description{\n                    font-weight: 400;\n                    font-size: $font-size-sm;\n                }\n            }\n        }\n    }\n}\n\n.navbar-header {\n    display: flex;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    height: $header-height;\n    padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\n\n    .dropdown {\n        .show.header-item {\n            background-color: darken($header-bg, 2%);\n        }\n    }\n}\n\n\n\n.navbar-brand-box {\n    padding: 0 1rem;\n    width: $navbar-brand-box-width;\n}\n\n/* Search */\n\n.app-search {\n    display: flex;\n    align-self: center;\n\n    \n    .form-control {\n        &:hover, &:focus, &:active, &:focus-within{\n            border-color: white !important;\n        }\n        border: 2px solid transparent;\n        height: $header-size-icon;\n        width: 400px;\n        font-size: $font-size-md;\n        color: $light;\n        padding-left: 18px;\n        font-weight: 400;\n        padding-right: 36px;\n        background-color: $topbar-search-bg;\n        box-shadow: none;\n        border-radius: 10px;\n\n        &::placeholder{\n            color: $light_blue_07;\n        }\n    }\n    i {\n        position: absolute;\n        z-index: 10;\n        padding: 0 16px;\n        font-size: $font-size-xlg;\n        line-height: $header-size-icon;\n        right: 0;\n        cursor: pointer;\n        top: 0;\n        color: $topbar-search-icon;\n        transition: all ease-in-out;\n    }\n}\n\n@media (max-width: 991px) {\n\n    #page-topbar{\n        left: 0 !important;\n\n        & .navbar-header{\n            & .header-item.logo-business div{\n                width: auto;\n            }\n            & .app-search{\n                & input{\n                    width: auto;\n                }\n            }\n        }\n    }\n\n    .navbar-brand-box {\n        width: auto;\n    }\n\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: inline-block;\n        }\n    }\n}\n\n.page-content {\n    padding: 30px 15px;\n    overflow-x: hidden;\n}\n\n.page-breadcrumb{\n    padding: 0 calc(#{$grid-gutter-width} / 2) 0 calc(#{$grid-gutter-width} / 2);\n}\n\n.header-item {\n    height: $header-height;\n    box-shadow: none !important;\n    color: $header-dark-item-color;\n    border: 0;\n    border-radius: 0px;\n\n    &:hover {\n        background-color: $header-dropdown-bg-opacity;\n    }\n\n    &.header-container-profile-user div{\n        height: $header-size-icon;\n        width: $header-size-icon;\n        object-fit: cover;\n    }\n\n    &.logo-business{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: .2s ease-in-out;\n\n        & div{\n            height: $header-size-icon;\n            width: 190px;\n            object-fit: cover;\n            background-color: $light;\n            border-radius: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n    \n            & img{\n                height: $header-size-icon - 10px;\n                max-width: 160px;\n            }\n        }\n    }\n}\n\n.logo-business, .header-container-profile-user{\n    background-color: transparent;\n    &.active-dropdown{\n        background-color: $header-dropdown-bg-opacity;\n    }\n}\n\n.header-container-profile-user{\n    display: flex;\n    align-items: center;\n\n    .header-profile-user {\n        height: $header-size-icon;\n        width: $header-size-icon;\n        background-color: $gray-300;\n        padding: 0;\n    }\n}\n\n.header-container-profile-user-dropdown-menu{\n    .dropdown-item{\n        font-weight: 400;\n        &:hover{\n            font-weight: 500;\n            color: $blue_primary;\n            background-color: $light_blue_13;\n        }\n    }\n}\n\n.noti-icon {\n    i {\n        font-size: 32px;\n        color: $header-item-color;\n    }\n\n    .noti-dot {\n        font-size: 10px;\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: $danger;\n        border-radius: 50%;\n        top: 15px;\n        min-width: 18px;\n        min-height: 18px;\n        height: auto;\n        width: auto;\n        padding: 0px;\n        right: 10px;\n    }\n}\n\n.notification-item {\n    .d-flex {\n        padding: 0.75rem 1rem;\n\n        &:hover {\n            background-color: $gray-300;\n        }\n    }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n    display: block;\n    border-radius: 3px;\n    line-height: 34px;\n    text-align: center;\n    padding: 15px 0 9px;\n    display: block;\n    border: 1px solid transparent;\n    color: $gray-600;\n\n    img {\n        height: 24px;\n    }\n\n    span {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &:hover {\n        border-color: $border-color;\n    }\n}\n\n// Full Screen\n.fullscreen-enable {\n    [data-toggle=\"fullscreen\"] {\n        .ri-fullscreen-line:before {\n            content: \"\\ed73\";\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    .navbar-header {\n        .dropdown {\n            position: static;\n\n            .dropdown-menu {\n                left: 10px !important;\n                right: 10px !important;\n            }\n        }\n    }\n}\n\n@media (max-width: 380px) {\n    .navbar-brand-box {\n        display: none;\n    }\n}\n\nbody[data-layout=\"horizontal\"] {\n    #page-topbar {\n        box-shadow: none;\n    }\n    .navbar-brand-box {\n        width: auto;\n    }\n    .page-content {\n        margin-top: $header-height;\n        padding: calc(55px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2) $footer-height\n            calc(#{$grid-gutter-width} / 2);\n    }\n}\n\n@media (max-width: 992px) {\n    body[data-layout=\"horizontal\"] {\n        .page-content {\n            margin-top: 15px;\n        }\n    }\n}\n","#page-topbarInsideTopBarInside {\n    position: relative;\n    z-index: 1000;\n    overflow: visible !important;\n    \n    & .navbar-container{\n        overflow-x: auto;\n        overflow-y: visible !important;\n        position: relative;\n        display: flex;\n        justify-content: center;\n        z-index: 1000;\n        \n        &::-webkit-scrollbar {\n            height: 8px;\n            background: rgba(255, 255, 255, 0.1);\n        }\n        \n        &::-webkit-scrollbar-thumb {\n            background: rgba(255, 255, 255, 0.3);\n            border-radius: 4px;\n            \n            &:hover {\n                background: rgba(255, 255, 255, 0.5);\n            }\n        }\n        \n        & .items {\n            position: fixed;\n            display: flex;\n            background-color: $blue_primary;\n            width: -webkit-fill-available;\n            overflow-x: auto;\n            overflow-y: visible !important;\n            flex-wrap: nowrap;\n            z-index: 1000;\n            contain: none !important;\n            \n            &::-webkit-scrollbar {\n                height: 8px;\n                background: rgba(255, 255, 255, 0.2);\n            }\n            \n            &::-webkit-scrollbar-thumb {\n                background: rgba(255, 255, 255, 0.4);\n                border-radius: 4px;\n                \n                &:hover {\n                    background: rgba(255, 255, 255, 0.6);\n                }\n            }\n            \n            & > div {\n                flex-shrink: 0;\n            }\n            \n            & .btn-item-topbar-inside {\n                text-wrap: nowrap;\n            }\n\n            & .btn-item-topbar-inside, & .dropdown-custom{\n                display: flex;\n                align-items: center;\n                gap: 6px;\n                height: #{$topbar-inside-height-item}px;\n                font-size: 13px;\n                padding: 0 12.5px;\n                font-weight: 500;\n                color: $light;\n                border:none;\n                border-radius: 0;\n                transition: .2s ease-in-out;\n            }\n\n            & > div {\n                position: relative !important;\n                display: inline-block !important;\n            }\n            \n            & .dropdown-wrapper {\n                position: relative !important;\n                display: inline-block !important;\n                width: 100%;\n                z-index: 1002 !important;\n                \n                & .dropdown {\n                    position: relative !important;\n                    width: 100%;\n                    z-index: 1002 !important;\n                }\n                \n                & .dropdown-menu {\n                    position: absolute !important;\n                    top: 100% !important;\n                    left: 0 !important;\n                    right: auto !important;\n                    margin-top: 0 !important;\n                    transform: none !important;\n                    z-index: 1003 !important;\n                    overflow: visible !important;\n                    max-height: calc(100vh - 150px);\n                    clip-path: none !important;\n                    clip: auto !important;\n                }\n            }\n\n            & .dropdown-custom[aria-expanded^=true],\n            & .dropdown-custom.is-open {\n                background-color: $color-azul1 !important;\n                color: white !important;\n                \n                & i {\n                    color: white !important;\n                }\n            }\n\n            & .dropdown-item, & .dropdown-item a{\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                color: $color-azul1;\n                width: 220px;\n                text-wrap: auto;\n                line-height: 22.5px;\n                position: relative;\n                overflow: visible !important;\n                z-index: auto;\n                font-size: 15px;\n                font-weight: 600;\n                height: #{$topbar-inside-height-item}px;\n\n                &.actived,\n                &.actived a,\n                &:hover{\n                    color: $color-azul1;\n                    background-color: $light_gray;\n                }\n\n                &.actived a{\n                    font-weight: 600;\n                }\n\n                & .dropdown-custom[aria-expanded^=true]{\n                    background-color: transparent;\n                }\n                & .dropdown-custom, & a{\n                    padding: 8px 6px;\n                    height: auto;\n                    font-weight: 600;\n                    color: $color-azul1;\n                    width: 100%;\n                    display: flex;\n                    font-size: 15px;\n                }\n                \n                & .submenu-custom-wrapper {\n                    position: relative !important;\n                    width: 100% !important;\n                    z-index: 1002 !important;\n                    \n                    & .submenu-toggle {\n                        &:hover {\n                            background-color: $light_gray;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.main-menu-portal {\n    z-index: 1003 !important;\n    overflow: visible !important;\n    background-color: white !important;\n    border-radius: 0 !important;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;\n    padding: 0px !important;\n    margin: 0 !important;\n    min-width: 220px !important;\n    width: auto !important;\n    position: fixed !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    \n    & .dropdown-item, & .dropdown-item a {\n        display: flex !important;\n        align-items: center !important;\n        gap: 10px !important;\n        color: $color-azul1 !important;\n        width: auto !important;\n        min-width: 100% !important;\n        text-wrap: auto !important;\n        line-height: 22.5px !important;\n        position: relative !important;\n        overflow: visible !important;\n        z-index: auto !important;\n        font-size: 15px !important;\n        font-weight: 600 !important;\n        height: #{$topbar-inside-height-item}px !important;\n        \n        &.actived,\n        &.actived a,\n        &:hover {\n            color: $color-azul1 !important;\n            background-color: $light_gray !important;\n        }\n        \n        &.actived a {\n            font-weight: 600 !important;\n        }\n        \n        & .dropdown-custom[aria-expanded^=true] {\n            background-color: transparent !important;\n        }\n        \n        & .dropdown-custom, & a {\n            padding: 8px 6px !important;\n            height: auto !important;\n            font-weight: 600 !important;\n            color: $color-azul1 !important;\n            width: 100% !important;\n            display: flex !important;\n            font-size: 15px !important;\n        }\n        \n        & .submenu-custom-wrapper {\n            position: relative !important;\n            width: 100% !important;\n            z-index: 1002 !important;\n        }\n    }\n}\n\n.submenu-custom {\n    z-index: 1003 !important;\n    overflow: visible !important;\n    min-width: 220px !important;\n    width: auto !important;\n    max-width: 400px !important;\n    background-color: white !important;\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;\n    padding: 0 !important;\n    margin-left: 0 !important;\n\n    & .dropdown-item {\n        display: flex !important;\n        align-items: center !important;\n        gap: 10px !important;\n        color: $color-azul1 !important;\n        width: 100% !important;\n        min-width: 220px !important;\n        line-height: 1 !important;\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        padding: 8px 12px !important;\n        background-color: white !important;\n        cursor: pointer !important;\n        margin: 0 !important;\n        border: none !important;\n        white-space: nowrap !important;\n        height: #{$topbar-inside-height-item}px !important;\n        \n        &:hover {\n            color: $color-azul1 !important;\n            background-color: $light_gray !important;\n        }\n        \n        & a {\n            padding: 8px 12px !important;\n            height: auto !important;\n            font-weight: 400 !important;\n            color: $color-azul1 !important;\n            width: 100% !important;\n            display: flex !important;\n            align-items: center !important;\n            gap: 10px !important;\n            font-size: 14px !important;\n            text-decoration: none !important;\n            cursor: pointer !important;\n            line-height: 1 !important;\n            margin: 0 !important;\n            white-space: nowrap !important;\n            \n            &:hover {\n                color: $color-azul1 !important;\n            }\n        }\n        \n        & span {\n            color: $color-azul1 !important;\n            font-size: 14px !important;\n            font-weight: 400 !important;\n        }\n        \n        & i {\n            color: $color-azul1 !important;\n            font-size: 15px !important;\n        }\n    }\n}","// \n// Page-title\n// \n\n.page-title-box {\n    padding-top: calc(#{$grid-gutter-width} / 2);\n    padding-bottom: 16px;\n\n    .breadcrumb {\n        background-color: transparent;\n        padding: 0;\n    }\n\n    h4 {\n        font-size: 18px;\n        font-weight: 600;\n    }\n}\n","// \n// _footer.scss\n// \n\n.footer {\n    bottom: 0;\n    padding: 20px calc(#{$grid-gutter-width} / 2);\n    position: absolute;\n    right: 0;\n    color: $footer-color;\n    left: $sidebar-width;\n    height: $footer-height;\n    box-shadow: $box-shadow;\n    background-color: $footer-bg;\n}\n\n@media (max-width: 992px) {\n    .footer {\n        left: 0;\n    }\n}\n\n// Enlarge menu\n.vertical-collpsed {\n    .footer {\n        left: $sidebar-collapsed-width;\n    }\n}\n\nbody[data-layout=\"horizontal\"] {\n    .footer {\n        left: 0 !important;\n    }  \n}","//\n// right-sidebar.scss\n//\n\n.right-bar {\n    background-color: $card-bg;\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n    display: block;\n    position: fixed;\n    transition: all 200ms ease-out;\n    width: $rightbar-width;\n    z-index: 9999;\n    float: right !important;    \n    right: -($rightbar-width + 10px);    \n    top: 0;\n    bottom: 0;\n\n    .right-bar-toggle {\n        background-color: lighten($dark, 7%);\n        height: 24px;\n        width: 24px;\n        line-height: 24px;\n        color: $gray-200;\n        text-align: center;\n        border-radius: 50%;\n\n        &:hover {\n            background-color: lighten($dark, 10%);\n        }\n    }\n}\n\n// Rightbar overlay\n.rightbar-overlay {\n    background-color: rgba($dark, 0.55);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 100vh;\n    bottom: 0;\n    display: none;\n    z-index: 9998;\n    transition: all .2s ease-out;\n}\n\n.right-bar-enabled {\n    .right-bar {\n        right: 0;\n    }\n    .rightbar-overlay {\n        display: block;\n    }\n}\n\n@include media-breakpoint-down(md) {\n    .right-bar {\n        overflow: auto;\n        .slimscroll-menu {\n            height: auto !important;\n        }\n    }\n}\n\n.right-bar-custom-filter{\n\n    & .simplebar-content{\n        height: 100%;\n        display: flex;\n        flex-grow: 1;\n        overflow: hidden !important;\n    }\n\n    & .content-filters{\n        overflow: auto;\n        &::-webkit-scrollbar {\n            width: 5px;\n            margin-left: 10px;            \n            }\n\n        &::-webkit-scrollbar-track {\n            background: #cecece;\n            border-radius: 10px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: #888;\n            border-radius: 10px;\n        }\n\n        &::-webkit-scrollbar-thumb:hover {\n            background: #555;\n        }\n    }\n\n    & .container-button-submit{\n        & button {\n            background-color: $blue_primary;\n            color: white;\n            padding: 8px 16px;\n            transition: .2s ease-in-out;\n            height: 54px;\n            font-weight: 600;\n            font-size: $font-size-lg;\n\n            &:hover{\n                background-color: darken($color: $blue_primary, $amount: 8);\n            }\n        }\n    }\n\n    & .rightbar-title{\n        & a {\n            text-decoration: underline;\n            color: $gray_03;\n        }\n        & button{\n            display: flex;\n            gap: 5px;\n            align-items: center;\n            background-color: transparent;\n            border: none;\n            padding: 10px 0px;\n            transition: .2s ease-in-out;\n            color: $gray_secundary !important;\n            \n            &:hover{\n                color: darken($color: $gray_secundary, $amount: 8);\n            }\n        }\n    }\n}","//\n// _menu.scss\n//\n\n.metismenu {\n    margin: 0;\n\n    li {\n        display: block;\n        width: 100%;\n        margin: 15px 0;\n    }\n\n    .mm-collapse {\n        display: none;\n\n        &:not(.mm-show) {\n            display: none;\n        }\n\n        &.mm-show {\n            display: block;\n        }\n    }\n\n    .mm-collapsing {\n        position: relative;\n        height: 0;\n        overflow: hidden;\n        transition-timing-function: ease;\n        transition-duration: 0.35s;\n        transition-property: height, visibility;\n    }\n}\n\n.vertical-menu {\n    width: $sidebar-width;\n    z-index: 1001;\n    background: $sidebar-bg;\n    bottom: 0;\n    margin-top: 0;\n    position: fixed;\n    top: 0;\n    box-shadow: $box-shadow;\n\n    & .card-menu-sidebar-info{\n        width: 315px;\n        border: 1px solid $light_blue_08;\n        border-radius: 5px;\n        background-color: $light_gray_03;\n        & .card-header{\n            background-color: $light_gray_03;\n            height: 60px;\n            font-family: $font-family-sans-serif;\n            font-weight: 500;\n            padding: 0 16px;\n            margin: 0;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            font-size: $font-size-xlg;\n            color: $color-azul1;\n        }\n        & .card-body{\n            text-align: left;\n            background-color: $light_gray_02;\n            height: auto;\n            font-size: $font-size-sm;\n            color: $dark_gray_primary_02;\n            padding: 16px;\n        }\n    }\n}\n\n.main-content {\n    // margin-left: $sidebar-width;\n    // margin-top: $header-height;\n    overflow: hidden;\n\n    .is-modal-page &{\n        height: 100vh !important;\n        overflow: auto !important;\n    }\n\n    .content {\n        padding: 0 15px 10px 15px;\n        margin-top: $header-height;\n    }\n\n    &:has(#page-topbarInsideTopBarInside){\n        & .page-content {\n            padding-top: 0 !important;\n        }\n        & .page-breadcrumb {\n            padding-top: calc(#{$topbar-inside-height-item}px + 4px) !important;\n        }\n    }\n}\n\n#sidebar-top-logo{\n    display: flex;\n    justify-content: center;\n    height: $header-height;\n    border-right: 1px solid #D7D7D7;\n    \n    & img{\n        border-bottom: 1px solid $gray_primary;        \n        padding: 12px;\n    }\n}\n\n#sidebar-menu {\n    padding: 0 10px 30px;\n\n    .mm-active {\n        > .has-arrow {\n            &:after {\n                transform: rotate(-180deg);\n            }\n        }\n\n        .active {\n            color: $sidebar-menu-item-active-color !important;\n    \n            .icone {\n                background-color: $light_blue_09 !important;\n            }\n        }\n    }\n\n    .has-arrow {\n        &:after {\n            content: \"\\F0140\";\n            font-family: \"Material Design Icons\";\n            display: block;\n            float: right;\n            transition: transform 0.2s;\n            font-size: 1rem;\n        }\n    }\n\n    ul {\n        li {\n            &.disabled{\n                & a, & .icone i, & .icone svg path{\n                    color: $gray_primary;\n                    fill: $gray_primary;\n                }\n            }\n\n            :hover {        \n                .icone {\n                    background-color: $light_blue_10 !important;                    \n                    padding: 0 20px;\n                }\n            }\n            a {\n                display: block;\n                padding: 0;\n                color: $dark_blue_10;\n                position: relative;\n                line-height: 1em;\n                font-size: 11px;\n                font-weight: 500;\n                font-family: $font-family-secondary;\n                margin-bottom: 12px;\n                \n                .icone{\n                    border-radius: 50px;\n                    transition: all 0.4s;\n                    position: relative;\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    margin-bottom: 6px;\n\n                    div svg{\n                        width: auto;\n                        height: auto;\n                    }\n                    \n                    i, div svg {\n                        font-size: 24px;\n                        padding: 8px;\n                        display: block;\n                        color: $dark_blue_10;\n                        transition: all 0.4s;\n                    }\n\n                }\n\n            }\n\n            .badge {\n                margin-top: 4px;\n            }\n\n            ul.sub-menu {\n                padding: 0;\n\n                li {\n                    a {\n                        padding: 0.4rem 1.5rem 0.4rem 3.2rem;\n                        font-size: 14px;\n                        color: $sidebar-menu-sub-item-color;\n                    }\n\n                    ul.sub-menu {\n                        padding: 0;\n\n                        li {\n                            a {\n                                padding: 0.4rem 1.5rem 0.4rem 4.2rem;\n                                font-size: 14px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.card-float-menu{\n    position: absolute;\n    padding-left: 30px;\n    background-color: transparent;\n    border: none;\n    outline: none;\n    box-shadow: none;\n}\n\n@media (max-width: 992px) {\n    .vertical-menu {\n        display: none;\n    }\n\n    .main-content {\n        margin-left: 0 !important;\n    }\n\n    body.sidebar-enable {\n        .vertical-menu {\n            display: block;\n        }\n    }\n}\n\n// Enlarge menu\n.vertical-collpsed {\n    .main-content {\n        margin-left: $sidebar-collapsed-width;\n    }\n\n    .navbar-brand-box {\n        width: $sidebar-collapsed-width !important;\n        padding: 0;\n    }\n\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: block;\n        }\n    }\n\n    // Side menu\n    .vertical-menu {\n        position: absolute;\n        width: $sidebar-collapsed-width !important;\n        z-index: 5;\n\n        .simplebar-mask,\n        .simplebar-content-wrapper {\n            overflow: visible !important;\n        }\n\n        .simplebar-scrollbar {\n            display: none !important;\n        }\n\n        .simplebar-offset {\n            bottom: 0 !important;\n        }\n\n        // Sidebar Menu\n        #sidebar-menu {\n            //.menu-title,\n            .badge,\n            .collapse.in {\n                display: none !important;\n            }\n\n            .nav.collapse {\n                height: inherit !important;\n            }\n\n            .has-arrow {\n                &:after {\n                    display: none;\n                }\n            }\n\n            > ul {\n                > li {\n                    position: relative;\n                    white-space: nowrap;\n\n                    > a {\n                        padding: 15px 20px;\n                        min-height: 55px;\n                        transition: none;\n\n                        &:hover,\n                        &:active,\n                        &:focus {\n                            color: $sidebar-menu-item-hover-color;\n                        }\n\n                        i {\n                            font-size: 20px;\n                            margin-left: 4px;\n                        }\n\n                        span {\n                            display: none;\n                            padding-left: 25px;\n                        }\n                    }\n\n                    &:hover {\n                        > a {\n                            position: relative;\n                            width: calc(#{$sidebar-width-sm} + #{$sidebar-collapsed-width});\n                            color: $primary;\n                            background-color: darken($sidebar-bg, 4%);\n                            transition: none;\n\n                            i {\n                                color: $primary;\n                            }\n\n                            span {\n                                display: inline;\n                            }\n                        }\n\n                        > ul {\n                            display: block;\n                            left: $sidebar-collapsed-width;\n                            position: absolute;\n                            width: 190px;\n                            height: auto !important;\n                            box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1);\n\n                            ul {\n                                box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1);\n                            }\n\n                            a {\n                                box-shadow: none;\n                                padding: 8px 20px;\n                                position: relative;\n                                width: 190px;\n                                z-index: 6;\n                                color: $sidebar-menu-sub-item-color;\n\n                                &:hover {\n                                    color: $sidebar-menu-item-hover-color;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                ul {\n                    padding: 5px 0;\n                    z-index: 9999;\n                    display: none;\n                    background-color: $sidebar-bg;\n\n                    li {\n                        &:hover {\n                            > ul {\n                                display: block;\n                                left: 190px;\n                                height: auto !important;\n                                margin-top: -36px;\n                                position: absolute;\n                                width: 190px;\n                            }\n                        }\n\n                        > a {\n                            span.pull-right {\n                                position: absolute;\n                                right: 20px;\n                                top: 12px;\n                                transform: rotate(270deg);\n                            }\n                        }\n                    }\n\n                    li.active {\n                        a {\n                            color: $gray-100;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// body[data-sidebar=\"dark\"] {\n//     .vertical-menu {\n//         background: $sidebar-dark-bg;\n//     }\n\n//     #sidebar-menu {\n//         ul {\n//             li {\n//                 a {\n//                     color: $sidebar-dark-menu-item-color;\n\n//                     i {\n//                         color: $sidebar-dark-menu-item-icon-color;\n//                     }\n\n//                     &:hover {\n//                         opacity: 0.7;\n\n//                         i {\n//                             opacity: 0.7;\n//                         }\n//                     }\n//                 }\n\n//                 ul.sub-menu {\n//                     li {\n//                         a {\n//                             opacity: 0.7;\n\n//                             &:hover {\n//                                 opacity: 0.7;\n//                             }\n//                         }\n//                     }\n//                 }\n//             }\n//         }\n//     }\n//     // Enlarge menu\n//     &.vertical-collpsed {\n//         min-height: 1400px;\n\n//         // Side menu\n//         .vertical-menu {\n//             // Sidebar Menu\n//             #sidebar-menu {\n//                 > ul {\n//                     > li {\n//                         &:hover {\n//                             > a {\n//                                 background: lighten($sidebar-dark-bg, 2%);\n//                                 opacity: 0.7;\n//                                 i {\n//                                     opacity: 0.7;\n//                                 }\n//                             }\n\n//                             > ul {\n//                                 a {\n//                                     opacity: 0.7;\n//                                     &:hover {\n//                                         opacity: 0.7;\n//                                     }\n//                                 }\n//                             }\n//                         }\n//                     }\n\n//                     ul {\n//                         background-color: lighten($card-bg, 1%);\n//                     }\n//                 }\n\n//                 ul {\n//                     > li {\n//                         > a {\n//                             &.mm-active {\n//                                 color: $sidebar-dark-menu-item-active-color !important;\n//                             }\n//                         }\n//                     }\n\n//                     li {\n//                         li {\n//                             &.mm-active,\n//                             &.active {\n//                                 > a {\n//                                     color: $sidebar-menu-item-active-color !important;\n//                                 }\n//                             }\n\n//                             a {\n//                                 &.mm-active,\n//                                 &.active {\n//                                     color: $sidebar-menu-item-active-color !important;\n//                                 }\n//                             }\n//                         }\n//                     }\n//                 }\n//             }\n//         }\n//     }\n\n//     .mm-active {\n//         color: $sidebar-dark-menu-item-active-color !important;\n//         > a {\n//             color: $sidebar-dark-menu-item-active-color !important;\n//             i {\n//                 color: $sidebar-dark-menu-item-active-color !important;\n//             }\n//         }\n//         > i {\n//             color: $sidebar-dark-menu-item-active-color !important;\n//         }\n//         .active {\n//             color: $sidebar-dark-menu-item-active-color !important;\n\n//             i {\n//                 color: $sidebar-dark-menu-item-active-color !important;\n//             }\n//         }\n//     }\n\n//     // .menu-title {\n//     //     color: $sidebar-dark-menu-item-icon-color;\n//     // }\n// }\n\nbody[data-layout=\"horizontal\"] {\n    .main-content {\n        margin-left: 0 !important;\n    }\n}\n\n// Compact Sidebar\n\nbody[data-sidebar-size=\"small\"] {\n    .navbar-brand-box {\n        width: auto; // $navbar-brand-box-width;\n        display: flex;\n        align-items: center;\n\n        @media (max-width: 992px) {\n            width: auto;\n        }\n    }\n\n    .vertical-menu {\n        width: $sidebar-width-sm;\n        text-align: center;\n\n        .has-arrow:after,\n        .badge {\n            display: none !important;\n        }\n    }\n    // & .main-content {\n    //     margin-left: $sidebar-width-sm;\n    //     height: calc(100vh - 90px);\n    //     overflow: auto;\n    // }\n    .footer {\n        left: $sidebar-width-sm;\n        @media (max-width: 991px) {\n            left: 0;\n        }\n    }\n\n    // #sidebar-menu {\n    //     ul li {\n    //         // &.menu-title {\n    //         //     background-color: lighten($sidebar-dark-bg, 2%);\n    //         // }\n    //         a {\n    //             .icone > i {\n    //                 font-size: 24px;\n    //                 background-color: transparent;\n    //                 color: $dark_blue_10;\n    //                 border-radius: 50px;\n    //                 align-items: center;\n    //                 justify-content: center;\n    //                 display: flex;\n    //             }\n    //         }\n    //         ul.sub-menu {\n    //             li {\n    //                 a {\n    //                     padding-left: 1.5rem;\n    //                 }\n\n    //                 ul.sub-menu {\n    //                     li {\n    //                         a {\n    //                             padding-left: 1.5rem;\n    //                         }\n    //                     }\n    //                 }\n    //             }\n    //         }\n    //     }\n    // }\n    &.vertical-collpsed {\n        .main-content {\n            margin-left: $sidebar-collapsed-width;\n        }\n        .vertical-menu {\n            #sidebar-menu {\n                text-align: left;\n                > ul {\n                    > li {\n                        > a {\n                            i {\n                                display: inline-block;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .footer {\n            left: $sidebar-collapsed-width;\n        }\n    }\n}\n","// \n// _horizontal.scss\n// \n\n.topnav {\n    background: $topnav-bg;\n    padding: 0 calc(#{$grid-gutter-width} / 2);\n    box-shadow: $box-shadow;\n    margin-top: $header-height;\n    position: fixed;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    \n    .topnav-menu {\n        margin: 0;\n        padding: 0;\n    }\n\n    .navbar-nav {\n        \n        .nav-link {\n            font-size: 15px;\n            position: relative;\n            padding: 1rem 1.3rem;\n            color: $menu-item-color;\n            font-family: $font-family-secondary;\n\n            i{\n                font-size: 15px;\n                vertical-align: middle;\n                display: inline-block;\n            }\n            &:focus, &:hover{\n                color: $menu-item-active-color;\n                background-color: transparent;\n            }\n        }\n        \n        .dropdown-item{\n            color: $menu-item-color;\n            &.active, &:hover{\n                color: $menu-item-active-color;\n            }\n        }\n        \n        .nav-item{\n            .nav-link.active{\n                color: $menu-item-active-color;\n            }\n        }\n\n        .dropdown{\n            &.active{\n              >a {\n                    color: $menu-item-active-color;\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xl) {\n\n    body[data-layout=\"horizontal\"] {\n        .container-fluid,\n        .navbar-header {\n            max-width: 85%;\n        }\n    }\n}\n\n@include media-breakpoint-up(lg) {\n    .topnav {\n        .navbar-nav {\n            .nav-item {\n                &:first-of-type {\n                    .nav-link {\n                        padding-left: 0;\n                    }\n                }\n            }\n        }\n\n        .dropdown-item {\n            padding: .5rem 1.5rem;\n            min-width: 180px;\n        }\n\n        .dropdown {\n            &.mega-dropdown{\n                // position: static;\n                .mega-dropdown-menu{\n                    left: 0px;\n                    right: auto;\n                }\n            }\n            .dropdown-menu {\n                margin-top: 0;\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\n\n                .arrow-down {\n                    &::after {\n                        right: 15px;\n                        transform: rotate(-135deg) translateY(-50%);\n                        position: absolute;\n                    }\n                }\n\n                .dropdown {\n                    .dropdown-menu {\n                        position: absolute;\n                        top: 0 !important;\n                        left: 100%;\n                        display: none\n                    }\n                }\n            }\n\n            &:hover {\n                >.dropdown-menu {\n                    display: block;\n                }\n            }\n        }\n\n        .dropdown:hover>.dropdown-menu>.dropdown:hover>.dropdown-menu {\n            display: block\n        }\n    }\n\n    .navbar-toggle {\n        display: none;\n    }\n}\n\n.arrow-down {\n    display: inline-block;\n\n    &:after {\n        border-color: initial;\n        border-style: solid;\n        border-width: 0 0 1px 1px;\n        content: \"\";\n        height: .4em;\n        display: inline-block;\n        right: 5px;\n        top: 50%;\n        margin-left: 10px;\n        transform: rotate(-45deg) translateY(-50%);\n        transform-origin: top;\n        transition: all .3s ease-out;\n        width: .4em;\n    }\n}\n\n\n@include media-breakpoint-down(xl) {\n    .topnav-menu {\n        .navbar-nav {\n            li {\n                &:last-of-type {\n                    .dropdown {\n                        .dropdown-menu {\n                            right: 100%;\n                            left: auto;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(lg) {\n\n    .navbar-brand-box{\n        .logo-dark {\n            display: $display-block;\n            span.logo-sm{\n                display: $display-block;\n            }\n        }\n    \n        .logo-light {\n            display: $display-none;\n        }\n    }\n\n    .topnav {\n        max-height: 360px;\n        overflow-y: auto;\n        padding: 0;\n        .navbar-nav {\n            .nav-link {\n                padding: 0.75rem 1.1rem;\n            }\n        }\n\n        .dropdown {\n            .dropdown-menu {\n                background-color: transparent;\n                border: none;\n                box-shadow: none;\n                padding-left: 15px;\n                &.dropdown-mega-menu-xl{\n                    width: auto;\n    \n                    .row{\n                        margin: 0px;\n                    }\n                }\n            }\n\n            .dropdown-item {\n                position: relative;\n                background-color: transparent;\n\n                &.active,\n                &:active {\n                    color: $primary;\n                }\n            }\n        }\n\n        .arrow-down {\n            &::after {\n                right: 15px;\n                position: absolute;\n            }\n        }\n    }\n}\n\n\n@include media-breakpoint-up(lg) {\n\n    body[data-layout=\"horizontal\"][data-topbar=\"light\"] {\n        .navbar-brand-box{\n            .logo-dark {\n                display: $display-block;\n            }\n        \n            .logo-light {\n                display: $display-none;\n            }\n        }\n\n        .topnav{\n            background-color: $header-dark-bg;\n            .navbar-nav {\n        \n                .nav-link {\n                    color: rgba($white, 0.7);\n                    \n                    &:focus, &:hover{\n                        color: rgba($white, 0.9);\n                    }\n                }\n\n                > .dropdown{\n                    &.active{\n                    >a {\n                            color: rgba($white, 0.9) !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","// \n// _general.scss\n// \n\n#header-default-body{\n    & a{\n        &::before{\n        content: \"\";\n        border: solid $color-azul1;\n        border-width: 0 3px 3px 0;\n        display: inline-block;\n        background-color: transparent;\n        margin-left: 5px;\n        width: 18px;\n        height: 18px;\n        transform: rotate(135deg);\n        -webkit-transform: rotate(135deg);\n        }\n    }\n}\n\n.loading-overlay{\n    top:0;\n    left: 0;\n    position: absolute;\n    background-color: #CDCDCD60;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    border-radius: 4px;\n    align-items: center;\n    transition: .2s ease-in-out;\n    justify-content: center;\n    z-index: 10;\n}","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xs {\n  height: 2rem;\n  width: 2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-xxl {\n  height: 9.5rem;\n  width: 9.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  background-color: $primary;\n  color: $white;\n  display: flex;\n  font-weight: $font-weight-medium;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n\n// avatar group\n.avatar-group {\n  padding-left: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  .avatar-group-item {\n    margin-left: -12px;\n    border: 2px solid $card-bg;\n    border-radius: 50%;\n    transition: all 0.2s;\n    &:hover{\n      position: relative;\n      transform: translateY(-2px);\n    }\n  }\n}\n\n.container-avatar-with-box-info{\n  position: relative;\n  \n  & .container-avatar{\n    position: relative;\n    cursor: pointer;\n\n    &:hover{\n      & .modal-info{\n        display: block;\n      }\n    }\n    & .modal-info{\n  \n      &.right-box{\n        right: 33px;\n      }\n      &.left-box{\n        left: 33px;\n      }\n  \n      display: none;\n      transition: .2s ease-in-out;\n      background-color: #ffffff;\n      border: 1px solid $color-cinza2;\n      border-radius: 16px;\n      padding: 24px;\n      width: 480px;\n      top: 0;\n      z-index: 99;\n      position: absolute;\n    }\n  }\n  \n}","\n//\n// accordion.scss\n//\n\n.custom-accordion {\n    .card {\n        + .card {\n            margin-top: 0.5rem;\n        }\n    }\n\n    a {\n        &.collapsed {\n            i.accor-plus-icon {\n                &:before {\n                    content: \"\\F0415\";\n                }\n            }\n        }\n    }\n\n    .card-header{\n        border-radius: 7px;\n    }\n}\n\n.custom-accordion-arrow{\n    .card{\n        border: 1px solid $border-color;\n        box-shadow: none;\n    }\n    .card-header{\n        padding-left: 45px;\n        position: relative;\n\n        .accor-arrow-icon{\n            position: absolute;\n            display: inline-block;\n            width: 24px;\n            height: 24px;\n            line-height: 24px;\n            font-size: $font-size-md;\n            background-color: $primary;\n            color: $white;\n            border-radius: 50%;\n            text-align: center;\n            left: 10px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n\n    a {\n        &.collapsed {\n            i.accor-arrow-icon {\n                &:before {\n                    content: \"\\F0142\";\n                }\n            }\n        }\n    }\n}\n\n.nav-accordion-custom{\n    & ul{\n        border: none;\n        & li{\n            height: 54px;\n            background-color: $info;\n            transition: .2s ease-in-out;\n            border-bottom: 4px solid $info;\n\n            &:last-child{\n                border-radius: 0 10px 10px 0;\n            }\n            &:first-child{\n                border-radius: 10px 0 0 10px;\n            }\n            &:hover{\n                background-color: $light_blue_10;\n                border-bottom-color: $light_blue_10;\n            }\n\n            &:has(.active){\n                border-color: $primary;\n                border-bottom-color: $blue_primary;\n            }\n            &:has(.active),\n            & .nav-link.active{\n                color: $color-azul1;\n                background-color: transparent;\n            }\n\n            & .nav-link{\n                border: 0;\n                height: 54px;\n                color: $gray_secundary;                \n                font-weight: 600;\n                font-size: $font-size-md;\n                display: flex;\n                width: 125px;\n                padding: 0;\n                align-items: center;\n                justify-content: center;\n            }\n        }\n    }\n}\n\n.card-accordion-custom{\n    & .accordion-item{\n        border: 0;        \n        box-shadow: none;\n        background-color: transparent;\n        border-radius: 0;\n    }\n    & .accordion-header{\n        border-bottom: 1px solid $color-cinza2;\n        height: 50px;\n        display: flex;\n        align-items: center;\n    }\n    & .accordion-body{\n        padding: 0;\n    }\n    & .accordion-button{\n        padding: 0;\n        border: 0;\n        box-shadow: none;\n        background-color: transparent;\n        border-radius: 0;\n        font-size: $font-size-md;\n        font-weight: 600;\n        color: $gray_secundary;\n    }\n    & .accordion-button::after{\n        display: none;\n    }\n}","//\n// _helper.scss\n//\n\n// Font Family\n.font-family-secondary {\n    font-family: $font-family-secondary;\n}\n\n.font-size-10 {\n    font-size: 10px !important;\n}\n\n.font-size-11 {\n    font-size: 11px !important;\n}\n\n.font-size-12 {\n    font-size: 12px !important;\n}\n\n.font-size-13 {\n    font-size: 13px !important;\n}\n\n.font-size-14 {\n    font-size: 14px !important;\n}\n\n.font-size-15 {\n    font-size: 15px !important;\n}\n\n.font-size-16 {\n    font-size: $font-size-md !important;\n}\n\n.font-size-17 {\n    font-size: 17px !important;\n}\n\n.font-size-18 {\n    font-size: 18px !important;\n}\n\n.font-size-20 {\n    font-size: $font-size-xlg !important;\n}\n\n.font-size-22 {\n    font-size: 22px !important;\n}\n\n.font-size-24 {\n    font-size: 24px !important;\n}\n\n\n.font-size-25 {\n    font-size: 25px !important;\n}\n\n\n.font-size-26 {\n    font-size: 26px !important;\n}\n\n.font-size-28 {\n    font-size: 28px !important;\n}\n\n.font-size-30 {\n    font-size: 30px !important;\n}\n\n.font-size-32 {\n    font-size: 32px !important;\n}\n\n.font-w-300 { font-weight: 300 !important;}\n.font-w-400 { font-weight: 400 !important;}\n.font-w-500 { font-weight: 500 !important;}\n.font-w-600 { font-weight: 600 !important;}\n.font-w-700 { font-weight: 700 !important;}\n.font-w-bold { font-weight: bold !important;}\n\n.cursor-pointer{\n    cursor: pointer;\n}\n\n.logo-user{\n    width: 50px;\n    height: 50px;\n    background-color: $gray_primary;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n// Social\n\n.social-list-item {\n    height: 2rem;\n    width: 2rem;\n    line-height: calc(2rem - 2px);\n    display: block;\n    border: 1px solid $gray-500;\n    border-radius: 50%;\n    color: $gray-500;\n    text-align: center;\n    transition: all 0.4s;\n\n    &:hover {\n        color: $gray-600;\n        background-color: $gray-200;\n    }\n}\n\n\n.w-xs {\n    min-width: 80px;\n}\n\n.w-sm {\n    min-width: 95px;\n}\n\n.w-md {\n    min-width: 110px;\n}\n\n.w-lg {\n    min-width: 140px;\n}\n\n.w-xl {\n    min-width: 160px;\n}\n\n// overlay\n\n.bg-overlay {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    top: 0;\n    opacity: 0.7;\n    background-color: $black;\n}\n\n\n\n\n// alert\n\n.alert-dismissible {\n    .btn-close {\n        font-size: 10px;\n        padding: $alert-padding-y * 1.4 $alert-padding-x;\n        background: transparent escape-svg($btn-close-bg-dark) center / $btn-close-width auto no-repeat;\n    }\n}\n\n// Search \n.search-box{\n    position: relative;\n    .form-control{\n        padding-left: 40px;\n    }\n    .search-icon{\n        font-size: 14px;\n        position: absolute;\n        left: 13px;\n        top: 0;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        color: $text-muted;\n    }\n}\n\n// Page erros\n.page-erros{\n    height: 100vh;\n    h4{\n        font-size: 46px;\n        font-weight: 700;\n        font-family: $font-family-sans-serif;\n        color: $gray_secundary;\n    }\n    p{\n        color: $gray_secundary;\n        font-weight: 400;\n        font-size: $font-size-md;\n    }\n    a{\n        font-weight: 600;\n        font-size: $font-size-md;\n        border: 1px solid #00000026;\n    }\n}\n\n.flip-icon{\n    transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n}\n\n.user-photo-label{\n    border-radius: 50%;\n    color: $gray_primary;\n    width: auto;\n    display: flex;//contents;\n    // background-color: $info;\n}","//\n// Forms.scss\n//\n\n// input code verification\n\n.digit-input {\n  width: 5rem !important;\n  height: 6.5rem;\n  font-size: 6.5rem !important;\n  text-align: center;\n  color: #999;\n  background: transparent;\n  border: none;\n  border-bottom: 6px solid #ccc !important;\n  outline: none;\n  margin: 0 0.25rem;\n  font-weight: 500;\n}\n\n//\n// select - componente inputSelectCustom\n//\n\n.select-filter-custom {\n  &.select-filter-custom--is-disabled {\n    opacity: 0.7;\n  }\n  &.is-invalid {\n    & .select-filter-custom__control {\n      border-color: #dc3545 !important;\n    }\n  }\n\n  & .select-filter-custom__control {\n    border: 1px solid #a8a8a8 !important;\n    background-color: white;\n    border-radius: 4px;\n    transition: border-color 0.2s ease;\n  }\n}\n\n.select-filter-custom:hover,\n.select-filter-custom__control:hover {\n  border-color: #244ea2 !important;\n  box-shadow: none !important;\n  color: #a8a8a8 !important;\n}\n\n.select-filter-custom__control--is-focused {\n  border-color: #244ea2 !important;\n  box-shadow: none !important;\n}\n\n.select-filter-custom__value-container {\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n}\n\n.select-filter-custom__placeholder,\n.select-filter-custom__single-value {\n  color: $color-cinza4 !important;\n}\n\n.select-filter-custom__option {\n  background-color: $color-branco2 !important;\n}\n\n.select-filter-custom__option--is-focused {\n  background-color: $color-azul410 !important;\n}\n\n.select-filter-custom__option--is-selected {\n  background-color: #263874 !important;\n  color: #ffffff !important;\n}\n\n.select-filter-custom__menu {\n  padding: 10px 0;\n  background-color: $color-branco2 !important;\n}\n\n// form-check\n\n.form-check-right {\n  padding-left: 0;\n  display: inline-block;\n  padding-right: $form-check-padding-start;\n  .form-check-input {\n    float: right;\n    margin-left: 0;\n    margin-right: $form-check-padding-start * -1;\n  }\n  .form-check-label {\n    display: block;\n  }\n}\n\n.form-check {\n  position: relative;\n  text-align: left /*rtl: right*/;\n  user-select: none;\n}\n\n.form-check-input,\n.form-check-label {\n  cursor: pointer;\n  margin-bottom: 0;\n  user-select: none;\n}\n\n// Switch sizes\n\n.form-switch-md {\n  padding-left: 2.5rem;\n  min-height: 24px;\n  line-height: 24px;\n  .form-check-input {\n    width: 40px;\n    height: 20px;\n    left: -0.5rem;\n    position: relative;\n  }\n\n  .form-check-label {\n    vertical-align: middle;\n  }\n}\n\n.form-switch-lg {\n  padding-left: 2.75rem;\n  min-height: 28px;\n  line-height: 28px;\n  .form-check-input {\n    width: 48px;\n    height: 24px;\n    left: -0.75rem;\n    position: relative;\n  }\n}\n\n// Custom form sistem #01\n.form-custom01-filter {\n  & .btn-filter-submit {\n    &:hover {\n      background-color: $blue_primary;\n    }\n    transition: 0.2s ease-in-out;\n    background-color: $light_blue_01;\n    font-weight: 400;\n  }\n  & .form-control,\n  & .btn-filter-submit {\n    height: $input-height;\n    border-color: $gray_primary;\n  }\n\n  & .form-control:focus:focus-within:hover {\n    border-color: $primary !important;\n    box-shadow: none !important;\n  }\n\n  & .form-control {\n    box-shadow: none;\n    border: 1px solid $gray_primary;\n    border-radius: 4px;\n    color: $gray_secundary;\n    font-size: 15px;\n    padding-left: 18px;\n    cursor: pointer;\n  }\n  & label {\n    color: $gray_secundary;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21px;\n  }\n}\n\n.btn-hover-primary {\n  &:hover {\n    background-color: $primary !important;\n  }\n  transition: 0.2s ease-in-out;\n}\n\n.input-custom-search {\n  position: relative;\n  display: flex;\n\n  & input {\n    height: 40px;\n    width: 100%;\n    color: $color-cinza3;\n    border-radius: $border-radius;\n    border-color: $gray_primary;\n    background-color: white;\n    font-family: $font-family-sans-serif;\n    font-weight: 400;\n    &:hover,\n    &:focus {\n      box-shadow: 0px 0px 1px 1px $light_blue_05;\n      border-color: $light_blue_05;\n    }\n    &::placeholder {\n      color: $color-cinza3 !important;\n    }\n  }\n\n  & i {\n    cursor: pointer;\n    position: absolute;\n    right: 18px;\n    display: flex;\n    align-self: center;\n    color: $light_blue_05;\n  }\n}\n\n.input-radio-custom {\n  &.form-check-input {\n    background-image: none !important;\n  }\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  width: 20px !important;\n  height: 20px !important;\n  padding: 1px !important;\n  background-clip: content-box;\n  border: 2px solid $blue_primary !important;\n  border-radius: 50% !important;\n  background-color: white !important;\n\n  &:checked {\n    background-color: $blue_primary !important;\n  }\n}\n\n.input-checkbox-custom {\n  cursor: pointer;\n  width: 22px !important;\n  height: 22px !important;\n  padding: 0;\n  margin: 0;\n  border: 2px solid $blue_primary !important;\n  border-radius: 4px !important;\n  background-color: white !important;\n\n  &:checked {\n    background-color: $color-azul4 !important;\n    border-color: $color-azul4 !important;\n  }\n  &:disabled {\n    background-color: $color-azul130 !important;\n    border-color: $color-azul130 !important;\n  }\n}\n\n.form-default-primary {\n  & .form-control:has(input:disabled) {\n    background-color: $gray_disabled !important;\n    border-color: $border_disabled !important;\n    & i {\n      color: $gray_primary !important;\n    }\n  }\n\n  & .form-label {\n    margin-bottom: 0.25rem;\n  }\n\n  & input:disabled {\n    background-color: $color-branco3 !important;\n    border-color: $color-cinza3 !important;\n    cursor: not-allowed;\n    &:hover,\n    &:active,\n    &:focus {\n      border-color: $color-cinza3 !important;\n    }\n  }\n\n  & input,\n  & select {\n    &.is-valid {\n      border-color: $color-verde1 !important;\n    }\n    &.is-invalid {\n      border-color: $color-vermelho1 !important;\n    }\n  }\n\n  & input,\n  & .form-control {\n    font-family: $font-family-sans-serif;\n    height: $input-height;\n    font-size: $font-size-md;\n    width: 100%;\n    border-radius: $border-radius;\n    padding: 16px;\n    background-color: white;\n    color: $color-cinza4;\n    border: 1px solid $gray_primary;\n\n    &:hover,\n    &:active,\n    &:focus {\n      border-color: $blue_primary !important;\n    }\n\n    & i {\n      font-size: 24px;\n      color: $light_blue_05;\n      display: contents;\n    }\n\n    & input {\n      border: none;\n      border-radius: 0;\n      padding: 0;\n      height: auto !important;\n      width: 100%;\n      font-size: 14px;\n      color: $color-cinza4;\n      &::placeholder {\n        color: $color-cinza3;\n      }\n    }\n  }\n}\n\n.input-date-group-custom {\n  & .date-input::-webkit-calendar-picker-indicator {\n    display: none;\n  }\n\n  & input:hover + .date-icon-bizin {\n    border-color: $color-azul2 !important;\n  }\n\n  & .active,\n  & .date-input:hover {\n    border-color: $color-azul2 !important;\n  }\n\n  & .date-input {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n    border-right: none;\n  }\n\n  & .date-icon-bizin {\n    & i {\n      font-size: 1.2rem;\n      color: $color-azul2;\n    }\n\n    &:hover {\n      border-color: $color-azul2 !important;\n    }\n\n    background-color: white;\n    width: 54px;\n    height: $input-height;\n    border: 1px solid $gray_primary;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-end-end-radius: 4px;\n    border-start-end-radius: 4px;\n    transition: 0.2s ease-in-out;\n    cursor: pointer;\n  }\n}\n\n#container-input-send-message {\n  width: 100%;\n  min-height: 56px;\n  display: flex;\n  border-radius: 12px;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 0;\n  padding-left: 0;\n  border: 1px solid $color-cinza3;\n  background-color: white;\n  transition: 0.2s ease-in-out;\n  &:hover {\n    box-shadow: 0px 0px 0px 2px $color-azul3;\n  }\n  &:focus-within,\n  &:focus-visible {\n    box-shadow: 0px 0px 0px 2px $color-azul4;\n  }\n\n  & #input-editor-custom:focus-within,\n  & #input-editor-custom:active,\n  & #input-editor-custom:focus-visible {\n    & .ql-toolbar {\n      display: block;\n    }\n  }\n\n  & .btn-upload-file-chat {\n    &.p-button:focus {\n      box-shadow: none !important;\n    }\n  }\n\n  & .btn-send-message button {\n    padding-right: 16px;\n    outline: none !important;\n    box-shadow: none !important;\n    transition: 0.2s ease-in-out;\n    border-radius: 0px;\n    padding: 0 20px 0 12px;\n    border: 0px;\n    border-left: 1px solid $color-cinza2;\n    & i:hover {\n      color: $color-azul4 !important;\n    }\n  }\n}\n\n#input-editor-custom {\n  font-family: $font-family-sans-serif;\n  display: flex;\n  flex-direction: column-reverse;\n\n  & .ql-editor {\n    border: none;\n    color: $color-cinza4;\n    font-weight: 400;\n    padding-left: 16px;\n    border-radius: 12px;\n    font-size: $font-size-md;\n    word-break: break-all;\n\n    & p {\n      color: $color-cinza4;\n    }\n\n    &::before {\n      color: $color-cinza4;\n      font-style: normal;\n    }\n\n    & img {\n      max-height: 120px !important;\n    }\n  }\n\n  & .ql-toolbar {\n    display: none;\n    padding-top: 0;\n  }\n\n  & .ql-toolbar,\n  & .ql-container {\n    border: none;\n  }\n}\n\n.checkbox-annul {\n  appearance: none;\n  -webkit-appearance: none;\n\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n\n  border: 1.5px solid #353535;\n  border-radius: 2px;\n  background-color: #fff;\n\n  position: relative;\n}\n\n.checkbox-annul {\n  appearance: none !important;\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n\n  border: 1px solid #263874;\n  border-radius: 2px;\n  background: #ffffff;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  position: relative;\n}\n\n.checkbox-annul:checked {\n  background: #498ef2;\n  border-color: #498ef2;\n}\n\n.checkbox-annul:checked::after {\n  content: \"✓\";\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.box-local-desembarque {\n  background: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.box-local-desembarque .row {\n  row-gap: 16px;\n}\n\n.box-local-desembarque .form-group {\n  margin-bottom: 0;\n}\n\n.checkbox-container {\n  background: #fff;\n  padding: 24px;\n  border-radius: 12px;\n  //height: 220px;\n  height: auto;\n}\n\n.checkbox-container-title {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  color: $color-azul2;\n  margin-bottom: 8px;\n}\n\n.df-ot0055-background {\n  background-color: #f5f5f5;\n}\n\n.df-ot0055-page {\n  background: transparent;\n}\n\n.df-ot0055-page-func {\n  background: #ffffff;\n\n  &.page-content {\n    padding: 24px !important;\n  }\n\n  > .dataTable-custom-primary.container-fluid {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n\n.checkbox-scroll {\n  height: 165px;\n  overflow-y: auto;\n\n  scrollbar-width: thin;\n  scrollbar-color: #9a9a9a transparent;\n}\n\n.checkbox-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.checkbox-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.checkbox-scroll::-webkit-scrollbar-thumb {\n  background: #9b9b9b;\n  border-radius: 999px;\n}\n\n.checkbox-scroll::-webkit-scrollbar-thumb:hover {\n  background: #7f7f7f;\n}\n\n.checkbox-scroll::-webkit-scrollbar-button {\n  display: none;\n}\n\n.df-ot0086-page {\n  input[type=\"time\"] {\n    border-radius: 12px !important;\n  }\n}\n\n.input-time-group {\n  position: relative;\n\n  & .input-time-popup {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 9999;\n    display: flex;\n    width: 180px;\n    margin-top: 4px;\n\n    background: #ffffff;\n    border: 1px solid #a8a8a8;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n\n  & .input-time-column {\n    width: 50%;\n    max-height: 220px;\n    overflow-y: auto;\n\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #a8a8a8;\n      border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n  }\n\n  & .input-time-column-left {\n    border-right: 1px solid #e9ecef;\n  }\n\n  & .input-time-item {\n    padding: 8px;\n    text-align: center;\n    cursor: pointer;\n    color: #263874;\n    user-select: none;\n    transition:\n      background-color 0.15s ease,\n      color 0.15s ease;\n\n    &:hover {\n      background: #c1e0ff;\n    }\n\n    &.input-time-item-selected {\n      background: #263874;\n      color: #ffffff;\n    }\n  }\n}\n\n.grid-horarios .mb-3 {\n  margin-bottom: 24px !important;\n}\n","//\n// _demos.scss\n//\n\n\n// Lightbox\n\n.mfp-popup-form {\n  max-width: 1140px;\n}\n\n// Modals\n\n.bs-example-modal {\n  position: relative;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  z-index: 1;\n  display: block;\n}\n\n// Icon demo ( Demo only )\n.icon-demo-content {\n  color: $gray-500;\n\n  i {\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    line-height: 36px;\n    font-size: 22px;\n    color: $gray-600;\n    border: 2px solid $gray-300;\n    border-radius: 4px;\n    transition: all 0.4s;\n    text-align: center;\n    margin-right: 16px;\n    vertical-align: middle;\n  }\n\n  .col-lg-4 {\n    margin-top: 24px;\n\n    &:hover {\n      i {\n        color: $white;\n        background-color: $primary;\n        border-color: $primary;\n      }\n    }\n  }\n}\n\n.icon-demo-content-dripicons {\n  color: $gray-500;\n\n  i {\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    line-height: 43px;\n    font-size: 22px;\n    color: $gray-600;\n    border: 2px solid $gray-300;\n    border-radius: 4px;\n    transition: all 0.4s;\n    text-align: center;\n    margin-right: 16px;\n    vertical-align: middle;\n  }\n\n  .col-lg-4 {\n    margin-top: 24px;\n\n    &:hover {\n      i {\n        color: $white;\n        background-color: $primary;\n        border-color: $primary;\n      }\n    }\n  }\n}\n\n// Grid\n\n.grid-structure {\n  .grid-container {\n    background-color: $gray-100;\n    margin-top: 10px;\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    padding: 10px 20px;\n  }\n}\n\n// card radio\n\n.card-radio {\n  background-color: $card-bg;\n  border: 2px solid $card-border-color;\n  border-radius: $border-radius;\n  padding: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.card-radio-label {\n  display: block;\n}\n\n.card-radio-input {\n  display: none;\n  &:checked + .card-radio {\n    border-color: $primary !important;\n  }\n}\n\n.navs-carousel {\n  .owl-nav {\n    margin-top: 16px;\n    button {\n      width: 30px;\n      height: 30px;\n      line-height: 28px !important;\n      font-size: 20px !important;\n      border-radius: 50% !important;\n      background-color: rgba($primary, 0.25) !important;\n      color: $primary !important;\n      margin: 4px 8px !important;\n    }\n  }\n}\n","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .vertical-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-header,\n    .footer {\n        display: none !important;\n    }\n    .card-body,\n    .main-content,\n    .right-bar,\n    .page-content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card{\n        border: 0;\n    }\n}",".avatar-wrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.avatar-img {\n  object-fit: cover;\n  border-radius: 50%;\n  transition: opacity .2s ease;\n}\n.avatar-upload {\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity .2s ease;\n}\n.upload-icon {\n  color: #fff;\n}\n.avatar-wrapper:hover .avatar-upload {\n  opacity: 1;\n}\n.avatar-wrapper:hover .avatar-img {\n  opacity: .6;\n}\n\n.avatar-modal .modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.avatar-modal {\n  max-width: 650px !important;  \n  width: 100% !important;\n}\n\n.avatar-modal .modal-body .rounded-circle {\n  width: 300px;\n  height: 300px;\n  object-fit: cover;\n}\n\n.avatar-modal-margem{\n    margin-left: 100px;\n    margin-right: 100px;\n}\n\n.crop-container {\n  width: 300px;  \n  height: 300px;\n  background: #ffffff; \n  position: relative;\n  overflow: hidden;\n}\n\n.avatar-modal .modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n\n.iframe-wrapper {\n  width: 725px !important;\n  height: 456px !important; \n  padding: 16px;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.iframe-avatar {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.modal-avatar-iframe .modal-dialog {\n  max-width: 725px !important;\n  margin: 0 auto !important;\n}\n\n.modal-avatar-iframe .modal-content {\n  border-radius: 12px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  background: transparent !important;\n  border: none !important;\n}\n\n\n\nbody.iframe-avatar-mode .page-content {\n  height: 456px !important;\n  min-height: 456px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n}\n","\n// \n// tooltip.scss\n//\n\n\n.tooltip-custom .tooltip-inner {\n  background-color: #fff;\n  color: #444;\n  border: 1px solid #ddd;\n}\n\n.tooltip-custom.bs-tooltip-bottom .arrow::before {\n  border-bottom-color: #fff;\n}\n\n.tooltip-custom .bs-tooltip-auto .arrow::before {\n  border-bottom-color: #fff;\n}\n\n.tooltip-custom .bs-tooltip-auto .tooltip-inner {\n  text-align: left;\n}\n\n.tooltip-table-dinamic{\n  & .tooltip-arrow{\n    display: none;\n  }\n\n  & .bs-tooltip-auto{\n    padding-bottom: 5px;\n    & .tooltip-inner{\n      background-color: white;\n      color: black;\n      font-size: 10px;\n    }\n  }\n}\n\n.tooltip-pre-filter{\n  & .tooltip-arrow{\n    display: none;\n  }\n\n  & .bs-tooltip-auto{\n    padding: 5px;\n    & .tooltip-inner{\n      background-color: white;\n      color: black;\n      font-size: 10px;\n\n    }\n  }\n}\n\n.tooltip-info-search{\n  & .tooltip-arrow{\n    display: none;\n  }\n\n  & .bs-tooltip-auto{\n    padding: 5px;\n    & .tooltip-inner{\n      background-color: white;\n      border: 1px solid $light_gray_05;\n      color: $color-azul1;\n      font-size: 10px;\n\n    }\n  }\n}","//\n// _notificationModal.scss\n//\n\n#notification-modal {\n\n    max-width: 380px; \n  \n\n  & .notification-div-icon {\n    margin-top: 10px;\n    display: flex;          \n    justify-content: center;      \n    align-items: center;            \n    margin: 0 auto 1rem;         \n    border-radius: 50%;\n    padding: 34px;\n    width: 75px;\n    height: 75px;                \n\n    & i {\n      color: $white;\n      font-size: 30px;\n    }\n  }\n\n  & .notification-msg {\n      font-family: $font-family-sans-serif;      \n      color: $dark_gray_primary;            \n      line-height: 1.4;         \n      \n  }\n\n}\n",".modal-direct-render {\n  margin: 0 auto;\n  max-width: none;\n\n  & .modal-header {\n    padding: 16px 24px;\n    border-color: $gray_primary;\n  }\n\n  & .modal-body {\n    padding: 20px 24px;\n  }\n\n  .select-filter-custom.select-filter-custom--is-disabled {\n    .select-filter-custom__control {\n      background-color: #e9ecef !important;\n      cursor: not-allowed;\n    }\n    .select-filter-custom__indicator {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n  }\n}\n\n.modal-dinamic-table-simple {\n  margin: 0 auto;\n  height: 100%;\n  align-content: center;\n  max-width: none;\n  width: 860px;\n\n  & .modal-header {\n    padding: 24px;\n    border-color: $gray_primary;\n  }\n\n  & .modal-body {\n    padding: 16px 24px 24px 24px;\n    height: calc(100% - 100px);\n  }\n\n  & .message-content-box-right {\n    display: flex;\n    justify-content: flex-end;\n\n    & .message-content-box {\n      background-color: #e5f3fd !important;\n    }\n  }\n\n  & .message-content-box {\n    background-color: $color-branco2;\n    padding: 16px;\n    border-radius: 12px;\n    margin-bottom: 5px;\n    width: auto;\n    max-width: 66%;\n    overflow-wrap: break-word;\n\n    & p,\n    & > div {\n      color: $color-cinza5;\n      font-weight: 400;\n      font-size: 14px;\n      margin: 0;\n    }\n  }\n\n  &.type-VIEW_MESSAGE {\n    & .modal-body {\n      display: flex;\n      flex-direction: column;\n\n      & .photo-user img {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        overflow: hidden;\n        object-fit: cover;\n      }\n\n      & .container-flow {\n        height: 90px;\n      }\n\n      & .list-messages {\n        overflow: auto;\n        flex-grow: 1;\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: end;\n        max-height: 422px;\n\n        & .divider-no-view {\n          display: flex;\n          align-items: center;\n          & hr {\n            color: $color-azul4;\n            border-width: 2px;\n            width: 100%;\n          }\n          & .label {\n            background-color: white;\n            margin: 0;\n            width: 180px;\n            font-size: 14px;\n            color: $color-azul4;\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n\n  &.type-VIEW_TIMELINE {\n    height: auto !important;\n    max-height: 90vh;\n\n    & .modal-body {\n      height: calc(90vh - 150px) !important;\n      max-height: calc(90vh - 150px) !important;\n      overflow-y: auto;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    & .modal-header-content {\n      background: #f8f9fa;\n      border-bottom: 1px solid #e9ecef;\n      padding: 20px;\n      border-radius: 8px 8px 0 0;\n    }\n\n    & .modal-body-content {\n      padding: 20px;\n      background: #ffffff;\n    }\n\n    & .modal-content-custom {\n      background: #ffffff;\n      border-radius: 8px;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n\n      & .document-history-header {\n        margin-bottom: 0;\n        border-radius: 0;\n        box-shadow: none;\n      }\n\n      & .vertical-timeline {\n        margin-top: 20px;\n      }\n\n      & .timeline-section {\n        margin-bottom: 15px;\n      }\n\n      & .timeline-event {\n        padding: 12px 15px;\n      }\n\n      & .timeline-step {\n        width: 35px;\n        height: 35px;\n      }\n\n      & .timeline-dot {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n}\n\n.is-modal-page .page-content {\n  padding: 0 !important;\n}\n\n/* modal container */\n.custom-modal {\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.icon-warning {\n  width: 80px;\n  height: 80px;\n  background: #f4c430;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: white;\n  font-size: 32px;\n}\n\n.modal-title-custom {\n  font-weight: 600;\n  color: #1f2a44;\n  margin-bottom: 10px;\n}\n\n.modal-subtext {\n  color: #6c757d;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n.btn-cancel {\n  background: transparent;\n  border: none;\n  color: #1f2a44;\n  font-weight: 500;\n  padding: 10px 16px;\n}\n\n.btn-confirm {\n  background: #2f3e6e;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: 0.2s;\n}\n\n.btn-confirm:hover {\n  background: #24325a;\n}\n\n.icon-success {\n  width: 80px;\n  height: 80px;\n  background: #4caf50;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: white;\n  font-size: 32px;\n}\n\n.icon-error {\n  width: 80px;\n  height: 80px;\n  background: #f44336;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: white;\n  font-size: 32px;\n}\n\n.success-alert-custom {\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  padding: 18px 24px;\n\n  background: #eef8ea;\n  border: none;\n  border-radius: 4px;\n\n  i {\n    color: #43b02a;\n    font-size: 24px;\n  }\n\n  .success-title {\n    color: #178a1f;\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  .success-message {\n    color: #6c757d;\n    font-size: 16px;\n    font-weight: 400;\n  }\n}\n\n.error-alert-custom-box {\n  display: flex;\n  align-items: center;\n\n  background: #fbe1e1;\n  border-radius: 4px;\n\n  padding: 16px 18px;\n\n  color: #ec221f;\n\n  width: fit-content;\n  max-width: 100%;\n}\n\n.error-alert-custom-box .error-icon {\n  color: #ec221f;\n\n  font-size: 18px;\n\n  flex-shrink: 0;\n}\n\n.error-alert-custom-box .error-bold {\n  color: #ec221f;\n\n  font-weight: 700;\n\n  margin-right: 6px;\n}\n\n.error-alert-custom-box span {\n  color: #ec221f;\n\n  font-size: 14px;\n\n  line-height: 20px;\n}\n\n// =====================\n// Input Group de Data (RotaFreteForm)\n// =====================\n.rota-date-input-group {\n  display: flex;\n  align-items: stretch;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #ced4da;\n\n  &:focus-within {\n    border-color: #263973;\n    box-shadow: 0 0 0 0.15rem rgba(38, 57, 115, 0.15);\n  }\n\n  .rota-date-wrapper {\n    flex: 1;\n    display: flex;\n    align-items: center;\n  }\n\n  .rota-date-input {\n    border: none;\n    border-radius: 8px 0 0 8px;\n    padding: 0.45rem 0.75rem;\n    font-size: 14px;\n    color: #495057;\n    width: 100%;\n\n    &:focus {\n      box-shadow: none;\n      border: none;\n      outline: none;\n    }\n\n    &::placeholder {\n      color: #adb5bd;\n    }\n\n    &:disabled {\n      background-color: #e9ecef;\n      opacity: 1;\n      cursor: not-allowed;\n    }\n  }\n\n  .rota-date-addon {\n    background-color: #fff;\n    border-left: 1px solid #ced4da;\n    border-radius: 0 8px 8px 0;\n    padding: 0 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n}\n\n// =====================\n// RotaFreteForm - Layout Grid\n// =====================\n.rota-form-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.rota-form-section {\n  &:not(:last-child) {\n    margin-bottom: 24px;\n  }\n}\n\n.rota-section-title {\n  font-weight: 700;\n  color: #1f2a44;\n  font-size: 16px;\n  margin-bottom: 12px;\n}\n\n.rota-form-grid {\n  display: grid;\n  row-gap: 16px;\n}\n\n.rota-grid-2col {\n  grid-template-columns: 1fr 1fr;\n  column-gap: 16px;\n}\n\n.rota-grid-3col {\n  grid-template-columns: 1fr 1fr 1fr;\n  column-gap: 16px;\n}\n\n.rota-grid-uf-municipio {\n  grid-template-columns: 35% 1fr;\n  column-gap: 16px;\n}\n\n.rota-field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n\n  // Label externo: zerar margin-bottom para colar no campo\n  & > label {\n    margin-bottom: 2px;\n  }\n\n  // Zerar margens do FormGroup do ComboBoxAutomatic\n  & > .form-group,\n  & > div > .form-group {\n    margin-bottom: 0;\n\n    // Esconder label vazia do ComboBoxAutomatic (title=\"\")\n    & > label:empty {\n      display: none;\n      margin: 0;\n      padding: 0;\n      height: 0;\n    }\n  }\n\n  // Zerar margem do wrapper div do TranspaleStringToComponente\n  & > .transpale-wrapper {\n    margin-bottom: 0;\n  }\n\n  & > small,\n  & > .rota-field-hint {\n    margin-top: 0;\n  }\n}\n\n.rota-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 16px;\n  margin-top: 32px;\n}\n\n// =====================\n// Histórico da Rota (DF_LO0025)\n// =====================\n.historico-rota-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.historico-header-card {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  .historico-flow-section {\n    padding: 8px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .historico-context-section {\n    padding: 8px 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    .card-context-dynamic-wrapper {\n      width: 100%;\n    }\n  }\n}\n\n.historico-accordion-wrapper {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 8px;\n}\n\n.historico-accordion-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #dbeafe;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #bfdbfe;\n  }\n}\n\n.historico-accordion-body {\n  padding: 16px 8px 8px 8px;\n}\n\n.historico-timeline {\n  display: flex;\n  flex-direction: column;\n}\n\n.historico-timeline-item {\n  display: flex;\n  gap: 16px;\n  position: relative;\n}\n\n.historico-timeline-left {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.historico-timeline-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.historico-timeline-line {\n  width: 2px;\n  flex-grow: 1;\n  min-height: 24px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  opacity: 0.4;\n}\n\n.historico-timeline-content {\n  flex-grow: 1;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 4px 0;\n  margin-bottom: 12px;\n}\n\n.historico-timeline-badge {\n  display: inline-flex;\n  align-items: center;\n  background: #f1f5f9;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 14px;\n  color: #334155;\n\n  i {\n    color: #3B82F6;\n  }\n}\n\n// Status icons no CardContext\n.status-active {\n  color: #22c55e;\n  font-size: 18px;\n}\n\n.status-inactive {\n  color: #ef4444;\n  font-size: 18px;\n}\n\n// =====================\n// Tela de Confirmação (RotaFreteForm - criar/editar)\n// =====================\n.rota-confirm-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 40px 24px;\n  max-width: 400px;\n  margin: 0 auto;\n}\n","//\n// _calendar.scss\n//\n\n.calendar-multi-month {\n  display: flex;\n  gap: 32px;\n  background: $color-branco2;\n  border-radius: 12px;\n  padding: 37px 20px;\n\n  .calendar-month {\n    flex: 1;\n    min-width: 0;\n\n    .calendar-month-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      font-weight: 600;\n      font-size: 16px;\n      color: $color-azul2;\n      margin-bottom: 20px;\n\n      .calendar-nav-btn {\n        background: transparent;\n        border: 0;\n        padding: 4px 8px;\n        color: $color-azul2;\n        cursor: pointer;\n\n        &[disabled] {\n          display: none;\n        }\n      }\n    }\n\n    .calendar-weekdays {\n      display: grid;\n      grid-template-columns: repeat(7, 1fr);\n      text-align: center;\n      color: $light_blue_01;\n      font-size: 14px;\n      font-weight: 700;\n      margin-bottom: 8px;\n\n      & span{\n        // width: 30px;\n      /* height: 37px; */\n        padding: 0;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n          }\n    }\n\n    .calendar-days {\n      display: grid;\n      grid-template-columns: repeat(7, 1fr);\n      gap: 4px;\n    }\n\n    .calendar-day {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 100%;\n      max-width: 30px;\n      height: 30px;\n      max-height: 30px;\n      margin: 0 auto;\n      border-radius: 50%;\n      font-size: 13px;\n      color: $blue_primary;\n      cursor: pointer;\n      user-select: none;\n      transition: background-color 0.15s, color 0.15s;\n\n      &:not(.calendar-day--disabled):not(.calendar-day--past):not(.calendar-day--other-month):hover {\n        background-color: $light_blue_02;\n        color: $blue_primary;\n      }\n\n      &--selected {\n        background-color: $blue_primary;\n        color: #fff;\n        font-weight: 600;\n      }\n\n      &--disabled {\n        background-color: $color-cinza2;\n        color: $gray_03;\n        cursor: default;\n      }\n\n      &--past {\n        color: $color-cinza2-5;\n        cursor: default;\n      }\n\n      &--other-month {\n        color: $color-cinza2;\n        cursor: default;\n      }\n    }\n  }\n}\n",".text-color-azul4-hover {\n  &:hover {\n    color: $color-azul4 !important;\n  }\n}\n","\n//\n// Bootstrap touchspin\n//\n\n\n.bootstrap-touchspin{\n    &.input-group{\n      &>.input-group-prepend{\n        &>.btn, &>.input-group-text{\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        }\n      }\n    }\n  \n    &.input-group{\n      &>.input-group-append{\n        &>.btn, &>.input-group-text{\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n      }\n    }\n  }","// \n// calendar.scss\n//\n\n.fc-toolbar {\n  h2 {\n      font-size: $font-size-md;\n      line-height: 30px;\n      text-transform: uppercase;\n  }\n}\n\n.fc {\n  th.fc-widget-header {\n      background: $light;\n      font-size: 13px;\n      line-height: 20px;\n      padding: 10px 0;\n      text-transform: uppercase;\n      font-weight: $font-weight-semibold;\n  }\n}\n\n.fc-unthemed{\n  .fc-content, \n  .fc-divider, \n  .fc-list-heading td, \n  .fc-list-view, \n  .fc-popover, \n  .fc-row, \n  tbody, \n  td, \n  th, \n  thead{\n      border-color: $light;\n  }\n  td.fc-today {\n      background: lighten($gray-200, 4%);\n  }\n}\n\n.fc-button {\n  background: $card-bg;\n  border-color: $border-color;\n  color: $gray-700;\n  text-transform: capitalize;\n  box-shadow: none;\n  padding: 6px 12px !important;\n  height: auto !important;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  background-color: $primary;\n  color: $white;\n  text-shadow: none;\n}\n\n.fc-event {\n  border-radius: 2px;\n  border: none;\n  cursor: move;\n  font-size: 0.8125rem;\n  margin: 5px 7px;\n  padding: 5px 5px;\n  text-align: center;\n}\n\n#external-events .external-event {\n  text-align: left!important;\n  padding: 8px 16px;\n}\n\n.fc-event, .fc-event-dot{\n  background-color: $primary;\n}\n\n.fc-event .fc-content{\n  color: $white;\n}\n\n.fc {\n  .table-bordered {\n    td, th {\n      border-color: $table-group-separator-color;\n    }\n  }\n  \n  .fc-toolbar {\n    @media (max-width: 575.98px) {\n      display: block;\n    }\n    \n      h2 {\n          font-size: $font-size-md;\n          line-height: 30px;\n          text-transform: uppercase;\n      }\n\n      @media (max-width: 767.98px) {\n\n          .fc-left,\n          .fc-right,\n          .fc-center {\n              float: none;\n              display: block;\n              text-align: center;\n              clear: both;\n              margin: 10px 0;\n          }\n\n          >*>* {\n              float: none;\n          }\n\n          .fc-today-button {\n              display: none;\n          }\n      }\n      \n      .btn {\n          text-transform: capitalize;\n      }\n\n  }\n}\n.fc-bootstrap .fc-today.alert-info{\n  background-color: $gray-300;\n}\n\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\n  background-color: $black !important;\n}\n\n// RTL\n[dir=\"rtl\"] .fc-header-toolbar {\n  direction: ltr !important;\n}\n\n[dir=\"rtl\"] .fc-toolbar>*>:not(:first-child) {\n  margin-left: .75em;\n}\n\n\n\n","//\n// colorpicker.scss\n//\n\n.sp-container {\n    background-color: $dropdown-bg;\n    button {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.71094rem;\n        border-radius: 0.2rem;\n        font-weight: 400;\n        color: $dark;\n\n        &.sp-palette-toggle {\n            background-color: $light;\n        }\n\n        &.sp-choose {\n            background-color: $success;\n            margin-left: 5px;\n            margin-right: 0;\n        }\n    }\n}\n\n.sp-palette-container {\n    border-right: 1px solid $border-color;\n}\n\n.sp-input {\n    background-color: $input-bg;\n    border-color: $input-border-color !important;\n    color: $input-color;\n    &:focus {\n        outline: none;\n    }\n}\n.sp-colorize-container {\n    &.sp-add-on {\n        border: $input-border-width solid $input-border-color !important;\n    }\n}\n\n.sp-original-input-container {\n    .sp-add-on {\n        border-top-right-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n        border-top-left-radius: 4px !important;\n        border-bottom-left-radius: 4px !important;\n    }\n}\n\ninput.spectrum.with-add-on {\n    border: 1px solid $input-border-color;\n    border-left: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: $input-border-radius;\n    border-bottom-right-radius: $input-border-radius;\n}\n","[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n  border-right: 1px solid #D7D7D7;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 6px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}","//\n// datatable.scss\n\n\n.dataTables_wrapper {\n  &.container-fluid {\n    padding: 0;\n  }\n}\n\ndiv.dataTables_wrapper {\n  div.dataTables_filter {\n    text-align: right;\n\n    @media (max-width: 767px) {\n      text-align: center;\n    }\n\n\n    input {\n      margin-left: 0.5em;\n      margin-right: 0;\n    }\n  }\n}\n\n.datatable {\n  td {\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\ndiv.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"] {\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n}\n\n\ntable.dataTable {\n  border-collapse: collapse !important;\n  margin-bottom: 15px !important;\n\n  // Change icons view\n  thead {\n\n    .sorting,\n    .sorting_asc,\n    .sorting_desc,\n    .sorting_asc_disabled,\n    .sorting_desc_disabled {\n      &:before {\n        left: auto;\n        right: 0.5rem;\n        content: \"\\F0360\";\n        font-family: \"Material Design Icons\";\n        font-size: 1rem;\n        top: 9px;\n\n\n      }\n\n      &:after {\n        left: auto;\n        right: 0.5em;\n        content: \"\\F035D\";\n        font-family: \"Material Design Icons\";\n        top: 15px;\n        font-size: 1rem;\n      }\n    }\n\n    tr {\n\n      th,\n      td {\n\n        &.sorting_asc,\n        &.sorting_desc,\n        &.sorting {\n          padding-left: 12px;\n          padding-right: 30px;\n        }\n      }\n    }\n  }\n\n  tbody {\n    // Multi select table\n\n    > tr.selected, >tr>.selected {\n        background-color: rgba($primary,.2);\n        \n        td {\n            border-color: rgba($primary,.2);\n            color: $primary;\n        }\n    }\n    td {\n        &:focus {\n            outline: none !important;\n        }\n    }\n    // Key Tables\n    th.focus,td.focus{\n        outline: 2px solid $primary !important;\n        outline-offset: -1px;\n        background-color: rgba($primary, 0.15);\n    }\n}\n}\n\n.dataTables_info {\n  font-weight: $font-weight-semibold;\n}\n\n\n// Responsive data table\ntable.dataTable.dtr-inline.collapsed {\n  >tbody {\n    >tr[role=row] {\n\n      >td,\n      >th {\n        &:first-child {\n          &:before {\n            box-shadow: $box-shadow-lg;\n            background-color: $success;\n            bottom: auto;\n          }\n        }\n      }\n    }\n\n    >tr.parent {\n\n      >td,\n      >th {\n        &:first-child {\n          &:before {\n            background-color: $danger;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Data Table copy button\ndiv.dt-button-info {\n  background-color: $primary;\n  border: none;\n  color: $white;\n  box-shadow: none;\n  border-radius: 3px;\n  text-align: center;\n  z-index: 21;\n\n  h2 {\n    border-bottom: none;\n    background-color: rgba($white, 0.2);\n    color: $white;\n  }\n}\n\n@include media-breakpoint-down(md) {\n\n  li.paginate_button.previous,\n  li.paginate_button.next {\n    display: inline-block;\n    font-size: 1.5rem;\n  }\n\n  li.paginate_button {\n    display: none;\n  }\n\n  .dataTables_paginate {\n    ul {\n      text-align: center;\n      display: block;\n      margin: $spacer 0 0 !important;\n    }\n  }\n\n  div.dt-buttons {\n    display: inline-table;\n    margin-bottom: $spacer;\n  }\n\n  .sorting_1 {\n    cursor: pointer;\n  }\n}\n\n// Active status\n.activate-select {\n  .sorting_1 {\n    background-color: $gray-100;\n  }\n}\n\n\n\n\n\n// datatable\n\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n}\n\n\n\n.table,\ntable {\n  &.dataTable {\n    &.dtr-inline.collapsed>tbody>tr>td {\n      position: relative;\n\n      &.dtr-control {\n        padding-left: 30px;\n\n        &:before {\n          top: 64%;\n          left: 5px;\n          height: 14px;\n          width: 14px;\n          margin-top: -14px;\n          display: block;\n          position: absolute;\n          color: $white;\n          border: 2px solid $white;\n          border-radius: 14px;\n          box-sizing: content-box;\n          text-align: center;\n          text-indent: 0 !important;\n          line-height: 12px;\n          content: '+';\n          background-color: $primary;\n        }\n      }\n    }\n  }\n}","\n//\n// Datepicker\n//\n\n.datepicker {\n  border: 1px solid $gray-100;\n  padding: 8px;\n  z-index: 999 !important;\n  table{\n    tr{\n      th{\n        font-weight: 500;\n      }\n      td{\n        &.active, &.active:hover, .active.disabled, &.active.disabled:hover,\n        &.today,  &.today:hover, &.today.disabled, &.today.disabled:hover, \n        &.selected, &.selected:hover, &.selected.disabled, &.selected.disabled:hover{\n          background-color: $primary !important;\n          background-image: none;\n          box-shadow: none;\n          color: $white !important;\n        }\n\n        &.day.focused,\n        &.day:hover,\n        span.focused,\n        span:hover {\n            background: $gray-200;\n        }\n\n        &.new,\n        &.old,\n        span.new,\n        span.old {\n            color: $gray-500;\n            opacity: 0.6;\n        }\n\n        &.range, &.range.disabled, &.range.disabled:hover, &.range:hover{\n            background-color: $gray-300;\n        }\n      }\n    }\n  }\n}\n\n.table-condensed{\n  >thead>tr>th, >tbody>tr>td {\n    padding: 7px;\n  }\n}","/* Flot chart */\n.flot-charts-height {\n  height: 320px;\n}\n\n.flotTip {\n  padding: 8px 12px;\n  background-color: $dropdown-bg !important;\n  z-index: 100;\n  color: $gray-600 !important;\n  box-shadow: $box-shadow;\n  border-radius: 4px;\n}\n\n.legendLabel {\n  color: $gray-500;\n}\n\n.legend {\n  div {\n    background-color: transparent !important;\n  }\n}\n","//\n// Form editors.scss\n//\n\n.ql-container {\n    border-bottom-right-radius: 0.25rem !important;\n    border-bottom-left-radius: 0.25rem !important;\n    font-family: $font-family-base;\n\n    &.ql-snow {\n        border-color: $input-border-color;\n    }\n}\n\n.ql-bubble {\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n}\n\n.ql-toolbar {\n    border-top-left-radius: 0.25rem !important;\n    border-top-right-radius: 0.25rem !important;\n    font-family: $font-family-base !important;\n    span {\n        outline: none !important;\n        color: $body-color;\n\n        &:hover {\n            color: $primary !important;\n        }\n    }\n\n    &.ql-snow {\n        border-color: $input-border-color;\n\n        .ql-picker.ql-expanded {\n            .ql-picker-label {\n                border-color: transparent;\n            }\n        }\n    }\n}\n\n.ql-editing{\n    right: 0 !important;\n    top: 0 !important;\n    left: auto !important;\n\n}\n\n.ql-snow .ql-tooltip {\n    background-color: $dropdown-bg;\n    color: $dropdown-link-color;\n    box-shadow: $dropdown-box-shadow;\n    border: $dropdown-border-width solid $dropdown-border-color;\n     \n    input{\n        background: $input-bg;\n        color: $input-color;\n        border-color: $input-focus-border-color !important;\n    }\n}\n.ql-snow {\n    .ql-stroke,\n    .ql-script,\n    .ql-strike svg {\n        stroke: $body-color;\n    }\n    .ql-fill {\n        fill: $body-color;\n    }\n}\n\n.ql-snow {\n    .ql-picker-options {\n        background-color: $dropdown-bg;\n        border-color: $dropdown-border-color !important;\n    }\n}\n","//\n// Form-Upload\n//\n\n/* Dropzone */\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed $gray-400;\n  background: $card-bg;\n  border-radius: 6px;\n\n  .dz-message {\n    font-size: 24px;\n    width: 100%;\n    text-align: center;\n    padding: 30px;\n    &:focus {\n      outline: none;\n    }\n  }\n}\n","//\n// Form Wizard\n//\n\n// twitter-bs-wizard\n\n.twitter-bs-wizard {\n\n    .twitter-bs-wizard-nav {\n        position: relative;\n\n        &:before {\n            content: \"\";\n            width: 100%;\n            height: 2px;\n            background-color: $gray-300;\n            position: absolute;\n            left: 0;\n            top: 26px;\n        }\n\n        .step-number {\n            display: inline-block;\n            width: 38px;\n            height: 38px;\n            line-height: 34px;\n            border: 2px solid $primary;\n            color: $primary;\n            text-align: center;\n            border-radius: 50%;\n            position: relative;\n            background-color: $card-bg;\n\n            @media (max-width: 991.98px) {\n                display: block;\n                margin: 0 auto 8px !important;\n            }\n        }\n\n        .nav-link {\n            .step-title {\n                display: block;\n                margin-top: 8px;\n                font-weight: $font-weight-bold;\n\n                @media (max-width: 575.98px) {\n                    display: none;\n                }\n            }\n\n            &.active {\n                background-color: transparent;\n                color: $gray-700;\n\n                .step-number {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n        }\n    }\n\n    .twitter-bs-wizard-pager-link {\n        padding-top: 24px;\n        padding-left: 0;\n        list-style: none;\n        margin-bottom: 0;\n\n        li {\n            display: inline-block;\n\n            a {\n                display: inline-block;\n                padding: .47rem .75rem;\n                background-color: $primary;\n                color: $white;\n                border-radius: .25rem;\n            }\n\n            &.disabled {\n                a {\n                    cursor: not-allowed;\n                    background-color: lighten($primary, 8%);\n                }\n            }\n\n            &.next {\n                float: right;\n            }\n        }\n    }\n}\n\n.twitter-bs-wizard-tab-content {\n    padding-top: 24px;\n    min-height: 262px;\n}","\n//\n// Google map\n//\n\n.gmaps, .gmaps-panaroma {\n  height: 300px;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: $font-size-md;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n  \n}","\n//\n// Parsley\n//\n\n.error {\n  color: $danger;\n}\n\n.parsley-error {\n  border-color: $danger;\n}\n\n.parsley-errors-list {\n  display: none;\n  margin: 0;\n  padding: 0;\n  &.filled {\n    display: block;\n  }\n  > li {\n    font-size: 12px;\n    list-style: none;\n    color: $danger;\n    margin-top: 5px;\n  }\n}","//\n// Range slider\n//\n\n.irs {\n    .irs--square {\n        cursor: pointer;\n    }\n}\n\n.irs--round {\n    .irs-bar,\n    .irs-to,\n    .irs-from,\n    .irs-single {\n        background: $primary !important;\n        font-size: 11px;\n    }\n\n    .irs-to,\n    .irs-from,\n    .irs-single {\n        top: 5px;\n        &:before {\n            display: none;\n        }\n    }\n\n    .irs-line {\n        background: $gray-300;\n        border-color: $gray-300;\n        cursor: pointer;\n    }\n    .irs-grid-text {\n        font-size: 11px;\n        color: $gray-400;\n    }\n    .irs-min,\n    .irs-max {\n        color: $gray-500;\n        background: $gray-300;\n        font-size: 11px;\n    }\n\n    .irs-handle {\n        border: 2px solid $primary;\n        width: 12px;\n        height: 12px;\n        top: 31px;\n        background-color: $card-bg !important;\n        cursor: pointer;\n        &:active {\n            cursor: pointer;\n        }\n    }\n}\n","\n//\n// Rating\n//\n\n.symbol{\n  border-color: $card-bg;\n}\n\n.rating-symbol-background, .rating-symbol-foreground {\n  font-size: 24px;\n}\n\n.rating-symbol-foreground {\n  top: 0px;\n}\n\n.rating-star{\n  > span{\n    display: inline-block;\n    vertical-align: middle;\n\n    &.badge{\n      margin-left: 4px;\n    }\n  }\n}","\n//\n// Responsive Table\n//\n\n.table-rep-plugin {\n  .btn-toolbar {\n    display: block;\n  }\n  .table-responsive {\n    border: none !important;\n  }\n  .btn-group{\n    .btn-default {\n      background-color: $light;\n      color: $dark;\n      border: 1px solid darken($light, 2%);\n      &.btn-primary {\n          background-color: $primary;\n          border-color: $primary;\n          color: $white;\n      }\n  }\n    &.pull-right {\n      float: right;\n      .dropdown-menu {\n        right: 0;\n        transform: none !important;\n        top: 100% !important;\n      }\n    }\n  }\n  tbody {\n    th {\n      font-size: 14px;\n      font-weight: normal;\n    }\n  }\n\n  .checkbox-row {\n    padding-left: 40px;\n    color: $dropdown-color !important;\n\n    &:hover{\n      background-color: lighten($gray-200, 2%) !important;\n    }\n\n    label {\n      display: inline-block;\n      padding-left: 5px;\n      position: relative;\n      &::before {\n        -o-transition: 0.3s ease-in-out;\n        -webkit-transition: 0.3s ease-in-out;\n        background-color: $white;\n        border-radius: 3px;\n        border: 1px solid $gray-300;\n        content: \"\";\n        display: inline-block;\n        height: 17px;\n        left: 0;\n        margin-left: -20px;\n        position: absolute;\n        transition: 0.3s ease-in-out;\n        width: 17px;\n        outline: none !important;\n      }\n      &::after {\n        color: $gray-200;\n        display: inline-block;\n        font-size: 11px;\n        height: 16px;\n        left: 0;\n        margin-left: -20px;\n        padding-left: 3px;\n        padding-top: 1px;\n        position: absolute;\n        top: -1px;\n        width: 16px;\n      }\n    }\n    input[type=\"checkbox\"] {\n      cursor: pointer;\n      opacity: 0;\n      z-index: 1;\n      outline: none !important;\n\n      &:disabled + label {\n        opacity: 0.65;\n      }\n    }\n    input[type=\"checkbox\"]:focus + label {\n      &::before {\n        outline-offset: -2px;\n        outline: none;\n      }\n    }\n    input[type=\"checkbox\"]:checked + label {\n      &::after {\n        content: \"\\f00c\";\n        font-family: 'Font Awesome 5 Free';\n        font-weight: 900;\n      }\n    }\n    input[type=\"checkbox\"]:disabled + label {\n      &::before {\n        background-color: $gray-100;\n        cursor: not-allowed;\n      }\n    }\n    input[type=\"checkbox\"]:checked + label {\n      &::before {\n        background-color: $primary;\n        border-color: $primary;\n      }\n      &::after {\n        color: $white;\n      }\n    }\n  }\n\n  .fixed-solution {\n    .sticky-table-header{\n      top: $header-height !important;\n      background-color: $primary;\n      table{\n        color: $white;\n      }\n    }\n  }\n}\n\nbody[data-layout=\"horizontal\"] {\n  @media (min-width: 992px) {\n    .fixed-solution {\n      .sticky-table-header{\n        top: $header-height + 50px !important;;\n      }\n    }\n  }\n}","//\n// Select 2\n//\n\n.select2-container {\n    display: block;\n    .select2-selection--single {\n        background-color: $input-bg;\n        border: 1px solid $input-border-color;\n        height: 38px;\n        &:focus {\n            outline: none;\n        }\n\n        .select2-selection__rendered {\n            line-height: 36px;\n            padding-left: 12px;\n            color: $input-color;\n        }\n\n        .select2-selection__arrow {\n            height: 34px;\n            width: 34px;\n            right: 3px;\n\n            b {\n                border-color: $gray-500 transparent transparent transparent;\n                border-width: 6px 6px 0 6px;\n            }\n        }\n\n        .select2-selection__placeholder {\n            color: $body-color;\n        }\n    }\n}\n\n[dir=\"rtl\"]{\n    .select2-selection__rendered {\n        text-align: end;\n    }\n}\n\n.select2-container--open {\n    .select2-selection--single {\n        .select2-selection__arrow {\n            b {\n                border-color: transparent transparent $gray-500 transparent !important;\n                border-width: 0 6px 6px 6px !important;\n            }\n        }\n    }\n}\n\n.select2-container--default {\n    .select2-search--dropdown {\n        padding: 10px;\n        background-color: $dropdown-bg;\n        .select2-search__field {\n            border: 1px solid $input-border-color;\n            background-color: $input-bg;\n            color: $gray-600;\n            outline: none;\n        }\n    }\n    .select2-results__option--highlighted[aria-selected] {\n        background-color: $primary;\n    }\n    .select2-results__option[aria-selected=\"true\"] {\n        background-color: $dropdown-link-active-bg;\n        color: $dropdown-link-active-color;\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n}\n\n.select2-results__option {\n    padding: 6px 12px;\n}\n\n.select2-dropdown {\n    border: 1px solid $dropdown-border-color;\n    background-color: $dropdown-bg;\n    box-shadow: $box-shadow;\n}\n\n.select2-search {\n    input {\n        border: 1px solid $gray-300;\n    }\n}\n\n.select2-container {\n    .select2-selection--multiple {\n        min-height: 38px;\n        background-color: $input-bg;\n        border: 1px solid $input-border-color !important;\n\n        .select2-selection__rendered {\n            padding: 2px 10px;\n        }\n        .select2-search__field {\n            border: 0;\n            color: $input-color;\n            &::placeholder {\n                color: $input-color;\n            }\n        }\n        .select2-selection__choice {\n            background-color: $gray-200;\n            border: 1px solid $gray-300;\n            border-radius: 1px;\n            padding: 0 7px;\n        }\n    }\n}\n\n.select2-container--default {\n    &.select2-container--focus {\n        .select2-selection--multiple {\n            border-color: $gray-400;\n        }\n    }\n\n    .select2-results__group {\n        font-weight: $font-weight-semibold;\n    }\n}\n\n// ajax select\n\n.select2-result-repository__avatar {\n    float: left;\n    width: 60px;\n    margin-right: 10px;\n    img {\n        width: 100%;\n        height: auto;\n        border-radius: 2px;\n    }\n}\n\n.select2-result-repository__statistics {\n    margin-top: 7px;\n}\n\n.select2-result-repository__forks,\n.select2-result-repository__stargazers,\n.select2-result-repository__watchers {\n    display: inline-block;\n    font-size: 11px;\n    margin-right: 1em;\n    color: $gray-500;\n\n    .fa {\n        margin-right: 4px;\n\n        &.fa-flash {\n            &::before {\n                content: \"\\f0e7\";\n                font-family: \"Font Awesome 5 Free\";\n            }\n        }\n    }\n}\n\n.select2-results__option--highlighted {\n    .select2-result-repository__forks,\n    .select2-result-repository__stargazers,\n    .select2-result-repository__watchers {\n        color: rgba($white, 0.8);\n    }\n}\n\n.select2-result-repository__meta {\n    overflow: hidden;\n}\n\n// templating-select\n\n.img-flag {\n    margin-right: 7px;\n    height: 15px;\n    width: 18px;\n}\n","//\n// session-timeout.scss\n//\n\n#session-timeout-dialog {\n    .close {\n        display: none;\n    }\n\n    .countdown-holder {\n        color: $danger;\n        font-weight: $font-weight-medium;\n    }\n\n    .btn-default {\n        background-color: $white;\n        color: $danger;\n        box-shadow: none;\n    }\n}","//\n// sparkline.scss\n//\n\n.jqstooltip {\n  box-sizing: content-box;\n  width: auto !important;\n  height: auto !important;\n  background-color: $gray-800 !important;\n  box-shadow: $box-shadow-lg;\n  padding: 5px 10px !important;\n  border-radius: 3px;\n  border-color: $gray-900 !important;\n}\n\n.jqsfield {\n  color: $gray-200 !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  font-family: $font-family-base !important;\n  font-weight: $font-weight-medium !important;\n}\n","\n//\n//  Sweetalert2\n//\n\n.swal2-container {\n  .swal2-title{\n    font-size: 24px;\n    font-weight: $font-weight-medium;\n  }  \n}\n\n.swal2-content{\n  font-size: $font-size-md;\n}\n\n.swal2-icon{\n  &.swal2-question{\n    border-color: $info;\n    color: $info;\n  }\n  &.swal2-success {\n    [class^=swal2-success-line]{\n      background-color: $success;\n    }\n\n    .swal2-success-ring{\n      border-color: rgba($success, 0.3);\n    }\n  }\n  &.swal2-warning{\n    border-color: $warning;\n    color: $warning;\n  }\n}\n\n.swal2-styled{\n  &:focus{\n    box-shadow: none;\n  }\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step{\n    background: $primary;\n    &.swal2-active-progress-step{\n      background: $primary;\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\n        background: rgba($primary, 0.3);\n      }\n    }\n  }\n\n  .swal2-progress-step-line{\n    background: $primary;\n  }\n}\n\n.swal2-loader{\n  border-color: $primary transparent $primary transparent;\n}\n","//\n//  Sweetalert2\n//\n\n/* CSS Switch */\ninput[switch] {\n  display: none;\n  + label {\n    font-size: 1em;\n    line-height: 1;\n    width: 56px;\n    height: 24px;\n    background-color: $gray-400;\n    background-image: none;\n    border-radius: 2rem;\n    padding: 0.16667rem;\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    position: relative;\n    font-weight: $font-weight-medium;\n    transition: all 0.1s ease-in-out;\n    &:before {\n      color: $dark;\n      content: attr(data-off-label);\n      display: block;\n      font-family: inherit;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 21px;\n      position: absolute;\n      right: 1px;\n      margin: 3px;\n      top: -2px;\n      text-align: center;\n      min-width: 1.66667rem;\n      overflow: hidden;\n      transition: all 0.1s ease-in-out;\n    }\n\n    &:after {\n      content: '';\n      position: absolute;\n      left: 3px;\n      background-color: $gray-200;\n      box-shadow: none;\n      border-radius: 2rem;\n      height: 20px;\n      width: 20px;\n      top: 2px;\n      transition: all 0.1s ease-in-out;\n    }\n  }\n\n  &:checked + label {\n    background-color: $primary;\n  }\n}\n\ninput[switch]:checked + label {\n  background-color: $primary;\n  &:before {\n    color: $white;\n    content: attr(data-on-label);\n    right: auto;\n    left: 3px;\n  }\n\n  &:after {\n    left: 33px;\n    background-color: $gray-200;\n  }\n}\n\ninput[switch=\"bool\"] + label {\n  background-color: $danger;\n}\ninput[switch=\"bool\"] + label:before,input[switch=\"bool\"]:checked + label:before,\ninput[switch=\"default\"]:checked + label:before{\n  color: $white;\n}\n\ninput[switch=\"bool\"]:checked + label {\n  background-color: $success;\n}\n\ninput[switch=\"default\"]:checked + label {\n  background-color: #a2a2a2;\n}\n\ninput[switch=\"primary\"]:checked + label {\n  background-color: $primary;\n}\n\ninput[switch=\"success\"]:checked + label {\n  background-color: $success;\n}\n\ninput[switch=\"info\"]:checked + label {\n  background-color: $info;\n}\n\ninput[switch=\"warning\"]:checked + label {\n  background-color: $warning;\n}\n\ninput[switch=\"danger\"]:checked + label {\n  background-color: $danger;\n}\n\ninput[switch=\"dark\"]:checked + label {\n  background-color: $dark;\n}\n\n.square-switch{\n  margin-right: 7px;\n  input[switch]+label, input[switch]+label:after{\n    border-radius: 4px;\n  }\n}","\n//\n// Table editable\n//\n\n.table-edits{\n  input, select{\n    height: $input-height-sm;\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    border: 1px solid $input-border-color;\n    background-color: $input-bg;\n    color: $input-color;\n    border-radius: $input-border-radius;\n    &:focus{\n      outline: none;\n      border-color: $input-focus-border-color;\n    }\n  }\n}","//\n// vector-maps.scss\n//\n\n.jqvmap-label {\n    background-color: $dark;\n    color:  $gray-200;\n    font-size: $font-size-base;\n    padding: 0.3rem 0.6rem;\n}\n\n.jqvmap-zoomin, .jqvmap-zoomout {\n    width: 24px;\n    height: 24px;\n    line-height: 18px;\n}\n\n.jqvmap-zoomout {\n    top: 40px;\n}","//\n// x editable.scss\n//\n\n.editable-input{\n    .form-control{\n      display: inline-block;\n    }\n  }\n  \n  .editable-buttons{\n    margin-left: 7px;\n    .editable-cancel{\n      margin-left: 7px;\n    }\n  }","// \n// authentication.scss\n//\n\n\n\nbody, input, button, p, h1, h2, h3 , h4, span, strong, div , a{\n    font-family: 'Poppins', sans-serif;\n}\n\n.texto1-login {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 38px;\n    text-align: left;\n    color: #333333;\n\n    @media (max-width: 992px) {\n        font-size: 26px;\n    }\n}\n\n@media only screen and (max-height: 680px) {\n    .texto1-login {\n        font-size: 24px !important;\n        line-height: 36px !important;\n    }\n\n    .col-login .card-body{\n        padding: 0 30px !important;\n    }\n}\n\n\n.bg-pattern {\n    background: #EBEBEB;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n}\n\n.card-login {\n    box-shadow: none;\n    background: transparent\n}\n\n.auth-logo {\n    &.logo-light {\n        display: $display-none !important;\n    }\n}\n\n\n.bold-01 {  \n  font-weight: 800; \n  text-align:  left;\n  color : #333333;\n}\n\n.logo-login{\n    width: 250px;\n    height: auto;\n}\n\n\n.logo-app{\n    width: 10vw;\n    height: auto;\n}\n\n\n.col-login{\n    height: 100vh;\n    background: #ebebeb;\n}\n\n.banner-login{\n    width: 100vh;\n    height: 100vh; \n    object-fit: cover;\n}\n\n\n.carouselExampleIndicators{\n    z-index: 2001;    \n}\n\n.carousel-indicators{\n    z-index: 2002 !important;\n}\n\n.carousel-indicators [data-bs-target] {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%; /* Transformar em bolinhas */\n    background-color: #9de6e6;   \n    opacity: 1;\n    z-index: 2003;   \n}\n\n.carousel-control-next,\n.carousel-control-prev{\n    z-index: 2000;\n}\n.carousel-control-prev-icon, \n.carousel-control-next-icon {\n    width: 4rem;\n    height: 4rem;\n}\n\n.carousel-indicators .active {\n    background-color: white;\n}\n\n.t-right{\n    text-align:right;\n}\n\n.t-left{\n    text-align:left;\n}\n\n.botao-voltar-login {        \n    padding-bottom: 10px;\n    color: #757575;\n}\n\n.fale-conosco{\n    padding-left: 5px;\n}\n\n\n.overlay-banner-login{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #001a4f54;\n    z-index: 500;\n}\n\n\n.azul-claro {\n    color: #7dc3dc;\n}\n.input-icone-login{\n    background: #fff;    \n    border-top-left-radius: $border-radius ;\n    border-bottom-left-radius: $border-radius ;\n\n}\n\n.input-login {\n    border-left: 0px;\n    font-size: $font-size-md !important;\n    border-top-right-radius: $border-radius !important;\n    border-bottom-right-radius: $border-radius !important;\n    height: 45px;\n}\n\n.bt-icone-login {\n    position: absolute;\n    right: 0px;\n    top: 7px;\n    z-index: 3000;\n}\n\nbutton.btn.btn-primary.waves-effect.waves-light {\n    height: 45px;\n    border-radius: $border-color !important;\n    font-size: $font-size-md !important;\n    background-color: $color-azul2 !important;\n}\n\n.col-login .card-body {    \n    padding: 0 80px;\n\n    @media (max-width: 992px) {\n        padding: 0 40px;\n    }    \n}\n\n.fala-conosco{\n        padding-left: 4px;\n}",".page-search{\n    input[type=\"date\"]::-webkit-inner-spin-button,\n    input[type=\"date\"]::-webkit-calendar-picker-indicator {\n        display: none;\n        -webkit-appearance: none;\n    }\n\n    & .content-page{\n        & .sidebar{\n            width: 110px;\n            display: flex;\n            gap: 8px;\n            flex-direction: column;\n            & button{\n                &.actived, &:hover:not(.disabled){\n                    background-color: $color-azul1;\n                    border-color: $color-azul1;\n                    color: white;\n                }\n                &.disabled{\n                    cursor: not-allowed;\n                    color: $color-cinza2-5;\n                    border-color: $color-cinza2-5;\n                    & span.dot{\n                        color: white !important;\n                        background-color: $color-cinza2-5 !important;\n                    }\n                }\n                transition: .2s ease-in-out;\n                text-align: center;\n                width: 100%;\n                min-height: 36px;\n                font-family: $font-family-sans-serif;\n                font-weight: 400;\n                font-size: 13px;\n                padding: 6px 0;\n                background-color: transparent;\n                border-radius: 18px;\n                border: 2px solid $color-azul1;\n                position: relative;\n\n                & span.dot{\n                    position: absolute;\n                    right: -8px;\n                    top: -2px;\n                    z-index: 1;\n                    height: 16px;\n                    border-radius: 8px;\n                    background-color: $color-azul4;\n                    color: white;\n                    font-size: 11px;\n                    padding: 0px 4px;\n                    margin: 0;\n                }\n            }\n\n            & .dropdown-filter{\n                & div:first-child{\n                    & > a{\n                        background-color: transparent;\n                        font-family: $font-family-sans-serif;\n                        font-weight: 600;\n                        font-size: 20px;\n                        color: $color-azul2;\n                        width: 100%;\n                        text-align: center;\n                        margin: 8px 0 10px;\n\n                        &.disabled, &.disabled:hover{\n                            cursor: not-allowed;\n                            color: $color-cinza2-5;\n                        }\n    \n                        &:hover, &.actived{\n                            color: $blue_primary;\n                        }\n    \n                        &::after{\n                            display: none;\n                        }\n                    }\n    \n                    & .dropdown-content-filter{\n                        display: none;\n                        position: absolute;\n                        width: 280px;\n                        transition: .2s ease-in-out;\n                        height: auto;\n                        top: 0;\n                        left: 130px;\n                        border-radius: 4px;\n                        padding: 8px 0;\n                        background-color: #F5F5F5;\n                        box-shadow: 0px 1px 3px 1px #00000026;\n                        z-index: 99;\n    \n                        & .pre-filters{                        \n                            position: relative;\n                            padding: 0 12px 12px;\n                            border-bottom: 1px solid $light_gray_06;\n    \n                            & .header-title{\n                                font-family: $font-family-sans-serif;\n                                font-weight: 600;\n                                font-size: 20px;\n                                display: block;\n                                margin-bottom: 5px;\n                                color: $color-azul2;\n                            }\n    \n                            & button{\n                                &:hover{\n                                    background-color: transparent;\n                                    text-decoration: underline;\n                                }\n                                text-align: left;\n                                border: none;\n                                color: $color-azul2;\n                                font-family: $font-family-sans-serif;\n                                font-weight: 400;\n                                height: 36px;\n                                font-size: 16px;\n                            }\n    \n                        }\n    \n                        & .content-inputs{\n                            padding: 12px 12px 0;\n    \n                            & label{\n                                font-family: $font-family-sans-serif;\n                                font-weight: 500;\n                                font-size: 14px;\n                                color: $gray_secundary;\n                            }\n    \n                            & .input-group{\n                                width: 100%;\n                                height: 54px;\n                                border-radius: 12px;\n                                background-color: white;\n                                justify-content: space-between;\n                                border: 1px solid $gray_primary;\n                                display: flex;\n                                align-items: center;\n                                cursor: pointer;\n                                &:has(input:active), &:hover, &:has(input:focus){\n                                    border-color: $blue_primary !important;\n                                }\n    \n                                & input{\n                                    border: none;\n                                    background-color: transparent;\n                                    font-weight: 400;\n                                    font-size: 16px;\n                                    color: $gray_primary;                                \n                                    &::placeholder{\n                                        color: $gray_primary;\n                                    }\n                                }\n    \n                                & .input-group-append{\n                                    width: 54px;\n                                    height: 100%;\n                                    display: flex;                                \n                                    align-items: center;\n                                    justify-content: center;\n                                    border-left: 1px solid $gray_primary;\n    \n                                    & i{\n                                        font-size: 19px;\n                                        color: $color-azul2;\n                                    }\n                                }\n    \n                            }\n    \n                            & .footer-btn{\n                                & button{\n                                    height: 54px;\n                                    border-radius: 10px;\n                                    transition: .2s ease-in-out;\n                                    padding: 8px 16px;\n                                    font-weight: 600;\n                                    font-size: 16px;\n                                    font-family: $font-family-sans-serif;\n                                    &[type=\"button\"]:hover{\n                                        color: $blue_primary !important;\n                                        background-color: transparent !important;\n                                    }\n                                    \n                                    &[type=\"submit\"]{\n                                        color: white;\n                                        background-color: $color-azul1;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }                \n            }\n        }\n\n        & .overlay{\n            background-color: #00000018;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            right: 0;\n            position: absolute;\n            overflow: auto;\n        }\n\n        & .rightbar{\n            margin-left: 20px;\n            hr{\n                color: $light_gray_06;\n            }\n\n            & .subtitle-item-container{\n                margin-bottom: 12px;\n\n                & span.dot{\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    width: 43px;\n                    margin-left: 20px;\n                    height: 32px;\n                    border-radius: 18px;\n                    padding-top: 4px 16px;\n                    color: white;\n                    background-color: $color-azul4;\n                }\n            }\n\n            & .more-see-link{\n                font-family: $font-family-sans-serif;\n                font-weight: 400;\n                font-size: 14px;\n                padding: 4px;\n                background-color: transparent;\n                color: $light_blue_01;\n                border: none;\n                outline: none;\n                text-decoration: underline;\n            }\n            \n            & .item-container{\n\n                & .item-content-header{\n                    & .icon-arrow{\n                        font-size: 24px;\n                        color: $gray_primary;\n                        margin-top: 1px;\n                        // padding: 0 16px;\n                    }\n\n                    & .external-link{\n                        font-size: 16px;\n                        color: $color-azul2;\n                        cursor: pointer;\n                    }\n                }\n\n                & .item-content-body{\n                    & .item-badge-info {\n                        gap: 10px;\n                        display: flex;\n                        align-items: center;\n                        padding: 0 12px;\n                        height: 40px;\n                        border-radius: 12px;\n                        background-color: $info;\n                        font-family: $font-family-sans-serif;\n                        font-weight: 400;\n                        font-size: 14px;\n                        color: $dark_gray_primary;\n\n                        & i {\n                        font-size: 22px;\n                        color: $color-azul2;\n                        }\n                    }\n                    & .container-status { \n                        & .flag{\n                            height: 30px;\n                            border-radius: 18px;\n                            padding: 6px 16px;\n                            color: white;\n                            background-color: $blue_primary;\n                            font-family: $font-family-sans-serif;\n                            font-weight: 400;\n                            font-size: 12px;\n                        }\n                        & i{\n                            color: $light_blue_01;\n                            font-size: 16px !important;\n                        }\n                    }\n                }\n\n                & .item-content-footer{\n                    margin-top: 8px;\n                    & i, & span, & .info-footer{                        \n                        font-size: 16px;\n                        color: $gray_secundary;\n                    }\n                    & span, & .info-footer{\n                        font-size: 12px !important;\n                        line-height: 100%;\n                        font-family: $font-family-sans-serif;\n                    }\n                    & span{\n                        font-weight: 400;\n                    }\n                    & .info-footer{\n                        color: $color-azul2 !important;\n                        font-weight: 500;\n\n                    }\n                }\n\n                width: 935px;\n                padding: 16px;\n                margin-bottom: 12px;\n                box-shadow: 0px 1px 3px 1px #00000026;\n                background-color: white;\n                border-radius: 12px;\n                border: 1px solid #A8A8A8;\n                border-left: 5px solid $dark_blue_10;\n                transition: .2s ease-in-out;\n\n                & .name, & .full-date, & .info{\n                    color: $dark_gray_primary;\n                }\n\n                & .name{\n                    font-family: $font-family-sans-serif;\n                    font-family: Poppins;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 100%;\n                }\n\n                &.visited{\n                    border-left: 1px solid #A8A8A8 !important;\n                }\n                &.visited{\n                    opacity: .7;\n                }\n\n                & .info{\n                    font-family: $font-family-sans-serif;\n                    font-weight: 500;\n                    font-size: 14px;\n                    line-height: 20px;\n                }\n\n                &.container-message, &.container-transation{\n                    & .date-message, & .name-user, & .info-message, & .label-info-message{\n                        color: black;\n                        font-family: $font-family-sans-serif;\n                    }\n                    \n                    & .date-message{\n                        font-weight: 400;\n                        color: $dark_gray_primary !important;\n                        font-size: 14px !important;\n                    }\n\n                    & i{\n                        font-size: 15px;\n                        color: $color-azul2;\n                    }\n\n                    & .label-info-message{\n                        font-size: 16px;\n                        font-weight: 500;\n                    }\n                    & .name-user{\n                        font-weight: 600;\n                        font-size: 18px;\n                        color: $color-azul1;\n                    }\n\n                    & .info-message{\n                        font-size: 14px;\n                        color: $color-cinza5 !important;\n                    }                    \n\n                    & .code-transation{\n                        font-family: $font-family-sans-serif;\n                        font-weight: 300;\n                        font-size: 16px;\n                        color: $gray_primary;\n                        & i{\n                            color: $gray_primary;\n                            font-size: 15px;\n                        }\n                    }\n                }\n            }\n        }\n\n        & .container-filters-applied{\n            & .label{\n                font-family: $font-family-sans-serif;\n                font-weight: 500;\n                font-size: $font-size-sm;\n                color: black;                \n            }\n\n            & button{\n                background-color: $light_blue_08;\n                border: none;\n                height: 30px;\n                gap: 8px;\n                border-radius: 18px;\n                padding: 0 16px;\n                font-family: $font-family-sans-serif;\n                font-weight: 400;\n                font-size: $font-size-sm;\n                transition: .2s ease-in-out;\n                color: $color-azul2;\n                cursor: default;\n\n                &:hover{\n                    background-color: $blue_primary;\n                    color: white;\n                    & i{\n                        color: white;\n                    }\n                }\n\n                & i {\n                    color: $color-azul2;\n                    font-size: $font-size-sm;\n                    cursor: pointer;\n                }\n            }\n        }\n\n        & .no-content{\n            margin-top: 24px;\n\n            & h6{\n                font-family: $font-family-sans-serif;\n                font-weight: 500;\n                font-size: $font-size-xlg;\n                line-height: 100%;\n                color: $color-azul1;\n                padding-bottom: 16px;\n            }\n\n            & p {\n                font-family: $font-family-sans-serif;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #232323B2;\n            }\n        }\n    }\n}","/* Estilos customizados para BI_AUT003 */\n\n// Variáveis\n$border-color: #e9ecef;\n$shadow-light: rgba(0, 0, 0, 0.1);\n$shadow-medium: rgba(0, 0, 0, 0.15);\n$shadow-dark: rgba(0, 0, 0, 0.2);\n$shadow-strong: #00000057;\n$background-light: #f8f9fa;\n$text-color: #495057;\n$white: #ffffff;\n\n// Document History Header\n.document-history-header {\n  border: 1px solid $border-color;\n  box-shadow: 0 2px 4px $shadow-light;\n}\n\n.timeline-step {\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px $shadow-medium;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px $shadow-dark;\n  }\n}\n\n.timeline-connector {\n  opacity: 0.3;\n}\n\n// Vertical Timeline\n.vertical-timeline {\n  position: relative;\n}\n\n.timeline-section {\n  border: 1px solid $border-color;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px $shadow-strong;\n\n  &:hover {\n    box-shadow: 0 4px 8px $shadow-medium;\n  }\n}\n\n.timeline-events {\n  background-color: $background-light;\n  border-top: 1px solid $border-color;\n}\n\n.timeline-event {\n  padding: 15px 20px;\n  border-bottom: 1px solid $border-color;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.timeline-marker {\n  min-width: 40px;\n}\n\n.timeline-dot {\n  box-shadow: 0 2px 4px $shadow-dark;\n  border: 2px solid $white;\n}\n\n.timeline-line {\n  opacity: 0.5;\n}\n\n.timeline-content {\n  h6 {\n    color: $text-color;\n    font-weight: 600;\n  }\n}\n\n// Status Indicators\n.status-indicator {\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n// Document Flow\n.document-flow {\n  background: linear-gradient(135deg, $background-light 0%, $border-color 100%);\n  border-radius: 8px;\n  padding: 15px;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .horizontal-timeline .d-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .timeline-step {\n    margin: 5px;\n  }\n\n  .timeline-connector {\n    display: none;\n  }\n\n  .document-flow {\n    text-align: center;\n  }\n\n  .timeline-event {\n    padding: 10px 15px;\n  }\n}\n\n// Animation for expand/collapse\n.timeline-section .collapse {\n  transition: all 0.3s ease;\n}\n\n// Animação de crescimento gradual para timeline circles\n@keyframes gradualGrow {\n  0% {\n    transform: scale(1);\n  }\n  5% {\n    transform: scale(1.01);\n  }\n  10% {\n    transform: scale(1.02);\n  }\n  15% {\n    transform: scale(1.03);\n  }\n  20% {\n    transform: scale(1.04);\n  }\n  25% {\n    transform: scale(1.05);\n  }\n  30% {\n    transform: scale(1.06);\n  }\n  35% {\n    transform: scale(1.07);\n  }\n  40% {\n    transform: scale(1.08);\n  }\n  45% {\n    transform: scale(1.09);\n  }\n  50% {\n    transform: scale(1.10);\n  }\n  55% {\n    transform: scale(1.11);\n  }\n  60% {\n    transform: scale(1.12);\n  }\n  65% {\n    transform: scale(1.13);\n  }\n  70% {\n    transform: scale(1.14);\n  }\n  75% {\n    transform: scale(1.15);\n  }\n  80% {\n    transform: scale(1.16);\n  }\n  85% {\n    transform: scale(1.17);\n  }\n  90% {\n    transform: scale(1.18);\n  }\n  95% {\n    transform: scale(1.19);\n  }\n  100% {\n    transform: scale(1.20);\n  }\n}\n\n@keyframes gradualShrink {\n  0% {\n    transform: scale(1.15);\n  }\n  6.67% {\n    transform: scale(1.14);\n  }\n  13.33% {\n    transform: scale(1.13);\n  }\n  20% {\n    transform: scale(1.12);\n  }\n  26.67% {\n    transform: scale(1.11);\n  }\n  33.33% {\n    transform: scale(1.10);\n  }\n  40% {\n    transform: scale(1.09);\n  }\n  46.67% {\n    transform: scale(1.08);\n  }\n  53.33% {\n    transform: scale(1.07);\n  }\n  60% {\n    transform: scale(1.06);\n  }\n  66.67% {\n    transform: scale(1.05);\n  }\n  73.33% {\n    transform: scale(1.04);\n  }\n  80% {\n    transform: scale(1.03);\n  }\n  86.67% {\n    transform: scale(1.02);\n  }\n  93.33% {\n    transform: scale(1.01);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n","/* ==============\n  Email\n===================*/\n\n.mail-list {\n  a {\n    display: block;\n    color: $gray-600;\n    line-height: 24px;\n    padding: 6px 5px;\n    &.active {\n      color: $danger;\n      font-weight: 500;\n    }\n\n    i{\n      font-size: 18px;\n    }\n  }\n}\n\n.chat-user-box {\n  p.user-title {\n    color: $dark;\n    font-weight: 500;\n  }\n  p {\n    font-size: 13px;\n  }\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n\n  li {\n    position: relative;\n    display: block;\n    height: 50px;\n    line-height: 50px;\n    cursor: default;\n    transition-duration: .3s;\n\n    a{\n      color: $gray-600;\n    }\n\n    &:hover {\n      background: $gray-300;\n      transition-duration: .05s;\n    }\n\n    .col-mail {\n      float: left;\n      position: relative;\n    }\n\n    .col-mail-1 {\n      width: 320px;\n\n      .star-toggle,\n      .checkbox-wrapper-mail,\n      .dot {\n        display: block;\n        float: left;\n      }\n\n      .dot {\n        border: 4px solid transparent;\n        border-radius: 100px;\n        margin: 22px 26px 0;\n        height: 0;\n        width: 0;\n        line-height: 0;\n        font-size: 0;\n      }\n\n      .checkbox-wrapper-mail {\n        margin: 15px 10px 0 20px;\n      }\n\n      .star-toggle {\n        margin-top: 18px;\n        margin-left: 5px;\n      }\n\n      .title {\n        position: absolute;\n        top: 0;\n        left: 110px;\n        right: 0;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        margin-bottom: 0;\n      }\n    }\n\n    .col-mail-2 {\n      position: absolute;\n      top: 0;\n      left: 320px;\n      right: 0;\n      bottom: 0;\n\n      .subject,\n      .date {\n        position: absolute;\n        top: 0;\n      }\n\n      .subject {\n        left: 0;\n        right: 200px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n      }\n\n      .date {\n        right: 0;\n        width: 170px;\n        padding-left: 80px;\n      }\n    }\n\n    &.active,\n    &.active:hover {\n      box-shadow: inset 3px 0 0 $primary;\n    }\n\n    \n  &.unread  {\n    background-color: $gray-300;\n    font-weight: 500;\n    color: darken($dark,5%);\n      a{\n        color: darken($dark,5%);\n        font-weight: 500;\n      }\n    }\n  }\n\n\n  .checkbox-wrapper-mail {\n    cursor: pointer;\n    height: 20px;\n    width: 20px;\n    position: relative;\n    display: inline-block;\n    box-shadow: inset 0 0 0 1px $gray-400;\n    border-radius: 1px;\n\n    input {\n      opacity: 0;\n      cursor: pointer;\n    }\n    input:checked ~ label {\n      opacity: 1;\n    }\n\n    label {\n      position: absolute;\n      height: 20px;\n      width: 20px;\n      left: 0;\n      cursor: pointer;\n      opacity: 0;\n      margin-bottom: 0;\n      transition-duration: .05s;\n      top: 0;\n      &:before {\n        content: \"\\F012C\";\n        font-family: \"Material Design Icons\";\n        top: 0;\n        height: 20px;\n        color: darken($dark,5%);\n        width: 20px;\n        position: absolute;\n        margin-top: -16px;\n        left: 4px;\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) { \n  .message-list li .col-mail-1 {\n      width: 200px;\n  }\n}","//\n// coming-soon.scss\n//\n\n.counter-number {\n    font-size: 32px;\n    font-weight: $font-weight-medium;\n    text-align: center;\n    span {\n        font-size: $font-size-md;\n        font-weight: $font-weight-normal;\n        display: block;\n        padding-top: 7px;\n    }\n}\n\n.coming-box {\n    float: left;\n    width: 21%;\n    padding: 14px 7px;\n    margin: 0px $grid-gutter-width/2 $grid-gutter-width $grid-gutter-width/2;\n    background-color: $card-bg;\n    border-radius: $card-inner-border-radius;\n    box-shadow: $box-shadow;\n}\n\n@media (max-width: 991.98px) {\n    .coming-box {\n        width: 40%;\n    }\n}\n","// \n// timeline.scss\n//\n/************** vertical timeline **************/ \n\n/************** Horizontal timeline **************/     \n\n.slick-slide {\n    margin: 10px 12px;\n    transition: all ease-in-out .3s;\n    opacity: .2;\n    padding: 7px;\n    border-radius: 4px;\n    &:focus{\n        outline: none;\n    }\n}\n\n.slick-prev, .slick-next {\n    &:before{\n        color: $dark;\n    }  \n}\n\n.slick-active {\n    opacity: 1;\n}\n\n\n.slick-slider {\n    &.hori-timeline-desc{\n        padding: 12px 24px 0;\n        text-align: center;\n        border-radius: 7px;\n    }\n\n    &.hori-timeline-nav{\n\n        .slick-active {\n            opacity: 0.5;\n        }   \n        \n        .slick-current {\n            opacity: 1;\n            background-color: rgba($primary, 0.2);\n            .nav-title{\n                color: $primary;\n            }\n        }\n        \n        .slider-nav-item{\n            text-align: center;\n        }\n       \n    }\n\n    &.fade{\n        &:not(slow) {\n            opacity: 1;\n        }\n    }\n}\n\n\n\n/************** vertical timeline **************/ \n\n.verti-timeline{\n    border-left: 2px solid $gray-300;\n    margin: 0 5px;\n\n    .event-list{\n        position: relative;\n        padding: 0px 0px 25px 30px;\n\n        &:before{\n            content: \"\";\n            position: absolute;\n            width: 20px;\n            height: 20px;\n            left: -2px;\n            top: 8px;\n            border-top: 6px double $gray-300;\n            border-left: 2px solid $gray-300;\n            border-top-left-radius: 15px;\n        }\n\n        .event-content{\n            position: relative;\n            border: 2px solid $border-color;\n            border-radius: 7px;\n        }\n\n        &.active{\n            .event-timeline-dot{\n                color: $primary;\n            }\n        }\n\n        &:last-child{\n            padding-bottom: 0px;\n        }\n    }\n}","// \n// Extras pages.scss\n//\n\n\n/*********************\n    Faqs\n**********************/\n\n.gallery-box {\n    a {\n        .gallery-content {\n            border-radius: 4px;\n            overflow: hidden;\n        }\n\n        .gallery-overlay {\n            position: absolute;\n            left: 0;\n            right: 0;\n            top: 0;\n            bottom: 0;\n            background: $primary;\n            opacity: 0;\n            transition: all 0.5s;\n        }\n\n        .overlay-content {\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: -60px;\n            background-color: $card-bg;\n            transition: all 0.5s;\n            padding: 16px 12px 12px 12px;\n            margin: 0px 12px;\n            border-radius: 4px;\n        }\n\n        .gallery-overlay-icon {\n            position: absolute;\n            top: 50%;\n            left: 0;\n            right: 0;\n            transform: translateY(-85%);\n            transition: all 0.5s;\n\n            i {\n                font-size: 28px;\n            }\n        }\n\n        &:hover {\n            .gallery-overlay {\n                opacity: 0.7;\n            }\n\n            .overlay-content {\n                position: absolute;\n                bottom: 12px;\n            }\n        }\n    }\n}\n\n/* BI_WS0025 - Linha Total da tabela */\n.row-total-agendamento td {\n    background-color: #f1f1f1 !important;\n    color: #1f3566 !important;\n    font-weight: 600 !important;\n}\n\n.row-total-agendamento td:nth-child(1),\n.row-total-agendamento td:nth-child(2) {\n    background-color: #d9d9d9 !important;\n    color: #1f3566 !important;\n    font-weight: 700 !important;\n}\n\n.error-text {\n    text-shadow: 4px 4px rgba($primary, 0.4);\n}",".terms-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: $footer-bg;\n}\n\n.terms-header {\n  background-color: $blue_primary;\n  min-height: 80px;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  position: relative;\n  color: $footer-bg;\n  overflow: visible;\n}\n\n.terms-side {\n  display: flex;\n  align-items: center;\n}\n\n.terms-side.left {\n  justify-content: flex-start;\n}\n\n.terms-side.right {\n  justify-content: flex-end;\n}\n\n.terms-back-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  font-family: 'Poppins', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1;\n  padding: 6px 10px;\n\n  i {\n    font-size: 16px;\n  }\n}\n\n.terms-logo {\n  display: flex;\n  justify-content: center;\n}\n\n.terms-language {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  .lang-button {\n    background-color: $blue_primary;\n    border: none; \n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0;\n    padding: 0;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    transition: background 0.2s ease;\n    position: relative;\n    box-shadow: none;\n  }\n\n  .flag-icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    object-fit: cover;\n    pointer-events: none;\n    border: 2px solid white;\n    transition: border-color 0.2s ease; \n    &.active-flag { \n      border-color: white; \n    }\n  }\n\n  .chevron-icon {\n    width: 10px;\n    height: 6px;\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    fill: white;\n    margin-left: 4px;\n  }\n  &.dropdown-open .chevron-icon {\n    transform: rotate(180deg); \n  }\n\n  .lang-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background: #fff;\n    border: 1px transparent;\n    border-radius: 1px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    width: 60px; \n\n    .dropdown-item {\n      display: flex;\n      align-items: center;\n      justify-content: center; \n      padding: 4px 0;\n      height: 40px;\n      cursor: pointer;\n      transition: background-color 0.2s ease, transform 0.2s ease;\n\n      &:hover {\n        background-color: #bfe1fc; \n        transform: scale(1.02);\n      }\n\n      &.selected-language-item { \n        background-color: #244EA2; \n        &:hover { \n          background-color: #244EA2;\n          transform: scale(1);\n        }\n      }\n      img {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        object-fit: cover;\n        border: 2px solid white;\n        transition: border-color 0.2s ease; \n      }\n    }\n  }\n}\n\n.terms-content {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 40px;\n  flex-grow: 1;\n\n  ul,\n  ol {\n    margin-bottom: 24px;\n  }\n\n  li {\n    margin-bottom: 8px;\n  }\n\n  h1 {\n    font-size: 32px;\n    line-height: 100%;\n    color: $color-azul1;\n    margin-bottom: 24px;\n  }\n\n  h2 {\n    font-size: 24px;\n    line-height: 100%;\n    color: $color-azul1;\n    margin-top: 40px;\n    margin-bottom: 16px;\n  }\n\n  h3 {\n    font-size: 20px;\n    line-height: 100%;\n    color: $color-azul1;\n  }\n}\n\n.terms-footer {\n  background-color: #F2F2F2;\n  color: #555555;\n  text-align: center;\n  padding: 1rem;\n  font-size: 12px;\n  font-family: 'Poppins', sans-serif;\n}\n\n\n.legal-links-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px; \n\n  .legal-link-item {\n    font-size: 14px; \n    font-family: 'Poppins', sans-serif;\n    font-weight: 400; \n    line-height: 100%; \n    letter-spacing: 0%; \n\n    color: #007bff;\n    text-decoration: none; \n  }\n\n  .legal-link-separator {\n    font-size: 14px; \n    font-family: 'Poppins', sans-serif;\n    font-weight: 400; \n    line-height: 100%;\n    letter-spacing: 0%;\n\n    color: #007bff; \n  }\n}\n\n.app-store-buttons {\n  margin-top: 30px; \n}\n\n.text-light-blue-01 {\n  color: #007bff;\n}","%power-off-base {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  padding: 6px;\n}\n\n.power-off-active {\n  @extend %power-off-base;\n  background-color: #D1E7DD;\n\n  i {\n    color: #198754 !important;\n  }\n}\n\n.power-off-inactive {\n  @extend %power-off-base;\n  background-color: #F8D7DA;\n\n  i {\n    color: #DC3545 !important;\n  }\n}\n\n.btn-criar-rota {\n  background-color: #fff;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: #263874;\n    color: #FFFFFF !important;\n    border-color: #263874;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
